/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/myreads-react-md/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(546);
	module.exports = __webpack_require__(251);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(27);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(17);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 6 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(170);


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = deprecated;
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(328)();
	}


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMProperty = __webpack_require__(47);
	var ReactDOMComponentFlags = __webpack_require__(171);
	
	var invariant = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.keyCodes = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  var LEFT_MOUSE = exports.LEFT_MOUSE = 0;
	  var RIGHT_MOUSE = exports.RIGHT_MOUSE = 2;
	
	  var TAB = exports.TAB = 9;
	  var ENTER = exports.ENTER = 13;
	  var ESC = exports.ESC = 27;
	  var SPACE = exports.SPACE = 32;
	  var PAGE_UP = exports.PAGE_UP = 33;
	  var PAGE_DOWN = exports.PAGE_DOWN = 34;
	  var END = exports.END = 35;
	  var HOME = exports.HOME = 36;
	  var LEFT = exports.LEFT = 37;
	  var UP = exports.UP = 38;
	  var RIGHT = exports.RIGHT = 39;
	  var DOWN = exports.DOWN = 40;
	
	  var ZERO = exports.ZERO = 48;
	  var NINE = exports.NINE = 57;
	  var KEYPAD_ZERO = exports.KEYPAD_ZERO = 96;
	  var KEYPAD_NINE = exports.KEYPAD_NINE = 105;
	});

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.getField = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = getField;
	  /**
	   * Gets the current field for a component that can the field
	   * as either uncontrolled or controlled.
	   *
	   * @param {Object} props - the props object.
	   * @param {Object} state = the state object.
	   * @param {string=} field - the field to extract a value from. Defaults to 'value'.
	   *
	   * @return the field's value.
	   */
	  function getField(props, state) {
	    var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
	
	    return typeof props[field] !== 'undefined' ? props[field] : state[field];
	  }
	});

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react);
	    global.controlled = mod.exports;
	  }
	})(this, function (exports, _react) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = controlled;
	
	
	  /**
	   * Validates the a component is fully controlled or uncontrolled.  If the given prop is not
	   * `undefined`, it will check if the `funcName` is defined and a function. A missing function
	   * will generate an error similar to the built-in React controlled validation message.
	   *
	   * @param {String} funcName - The function name to use for additional validation.
	   * @param {function} validator - The PropTypes validator to use for the given prop.
	   * @return {Error} an error or null.
	   */
	  function controlled(validator, funcName) {
	    var fallbackPropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'defaultValue';
	
	    return function validate(props, propName, componentName, location, propFullName) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	
	      for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	        args[_key - 5] = arguments[_key];
	      }
	
	      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	      if (!err && typeof props[propName] !== 'undefined' && !props.readOnly) {
	        var _PropTypes$func;
	
	        var funcError = (_PropTypes$func = _react.PropTypes.func).isRequired.apply(_PropTypes$func, [props, funcName, componentName, location, propFullName].concat(args));
	        if (funcError) {
	          err = new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' without a ' + ('`' + funcName + '` handler. This will render a read only field. Set either the `' + funcName + '` ') + ('or use the `' + fallbackPropName + '` instead.'));
	        }
	      }
	
	      return err;
	    };
	  } /** @module PropTypes/controlled */
	});

/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(11), __webpack_require__(30), __webpack_require__(40), __webpack_require__(67), __webpack_require__(18), __webpack_require__(49), __webpack_require__(128), __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../constants/keyCodes'), require('../constants/CSSTransitionGroupTick'), require('../utils/PropTypes/invalidIf'), require('../utils/EventUtils/captureNextEvent'), require('../FontIcons/FontIcon'), require('../Helpers/IconSeparator'), require('../Inks/injectInk'), require('../Tooltips/injectTooltip'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.keyCodes, global.CSSTransitionGroupTick, global.invalidIf, global.captureNextEvent, global.FontIcon, global.IconSeparator, global.injectInk, global.injectTooltip);
	    global.Button = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _keyCodes, _CSSTransitionGroupTick, _invalidIf, _captureNextEvent, _FontIcon, _IconSeparator, _injectInk, _injectTooltip) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	  var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	  var _injectInk2 = _interopRequireDefault(_injectInk);
	
	  var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Button = function (_PureComponent) {
	    _inherits(Button, _PureComponent);
	
	    function Button(props) {
	      _classCallCheck(this, Button);
	
	      var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	      _this.state = {
	        pressed: false,
	        snackbar: false,
	        snackbarType: null
	      };
	
	      _this._blur = _this._blur.bind(_this);
	      _this._animateForSnackbar = _this._animateForSnackbar.bind(_this);
	      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._handleMouseUp = _this._handleMouseUp.bind(_this);
	      _this._handleMouseDown = _this._handleMouseDown.bind(_this);
	      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      return _this;
	    }
	
	    _createClass(Button, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.disabled && !nextProps.disabled && this.state.hover) {
	          this.setState({ hover: false });
	        }
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        var _this2 = this;
	
	        if (!this.state.pressed && nextState.pressed) {
	          this._timeout = setTimeout(function () {
	            _this2._timeout = null;
	            if (_this2._attemptedBlur) {
	              _this2._attemptedBlur = false;
	
	              _this2.setState({ pressed: false });
	            }
	          }, 450);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        if (this._snackbarTimeout) {
	          clearTimeout(this._snackbarTimeout);
	        }
	
	        window.removeEventListener('click', this._blur);
	      }
	    }, {
	      key: '_getType',
	      value: function _getType(props) {
	        if (props.flat || props.disabled && props.raised) {
	          return 'flat';
	        } else if (props.icon || props.disabled && props.floating) {
	          return 'icon';
	        } else if (props.raised) {
	          return 'raised';
	        } else if (props.floating) {
	          return 'icon md-btn--floating';
	        }
	
	        return 'flat';
	      }
	    }, {
	      key: '_blur',
	      value: function _blur() {
	        if (this.props.disabled) {
	          return;
	        }
	
	        if (this._timeout) {
	          this._attemptedBlur = true;
	        } else {
	          this.setState({ pressed: false });
	        }
	      }
	    }, {
	      key: '_handleMouseUp',
	      value: function _handleMouseUp(e) {
	        if (this.props.onMouseUp) {
	          this.props.onMouseUp(e);
	        }
	
	        this._blur();
	      }
	    }, {
	      key: '_handleMouseDown',
	      value: function _handleMouseDown(e) {
	        if (this.props.onMouseDown) {
	          this.props.onMouseDown(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ pressed: true });
	        }
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        if (this.props.onTouchStart) {
	          this.props.onTouchStart(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ pressed: true });
	        }
	      }
	    }, {
	      key: '_handleTouchEnd',
	      value: function _handleTouchEnd(e) {
	        if (this.props.onTouchEnd) {
	          this.props.onTouchEnd(e);
	        }
	
	        this._blur();
	        (0, _captureNextEvent2.default)('mouseover');
	      }
	    }, {
	      key: '_handleKeyUp',
	      value: function _handleKeyUp(e) {
	        if (this.props.onKeyUp) {
	          this.props.onKeyUp(e);
	        }
	
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          window.addEventListener('click', this._blur);
	          this.setState({ pressed: true });
	        }
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        if (this.props.onKeyDown) {
	          this.props.onKeyDown(e);
	        }
	
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          window.removeEventListener('click', this._blur);
	          this.setState({ pressed: false });
	        }
	      }
	    }, {
	      key: '_handleMouseOver',
	      value: function _handleMouseOver(e) {
	        if (this.props.onMouseOver) {
	          this.props.onMouseOver(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ hover: true });
	        }
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave(e) {
	        if (this.props.onMouseLeave) {
	          this.props.onMouseLeave(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ hover: false });
	        }
	      }
	    }, {
	      key: '_animateForSnackbar',
	      value: function _animateForSnackbar(multiline, leaveTimeout) {
	        var _this3 = this;
	
	        if (typeof leaveTimeout === 'number') {
	          this._snackbarTimeout = setTimeout(function () {
	            _this3._snackbarTimeout = setTimeout(function () {
	              _this3._snackbarTimeout = null;
	
	              _this3.setState({ snackbar: false });
	            }, leaveTimeout + 150);
	
	            _this3.setState({ snackbarType: null });
	          }, _CSSTransitionGroupTick2.default);
	        } else {
	          this._snackbarTimeout = setTimeout(function () {
	            _this3._snackbarTimeout = null;
	
	            _this3.setState({ snackbar: true, snackbarType: multiline ? 'multiline-' : '' });
	          }, _CSSTransitionGroupTick2.default);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _cn;
	
	        var _props = this.props,
	            className = _props.className,
	            iconClassName = _props.iconClassName,
	            label = _props.label,
	            iconBefore = _props.iconBefore,
	            href = _props.href,
	            primary = _props.primary,
	            secondary = _props.secondary,
	            flat = _props.flat,
	            raised = _props.raised,
	            floating = _props.floating,
	            mini = _props.mini,
	            fixed = _props.fixed,
	            fixedPosition = _props.fixedPosition,
	            disabled = _props.disabled,
	            component = _props.component,
	            ink = _props.ink,
	            tooltip = _props.tooltip,
	            icon = _props.icon,
	            forceIconSize = _props.forceIconSize,
	            forceIconFontSize = _props.forceIconFontSize,
	            props = _objectWithoutProperties(_props, ['className', 'iconClassName', 'label', 'iconBefore', 'href', 'primary', 'secondary', 'flat', 'raised', 'floating', 'mini', 'fixed', 'fixedPosition', 'disabled', 'component', 'ink', 'tooltip', 'icon', 'forceIconSize', 'forceIconFontSize']);
	
	        delete props.children;
	        delete props.tooltipLabel;
	        delete props.tooltipPosition;
	
	        if (href) {
	          delete props.type;
	        }
	
	        var children = this.props.children;
	        var _state = this.state,
	            pressed = _state.pressed,
	            hover = _state.hover,
	            snackbar = _state.snackbar,
	            snackbarType = _state.snackbarType;
	
	        var mdBtnType = this._getType(this.props);
	
	        var Component = component || (href ? 'a' : 'button');
	        if (children || iconClassName) {
	          children = _react2.default.createElement(
	            _FontIcon2.default,
	            { iconClassName: iconClassName, forceSize: forceIconSize, forceFontSize: forceIconFontSize },
	            children
	          );
	        }
	
	        if (children && label) {
	          children = _react2.default.createElement(
	            _IconSeparator2.default,
	            { label: label, iconBefore: iconBefore },
	            children
	          );
	        } else if (label) {
	          children = label;
	        }
	
	        var raisedStyles = raised || floating;
	
	        var themeClassNames = !disabled && (0, _classnames2.default)({
	          'md-text--theme-primary md-ink--primary': !raisedStyles && primary,
	          'md-text--theme-secondary md-ink--secondary': !raisedStyles && secondary,
	          'md-background--primary md-background--primary-hover': raisedStyles && primary,
	          'md-background--secondary md-background--secondary-hover': raisedStyles && secondary,
	          'md-btn--color-primary-active': !raisedStyles && hover && primary,
	          'md-btn--color-secondary-active': !raisedStyles && hover && secondary
	        });
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            disabled: disabled,
	            onTouchStart: this._handleTouchStart,
	            onTouchEnd: this._handleTouchEnd,
	            onMouseDown: this._handleMouseDown,
	            onMouseUp: this._handleMouseUp,
	            onKeyDown: this._handleKeyDown,
	            onKeyUp: this._handleKeyUp,
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave,
	            href: href,
	            className: (0, _classnames2.default)('md-inline-block md-btn md-btn--' + mdBtnType, themeClassNames, (_cn = {
	              'md-text': !disabled && !primary && !secondary && !icon && !floating,
	              'md-text--disabled': disabled,
	              'md-pointer--hover': !disabled,
	              'md-btn--text': flat || raised,
	              'md-btn--hover': hover && !disabled,
	              'md-btn--raised-disabled': raised && disabled,
	              'md-btn--raised-pressed': !disabled && raisedStyles && pressed,
	              'md-btn--fixed': fixed
	            }, _defineProperty(_cn, 'md-btn--fixed-' + fixedPosition, floating && fixed), _defineProperty(_cn, 'md-btn--floating-mini', floating && mini), _defineProperty(_cn, 'md-btn--floating-pressed', floating && pressed), _defineProperty(_cn, 'md-btn--snackbar-floating', snackbar), _defineProperty(_cn, 'md-btn--snackbar-floating-' + snackbarType + 'adjust', snackbar && snackbarType !== null), _cn), className)
	          }),
	          ink,
	          tooltip,
	          children
	        );
	      }
	    }]);
	
	    return Button;
	  }(_react.PureComponent);
	
	  Button.propTypes = {
	    /**
	     * An optional style to apply to the button.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the button.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * A label to display on a `FlatButton` or a `RaisedButton`. This text can either
	     * be placed before or after an optional `FontIcon` using the `iconBefore` prop.
	     * This is required for `Flat` or `Raised` buttons. It is not allowed for `Icon`
	     * or `Floating` buttons. Use the `tooltipLabel` prop for `Icon` or `Floating` buttons.
	     */
	    label: (0, _invalidIf2.default)(_react.PropTypes.string, 'icon', 'floating'),
	
	    /**
	     * A boolean if the icon should appear before or after the text for a `FlatButton` or
	     * a `RaisedButton`.
	     */
	    iconBefore: _react.PropTypes.bool,
	
	    /**
	     * Any children used to display a `FontIcon` in any version of the button. This will
	     * be used with the `iconClassName` prop. If the `iconClassName` and the `children` prop
	     * are omitted, no icon will be added to the `RaisedButton` or `FlatButton`. An error
	     * will be displayed for the `IconButton` or `FloatingButton`.
	     */
	    children: function children(props, propName, componentName) {
	      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        args[_key - 3] = arguments[_key];
	      }
	
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var err = _react.PropTypes.node.apply(_react.PropTypes, [props, propName, componentName].concat(args));
	
	      var icon = props.icon || props.floating;
	      var missing = !props.children && !props.iconClassName;
	      if (!err && icon && missing) {
	        err = new Error('You created an `' + (props.icon ? 'Icon' : 'Floating') + '` ' + componentNameSafe + ' without ' + 'having the correct props to generate an icon. Expected either the `children` prop or the ' + ('`iconClassName` prop but received children: `' + props.children + '` and iconClassName: ') + ('`' + props.iconClassName + '`.'));
	      }
	
	      return err;
	    },
	
	    /**
	     * An icon className to use in an optional `FontIcon` in any version of the button. This will
	     * be used with the `children` prop. If the `floating` or `icon` props are set to true, this or
	     * the children are required.
	     */
	    iconClassName: _react.PropTypes.string,
	
	    /**
	     * The type for the button. This is required when the `component` prop is not
	     * the 'a' tag, a `function`, or when the `href` prop is defined.
	     */
	    type: function type(props, propName, component) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	        args[_key2 - 3] = arguments[_key2];
	      }
	
	      var c = props.component;
	      var validator = _react.PropTypes.oneOf(['button', 'submit', 'reset']);
	      if (!props.href && c !== 'a' && typeof c !== 'function') {
	        validator = validator.isRequired;
	      }
	
	      return validator.apply(undefined, [props, propName, component].concat(args));
	    },
	
	    /**
	     * Boolean if the button should be styled with the primary color.
	     */
	    primary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the button should be styled with the secondary color.
	     */
	    secondary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the button is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional href for the button. This will style the `a` tag as a button.
	     */
	    href: _react.PropTypes.string,
	
	    /**
	     * An optional component to render the button as. This allows you to get all the styles and functionality
	     * of the Button, but as a custom React component.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	
	    /**
	     * An optional function to call when the `click` event is triggered.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `touchstart` event is triggered.
	     */
	    onTouchStart: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `touchend` event is triggered.
	     */
	    onTouchEnd: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `mousedown` event is triggered.
	     */
	    onMouseDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `mouseup` event is triggered.
	     */
	    onMouseUp: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `keyup` event is triggered.
	     */
	    onKeyUp: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `keydown` event is triggered.
	     */
	    onKeyDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `mouseover` event is triggered.
	     */
	    onMouseOver: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `mouseleave` event is triggered.
	     */
	    onMouseLeave: _react.PropTypes.func,
	
	    /**
	     * Boolean if the `FloatingButton` should be fixed to the page. This prop can
	     * only be enabled if the `floating` prop is true.
	     */
	    fixed: (0, _invalidIf2.default)(_react.PropTypes.bool, 'flat', 'raised', 'icon'),
	
	    /**
	     * The position that the `FloatingButton` should be fixed to the page. It will
	     * either be fixed to the top right, top left, bottom right, or bottom left of
	     * the page. This prop is ony used if the `floating` prop and `fixed` prop are
	     * `true`.
	     */
	    fixedPosition: _react.PropTypes.oneOf(['tr', 'tl', 'br', 'bl']).isRequired,
	
	    /**
	     * Boolean if the `FloatingButton` should be `mini`. This prop can only be used
	     * when the `floating` prop is true.
	     */
	    mini: (0, _invalidIf2.default)(_react.PropTypes.bool, 'flat', 'raised', 'icon'),
	
	    /**
	     * Boolean if the `Button` should be styled as a `FlatButton`.
	     */
	    flat: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `Button` should be styled as a `RaisedButton`.
	     */
	    raised: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `Button` should be styled as a `IconButton`.
	     */
	    icon: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `Button` should be styled as a `FloatingButton`.
	     */
	    floating: _react.PropTypes.bool,
	
	    /**
	     * An optional label to use for the tooltip. This is normally only used for
	     * `IconButton`s or `FloatingButton`s, but can be used on `FlatButton`s and
	     * `RaisedButton`s if you wish. Knock yourself out!
	     *
	     * If this prop is omitted, no tooltip will be included.
	     */
	    tooltipLabel: _react.PropTypes.string,
	
	    /**
	     * An optional delay before the tooltip appears on mouse over.
	     */
	    tooltipDelay: _react.PropTypes.number,
	
	    /**
	     * The position for the tooltip.
	     */
	    tooltipPosition: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * An ink from `injectInk`.
	     * @access private
	     */
	    ink: _react.PropTypes.node,
	
	    /**
	     * A tooltip from `injectTooltip`
	     * @access private
	     */
	    tooltip: _react.PropTypes.node,
	
	    /**
	     * Custom validator for verifying that only one type is defined and that
	     * at one type is defined.
	     */
	    _typeValidator: function _typeValidator(props, propName, component) {
	      var flat = props.flat,
	          raised = props.raised,
	          icon = props.icon,
	          floating = props.floating;
	
	
	      var defined = [raised, flat, icon, floating].filter(function (d) {
	        return d;
	      });
	      var len = defined.length;
	      if (len === 0) {
	        return new Error('A material design button type must be specified in the `' + component + '` but none were ' + 'given. Valid types are `flat`, `raised`, `icon`, or `floating`.');
	      } else if (len !== 1) {
	        return new Error('Only one material design button type may be specified in the `' + component + '` but `' + len + '` ' + 'were given. Select only one of `flat`, `raised`, `icon`, or `floating`.');
	      }
	
	      return null;
	    },
	
	    /**
	     * Either a boolean that will enforce the 24x24 size of the font icon or a number of the size
	     * to enforce. This is useful when using other font icon libraries that do not have a consistent
	     * size.
	     */
	    forceIconSize: _FontIcon2.default.propTypes.forceSize,
	
	    /**
	     * Boolean if the `forceIconSize` prop should also force the `font-size` instead of only `width` and `height`.
	     */
	    forceIconFontSize: _react.PropTypes.bool
	  };
	  Button.defaultProps = {
	    type: 'button',
	    iconBefore: true,
	    fixedPosition: 'br'
	  };
	  exports.default = (0, _injectInk2.default)((0, _injectTooltip2.default)(Button));
	});

/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.FontIcon = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var styles = {
	    sized: { width: 24, height: 24 },
	    fullySized: { width: 24, height: 24, fontSize: 24 }
	  };
	
	  /**
	   * The \`FontIcon\` component is used for rendering a font-icon library's
	   * icon. The default is to use the `material-icons` library, but others
	   * can be used as well.
	   *
	   * If you are using another font-icon library that does not always create
	   * icons with a perfect 1:1 scale (such as font-awesome), it is recommended
	   * to update the `.md-icon` styles to set the width and height to `$md-font-icon-size`.
	   * However, this will prevent different sided icons.
	   *
	   * \`\`\`scss
	   * .md-icon.fa {
	   *   height: $md-font-icon-size;
	   *   width: $md-font-icon-size;
	   * }
	   * \`\`\`
	   */
	
	  var FontIcon = function (_PureComponent) {
	    _inherits(FontIcon, _PureComponent);
	
	    function FontIcon() {
	      _classCallCheck(this, FontIcon);
	
	      return _possibleConstructorReturn(this, (FontIcon.__proto__ || Object.getPrototypeOf(FontIcon)).apply(this, arguments));
	    }
	
	    _createClass(FontIcon, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            iconClassName = _props.iconClassName,
	            className = _props.className,
	            children = _props.children,
	            disabled = _props.disabled,
	            style = _props.style,
	            forceSize = _props.forceSize,
	            forceFontSize = _props.forceFontSize,
	            props = _objectWithoutProperties(_props, ['iconClassName', 'className', 'children', 'disabled', 'style', 'forceSize', 'forceFontSize']);
	
	        var mergedStyles = style;
	        if (typeof forceSize === 'boolean') {
	          var merge = forceFontSize ? styles.fullySized : styles.sized;
	          mergedStyles = style ? _extends({}, merge, style) : merge;
	        } else if (typeof forceSize === 'number') {
	          var _merge = {
	            fontSize: forceFontSize ? forceSize : undefined,
	            height: forceSize,
	            width: forceSize
	          };
	
	          mergedStyles = style ? _extends({}, _merge, style) : _merge;
	        }
	
	        return _react2.default.createElement(
	          'i',
	          _extends({}, props, {
	            style: mergedStyles,
	            className: (0, _classnames2.default)('md-icon', iconClassName, {
	              'md-icon--disabled': disabled
	            }, className)
	          }),
	          children
	        );
	      }
	    }]);
	
	    return FontIcon;
	  }(_react.PureComponent);
	
	  FontIcon.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `FontIcon`.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The icon font library className to use to display the icon.
	     */
	    iconClassName: _react.PropTypes.string.isRequired,
	
	    /**
	     * Any children required to display the icon with the font library.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the `FontIcon` should gain the disabled colors.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * Either a boolean that will enforce the 24x24 size of the font icon or a number of the size
	     * to enforce. This is useful when using other font icon libraries that do not have a consistent
	     * size.
	     */
	    forceSize: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.number]),
	
	    /**
	     * Boolean if the `forceSize` prop should also force the `font-size` instead of only `width` and `height`.
	     */
	    forceFontSize: function forceFontSize(props, propName, component) {
	      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        args[_key - 3] = arguments[_key];
	      }
	
	      var error = _react.PropTypes.bool.apply(_react.PropTypes, [props, propName, component].concat(args));
	      if (!error && typeof props.forceSize === 'undefined' && props[propName]) {
	        error = new Error('You provided a `forceFontSize` prop to the ' + component + ' component, without specifying the `forceSize` ' + ('prop. Either set the `forceSize` prop to a boolean or a number, or disable `' + propName + '`.'));
	      }
	
	      return error;
	    }
	  };
	  FontIcon.defaultProps = {
	    iconClassName: 'material-icons'
	  };
	  exports.default = FontIcon;
	});

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(540);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(541);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(542);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(234);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(139);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(543);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(544);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(140);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(545);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(168);
	var PooledClass = __webpack_require__(37);
	var ReactFeatureFlags = __webpack_require__(174);
	var ReactReconciler = __webpack_require__(48);
	var Transaction = __webpack_require__(77);
	
	var invariant = __webpack_require__(3);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(82), __webpack_require__(128)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./AccessibleFakeButton'), require('../Inks/injectInk'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.AccessibleFakeButton, global.injectInk);
	    global.AccessibleFakeInkedButton = mod.exports;
	  }
	})(this, function (exports, _AccessibleFakeButton, _injectInk) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	  var _injectInk2 = _interopRequireDefault(_injectInk);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = (0, _injectInk2.default)(_AccessibleFakeButton2.default);
	});

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 24 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(37);
	
	var emptyFunction = __webpack_require__(17);
	var warning = __webpack_require__(4);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(68)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../utils/PropTypes/between'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.between);
	    global.Paper = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _between) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _between2 = _interopRequireDefault(_between);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Paper = function (_PureComponent) {
	    _inherits(Paper, _PureComponent);
	
	    function Paper() {
	      _classCallCheck(this, Paper);
	
	      return _possibleConstructorReturn(this, (Paper.__proto__ || Object.getPrototypeOf(Paper)).apply(this, arguments));
	    }
	
	    _createClass(Paper, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            Component = _props.component,
	            zDepth = _props.zDepth,
	            className = _props.className,
	            raiseOnHover = _props.raiseOnHover,
	            props = _objectWithoutProperties(_props, ['component', 'zDepth', 'className', 'raiseOnHover']);
	
	        return _react2.default.createElement(Component, _extends({}, props, {
	          className: (0, _classnames2.default)('md-paper md-paper--' + zDepth, {
	            'md-paper--0-hover': zDepth === 0 && raiseOnHover
	          }, className)
	        }));
	      }
	    }]);
	
	    return Paper;
	  }(_react.PureComponent);
	
	  Paper.propTypes = {
	    /**
	     * The component to render the paper as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The depth of the paper. This should be a number between 0 - 5. If
	     * the depth is 0, it will raise to a depth of 3 on hover.
	     */
	    zDepth: (0, _between2.default)(_react.PropTypes.number.isRequired, 0, 5),
	
	    /**
	     * Any children to display in the paper.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the paper should raise to the `zDepth` of `3` on hover when the initial
	     * `zDepth` is `0`.
	     */
	    raiseOnHover: _react.PropTypes.bool
	  };
	  Paper.defaultProps = {
	    zDepth: 1,
	    component: 'div'
	  };
	  exports.default = Paper;
	});

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactChildren = __webpack_require__(556);
	var ReactComponent = __webpack_require__(141);
	var ReactPureComponent = __webpack_require__(561);
	var ReactClass = __webpack_require__(557);
	var ReactDOMFactories = __webpack_require__(558);
	var ReactElement = __webpack_require__(53);
	var ReactPropTypes = __webpack_require__(560);
	var ReactVersion = __webpack_require__(564);
	
	var onlyChild = __webpack_require__(240);
	var warning = __webpack_require__(4);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	// TODO: Fix tests so that this deprecation warning doesn't cause failures.
	if (false) {
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        process.env.NODE_ENV !== 'production' ? warning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated. Use ' + 'the prop-types package from npm instead.') : void 0;
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	  }
	}
	
	module.exports = React;

/***/ },
/* 28 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 29 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.CSSTransitionGroupTick = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = 17;
	});

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(41)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(29)
	  , core      = __webpack_require__(24)
	  , ctx       = __webpack_require__(149)
	  , hide      = __webpack_require__(42)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 33 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(55)
	  , IE8_DOM_DEFINE = __webpack_require__(151)
	  , toPrimitive    = __webpack_require__(97)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(31) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(152)
	  , defined = __webpack_require__(86);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(554);

/***/ },
/* 37 */
[572, 5],
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(135)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('react-motion'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.reactMotion);
	    global.Collapse = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _reactMotion) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Collapse = function (_PureComponent) {
	    _inherits(Collapse, _PureComponent);
	
	    function Collapse(props) {
	      _classCallCheck(this, Collapse);
	
	      var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	      if (!props.collapsed) {
	        _this.state = { initialOpen: true };
	      } else {
	        _this.state = { height: 0, paddingTop: 0, paddingBottom: 0 };
	      }
	
	      _this._setHeight = _this._setHeight.bind(_this);
	      return _this;
	    }
	
	    _createClass(Collapse, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.state.initialOpen && nextProps.collapsed) {
	          this.setState({ initialOpen: false });
	        }
	      }
	    }, {
	      key: '_spring',
	      value: function _spring(collapsed, initialOpen, value, config) {
	        var nextValue = !collapsed ? Math.max(0, value) : 0;
	        if (initialOpen && !collapsed) {
	          return nextValue;
	        }
	
	        return (0, _reactMotion.spring)(nextValue, config);
	      }
	    }, {
	      key: '_setHeight',
	      value: function _setHeight(child) {
	        var height = 0;
	        var paddingTop = 0;
	        var paddingBottom = 0;
	        if (child !== null) {
	          var node = (0, _reactDom.findDOMNode)(child);
	          var cs = window.getComputedStyle(node);
	          height = node.offsetHeight;
	          paddingTop = parseInt(cs.getPropertyValue('padding-top'), 10);
	          paddingBottom = parseInt(cs.getPropertyValue('padding-bottom'), 10);
	        }
	
	        this.setState({ height: height, paddingTop: paddingTop, paddingBottom: paddingBottom });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            height = _state.height,
	            paddingTop = _state.paddingTop,
	            paddingBottom = _state.paddingBottom,
	            initialOpen = _state.initialOpen;
	        var _props = this.props,
	            children = _props.children,
	            collapsed = _props.collapsed,
	            defaultStyle = _props.defaultStyle,
	            motionStyle = _props.style,
	            springConfig = _props.springConfig;
	
	        return _react2.default.createElement(
	          _reactMotion.Motion,
	          {
	            style: _extends({}, motionStyle, {
	              height: this._spring(collapsed, initialOpen, height, springConfig),
	              paddingTop: this._spring(collapsed, initialOpen, paddingTop, springConfig),
	              paddingBottom: this._spring(collapsed, initialOpen, paddingBottom, springConfig)
	            }),
	            defaultStyle: _extends({}, defaultStyle, {
	              height: height,
	              paddingTop: paddingTop,
	              paddingBottom: paddingBottom
	            })
	          },
	          function (style) {
	            if (collapsed && !style.height) {
	              return null;
	            }
	
	            var child = _react.Children.only(children);
	            var nextStyle = child.props.style;
	            if (collapsed || style.height !== height) {
	              nextStyle = Object.assign({}, child.props.style, _extends({}, style, {
	                overflow: 'hidden'
	              }));
	            }
	            return (0, _react.cloneElement)(child, {
	              ref: _this2._setHeight,
	              style: nextStyle
	            });
	          }
	        );
	      }
	    }]);
	
	    return Collapse;
	  }(_react.PureComponent);
	
	  Collapse.propTypes = {
	    /**
	     * An optional style to merge with the `Motion` style.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional default style to merge with the `Motion` default style.
	     */
	    defaultStyle: _react.PropTypes.object,
	
	    /**
	     * Boolean if the children are currently collapsed.
	     */
	    collapsed: _react.PropTypes.bool.isRequired,
	
	    /**
	     * A single child to collapse or expand.
	     */
	    children: _react.PropTypes.element.isRequired,
	
	    /**
	     * The spring config to use for the animation.
	     */
	    springConfig: _react.PropTypes.object.isRequired
	  };
	  Collapse.defaultProps = {
	    springConfig: {
	      precision: 0.5
	    }
	  };
	  exports.default = Collapse;
	});

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.componentDeprecated = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = componentDeprecated;
	  function componentDeprecated(reason) {
	    return function validate(props, propName, componentName) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	
	      return new Error('The `' + componentNameSafe + '` has been deprecated and will be removed in the next release. ' + reason);
	    };
	  }
	});

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.invalidIf = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = invalidIf;
	  /**
	   * A custom validator that will throw an error if any of the `ifDefinedProps` are also defined.
	   *
	   * @param {function} validator - The PropTypes validator to use.
	   * @param {String...} ifDefinedProps - any othe rprop names to validate against
	   * @return {Error} an error or null
	   */
	  function invalidIf(validator) {
	    for (var _len = arguments.length, ifDefinedProps = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      ifDefinedProps[_key - 1] = arguments[_key];
	    }
	
	    return function validate(props, propName, componentName, location, propFullName) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	        args[_key2 - 5] = arguments[_key2];
	      }
	
	      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	      if (err) {
	        return err;
	      }
	
	      var defined = typeof props[propName] !== 'undefined' && !!props[propName];
	      var othersDefined = ifDefinedProps.filter(function (name) {
	        return typeof props[name] !== 'undefined' && !!props[name];
	      });
	      if (defined && othersDefined.length) {
	        var names = '`' + othersDefined.join('`, `') + '`';
	        if (othersDefined.length === 1) {
	          return new Error('You provided both a `' + propFullNameSafe + '` and ' + names + ' prop to the ' + componentNameSafe + ' ' + 'but only one can be given.');
	        }
	
	        return new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' when ' + ('the following props were defined: ' + names + '. Either remove the `' + propFullNameSafe + '` ') + 'or use the remove all the other props.');
	      }
	
	      return null;
	    };
	  }
	});

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(34)
	  , createDesc = __webpack_require__(70);
	module.exports = __webpack_require__(31) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(94)('wks')
	  , uid        = __webpack_require__(71)
	  , Symbol     = __webpack_require__(29).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(106);
	var setInnerHTML = __webpack_require__(79);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(114);
	var setTextContent = __webpack_require__(187);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(365);
	var ReactInstrumentation = __webpack_require__(20);
	
	var warning = __webpack_require__(4);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.IconSeparator = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var IconSeparator = function (_PureComponent) {
	    _inherits(IconSeparator, _PureComponent);
	
	    function IconSeparator() {
	      _classCallCheck(this, IconSeparator);
	
	      return _possibleConstructorReturn(this, (IconSeparator.__proto__ || Object.getPrototypeOf(IconSeparator)).apply(this, arguments));
	    }
	
	    _createClass(IconSeparator, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            labelStyle = _props.labelStyle,
	            labelClassName = _props.labelClassName,
	            component = _props.component,
	            label = _props.label,
	            iconBefore = _props.iconBefore,
	            children = _props.children,
	            props = _objectWithoutProperties(_props, ['className', 'labelStyle', 'labelClassName', 'component', 'label', 'iconBefore', 'children']);
	
	        var text = void 0;
	        if ((0, _react.isValidElement)(label)) {
	          var labelProps = _react.Children.only(label).props;
	          text = (0, _react.cloneElement)(label, {
	            className: (0, _classnames2.default)('md-icon-text', labelClassName, labelProps.className),
	            style: _extends({}, labelStyle, labelProps.style)
	          });
	        } else {
	          text = _react2.default.createElement(
	            'span',
	            { style: labelStyle, className: (0, _classnames2.default)('md-icon-text', labelClassName) },
	            label
	          );
	        }
	
	        var Component = component;
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, { className: (0, _classnames2.default)('md-icon-separator', className) }),
	          iconBefore && children,
	          text,
	          !iconBefore && children
	        );
	      }
	    }]);
	
	    return IconSeparator;
	  }(_react.PureComponent);
	
	  IconSeparator.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the label.
	     */
	    labelStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the label.
	     */
	    labelClassName: _react.PropTypes.string,
	
	    /**
	     * The label to display.
	     */
	    label: _react.PropTypes.node.isRequired,
	
	    /**
	     * The icon to display.
	     */
	    children: _react.PropTypes.node.isRequired,
	
	    /**
	     * Boolean if the icon should appear before or after the text
	     */
	    iconBefore: _react.PropTypes.bool,
	
	    /**
	     * The component to be rendered as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired
	  };
	  IconSeparator.defaultProps = {
	    component: 'div'
	  };
	  exports.default = IconSeparator;
	});

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(211), __webpack_require__(8), __webpack_require__(204)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Subheaders'), require('react-prop-types/lib/deprecated'), require('../Menus/contextTypes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.Subheaders, global.deprecated, global.contextTypes);
	    global.List = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _Subheaders, _deprecated, _contextTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _Subheaders2 = _interopRequireDefault(_Subheaders);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var List = function (_PureComponent) {
	    _inherits(List, _PureComponent);
	
	    function List() {
	      _classCallCheck(this, List);
	
	      return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
	    }
	
	    _createClass(List, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        var _context = this.context,
	            listLevel = _context.listLevel,
	            context = _objectWithoutProperties(_context, ['listLevel']);
	
	        return _extends({}, context, {
	          listLevel: typeof listLevel === 'undefined' ? 1 : listLevel + 1
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _cn;
	
	        var _props = this.props,
	            className = _props.className,
	            ordered = _props.ordered,
	            children = _props.children,
	            subheader = _props.subheader,
	            primarySubheader = _props.primarySubheader,
	            props = _objectWithoutProperties(_props, ['className', 'ordered', 'children', 'subheader', 'primarySubheader']);
	
	        var _context2 = this.context,
	            menuPosition = _context2.menuPosition,
	            menuCascading = _context2.menuCascading,
	            listLevel = _context2.listLevel;
	
	
	        var subheaderEl = void 0;
	        if (subheader) {
	          subheaderEl = _react2.default.createElement(_Subheaders2.default, { key: 'subheader', primaryText: subheader, primary: primarySubheader });
	        }
	
	        var Component = ordered ? 'ol' : 'ul';
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-list', (_cn = {
	              'md-list--menu': menuPosition,
	              'md-list--menu-scrollable': menuPosition && !menuCascading,
	              'md-list--menu-cascading': menuCascading,
	              'md-list--menu-nested': menuPosition && listLevel
	            }, _defineProperty(_cn, 'md-list--nested-' + listLevel, listLevel && !menuPosition), _defineProperty(_cn, 'md-list--menu-' + menuPosition, menuPosition), _cn), className)
	          }),
	          subheaderEl,
	          children
	        );
	      }
	    }]);
	
	    return List;
	  }(_react.PureComponent);
	
	  List.propTypes = {
	    /**
	     * An optional style to apply to the list.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the list.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Boolean if this should be an ordered list (`<ol>`) component. Otherwise, it will
	     * be rendered as `<ul>`.
	     */
	    ordered: _react.PropTypes.bool,
	
	    /**
	     * This *should* be a list of `ListItem`, `ListItemControl`, `Divider`, or
	     * `Subheader`.
	     */
	    children: _react.PropTypes.node,
	    subheader: (0, _deprecated2.default)(_react.PropTypes.string, 'Use the `Subheader` component as a child instead'),
	    primarySubheader: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use the `Subheader` component as a child instead')
	  };
	  List.childContextTypes = _contextTypes2.default;
	  List.contextTypes = _contextTypes2.default;
	  exports.default = List;
	});

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(8), __webpack_require__(13), __webpack_require__(12), __webpack_require__(520), __webpack_require__(22), __webpack_require__(18), __webpack_require__(475)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/getField'), require('../utils/StringUtils/capitalizeFirst'), require('../Helpers/AccessibleFakeInkedButton'), require('../FontIcons/FontIcon'), require('./SwitchTrack'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.deprecated, global.isRequiredForA11y, global.getField, global.capitalizeFirst, global.AccessibleFakeInkedButton, global.FontIcon, global.SwitchTrack);
	    global.SelectionControl = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _deprecated, _isRequiredForA11y, _getField, _capitalizeFirst, _AccessibleFakeInkedButton, _FontIcon, _SwitchTrack) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _capitalizeFirst2 = _interopRequireDefault(_capitalizeFirst);
	
	  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  var _SwitchTrack2 = _interopRequireDefault(_SwitchTrack);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * Prevents a second warning from appearing when using the deprecated or a11y required
	   * props by using the `__superSecretProp`.... So secret!
	   */
	  function preventDouble(validator) {
	    return function validate(props, propName) {
	      for (var _len = arguments.length, others = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        others[_key - 2] = arguments[_key];
	      }
	
	      var err = validator.apply(undefined, [props, propName].concat(others));
	      if (err && props.__superSecreteProp) {
	        err = null;
	      }
	
	      return err;
	    };
	  }
	
	  /**
	   * The `SelectionControl` component is used to render any of the `Radio`, `Checkbox`, or `Switch`
	   * selection control type. This component might eventually replace all three since they use this
	   * anyways. I am not sure yet though.
	   */
	
	  var SelectionControl = function (_PureComponent) {
	    _inherits(SelectionControl, _PureComponent);
	
	    function SelectionControl(props) {
	      _classCallCheck(this, SelectionControl);
	
	      var _this = _possibleConstructorReturn(this, (SelectionControl.__proto__ || Object.getPrototypeOf(SelectionControl)).call(this, props));
	
	      _this.state = {};
	      if (typeof props.checked === 'undefined') {
	        _this.state.checked = !!props.defaultChecked;
	      }
	
	      _this._setInput = _this._setInput.bind(_this);
	      _this._setControl = _this._setControl.bind(_this);
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._handleChange = _this._handleChange.bind(_this);
	      _this._handleControlClick = _this._handleControlClick.bind(_this);
	      _this._getIcon = _this._getIcon.bind(_this);
	      return _this;
	    }
	
	    _createClass(SelectionControl, [{
	      key: '_setInput',
	      value: function _setInput(input) {
	        this._input = input;
	      }
	    }, {
	      key: '_setControl',
	      value: function _setControl(control) {
	        this._control = control;
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        this._container = container;
	      }
	    }, {
	      key: '_getIcon',
	      value: function _getIcon() {
	        var _props = this.props,
	            checkedIcon = _props.checkedIcon,
	            uncheckedIcon = _props.uncheckedIcon,
	            type = _props.type;
	
	        var checked = (0, _getField2.default)(this.props, this.state, 'checked');
	        if (checkedIcon || uncheckedIcon) {
	          return checked ? checkedIcon : uncheckedIcon;
	        }
	
	        var prefix = (checked ? '' : 'un') + 'checked' + (0, _capitalizeFirst2.default)(type) + 'Icon';
	        return _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: this.props[prefix + 'ClassName'] },
	          this.props[prefix + 'Children']
	        );
	      }
	    }, {
	      key: '_handleChange',
	      value: function _handleChange(e) {
	        var _props2 = this.props,
	            type = _props2.type,
	            onChange = _props2.onChange;
	
	        var checked = !(0, _getField2.default)(this.props, this.state, 'checked');
	        if (onChange) {
	          onChange(type === 'radio' ? e.target.value : checked, e);
	        }
	
	        if (!this._fromFakeButton && type !== 'switch' && typeof this._control.createInk === 'function') {
	          // create ink doesn't exist when testing atm
	          this._control.createInk();
	        }
	        this._fromFakeButton = false;
	
	        if (typeof this.props.checked === 'undefined') {
	          this.setState({ checked: checked });
	        }
	      }
	    }, {
	      key: '_handleControlClick',
	      value: function _handleControlClick() {
	        this._fromFakeButton = true;
	        // Trigger the change
	        this._input.click();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props3 = this.props,
	            id = _props3.id,
	            style = _props3.style,
	            className = _props3.className,
	            inline = _props3.inline,
	            type = _props3.type,
	            name = _props3.name,
	            value = _props3.value,
	            disabled = _props3.disabled,
	            labelBefore = _props3.labelBefore,
	            onBlur = _props3.onBlur,
	            onFocus = _props3.onFocus,
	            props = _objectWithoutProperties(_props3, ['id', 'style', 'className', 'inline', 'type', 'name', 'value', 'disabled', 'labelBefore', 'onBlur', 'onFocus']);
	
	        delete props.label;
	        delete props.checked;
	        delete props.onChange;
	        delete props.checkedIcon;
	        delete props.uncheckedIcon;
	        delete props.__superSecreteProp;
	        delete props.checkedRadioIconChildren;
	        delete props.checkedRadioIconClassName;
	        delete props.uncheckedRadioIconChildren;
	        delete props.uncheckedRadioIconClassName;
	        delete props.checkedCheckboxIconChildren;
	        delete props.checkedCheckboxIconClassName;
	        delete props.uncheckedCheckboxIconChildren;
	        delete props.uncheckedCheckboxIconClassName;
	
	        var checked = (0, _getField2.default)(this.props, this.state, 'checked');
	        var isSwitch = type === 'switch';
	        var label = _react2.default.createElement(
	          'label',
	          {
	            key: 'label',
	            htmlFor: id,
	            className: (0, _classnames2.default)('md-selection-control-label', {
	              'md-pointer--hover': !disabled,
	              'md-text--disabled': disabled,
	              'md-text': !disabled
	            })
	          },
	          this.props.label
	        );
	
	        var control = void 0;
	        if (isSwitch) {
	          control = _react2.default.createElement(_SwitchTrack2.default, {
	            disabled: disabled,
	            checked: checked,
	            onClick: this._handleControlClick,
	            onBlur: onBlur,
	            onFocus: onFocus
	          });
	        } else {
	          control = _react2.default.createElement(
	            _AccessibleFakeInkedButton2.default,
	            {
	              ref: this._setControl,
	              onBlur: onBlur,
	              onFocus: onFocus,
	              disabled: disabled,
	              onClick: this._handleControlClick,
	              className: (0, _classnames2.default)('md-btn md-btn--icon', {
	                'md-text--disabled': disabled,
	                'md-text--theme-secondary': !disabled && checked,
	                'md-text--secondary': !disabled && !checked
	              }),
	              role: type,
	              'aria-checked': checked
	            },
	            this._getIcon()
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, {
	            ref: this._setContainer,
	            style: style,
	            className: (0, _classnames2.default)('md-selection-control-container', {
	              'md-selection-control-container--inline': inline,
	              'md-switch-container': isSwitch
	            }, className)
	          }),
	          labelBefore && label,
	          _react2.default.createElement('input', {
	            ref: this._setInput,
	            id: id,
	            type: isSwitch ? 'checkbox' : type,
	            checked: checked,
	            onChange: this._handleChange,
	            disabled: disabled,
	            className: 'md-selection-control-input',
	            name: name,
	            value: value,
	            'aria-hidden': true
	          }),
	          control,
	          !labelBefore && label
	        );
	      }
	    }]);
	
	    return SelectionControl;
	  }(_react.PureComponent);
	
	  SelectionControl.propTypes = {
	    /**
	     * An id to use with the selection control. This is used for accessibility and so that the label
	     * triggers the selection control toggle.
	     */
	    id: preventDouble((0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]))),
	
	    /**
	     * An optional style to apply to the selection control's container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the selection control's container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The type of selection control to render.
	     */
	    type: _react.PropTypes.oneOf(['checkbox', 'radio', 'switch']).isRequired,
	
	    /**
	     * A label to display with the selection control. This is required for accessibility and triggering
	     * the toggle.
	     */
	    label: _react.PropTypes.node,
	
	    /**
	     * Boolean if the label should appear before the checkbox/radio icon or switch.
	     */
	    labelBefore: _react.PropTypes.bool,
	
	    /**
	     * A name to use for the `SelectionControl`. This is required for accessibility. If the `type`
	     * is a `checkbox` and it is part of a group, it is recommended to make this a string ending
	     * in `[]` so that the value can be found from `document.querySelector('input[name="someName[]"]').value`.
	     */
	    name: preventDouble((0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]))),
	
	    /**
	     * Boolean if the `Radio` is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * A function to call when the `SelectionControl` triggers the `change` event. The `onChange`
	     * callback will either include:
	     * - the currently changed radio's value
	     * - the next checked state for the `Switch` or `Checkbox`.
	     *
	     * as the first paramater followed by the change event.
	     *
	     * ```js
	     * // Radio
	     * onChange(changeEvent.target.value, changeEvent);
	     *
	     * // Checkbox or Switch
	     * onChange(changeEvent.target.checked, changeEvent);
	     * ```
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `SelectionControl` triggers the `blur` event.
	     */
	    onBlur: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `SelectionControl` triggers the `focus` event.
	     */
	    onFocus: _react.PropTypes.func,
	
	    /**
	     * The value for the `SelectionControl`. It is not required for `Checkbox` and `Switch`,
	     * but it is recommended.
	     */
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * A boolean if the `SelectionControl` is currently checked. This _really_ makes the `onChange`
	     * prop required, but since there are cases you might want to have the `onChange` listener on a
	     * `fieldset` or something above the component, it is never set to `required`. It will however
	     * prevent updates if there is no change listener.
	     */
	    checked: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `Checkbox` or `Switch` are checked by default. This prop is invalid for a
	     * `Radio`.
	     */
	    defaultChecked: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `SelectionControl` should be displayed inline instead of a block.
	     */
	    inline: _react.PropTypes.bool,
	
	    /**
	     * Any children used to render the checkbox checked `FontIcon`.
	     */
	    checkedCheckboxIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className to use to render the checkbox checked `FontIcon`.
	     */
	    checkedCheckboxIconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children used to render the checkbox unchecked `FontIcon`.
	     */
	    uncheckedCheckboxIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className to use to render the checkbox unchecked `FontIcon`.
	     */
	    uncheckedCheckboxIconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children used to render the radio checked `FontIcon`.
	     */
	    checkedRadioIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className to use to render the radio checked `FontIcon`.
	     */
	    checkedRadioIconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children used to render the radio unchecked `FontIcon`.
	     */
	    uncheckedRadioIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className to use to render the radio unchecked `FontIcon`.
	     */
	    uncheckedRadioIconClassName: _react.PropTypes.string,
	
	    checkedIcon: preventDouble((0, _deprecated2.default)(_react.PropTypes.node, 'Use the `checkedCheckboxIconChildren` and `checkedCheckboxIconClassName`  or the ' + '`checkedRadioIconChildren` and `checkedRadioIconClassName` props instead')),
	    uncheckedIcon: preventDouble((0, _deprecated2.default)(_react.PropTypes.node, 'Use the `uncheckedCheckboxIconChildren` and `uncheckedCheckboxIconClassName`  or the ' + '`uncheckedRadioIconChildren` and `uncheckedRadioIconClassName` props instead')),
	
	    /* maybe removed once upgrade again? */
	    __superSecreteProp: _react.PropTypes.bool
	  };
	  SelectionControl.defaultProps = {
	    checkedCheckboxIconChildren: 'check_box',
	    uncheckedCheckboxIconChildren: 'check_box_outline_blank',
	    checkedRadioIconChildren: 'radio_button_checked',
	    uncheckedRadioIconChildren: 'radio_button_unchecked'
	  };
	  exports.default = SelectionControl;
	});

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(8), __webpack_require__(13), __webpack_require__(11), __webpack_require__(14), __webpack_require__(40), __webpack_require__(516), __webpack_require__(227), __webpack_require__(214), __webpack_require__(216), __webpack_require__(498), __webpack_require__(496), __webpack_require__(215)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../utils/PropTypes/controlled'), require('../utils/PropTypes/invalidIf'), require('../utils/PropTypes/minNumber'), require('../utils/StringUtils/addSuffix'), require('./FloatingLabel'), require('./TextFieldMessage'), require('./PasswordButton'), require('./InputField'), require('./TextFieldDivider'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.deprecated, global.isRequiredForA11y, global.keyCodes, global.controlled, global.invalidIf, global.minNumber, global.addSuffix, global.FloatingLabel, global.TextFieldMessage, global.PasswordButton, global.InputField, global.TextFieldDivider);
	    global.TextField = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _deprecated, _isRequiredForA11y, _keyCodes, _controlled, _invalidIf, _minNumber, _addSuffix, _FloatingLabel, _TextFieldMessage, _PasswordButton, _InputField, _TextFieldDivider) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	  var _minNumber2 = _interopRequireDefault(_minNumber);
	
	  var _addSuffix2 = _interopRequireDefault(_addSuffix);
	
	  var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);
	
	  var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);
	
	  var _PasswordButton2 = _interopRequireDefault(_PasswordButton);
	
	  var _InputField2 = _interopRequireDefault(_InputField);
	
	  var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TextField = function (_PureComponent) {
	    _inherits(TextField, _PureComponent);
	
	    function TextField(props) {
	      _classCallCheck(this, TextField);
	
	      var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));
	
	      var currentLength = 0;
	      if (typeof props.value !== 'undefined') {
	        currentLength = props.value.length;
	      } else if (typeof props.defaultValue !== 'undefined') {
	        currentLength = props.defaultValue.length;
	      }
	
	      _this.state = {
	        active: false,
	        error: false,
	        floating: !!props.defaultValue || !!props.value,
	        passwordVisible: props.passwordInitiallyVisible,
	        height: null,
	        currentLength: currentLength
	      };
	
	      _this.focus = _this.focus.bind(_this);
	      _this.getField = _this.getField.bind(_this);
	      _this._blur = _this._blur.bind(_this);
	      _this._setField = _this._setField.bind(_this);
	      _this._setDivider = _this._setDivider.bind(_this);
	      _this._setMessage = _this._setMessage.bind(_this);
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._setPasswordBtn = _this._setPasswordBtn.bind(_this);
	      _this._setFloatingLabel = _this._setFloatingLabel.bind(_this);
	      _this._handleFocus = _this._handleFocus.bind(_this);
	      _this._handleChange = _this._handleChange.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._handleHeightChange = _this._handleHeightChange.bind(_this);
	      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
	      _this._updateMultilineHeight = _this._updateMultilineHeight.bind(_this);
	      _this._togglePasswordField = _this._togglePasswordField.bind(_this);
	      _this._handleContainerClick = _this._handleContainerClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(TextField, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this._isMultiline(this.props)) {
	          this._updateMultilineHeight();
	          window.addEventListener('resize', this._updateMultilineHeight);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var multiline = this._isMultiline(nextProps);
	        if (this._isMultiline(this.props) !== multiline) {
	          this._updateMultilineHeight(nextProps);
	          window[(multiline ? 'add' : 'remove') + 'EventListener']('resize', this._updateMultilineHeight);
	        }
	
	        if (this.props.value !== nextProps.value) {
	          var value = typeof nextProps.value !== 'undefined' ? nextProps.value.toString() : '';
	          var error = this.state.error;
	
	          if (nextProps.maxLength) {
	            error = value.length > nextProps.maxLength;
	          } else if (nextProps.required && error) {
	            error = !value;
	          }
	
	          this.setState({
	            error: error,
	            floating: !!value || this.state.floating && this.state.active,
	            currentLength: value.length
	          });
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var _props = this.props,
	            block = _props.block,
	            active = _props.active;
	
	        if (block !== prevProps.block || active !== prevProps.active || this.state.active !== prevState.active) {
	          var fn = window[(active || this.state.active ? 'add' : 'remove') + 'EventListener'];
	          fn('mousedown', this._handleOutsideClick);
	          fn('touchstart', this._handleOutsideClick);
	        }
	
	        if (this._isMultiline(this.props) && !this._isMultiline(prevProps)) {
	          this._updateMultilineHeight(this.props);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var active = this.props.active;
	
	        var rm = window.removeEventListener;
	        if (active || this.state.active) {
	          rm('mousedown', this._handleOutsideClick);
	          rm('touchstart', this._handleOutsideClick);
	        }
	
	        if (this._isMultiline(this.props)) {
	          rm('resize', this._updateMultilineHeight);
	        }
	      }
	    }, {
	      key: 'getField',
	      value: function getField() {
	        return this._field.getField();
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        this._field.focus();
	      }
	    }, {
	      key: '_isMultiline',
	      value: function _isMultiline(props) {
	        return typeof props.rows !== 'undefined';
	      }
	    }, {
	      key: '_cloneIcon',
	      value: function _cloneIcon(icon, active, error, disabled, stateful, block, dir) {
	        if (!icon) {
	          return icon;
	        }
	
	        try {
	          var iconEl = _react.Children.only(icon);
	          return (0, _react.cloneElement)(iconEl, {
	            key: 'icon-' + dir,
	            className: (0, _classnames2.default)('md-text-field-icon', {
	              'md-text-field-icon--positioned': !block,
	              'md-text-field-icon--disabled': disabled,
	              'md-text-field-icon--active': stateful && !error && active,
	              'md-text-field-icon--error': stateful && error
	            }, iconEl.props.className)
	          });
	        } catch (e) {
	          return icon;
	        }
	      }
	    }, {
	      key: '_setField',
	      value: function _setField(field) {
	        if (field !== null) {
	          this._field = field;
	        }
	      }
	    }, {
	      key: '_setMessage',
	      value: function _setMessage(message) {
	        if (message !== null) {
	          this._message = (0, _reactDom.findDOMNode)(message);
	        }
	      }
	    }, {
	      key: '_setDivider',
	      value: function _setDivider(divider) {
	        if (divider !== null) {
	          this._divider = (0, _reactDom.findDOMNode)(divider);
	        }
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        if (container !== null) {
	          this._node = container;
	        }
	      }
	    }, {
	      key: '_setPasswordBtn',
	      value: function _setPasswordBtn(btn) {
	        if (btn !== null) {
	          this._password = (0, _reactDom.findDOMNode)(btn);
	        }
	      }
	    }, {
	      key: '_setFloatingLabel',
	      value: function _setFloatingLabel(label) {
	        if (label !== null) {
	          this._label = (0, _reactDom.findDOMNode)(label);
	        }
	      }
	    }, {
	      key: '_handleContainerClick',
	      value: function _handleContainerClick(e) {
	        if (this.props.onClick) {
	          this.props.onClick(e);
	        }
	
	        if (!this.props.disabled) {
	          this.focus();
	        }
	      }
	    }, {
	      key: '_updateMultilineHeight',
	      value: function _updateMultilineHeight() {
	        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	        var block = props.block;
	
	        var multiline = this._isMultiline(props);
	        if (!multiline) {
	          return;
	        }
	
	        var cs = window.getComputedStyle((0, _reactDom.findDOMNode)(this._field));
	        this._additionalHeight = parseInt(cs.getPropertyValue('margin-top'), 10);
	
	        if (!block) {
	          var mb = parseInt(window.getComputedStyle(this._divider).getPropertyValue('margin-bottom'), 10);
	          this._additionalHeight += mb === 4 ? 12 : 16;
	        }
	
	        if (this._message) {
	          this._additionalHeight += this._message.offsetHeight;
	        }
	      }
	    }, {
	      key: '_blur',
	      value: function _blur() {
	        var value = this._field.getValue();
	
	        var state = { active: false, error: this.props.required && !value };
	        if (!this.props.block) {
	          state.floating = !!value;
	        }
	
	        this.setState(state);
	      }
	    }, {
	      key: '_handleOutsideClick',
	      value: function _handleOutsideClick(e) {
	        if (!this._node.contains(e.target)) {
	          this._blur();
	        }
	      }
	    }, {
	      key: '_handleFocus',
	      value: function _handleFocus(e) {
	        var _props2 = this.props,
	            onFocus = _props2.onFocus,
	            block = _props2.block;
	
	        if (onFocus) {
	          onFocus(e);
	        }
	
	        var state = { active: true };
	        if (!block) {
	          state.floating = true;
	        }
	
	        this.setState(state);
	      }
	    }, {
	      key: '_handleChange',
	      value: function _handleChange(e) {
	        var _props3 = this.props,
	            onChange = _props3.onChange,
	            maxLength = _props3.maxLength,
	            required = _props3.required;
	
	        if (onChange) {
	          onChange(e.target.value, e);
	        }
	
	        var currentLength = e.target.value.length;
	        if (typeof maxLength !== 'undefined') {
	          this.setState({ currentLength: currentLength, error: currentLength > maxLength });
	        } else if (required && this.state.error) {
	          this.setState({ error: !currentLength });
	        }
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        if (this.props.onKeyDown) {
	          this.props.onKeyDown(e);
	        }
	
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          this._blur();
	        }
	      }
	    }, {
	      key: '_togglePasswordField',
	      value: function _togglePasswordField() {
	        this.setState({ passwordVisible: !this.state.passwordVisible }, this.focus);
	      }
	    }, {
	      key: '_handleHeightChange',
	      value: function _handleHeightChange(height) {
	        if (this._additionalHeight) {
	          this.setState({ height: height + this._additionalHeight });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            currentLength = _state.currentLength,
	            passwordVisible = _state.passwordVisible,
	            height = _state.height;
	
	        var _props4 = this.props,
	            id = _props4.id,
	            type = _props4.type,
	            style = _props4.style,
	            className = _props4.className,
	            inputStyle = _props4.inputStyle,
	            inputClassName = _props4.inputClassName,
	            block = _props4.block,
	            fullWidth = _props4.fullWidth,
	            required = _props4.required,
	            customSize = _props4.customSize,
	            maxLength = _props4.maxLength,
	            errorText = _props4.errorText,
	            helpText = _props4.helpText,
	            helpOnFocus = _props4.helpOnFocus,
	            disabled = _props4.disabled,
	            leftIconStateful = _props4.leftIconStateful,
	            rightIconStateful = _props4.rightIconStateful,
	            passwordIconChildren = _props4.passwordIconChildren,
	            passwordIconClassName = _props4.passwordIconClassName,
	            lineDirection = _props4.lineDirection,
	            paddedBlock = _props4.paddedBlock,
	            onDoubleClick = _props4.onDoubleClick,
	            onTouchStart = _props4.onTouchStart,
	            onTouchMove = _props4.onTouchMove,
	            onTouchCancel = _props4.onTouchCancel,
	            onTouchEnd = _props4.onTouchEnd,
	            onMouseDown = _props4.onMouseDown,
	            onMouseUp = _props4.onMouseUp,
	            onMouseOver = _props4.onMouseOver,
	            onMouseLeave = _props4.onMouseLeave,
	            ink = _props4.ink,
	            inlineIndicator = _props4.inlineIndicator,
	            icon = _props4.icon,
	            props = _objectWithoutProperties(_props4, ['id', 'type', 'style', 'className', 'inputStyle', 'inputClassName', 'block', 'fullWidth', 'required', 'customSize', 'maxLength', 'errorText', 'helpText', 'helpOnFocus', 'disabled', 'leftIconStateful', 'rightIconStateful', 'passwordIconChildren', 'passwordIconClassName', 'lineDirection', 'paddedBlock', 'onDoubleClick', 'onTouchStart', 'onTouchMove', 'onTouchCancel', 'onTouchEnd', 'onMouseDown', 'onMouseUp', 'onMouseOver', 'onMouseLeave', 'ink', 'inlineIndicator', 'icon']);
	
	        delete props.label;
	        delete props.placeholder;
	        delete props.error;
	        delete props.active;
	        delete props.floating;
	        delete props.leftIcon;
	        delete props.rightIcon;
	        delete props.adjustMinWidth;
	        delete props.onClick;
	        delete props.onChange;
	        delete props.onKeyDown;
	        delete props.onFocus;
	        delete props.floatingLabel;
	
	        var _props5 = this.props,
	            label = _props5.label,
	            placeholder = _props5.placeholder,
	            error = _props5.error,
	            active = _props5.active,
	            floating = _props5.floating,
	            leftIcon = _props5.leftIcon,
	            rightIcon = _props5.rightIcon;
	
	        active = active || this.state.active;
	        error = error || this.state.error;
	        floating = floating || this.state.floating;
	
	        if (required) {
	          if (label) {
	            label = (0, _addSuffix2.default)(label, '*');
	          }
	
	          if (placeholder && !label) {
	            placeholder = (0, _addSuffix2.default)(placeholder, '*');
	          }
	        }
	
	        if (label && !floating) {
	          placeholder = null;
	        }
	
	        leftIcon = this._cloneIcon(icon || leftIcon, active, error, disabled, leftIconStateful, block, 'left');
	        if (type === 'password' && !disabled) {
	          rightIcon = _react2.default.createElement(_PasswordButton2.default, {
	            key: 'password-btn',
	            ref: this._setPasswordBtn,
	            onClick: this._togglePasswordField,
	            active: active,
	            passwordVisible: passwordVisible,
	            iconChildren: passwordIconChildren,
	            iconClassName: passwordIconClassName,
	            block: block,
	            floating: !!label
	          });
	        } else if (inlineIndicator) {
	          var el = _react.Children.only(inlineIndicator);
	          rightIcon = (0, _react.cloneElement)(inlineIndicator, {
	            key: 'icon-right',
	            className: (0, _classnames2.default)('md-text-field-inline-indicator', {
	              'md-text-field-inline-indicator--floating': label,
	              'md-text-field-inline-indicator--block': block
	            }, el.props.className)
	          });
	        } else {
	          rightIcon = this._cloneIcon(rightIcon, active, error, disabled, rightIconStateful, block, 'right');
	        }
	        var rightIconed = !!rightIcon && type !== 'password' && !inlineIndicator;
	
	        var floatingLabel = _react2.default.createElement(_FloatingLabel2.default, {
	          key: 'label',
	          ref: this._setFloatingLabel,
	          label: label,
	          htmlFor: id,
	          active: active,
	          error: error,
	          floating: floating,
	          customSize: customSize,
	          disabled: disabled,
	          iconOffset: !!leftIcon
	        });
	
	        var message = _react2.default.createElement(_TextFieldMessage2.default, {
	          key: 'message',
	          ref: this._setMessage,
	          active: active,
	          error: error,
	          errorText: errorText,
	          helpText: helpText,
	          helpOnFocus: helpOnFocus,
	          block: block,
	          maxLength: maxLength,
	          leftIcon: !!leftIcon,
	          rightIcon: !!rightIcon,
	          currentLength: currentLength
	        });
	
	        var field = _react2.default.createElement(_InputField2.default, _extends({}, props, {
	          key: 'field',
	          ref: this._setField,
	          id: id,
	          type: type,
	          label: label,
	          style: inputStyle,
	          className: inputClassName,
	          disabled: disabled,
	          customSize: customSize,
	          fullWidth: fullWidth,
	          passwordVisible: passwordVisible,
	          placeholder: placeholder,
	          block: block,
	          onFocus: this._handleFocus,
	          onKeyDown: this._handleKeyDown,
	          onChange: this._handleChange,
	          onHeightChange: this._handleHeightChange,
	          inlineIndicator: !!inlineIndicator
	        }));
	
	        var divider = void 0;
	        if (!block) {
	          divider = _react2.default.createElement(_TextFieldDivider2.default, {
	            key: 'text-divider',
	            ref: this._setDivider,
	            active: active,
	            error: error,
	            lineDirection: lineDirection
	          });
	        }
	
	        var children = void 0;
	        if (leftIcon || rightIconed) {
	          children = _react2.default.createElement(
	            'div',
	            { key: 'icon-divider', className: 'md-text-field-icon-container' },
	            leftIcon,
	            _react2.default.createElement(
	              'div',
	              {
	                key: 'divider-container',
	                className: (0, _classnames2.default)('md-text-field-divider-container', {
	                  'md-text-field-divider-container--grow': fullWidth
	                })
	              },
	              field,
	              divider
	            ),
	            rightIcon
	          );
	        } else {
	          children = [leftIcon, field, divider, rightIcon];
	        }
	
	        children = [floatingLabel, children, message];
	
	        var multiline = this._isMultiline(this.props);
	        return _react2.default.createElement(
	          'div',
	          {
	            ref: this._setContainer,
	            style: Object.assign({}, style, { height: height }),
	            className: (0, _classnames2.default)('md-text-field-container', {
	              'md-inline-block': !fullWidth && !block,
	              'md-full-width': block || fullWidth,
	              'md-text-field-container--disabled': disabled,
	              'md-text-field-container--input': typeof props.rows === 'undefined',
	              'md-text-field-container--input-block': block && !multiline,
	              'md-text-field-container--multiline': multiline,
	              'md-text-field-container--multiline-block': multiline && block,
	              'md-text-field-container--padded-block': block && paddedBlock
	            }, className),
	            onClick: this._handleContainerClick,
	            onDoubleClick: onDoubleClick,
	            onMouseOver: onMouseOver,
	            onMouseLeave: onMouseLeave,
	            onMouseDown: onMouseDown,
	            onMouseUp: onMouseUp,
	            onTouchStart: onTouchStart,
	            onTouchEnd: onTouchEnd,
	            onTouchCancel: onTouchCancel,
	            onTouchMove: onTouchMove
	          },
	          ink,
	          children
	        );
	      }
	    }]);
	
	    return TextField;
	  }(_react.PureComponent);
	
	  TextField.propTypes = {
	    /**
	     * An optional style to apply to the text field's container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the text field's container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the `input` or `textarea` tag.
	     */
	    inputStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `input` or `textarea` tag.
	     */
	    inputClassName: _react.PropTypes.string,
	
	    /**
	     * An optional value to apply to the text field. This will make the component
	     * controlled and require the `onChange` prop.
	     */
	    value: (0, _controlled2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]), 'onChange'),
	
	    /**
	     * An optional default value for the text field.
	     */
	    defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	    /**
	     * Boolean if the text field should be displayed as a `block`. This is equivalent to
	     * the `full width` text field in the Material Design specs. This view will disable
	     * floating labels and remove the text divider from the component.
	     */
	    block: function block(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      var err = _react.PropTypes.bool.apply(_react.PropTypes, [props, propName, component].concat(others));
	      if (!err && props[propName] && props.label) {
	        err = new Error('The `' + component + '` is unable to have a `label` and be displayed as `block`. ' + ('If you would like a `label` for the block `' + component + '`, please use the `placeholder` prop.'));
	      }
	
	      return err;
	    },
	
	    /**
	     * Boolean if the `block` text field should include padding to the left and right of
	     * the text field.
	     */
	    paddedBlock: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the text field is currently disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional label to display with the text field. This will convert the text field
	     * into a floating label text field. You can make it single line by only using the
	     * `placeholder` prop.
	     */
	    label: _react.PropTypes.string,
	
	    /**
	     * An optional placeholder text to display in the text field. If there is no `label` prop,
	     * the text field will be displayed as a single line text field. If there is a `label` prop,
	     * this will only be visible when there is no value and the user focused the text field.
	     */
	    placeholder: _react.PropTypes.string,
	
	    /**
	     * The id for the text field.  This is required for a11y if the `label` prop is defined.
	     */
	    id: function id(props, propName, component) {
	      for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	        others[_key2 - 3] = arguments[_key2];
	      }
	
	      var validator = _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]);
	      if (typeof props.label !== 'undefined') {
	        return (0, _isRequiredForA11y2.default)(validator).apply(undefined, [props, propName, component].concat(others));
	      }
	
	      return validator.apply(undefined, [props, propName, component].concat(others));
	    },
	
	    /**
	     * The type for the text field. This is one of the most import props for mobile accessibility
	     * as it will update the keyboard for the text type. This does not get applied on multiline
	     * text fields.
	     */
	    type: _react.PropTypes.oneOf(['text', 'number', 'email', 'search', 'tel', 'url', 'password']).isRequired,
	
	    /**
	     * An optional function to call when the text field's container triggers the `click` event.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field's container triggers the `doubleclick`
	     * event.
	     */
	    onDoubleClick: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field's container triggers the `touchstart`
	     * event.
	     */
	    onTouchStart: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field's container triggers the `touchmove`
	     * event.
	     */
	    onTouchMove: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field's container triggers the `touchcancel`
	     * event.
	     */
	    onTouchCancel: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field's container triggers the `touchend`
	     * event.
	     */
	    onTouchEnd: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field's container triggers the `mousedown`
	     * event.
	     */
	    onMouseDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field's container triggers the `mouseup`
	     * event.
	     */
	    onMouseUp: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field's container triggers the `mouseover`
	     * event.
	     */
	    onMouseOver: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field's container triggers the `mouseleave`
	     * event.
	     */
	    onMouseLeave: _react.PropTypes.func,
	
	    /**
	     * An optional onChange function to call. If the `value` prop is true, this is
	     * required.
	     *
	     * When the value changes in the text field, this will be called with the new text
	     * field's value and the change event.
	     *
	     * ```js
	     * onChange(e.target.value, e);
	     * ```
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field is focused.
	     */
	    onFocus: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the text field has the `keydown` event.
	     */
	    onKeyDown: _react.PropTypes.func,
	
	    /**
	     * An optional boolean if the `active` state of the text field can be externally
	     * modified as well. The text field is usually considered active when it gains focus.
	     *
	     * If this prop is set, it will check both the active prop and the active state to
	     * determine if one is true.
	     */
	    active: _react.PropTypes.bool,
	
	    /**
	     * An optional boolean if the `error` state of the text field can be externally
	     * modified as well. The text field is usually considered errored when it is required
	     * and there is no value or the current length of the text field's value is greater
	     * than the `maxLength` prop.
	     *
	     * If this prop is set, it will check both the error prop and the error state to
	     * determine if one is true.
	     */
	    error: _react.PropTypes.bool,
	
	    /**
	     * An optional boolean if the `floating` state of the text field's floating label can be
	     * externally modified as well. The floating state is true when the tet field gains focus
	     * or there is a value in the text field.
	     *
	     * If this prop is set, it will check both the floating prop and the floating state to
	     * determine if one is true.
	     */
	    floating: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the text field is required. If the user blurs the text field while there is
	     * no value and it is required, the `error` state will be set to true.
	     */
	    required: _react.PropTypes.bool,
	
	    /**
	     * The direction that the underline should appear from.
	     */
	    lineDirection: _react.PropTypes.oneOf(['left', 'center', 'right']).isRequired,
	
	    /**
	     * An optional icon to place to the left of the text field.
	     */
	    leftIcon: _react.PropTypes.element,
	
	    /**
	     * Boolean if the left icon should be stateful. This means that the icon will
	     * gain the active or error colors with the text field.
	     */
	    leftIconStateful: _react.PropTypes.bool,
	
	    /**
	     * An optional icon to place to the right of the text field.
	     */
	    rightIcon: _react.PropTypes.element,
	
	    /**
	     * Boolean if the right icon should be stateful. This means that the icon will
	     * gain the active or error colors with the text field.
	     */
	    rightIconStateful: _react.PropTypes.bool,
	
	    /**
	     * Any children used to display the password icon.
	     */
	    passwordIconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className for the password icon.
	     */
	    passwordIconClassName: _react.PropTypes.string,
	
	    /**
	     * Boolean if the password is initially visible.
	     */
	    passwordInitiallyVisible: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the text field should be displayed as full width.
	     */
	    fullWidth: _react.PropTypes.bool,
	
	    /**
	     * The number of rows for the `multiline` text field. This value must be greater than
	     * or equal to 2. When this value is set, the text field will be converted to a multiline
	     * field.
	     */
	    rows: (0, _minNumber2.default)(2, false),
	
	    /**
	     * The maximum number of rows for a `multiline` text field. If this value is
	     * `undefined`, `0`, or a number less than `0`, the multiline text field will
	     * infinitely expand.
	     */
	    maxRows: _react.PropTypes.number,
	
	    /**
	     * An optional customsize to apply to the text field. This is used along with
	     * the `$md-text-field-custom-sizes` variable. It basically applies a className of
	     * `md-text-field--NAME`.
	     */
	    customSize: _react.PropTypes.string,
	
	    /**
	     * An optional error text to display below the text field. This will only appear when
	     * the text field has the `error` state through the `error` prop, the current length
	     * of the text field's value is greater than the `maxLength` prop, or the field is
	     * required and the user blurs the text field with no value.
	     */
	    errorText: (0, _invalidIf2.default)(_react.PropTypes.string, 'block'),
	
	    /**
	     * An optional help text to display below the text field. This will always be visible
	     * unless the `helpOnFocus` prop is set to true. Otherwise it will appear on focus.
	     */
	    helpText: (0, _invalidIf2.default)(_react.PropTypes.string, 'block'),
	
	    /**
	     * Boolean if the help text should display on focus only.
	     */
	    helpOnFocus: _react.PropTypes.bool,
	
	    /**
	     * An optional max length for the text field. This will insert a counter underneath the
	     * text field that appears on focus.
	     */
	    maxLength: _react.PropTypes.number,
	
	    /**
	     * The ink when there is an injectInk above the text field. Used from the SelectField.
	     *
	     * @access private
	     */
	    ink: _react.PropTypes.node,
	
	    /**
	     * An optional element to display inside of the `TextField` to the farthest right. This will
	     * position the indicator absolutely and add some additional padding to the `TextField`.
	     */
	    inlineIndicator: _react.PropTypes.element,
	
	    icon: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `leftIcon` or `rightIcon` prop instead'),
	    floatingLabel: (0, _deprecated2.default)(_react.PropTypes.bool, 'The `label` prop is now always floating. To create a non-floating text field, only use the `placeholder` prop'),
	    adjustMinWidth: (0, _deprecated2.default)(_react.PropTypes.bool, 'Manually add a min width style instead')
	  };
	  TextField.defaultProps = {
	    type: 'text',
	    lineDirection: 'left',
	    passwordIconChildren: 'remove_red_eye',
	    leftIconStateful: true,
	    rightIconStateful: true,
	    fullWidth: true
	  };
	  exports.default = TextField;
	});

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(28);
	
	var warning = __webpack_require__(4);
	var canDefineProperty = __webpack_require__(239);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(237);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 54 */
5,
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(56);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(157)
	  , enumBugKeys = __webpack_require__(87);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 58 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var stripPrefix = exports.stripPrefix = function stripPrefix(path, prefix) {
	  return path.indexOf(prefix) === 0 ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  pathname = decodeURI(pathname);
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = encodeURI(pathname || '/');
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventPluginRegistry = __webpack_require__(107);
	var EventPluginUtils = __webpack_require__(108);
	var ReactErrorUtils = __webpack_require__(112);
	
	var accumulateInto = __webpack_require__(180);
	var forEachAccumulated = __webpack_require__(181);
	var invariant = __webpack_require__(3);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(59);
	var EventPluginUtils = __webpack_require__(108);
	
	var accumulateInto = __webpack_require__(180);
	var forEachAccumulated = __webpack_require__(181);
	var warning = __webpack_require__(4);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	var getEventTarget = __webpack_require__(117);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Buttons/Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.Button);
	    global.DialogFooter = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var FOOTER_PADDING = 8;
	
	  var DialogFooter = function (_PureComponent) {
	    _inherits(DialogFooter, _PureComponent);
	
	    function DialogFooter(props) {
	      _classCallCheck(this, DialogFooter);
	
	      var _this = _possibleConstructorReturn(this, (DialogFooter.__proto__ || Object.getPrototypeOf(DialogFooter)).call(this, props));
	
	      _this.state = { stacked: false };
	
	      _this._toElement = _this._toElement.bind(_this);
	      _this._generateActions = _this._generateActions.bind(_this);
	      _this._setContainer = _this._setContainer.bind(_this);
	      return _this;
	    }
	
	    _createClass(DialogFooter, [{
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        var _this2 = this;
	
	        if (container !== null) {
	          (function () {
	            _this2._container = container;
	            var maxWidth = (_this2._container.offsetWidth - FOOTER_PADDING * 3) / 2;
	
	            var stacked = false;
	            Array.prototype.slice.call(_this2._container.querySelectorAll('.md-btn')).some(function (_ref) {
	              var offsetWidth = _ref.offsetWidth;
	
	              stacked = offsetWidth > maxWidth;
	              return stacked;
	            });
	
	            _this2.setState({ stacked: stacked });
	          })();
	        }
	      }
	    }, {
	      key: '_toElement',
	      value: function _toElement(action, index) {
	        if ((0, _react.isValidElement)(action)) {
	          var button = _react.Children.only(action);
	
	          return (0, _react.cloneElement)(action, {
	            key: button.props.key || index,
	            className: (0, _classnames2.default)('md-btn--dialog', button.props.className),
	            waitForInkTransition: true
	          });
	        }
	
	        return _react2.default.createElement(_Button2.default, _extends({
	          key: index,
	          flat: true
	        }, action, {
	          className: (0, _classnames2.default)('md-btn--dialog', action.className),
	          waitForInkTransition: true
	        }));
	      }
	    }, {
	      key: '_generateActions',
	      value: function _generateActions() {
	        var actions = this.props.actions;
	
	        if (Array.isArray(actions)) {
	          return actions.map(this._toElement);
	        }
	
	        return this._toElement(actions);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var stacked = this.state.stacked;
	        var className = this.props.className;
	
	        var _props = this.props,
	            children = _props.children,
	            actions = _props.actions,
	            props = _objectWithoutProperties(_props, ['children', 'actions']);
	
	        delete props.className;
	        delete props.onActionMount;
	
	        if (!actions || Array.isArray(actions) && !actions.length) {
	          return null;
	        }
	
	        className = (0, _classnames2.default)('md-dialog-footer', {
	          'md-dialog-footer--inline': !stacked,
	          'md-dialog-footer--stacked': stacked
	        }, className);
	
	        return _react2.default.createElement(
	          'footer',
	          _extends({}, props, { className: className, ref: this._setContainer }),
	          this._generateActions(),
	          children
	        );
	      }
	    }]);
	
	    return DialogFooter;
	  }(_react.PureComponent);
	
	  DialogFooter.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    children: _react.PropTypes.node,
	    actions: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.object, _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.object]))])
	  };
	  exports.default = DialogFooter;
	});

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom);
	    global.Portal = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Portal = function (_PureComponent) {
	    _inherits(Portal, _PureComponent);
	
	    function Portal(props) {
	      _classCallCheck(this, Portal);
	
	      var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));
	
	      _this._portal = null;
	      _this._container = null;
	
	      _this._applyStyles = _this._applyStyles.bind(_this);
	      _this._renderPortal = _this._renderPortal.bind(_this);
	      _this._removePortal = _this._removePortal.bind(_this);
	      return _this;
	    }
	
	    _createClass(Portal, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.visible) {
	          this._renderPortal(this.props);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var visible = nextProps.visible,
	            onOpen = nextProps.onOpen;
	
	        if (this.props.visible === visible && this._container) {
	          // Need to just re-render the subtree
	          this._renderPortal(nextProps);
	          return;
	        }
	
	        if (visible) {
	          if (onOpen) {
	            onOpen();
	          }
	          this._renderPortal(nextProps);
	        } else {
	          this._removePortal();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._removePortal();
	      }
	    }, {
	      key: '_applyStyles',
	      value: function _applyStyles(props) {
	        if (props.className) {
	          this._container.className = props.className;
	        }
	      }
	    }, {
	      key: '_renderPortal',
	      value: function _renderPortal(props) {
	        if (!this._container) {
	          this._container = document.createElement(props.component);
	
	          this._applyStyles(props);
	          var node = props.renderNode || document.body;
	          if (props.lastChild) {
	            node.appendChild(this._container);
	          } else {
	            node.insertBefore(this._container, node.firstChild);
	          }
	        } else {
	          this._applyStyles(props);
	        }
	
	        this._portal = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, props.children, this._container);
	      }
	    }, {
	      key: '_removePortal',
	      value: function _removePortal() {
	        if (this.props.onClose) {
	          this.props.onClose();
	        }
	
	        if (this._container) {
	          (0, _reactDom.unmountComponentAtNode)(this._container);
	          (this.props.renderNode || document.body).removeChild(this._container);
	        }
	
	        this._portal = null;
	        this._container = null;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        // When doing server side rendering, actualy render the component as a direct child of its parent.
	        // Once it has been rendered and working client side, it will be removed correctly.
	        if (typeof window === 'undefined' && this.props.visible) {
	          var _props = this.props,
	              Component = _props.component,
	              className = _props.className,
	              children = _props.children;
	
	          return _react2.default.createElement(
	            Component,
	            { className: className },
	            children
	          );
	        }
	
	        return null;
	      }
	    }]);
	
	    return Portal;
	  }(_react.PureComponent);
	
	  Portal.propTypes = {
	    /**
	     * An optional className to apply to the newly created `component` when visible.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Boolean if the children are visible.
	     */
	    visible: _react.PropTypes.bool.isRequired,
	
	    /**
	     * The children to render when visible.
	     */
	    children: _react.PropTypes.element,
	
	    /**
	     * The component to render as. This should be a valid DOM element.
	     */
	    component: _react.PropTypes.string.isRequired,
	
	    /**
	     * An optional function to call when the portal is opened.
	     */
	    onOpen: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the portal is closed
	     */
	    onClose: _react.PropTypes.func,
	
	    /**
	     * An optional DOM Node to render the portal into. The default is to render as
	     * the first child in the `body`.
	     */
	    renderNode: _react.PropTypes.object,
	
	    /**
	     * Boolean if the portal should render the childeren as the last child of the `renderNode`
	     * or `body` instead of the first.
	     */
	    lastChild: _react.PropTypes.bool
	  };
	  Portal.defaultProps = {
	    component: 'span'
	  };
	  exports.default = Portal;
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(8), __webpack_require__(12), __webpack_require__(14), __webpack_require__(11), __webpack_require__(22), __webpack_require__(38), __webpack_require__(126), __webpack_require__(129), __webpack_require__(200), __webpack_require__(50)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../constants/keyCodes'), require('../Helpers/AccessibleFakeInkedButton'), require('../Helpers/Collapse'), require('../FontIcons/Collapser'), require('./TileAddon'), require('./ListItemText'), require('./List'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.deprecated, global.getField, global.controlled, global.keyCodes, global.AccessibleFakeInkedButton, global.Collapse, global.Collapser, global.TileAddon, global.ListItemText, global.List);
	    global.ListItem = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _deprecated, _getField, _controlled, _keyCodes, _AccessibleFakeInkedButton, _Collapse, _Collapser, _TileAddon, _ListItemText, _List) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	  var _Collapse2 = _interopRequireDefault(_Collapse);
	
	  var _Collapser2 = _interopRequireDefault(_Collapser);
	
	  var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	  var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	  var _List2 = _interopRequireDefault(_List);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var ListItem = function (_PureComponent) {
	    _inherits(ListItem, _PureComponent);
	
	    function ListItem(props) {
	      _classCallCheck(this, ListItem);
	
	      var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));
	
	      _this.state = { active: false };
	
	      if (typeof props.isOpen === 'undefined') {
	        _this.state.isOpen = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultOpen;
	      }
	
	      _this.focus = _this.focus.bind(_this);
	      _this._setTile = _this._setTile.bind(_this);
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
	      _this._handleClick = _this._handleClick.bind(_this);
	      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
	      return _this;
	    }
	
	    _createClass(ListItem, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.state.active) {
	          window.removeEventListener('click', this._handleOutsideClick);
	        }
	
	        if (this._touchTimeout) {
	          clearTimeout(this._touchTimeout);
	        }
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        if (this._tile) {
	          this._tile.focus();
	        }
	      }
	    }, {
	      key: 'blur',
	      value: function blur() {
	        if (this._tile) {
	          this._tile.blur();
	        }
	      }
	    }, {
	      key: '_setTile',
	      value: function _setTile(tile) {
	        if (tile) {
	          this._tile = tile;
	        }
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        if (container) {
	          this._container = (0, _reactDom.findDOMNode)(container);
	        }
	      }
	    }, {
	      key: '_handleOutsideClick',
	      value: function _handleOutsideClick(e) {
	        if (this._container && !this._container.contains(e.target)) {
	          window.removeEventListener('click', this._handleOutsideClick);
	          this.setState({ active: false });
	        }
	      }
	    }, {
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        if (this.props.onClick) {
	          this.props.onClick(e);
	        }
	
	        if (typeof this.state.isOpen !== 'undefined') {
	          this.setState({ isOpen: !this.state.isOpen });
	        }
	      }
	    }, {
	      key: '_handleMouseOver',
	      value: function _handleMouseOver(e) {
	        if (this.props.onMouseOver) {
	          this.props.onMouseOver(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ active: true });
	        }
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave(e) {
	        if (this.props.onMouseLeave) {
	          this.props.onMouseLeave(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ active: false });
	        }
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        if (this.props.onTouchStart) {
	          this.props.onTouchStart(e);
	        }
	
	        this._touched = true;
	
	        this.setState({ active: true, touchedAt: Date.now() });
	      }
	    }, {
	      key: '_handleTouchEnd',
	      value: function _handleTouchEnd(e) {
	        var _this2 = this;
	
	        if (this.props.onTouchEnd) {
	          this.props.onTouchEnd(e);
	        }
	
	        var time = Date.now() - this.state.touchedAt;
	        this._touchTimeout = setTimeout(function () {
	          _this2._touchTimeout = null;
	
	          _this2.setState({ active: false });
	        }, time > 450 ? 0 : 450 - time);
	      }
	    }, {
	      key: '_handleKeyUp',
	      value: function _handleKeyUp(e) {
	        if (this.props.onKeyUp) {
	          this.props.onKeyUp(e);
	        }
	
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          window.addEventListener('click', this._handleOutsideClick);
	          this.setState({ active: true });
	        }
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        if (this.props.onKeyDown) {
	          this.props.onKeyDown(e);
	        }
	
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          window.removeEventListener('click', this._handleOutsideClick);
	          this.setState({ active: false });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            tileStyle = _props.tileStyle,
	            tileClassName = _props.tileClassName,
	            disabled = _props.disabled,
	            leftIcon = _props.leftIcon,
	            leftAvatar = _props.leftAvatar,
	            inset = _props.inset,
	            rightIcon = _props.rightIcon,
	            rightAvatar = _props.rightAvatar,
	            primaryText = _props.primaryText,
	            secondaryText = _props.secondaryText,
	            threeLines = _props.threeLines,
	            children = _props.children,
	            nestedItems = _props.nestedItems,
	            active = _props.active,
	            activeClassName = _props.activeClassName,
	            expanderIconChildren = _props.expanderIconChildren,
	            expanderIconClassName = _props.expanderIconClassName,
	            props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'disabled', 'leftIcon', 'leftAvatar', 'inset', 'rightIcon', 'rightAvatar', 'primaryText', 'secondaryText', 'threeLines', 'children', 'nestedItems', 'active', 'activeClassName', 'expanderIconChildren', 'expanderIconClassName']);
	
	        delete props.isOpen;
	        delete props.defaultOpen;
	        delete props.initiallyOpen;
	
	        var isOpen = (0, _getField2.default)(this.props, this.state, 'isOpen');
	        var leftNode = _react2.default.createElement(_TileAddon2.default, {
	          key: 'left-addon',
	          active: active,
	          activeClassName: activeClassName,
	          icon: leftIcon,
	          avatar: leftAvatar
	        });
	
	        var rightNode = _react2.default.createElement(_TileAddon2.default, {
	          key: 'right-addon',
	          active: active,
	          activeClassName: activeClassName,
	          icon: rightIcon,
	          avatar: rightAvatar
	        });
	
	        var nestedList = void 0;
	        if (nestedItems) {
	          nestedList = _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: !isOpen },
	            _react2.default.createElement(
	              _List2.default,
	              null,
	              nestedItems
	            )
	          );
	
	          if (!rightIcon || !rightAvatar) {
	            rightNode = _react2.default.createElement(_TileAddon2.default, {
	              key: 'expander-addon',
	              icon: _react2.default.createElement(
	                _Collapser2.default,
	                { flipped: isOpen, iconClassName: expanderIconClassName },
	                expanderIconChildren
	              ),
	              avatar: null
	            });
	          }
	        }
	        var icond = !!leftIcon || !!rightIcon;
	        var avatard = !!leftAvatar || !!rightAvatar;
	
	        return _react2.default.createElement(
	          'li',
	          {
	            style: style,
	            className: (0, _classnames2.default)('md-list-item', {
	              'md-list-item--nested-container': nestedItems
	            }, className),
	            ref: this._setContainer
	          },
	          _react2.default.createElement(
	            _AccessibleFakeInkedButton2.default,
	            _extends({}, props, {
	              __SUPER_SECRET_REF__: this._setTile,
	              key: 'tile',
	              onClick: this._handleClick,
	              onMouseOver: this._handleMouseOver,
	              onMouseLeave: this._handleMouseLeave,
	              onTouchStart: this._handleTouchStart,
	              onTouchEnd: this._handleTouchEnd,
	              onKeyDown: this._handleKeyDown,
	              onKeyUp: this._handleKeyUp,
	              disabled: disabled,
	              style: tileStyle,
	              className: (0, _classnames2.default)('md-list-tile', {
	                'md-text': !disabled,
	                'md-text--disabled': disabled,
	                'md-list-tile--active': this.state.active && !this._touched,
	                'md-list-tile--icon': !secondaryText && icond && !avatard,
	                'md-list-tile--avatar': !secondaryText && avatard,
	                'md-list-tile--two-lines': secondaryText && !threeLines,
	                'md-list-tile--three-lines': secondaryText && threeLines,
	                'md-list-item--inset': inset && !leftIcon && !leftAvatar
	              }, tileClassName),
	              'aria-expanded': nestedList ? isOpen : null
	            }),
	            leftNode,
	            _react2.default.createElement(_ListItemText2.default, {
	              active: active,
	              activeClassName: activeClassName,
	              disabled: disabled,
	              primaryText: primaryText,
	              secondaryText: secondaryText,
	              threeLines: threeLines,
	              className: (0, _classnames2.default)({
	                'md-tile-content--left-icon': leftIcon,
	                'md-tile-content--left-avatar': leftAvatar,
	                'md-tile-content--right-padding': rightIcon || rightAvatar
	              })
	            }),
	            rightNode,
	            children
	          ),
	          nestedList
	        );
	      }
	    }]);
	
	    return ListItem;
	  }(_react.PureComponent);
	
	  ListItem.propTypes = {
	    /**
	     * An optional style to apply to the `li` tag.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `li` tag.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the `.md-list-tile`.
	     *
	     * @see component
	     */
	    tileStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `.md-list-tile`.
	     *
	     * @see component
	     */
	    tileClassName: _react.PropTypes.string,
	
	    /**
	     * Any additional children to display in the `.md-list-tile`. If you use this prop,
	     * you will most likely need to override the `height` for the `.md-list-tile--icon`,
	     * `.md-list-tile--avatar`, `.md-list-tile--two-lines`, and/or `.md-list-tile--three-lines`
	     * to get it to display correctly unless the children are positioned `absolute`.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the `ListItem` is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional tab index for the `.md-list-tile`. If omitted, it will default to the
	     * `AccessibleFakeButton`'s `tabIndex` default prop value.
	     */
	    tabIndex: _react.PropTypes.number,
	
	    /**
	     * The primary text to display. This will only be rendered as a single line. Any overflown
	     * text will be converted to ellipsis.
	     */
	    primaryText: _react.PropTypes.node.isRequired,
	
	    /**
	     * An optional secondary text to display below the `primaryText`. This can be an additional
	     * one or two lines. Like the `primaryText`, and overflown text will be converted to ellipsis.
	     *
	     * You must set the `threeLines` prop to `true` if you want this to be displayed as two lines.
	     */
	    secondaryText: _react.PropTypes.node,
	
	    /**
	     * An optional `FontIcon` to display to the left of the text.
	     */
	    leftIcon: _react.PropTypes.node,
	
	    /**
	     * Boolean if the list item should be inset as if there is a `leftIcon` or a `leftAvatar`.
	     * This is used for some lists where only a parent contains the icon.
	     */
	    inset: _react.PropTypes.bool,
	
	    /**
	     * An optional `Avatar` to display to the left of the text. If you have a mixed `List` of
	     * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	     * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	     */
	    leftAvatar: _react.PropTypes.node,
	
	    /**
	     * An optional `FontIcon` to display to the right of the text.
	     */
	    rightIcon: _react.PropTypes.node,
	
	    /**
	     * An optional `Avatar` to display to the right of the text. If you have a mixed `List` of
	     * `FontIcon` and `Avatar`, it is recommended to set the `iconSized` prop on the `Avatar` to
	     * `true` so that the `Avatar` will be scaled down to the `FontIcon` size.
	     */
	    rightAvatar: _react.PropTypes.node,
	
	    /**
	     * Boolean if the `secondaryText` should span two lines instead of one. This will include
	     * three lines of text in total when including the `primaryText`.
	     */
	    threeLines: _react.PropTypes.bool,
	
	    /**
	     * An optional component to render the `.md-list-tile` as. This is mostly useful if you
	     * want to use the `ListItem` for navigation and working with the `react-router`'s `Link`
	     * component.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired,
	
	    /**
	     * An optional list of `ListItem`, `ListItemControl`, `Divider`, or `Subheader` components
	     * to render in a nested list. This will inject an expander icon to the right of the text
	     * in the `.md-list-tile` that rotates 180 degrees when open.
	     *
	     * The nested items will be visible once the user clicks on the `ListItem`.
	     *
	     * @see `defaultOpen`
	     * @see `isOpen`
	     */
	    nestedItems: _react.PropTypes.arrayOf(_react.PropTypes.node),
	
	    /**
	     * Boolean if the `nestedItems` are visible by default.
	     */
	    defaultOpen: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `nestedItems` are visible. This will make the `nestedItems` controlled
	     * and require the `onClick` function to be defined.
	     */
	    isOpen: (0, _controlled2.default)(_react.PropTypes.bool, 'onClick', 'defaultOpen'),
	
	    /**
	     * Any children used to render the expander icon.
	     */
	    expanderIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className to use to render the expander icon.
	     */
	    expanderIconClassName: _react.PropTypes.string,
	
	    /**
	     * An optional function to call when the `.md-list-tile` is clicked. This is required if the
	     * `isOpen` prop is defined.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `.md-list-tile` triggers the `mouseover` event.
	     */
	    onMouseOver: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `.md-list-tile` triggers the `mouseleave` event.
	     */
	    onMouseLeave: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `.md-list-tile` triggers the `touchstart` event.
	     */
	    onTouchStart: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `.md-list-tile` triggers the `touchend` event.
	     */
	    onTouchEnd: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `.md-list-tile` triggers the `keydown` event.
	     */
	    onKeyDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `.md-list-tile` triggers the `keyup` event.
	     */
	    onKeyUp: _react.PropTypes.func,
	
	    /**
	     * Boolean if the `ListItem` is currently active. This will apply the `activeClassName` prop
	     * to the `leftIcon`, `rightIcon`, and the `primaryText`.
	     */
	    active: _react.PropTypes.bool,
	
	    /**
	     * The className to apply to the `leftIcon`, `rightIcon`, and `primaryText` when the `active`
	     * prop is `true`.
	     */
	    activeClassName: _react.PropTypes.string,
	    initiallyOpen: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `defaultOpen` instead')
	  };
	  ListItem.defaultProps = {
	    activeClassName: 'md-text--theme-primary',
	    component: 'div',
	    expanderIconChildren: 'keyboard_arrow_down'
	  };
	  exports.default = ListItem;
	});

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(36), __webpack_require__(2), __webpack_require__(8), __webpack_require__(204), __webpack_require__(83), __webpack_require__(50)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('react-addons-css-transition-group'), require('classnames'), require('react-prop-types/lib/deprecated'), require('./contextTypes'), require('./Positions'), require('../Lists/List'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.reactAddonsCssTransitionGroup, global.classnames, global.deprecated, global.contextTypes, global.Positions, global.List);
	    global.Menu = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _reactAddonsCssTransitionGroup, _classnames, _deprecated, _contextTypes, _Positions, _List) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  var _Positions2 = _interopRequireDefault(_Positions);
	
	  var _List2 = _interopRequireDefault(_List);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Menu = function (_PureComponent) {
	    _inherits(Menu, _PureComponent);
	
	    function Menu(props) {
	      _classCallCheck(this, Menu);
	
	      var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));
	
	      _this._setList = _this._setList.bind(_this);
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._handleListClick = _this._handleListClick.bind(_this);
	      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(Menu, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        var _props = this.props,
	            menuCascading = _props.cascading,
	            menuPosition = _props.position;
	
	        return {
	          menuCascading: menuCascading,
	          menuPosition: menuPosition,
	          listLevel: 0
	        };
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var isOpen = this.props.isOpen;
	
	        if (isOpen) {
	          window.addEventListener('click', this._handleOutsideClick);
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        var isOpen = this.props.isOpen;
	
	        if (isOpen === prevProps.isOpen) {
	          return;
	        }
	
	        window[(isOpen ? 'add' : 'remove') + 'EventListener']('click', this._handleOutsideClick);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var isOpen = this.props.isOpen;
	
	        if (isOpen) {
	          window.removeEventListener('click', this._handleOutsideClick);
	        }
	
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	      }
	    }, {
	      key: '_setList',
	      value: function _setList(list) {
	        if (list !== null) {
	          this._list = (0, _reactDom.findDOMNode)(list);
	        }
	
	        try {
	          var children = _react.Children.only(this.props.children);
	          if (typeof children.ref === 'function') {
	            children.ref(list);
	          }
	        } catch (e) {
	          // do nothing
	        }
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        if (container !== null) {
	          this._container = (0, _reactDom.findDOMNode)(container);
	        }
	      }
	    }, {
	      key: '_handleOutsideClick',
	      value: function _handleOutsideClick(e) {
	        var isInContextMenu = this.props.position === _Positions2.default.CONTEXT && !this._list.contains(e.target);
	
	        if (isInContextMenu || !this._container.contains(e.target)) {
	          var _props2 = this.props,
	              onClose = _props2.onClose,
	              close = _props2.close;
	
	          if (close) {
	            close(e);
	          } else if (onClose) {
	            onClose(e);
	          }
	        }
	      }
	    }, {
	      key: '_handleListClick',
	      value: function _handleListClick(e) {
	        var _this2 = this;
	
	        var _props3 = this.props,
	            onClose = _props3.onClose,
	            close = _props3.close;
	
	
	        var node = e.target;
	        while (this._container.contains(node)) {
	          if (!node.classList.contains('md-list-item--nested-container') && node.classList.contains('md-list-item')) {
	            this._timeout = setTimeout(function () {
	              _this2._timeout = null;
	
	              if (close) {
	                close(e);
	              } else if (onClose) {
	                onClose(e);
	              }
	            }, 300);
	
	            return;
	          }
	          node = node.parentNode;
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props4 = this.props,
	            id = _props4.id,
	            className = _props4.className,
	            listStyle = _props4.listStyle,
	            listClassName = _props4.listClassName,
	            isOpen = _props4.isOpen,
	            fullWidth = _props4.fullWidth,
	            toggle = _props4.toggle,
	            contained = _props4.contained,
	            children = _props4.children,
	            position = _props4.position,
	            props = _objectWithoutProperties(_props4, ['id', 'className', 'listStyle', 'listClassName', 'isOpen', 'fullWidth', 'toggle', 'contained', 'children', 'position']);
	
	        delete props.close;
	        delete props.onClose;
	        delete props.cascading;
	        delete props.autoclose;
	        delete props.listId;
	
	        var listId = this.props.listId;
	
	        if (!listId && id) {
	          listId = id + 'List';
	        }
	
	        var menuClassName = (0, _classnames2.default)({ 'md-list--menu-contained': contained }, listClassName);
	        var menuItems = void 0;
	        try {
	          var list = _react.Children.only(children);
	
	          menuItems = (0, _react.cloneElement)(children, {
	            id: list.props.id || listId,
	            key: 'menu-list',
	            className: (0, _classnames2.default)(menuClassName, list.props.className),
	            onClick: this._handleListClick,
	            ref: this._setList
	          });
	        } catch (e) {
	          menuItems = _react2.default.createElement(
	            _List2.default,
	            {
	              id: listId,
	              key: 'menu-list',
	              style: listStyle,
	              className: menuClassName,
	              onClick: this._handleListClick,
	              ref: this._setList
	            },
	            children
	          );
	        }
	
	        return _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          _extends({}, props, {
	            id: id,
	            ref: this._setContainer,
	            className: (0, _classnames2.default)('md-inline-block md-menu-container', {
	              'md-full-width': fullWidth,
	              'md-menu-container--menu-below': position === _Positions2.default.BELOW
	            }, className),
	            'aria-haspopup': true,
	            'aria-expanded': isOpen,
	            'aria-owns': listId
	          }),
	          toggle,
	          isOpen ? menuItems : null
	        );
	      }
	    }]);
	
	    return Menu;
	  }(_react.PureComponent);
	
	  Menu.Positions = _Positions2.default;
	  Menu.propTypes = {
	    /**
	     * An optional id to give to the menu's container. This is used for accessibility and is
	     * generally recommended.
	     */
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional id to give to the `List` that gets generated when open. This is used for
	     * accessibility and generally recommended. If this prop is given, the `aria-owns` attribute
	     * will be added to the list.
	     */
	    listId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional style to apply to the main container for a menu.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the main container for a menu.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the menu's `List` once it has been toggled open.
	     */
	    listStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the menu's `List` once it has been toggled open.
	     */
	    listClassName: _react.PropTypes.string,
	
	    /**
	     * The component to render the container as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * This can either be a single `List` component or an array of `ListItem`, `ListItemControl`,
	     * `Divider`, or `Subheader` to display when the menu is open. If it is the `List` component,
	     * it will be cloned with some additional class names.
	     */
	    children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)]),
	
	    /**
	     * Boolean if the `Menu` is currently open.
	     */
	    isOpen: _react.PropTypes.bool.isRequired,
	
	    /**
	     * The transition name to use for the menu's enter and leave transitions
	     */
	    transitionName: _react.PropTypes.string.isRequired,
	
	    /**
	     * The timeout for the enter transition.
	     */
	    transitionEnterTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * The timeout for the leave transition.
	     */
	    transitionLeaveTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * The node to use as the toggle for the menu.
	     */
	    toggle: _react.PropTypes.node,
	
	    /**
	     * The position that the menu should appear from. If the position is set to
	     * `Menu.Positions.CONTEXT`, the `onClose` function will be called when something
	     * outside of the `List` is clicked instead of something outside of the `Menu`.
	     */
	    position: _react.PropTypes.oneOf([Menu.Positions.TOP_LEFT, Menu.Positions.TOP_RIGHT, Menu.Positions.BOTTOM_LEFT, Menu.Positions.BOTTOM_RIGHT, Menu.Positions.CONTEXT, Menu.Positions.BELOW]).isRequired,
	
	    /**
	     * A function used to close the menu. This is used when the user clicks outside
	     * of the menu or when a `ListItem` is clicked.
	     */
	    onClose: _react.PropTypes.func.isRequired,
	
	    /**
	     * Boolean if the menu is cascading. This isn't really working too well yet.
	     */
	    cascading: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the width of the `List` should be limited to the width of the `toggle`
	     */
	    contained: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the menu should be displayed full width instead of inline.
	     */
	    fullWidth: _react.PropTypes.bool,
	
	    close: (0, _deprecated2.default)(_react.PropTypes.func, 'Use `onClose` instead'),
	    autoclose: (0, _deprecated2.default)(_react.PropTypes.bool, 'The menus will always autoclose as according to the specs'),
	    limitHeight: (0, _deprecated2.default)(_react.PropTypes.bool, 'The menus will always be limited in height as according to the specs'),
	    expanderIconClassName: (0, _deprecated2.default)(_react.PropTypes.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon'),
	    expanderIconChildren: (0, _deprecated2.default)(_react.PropTypes.node, 'The expander for cascading menus will now just be a simple rotate of the existing `ListItem` ' + 'expander icon')
	  };
	  Menu.defaultProps = {
	    component: 'div',
	    transitionName: 'md-menu',
	    transitionEnterTimeout: 200,
	    transitionLeaveTimeout: 200,
	    position: Menu.Positions.TOP_RIGHT
	  };
	  Menu.childContextTypes = _contextTypes2.default;
	  exports.default = Menu;
	});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.captureNextEvent = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = captureNextEvent;
	  /**
	   * This function will capture the next event and stop propagation during the
	   * bubbling cycle of events. This is really only useful if you want to stop
	   * the default behavior of chained events.
	   *
	   * @param {String} type - The event type to capture.
	   * @param {Object|func=} target - Either the DOM node to target, a callback function
	   *      to call once the event has been captured, or undefined. If this is undefined,
	   *      the event will be captured on the window.
	   * @param {func=} callback - An optional callback function to call once the event
	   *      has been captured.
	   */
	  function captureNextEvent(type, target, callback) {
	    var el = typeof target !== 'function' && target ? target : window;
	    var cb = typeof target === 'function' ? target : callback;
	
	    var capture = function capture(e) {
	      e.stopPropagation();
	      if (cb) {
	        cb(e);
	      }
	
	      el.removeEventListener(type, capture, true);
	    };
	
	    el.addEventListener(type, capture, true);
	  }
	});

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(225)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('../NumberUtils/isBetween'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.isBetween);
	    global.between = mod.exports;
	  }
	})(this, function (exports, _isBetween) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = between;
	
	  var _isBetween2 = _interopRequireDefault(_isBetween);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  /**
	   * Validates that a number is between a min and max value.
	   *
	   * @param {function} validator - The number validator to use.
	   * @param {number} min - The min number to use.
	   * @param {number} max - The max number to use.
	   * @return {Error} the prop type error or null
	   */
	  function between(validator, min, max) {
	    return function validate(props, propName, componentName, location, propFullName) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	
	      for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	        args[_key - 5] = arguments[_key];
	      }
	
	      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	      var value = props[propName];
	      if (!err && typeof value !== 'undefined' && !(0, _isBetween2.default)(value, min, max)) {
	        err = new Error('You provided a `' + propFullNameSafe + '` ' + location + ' to the ' + componentNameSafe + ' that was ' + ('not within the range from \'' + min + ' - ' + max + '\'. `' + propFullNameSafe + '`: ' + value + '.'));
	      }
	
	      return err;
	    };
	  } /** @module PropTypes/between */
	});

/***/ },
/* 69 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 71 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 73 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(329);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventPluginRegistry = __webpack_require__(107);
	var ReactEventEmitterMixin = __webpack_require__(357);
	var ViewportMetrics = __webpack_require__(179);
	
	var getVendorPrefixedEventName = __webpack_require__(184);
	var isEventSupported = __webpack_require__(118);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	var ViewportMetrics = __webpack_require__(179);
	
	var getEventModifierState = __webpack_require__(116);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	var DOMNamespaces = __webpack_require__(106);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(114);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react);
	    global.contextTypes = mod.exports;
	  }
	})(this, function (exports, _react) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = {
	    uncheckedIconClassName: _react.PropTypes.string.isRequired,
	    uncheckedIconChildren: _react.PropTypes.node,
	    checkedIconClassName: _react.PropTypes.string.isRequired,
	    checkedIconChildren: _react.PropTypes.node,
	    plain: _react.PropTypes.bool,
	    allSelected: _react.PropTypes.bool.isRequired,
	    selectedRows: _react.PropTypes.arrayOf(_react.PropTypes.bool).isRequired,
	    createCheckbox: _react.PropTypes.func.isRequired,
	    removeCheckbox: _react.PropTypes.func.isRequired,
	    toggleAllRows: _react.PropTypes.func.isRequired,
	    toggleSelectedRow: _react.PropTypes.func.isRequired,
	    baseId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    baseName: _react.PropTypes.string
	  };
	});

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.findTable = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = findTable;
	  /**
	   * Attempts fo find the base table component from an element in the table.
	   * This will either be the wrapper for responsive data tables, or the table element.
	   *
	   * @param {Object} el - The element to traverse from
	   * @param {Object} the table or null.
	   */
	  function findTable(el) {
	    var table = void 0;
	    var node = el;
	    while (node && node.parentNode) {
	      if (node.classList && node.classList.contains('md-data-table')) {
	        // Attempt to check one more element up to see if there is a table-container
	        // for responsive tables.
	        table = node;
	      } else if (node.classList && node.classList.contains('md-data-table--responsive')) {
	        return node;
	      } else if (table) {
	        return table;
	      }
	
	      node = node.parentNode;
	    }
	
	    return null;
	  }
	});

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('../constants/keyCodes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.keyCodes);
	    global.AccessibleFakeButton = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _keyCodes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var AccessibleFakeButton = function (_PureComponent) {
	    _inherits(AccessibleFakeButton, _PureComponent);
	
	    function AccessibleFakeButton(props) {
	      _classCallCheck(this, AccessibleFakeButton);
	
	      var _this = _possibleConstructorReturn(this, (AccessibleFakeButton.__proto__ || Object.getPrototypeOf(AccessibleFakeButton)).call(this, props));
	
	      _this.state = { pressed: false, tabFocused: false };
	      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	      _this._handleBlur = _this._handleBlur.bind(_this);
	      _this._setNode = _this._setNode.bind(_this);
	      _this._handleClick = _this._handleClick.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      return _this;
	    }
	
	    /**
	     * Focuses the button.
	     */
	
	
	    _createClass(AccessibleFakeButton, [{
	      key: 'focus',
	      value: function focus() {
	        if (this._node) {
	          this._node.focus();
	        }
	      }
	    }, {
	      key: 'blur',
	      value: function blur() {
	        if (this._node) {
	          this._node.blur();
	        }
	      }
	    }, {
	      key: '_setNode',
	      value: function _setNode(node) {
	        if (node) {
	          this._node = (0, _reactDom.findDOMNode)(node);
	        }
	      }
	    }, {
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        if (this.props.disabled) {
	          return;
	        }
	
	        if (this.props.onClick) {
	          this.props.onClick(e);
	        }
	
	        this._node.focus();
	        this.setState({ pressed: !this.state.pressed });
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        if (this.props.disabled) {
	          return;
	        }
	
	        if (this.props.onKeyDown) {
	          this.props.onKeyDown(e);
	        }
	
	        if ((e.which || e.keyCode) === _keyCodes.ENTER) {
	          this._handleClick(e);
	        }
	      }
	    }, {
	      key: '_handleKeyUp',
	      value: function _handleKeyUp(e) {
	        var _props = this.props,
	            onKeyUp = _props.onKeyUp,
	            onTabFocus = _props.onTabFocus;
	
	        if (onKeyUp) {
	          onKeyUp(e);
	        }
	
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          if (onTabFocus) {
	            onTabFocus(e);
	          }
	
	          this.setState({ tabFocused: true });
	        }
	      }
	    }, {
	      key: '_handleBlur',
	      value: function _handleBlur(e) {
	        if (this.props.onBlur) {
	          this.props.onBlur(e);
	        }
	
	        if (this.state.tabFocused) {
	          this.setState({ tabFocused: false });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            Component = _props2.component,
	            children = _props2.children,
	            className = _props2.className,
	            tabbedClassName = _props2.tabbedClassName,
	            disabled = _props2.disabled,
	            tabIndex = _props2.tabIndex,
	            ink = _props2.ink,
	            props = _objectWithoutProperties(_props2, ['component', 'children', 'className', 'tabbedClassName', 'disabled', 'tabIndex', 'ink']);
	
	        delete props.onBlur;
	        delete props.onClick;
	        delete props.onKeyUp;
	        delete props.onKeyDown;
	        delete props.onTabFocus;
	
	        var childElements = children;
	        if (ink) {
	          childElements = _react.Children.toArray(children);
	          childElements.unshift(ink);
	        }
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            ref: this._setNode,
	            className: (0, _classnames2.default)('md-fake-btn', _defineProperty({
	              'md-pointer--hover': !disabled
	            }, tabbedClassName, tabbedClassName && this.state.tabFocused), className),
	            disabled: disabled,
	            tabIndex: disabled ? null : tabIndex,
	            onBlur: this._handleBlur,
	            onClick: this._handleClick,
	            onKeyUp: this._handleKeyUp,
	            onKeyDown: this._handleKeyDown,
	            'aria-pressed': this.state.pressed
	          }),
	          childElements
	        );
	      }
	    }]);
	
	    return AccessibleFakeButton;
	  }(_react.PureComponent);
	
	  AccessibleFakeButton.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional function to call only when the button has been focused with the tab key.
	     */
	    tabbedClassName: _react.PropTypes.string,
	
	    /**
	     * Any children to display in the Accessible Fake Button.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * An optional onClick function to call whent he user clicks the
	     * button or presses space || enter.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * An optional onKeyDown function to call.
	     */
	    onKeyDown: _react.PropTypes.func,
	
	    /**
	     * An optional onBlur function to call.
	     */
	    onBlur: _react.PropTypes.func,
	
	    /**
	     * An optional onKeyUp function to call.
	     */
	    onKeyUp: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the element is focused with the tab key.
	     */
	    onTabFocus: _react.PropTypes.func,
	
	    /**
	     * The component to render the Fake button as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * The tab index to use for the Fake button so it is keyboard focusable.
	     */
	    tabIndex: _react.PropTypes.number,
	
	    /**
	     * Boolean if the Button is disabled. This will prevent tab focus.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * The role for the accessible fake button. It is recommended to keep it
	     * the default of `button` unless you are rendering it as an `a` tag.
	     */
	    role: _react.PropTypes.string,
	
	    /**
	     * The ink when coming from the AccessibleFakeInkedButton
	     * @access private
	     */
	    ink: _react.PropTypes.node
	  };
	  AccessibleFakeButton.defaultProps = {
	    component: 'div',
	    tabIndex: 0,
	    role: 'button'
	  };
	  exports.default = AccessibleFakeButton;
	});

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.Positions = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = {
	    TOP_RIGHT: 'tr',
	    TOP_LEFT: 'tl',
	    BOTTOM_RIGHT: 'br',
	    BOTTOM_LEFT: 'bl',
	    CONTEXT: 'context',
	    BELOW: 'below'
	  };
	});

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(228), __webpack_require__(504)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../utils/StringUtils/getDisplayName'), require('./TooltipContainer'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.getDisplayName, global.TooltipContainer);
	    global.injectTooltip = mod.exports;
	  }
	})(this, function (exports, _react, _getDisplayName, _TooltipContainer) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	  var _TooltipContainer2 = _interopRequireDefault(_TooltipContainer);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  exports.default = function (ComposedComponent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_PureComponent) {
	      _inherits(TooltipedComponent, _PureComponent);
	
	      function TooltipedComponent(props) {
	        _classCallCheck(this, TooltipedComponent);
	
	        var _this = _possibleConstructorReturn(this, (TooltipedComponent.__proto__ || Object.getPrototypeOf(TooltipedComponent)).call(this, props));
	
	        _this._composed = null;
	
	        _this.getComposedComponent = _this.getComposedComponent.bind(_this);
	        _this._setComposedComponent = _this._setComposedComponent.bind(_this);
	        return _this;
	      }
	
	      /**
	       * Gets the composed component as a ref. This is usefull if you need to access the ref of the
	       * composed component instead of the `injectTooltip` HOC to use some publically accessible methods.
	       *
	       * ```js
	       * <SomeInkedComponent
	       *   ref={tooltipHOC => {
	       *     tooltipHOC.getComposedComponent().focus();
	       *   }}
	       * />
	       * ```
	       *
	       * > NOTE: This can be `null`, so make sure to do a null check before using..
	       */
	
	
	      _createClass(TooltipedComponent, [{
	        key: 'getComposedComponent',
	        value: function getComposedComponent() {
	          return this._composed;
	        }
	      }, {
	        key: '_setComposedComponent',
	        value: function _setComposedComponent(component) {
	          this._composed = component;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              tooltipLabel = _props.tooltipLabel,
	              tooltipDelay = _props.tooltipDelay,
	              tooltipPosition = _props.tooltipPosition,
	              tooltipStyle = _props.tooltipStyle,
	              tooltipClassName = _props.tooltipClassName,
	              tooltipContainerStyle = _props.tooltipContainerStyle,
	              tooltipContainerClassName = _props.tooltipContainerClassName,
	              tooltipTransitionEnterTimeout = _props.tooltipTransitionEnterTimeout,
	              tooltipTransitionLeaveTimeout = _props.tooltipTransitionLeaveTimeout,
	              props = _objectWithoutProperties(_props, ['tooltipLabel', 'tooltipDelay', 'tooltipPosition', 'tooltipStyle', 'tooltipClassName', 'tooltipContainerStyle', 'tooltipContainerClassName', 'tooltipTransitionEnterTimeout', 'tooltipTransitionLeaveTimeout']);
	
	          if (tooltipLabel) {
	            props.tooltip = _react2.default.createElement(_TooltipContainer2.default, {
	              key: 'tooltipContainer',
	              label: tooltipLabel,
	              delay: tooltipDelay,
	              position: tooltipPosition,
	              enterTimeout: tooltipTransitionEnterTimeout,
	              leaveTimeout: tooltipTransitionLeaveTimeout,
	              style: tooltipContainerStyle,
	              className: tooltipContainerClassName,
	              tooltipStyle: tooltipStyle,
	              tooltipClassName: tooltipClassName
	            });
	          }
	
	          props.ref = this._setComposedComponent;
	
	          return _react2.default.createElement(ComposedComponent, props);
	        }
	      }]);
	
	      return TooltipedComponent;
	    }(_react.PureComponent), _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'Tooltiped'), _class.propTypes = {
	      /**
	       * An optional style to apply to the tooltip container.
	       */
	      tooltipContainerStyle: _react.PropTypes.object,
	
	      /**
	       * An optional className to apply to the tooltip container.
	       */
	      tooltipContainerClassName: _react.PropTypes.string,
	
	      /**
	       * An optional style to apply to the tooltip itself.
	       */
	      tooltipStyle: _react.PropTypes.object,
	
	      /**
	       * An optional className to the tooltip itself.
	       */
	      tooltipClassName: _react.PropTypes.string,
	
	      /**
	       * The tooltip to display. If omitted, the `tooltip` prop will not be injected.
	       */
	      tooltipLabel: _react.PropTypes.node,
	
	      /**
	       * The amount of delay before the tooltip will appear on hover, touch, or keyboard focus.
	       */
	      tooltipDelay: _react.PropTypes.number.isRequired,
	
	      /**
	       * The position that the tooltip should appear related to the composed compoennt.
	       */
	      tooltipPosition: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']).isRequired,
	
	      /**
	       * The transition time for the tooltip appearing.
	       */
	      tooltipTransitionEnterTimeout: _react.PropTypes.number.isRequired,
	
	      /**
	       * The transition time for the tooltip disappearing.
	       */
	      tooltipTransitionLeaveTimeout: _react.PropTypes.number.isRequired
	    }, _class.defaultProps = {
	      tooltipDelay: 0,
	      tooltipPosition: 'bottom',
	      tooltipTransitionEnterTimeout: 150,
	      tooltipTransitionLeaveTimeout: 150
	    }, _temp;
	  };
	});

/***/ },
/* 85 */
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 86 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 87 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 88 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 89 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(55)
	  , dPs         = __webpack_require__(282)
	  , enumBugKeys = __webpack_require__(87)
	  , IE_PROTO    = __webpack_require__(93)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(150)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(275).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 91 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(34).f
	  , has = __webpack_require__(33)
	  , TAG = __webpack_require__(43)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(94)('keys')
	  , uid    = __webpack_require__(71);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(29)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 95 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(86);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(56);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(29)
	  , core           = __webpack_require__(24)
	  , LIBRARY        = __webpack_require__(89)
	  , wksExt         = __webpack_require__(99)
	  , defineProperty = __webpack_require__(34).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(43);

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(301);
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 101 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(568);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(569);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(72)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(46);
	var Danger = __webpack_require__(335);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInstrumentation = __webpack_require__(20);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(114);
	var setInnerHTML = __webpack_require__(79);
	var setTextContent = __webpack_require__(187);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: { toIndex: update.toIndex, content: update.content.toString() }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactErrorUtils = __webpack_require__(112);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 109 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactPropTypesSecret = __webpack_require__(363);
	var propTypesFactory = __webpack_require__(392);
	
	var React = __webpack_require__(27);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = func.bind(null, a);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(28);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(21);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 114 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var emptyFunction = __webpack_require__(17);
	var warning = __webpack_require__(4);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(84), __webpack_require__(126), __webpack_require__(49)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Tooltips/injectTooltip'), require('../FontIcons/Collapser'), require('../Helpers/IconSeparator'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.injectTooltip, global.Collapser, global.IconSeparator);
	    global.TableColumn = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _injectTooltip, _Collapser, _IconSeparator) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	  var _Collapser2 = _interopRequireDefault(_Collapser);
	
	  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TableColumn = function (_PureComponent) {
	    _inherits(TableColumn, _PureComponent);
	
	    function TableColumn() {
	      _classCallCheck(this, TableColumn);
	
	      return _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).apply(this, arguments));
	    }
	
	    _createClass(TableColumn, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            numeric = _props.numeric,
	            adjusted = _props.adjusted,
	            header = _props.header,
	            children = _props.children,
	            sorted = _props.sorted,
	            sortIconChildren = _props.sortIconChildren,
	            sortIconClassName = _props.sortIconClassName,
	            tooltip = _props.tooltip,
	            selectColumnHeader = _props.selectColumnHeader,
	            __fixedColumn = _props.__fixedColumn,
	            props = _objectWithoutProperties(_props, ['className', 'numeric', 'adjusted', 'header', 'children', 'sorted', 'sortIconChildren', 'sortIconClassName', 'tooltip', 'selectColumnHeader', '__fixedColumn']);
	
	        var sortable = typeof sorted === 'boolean';
	
	        var displayedChildren = children;
	        if (sortable) {
	          displayedChildren = _react2.default.createElement(
	            _IconSeparator2.default,
	            { label: children, iconBefore: true },
	            _react2.default.createElement(
	              _Collapser2.default,
	              { flipped: !sorted, iconClassName: sortIconClassName },
	              sortIconChildren
	            )
	          );
	        }
	
	        var Component = header ? 'th' : 'td';
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-table-column', {
	              'md-table-column--header': header,
	              'md-table-column--data': !header,
	              'md-table-column--adjusted': adjusted,
	              'md-table-column--sortable md-pointer--hover': sortable,
	              'md-table-column--relative': !__fixedColumn && tooltip,
	              'md-table-column--select-field': selectColumnHeader,
	              'md-text': !header,
	              'md-text--secondary': header,
	              'md-text-left': !numeric,
	              'md-text-right': numeric
	            }, className)
	          }),
	          tooltip,
	          displayedChildren
	        );
	      }
	    }]);
	
	    return TableColumn;
	  }(_react.PureComponent);
	
	  TableColumn.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * The optional className for the table column
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The children to display in the column.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the column is currently sorted. If this prop is not `undefined`,
	     * it will add the sort icon unto this column. You will also need to use the
	     * `onClick` function to toggle the `sorted` prop as well as handling the sorting
	     * of data.
	     *
	     * This value should really only be set in the `TableHeader` component.
	     */
	    sorted: _react.PropTypes.bool,
	
	    /**
	     * The optional icon children to display in the sort icon.
	     */
	    sortIconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className for the sort icon.
	     */
	    sortIconClassName: _react.PropTypes.string.isRequired,
	
	    /**
	     * A boolean if the column has numeric data. It will right-align the data.
	     */
	    numeric: _react.PropTypes.bool,
	
	    /**
	     * Boolean if this column should be adjusted with additional padding. This *should*
	     * be handled automatically by the `TableRow` component but can be set manually as well.
	     */
	    adjusted: _react.PropTypes.bool,
	
	    /**
	     * Boolean if this column is the `th` for a column of `SelectFieldColumn`. This will apply
	     * additional styling to the column to position with the select field.
	     */
	    selectColumnHeader: _react.PropTypes.bool,
	
	    /**
	     * Boolean if this is a `th` component. This value **should** be set
	     * automatically for you if it is in the `TableHeader` component.
	     */
	    header: _react.PropTypes.bool.isRequired,
	
	    /**
	     * The optional tooltip to render on hover.
	     */
	    tooltipLabel: _react.PropTypes.string,
	
	    /**
	     * An optional delay to apply to the tooltip before it appears.
	     */
	    tooltipDelay: _react.PropTypes.number,
	
	    /**
	     * The position of the tooltip.
	     */
	    tooltipPosition: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * The injected tooltip.
	     * @access private
	     */
	    tooltip: _react.PropTypes.node,
	
	    /**
	     * Boolean if the TableColumn is coming from the EditDialogColumn or SelectFieldColumn
	     * components. When this is false, it will update the column to have `position: relative`
	     * so that tooltips can be displayed.
	     */
	    __fixedColumn: _react.PropTypes.bool
	  };
	  TableColumn.defaultProps = {
	    header: false,
	    sortIconClassName: 'material-icons',
	    sortIconChildren: 'arrow_upward'
	  };
	  exports.default = (0, _injectTooltip2.default)(TableColumn);
	});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(80)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('./contextTypes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.contextTypes);
	    global.headerContextTypes = mod.exports;
	  }
	})(this, function (exports, _react, _contextTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = Object.assign({}, _contextTypes2.default, { header: _react.PropTypes.bool });
	});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(36), __webpack_require__(2), __webpack_require__(8), __webpack_require__(13), __webpack_require__(11), __webpack_require__(30), __webpack_require__(12), __webpack_require__(521), __webpack_require__(517), __webpack_require__(424), __webpack_require__(64)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('react-addons-css-transition-group'), require('classnames'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../constants/CSSTransitionGroupTick'), require('../utils/getField'), require('../utils/toggleScroll'), require('../utils/PropTypes/oneRequiredForA11y'), require('./Dialog'), require('../Helpers/Portal'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.reactAddonsCssTransitionGroup, global.classnames, global.deprecated, global.isRequiredForA11y, global.keyCodes, global.CSSTransitionGroupTick, global.getField, global.toggleScroll, global.oneRequiredForA11y, global.Dialog, global.Portal);
	    global.DialogContainer = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _reactAddonsCssTransitionGroup, _classnames, _deprecated, _isRequiredForA11y, _keyCodes, _CSSTransitionGroupTick, _getField, _toggleScroll, _oneRequiredForA11y, _Dialog, _Portal) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _toggleScroll2 = _interopRequireDefault(_toggleScroll);
	
	  var _oneRequiredForA11y2 = _interopRequireDefault(_oneRequiredForA11y);
	
	  var _Dialog2 = _interopRequireDefault(_Dialog);
	
	  var _Portal2 = _interopRequireDefault(_Portal);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var DialogContainer = function (_PureComponent) {
	    _inherits(DialogContainer, _PureComponent);
	
	    function DialogContainer(props) {
	      _classCallCheck(this, DialogContainer);
	
	      var _this = _possibleConstructorReturn(this, (DialogContainer.__proto__ || Object.getPrototypeOf(DialogContainer)).call(this, props));
	
	      var visible = typeof props.isOpen !== 'undefined' ? props.isOpen : props.visible;
	
	      _this.state = {
	        active: visible && !props.fullPage,
	        overlay: visible && !props.fullPage,
	        portalVisible: visible,
	        dialogVisible: false
	      };
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._handleClick = _this._handleClick.bind(_this);
	      _this._handleDialogMounting = _this._handleDialogMounting.bind(_this);
	      _this._mountPortal = _this._mountPortal.bind(_this);
	      _this._mountDialog = _this._mountDialog.bind(_this);
	      _this._unmountPortal = _this._unmountPortal.bind(_this);
	      _this._handleEscClose = _this._handleEscClose.bind(_this);
	      return _this;
	    }
	    /* eslint-disable max-len */
	
	
	    _createClass(DialogContainer, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!this.props.isOpen && !this.props.visible) {
	          return;
	        }
	
	        (0, _toggleScroll2.default)(true);
	        this._mountDialog(this.props);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var visible = typeof nextProps.isOpen !== 'undefined' ? nextProps.isOpen : nextProps.visible;
	        if (this.props.isOpen === visible || this.props.visible === visible) {
	          return;
	        }
	
	        var el = (0, _getField2.default)(this.props, this.context, 'renderNode') || window;
	        var pageX = el.scrollX,
	            pageY = el.scrollY;
	
	        if (typeof el.scrollTop !== 'undefined' && typeof el.scrollLeft !== 'undefined') {
	          pageX = el.scrollLeft;
	          pageY = el.scrollTop;
	        } else if (typeof el.scrollY !== 'undefined' && typeof el.scrollX !== 'undefined') {
	          pageX = el.scrollX;
	          pageY = el.scrollY;
	        }
	
	        this._pageX = pageX;
	        this._pageY = pageY;
	        (0, _toggleScroll2.default)(visible);
	
	        if (visible) {
	          this._activeElement = document.activeElement;
	          this._mountPortal(nextProps);
	        } else {
	          this.setState({ dialogVisible: false, active: false });
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            visible = _props.visible,
	            closeOnEsc = _props.closeOnEsc,
	            modal = _props.modal;
	
	        var escapable = !modal && closeOnEsc;
	        var prevEscapable = !prevProps.modal && prevProps.closeOnEsc;
	
	        // Only going to support visible here since it was not implemented before.
	        if (visible === prevProps.visible && escapable === prevEscapable) {
	          return;
	        }
	
	        var add = false;
	        var remove = false;
	
	        if (escapable !== prevEscapable) {
	          add = visible && escapable;
	          remove = !visible || prevEscapable && !escapable;
	        } else if (escapable) {
	          add = visible;
	          remove = !visible;
	        }
	
	        if (add) {
	          window.addEventListener('keydown', this._handleEscClose);
	        } else if (remove) {
	          window.removeEventListener('keydown', this._handleEscClose);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.props.isOpen || this.props.visible) {
	          (0, _toggleScroll2.default)(false);
	        }
	
	        if (this.props.visible && this.props.closeOnEsc && !this.props.modal) {
	          window.removeEventListener('keydown', this._handleEscClose);
	        }
	
	        if (this._inTimeout) {
	          clearTimeout(this._inTimeout);
	        }
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        if (container !== null) {
	          this._container = (0, _reactDom.findDOMNode)(container);
	        }
	      }
	    }, {
	      key: '_handleEscClose',
	      value: function _handleEscClose(e) {
	        if ((e.which || e.keyCode) === _keyCodes.ESC) {
	          (this.props.onHide || this.props.close)(e);
	        }
	      }
	    }, {
	      key: '_mountPortal',
	      value: function _mountPortal(props) {
	        this._mountDialog(props);
	        this.setState({ portalVisible: true });
	      }
	    }, {
	      key: '_mountDialog',
	      value: function _mountDialog(props) {
	        var _this2 = this;
	
	        var fullPage = props.fullPage,
	            onShow = props.onShow;
	
	        this._inTimeout = setTimeout(function () {
	          _this2._inTimeout = fullPage ? null : setTimeout(function () {
	            _this2._inTimeout = null;
	            _this2.setState({ active: true });
	          }, _CSSTransitionGroupTick2.default);
	          _this2.setState({ dialogVisible: true, overlay: !fullPage }, onShow);
	        }, _CSSTransitionGroupTick2.default);
	      }
	    }, {
	      key: '_unmountPortal',
	      value: function _unmountPortal() {
	        this.setState({ portalVisible: false });
	      }
	    }, {
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : this.props.visible;
	        if (this.props.modal || !visible || e.target !== this._container) {
	          return;
	        }
	
	        (this.props.onHide || this.props.close)(e);
	      }
	    }, {
	      key: '_handleDialogMounting',
	      value: function _handleDialogMounting(dialog) {
	        if (dialog === null) {
	          if (this._activeElement) {
	            this._activeElement.focus();
	          }
	
	          this._activeElement = null;
	          this.setState({ overlay: false });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            overlay = _state.overlay,
	            active = _state.active,
	            dialogVisible = _state.dialogVisible,
	            portalVisible = _state.portalVisible;
	
	        var _props2 = this.props,
	            style = _props2.style,
	            className = _props2.className,
	            dialogStyle = _props2.dialogStyle,
	            dialogClassName = _props2.dialogClassName,
	            modal = _props2.modal,
	            fullPage = _props2.fullPage,
	            component = _props2.component,
	            transitionEnterTimeout = _props2.transitionEnterTimeout,
	            transitionLeaveTimeout = _props2.transitionLeaveTimeout,
	            lastChild = _props2.lastChild,
	            props = _objectWithoutProperties(_props2, ['style', 'className', 'dialogStyle', 'dialogClassName', 'modal', 'fullPage', 'component', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'lastChild']);
	
	        delete props.renderNode;
	        delete props.close;
	        delete props.isOpen;
	        delete props.visible;
	        delete props.onShow;
	        delete props.onHide;
	        delete props.actionLeft;
	        delete props.actionRight;
	        delete props.transitionName;
	        delete props.transitionEnter;
	        delete props.transitionLeave;
	        delete props.closeOnEsc;
	
	        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	
	        var dialog = _react2.default.createElement(_Dialog2.default, _extends({
	          key: 'dialog',
	          style: dialogStyle,
	          className: dialogClassName,
	          ref: this._handleDialogMounting,
	          fullPage: fullPage
	        }, props, {
	          containerX: this._pageX,
	          containerY: this._pageY,
	          onLeave: this._unmountPortal
	        }));
	
	        return _react2.default.createElement(
	          _Portal2.default,
	          { visible: portalVisible, renderNode: renderNode, lastChild: lastChild },
	          _react2.default.createElement(
	            _reactAddonsCssTransitionGroup2.default,
	            {
	              component: component,
	              ref: this._setContainer,
	              style: style,
	              className: (0, _classnames2.default)('md-dialog-container', {
	                'md-overlay': !fullPage && overlay,
	                'md-pointer--hover': !fullPage && overlay && !modal,
	                'md-overlay--active': !fullPage && active && overlay
	              }, className),
	              transitionName: 'md-dialog--' + (fullPage ? 'full-page' : 'centered'),
	              transitionEnterTimeout: transitionEnterTimeout,
	              transitionLeaveTimeout: transitionLeaveTimeout,
	              onClick: this._handleClick
	            },
	            dialogVisible ? dialog : null
	          )
	        );
	      }
	    }]);
	
	    return DialogContainer;
	  }(_react.PureComponent);
	
	  DialogContainer.propTypes = {
	    /**
	     * An id to use for the `Dialog` once it has been opened. This is used for the
	     * [dialog role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_dialog_role).
	     * This is used to generate an `id` for the `title` prop when it has been defined.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	    /* eslint-enable max-len */
	
	    /**
	     * An optional accessibility prop to use when the `Dialog` is opened. This should be an id
	     * pointing to some text that describes the content of the dialog. For accessibility
	     * reasons, one of the following props must be defined:
	     * - `title`
	     * - `aria-describedby`
	     * - `aria-labelledby`
	     * - `aria-label`
	     *
	     * An example usage:
	     *
	     * ```js
	     * <Dialog id="accessibleExample" visible aria-describedby="accessibleContent">
	     *   <p id="accessibleContent">This is some content that describes the dialog.</p>
	     * </Dialog>
	     * ```
	     */
	    'aria-describedby': (0, _oneRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]), 'title', 'aria-labelledby', 'aria-label'),
	
	    /**
	     * An optional accessibility prop to use when the `title` prop is not given. This should be
	     * an id pointing to a `h` tag that labels the dialog.
	     *
	     * An example usage:
	     *
	     * ```js
	     * <Dialog visible id="accessibleExample" aria-labelledby="accessibleDialogLabel">
	     *   <h2 id="accessibleDialogLabel">Some Accessible Dialog</h2>
	     * </Dialog>
	     * ```
	     */
	    'aria-labelledby': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional accessibility prop to use when the `title` and `aria-labelledby` props are
	     * not defined. This should be a string that describes what is in the `Dialog`.
	     *
	     * An example usage:
	     *
	     * ```js
	     * <Dialog visible id="accessibleExample" aria-label="Some Accessible Dialog">
	     *   <p>Lorem Ipsum</p>
	     * </Dialog>
	     * ```
	     */
	    'aria-label': _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the dialog's container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the dialog's container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the dialog itself when the `visible` prop is `true`.
	     */
	    dialogStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the dialog itself when the `visible` prop is `true`.
	     */
	    dialogClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the dialog's content.
	     */
	    contentStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the dialog's content.
	     */
	    contentClassName: _react.PropTypes.string,
	
	    /**
	     * The component to render the dialog's container in.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * The component to render the dialog's content in.
	     */
	    contentComponent: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * The content to display in the dialog once open.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * A single action or a list of actions to display in the dialog. This can either be a list
	     * of `FlatButton` props or `<Button flat {...props} />` elements.
	     */
	    actions: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.object, _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.object]))]),
	
	    /**
	     * Bolean if the `Dialog` is current visible.
	     */
	    visible: _react.PropTypes.bool.isRequired,
	
	    /**
	     * An optional function to call when the `visible` prop is changed from `false` to `true`.
	     */
	    onShow: _react.PropTypes.func,
	
	    /**
	     * A function to call that will close the dialog. This is required when the `modal` and `fullPage`
	     * props are not `true`.
	     */
	    onHide: function onHide(props, propName) {
	      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	        args[_key - 2] = arguments[_key];
	      }
	
	      var validator = _react.PropTypes.func;
	      if (!props.modal && !props.fullPage) {
	        validator = validator.isRequired;
	      }
	
	      return validator.apply(undefined, [props, propName].concat(args));
	    },
	
	    /**
	     * Boolean if the dialog should behave like a modal. This means that the dialog can only
	     * be closed by clicking on an action instead of also clicking on the overlay.
	     */
	    modal: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the dialog should be displayed as a full page dialog.
	     */
	    fullPage: function fullPage(props, propName, componentName) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	        args[_key2 - 3] = arguments[_key2];
	      }
	
	      if (typeof props[propName] === 'undefined') {
	        return null;
	      }
	      var componentNameSafe = componentName || '<<anonymous>>';
	
	      var err = _react.PropTypes.bool.apply(_react.PropTypes, [props, propName, componentName].concat(args));
	
	      if (!err && typeof props.title !== 'undefined') {
	        err = new Error('You provided a `title` ' + location + ' to the `' + componentNameSafe + '` when `fullPage` ' + 'has been set to true. A title for a full page dialog should be rendered as a child instead.');
	      }
	
	      return err;
	    },
	
	    /**
	     * An optional pageX location to use when rendering a full page dialog. This is used to set the location
	     * the dialog should appear from.
	     */
	    pageX: _react.PropTypes.number,
	
	    /**
	     * An optional pageY location to use when rendering a full page dialog. This is used to set the location
	     * the dialog should appear from.
	     */
	    pageY: _react.PropTypes.number,
	
	    /**
	     * Boolean if the dialog should focus one of children once it has mounted.
	     */
	    focusOnMount: _react.PropTypes.bool.isRequired,
	
	    /**
	     * The transition enter timeout for the dialog.
	     */
	    transitionEnterTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * The transition leave timeout for the dialog.
	     */
	    transitionLeaveTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if the dialog should be closeable by pressing the escape key.
	     * This will always be considered `false` of the `modal` props is `true`.
	     */
	    closeOnEsc: _react.PropTypes.bool,
	
	    /**
	     * Since the `Dialog` uses the `Portal` component, you can pass an optional HTML Node to render
	     * the dialog in instead of the `document.body`.
	     */
	    renderNode: _react.PropTypes.object,
	
	    /**
	     * Boolean if the dialog should be rendered as the last child in the `renderNode` or `body` instead
	     * of as the first.
	     */
	    lastChild: _react.PropTypes.bool,
	
	    isOpen: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `visible` instead'),
	    transitionName: (0, _deprecated2.default)(_react.PropTypes.string, 'The transition name will be managed by the component'),
	    transitionEnter: (0, _deprecated2.default)(_react.PropTypes.bool, 'The transition will always be enforced'),
	    transitionLeave: (0, _deprecated2.default)(_react.PropTypes.bool, 'The transition will always be enforced'),
	    actionLeft: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `fullPage` prop instead'),
	    actionRight: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `fullPage` prop instead'),
	    close: (0, _deprecated2.default)(_react.PropTypes.func, 'Use `onHide` instead.')
	  };
	  DialogContainer.defaultProps = {
	    component: 'span',
	    closeOnEsc: true,
	    contentComponent: 'section',
	    focusOnMount: true,
	    transitionEnterTimeout: 300,
	    transitionLeaveTimeout: 300
	  };
	  DialogContainer.contextTypes = {
	    renderNode: _react.PropTypes.object
	  };
	  exports.default = DialogContainer;
	});

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.Divider = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Divider = function (_PureComponent) {
	    _inherits(Divider, _PureComponent);
	
	    function Divider() {
	      _classCallCheck(this, Divider);
	
	      return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
	    }
	
	    _createClass(Divider, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            inset = _props.inset,
	            vertical = _props.vertical,
	            props = _objectWithoutProperties(_props, ['className', 'inset', 'vertical']);
	
	        var Component = vertical ? 'div' : 'hr';
	
	        return _react2.default.createElement(Component, _extends({}, props, {
	          className: (0, _classnames2.default)('md-divider', {
	            'md-divider--vertical': vertical,
	            'md-divider--inset': inset
	          }, className)
	        }));
	      }
	    }]);
	
	    return Divider;
	  }(_react.PureComponent);
	
	  Divider.propTypes = {
	    /*
	     * An optional style to apply to the divider.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the divider.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Boolean if this divider should be inset relative to it's container
	     * component. This means that if it is in a `List` with `Avatar`, it
	     * will start the divider  to the left of the main text in the list.
	     */
	    inset: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the divider should be vertical instead of horizontal.
	     */
	    vertical: _react.PropTypes.bool
	  };
	  exports.default = Divider;
	});

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(218), __webpack_require__(12), __webpack_require__(231), __webpack_require__(14), __webpack_require__(26), __webpack_require__(64), __webpack_require__(50), __webpack_require__(197), __webpack_require__(196)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('../constants/media'), require('../utils/getField'), require('../utils/mapToListParts'), require('../utils/PropTypes/controlled'), require('../Papers/Paper'), require('../Helpers/Portal'), require('../Lists/List'), require('./isType'), require('./DrawerTypes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.media, global.getField, global.mapToListParts, global.controlled, global.Paper, global.Portal, global.List, global.isType, global.DrawerTypes);
	    global.Drawer = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _media, _getField, _mapToListParts, _controlled, _Paper, _Portal, _List, _isType, _DrawerTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  var _Portal2 = _interopRequireDefault(_Portal);
	
	  var _List2 = _interopRequireDefault(_List);
	
	  var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var oneOfDrawerTypes = _react.PropTypes.oneOf([_DrawerTypes2.default.FULL_HEIGHT, _DrawerTypes2.default.CLIPPED, _DrawerTypes2.default.FLOATING, _DrawerTypes2.default.PERSISTENT, _DrawerTypes2.default.PERSISTENT_MINI, _DrawerTypes2.default.TEMPORARY, _DrawerTypes2.default.TEMPORARY_MINI]);
	
	  /**
	   * The `Drawer` component is used for having a sliding panel of content or navigation
	   * that appears from the side of a screen.
	   *
	   * If the `Drawer` uses any of the `_MINI` drawer types, you will need to also create another
	   * `Drawer` that is not `_MINI`. Transitioning the `width` on mobile devices is very sluggish,
	   * and it isn't much more work to create another drawer.
	   */
	
	  var Drawer = function (_PureComponent) {
	    _inherits(Drawer, _PureComponent);
	
	    _createClass(Drawer, null, [{
	      key: 'getCurrentMedia',
	      value: function getCurrentMedia() {
	        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Drawer.defaultProps;
	        var mobileMinWidth = props.mobileMinWidth,
	            tabletMinWidth = props.tabletMinWidth,
	            desktopMinWidth = props.desktopMinWidth,
	            mobileType = props.mobileType,
	            tabletType = props.tabletType,
	            desktopType = props.desktopType,
	            constantType = props.constantType;
	
	        if (typeof window === 'undefined') {
	          var _type = constantType && props.type ? props.type : mobileType;
	          return { mobile: true, tablet: false, desktop: false, type: _type };
	        }
	
	        var mobile = Drawer.matchesMedia(mobileMinWidth, tabletMinWidth - 1);
	        var tablet = Drawer.matchesMedia(tabletMinWidth, desktopMinWidth);
	        var desktop = Drawer.matchesMedia(desktopMinWidth);
	
	        var type = void 0;
	        if (constantType && props.type && (0, _isType.isTemporary)(props.type)) {
	          type = props.type;
	        } else if (desktop) {
	          type = desktopType;
	        } else if (tablet) {
	          type = tabletType;
	        } else {
	          type = mobileType;
	        }
	
	        return { type: type, mobile: mobile, tablet: tablet, desktop: desktop };
	      }
	    }, {
	      key: 'matchesMedia',
	      value: function matchesMedia(min, max) {
	        var media = 'screen and (min-width: ' + min + 'px)';
	        if (max) {
	          media += ' and (max-width: ' + max + 'px)';
	        }
	
	        return window.matchMedia(media).matches;
	      }
	    }]);
	
	    function Drawer(props) {
	      _classCallCheck(this, Drawer);
	
	      var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));
	
	      var defaultVisible = props.defaultVisible,
	          defaultMedia = props.defaultMedia,
	          overlay = props.overlay;
	
	
	      _this.state = {
	        mobile: defaultMedia === 'mobile',
	        tablet: defaultMedia === 'tablet',
	        desktop: defaultMedia === 'desktop',
	        animating: false,
	        overlayActive: false,
	        drawerActive: false
	      };
	
	      if (typeof props.type === 'undefined') {
	        _this.state.type = props[defaultMedia + 'Type'];
	      }
	
	      var type = (0, _getField2.default)(props, _this.state, 'type');
	      _this._initialFix = true;
	
	      if (typeof props.visible === 'undefined') {
	        _this.state.visible = typeof defaultVisible !== 'undefined' ? defaultVisible : (0, _isType.isPermanent)(type);
	      }
	
	      var visible = (0, _getField2.default)(props, _this.state, 'visible');
	
	      _this.state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(type) && !_this.state.desktop) && visible;
	      _this.state.drawerActive = visible;
	
	      _this._animate = _this._animate.bind(_this);
	      _this._closeDrawer = _this._closeDrawer.bind(_this);
	      _this._setNavigation = _this._setNavigation.bind(_this);
	      _this._handleNavClick = _this._handleNavClick.bind(_this);
	      _this._updateType = _this._updateType.bind(_this);
	      _this._updateMedia = _this._updateMedia.bind(_this);
	      return _this;
	    }
	
	    _createClass(Drawer, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (typeof window !== 'undefined') {
	          this._updateType(this.props);
	        }
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.addEventListener('resize', this._updateMedia);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            mobileMinWidth = _props.mobileMinWidth,
	            mobileType = _props.mobileType,
	            tabletMinWidth = _props.tabletMinWidth,
	            tabletType = _props.tabletType,
	            desktopMinWidth = _props.desktopMinWidth,
	            desktopType = _props.desktopType;
	
	
	        if (nextProps.mobileMinWidth !== mobileMinWidth || nextProps.mobileType !== mobileType || nextProps.tabletMinWidth !== tabletMinWidth || nextProps.tabletType !== tabletType || nextProps.desktopMinWidth !== desktopMinWidth || nextProps.desktopType !== desktopType) {
	          this._updateType(nextProps);
	        }
	
	        var visible = nextProps.visible,
	            transitionDuration = nextProps.transitionDuration,
	            overlay = nextProps.overlay;
	
	        if (this.props.visible === nextProps.visible) {
	          return;
	        }
	
	        var type = (0, _getField2.default)(nextProps, this.state, 'type');
	        this._animate(visible, type, transitionDuration, overlay, this.state.desktop);
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        var visible = nextState.visible;
	
	        if (typeof nextProps.visible !== 'undefined' || this.state.visible === visible) {
	          return;
	        }
	        var type = (0, _getField2.default)(nextProps, nextState, 'type');
	        this._animate(visible, type, nextProps.transitionDuration, nextProps.overlay, nextState.desktop);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        if (this._closeTimeout) {
	          clearTimeout(this._closeTimeout);
	        }
	
	        window.removeEventListener('resize', this._updateMedia);
	      }
	    }, {
	      key: '_updateType',
	      value: function _updateType(props) {
	        var onMediaTypeChange = props.onMediaTypeChange,
	            onVisibilityToggle = props.onVisibilityToggle,
	            overlay = props.overlay;
	
	
	        var state = Drawer.getCurrentMedia(props);
	        var diffType = (0, _getField2.default)(props, this.state, 'type') !== state.type;
	        var diffMedia = state.mobile !== this.state.mobile || state.tablet !== this.state.tablet || state.desktop !== this.state.desktop;
	
	        if (onMediaTypeChange && (diffType || diffMedia)) {
	          onMediaTypeChange(state.type, { mobile: state.mobile, tablet: state.tablet, desktop: state.desktop });
	        }
	
	        if (diffType) {
	          var visible = (0, _isType.isPermanent)(state.type);
	          if (this._initialFix) {
	            if (props.defaultVisible) {
	              visible = props.defaultVisible;
	            } else if (props.visible) {
	              visible = props.visible;
	            }
	          }
	
	          var prevVisible = (0, _getField2.default)(props, this.state, 'visible');
	          if (onVisibilityToggle && visible !== prevVisible) {
	            onVisibilityToggle(visible);
	          }
	
	          if (typeof props.visible === 'undefined') {
	            state.visible = visible;
	          }
	        } else if (this._initialFix && diffMedia) {
	          state.overlayActive = (typeof overlay !== 'undefined' ? overlay : (0, _isType.isTemporary)(state.type) && !state.desktop) && (0, _getField2.default)(props, this.state, 'visible');
	        }
	
	        if (typeof props.type !== 'undefined') {
	          delete state.type;
	        }
	
	        this._initialFix = false;
	        this.setState(state);
	      }
	    }, {
	      key: '_updateMedia',
	      value: function _updateMedia() {
	        this._updateType(this.props);
	      }
	    }, {
	      key: '_animate',
	      value: function _animate(visible, type, timeout, overlay, desktop) {
	        var _this2 = this;
	
	        if (visible) {
	          this.timeout = setTimeout(function () {
	            _this2.timeout = null;
	
	            _this2.setState({
	              overlayActive: overlay || (0, _isType.isTemporary)(type) && !desktop,
	              drawerActive: true,
	              animating: true
	            });
	          }, 17);
	        } else {
	          this._timeout = setTimeout(function () {
	            _this2._timeout = null;
	
	            _this2.setState({ animating: false });
	          }, timeout);
	          this.setState({ animating: true, overlayActive: false, drawerActive: false });
	        }
	      }
	    }, {
	      key: '_setNavigation',
	      value: function _setNavigation(navigation) {
	        this._navigation = (0, _reactDom.findDOMNode)(navigation);
	      }
	    }, {
	      key: '_handleNavClick',
	      value: function _handleNavClick(e) {
	        var _this3 = this;
	
	        if (!this.props.closeOnNavItemClick || !(0, _isType.isTemporary)((0, _getField2.default)(this.props, this.state, 'type'))) {
	          return;
	        }
	
	        var target = e.target;
	
	        while (target && this._navigation.contains(target)) {
	          if (target.classList.contains('md-list-tile')) {
	            // Clicked a nav item that has a nested list
	            if (target.getAttribute('aria-expanded') !== null) {
	              return;
	            }
	
	            this._closeTimeout = setTimeout(function () {
	              _this3._closeTimeout = null;
	
	              _this3._closeDrawer(e);
	            }, 450);
	            return;
	          }
	
	          target = target.parentNode;
	        }
	      }
	    }, {
	      key: '_closeDrawer',
	      value: function _closeDrawer() {
	        if (this.props.onVisibilityToggle) {
	          this.props.onVisibilityToggle(false);
	        }
	
	        if (typeof this.props.visible === 'undefined') {
	          this.setState({ visible: false });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _cn;
	
	        var _state = this.state,
	            overlayActive = _state.overlayActive,
	            drawerActive = _state.drawerActive,
	            animating = _state.animating;
	
	        var _props2 = this.props,
	            style = _props2.style,
	            className = _props2.className,
	            navStyle = _props2.navStyle,
	            navClassName = _props2.navClassName,
	            component = _props2.component,
	            navItems = _props2.navItems,
	            header = _props2.header,
	            children = _props2.children,
	            inline = _props2.inline,
	            position = _props2.position,
	            overlay = _props2.overlay,
	            autoclose = _props2.autoclose,
	            clickableDesktopOverlay = _props2.clickableDesktopOverlay,
	            lastChild = _props2.lastChild,
	            props = _objectWithoutProperties(_props2, ['style', 'className', 'navStyle', 'navClassName', 'component', 'navItems', 'header', 'children', 'inline', 'position', 'overlay', 'autoclose', 'clickableDesktopOverlay', 'lastChild']);
	
	        delete props.constantType;
	        delete props.renderNode;
	        delete props.visible;
	        delete props.defaultVisible;
	        delete props.type;
	        delete props.defaultMedia;
	        delete props.mobileType;
	        delete props.mobileMinWidth;
	        delete props.tabletType;
	        delete props.tabletMinWidth;
	        delete props.desktopType;
	        delete props.desktopMinWidth;
	        delete props.transitionDuration;
	        delete props.onVisibilityToggle;
	        delete props.onMediaTypeChange;
	        delete props.closeOnNavItemClick;
	
	        var desktop = this.state.desktop;
	
	        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	        var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	        var type = (0, _getField2.default)(this.props, this.state, 'type');
	        var mini = (0, _isType.isMini)(type);
	        var temporary = (0, _isType.isTemporary)(type);
	        var floating = _DrawerTypes2.default.FLOATING === type;
	        var permanent = (0, _isType.isPermanent)(type);
	
	        var Component = void 0;
	        if (component) {
	          Component = component;
	        } else if (navItems) {
	          Component = 'nav';
	        } else {
	          Component = 'aside';
	        }
	
	        var navigation = void 0;
	        if (navItems) {
	          navigation = _react2.default.createElement(
	            _List2.default,
	            {
	              ref: this._setNavigation,
	              key: 'navigation',
	              style: navStyle,
	              className: (0, _classnames2.default)('md-list--drawer', {
	                'md-toolbar-relative': mini && !visible,
	                'md-background': floating
	              }, navClassName),
	              onClick: autoclose ? this._handleNavClick : null
	            },
	            navItems.map(_mapToListParts2.default)
	          );
	        }
	        var zDepth = 1;
	        if (floating || inline) {
	          zDepth = 0;
	        } else if (temporary && visible) {
	          zDepth = 5;
	        }
	
	        var overlayVisible = (!desktop || clickableDesktopOverlay) && (overlay || temporary) && (animating || visible);
	
	        var drawer = _react2.default.createElement(
	          _Paper2.default,
	          _extends({}, props, {
	            key: 'drawer',
	            component: Component,
	            zDepth: zDepth,
	            raiseOnHover: false,
	            style: style,
	            className: (0, _classnames2.default)('md-drawer', (_cn = {}, _defineProperty(_cn, 'md-drawer--' + position, !inline), _defineProperty(_cn, 'md-drawer--fixed', !inline), _defineProperty(_cn, 'md-drawer--inline', inline), _defineProperty(_cn, 'md-drawer--active', mini || drawerActive), _defineProperty(_cn, 'md-drawer--mini', mini), _defineProperty(_cn, 'md-transition--decceleration', visible), _defineProperty(_cn, 'md-transition--acceleration', !visible), _defineProperty(_cn, 'md-background', inline || floating), _defineProperty(_cn, 'md-background--card', !floating && !inline), _cn), className)
	          }),
	          header,
	          navigation,
	          children,
	          _react2.default.createElement(
	            _Portal2.default,
	            { visible: overlayVisible, renderNode: renderNode },
	            _react2.default.createElement('div', {
	              className: (0, _classnames2.default)('md-overlay md-overlay--drawer md-pointer--hover', {
	                'md-overlay--active': overlayActive
	              }),
	              onClick: this._closeDrawer
	            })
	          )
	        );
	
	        if (inline || permanent) {
	          return drawer;
	        }
	
	        return _react2.default.createElement(
	          _Portal2.default,
	          { visible: mini || animating || visible, renderNode: renderNode, lastChild: lastChild },
	          drawer
	        );
	      }
	    }]);
	
	    return Drawer;
	  }(_react.PureComponent);
	
	  Drawer.DrawerTypes = _DrawerTypes2.default;
	  Drawer.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the `List` surrounding the `navItems`.
	     */
	    navStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `List` surrounding the `navItems`.
	     */
	    navClassName: _react.PropTypes.string,
	
	    /**
	     * An optional component to render the drawer in. When this prop is undefined, the drawer
	     * will be rendered as a `nav` if the `navItems` prop is defined, otherwise an `aside`.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.element]),
	
	    /**
	     * An optional list of navigation items to display in the drawer. This list can either contain
	     * a valid child component for a `List` or an object used to create a `Divider`, `Subheader`,
	     * or `ListItem`.
	     *
	     * - To create a divider in the list, set a `divider` key to `true`. Any other keys will be
	     * passed to the `Divider` component.
	     * - To create a subheader in the list, set the `subheader` key to `true`. Any other keys will
	     * be passed to the `Subheader` component.
	     * - To create a list item, just create an object with any normal `ListItem` props.
	     */
	    navItems: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.shape({
	      divider: _react.PropTypes.bool,
	      subheader: _react.PropTypes.bool,
	      primaryText: _react.PropTypes.string
	    })])),
	
	    /**
	     * Boolean if a temporary drawer should close when a nav item is clicked.
	     */
	    autoclose: _react.PropTypes.bool,
	
	    /**
	     * An optional header to display. This _should_ normally be a toolbar.
	     */
	    header: _react.PropTypes.node,
	
	    /**
	     * Any additional children to display after the `header` and `navItems`.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * The drawer type to use when the current device matches the mobile
	     * media query.
	     */
	    mobileType: _react.PropTypes.oneOf([Drawer.DrawerTypes.TEMPORARY, Drawer.DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	    /**
	     * The min-width to use for the mobile media query.
	     */
	    mobileMinWidth: _react.PropTypes.number.isRequired,
	
	    /**
	     * The drawer type to use when the current device matches the tablet
	     * media query.
	     */
	    tabletType: oneOfDrawerTypes.isRequired,
	
	    /**
	     * The min-width to use for the tablet media query.
	     */
	    tabletMinWidth: _react.PropTypes.number.isRequired,
	
	    /**
	     * The drawer type to use when the current device matches the desktop media
	     * query.
	     */
	    desktopType: oneOfDrawerTypes.isRequired,
	
	    /**
	     * The min-width for a desktop screen.
	     */
	    desktopMinWidth: _react.PropTypes.number.isRequired,
	
	    /**
	     * An optional type to enforce across all media sizes. Since `mobile` devices are
	     * included, you are required to manually specify when the `type` should be `temporary`.
	     *
	     * When the `type` is not one of the `temporary` types, the `onMediaTypeChange` prop
	     * must be provided.
	     */
	    type: function type(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      var type = props[propName];
	      if ((0, _isType.isTemporary)(type)) {
	        return oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	      }
	
	      var err = oneOfDrawerTypes.apply(undefined, [props, propName, component].concat(others));
	      if (!err && typeof type !== 'undefined' && !(0, _isType.isMini)(type) && typeof props.onMediaTypeChange === 'undefined') {
	        err = new Error('You provided a `' + propName + '` prop to the ' + component + ' without the `onMediaTypeChange` ' + ('handler. The `onMediaTypeChange` prop must be specified when the `' + propName + '` is not ') + 'one of the `temporary` types.');
	      }
	
	      return err;
	    },
	
	    /**
	     * An optional function to call when the drawer's type changes when the screen resizes.
	     * The callback will include the new `type` that should be used for the screen size,
	     * and an object containing the media matches for `mobile`, `tablet`, and `desktop`.
	     *
	     * ```js
	     * this.props.onMediaTypeChange(Drawer.DrawerTypes.TEMPORARY, {
	     *   mobile: true,
	     *   tablet: false,
	     *   desktop: false,
	     * });
	     * ```
	     */
	    onMediaTypeChange: _react.PropTypes.func,
	
	    /**
	     * The default drawer type to display on initial render. The drawer will automatically
	     * adjust itself to the correct media once it has mounted. This prop is really only useful
	     * for server side rendering.
	     */
	    defaultMedia: _react.PropTypes.oneOf(['mobile', 'tablet', 'desktop']).isRequired,
	
	    /**
	     * Boolean if there should be a visible overlay when the drawer is visible. The default behavior
	     * is to only include a visible overlay when the `type` is `TEMPORARY` or `TEMPORARY_MINI` and
	     * the device is not a desktop.
	     */
	    overlay: _react.PropTypes.bool,
	
	    /**
	     * An optional DOM Node to render the drawer into. The default is to render as
	     * the first child in the `body`.
	     *
	     * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	     * since the `Portal` component will not be used.
	     */
	    renderNode: _react.PropTypes.object,
	
	    /**
	     * Boolean if the drawer should be rendered as the last child instead of the first child
	     * in the `renderNode` or `body`.
	     *
	     * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	     * since the `Portal` component will not be used.
	     */
	    lastChild: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the drawer is visible by default. If this is omitted, the drawer will be visible
	     * if the current drawer type is NOT `Drawer.DrawerTypes.TEMPORARY` or `Drawer.DrawerTypes.TEMPORARY_MINI`.
	     *
	     * This basically means that if you are using the default configuration, a mobile device's drawer
	     * will be hidden while tablets and desktops will be visible.
	     */
	    defaultVisible: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the drawer is visible. This will force the component to define the `onVisibilityToggle`
	     * prop as well as manually updating the drawer's visibility.
	     */
	    visible: (0, _controlled2.default)(_react.PropTypes.bool, 'onVisibilityToggle', 'defaultVisible'),
	
	    /**
	     * An optional function to call when the visibility of the drawer is changed. The function will
	     * be called with the new visibility state.
	     *
	     * ```js
	     * onVisibilityToggle(!currentlyVisible);
	     * ```
	     */
	    onVisibilityToggle: _react.PropTypes.func,
	
	    /**
	     * The drawer's position on the page when it is not `inline`. When the drawer's position is `left`,
	     * the width will be `calc(100vw - 56px)` on mobile devices and `$md-drawer-desktop-width` on desktops.
	     *
	     * When the position is `right`, the width will be `100vw` for mobile devices and scaling to the drawer's
	     * children width on desktops.
	     */
	    position: _react.PropTypes.oneOf(['left', 'right']).isRequired,
	
	    /**
	     * Boolean if the drawer should be displayed inline instead of fixed to the page. When this prop
	     * is enabled, the `position` prop will not be used.
	     */
	    inline: _react.PropTypes.bool,
	
	    /**
	     * The `$md-drawer-transition-time` value from sass.
	     */
	    transitionDuration: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if the temporary drawer's overlay should be created on desktop screens. This is really used so that
	     * the drawer will close when a user clicks anywhere on the page except in the drawer.
	     */
	    clickableDesktopOverlay: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the navigation drawer should automatically close when a nav item has been clicked.
	     */
	    closeOnNavItemClick: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `type` prop should be constant across all media sizes. This is only valid if the `type` is
	     * one of the temporary types.
	     *
	     * This will basically mean that when attempting to do a media adjustment, it will use the `type` prop instead of
	     * `mobileType`, `tabletType`, and `desktopType` to determine the next drawer type.
	     */
	    constantType: _react.PropTypes.bool.isRequired
	  };
	  Drawer.defaultProps = {
	    defaultMedia: 'mobile',
	    mobileType: Drawer.DrawerTypes.TEMPORARY,
	    mobileMinWidth: _media.MOBILE_MIN_WIDTH,
	    tabletType: Drawer.DrawerTypes.PERSISTENT,
	    tabletMinWidth: _media.TABLET_MIN_WIDTH,
	    desktopType: Drawer.DrawerTypes.FULL_HEIGHT,
	    desktopMinWidth: _media.DESKTOP_MIN_WIDTH,
	    position: 'left',
	    transitionDuration: 300,
	    autoclose: true,
	    clickableDesktopOverlay: true,
	    closeOnNavItemClick: true,
	    constantType: true
	  };
	  Drawer.contextTypes = {
	    renderNode: _react.PropTypes.object
	  };
	  exports.default = Drawer;
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./FontIcon'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.FontIcon);
	    global.Collapser = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _FontIcon) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Collapser = function (_PureComponent) {
	    _inherits(Collapser, _PureComponent);
	
	    function Collapser(props) {
	      _classCallCheck(this, Collapser);
	
	      var _this = _possibleConstructorReturn(this, (Collapser.__proto__ || Object.getPrototypeOf(Collapser)).call(this, props));
	
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(Collapser, [{
	      key: 'render',
	      value: function render() {
	        var _cn;
	
	        var _props = this.props,
	            className = _props.className,
	            flipped = _props.flipped,
	            suffix = _props.suffix,
	            suffixFlipped = _props.suffixFlipped,
	            props = _objectWithoutProperties(_props, ['className', 'flipped', 'suffix', 'suffixFlipped']);
	
	        return _react2.default.createElement(_FontIcon2.default, _extends({
	          key: 'collapser'
	        }, props, {
	          className: (0, _classnames2.default)('md-collapser', (_cn = {
	            'md-collapser--flipped': flipped && (!suffixFlipped || !suffix)
	          }, _defineProperty(_cn, 'md-collapser--' + suffix, suffix), _defineProperty(_cn, 'md-collapser--' + suffix + '-flipped', suffix && flipped && suffixFlipped), _cn), className)
	        }));
	      }
	    }]);
	
	    return Collapser;
	  }(_react.PureComponent);
	
	  Collapser.propTypes = {
	    className: _react.PropTypes.string,
	    iconClassName: _react.PropTypes.string,
	    children: _react.PropTypes.node,
	    flipped: _react.PropTypes.bool,
	    suffix: _react.PropTypes.string,
	    suffixFlipped: _react.PropTypes.bool
	  };
	  Collapser.defaultProps = {
	    children: 'keyboard_arrow_down'
	  };
	  exports.default = Collapser;
	});

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(18)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./FontIcon'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.FontIcon);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _FontIcon) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _FontIcon2.default;
	});

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(439), __webpack_require__(228)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('./InkContainer'), require('../utils/StringUtils/getDisplayName'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.InkContainer, global.getDisplayName);
	    global.injectInk = mod.exports;
	  }
	})(this, function (exports, _react, _InkContainer, _getDisplayName) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _InkContainer2 = _interopRequireDefault(_InkContainer);
	
	  var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  exports.default = function (ComposedComponent) {
	    var _class, _temp;
	
	    return _temp = _class = function (_PureComponent) {
	      _inherits(InkedComponent, _PureComponent);
	
	      function InkedComponent(props, context) {
	        _classCallCheck(this, InkedComponent);
	
	        var _this = _possibleConstructorReturn(this, (InkedComponent.__proto__ || Object.getPrototypeOf(InkedComponent)).call(this, props, context));
	
	        _this.focus = _this.focus.bind(_this);
	        _this.createInk = _this.createInk.bind(_this);
	        _this.getComposedComponent = _this.getComposedComponent.bind(_this);
	        _this._setInkRef = _this._setInkRef.bind(_this);
	        _this._setComposedComponent = _this._setComposedComponent.bind(_this);
	        return _this;
	      }
	
	      _createClass(InkedComponent, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          var ref = this.props.__SUPER_SECRET_REF__;
	          // Emulate the ref callback...
	
	          if (ref) {
	            ref(this);
	          }
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          var ref = this.props.__SUPER_SECRET_REF__;
	          // Emulate the ref callback...
	
	          if (ref) {
	            ref(null);
	          }
	        }
	
	        /**
	         * A publically accessible way to manually create an ink. This can be used with the `refs`.
	         * The ink can either be created by using the `pageX` and `pageY` from a click/touch event
	         * or it will be created in the center of the `ComposedComponent`.
	         *
	         * ```js
	         * <SomeInkedComponent ref={inkHOC => inkHOC.createInk()} />
	         * ```
	         *
	         * @param {number=} pageX - An optional pageX of the click or touch event.
	         * @param {number=} pageY - An optional pageY of the click or touch event.
	         */
	
	      }, {
	        key: 'createInk',
	        value: function createInk(pageX, pageY) {
	          if (this._inkContainer && !this.props.disabled && !this.props.inkDisabled) {
	            this._inkContainer.createInk(pageX, pageY);
	          }
	        }
	
	        /**
	         * This will attempt to focus the composed component. If the component is disabled, nothing
	         * will happen. If the `disabled` and `inkDisabled` props are not set to `true`, an ink will
	         * also be created.
	         *
	         * ```js
	         * <SomeInkedComponent ref={inkHOC => inkHOC.focus()} />
	         * ```
	         */
	
	      }, {
	        key: 'focus',
	        value: function focus() {
	          if (this._inkContainer) {
	            this._inkContainer.focus();
	          }
	        }
	
	        /**
	         * Gets the composed component as a ref. This is usefull if you need to access the ref of the
	         * composed component instead of the `injectInk` HOC to use some publically accessible methods.
	         *
	         * ```js
	         * <SomeInkedComponent
	         *   ref={inkHOC => {
	         *     inkHOC.getComposedComponent().focus();
	         *   }}
	         * />
	         * ```
	         */
	
	      }, {
	        key: 'getComposedComponent',
	        value: function getComposedComponent() {
	          return this._composed;
	        }
	      }, {
	        key: '_setInkRef',
	        value: function _setInkRef(inkContainer) {
	          if (inkContainer) {
	            this._inkContainer = inkContainer;
	          }
	        }
	      }, {
	        key: '_setComposedComponent',
	        value: function _setComposedComponent(component) {
	          this._composed = component;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              inkDisabled = _props.inkDisabled,
	              transitionOverlap = _props.inkTransitionOverlap,
	              transitionEnterTimeout = _props.inkTransitionEnterTimeout,
	              transitionLeaveTimeout = _props.inkTransitionLeaveTimeout,
	              inkStyle = _props.inkStyle,
	              inkClassName = _props.inkClassName,
	              inkContainerStyle = _props.inkContainerStyle,
	              inkContainerClassName = _props.inkContainerClassName,
	              disabledInteractions = _props.disabledInteractions,
	              waitForInkTransition = _props.waitForInkTransition,
	              props = _objectWithoutProperties(_props, ['inkDisabled', 'inkTransitionOverlap', 'inkTransitionEnterTimeout', 'inkTransitionLeaveTimeout', 'inkStyle', 'inkClassName', 'inkContainerStyle', 'inkContainerClassName', 'disabledInteractions', 'waitForInkTransition']);
	
	          delete props.__SUPER_SECRET_REF__;
	
	          if (!(props.disabled || inkDisabled)) {
	            props.ink = _react2.default.createElement(_InkContainer2.default, {
	              ref: this._setInkRef,
	              key: 'ink-container',
	              style: inkContainerStyle,
	              className: inkContainerClassName,
	              inkStyle: inkStyle,
	              inkClassName: inkClassName,
	              disabledInteractions: disabledInteractions,
	              transitionOverlap: transitionOverlap,
	              transitionEnterTimeout: transitionEnterTimeout,
	              transitionLeaveTimeout: transitionLeaveTimeout,
	              waitForInkTransition: waitForInkTransition
	            });
	          }
	
	          props.ref = this._setComposedComponent;
	
	          return _react2.default.createElement(ComposedComponent, props);
	        }
	      }]);
	
	      return InkedComponent;
	    }(_react.PureComponent), _class.displayName = (0, _getDisplayName2.default)(ComposedComponent, 'Inked'), _class.propTypes = {
	      /**
	       * An optional style to apply to each ink that gets generated.
	       */
	      inkStyle: _react.PropTypes.object,
	
	      /**
	       * An optional className to apply to each ink that gets generated.
	       */
	      inkClassName: _react.PropTypes.string,
	
	      /**
	       * An optional style to apply to the ink's container.
	       */
	      inkContainerStyle: _react.PropTypes.object,
	
	      /**
	       * An optional className to apply to the ink's container.
	       */
	      inkContainerClassName: _react.PropTypes.string,
	
	      /**
	       * Boolean if the composed component or the ink is disabled.
	       */
	      disabled: _react.PropTypes.bool,
	
	      /**
	       * Boolean if only the ink is disabled for the composed component.
	       */
	      inkDisabled: _react.PropTypes.bool,
	
	      /**
	       * The time (in ms) that the enter and leave transitions for the ink should overlap.
	       * This really just allows for a more _fluid_ looking ink when something is quickly
	       * touched or clicked by having it fade out while growing.
	       */
	      inkTransitionOverlap: _react.PropTypes.number.isRequired,
	
	      /**
	       * The transition time for the ink to be considered fully entered. This should really
	       * map up to whatever value you set for `$md-ink-enter-transition-time`.
	       */
	      inkTransitionEnterTimeout: _react.PropTypes.number.isRequired,
	
	      /**
	       * The transition time for the ink to be considered fully leaved (left?). This should really
	       * map up to whatever value you set for `$md-ink-leave-transition-time`.
	       */
	      inkTransitionLeaveTimeout: _react.PropTypes.number.isRequired,
	
	      /**
	       * Boolean if the `ComposedComponent`'s click event only after the ink has finished transitioning
	       * in and out. This is really only to get a more _fluid_ looking click event when clicking on
	       * the `ComposedComponent` ends up taking it out of the view. (ex: Closing a Dialog).
	       */
	      waitForInkTransition: _react.PropTypes.bool,
	
	      /**
	       * An optional array of interactions that can be disabled for the ink. This is a *very* limited
	       * use case where `Switches` needed the ink disabled only when using a mouse.
	       */
	      disabledInteractions: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['keyboard', 'mouse', 'touch'])),
	
	      /**
	       * When using inked components in a `TransitionGroup`, the ref callback is not actually invoked.
	       * This is a little _hack_ to get it to work by not using `ref`, but this name.
	       */
	      __SUPER_SECRET_REF__: _react.PropTypes.func
	    }, _class.defaultProps = {
	      inkTransitionOverlap: 150,
	      inkTransitionEnterTimeout: 450,
	      inkTransitionLeaveTimeout: 300
	    }, _temp;
	  };
	});

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.TileAddon = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TileAddon = function (_PureComponent) {
	    _inherits(TileAddon, _PureComponent);
	
	    function TileAddon() {
	      _classCallCheck(this, TileAddon);
	
	      return _possibleConstructorReturn(this, (TileAddon.__proto__ || Object.getPrototypeOf(TileAddon)).apply(this, arguments));
	    }
	
	    _createClass(TileAddon, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            icon = _props.icon,
	            avatar = _props.avatar,
	            active = _props.active,
	            activeClassName = _props.activeClassName,
	            style = _props.style,
	            className = _props.className;
	
	        if (!icon && !avatar) {
	          return null;
	        }
	
	        var avatarIcon = false;
	        if (avatar) {
	          var avatarChild = _react2.default.Children.only(avatar);
	          if (avatarChild.props.iconSized) {
	            avatarIcon = true;
	          }
	        }
	        return _react2.default.createElement(
	          'div',
	          {
	            style: style,
	            className: (0, _classnames2.default)('md-tile-addon', _defineProperty({
	              'md-tile-addon--icon': icon || avatarIcon,
	              'md-tile-addon--avatar': avatar && !avatarIcon
	            }, activeClassName, active), className)
	          },
	          icon || avatar
	        );
	      }
	    }]);
	
	    return TileAddon;
	  }(_react.PureComponent);
	
	  TileAddon.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    active: _react.PropTypes.bool,
	    activeClassName: _react.PropTypes.string,
	    icon: _react.PropTypes.node,
	    avatar: _react.PropTypes.node
	  };
	  exports.default = TileAddon;
	});

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.PickerControl = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var PickerControl = function (_PureComponent) {
	    _inherits(PickerControl, _PureComponent);
	
	    function PickerControl() {
	      _classCallCheck(this, PickerControl);
	
	      return _possibleConstructorReturn(this, (PickerControl.__proto__ || Object.getPrototypeOf(PickerControl)).apply(this, arguments));
	    }
	
	    _createClass(PickerControl, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            active = _props.active,
	            props = _objectWithoutProperties(_props, ['className', 'active']);
	
	        return _react2.default.createElement('button', _extends({}, props, {
	          type: 'button',
	          className: (0, _classnames2.default)('md-btn md-pointer--hover md-picker-control md-picker-text', {
	            'md-picker-text--active': active
	          }, className)
	        }));
	      }
	    }]);
	
	    return PickerControl;
	  }(_react.PureComponent);
	
	  PickerControl.propTypes = {
	    className: _react.PropTypes.string,
	    active: _react.PropTypes.bool.isRequired,
	    onClick: _react.PropTypes.func.isRequired,
	    children: _react.PropTypes.node.isRequired
	  };
	  exports.default = PickerControl;
	});

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(7), __webpack_require__(8), __webpack_require__(13), __webpack_require__(11), __webpack_require__(12), __webpack_require__(14), __webpack_require__(225), __webpack_require__(227), __webpack_require__(50), __webpack_require__(65), __webpack_require__(66), __webpack_require__(83), __webpack_require__(214), __webpack_require__(216), __webpack_require__(468)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-dom'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../utils/NumberUtils/isBetween'), require('../utils/StringUtils/addSuffix'), require('../Lists/List'), require('../Lists/ListItem'), require('../Menus/Menu'), require('../Menus/Positions'), require('../TextFields/FloatingLabel'), require('../TextFields/TextFieldMessage'), require('./Field'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.reactDom, global.deprecated, global.isRequiredForA11y, global.keyCodes, global.getField, global.controlled, global.isBetween, global.addSuffix, global.List, global.ListItem, global.Menu, global.Positions, global.FloatingLabel, global.TextFieldMessage, global.Field);
	    global.SelectField = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _reactDom, _deprecated, _isRequiredForA11y, _keyCodes, _getField, _controlled, _isBetween, _addSuffix, _List, _ListItem, _Menu, _Positions, _FloatingLabel, _TextFieldMessage, _Field) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _isBetween2 = _interopRequireDefault(_isBetween);
	
	  var _addSuffix2 = _interopRequireDefault(_addSuffix);
	
	  var _List2 = _interopRequireDefault(_List);
	
	  var _ListItem2 = _interopRequireDefault(_ListItem);
	
	  var _Menu2 = _interopRequireDefault(_Menu);
	
	  var _Positions2 = _interopRequireDefault(_Positions);
	
	  var _FloatingLabel2 = _interopRequireDefault(_FloatingLabel);
	
	  var _TextFieldMessage2 = _interopRequireDefault(_TextFieldMessage);
	
	  var _Field2 = _interopRequireDefault(_Field);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var VALID_LIST_ITEM_PROPS = Object.keys(_ListItem2.default.propTypes);
	
	  var MOBILE_LIST_PADDING = 8;
	  var SelectFieldPositions = Object.assign({}, _Positions2.default);
	  delete SelectFieldPositions.BOTTOM_RIGHT;
	  delete SelectFieldPositions.BOTTOM_LEFt;
	
	  var SelectField = function (_PureComponent) {
	    _inherits(SelectField, _PureComponent);
	
	    function SelectField(props) {
	      _classCallCheck(this, SelectField);
	
	      var _this = _possibleConstructorReturn(this, (SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call(this, props));
	
	      _this.state = {
	        active: false,
	        activeIndex: _this._getActiveIndex(props, { value: props.defaultValue }),
	        isOpen: typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultOpen,
	        activeLabel: _this._getActiveLabel(props, typeof props.value !== 'undefined' ? props.value : props.defaultValue),
	        match: null,
	        lastSearch: null,
	        error: false
	      };
	
	      if (typeof props.value === 'undefined') {
	        _this.state.value = props.defaultValue;
	      }
	
	      _this._setMenu = _this._setMenu.bind(_this);
	      _this._setField = _this._setField.bind(_this);
	      _this._positionList = _this._positionList.bind(_this);
	      _this._toggleOpen = _this._toggleOpen.bind(_this);
	      _this._handleBlur = _this._handleBlur.bind(_this);
	      _this._handleFocus = _this._handleFocus.bind(_this);
	      _this._handleOpen = _this._handleOpen.bind(_this);
	      _this._handleClose = _this._handleClose.bind(_this);
	      _this._getActiveLabel = _this._getActiveLabel.bind(_this);
	      _this._mapToListItem = _this._mapToListItem.bind(_this);
	      _this._handleItemSelect = _this._handleItemSelect.bind(_this);
	      _this._handleContainerClick = _this._handleContainerClick.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._setMenuItem = _this._setMenuItem.bind(_this);
	      _this._getActiveIndex = _this._getActiveIndex.bind(_this);
	      _this._advanceFocus = _this._advanceFocus.bind(_this);
	      _this._attemptItemFocus = _this._attemptItemFocus.bind(_this);
	      _this._selectItemByLetter = _this._selectItemByLetter.bind(_this);
	      _this._selectFirstMatch = _this._selectFirstMatch.bind(_this);
	
	      _this._items = [];
	      _this._activeItem = null;
	      return _this;
	    }
	
	    _createClass(SelectField, [{
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        var prevValue = (0, _getField2.default)(this.props, this.state, 'value');
	        var value = (0, _getField2.default)(nextProps, nextState, 'value');
	        var error = (0, _getField2.default)(nextProps, nextState, 'error');
	        var isOpen = (0, _getField2.default)(nextProps, nextState, 'isOpen');
	        var valued = !(0, _getField2.default)(nextProps, nextState, 'value');
	
	        var state = void 0;
	        if (prevValue !== value || this.props.menuItems !== nextProps.menuItems) {
	          state = {
	            activeLabel: this._getActiveLabel(nextProps, value)
	          };
	        }
	
	        if (nextProps.required && !isOpen && error !== valued) {
	          state = state || {};
	          state.error = valued;
	        }
	
	        if (state) {
	          this.setState(state);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._matchingTimeout) {
	          clearTimeout(this._matchingTimeout);
	        }
	      }
	    }, {
	      key: '_attemptItemFocus',
	      value: function _attemptItemFocus(index) {
	        if (index === -1) {
	          return;
	        }
	
	        var item = this._items[index];
	        if (item) {
	          item.focus();
	        }
	      }
	    }, {
	      key: '_getActiveLabel',
	      value: function _getActiveLabel(_ref, value) {
	        var _this2 = this;
	
	        var menuItems = _ref.menuItems,
	            itemLabel = _ref.itemLabel,
	            itemValue = _ref.itemValue;
	
	        var activeLabel = '';
	        menuItems.some(function (item) {
	          activeLabel = _this2._getActiveLabelFromItem(item, value, itemLabel, itemValue);
	          return activeLabel;
	        });
	
	        return activeLabel;
	      }
	    }, {
	      key: '_getActiveLabelFromItem',
	      value: function _getActiveLabelFromItem(item, value, itemLabel, itemValue) {
	        switch (typeof item === 'undefined' ? 'undefined' : _typeof(item)) {
	          case 'number':
	          case 'string':
	            if (item === value || item === parseInt(value, 10)) {
	              return item;
	            }
	
	            break;
	          case 'object':
	            if (item[itemValue] === value || item[itemValue] === parseInt(value, 10)) {
	              return item[itemLabel];
	            }
	
	            break;
	          default:
	        }
	
	        return '';
	      }
	    }, {
	      key: '_getActiveIndex',
	      value: function _getActiveIndex(props, state) {
	        var _this3 = this;
	
	        var value = (0, _getField2.default)(props, state, 'value');
	        if (!value) {
	          return -1;
	        }
	
	        var itemLabel = props.itemLabel,
	            itemValue = props.itemValue,
	            menuItems = props.menuItems;
	
	        var index = -1;
	        menuItems.some(function (item, i) {
	          var found = _this3._getActiveLabelFromItem(item, value, itemLabel, itemValue);
	          if (found) {
	            index = i;
	          }
	
	          return found;
	        });
	
	        return index;
	      }
	    }, {
	      key: '_setMenu',
	      value: function _setMenu(menu) {
	        this._menu = (0, _reactDom.findDOMNode)(menu);
	      }
	    }, {
	      key: '_setField',
	      value: function _setField(field) {
	        this._field = (0, _reactDom.findDOMNode)(field);
	      }
	    }, {
	      key: '_positionList',
	      value: function _positionList(listRef) {
	        if (listRef === null) {
	          this._items = [];
	        } else if (!this._activeItem) {
	          return;
	        }
	
	        var list = (0, _reactDom.findDOMNode)(listRef);
	        var _props = this.props,
	            position = _props.position,
	            menuItems = _props.menuItems,
	            toolbar = _props.toolbar;
	
	        if (position === SelectField.Positions.BELOW || toolbar) {
	          // only modify scroll distance when below
	          var activeIndex = Math.min(this._activeItem, menuItems.length - 2);
	          var _itemTop = list.querySelectorAll('.md-list-tile')[activeIndex].offsetTop;
	
	          list.scrollTop = _itemTop > MOBILE_LIST_PADDING ? _itemTop : 0;
	          return;
	        }
	
	        var _activeItem = this._activeItem,
	            itemTop = _activeItem.offsetTop,
	            itemHeight = _activeItem.offsetHeight;
	        var menuHeight = this._menu.offsetHeight;
	
	        var itemPosition = Math.max(0, itemTop - itemHeight);
	        var listPadding = parseInt(window.getComputedStyle(list).getPropertyValue('padding-top'), 10);
	
	        // Basically calculates where the current item is in the list, and attempts to make the menu
	        // originate from that position.
	        var x = SelectField.Positions.TOP_LEFT === position ? '0' : '100%';
	        var y = (itemPosition === 0 ? 0 : menuHeight) + menuHeight / 2 + listPadding;
	        var transformOrigin = x + ' ' + y + 'px';
	
	        var top = void 0;
	        if (itemPosition > 0) {
	          // close enough. It is off by 4px for floating label on desktop
	          top = -(itemHeight + listPadding - (menuHeight - itemHeight));
	        }
	
	        if (itemPosition > 0) {
	          list.scrollTop = itemPosition;
	        }
	
	        this.setState({
	          listStyle: {
	            top: top,
	            transformOrigin: transformOrigin
	          }
	        });
	      }
	    }, {
	      key: '_handleFocus',
	      value: function _handleFocus(e) {
	        if (this.props.onFocus) {
	          this.props.onFocus(e);
	        }
	
	        this.setState({ active: true });
	      }
	    }, {
	      key: '_handleBlur',
	      value: function _handleBlur(e) {
	        if (this.props.onBlur) {
	          this.props.onBlur(e);
	        }
	
	        var isOpen = (0, _getField2.default)(this.props, this.state, 'isOpen');
	        var value = (0, _getField2.default)(this.props, this.state, 'value');
	
	        this.setState({
	          active: false,
	          error: this.props.required && !isOpen && !value
	        });
	      }
	    }, {
	      key: '_handleItemSelect',
	      value: function _handleItemSelect(index, v, e) {
	        var _props2 = this.props,
	            required = _props2.required,
	            menuItems = _props2.menuItems,
	            itemLabel = _props2.itemLabel,
	            itemValue = _props2.itemValue,
	            onChange = _props2.onChange,
	            position = _props2.position;
	
	        var number = typeof menuItems[index] === 'number' || typeof menuItems[index][itemValue] === 'number';
	        var value = number ? Number(v) : v;
	
	        var below = position === SelectField.Positions.BELOW;
	        if ((0, _getField2.default)(this.props, this.state, 'value') !== value && onChange) {
	          onChange(value, index, e);
	        }
	
	        var state = {
	          activeIndex: below ? 0 : index,
	          activeLabel: this._getActiveLabelFromItem(menuItems[index], value, itemLabel, itemValue),
	          error: required && !value
	        };
	
	        if (typeof this.props.value === 'undefined') {
	          state.value = value;
	        }
	
	        if (typeof this.props.isOpen === 'undefined' && e.type !== 'click') {
	          state.isOpen = false;
	        }
	
	        this.setState(state);
	      }
	    }, {
	      key: '_handleContainerClick',
	      value: function _handleContainerClick(e) {
	        if (this.props.onClick) {
	          this.props.onClick(e);
	        }
	
	        var target = e.target;
	
	        while (this._menu && this._menu.contains(target)) {
	          if (target.dataset.id) {
	            this._handleItemSelect(parseInt(target.dataset.id, 10), target.dataset.value, e);
	            return;
	          }
	
	          target = target.parentNode;
	        }
	      }
	    }, {
	      key: '_toggleOpen',
	      value: function _toggleOpen(e) {
	        var isOpen = !(0, _getField2.default)(this.props, this.state, 'isOpen');
	        if (this.props.onMenuToggle) {
	          this.props.onMenuToggle(isOpen, e);
	        }
	
	        if (typeof this.props.isOpen === 'undefined') {
	          this.setState({ isOpen: isOpen });
	        }
	      }
	    }, {
	      key: '_handleOpen',
	      value: function _handleOpen(e) {
	        if (this.props.onMenuToggle) {
	          this.props.onMenuToggle(true, e);
	        }
	
	        var state = void 0;
	        if (!(0, _getField2.default)(this.props, this.state, 'value') && this.state.activeIndex === -1) {
	          // When there is no value, need to change the default active index to 0 instead of -1
	          // so that the next DOWN arrow increments correctly
	          state = { activeIndex: 0 };
	        }
	
	        if (typeof this.props.isOpen === 'undefined') {
	          state = state || {};
	          state.isOpen = true;
	        }
	
	        if (state) {
	          this.setState(state);
	        }
	      }
	    }, {
	      key: '_handleClose',
	      value: function _handleClose(e) {
	        if (this.props.onMenuToggle) {
	          this.props.onMenuToggle(false, e);
	        }
	
	        var state = void 0;
	        if (this.props.position === SelectField.Positions.BELOW) {
	          // Set the active index back to 0 since the active item will be spliced out
	          // of the menu items
	          state = { activeIndex: 0 };
	        }
	
	        if (typeof this.props.isOpen === 'undefined') {
	          state = state || {};
	          state.isOpen = false;
	        }
	
	        if (state) {
	          this.setState(state);
	        }
	      }
	    }, {
	      key: '_mapToListItem',
	      value: function _mapToListItem(item, i) {
	        var _props3 = this.props,
	            id = _props3.id,
	            itemLabel = _props3.itemLabel,
	            itemValueKey = _props3.itemValue,
	            position = _props3.position;
	
	        var below = position === SelectField.Positions.BELOW;
	        var value = (0, _getField2.default)(this.props, this.state, 'value');
	
	        var primaryText = '';
	        var itemValue = '';
	        var props = void 0;
	        switch (typeof item === 'undefined' ? 'undefined' : _typeof(item)) {
	          case 'number':
	          case 'string':
	            primaryText = item;
	            itemValue = item;
	            break;
	          case 'object':
	            primaryText = item[itemLabel];
	            itemValue = typeof item[itemValueKey] !== 'undefined' ? item[itemValueKey] : item[itemLabel];
	            props = Object.keys(item).reduce(function (validProps, key) {
	              if (key !== itemLabel && key !== itemValueKey && key !== 'primaryText' && VALID_LIST_ITEM_PROPS.indexOf(key) !== -1) {
	                validProps[key] = item[key];
	              }
	
	              return validProps;
	            }, {});
	            break;
	          default:
	        }
	
	        var active = itemValue === value || itemValue === parseInt(value, 10);
	        if (below && active) {
	          return null;
	        }
	
	        return _react2.default.createElement(_ListItem2.default, _extends({}, props, {
	          ref: this._setMenuItem,
	          active: active,
	          tabIndex: -1,
	          primaryText: primaryText,
	          key: item.key || i,
	          role: 'option',
	          id: active ? id + 'Active' : null,
	          'data-id': i,
	          'data-value': itemValue,
	          tileStyle: below ? { paddingLeft: 24 } : undefined
	        }));
	      }
	    }, {
	      key: '_setMenuItem',
	      value: function _setMenuItem(item) {
	        if (!item) {
	          return;
	        }
	
	        if (item.props.active) {
	          this._activeItem = (0, _reactDom.findDOMNode)(item);
	          item.focus();
	        }
	
	        this._items.push(item);
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        var key = e.which || e.keyCode;
	        var isOpen = (0, _getField2.default)(this.props, this.state, 'isOpen');
	
	        if (key === _keyCodes.UP || key === _keyCodes.DOWN) {
	          e.preventDefault();
	        }
	
	        if (!isOpen && (key === _keyCodes.DOWN || key === _keyCodes.UP || key === _keyCodes.ENTER)) {
	          this._handleOpen(e);
	          return;
	        } else if (isOpen && (key === _keyCodes.ESC || key === _keyCodes.TAB)) {
	          if (this._field && key === _keyCodes.ESC) {
	            this._field.focus();
	          }
	
	          this._handleClose(e);
	          return;
	        }
	
	        switch (key) {
	          case _keyCodes.UP:
	          case _keyCodes.DOWN:
	            this._advanceFocus(key === _keyCodes.UP, e);
	            break;
	          case _keyCodes.ENTER:
	            if (this._field) {
	              this._field.focus();
	            }
	
	            this._handleContainerClick(e);
	            break;
	          default:
	            this._selectItemByLetter(e, key);
	        }
	      }
	    }, {
	      key: '_advanceFocus',
	      value: function _advanceFocus(decrement) {
	        var _props4 = this.props,
	            menuItems = _props4.menuItems,
	            position = _props4.position;
	        var activeIndex = this.state.activeIndex;
	
	
	        var below = position === SelectField.Positions.BELOW;
	
	        // If the select field is positioned below and there is no value, need to increment the last index
	        // by one since this select field removes the active item. Need to account for that here when there
	        // is no value.
	        var lastIndex = menuItems.length - (below && !(0, _getField2.default)(this.props, this.state, 'value') ? 0 : 1);
	        if (decrement && activeIndex <= 0 || !decrement && activeIndex >= lastIndex) {
	          return;
	        }
	
	        var nextIndex = Math.max(-1, Math.min(lastIndex, activeIndex + (decrement ? -1 : 1)));
	        if (nextIndex === activeIndex) {
	          return;
	        }
	
	        this._attemptItemFocus(nextIndex - (below ? 1 : 0));
	        if (below && decrement && nextIndex === 0) {
	          return;
	        }
	
	        this.setState({ activeIndex: nextIndex });
	      }
	    }, {
	      key: '_selectItemByLetter',
	      value: function _selectItemByLetter(e, key) {
	        var _this4 = this;
	
	        var charCode = String.fromCharCode(key);
	        var isLetter = charCode && charCode.match(/[A-Za-z0-9-_ ]/);
	        var isKeypad = (0, _isBetween2.default)(key, _keyCodes.KEYPAD_ZERO, _keyCodes.KEYPAD_NINE);
	        if (!(0, _isBetween2.default)(key, _keyCodes.ZERO, _keyCodes.NINE) && !isKeypad && !isLetter) {
	          return;
	        }
	
	        var letter = isLetter ? charCode : String(key - (isKeypad ? _keyCodes.KEYPAD_ZERO : _keyCodes.ZERO));
	
	        if (this._matchingTimeout) {
	          clearTimeout(this._matchingTimeout);
	        }
	
	        this._matchingTimeout = setTimeout(function () {
	          _this4._matchingTimeout = null;
	
	          _this4.setState({ match: null, lastSearch: null });
	        }, this.props.keyboardMatchingTimeout);
	
	        this._selectFirstMatch(letter, e);
	      }
	    }, {
	      key: '_selectFirstMatch',
	      value: function _selectFirstMatch(letter, e) {
	        var _props5 = this.props,
	            menuItems = _props5.menuItems,
	            itemLabel = _props5.itemLabel,
	            itemValue = _props5.itemValue;
	
	
	        var search = '' + (this.state.lastSearch || '') + letter;
	        var match = -1;
	        menuItems.some(function (item, i) {
	          var value = String((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item ? item[itemLabel] : item);
	          if (value && value.toUpperCase().indexOf(search) === 0) {
	            match = i;
	          }
	
	          return match > -1;
	        });
	
	        var activeItem = menuItems[match];
	
	        var state = {
	          match: match,
	          lastSearch: search
	        };
	
	        if (match === -1) {
	          this.setState(state);
	          return;
	        }
	
	        state.activeLabel = (typeof activeItem === 'undefined' ? 'undefined' : _typeof(activeItem)) === 'object' ? activeItem[itemLabel] : activeItem;
	        state.activeIndex = match;
	
	        if ((0, _getField2.default)(this.props, this.state, 'isOpen')) {
	          if (state.match !== this.state.match) {
	            this._attemptItemFocus(state.activeIndex);
	          }
	        } else {
	          var value = (typeof activeItem === 'undefined' ? 'undefined' : _typeof(activeItem)) === 'object' ? activeItem[itemValue] : activeItem;
	          state.error = !value;
	
	          if ((0, _getField2.default)(this.props, this.state, 'value') !== value && this.props.onChange) {
	            this.props.onChange(value, state.activeIndex, e);
	          }
	
	          if (typeof this.props.value === 'undefined') {
	            state.value = value;
	          }
	        }
	
	        this.setState(state);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            activeLabel = _state.activeLabel,
	            active = _state.active;
	
	        var _props6 = this.props,
	            id = _props6.id,
	            style = _props6.style,
	            className = _props6.className,
	            listStyle = _props6.listStyle,
	            listClassName = _props6.listClassName,
	            inputStyle = _props6.inputStyle,
	            inputClassName = _props6.inputClassName,
	            disabled = _props6.disabled,
	            menuItems = _props6.menuItems,
	            position = _props6.position,
	            stretchList = _props6.stretchList,
	            errorText = _props6.errorText,
	            helpText = _props6.helpText,
	            helpOnFocus = _props6.helpOnFocus,
	            required = _props6.required,
	            fullWidth = _props6.fullWidth,
	            props = _objectWithoutProperties(_props6, ['id', 'style', 'className', 'listStyle', 'listClassName', 'inputStyle', 'inputClassName', 'disabled', 'menuItems', 'position', 'stretchList', 'errorText', 'helpText', 'helpOnFocus', 'required', 'fullWidth']);
	
	        delete props.error;
	        delete props.itemLabel;
	        delete props.itemValue;
	        delete props.menuId;
	        delete props.listId;
	        delete props.defaultValue;
	        delete props.value;
	        delete props.isOpen;
	        delete props.defaultOpen;
	        delete props.keyboardMatchingTimeout;
	        delete props.onMenuToggle;
	
	        // delete deprecated
	        delete props.menuStyle;
	        delete props.menuClassName;
	        delete props.initiallyOpen;
	        delete props.floatingLabel;
	        delete props.noAutoAdjust;
	        delete props.adjustMinWidth;
	
	        var _props7 = this.props,
	            menuId = _props7.menuId,
	            listId = _props7.listId,
	            placeholder = _props7.placeholder,
	            label = _props7.label,
	            error = _props7.error;
	
	        error = error || this.state.error;
	        var value = (0, _getField2.default)(this.props, this.state, 'value');
	        var isOpen = (0, _getField2.default)(this.props, this.state, 'isOpen');
	        var below = position === SelectField.Positions.BELOW;
	
	        if (!menuId) {
	          menuId = id + 'Menu';
	        }
	
	        if (!listId) {
	          listId = id + 'Values';
	        }
	
	        if (required) {
	          if (label) {
	            label = (0, _addSuffix2.default)(label, '*');
	          }
	
	          if (placeholder && !label) {
	            placeholder = (0, _addSuffix2.default)(placeholder, '*');
	          }
	        }
	
	        var toggle = [_react2.default.createElement(_FloatingLabel2.default, {
	          key: 'floating-label',
	          label: label,
	          htmlFor: id,
	          active: active || isOpen,
	          error: error,
	          floating: !!activeLabel || active || isOpen,
	          disabled: disabled
	        }), _react2.default.createElement(_Field2.default, _extends({}, props, {
	          id: id,
	          ref: this._setField,
	          key: 'select-field',
	          style: inputStyle,
	          className: inputClassName,
	          activeLabel: activeLabel,
	          required: required,
	          disabled: disabled,
	          active: active || isOpen,
	          below: below,
	          value: value,
	          label: label,
	          error: error,
	          placeholder: placeholder,
	          onClick: this._toggleOpen,
	          onFocus: this._handleFocus,
	          onBlur: this._handleBlur
	        })), _react2.default.createElement(_TextFieldMessage2.default, {
	          key: 'message',
	          active: active || isOpen,
	          error: error,
	          errorText: errorText,
	          helpText: helpText,
	          helpOnFocus: helpOnFocus,
	          leftIcon: false,
	          rightIcon: false
	        })];
	
	        return _react2.default.createElement(
	          _Menu2.default,
	          {
	            id: menuId,
	            position: position,
	            isOpen: isOpen,
	            onClose: this._handleClose,
	            onClick: this._handleContainerClick,
	            onKeyDown: this._handleKeyDown,
	            toggle: toggle,
	            style: style,
	            className: (0, _classnames2.default)('md-select-field-menu', {
	              'md-select-field-menu--stretch': stretchList
	            }, className),
	            ref: this._setMenu,
	            fullWidth: fullWidth
	          },
	          _react2.default.createElement(
	            _List2.default,
	            {
	              id: listId,
	              role: 'listbox',
	              ref: this._positionList,
	              'aria-activedescendant': value ? id + 'Active' : null,
	              style: _extends({}, listStyle, this.state.listStyle),
	              className: listClassName
	            },
	            menuItems.map(this._mapToListItem).filter(function (item) {
	              return item !== null;
	            })
	          )
	        );
	      }
	    }]);
	
	    return SelectField;
	  }(_react.PureComponent);
	
	  SelectField.Positions = SelectFieldPositions;
	  SelectField.propTypes = {
	    /**
	     * An id to use for the select field. This is required for a11y. If the `menuId` and
	     * `listId` are not given, this will be used to create their ids for a11y.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * An optional name to give the select field's input.
	     */
	    name: _react.PropTypes.string,
	
	    /**
	     * An id to give the menu containing the select field. If this is omitted, the `id` prop
	     * will be used to make this id. `${id}Menu`.
	     */
	    menuId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An id to give the list that appears once the menu is open. If this is omitted, the `id` prop
	     * will be used to make this id. `${id}Values`.
	     */
	    listId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional style to apply to the select field's container. This is the `Menu` component.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional style to apply to the select field's container. This is the `Menu` component.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the select field's list of items that appear when opened.
	     */
	    listStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the select field's list of items that appear when opened.
	     */
	    listClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the select field itself.
	     */
	    inputStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the select field itself.
	     */
	    inputClassName: _react.PropTypes.string,
	
	    /**
	     * An optional value for the select field. This will require the `onChange` prop
	     * to be defined since it will be a controlled component.
	     */
	    value: (0, _controlled2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]), 'onChange'),
	
	    /**
	     * The default value for an uncontrolled select field.
	     */
	    defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
	
	    /**
	     * Boolean if the select field is open by default.
	     */
	    defaultOpen: _react.PropTypes.bool,
	
	    /**
	     * An optional boolean if the select field is currently open. This will make the component
	     * controlled and require the `onMenuToggle` prop to be defined.
	     */
	    isOpen: (0, _controlled2.default)(_react.PropTypes.bool, 'onMenuToggle', 'defaultOpen'),
	
	    /**
	     * An optional function to call when the menu's open state changes. The callback will include
	     * the next open state and the event that driggered it.
	     *
	     * ```js
	     * onMenuToggle(isOpen, event);
	     * ```
	     */
	    onMenuToggle: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the value for the select field changes. The callback will
	     * include the new value, the index of the menu item that was selected, and the event that
	     * triggered the change.
	     *
	     * ```js
	     * onChange(newValue, newActiveIndex, event);
	     * ```
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * A list of items to select from. This can be a mixed list of number, string,
	     * or object. If the item is an object, make sure the `itemLabel` and `itemValue`
	     * props match the keys in the object for the label and value.
	     */
	    menuItems: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.object])),
	
	    /**
	     * An optional floating label to display with the text field. This is invalid
	     * if the `position` is set to `SelectField.Positions.BELOW`.
	     */
	    label: _react.PropTypes.string,
	
	    /**
	     * An optional placeholder to display in the select field.
	     */
	    placeholder: _react.PropTypes.string,
	
	    /**
	     * Boolean if the select field is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * The key to use for extracting a menu item's label if the menu item is an object.
	     *
	     * Example:
	     *
	     * ```js
	     * const item = { something: 'My Label', somethingElse: 'value' };
	     * const itemLabel = 'something';
	     * const itemValue = 'somethingElse';
	     * ```
	     */
	    itemLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * The key to use for extracting a menu item'value label if the menu item is an object.
	     *
	     * Example:
	     *
	     * ```js
	     * const item = { something: 'My Label', somethingElse: 'value' };
	     * const itemLabel = 'something';
	     * const itemValue = 'somethingElse';
	     * ```
	     */
	    itemValue: _react.PropTypes.string.isRequired,
	
	    /**
	     * Any children used to display the select field's drop down icon.
	     */
	    iconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon class name to use to display the select field's drop down icon.
	     */
	    iconClassName: _react.PropTypes.string,
	
	    /*
	     * An optional function to call when the menu is clicked.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * The position that the select field's options should appear from. If the position is
	     * set to `BELOW`, the select field will be displayed as a button with ink instead of
	     * a text field.
	     */
	    position: _react.PropTypes.oneOf([SelectField.Positions.TOP_LEFT, SelectField.Positions.TOP_RIGHT, SelectField.Positions.BELOW]).isRequired,
	
	    /*
	     * The direction that the select field's focus indicator should grow from.
	     */
	    lineDirection: _react.PropTypes.oneOf(['left', 'center', 'right']).isRequired,
	
	    /**
	     * An optional function to call when the select field is focused.
	     */
	    onFocus: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the select field is blurred. This
	     * will also be triggered when a user selects a new item or keyboard navigates
	     * through the list items.
	     */
	    onBlur: _react.PropTypes.func,
	
	    /**
	     * The amount of time that a list of letters should be used when finding a menu item
	     * while typing. Since a user can select items by typing multiple letters in a row,
	     * this will be used as the timeout for clearing those letters.
	     *
	     * For example:
	     * - User types `g`
	     *
	     * Full match is now `'g'`.
	     *
	     * - User delays 200ms and types `u`
	     *
	     * Full match is now `'gu'`
	     *
	     * - User delays 1000ms and types `a`.
	     *
	     * Full match is now `'a'`
	     */
	    keyboardMatchingTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if the select field's list of menu items should stretch to at least
	     * be the width of the select field.
	     */
	    stretchList: _react.PropTypes.bool,
	
	    /**
	     * Boolean if there has been an error for the select field. This will display
	     * the `errorText`. And style the floating label and focus indicator with the
	     * error color.
	     */
	    error: _react.PropTypes.bool,
	
	    /**
	     * An optional error text to display when the `error` prop is true.
	     */
	    errorText: _react.PropTypes.node,
	
	    /**
	     * An optional help text to display below the select field.
	     */
	    helpText: _react.PropTypes.node,
	
	    /**
	     * Boolean if the help text should only be displayed when the select field
	     * has focus.
	     */
	    helpOnFocus: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the select field is required. This will updated the label or placeholder
	     * to include an asterisk.
	     */
	    required: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the select field is in a toolbar. This will automatically be injected if the select field
	     * is passed in as the `menuTitle` prop.
	     */
	    toolbar: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the menu surrounding the select field should be full width or not.
	     */
	    fullWidth: _react.PropTypes.bool,
	
	    menuStyle: (0, _deprecated2.default)(_react.PropTypes.object, 'Use `style` instead'),
	    menuClassName: (0, _deprecated2.default)(_react.PropTypes.string, 'Use `className` instead'),
	    initiallyOpen: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `defaultOpen` instead'),
	    floatingLabel: (0, _deprecated2.default)(_react.PropTypes.bool, 'A select field can only have floating labels now. Only provide the `label` prop'),
	    noAutoAdjust: (0, _deprecated2.default)(_react.PropTypes.bool, 'No longer valid to use since select fields are no longer text fields'),
	    adjustMinWidth: (0, _deprecated2.default)(_react.PropTypes.bool, 'No longer valid to use since select fields are no longer text fields')
	  };
	  SelectField.defaultProps = {
	    defaultValue: '',
	    itemLabel: 'label',
	    itemValue: 'value',
	    iconChildren: 'arrow_drop_down',
	    position: SelectField.Positions.TOP_LEFT,
	    lineDirection: 'left',
	    keyboardMatchingTimeout: 1000,
	    stretchList: true,
	    menuItems: []
	  };
	  exports.default = SelectField;
	});

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.addDate = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = addDate;
	
	  /**
	   * Adds a given amount to a date.
	   *
	   * @param {date} sourceDate the date to add
	   * @param {number} amt the amount to add
	   * @param {string} part the date part to add to. ['D', 'M', 'Y']
	   * @return a new Date with the part added or the date if the part is not valid.
	   */
	  function addDate(sourceDate, amt, part) {
	    var date = new Date(sourceDate);
	
	    switch (part) {
	      case 'D':
	        return new Date(date.setDate(date.getDate() + amt));
	      case 'M':
	        return new Date(date.setMonth(date.getMonth() + amt));
	      case 'Y':
	        return new Date(date.setFullYear(date.getFullYear() + amt));
	      default:
	        return date;
	    }
	  }
	});

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('../../constants/keyCodes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.keyCodes);
	    global.isValidClick = mod.exports;
	  }
	})(this, function (exports, _keyCodes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = isValidClick;
	
	
	  /**
	   * Checks if an event is a valid click event by ignoring
	   * any clisk that are not the left mouse button and not
	   * clicks that involve the shift key.
	   *
	   * @param {Object} e - the event to check
	   * @return {Boolean} true if the event is valid.
	   */
	  function isValidClick(e) {
	    return e.button === _keyCodes.LEFT_MOUSE && !e.shiftKey;
	  }
	});

/***/ },
/* 134 */
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(522);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(523);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(524);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(527);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(232);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(85);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(526);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },
/* 136 */
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 137 */
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(528);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(529);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(233);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(530);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(531);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(532);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(533);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(534);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(535);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(536);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(537);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(538);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(539);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(323);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(54);
	
	var ReactNoopUpdateQueue = __webpack_require__(143);
	
	var canDefineProperty = __webpack_require__(239);
	var emptyObject = __webpack_require__(44);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(54);
	
	var ReactCurrentOwner = __webpack_require__(28);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(4);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var api = "https://reactnd-books-api.udacity.com";
	
	// Generate a unique token for storing your bookshelf data on the backend server.
	var token = localStorage.token;
	if (!token) token = localStorage.token = Math.random().toString(36).substr(-8);
	
	var headers = {
	  'Accept': 'application/json',
	  'Authorization': token
	};
	
	var get = exports.get = function get(bookId) {
	  return fetch(api + '/books/' + bookId, { headers: headers }).then(function (res) {
	    return res.json();
	  }).then(function (data) {
	    return data.book;
	  });
	};
	
	var getAll = exports.getAll = function getAll() {
	  return fetch(api + '/books', { headers: headers }).then(function (res) {
	    return res.json();
	  }).then(function (data) {
	    return data.books;
	  });
	};
	
	var update = exports.update = function update(book, shelf) {
	  return fetch(api + '/books/' + book.id, {
	    method: 'PUT',
	    headers: Object.assign({}, headers, {
	      'Content-Type': 'application/json'
	    }),
	    body: JSON.stringify({ shelf: shelf })
	  }).then(function (res) {
	    return res.json();
	  });
	};
	
	var search = exports.search = function search(query, maxResults) {
	  return fetch(api + '/search', {
	    method: 'POST',
	    headers: Object.assign({}, headers, {
	      'Content-Type': 'application/json'
	    }),
	    body: JSON.stringify({ query: query, maxResults: maxResults })
	  }).then(function (res) {
	    return res.json();
	  }).then(function (data) {
	    return data.books;
	  });
	};

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ShelfChanger = __webpack_require__(249);
	
	var _ShelfChanger2 = _interopRequireDefault(_ShelfChanger);
	
	var _Cards = __webpack_require__(195);
	
	var _Media = __webpack_require__(203);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Shelves = function (_Component) {
	  _inherits(Shelves, _Component);
	
	  function Shelves() {
	    _classCallCheck(this, Shelves);
	
	    return _possibleConstructorReturn(this, (Shelves.__proto__ || Object.getPrototypeOf(Shelves)).apply(this, arguments));
	  }
	
	  _createClass(Shelves, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          books = _props.books,
	          transferShelf = _props.transferShelf,
	          addBook = _props.addBook,
	          clearQuery = _props.clearQuery;
	
	
	      if (books) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'md-grid' },
	          books.map(function (book) {
	            return _react2.default.createElement(
	              _Cards.Card,
	              { className: 'md-cell md-cell--6 md-cell--8-tablet', key: book.id },
	              _react2.default.createElement(
	                _Media2.default,
	                { aspectRatio: '1-1' },
	                _react2.default.createElement('img', { src: book.imageLinks.thumbnail, alt: book.title }),
	                _react2.default.createElement(
	                  _Media.MediaOverlay,
	                  null,
	                  _react2.default.createElement(_Cards.CardTitle, { title: book.title })
	                )
	              ),
	              _react2.default.createElement(_ShelfChanger2.default, {
	                book: book,
	                transferShelf: transferShelf,
	                addBook: addBook,
	                clearQuery: clearQuery,
	                shelf: book.shelf }),
	              _react2.default.createElement(
	                _Cards.CardText,
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  null,
	                  'Author(s):'
	                ),
	                book.authors.map(function (author) {
	                  return author ? _react2.default.createElement(
	                    'h3',
	                    { key: author },
	                    author
	                  ) : _react2.default.createElement(
	                    'h3',
	                    { key: author },
	                    'None'
	                  );
	                })
	              )
	            );
	          })
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            ' 0 found '
	          )
	        );
	      }
	    }
	  }]);
	
	  return Shelves;
	}(_react.Component);
	
	Shelves.propTypes = {
	  books: _propTypes2.default.array,
	  addBook: _propTypes2.default.func,
	  clearQuery: _propTypes2.default.func,
	  transferShelf: _propTypes2.default.func
	};
	exports.default = Shelves;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(264), __esModule: true };

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(257);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(256);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 148 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(271);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(56)
	  , document = __webpack_require__(29).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(31) && !__webpack_require__(41)(function(){
	  return Object.defineProperty(__webpack_require__(150)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(148);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(89)
	  , $export        = __webpack_require__(32)
	  , redefine       = __webpack_require__(158)
	  , hide           = __webpack_require__(42)
	  , has            = __webpack_require__(33)
	  , Iterators      = __webpack_require__(88)
	  , $iterCreate    = __webpack_require__(277)
	  , setToStringTag = __webpack_require__(92)
	  , getPrototypeOf = __webpack_require__(156)
	  , ITERATOR       = __webpack_require__(43)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(69)
	  , createDesc     = __webpack_require__(70)
	  , toIObject      = __webpack_require__(35)
	  , toPrimitive    = __webpack_require__(97)
	  , has            = __webpack_require__(33)
	  , IE8_DOM_DEFINE = __webpack_require__(151)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(31) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(157)
	  , hiddenKeys = __webpack_require__(87).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(33)
	  , toObject    = __webpack_require__(96)
	  , IE_PROTO    = __webpack_require__(93)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(33)
	  , toIObject    = __webpack_require__(35)
	  , arrayIndexOf = __webpack_require__(273)(false)
	  , IE_PROTO     = __webpack_require__(93)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(42);

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(17);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 160 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 161 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(45);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var splice = Array.prototype.splice;
	
	var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
	  getAllKeys(source).forEach(function(key) {
	    if (hasOwnProperty.call(source, key)) {
	      target[key] = source[key];
	    }
	  });
	  return target;
	};
	
	var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
	  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
	  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };
	
	/* istanbul ignore next */
	function copy(object) {
	  if (object instanceof Array) {
	    return assign(object.constructor(object.length), object)
	  } else if (object && typeof object === 'object') {
	    var prototype = object.constructor && object.constructor.prototype
	    return assign(Object.create(prototype || null), object);
	  } else {
	    return object;
	  }
	}
	
	function newContext() {
	  var commands = assign({}, defaultCommands);
	  update.extend = function(directive, fn) {
	    commands[directive] = fn;
	  };
	  update.isEquals = function(a, b) { return a === b; };
	
	  return update;
	
	  function update(object, spec) {
	    if (!(Array.isArray(object) && Array.isArray(spec))) {
	      invariant(
	        !Array.isArray(spec),
	        'update(): You provided an invalid spec to update(). The spec may ' +
	        'not contain an array except as the value of $set, $push, $unshift, ' +
	        '$splice or any custom command allowing an array value.'
	      );
	    }
	
	    invariant(
	      typeof spec === 'object' && spec !== null,
	      'update(): You provided an invalid spec to update(). The spec and ' +
	      'every included key path must be plain objects containing one of the ' +
	      'following commands: %s.',
	      Object.keys(commands).join(', ')
	    );
	
	    var nextObject = object;
	    var index, key;
	    getAllKeys(spec).forEach(function(key) {
	      if (hasOwnProperty.call(commands, key)) {
	        var objectWasNextObject = object === nextObject;
	        nextObject = commands[key](spec[key], nextObject, spec, object);
	        if (objectWasNextObject && update.isEquals(nextObject, object)) {
	          nextObject = object;
	        }
	      } else {
	        var nextValueForKey = update(object[key], spec[key]);
	        if (!update.isEquals(nextValueForKey, nextObject[key]) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
	          if (nextObject === object) {
	            nextObject = copy(object);
	          }
	          nextObject[key] = nextValueForKey;
	        }
	      }
	    })
	    return nextObject;
	  }
	
	}
	
	var defaultCommands = {
	  $push: function(value, nextObject, spec) {
	    invariantPushAndUnshift(nextObject, spec, '$push');
	    return value.length ? nextObject.concat(value) : nextObject;
	  },
	  $unshift: function(value, nextObject, spec) {
	    invariantPushAndUnshift(nextObject, spec, '$unshift');
	    return value.length ? value.concat(nextObject) : nextObject;
	  },
	  $splice: function(value, nextObject, spec, originalObject) {
	    invariantSplices(nextObject, spec);
	    value.forEach(function(args) {
	      invariantSplice(args);
	      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
	      splice.apply(nextObject, args);
	    });
	    return nextObject;
	  },
	  $set: function(value, nextObject, spec) {
	    invariantSet(spec);
	    return value;
	  },
	  $toggle: function(targets, nextObject) {
	    invariantToggle(targets, nextObject);
	    var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
	
	    targets.forEach(function(target) {
	      nextObjectCopy[target] = !nextObject[target];
	    });
	
	    return nextObjectCopy;
	  },
	  $unset: function(value, nextObject, spec, originalObject) {
	    invariant(
	      Array.isArray(value),
	      'update(): expected spec of $unset to be an array; got %s. ' +
	      'Did you forget to wrap the key(s) in an array?',
	      value
	    );
	    value.forEach(function(key) {
	      if (Object.hasOwnProperty.call(nextObject, key)) {
	        if (nextObject === originalObject) nextObject = copy(originalObject);
	        delete nextObject[key];
	      }
	    });
	    return nextObject;
	  },
	  $merge: function(value, nextObject, spec, originalObject) {
	    invariantMerge(nextObject, value);
	    getAllKeys(value).forEach(function(key) {
	      if (value[key] !== nextObject[key]) {
	        if (nextObject === originalObject) nextObject = copy(originalObject);
	        nextObject[key] = value[key];
	      }
	    });
	    return nextObject;
	  },
	  $apply: function(value, original) {
	    invariantApply(value);
	    return value(original);
	  }
	};
	
	module.exports = newContext();
	module.exports.newContext = newContext;
	
	// invariants
	
	function invariantPushAndUnshift(value, spec, command) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  );
	  var specValue = spec[command];
	  invariant(
	    Array.isArray(specValue),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    specValue
	  );
	}
	
	function invariantToggle(value) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected spec of $toggle to be an array; got %s. ' +
	    'Did you forget to wrap the key(s) in an array?',
	    value
	  );
	}
	
	function invariantSplices(value, spec) {
	  invariant(
	    Array.isArray(value),
	    'Expected $splice target to be an array; got %s',
	    value
	  );
	  invariantSplice(spec['$splice']);
	}
	
	function invariantSplice(value) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
	    'Did you forget to wrap your parameters in an array?',
	    value
	  );
	}
	
	function invariantApply(fn) {
	  invariant(
	    typeof fn === 'function',
	    'update(): expected spec of $apply to be a function; got %s.',
	    fn
	  );
	}
	
	function invariantSet(spec) {
	  invariant(
	    Object.keys(spec).length === 1,
	    'Cannot have more than one key in an object with $set'
	  );
	}
	
	function invariantMerge(target, specValue) {
	  invariant(
	    specValue && typeof specValue === 'object',
	    'update(): $merge expects a spec of type \'object\'; got %s',
	    specValue
	  );
	  invariant(
	    target && typeof target === 'object',
	    'update(): $merge expects a target of type \'object\'; got %s',
	    target
	  );
	}


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(242);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 165 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(238);

/***/ },
/* 167 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(37);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInstrumentation = __webpack_require__(20);
	
	var quoteAttributeValueForBrowser = __webpack_require__(389);
	var warning = __webpack_require__(4);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDefaultInjection = __webpack_require__(355);
	var ReactMount = __webpack_require__(177);
	var ReactReconciler = __webpack_require__(48);
	var ReactUpdates = __webpack_require__(21);
	var ReactVersion = __webpack_require__(368);
	
	var findDOMNode = __webpack_require__(384);
	var getHostComponentFromComposite = __webpack_require__(182);
	var renderSubtreeIntoContainer = __webpack_require__(390);
	var warning = __webpack_require__(4);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 171 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var LinkedValueUtils = __webpack_require__(110);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(21);
	
	var warning = __webpack_require__(4);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 173 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 174 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(350);
	
	var containsNode = __webpack_require__(309);
	var focusNode = __webpack_require__(160);
	var getActiveElement = __webpack_require__(161);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(46);
	var DOMProperty = __webpack_require__(47);
	var React = __webpack_require__(27);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactCurrentOwner = __webpack_require__(28);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMContainerInfo = __webpack_require__(344);
	var ReactDOMFeatureFlags = __webpack_require__(346);
	var ReactFeatureFlags = __webpack_require__(174);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactMarkupChecksum = __webpack_require__(360);
	var ReactReconciler = __webpack_require__(48);
	var ReactUpdateQueue = __webpack_require__(113);
	var ReactUpdates = __webpack_require__(21);
	
	var emptyObject = __webpack_require__(44);
	var instantiateReactComponent = __webpack_require__(185);
	var invariant = __webpack_require__(3);
	var setInnerHTML = __webpack_require__(79);
	var shouldUpdateReactComponent = __webpack_require__(119);
	var warning = __webpack_require__(4);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, { child: nextElement });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var React = __webpack_require__(27);
	
	var invariant = __webpack_require__(3);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 179 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 181 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(178);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var ReactCompositeComponent = __webpack_require__(342);
	var ReactEmptyComponent = __webpack_require__(173);
	var ReactHostComponent = __webpack_require__(175);
	
	var getNextDebugID = __webpack_require__(567);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + 'it\'s defined in.';
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 186 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	var escapeTextContentForBrowser = __webpack_require__(78);
	var setInnerHTML = __webpack_require__(79);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(28);
	var REACT_ELEMENT_TYPE = __webpack_require__(356);
	
	var getIteratorFn = __webpack_require__(387);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(109);
	var warning = __webpack_require__(4);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(39), __webpack_require__(18), __webpack_require__(84), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../utils/PropTypes/componentDeprecated'), require('../FontIcons/FontIcon'), require('../Tooltips/injectTooltip'), require('./Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.componentDeprecated, global.FontIcon, global.injectTooltip, global.Button);
	    global.IconButton = mod.exports;
	  }
	})(this, function (exports, _react, _componentDeprecated, _FontIcon, _injectTooltip, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var IconButton = function (_PureComponent) {
	    _inherits(IconButton, _PureComponent);
	
	    function IconButton() {
	      _classCallCheck(this, IconButton);
	
	      return _possibleConstructorReturn(this, (IconButton.__proto__ || Object.getPrototypeOf(IconButton)).apply(this, arguments));
	    }
	
	    _createClass(IconButton, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            iconClassName = _props.iconClassName,
	            children = _props.children,
	            tooltip = _props.tooltip,
	            floating = _props.floating,
	            props = _objectWithoutProperties(_props, ['iconClassName', 'children', 'tooltip', 'floating']);
	
	        delete props.tooltipLabel;
	        delete props.tooltipPosition;
	
	        return _react2.default.createElement(
	          _Button2.default,
	          _extends({}, props, { icon: !floating, floating: floating }),
	          tooltip,
	          _react2.default.createElement(
	            _FontIcon2.default,
	            { iconClassName: iconClassName },
	            children
	          )
	        );
	      }
	    }]);
	
	    return IconButton;
	  }(_react.PureComponent);
	
	  IconButton.propTypes = {
	    /**
	     * The className to use for rendering the `FontIcon`.
	     */
	    iconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children to use to render the `FontIcon`.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * An optional className to apply to the button.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The button type.
	     */
	    type: _react.PropTypes.string,
	
	    /**
	     * Boolean if the button is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional href to convert the button into a link button.
	     */
	    href: _react.PropTypes.string,
	
	    /**
	     * An optional function to call when the button is clicked.
	     */
	    onClick: _react.PropTypes.func,
	    /**
	     * Boolean if the IconButton is floating
	    floating: PropTypes.bool,
	     /**
	     * An optional label to use if you would like a tooltip to display
	     * on hover or touch hold.
	     */
	    tooltipLabel: _react.PropTypes.string,
	
	    /**
	     * The position that the tooltip should be displayed relative to
	     * the button.
	     */
	    tooltipPosition: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * An optional amount of delay before the tooltip appears.
	     */
	    tooltipDelay: _react.PropTypes.number,
	
	    // Inject from injectTooltip
	    tooltip: _react.PropTypes.node,
	    floating: _react.PropTypes.bool,
	
	    deprecated: (0, _componentDeprecated2.default)('The behavior of the `IconButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` compnent and add a ' + 'prop `icon`.')
	  };
	  IconButton.defaultProps = {
	    type: 'button'
	  };
	  exports.default = (0, _injectTooltip2.default)(IconButton);
	});

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(8), __webpack_require__(191)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/deprecated'), require('./CardExpander'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.deprecated, global.CardExpander);
	    global.CardActions = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _deprecated, _CardExpander) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _CardExpander2 = _interopRequireDefault(_CardExpander);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardActions = function (_Component) {
	    _inherits(CardActions, _Component);
	
	    function CardActions() {
	      _classCallCheck(this, CardActions);
	
	      return _possibleConstructorReturn(this, (CardActions.__proto__ || Object.getPrototypeOf(CardActions)).apply(this, arguments));
	    }
	
	    _createClass(CardActions, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            children = _props.children,
	            isExpander = _props.isExpander,
	            expander = _props.expander,
	            centered = _props.centered,
	            stacked = _props.stacked,
	            props = _objectWithoutProperties(_props, ['className', 'children', 'isExpander', 'expander', 'centered', 'stacked']);
	
	        return _react2.default.createElement(
	          'section',
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-dialog-footer--card', {
	              'md-dialog-footer--inline': !stacked,
	              'md-dialog-footer--stacked': stacked,
	              'md-dialog-footer--centered': centered
	            }, className)
	          }),
	          children,
	          isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
	        );
	      }
	    }]);
	
	    return CardActions;
	  }(_react.Component);
	
	  CardActions.propTypes = {
	    /**
	     * Boolean if this component should act as an expander and inject the
	     * `CardExpander`.
	     */
	    expander: _react.PropTypes.bool,
	
	    /**
	     * An optional className to apply to the actions container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An actions to display.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the actions should be centered.
	     */
	    centered: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the actions should be stacked.
	     */
	    stacked: _react.PropTypes.bool,
	
	    isExpander: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `expander` instead')
	  };
	  exports.default = CardActions;
	});

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(194), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./contextTypes'), require('../Buttons/Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.contextTypes, global.Button);
	    global.CardExpander = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _contextTypes, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardExpander = function (_Component) {
	    _inherits(CardExpander, _Component);
	
	    function CardExpander() {
	      _classCallCheck(this, CardExpander);
	
	      return _possibleConstructorReturn(this, (CardExpander.__proto__ || Object.getPrototypeOf(CardExpander)).apply(this, arguments));
	    }
	
	    _createClass(CardExpander, [{
	      key: 'render',
	      value: function render() {
	        var _context = this.context,
	            expanded = _context.expanded,
	            onExpandClick = _context.onExpandClick,
	            iconClassName = _context.iconClassName,
	            iconChildren = _context.iconChildren,
	            tooltipPosition = _context.tooltipPosition,
	            tooltipLabel = _context.tooltipLabel,
	            tooltipDelay = _context.tooltipDelay;
	
	
	        return _react2.default.createElement(
	          _Button2.default,
	          {
	            icon: true,
	            className: (0, _classnames2.default)('md-collapser md-collapser--card', {
	              'md-collapser--flipped': expanded
	            }),
	            onClick: onExpandClick,
	            iconClassName: iconClassName,
	            tooltipLabel: tooltipLabel,
	            tooltipDelay: tooltipDelay,
	            tooltipPosition: tooltipPosition
	          },
	          iconChildren
	        );
	      }
	    }]);
	
	    return CardExpander;
	  }(_react.Component);
	
	  CardExpander.contextTypes = _contextTypes2.default;
	  exports.default = CardExpander;
	});

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(8), __webpack_require__(193), __webpack_require__(191)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/deprecated'), require('./CardTitleBlock'), require('./CardExpander'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.deprecated, global.CardTitleBlock, global.CardExpander);
	    global.CardTitle = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _deprecated, _CardTitleBlock, _CardExpander) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);
	
	  var _CardExpander2 = _interopRequireDefault(_CardExpander);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardTitle = function (_Component) {
	    _inherits(CardTitle, _Component);
	
	    function CardTitle() {
	      _classCallCheck(this, CardTitle);
	
	      return _possibleConstructorReturn(this, (CardTitle.__proto__ || Object.getPrototypeOf(CardTitle)).apply(this, arguments));
	    }
	
	    _createClass(CardTitle, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            id = _props.id,
	            style = _props.style,
	            className = _props.className,
	            title = _props.title,
	            subtitle = _props.subtitle,
	            expander = _props.expander,
	            isExpander = _props.isExpander,
	            children = _props.children,
	            props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'title', 'subtitle', 'expander', 'isExpander', 'children']);
	
	        delete props.avatar;
	        var avatar = this.props.avatar;
	
	        if (avatar) {
	          var avatarClassName = _react.Children.only(avatar).props.className;
	
	          avatar = (0, _react.cloneElement)(avatar, {
	            className: (0, _classnames2.default)('md-avatar--card', avatarClassName)
	          });
	        }
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, {
	            style: style,
	            className: (0, _classnames2.default)('md-card-title', {
	              'md-card-title--primary': !avatar
	            }, className)
	          }),
	          avatar,
	          _react2.default.createElement(_CardTitleBlock2.default, { id: id, title: title, subtitle: subtitle, avatar: !!avatar }),
	          children,
	          isExpander || expander && _react2.default.createElement(_CardExpander2.default, null)
	        );
	      }
	    }]);
	
	    return CardTitle;
	  }(_react.Component);
	
	  CardTitle.propTypes = {
	    /**
	     * An optional id to add to the `title`.
	     */
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The title to display.
	     */
	    title: _react.PropTypes.node.isRequired,
	
	    /**
	     * An optional subtitle to display.
	     */
	    subtitle: _react.PropTypes.node,
	
	    /**
	     * Any additional children to display in the title block
	     * after the avatar, title, and subtitle.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * An optional avatar to display before the title and subtitle.
	     */
	    avatar: _react.PropTypes.element,
	
	    /**
	     * Boolean if the `CardTitle` component should inject a button
	     * for expanding all children below it.
	     */
	    expander: _react.PropTypes.bool,
	
	    isExpander: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `expander` instead')
	  };
	  exports.default = CardTitle;
	});

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.CardTitleBlock = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardTitleBlock = function (_PureComponent) {
	    _inherits(CardTitleBlock, _PureComponent);
	
	    function CardTitleBlock() {
	      _classCallCheck(this, CardTitleBlock);
	
	      return _possibleConstructorReturn(this, (CardTitleBlock.__proto__ || Object.getPrototypeOf(CardTitleBlock)).apply(this, arguments));
	    }
	
	    _createClass(CardTitleBlock, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            id = _props.id,
	            subtitle = _props.subtitle,
	            avatar = _props.avatar;
	        var title = this.props.title;
	
	        title = _react2.default.createElement(
	          'h2',
	          {
	            id: id,
	            className: (0, _classnames2.default)('md-card-title--title md-text', {
	              'md-card-title--large': !avatar
	            })
	          },
	          title
	        );
	
	        if (!subtitle) {
	          return title;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'md-card-title--title-block' },
	          title,
	          _react2.default.createElement(
	            'h3',
	            { className: 'md-card-title--title md-text--secondary' },
	            subtitle
	          )
	        );
	      }
	    }]);
	
	    return CardTitleBlock;
	  }(_react.PureComponent);
	
	  CardTitleBlock.propTypes = {
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    title: _react.PropTypes.node.isRequired,
	    subtitle: _react.PropTypes.node,
	    avatar: _react.PropTypes.bool
	  };
	  exports.default = CardTitleBlock;
	});

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react);
	    global.contextTypes = mod.exports;
	  }
	})(this, function (exports, _react) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = {
	    onExpandClick: _react.PropTypes.func,
	    expanded: _react.PropTypes.bool,
	    iconClassName: _react.PropTypes.string,
	    iconChildren: _react.PropTypes.string,
	    tooltipPosition: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	    tooltipLabel: _react.PropTypes.string,
	    tooltipDelay: _react.PropTypes.number
	  };
	});

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(406), __webpack_require__(192), __webpack_require__(408), __webpack_require__(190), __webpack_require__(409), __webpack_require__(407)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Card'), require('./CardTitle'), require('./CardMedia'), require('./CardActions'), require('./CardText'), require('./CardActionOverlay'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Card, global.CardTitle, global.CardMedia, global.CardActions, global.CardText, global.CardActionOverlay);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Card2, _CardTitle2, _CardMedia2, _CardActions2, _CardText2, _CardActionOverlay2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.CardActionOverlay = exports.CardText = exports.CardActions = exports.CardMedia = exports.CardTitle = exports.Card = undefined;
	
	  var _Card3 = _interopRequireDefault(_Card2);
	
	  var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	  var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	  var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	  var _CardText3 = _interopRequireDefault(_CardText2);
	
	  var _CardActionOverlay3 = _interopRequireDefault(_CardActionOverlay2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Card3.default;
	  exports.Card = _Card3.default;
	  exports.CardTitle = _CardTitle3.default;
	  exports.CardMedia = _CardMedia3.default;
	  exports.CardActions = _CardActions3.default;
	  exports.CardText = _CardText3.default;
	  exports.CardActionOverlay = _CardActionOverlay3.default;
	});

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.DrawerTypes = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = {
	    // Permanent drawers
	    FULL_HEIGHT: 'full-height',
	    CLIPPED: 'clipped',
	    FLOATING: 'floating',
	
	    // Persistent drawers
	    PERSISTENT: 'persistent',
	    PERSISTENT_MINI: 'persistent-mini',
	
	    // Temporary
	    TEMPORARY: 'temporary',
	    TEMPORARY_MINI: 'temporary-mini'
	  };
	});

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(196)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./DrawerTypes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.DrawerTypes);
	    global.isType = mod.exports;
	  }
	})(this, function (exports, _DrawerTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.isTemporary = isTemporary;
	  exports.isPersistent = isPersistent;
	  exports.isPermanent = isPermanent;
	  exports.isMini = isMini;
	
	  var _DrawerTypes2 = _interopRequireDefault(_DrawerTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var FULL_HEIGHT = _DrawerTypes2.default.FULL_HEIGHT,
	      CLIPPED = _DrawerTypes2.default.CLIPPED,
	      FLOATING = _DrawerTypes2.default.FLOATING,
	      PERSISTENT = _DrawerTypes2.default.PERSISTENT,
	      PERSISTENT_MINI = _DrawerTypes2.default.PERSISTENT_MINI,
	      TEMPORARY = _DrawerTypes2.default.TEMPORARY,
	      TEMPORARY_MINI = _DrawerTypes2.default.TEMPORARY_MINI;
	  function isTemporary(type) {
	    return [TEMPORARY, TEMPORARY_MINI].indexOf(type) !== -1;
	  }
	
	  function isPersistent(type) {
	    return [PERSISTENT, PERSISTENT_MINI].indexOf(type) !== -1;
	  }
	
	  function isPermanent(type) {
	    return [FULL_HEIGHT, CLIPPED, FLOATING].indexOf(type) !== -1;
	  }
	
	  function isMini(type) {
	    return [PERSISTENT_MINI, TEMPORARY_MINI].indexOf(type) !== -1;
	  }
	});

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(13), __webpack_require__(11), __webpack_require__(67), __webpack_require__(18), __webpack_require__(49), __webpack_require__(22)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../utils/EventUtils/captureNextEvent'), require('../FontIcons/FontIcon'), require('../Helpers/IconSeparator'), require('../Helpers/AccessibleFakeInkedButton'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.isRequiredForA11y, global.keyCodes, global.captureNextEvent, global.FontIcon, global.IconSeparator, global.AccessibleFakeInkedButton);
	    global.FileInput = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _isRequiredForA11y, _keyCodes, _captureNextEvent, _FontIcon, _IconSeparator, _AccessibleFakeInkedButton) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var FileInput = function (_PureComponent) {
	    _inherits(FileInput, _PureComponent);
	
	    function FileInput(props) {
	      _classCallCheck(this, FileInput);
	
	      var _this = _possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).call(this, props));
	
	      _this.state = { hover: false, pressed: false };
	
	      _this._blur = _this._blur.bind(_this);
	      _this._handleChange = _this._handleChange.bind(_this);
	      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._handleMouseUp = _this._handleMouseUp.bind(_this);
	      _this._handleMouseDown = _this._handleMouseDown.bind(_this);
	      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      return _this;
	    }
	
	    _createClass(FileInput, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.disabled && !nextProps.disabled && this.state.hover) {
	          this.setState({ hover: false });
	        }
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        var _this2 = this;
	
	        // I honestly don't remember why this was implemented, but it was copied from the Button
	        // component
	        if (!this.state.pressed && nextState.pressed) {
	          this._timeout = setTimeout(function () {
	            _this2._timeout = null;
	            if (_this2._attemptedBlur) {
	              _this2._attemptedBlur = false;
	
	              _this2.setState({ pressed: false });
	            }
	          }, 450);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        window.removeEventListener('click', this._blur);
	      }
	    }, {
	      key: '_handleChange',
	      value: function _handleChange(e) {
	        var _props = this.props,
	            multiple = _props.multiple,
	            onChange = _props.onChange;
	        var files = e.target.files;
	
	        if (!multiple) {
	          onChange(files[0] || null, e);
	        } else {
	          onChange(Array.prototype.slice.call(files), e);
	        }
	      }
	    }, {
	      key: '_blur',
	      value: function _blur() {
	        if (this.props.disabled) {
	          return;
	        }
	
	        if (this._timeout) {
	          this._attemptedBlur = true;
	        } else {
	          this.setState({ pressed: false });
	        }
	      }
	    }, {
	      key: '_handleMouseUp',
	      value: function _handleMouseUp(e) {
	        if (this.props.onMouseUp) {
	          this.props.onMouseUp(e);
	        }
	
	        this._blur();
	      }
	    }, {
	      key: '_handleMouseDown',
	      value: function _handleMouseDown(e) {
	        if (this.props.onMouseDown) {
	          this.props.onMouseDown(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ pressed: true });
	        }
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        if (this.props.onTouchStart) {
	          this.props.onTouchStart(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ pressed: true });
	        }
	      }
	    }, {
	      key: '_handleTouchEnd',
	      value: function _handleTouchEnd(e) {
	        if (this.props.onTouchEnd) {
	          this.props.onTouchEnd(e);
	        }
	
	        this._blur();
	        (0, _captureNextEvent2.default)('mouseover');
	      }
	    }, {
	      key: '_handleKeyUp',
	      value: function _handleKeyUp(e) {
	        if (this.props.onKeyUp) {
	          this.props.onKeyUp(e);
	        }
	
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          window.addEventListener('click', this._blur);
	          this.setState({ pressed: true });
	        }
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        if (this.props.onKeyDown) {
	          this.props.onKeyDown(e);
	        }
	
	        var key = e.which || e.keyCode;
	
	        if (key === _keyCodes.TAB) {
	          window.removeEventListener('click', this._blur);
	          this.setState({ pressed: false });
	        } else if (key === _keyCodes.SPACE || key === _keyCodes.ENTER) {
	          e.preventDefault();
	          e.target.click();
	        }
	      }
	    }, {
	      key: '_handleMouseOver',
	      value: function _handleMouseOver(e) {
	        if (this.props.onMouseOver) {
	          this.props.onMouseOver(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ hover: true });
	        }
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave(e) {
	        if (this.props.onMouseLeave) {
	          this.props.onMouseLeave(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ hover: false });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            hover = _state.hover,
	            pressed = _state.pressed;
	
	        var _props2 = this.props,
	            style = _props2.style,
	            className = _props2.className,
	            label = _props2.label,
	            iconChildren = _props2.iconChildren,
	            iconClassName = _props2.iconClassName,
	            primary = _props2.primary,
	            secondary = _props2.secondary,
	            flat = _props2.flat,
	            id = _props2.id,
	            iconBefore = _props2.iconBefore,
	            disabled = _props2.disabled,
	            accept = _props2.accept,
	            multiple = _props2.multiple,
	            props = _objectWithoutProperties(_props2, ['style', 'className', 'label', 'iconChildren', 'iconClassName', 'primary', 'secondary', 'flat', 'id', 'iconBefore', 'disabled', 'accept', 'multiple']);
	
	        delete props.onChange;
	        delete props.onKeyUp;
	        delete props.onKeyDown;
	        delete props.onMouseUp;
	        delete props.onMouseDown;
	        delete props.onMouseOver;
	        delete props.onMouseLeave;
	        delete props.onTouchStart;
	        delete props.onTouchEnd;
	
	        var icon = !iconClassName && !iconChildren ? null : _react2.default.createElement(
	          _FontIcon2.default,
	          { iconClassName: iconClassName },
	          iconChildren
	        );
	
	        var themeClassNames = !disabled && (0, _classnames2.default)({
	          'md-text--theme-primary md-ink--primary': flat && primary,
	          'md-text--theme-secondary md-ink--secondary': flat && secondary,
	          'md-background--primary md-background--primary-hover': !flat && primary,
	          'md-background--secondary md-background--secondary-hover': !flat && secondary,
	          'md-btn--color-primary-active': flat && hover && primary,
	          'md-btn--color-secondary-active': flat && hover && secondary
	        });
	
	        var labelChildren = label;
	        if (icon) {
	          labelChildren = _react2.default.createElement(
	            _IconSeparator2.default,
	            { label: label, iconBefore: iconBefore },
	            icon
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, {
	            style: style,
	            className: (0, _classnames2.default)('md-inline-block md-file-input-container', className)
	          }),
	          _react2.default.createElement(
	            _AccessibleFakeInkedButton2.default,
	            {
	              component: 'label',
	              htmlFor: id,
	              disabled: disabled,
	              onTouchStart: this._handleTouchStart,
	              onTouchEnd: this._handleTouchEnd,
	              onMouseDown: this._handleMouseDown,
	              onMouseUp: this._handleMouseUp,
	              onKeyDown: this._handleKeyDown,
	              onKeyUp: this._handleKeyUp,
	              onMouseOver: this._handleMouseOver,
	              onMouseLeave: this._handleMouseLeave,
	              className: (0, _classnames2.default)('md-btn md-btn--' + (flat || disabled ? 'flat' : 'raised') + ' md-btn--text', themeClassNames, {
	                'md-text': !disabled,
	                'md-text--disabled': disabled,
	                'md-btn--raised-disabled': disabled && !flat,
	                'md-btn--raised-pressed': !disabled && !flat && pressed
	              })
	            },
	            labelChildren
	          ),
	          _react2.default.createElement('input', {
	            multiple: multiple,
	            disabled: disabled,
	            id: id,
	            accept: accept,
	            type: 'file',
	            'aria-hidden': 'true',
	            className: 'md-file-input',
	            onChange: this._handleChange
	          })
	        );
	      }
	    }]);
	
	    return FileInput;
	  }(_react.PureComponent);
	
	  FileInput.propTypes = {
	    /**
	     * The id for the text field. This is required for a11y and to get the `input type="file"` to
	     * open.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])),
	
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Boolean if the `FileInput` should be styled with the primary color.
	     */
	    primary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `FileInput` should be styled with the secondary color.
	     */
	    secondary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `FileInput` should be styled as a flat button instead of a
	     * raised button.
	     */
	    flat: _react.PropTypes.bool,
	
	    /**
	     * This should be a comma separated list of Media Types that the `FileInput` can
	     * accept. If this prop is left blank, any file will be accepted.
	     *
	     * The values can either be:
	     * - A file extension
	     * - audio/*
	     * - video/*
	     * - image/*
	     * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
	     *
	     * > NOTE: IE does not enforce this.
	     */
	    accept: _react.PropTypes.string,
	
	    /**
	     * Boolean if multiple files will be accepted.
	     */
	    multiple: _react.PropTypes.bool,
	
	    /**
	     * A label to display on the `FileInput`. This will be used with the `AccessibleFakeInkedButton` component to
	     * create a `<label>` for the `<input type="file">`.
	     */
	    label: _react.PropTypes.node.isRequired,
	
	    /**
	     * Boolean if the icons hould appear before the label.
	     */
	    iconBefore: _react.PropTypes.bool,
	
	    /**
	     * The icon children to use for the upload icon.
	     */
	    iconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className to use for the upload icon.
	     */
	    iconClassName: _react.PropTypes.string,
	
	    /**
	     * A function to call when the value of the input changes. This will
	     * be triggered when the user selects a new file or cancels the new file selection.
	     *
	     * This function will be given the new [FileList](https://developer.mozilla.org/en-US/docs/Web/API/FileList)
	     * as an array and the change event. If this is not a multiple file input, only the
	     * newly selected File will be given instead of a list of one file. Since this is an
	     * `input` tag, the user will not be able to select the same file multiple times unless
	     * you manually clear the input's value.
	     *
	     * > NOTE: If the user hits cancel, null will be given for a single file input.
	     *
	     * ```js
	     * onChange(files, e);
	     * ```
	     */
	    onChange: _react.PropTypes.func.isRequired,
	
	    /**
	     * Boolean if the `FileInput` is currently disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional function to call when they keyup event is triggerred on the file input's label.
	     */
	    onKeyUp: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when they keydown event is triggerred on the file input's label.
	     */
	    onKeyDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when they mouseup event is triggerred on the file input's label.
	     */
	    onMouseUp: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when they mousedown event is triggerred on the file input's label.
	     */
	    onMouseDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when they mouseover event is triggerred on the file input's label.
	     */
	    onMouseOver: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when they mouseleave event is triggerred on the file input's label.
	     */
	    onMouseLeave: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when they touchend event is triggerred on the file input's label.
	     */
	    onTouchEnd: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when they touchstart event is triggerred on the file input's label.
	     */
	    onTouchStart: _react.PropTypes.func
	  };
	  FileInput.defaultProps = {
	    label: 'Select a file',
	    iconChildren: 'file_upload'
	  };
	  exports.default = FileInput;
	});

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(45), __webpack_require__(224)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('invariant'), require('../utils/EventUtils/isValidFocusKeypress'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.invariant, global.isValidFocusKeypress);
	    global.FocusContainer = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _invariant, _isValidFocusKeypress) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _invariant2 = _interopRequireDefault(_invariant);
	
	  var _isValidFocusKeypress2 = _interopRequireDefault(_isValidFocusKeypress);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _toArray(arr) {
	    return Array.isArray(arr) ? arr : Array.from(arr);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var hrefables = ['a', 'area'].map(function (tag) {
	    return tag + '[href],';
	  }).join('');
	  var disableables = ['button', 'input', 'textarea', 'select'].map(function (tag) {
	    return tag + ':not([disabled]),';
	  }).join('');
	  var FOCUSABLE_QUERY = '' + hrefables + disableables + '*[tabIndex]';
	
	  /**
	   * This component is used for keeping the focus within some container. When the container
	   * is mounted and the `focusOnMount` prop is `true`, it will attempt to focus either:
	   * - an element that matches `document.getElementById(this.props.initialFocus)`
	   * - an element that matches `this._container.querySelector(this.props.initialFocus)`
	   * - the first focusable element in it's children (if `this.props.initialFocus` is omitted)
	   */
	
	  var FocusContainer = function (_PureComponent) {
	    _inherits(FocusContainer, _PureComponent);
	
	    function FocusContainer(props) {
	      _classCallCheck(this, FocusContainer);
	
	      var _this = _possibleConstructorReturn(this, (FocusContainer.__proto__ || Object.getPrototypeOf(FocusContainer)).call(this, props));
	
	      _this.state = {};
	      _this._containFocus = _this._containFocus.bind(_this);
	      _this._handleFocus = _this._handleFocus.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._enableFocusTrap = _this._enableFocusTrap.bind(_this);
	      _this._disableFocusTrap = _this._disableFocusTrap.bind(_this);
	      _this._attemptInitialFocus = _this._attemptInitialFocus.bind(_this);
	      return _this;
	    }
	
	    _createClass(FocusContainer, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.containFocus === nextProps.containFocus) {
	          return;
	        }
	
	        if (this.props.containFocus) {
	          this._enableFocusTrap();
	          this._attemptInitialFocus();
	        } else {
	          this._disableFocusTrap();
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        if (this._container) {
	          this._focusables = Array.prototype.slice.call(this._container.querySelectorAll(FOCUSABLE_QUERY)).filter(function (el) {
	            return el.tabIndex !== -1;
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._container) {
	          this._disableFocusTrap();
	        }
	      }
	    }, {
	      key: '_enableFocusTrap',
	      value: function _enableFocusTrap() {
	        window.addEventListener('focus', this._handleFocus, true);
	        window.addEventListener('keydown', this._handleKeyDown, true);
	      }
	    }, {
	      key: '_disableFocusTrap',
	      value: function _disableFocusTrap() {
	        window.removeEventListener('focus', this._handleFocus, true);
	        window.removeEventListener('keydown', this._handleKeyDown, true);
	      }
	    }, {
	      key: '_attemptInitialFocus',
	      value: function _attemptInitialFocus() {
	        if (!this._container) {
	          return;
	        }
	
	        var initialFocus = this.props.initialFocus;
	
	
	        var toFocus = initialFocus ? document.getElementById(initialFocus) || this._container.querySelector(initialFocus) : this._focusables[0];
	
	        var debugError = void 0;
	        if (!toFocus && initialFocus) {
	          debugError = ' The `initialFocus` did not match a document\'s `id` or was an invalid ';
	          debugError += '`querySelector` for the container. `initialFocus`: `' + initialFocus + '`. ';
	          debugError += 'If this was supposed to be an `id`, make sure to prefix with the `#` symbol.';
	        }
	
	        (0, _invariant2.default)(toFocus, 'You specified that the `FocusContainer` should focus an element on mount, ' + 'but a focusable element was not found in the children. This could be because ' + 'the `initialFocus` prop is an invalid id or query selector, or the children ' + ('do not contain a valid focusable element.' + debugError));
	
	        if (toFocus) {
	          toFocus.focus();
	        }
	      }
	    }, {
	      key: '_containFocus',
	      value: function _containFocus(containerRef) {
	        if (containerRef === null) {
	          this._container = null;
	          this._disableFocusTrap();
	          return;
	        }
	
	        var focusOnMount = this.props.focusOnMount;
	
	        this._container = (0, _reactDom.findDOMNode)(containerRef);
	        this._focusables = Array.prototype.slice.call(this._container.querySelectorAll(FOCUSABLE_QUERY)).filter(function (el) {
	          return el.tabIndex !== -1;
	        });
	
	        if (focusOnMount) {
	          this._attemptInitialFocus();
	        }
	
	        this._enableFocusTrap();
	      }
	    }, {
	      key: '_handleFocus',
	      value: function _handleFocus(e) {
	        if (e.target !== window && this._shifted && this._container && !this._container.contains(e.target)) {
	          // Prevent the default focus action and focus the last focusable item
	          e.stopPropagation();
	          this._focusables[this._focusables.length - 1].focus();
	        }
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        this._shifted = e.shiftKey;
	        if (!(0, _isValidFocusKeypress2.default)(e, this.props.additionalFocusKeys)) {
	          return;
	        }
	
	        var target = e.target,
	            shiftKey = e.shiftKey;
	
	        var _focusables = _toArray(this._focusables),
	            first = _focusables[0],
	            focusables = _focusables.slice(1);
	
	        var last = focusables[focusables.length - 1];
	
	        if (shiftKey && target === first) {
	          e.preventDefault();
	          last.focus();
	        } else if (!shiftKey && target === last) {
	          e.preventDefault();
	          first.focus();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            Component = _props.component,
	            props = _objectWithoutProperties(_props, ['component']);
	
	        delete props.initialFocus;
	        delete props.focusOnMount;
	        delete props.containFocus;
	        delete props.additionalFocusKeys;
	
	        return _react2.default.createElement(Component, _extends({}, props, { ref: this._containFocus }));
	      }
	    }]);
	
	    return FocusContainer;
	  }(_react.PureComponent);
	
	  FocusContainer.propTypes = {
	    /**
	     * The component to render as. This can be a React DOM element or
	     * a react Component.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired,
	
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The children to display.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * An optional id string or a query selector string to use for the initial focus.
	     * This will only be triggered if the `focusOnMount` prop is `true`. If this is
	     * omitted and the `focusOnMount` prop is `true`, the first focusable element in the
	     * container will be focused.
	     *
	     * Examples:
	     *
	     * ```js
	     * initialFocus="#someAmazingId"
	     * // or
	     * initialFocus=".md-btn,.md-list-tile"
	     * ```
	     */
	    initialFocus: _react.PropTypes.string,
	
	    /**
	     * Boolean if an element in the container should be focused when mounted.
	     */
	    focusOnMount: _react.PropTypes.bool,
	
	    /**
	     * An optional list of additional key codes to use for focus events.
	     */
	    additionalFocusKeys: _react.PropTypes.arrayOf(_react.PropTypes.number),
	
	    /**
	     * Boolean if the focus container should start or stop containing the focus within the container.
	     * This is useful for changing the focus requirements after mount.
	     */
	    containFocus: _react.PropTypes.bool
	  };
	  FocusContainer.defaultProps = {
	    component: 'div'
	  };
	  exports.default = FocusContainer;
	});

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.ListItemText = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var ListItemText = function (_PureComponent) {
	    _inherits(ListItemText, _PureComponent);
	
	    function ListItemText() {
	      _classCallCheck(this, ListItemText);
	
	      return _possibleConstructorReturn(this, (ListItemText.__proto__ || Object.getPrototypeOf(ListItemText)).apply(this, arguments));
	    }
	
	    _createClass(ListItemText, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            active = _props.active,
	            activeClassName = _props.activeClassName,
	            disabled = _props.disabled,
	            primaryText = _props.primaryText,
	            secondaryText = _props.secondaryText,
	            className = _props.className,
	            threeLines = _props.threeLines,
	            props = _objectWithoutProperties(_props, ['active', 'activeClassName', 'disabled', 'primaryText', 'secondaryText', 'className', 'threeLines']);
	
	        var secondaryTextNode = void 0;
	        if (secondaryText) {
	          secondaryTextNode = _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)('md-tile-text--secondary', {
	                'md-text--disabled': disabled,
	                'md-text--secondary': !disabled,
	                'md-tile-text--three-lines': threeLines
	              })
	            },
	            secondaryText
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, { className: (0, _classnames2.default)('md-tile-content', className) }),
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _classnames2.default)('md-tile-text--primary', _defineProperty({
	                'md-text--disabled': disabled,
	                'md-text': !disabled && !active
	              }, activeClassName, !disabled && active))
	            },
	            primaryText
	          ),
	          secondaryTextNode
	        );
	      }
	    }]);
	
	    return ListItemText;
	  }(_react.PureComponent);
	
	  ListItemText.propTypes = {
	    active: _react.PropTypes.bool,
	    activeClassName: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    primaryText: _react.PropTypes.node.isRequired,
	    secondaryText: _react.PropTypes.node,
	    className: _react.PropTypes.string,
	    threeLines: _react.PropTypes.bool
	  };
	  exports.default = ListItemText;
	});

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.Media = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  function validateAspectRatio(props, propName, component) {
	    var _PropTypes$string;
	
	    var value = props[propName];
	
	    for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	      args[_key - 3] = arguments[_key];
	    }
	
	    var err = (_PropTypes$string = _react.PropTypes.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(args));
	    if (!err && value.split('-').length !== 2) {
	      err = new Error('Your provided an `' + propName + '` prop to the ' + component + ' that is not a valid ' + ('aspect ratio `' + value + '`. This should be in the form of \'{width}-{height}\'.'));
	    }
	
	    return err;
	  }
	
	  /**
	   * The `Media` component is used to display images, iframes, ...media. Who'da thunk?
	   */
	
	  var Media = function (_PureComponent) {
	    _inherits(Media, _PureComponent);
	
	    function Media() {
	      _classCallCheck(this, Media);
	
	      return _possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).apply(this, arguments));
	    }
	
	    _createClass(Media, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            Component = _props.component,
	            className = _props.className,
	            children = _props.children,
	            forceAspect = _props.forceAspect,
	            aspectRatio = _props.aspectRatio,
	            props = _objectWithoutProperties(_props, ['component', 'className', 'children', 'forceAspect', 'aspectRatio']);
	
	        delete props.expandable;
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-media', _defineProperty({}, 'md-media--' + aspectRatio, forceAspect), className)
	          }),
	          children
	        );
	      }
	    }]);
	
	    return Media;
	  }(_react.PureComponent);
	
	  Media.propTypes = {
	    /**
	     * An optional className to apply to the card media component.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Any media to display.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the aspect ratio should be forced.
	     */
	    forceAspect: _react.PropTypes.bool,
	
	    /**
	     * The aspect ratio to use.
	     */
	    aspectRatio: validateAspectRatio,
	
	    /**
	     * Boolean if this component should be expandable when there is a `CardExpander`
	     * above it in the `Card`.
	     */
	    expandable: _react.PropTypes.bool,
	
	    /**
	     * The component to render the card media as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired
	  };
	  Media.defaultProps = {
	    forceAspect: true,
	    aspectRatio: '16-9',
	    component: 'section'
	  };
	  exports.default = Media;
	});

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.MediaOverlay = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var MediaOverlay = function (_PureComponent) {
	    _inherits(MediaOverlay, _PureComponent);
	
	    function MediaOverlay() {
	      _classCallCheck(this, MediaOverlay);
	
	      return _possibleConstructorReturn(this, (MediaOverlay.__proto__ || Object.getPrototypeOf(MediaOverlay)).apply(this, arguments));
	    }
	
	    _createClass(MediaOverlay, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            Component = _props.component,
	            props = _objectWithoutProperties(_props, ['className', 'component']);
	
	        return _react2.default.createElement(Component, _extends({ className: (0, _classnames2.default)('md-media-overlay', className) }, props));
	      }
	    }]);
	
	    return MediaOverlay;
	  }(_react.PureComponent);
	
	  MediaOverlay.propTypes = {
	    /**
	     * An optional style to apply to the overlay.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the overlay.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Any children to display in the overlay. This is _normally_ a `CardTitle` component
	     * or some buttons.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * The component to be rendered as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired
	  };
	  MediaOverlay.defaultProps = {
	    component: 'div'
	  };
	  exports.default = MediaOverlay;
	});

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(201), __webpack_require__(202)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Media'), require('./MediaOverlay'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Media, global.MediaOverlay);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Media, _MediaOverlay2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.MediaOverlay = exports.Media = undefined;
	
	  var _Media2 = _interopRequireDefault(_Media);
	
	  var _MediaOverlay3 = _interopRequireDefault(_MediaOverlay2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Media2.default;
	  exports.Media = _Media2.default;
	  exports.MediaOverlay = _MediaOverlay3.default;
	});

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(83)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('./Positions'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.Positions);
	    global.contextTypes = mod.exports;
	  }
	})(this, function (exports, _react, _Positions) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Positions2 = _interopRequireDefault(_Positions);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = {
	    menuCascading: _react.PropTypes.bool,
	    menuPosition: _react.PropTypes.oneOf([_Positions2.default.TOP_LEFT, _Positions2.default.TOP_RIGHT, _Positions2.default.BOTTOM_LEFT, _Positions2.default.BOTTOM_RIGHT, _Positions2.default.CONTEXT, _Positions2.default.BELOW]),
	    listLevel: _react.PropTypes.number
	  };
	});

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../Buttons/Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.Button);
	    global.CloseButton = mod.exports;
	  }
	})(this, function (exports, _react, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CloseButton = function (_PureComponent) {
	    _inherits(CloseButton, _PureComponent);
	
	    function CloseButton(props) {
	      _classCallCheck(this, CloseButton);
	
	      var _this = _possibleConstructorReturn(this, (CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call(this, props));
	
	      _this._handleClick = _this._handleClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(CloseButton, [{
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        if (this.props.onClick) {
	          this.props.onClick(e);
	        }
	
	        if (this.context.onCloseClick) {
	          this.context.onCloseClick(e);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _context = this.context,
	            iconClassName = _context.closeIconClassName,
	            children = _context.closeChildren;
	
	
	        return _react2.default.createElement(
	          _Button2.default,
	          _extends({}, this.props, {
	            icon: true,
	            key: 'close',
	            iconClassName: iconClassName,
	            onClick: this._handleClick
	          }),
	          children
	        );
	      }
	    }]);
	
	    return CloseButton;
	  }(_react.PureComponent);
	
	  CloseButton.propTypes = {
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional additional function to call when the `click` event is triggered.
	     */
	    onClick: _react.PropTypes.func
	  };
	  CloseButton.contextTypes = {
	    closeIconClassName: _react.PropTypes.string,
	    closeChildren: _react.PropTypes.node,
	    onCloseClick: _react.PropTypes.func
	  };
	  exports.default = CloseButton;
	});

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.JumpToContentLink = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var JumpToContentLink = function (_PureComponent) {
	    _inherits(JumpToContentLink, _PureComponent);
	
	    function JumpToContentLink(props) {
	      _classCallCheck(this, JumpToContentLink);
	
	      var _this = _possibleConstructorReturn(this, (JumpToContentLink.__proto__ || Object.getPrototypeOf(JumpToContentLink)).call(this, props));
	
	      _this._handleClick = _this._handleClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(JumpToContentLink, [{
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        if (this.props.onClick) {
	          this.props.onClick(e);
	        }
	
	        document.getElementById(this.context.id).focus();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            props = _objectWithoutProperties(_props, ['className']);
	
	        var _context = this.context,
	            id = _context.id,
	            label = _context.label;
	
	        return _react2.default.createElement(
	          'a',
	          _extends({}, props, {
	            id: 'skipTo' + id,
	            href: '#' + id,
	            onClick: this._handleClick,
	            className: (0, _classnames2.default)('md-content-jump', className)
	          }),
	          label
	        );
	      }
	    }]);
	
	    return JumpToContentLink;
	  }(_react.PureComponent);
	
	  JumpToContentLink.propTypes = {
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional function to call when the linked is clicked.
	     */
	    onClick: _react.PropTypes.func
	  };
	  JumpToContentLink.contextTypes = {
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
	    label: _react.PropTypes.string.isRequired
	  };
	  exports.default = JumpToContentLink;
	});

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(446), __webpack_require__(205), __webpack_require__(206)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./NavigationDrawer'), require('./CloseButton'), require('./JumpToContentLink'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.NavigationDrawer, global.CloseButton, global.JumpToContentLink);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _NavigationDrawer, _CloseButton2, _JumpToContentLink2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = undefined;
	
	  var _NavigationDrawer2 = _interopRequireDefault(_NavigationDrawer);
	
	  var _CloseButton3 = _interopRequireDefault(_CloseButton2);
	
	  var _JumpToContentLink3 = _interopRequireDefault(_JumpToContentLink2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _NavigationDrawer2.default;
	  exports.NavigationDrawer = _NavigationDrawer2.default;
	  exports.CloseButton = _CloseButton3.default;
	  exports.JumpToContentLink = _JumpToContentLink3.default;
	});

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(12), __webpack_require__(14), __webpack_require__(51)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('./SelectionControl'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.getField, global.controlled, global.SelectionControl);
	    global.SelectionControlGroup = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _getField, _controlled, _SelectionControl) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  /**
	   * A custom PropTypes validator to make sure that each `control` in the `controls` prop
	   * contains the given `propName`, or the `SelectionControlGroup` has defined that prop.
	   */
	  function requiredByAllControls(validator) {
	    return function validate(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      var err = validator.apply(undefined, [props, propName, component].concat(others));
	
	      if (!err && typeof props[propName] === 'undefined') {
	        var invalids = props.controls.filter(function (c) {
	          return !c[propName];
	        }).map(function (_, i) {
	          return i;
	        });
	        if (invalids.length) {
	          var invalidPrefix = invalids.length === props.controls.length ? 'All `controls`' : 'The `controls` at indexes `' + invalids.join('`, `') + '`';
	          var invalidMsg = invalidPrefix + ' are missing the `' + propName + '` prop.';
	
	          err = new Error('The `' + propName + '` prop is required to make `' + component + '` accessible for users of ' + ('assistive technologies such as screen readers. Either add the `' + propName + '` to the `' + component + '` ') + ('or add the `' + propName + '` to each `control` in the `controls` prop. ' + invalidMsg));
	        }
	      }
	
	      return err;
	    };
	  }
	
	  /**
	   * The `SelectionControlGroup` component is used to simplify the generation of a list
	   * of `SelectionControl`. Any common props are extracted to this component and passed
	   * to the `SelectionControl`.
	   */
	
	  var SelectionControlGroup = function (_PureComponent) {
	    _inherits(SelectionControlGroup, _PureComponent);
	
	    function SelectionControlGroup(props) {
	      _classCallCheck(this, SelectionControlGroup);
	
	      var _this = _possibleConstructorReturn(this, (SelectionControlGroup.__proto__ || Object.getPrototypeOf(SelectionControlGroup)).call(this, props));
	
	      _this.state = {};
	      if (typeof props.value === 'undefined') {
	        _this.state.value = props.defaultValue;
	
	        if (typeof props.defaultValue === 'undefined') {
	          _this.state.value = props.type === 'radio' ? props.controls[0].value : '';
	        }
	      }
	      _this._handleChange = _this._handleChange.bind(_this);
	      return _this;
	    }
	
	    _createClass(SelectionControlGroup, [{
	      key: '_isChecked',
	      value: function _isChecked(value, controlValue, type) {
	        return type === 'radio' ? value === controlValue : value.split(',').indexOf(controlValue) !== -1;
	      }
	    }, {
	      key: '_handleChange',
	      value: function _handleChange(e) {
	        var value = e.target.value;
	        if (this.props.type === 'checkbox') {
	          var checked = e.target.checked;
	
	
	          var values = (0, _getField2.default)(this.props, this.state, 'value').split(',');
	          var index = values.indexOf(value);
	          if (checked) {
	            values.push(value);
	          } else {
	            values.splice(index, 1);
	          }
	
	          value = values.join(',');
	        }
	
	        if (this.props.onChange) {
	          this.props.onChange(value, e);
	        }
	
	        if (typeof this.props.value === 'undefined') {
	          this.setState({ value: value });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            id = _props.id,
	            name = _props.name,
	            type = _props.type,
	            label = _props.label,
	            labelClassName = _props.labelClassName,
	            className = _props.className,
	            controlStyle = _props.controlStyle,
	            controlClassName = _props.controlClassName,
	            Component = _props.component,
	            LabelComponent = _props.labelComponent,
	            inline = _props.inline,
	            disabled = _props.disabled,
	            props = _objectWithoutProperties(_props, ['id', 'name', 'type', 'label', 'labelClassName', 'className', 'controlStyle', 'controlClassName', 'component', 'labelComponent', 'inline', 'disabled']);
	
	        delete props.value;
	        delete props.controls;
	        delete props.defaultValue;
	
	        var value = (0, _getField2.default)(this.props, this.state, 'value');
	
	        var controls = this.props.controls.map(function (control, i) {
	          var controlProps = Object.assign({
	            id: '' + id + i,
	            key: 'control' + i,
	            name: '' + name + (type === 'checkbox' ? '[]' : ''),
	            type: type,
	            inline: inline,
	            disabled: disabled,
	            checked: _this2._isChecked(value, control.value, type)
	          }, control, {
	            style: Object.assign({}, control.style, controlStyle),
	            className: (0, _classnames2.default)(controlClassName, control.className)
	          });
	
	          return _react2.default.createElement(_SelectionControl2.default, controlProps);
	        });
	
	        var ariaLabel = void 0;
	        if (label) {
	          ariaLabel = _react2.default.createElement(
	            LabelComponent,
	            { className: labelClassName },
	            label
	          );
	        }
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-selection-control-group', className),
	            onChange: this._handleChange
	          }),
	          ariaLabel,
	          controls
	        );
	      }
	    }]);
	
	    return SelectionControlGroup;
	  }(_react.PureComponent);
	
	  SelectionControlGroup.propTypes = {
	    /**
	     * An optional style to apply to the container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to every `SelectionControl`. This will be merged with any `style`
	     * that a `control` might have.
	     */
	    controlStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to every `SelectionControl`. This will be merged with any
	     * `className` that a `control` might have.
	     */
	    controlClassName: _react.PropTypes.string,
	
	    /**
	     * An optional base id to apply to each `SelectionControl`. When this is included, the id for
	     * each control will start with this and end with their current index. If this is ommitted,
	     * each `control` in the `controls` prop *must* have an `id` prop. This is required for
	     * accessibility.
	     */
	    id: requiredByAllControls(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * The type to apply to each `SelectionControl` in the group. Only `checkbox` and `radio` is
	     * valid for a grouping.
	     */
	    type: _react.PropTypes.oneOf(['checkbox', 'radio']).isRequired,
	
	    /**
	     * The component to render the `SelectionControlGroup` in.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired,
	
	    /**
	     * An optional label to display above the group of `SelectionControl`s.
	     */
	    label: _react.PropTypes.node,
	
	    /**
	     * An optional className to apply to the node surrounding the `label` prop.
	     */
	    labelClassName: _react.PropTypes.string,
	
	    /**
	     * The component to render the optional `label` in.
	     */
	    labelComponent: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired,
	
	    /**
	     * An optional function to call when any `SelectionControl`'s `checked` state is changed
	     * in the group. If the `type` of the group is `radio`, the `value` of the `checked` radio
	     * will be given in the callback. If the `type` of the group is `checkbox`, a comma-delimited
	     * string of all `checked` checkboxes values will be given.
	     *
	     * ```js
	     * // checkbox
	     * onChange('Alpha,Omega', changeEvent);
	     *
	     * // radio
	     * onChange('Omega', changeEvent);
	     * ```
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * A name to use for each `SelectionControl` in the group. If the `type` of the group is
	     * `checkbox`, the name will be updated to be an array name so that using
	     * `document.querySelector('input[name="yourName[]"].value` will give the comma-delimited
	     * string of checked checkboxes.
	     *
	     * It is either required to have this prop set or every `control` in the `controls` prop to
	     * have the `name` prop.
	     */
	    name: requiredByAllControls(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * The default value for the `SelectionControlGroup`. This can either be a single value
	     * or a comma-delimited string of checkbox values. When the `type` of the group is `radio`
	     * and the group is uncontrolled, it is recommened to set this prop. Otherwise the first
	     * value of the `controls` prop will be used as the defalt value.
	     */
	    defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional value to use for the `SelectionControlGroup`. This will make the component
	     * controlled and require the `onChange` prop to be defined. Like the `defaultValue`, this
	     * can either be a single value or a comma-delimited list of checkbox values.
	     */
	    value: (0, _controlled2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]), 'onChange'),
	
	    /**
	     * A list of objects to create the `SelectControl` components. The shape of the object
	     * is the `propTypes` of the `SelectionControl` component, except that `value` prop is
	     * now required.
	     *
	     * The `SelectionControl` will inherit any inheritable props from the `SelectionControlGroup`.
	     */
	    controls: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      key: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	      label: _react.PropTypes.node.isRequired,
	      value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired
	    })).isRequired,
	
	    /**
	     * Boolean if the `SelectionControl` should be displayed inline.
	     */
	    inline: _react.PropTypes.bool,
	
	    /**
	     * Boolean if all the selection controls in the group are disabled.
	     */
	    disabled: _react.PropTypes.bool
	  };
	  SelectionControlGroup.defaultProps = {
	    component: 'fieldset',
	    labelComponent: 'legend',
	    labelClassName: 'md-subheading-1'
	  };
	  exports.default = SelectionControlGroup;
	});

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.isInvalidAnimate = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = isInvalidAnimate;
	  var gcc = 'getComposedComponent';
	
	  /**
	   * Just checks if the fab is actually a ref to the FAB Button.
	   */
	  function isInvalidAnimate(fab) {
	    return typeof fab[gcc] !== 'function' || typeof fab[gcc]()[gcc] !== 'function' || typeof fab[gcc]()[gcc]()._animateForSnackbar !== 'function';
	  }
	});

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.Subheader = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Subheader = function (_PureComponent) {
	    _inherits(Subheader, _PureComponent);
	
	    function Subheader() {
	      _classCallCheck(this, Subheader);
	
	      return _possibleConstructorReturn(this, (Subheader.__proto__ || Object.getPrototypeOf(Subheader)).apply(this, arguments));
	    }
	
	    _createClass(Subheader, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            Component = _props.component,
	            inset = _props.inset,
	            primary = _props.primary,
	            primaryText = _props.primaryText,
	            className = _props.className,
	            children = _props.children,
	            props = _objectWithoutProperties(_props, ['component', 'inset', 'primary', 'primaryText', 'className', 'children']);
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-subheader', {
	              'md-text--secondary': !primary,
	              'md-text--theme-primary': primary,
	              'md-list-item--inset': inset
	            }, className)
	          }),
	          primaryText,
	          children
	        );
	      }
	    }]);
	
	    return Subheader;
	  }(_react.PureComponent);
	
	  Subheader.propTypes = {
	    /**
	     * An optional style to apply to the subheader.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the subheader.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Boolean if the subheader should be styled with the primary color.
	     */
	    primary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the subheader is inset in the list. This will add additional
	     * spacing to align the subheader.
	     */
	    inset: _react.PropTypes.bool,
	
	    /**
	     * The primary text to use in the subheader.
	     */
	    primaryText: _react.PropTypes.node.isRequired,
	
	    /**
	     * Any optional children to display after the `primaryText`. This prop is
	     * unrecommended.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * The component to render the Subheader as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired
	  };
	  Subheader.defaultProps = {
	    component: 'li'
	  };
	  exports.default = Subheader;
	});

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(210)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Subheader'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Subheader);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Subheader) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Subheader2 = _interopRequireDefault(_Subheader);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Subheader2.default;
	});

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(13), __webpack_require__(66), __webpack_require__(22), __webpack_require__(231)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../Menus/Menu'), require('../Helpers/AccessibleFakeInkedButton'), require('../utils/mapToListParts'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.isRequiredForA11y, global.Menu, global.AccessibleFakeInkedButton, global.mapToListParts);
	    global.MenuTab = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _isRequiredForA11y, _Menu, _AccessibleFakeInkedButton, _mapToListParts) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _Menu2 = _interopRequireDefault(_Menu);
	
	  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	  var _mapToListParts2 = _interopRequireDefault(_mapToListParts);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var MenuTab = function (_PureComponent) {
	    _inherits(MenuTab, _PureComponent);
	
	    function MenuTab(props) {
	      _classCallCheck(this, MenuTab);
	
	      var _this = _possibleConstructorReturn(this, (MenuTab.__proto__ || Object.getPrototypeOf(MenuTab)).call(this, props));
	
	      _this.state = { isOpen: false };
	      _this._toggleOpen = _this._toggleOpen.bind(_this);
	      _this._handleClose = _this._handleClose.bind(_this);
	      return _this;
	    }
	
	    _createClass(MenuTab, [{
	      key: '_toggleOpen',
	      value: function _toggleOpen(e) {
	        if (this.props.onClick) {
	          this.props.onClick(e);
	        }
	
	        this.setState({ isOpen: !this.state.isOpen });
	      }
	    }, {
	      key: '_handleClose',
	      value: function _handleClose() {
	        this.setState({ isOpen: false });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            id = _props.id,
	            style = _props.style,
	            className = _props.className,
	            tabStyle = _props.tabStyle,
	            tabClassName = _props.tabClassName,
	            tabs = _props.tabs,
	            label = _props.label,
	            activeTabIndex = _props.activeTabIndex,
	            overflowAtIndex = _props.overflowAtIndex,
	            props = _objectWithoutProperties(_props, ['id', 'style', 'className', 'tabStyle', 'tabClassName', 'tabs', 'label', 'activeTabIndex', 'overflowAtIndex']);
	
	        var active = activeTabIndex >= overflowAtIndex;
	
	        var tab = _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          _extends({}, props, {
	            onClick: this._toggleOpen,
	            style: tabStyle,
	            className: (0, _classnames2.default)('md-tab md-tab--menu', tabClassName)
	          }),
	          label
	        );
	
	        return _react2.default.createElement(
	          _Menu2.default,
	          {
	            id: id,
	            style: style,
	            className: (0, _classnames2.default)('md-menu--tab', {
	              'md-tab--active': active,
	              'md-tab--inactive': !active
	            }, className),
	            toggle: tab,
	            isOpen: this.state.isOpen,
	            onClose: this._handleClose
	          },
	          tabs.map(_mapToListParts2.default)
	        );
	      }
	    }]);
	
	    return MenuTab;
	  }(_react.PureComponent);
	
	  MenuTab.propTypes = {
	    /**
	     * An id to give the tab's menu.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * The current active tab index. This is used to determine which list item
	     * is active in the menu, and if the styles for an active tab should be applied
	     * to the menu.
	     */
	    activeTabIndex: _react.PropTypes.number.isRequired,
	
	    /**
	     * An tab index that caused the overflow to happen.
	     */
	    overflowAtIndex: _react.PropTypes.number.isRequired,
	
	    /**
	     * A list of tabs that should be rendered in the menu once opened. This can either
	     * be:
	     *
	     * - a `ListItem`, `Divider`, or `Subheader` component
	     * - a string to use as the `primaryText` for a list item
	     * - an object that defines props to generate a `ListItem`, `Divider`, or `Subheader` component
	     */
	    tabs: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.shape({
	      divider: _react.PropTypes.bool,
	      subheader: _react.PropTypes.bool,
	      primaryText: _react.PropTypes.string
	    })])).isRequired,
	
	    /**
	     * An optional style to apply to the menu.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the menu.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the tab in the menu.
	     */
	    tabStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the tab in the menu.
	     */
	    tabClassName: _react.PropTypes.string,
	
	    /**
	     * An optional function to call when the tab is clicked.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * The label to display in the tab. This should normally be some text with
	     * a drop down arrow next to it.
	     */
	    label: _react.PropTypes.node.isRequired
	  };
	  exports.default = MenuTab;
	});

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.isRequiredForA11y);
	    global.TabPanel = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _isRequiredForA11y) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TabPanel = function (_PureComponent) {
	    _inherits(TabPanel, _PureComponent);
	
	    function TabPanel() {
	      _classCallCheck(this, TabPanel);
	
	      return _possibleConstructorReturn(this, (TabPanel.__proto__ || Object.getPrototypeOf(TabPanel)).apply(this, arguments));
	    }
	
	    _createClass(TabPanel, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            Component = _props.component,
	            id = _props.id,
	            active = _props.active,
	            className = _props.className,
	            controlledById = _props.controlledById,
	            children = _props.children,
	            props = _objectWithoutProperties(_props, ['component', 'id', 'active', 'className', 'controlledById', 'children']);
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            id: id,
	            className: (0, _classnames2.default)('md-tab-panel', className),
	            role: 'tabpanel',
	            'aria-hidden': !active,
	            'aria-labelledby': controlledById
	          }),
	          children
	        );
	      }
	    }]);
	
	    return TabPanel;
	  }(_react.PureComponent);
	
	  TabPanel.propTypes = {
	    /**
	     * An id for the panel. This is used for a11y. This should equal the `controlsId`
	     * of whichever tab's children will be placed in here.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * An id for the tab that owns this panel. This should equal the `id` of whichever
	     * tab's children will be placed in here.
	     */
	    controlledById: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The component to render the panel as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * Boolean if the panel is currently active. This is used to generated the `aria-hidden`
	     * attribute.
	     */
	    active: _react.PropTypes.bool,
	
	    /**
	     * Any children to display.
	     */
	    children: _react.PropTypes.node
	  };
	  TabPanel.defaultProps = {
	    component: 'div'
	  };
	  exports.default = TabPanel;
	});

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.FloatingLabel = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var FloatingLabel = function (_PureComponent) {
	    _inherits(FloatingLabel, _PureComponent);
	
	    function FloatingLabel() {
	      _classCallCheck(this, FloatingLabel);
	
	      return _possibleConstructorReturn(this, (FloatingLabel.__proto__ || Object.getPrototypeOf(FloatingLabel)).apply(this, arguments));
	    }
	
	    _createClass(FloatingLabel, [{
	      key: 'render',
	      value: function render() {
	        var _cn;
	
	        var _props = this.props,
	            label = _props.label,
	            htmlFor = _props.htmlFor,
	            className = _props.className,
	            floating = _props.floating,
	            active = _props.active,
	            error = _props.error,
	            disabled = _props.disabled,
	            iconOffset = _props.iconOffset,
	            customSize = _props.customSize,
	            props = _objectWithoutProperties(_props, ['label', 'htmlFor', 'className', 'floating', 'active', 'error', 'disabled', 'iconOffset', 'customSize']);
	
	        if (!label) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'label',
	          _extends({}, props, {
	            htmlFor: htmlFor,
	            className: (0, _classnames2.default)('md-floating-label', (_cn = {
	              'md-floating-label--active': !error && active,
	              'md-floating-label--error': !disabled && error,
	              'md-floating-label--inactive': !floating,
	              'md-floating-label--inactive-sized': !floating && !customSize
	            }, _defineProperty(_cn, 'md-floating-label--' + customSize, customSize), _defineProperty(_cn, 'md-floating-label--inactive-' + customSize, customSize && !floating), _defineProperty(_cn, 'md-floating-label--floating', floating), _defineProperty(_cn, 'md-floating-label--disabled', disabled), _defineProperty(_cn, 'md-floating-label--icon-offset', iconOffset), _cn), className)
	          }),
	          label
	        );
	      }
	    }]);
	
	    return FloatingLabel;
	  }(_react.PureComponent);
	
	  FloatingLabel.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    label: _react.PropTypes.string,
	    floating: _react.PropTypes.bool,
	    error: _react.PropTypes.bool,
	    active: _react.PropTypes.bool,
	    disabled: _react.PropTypes.bool,
	    iconOffset: _react.PropTypes.bool,
	    customSize: _react.PropTypes.string,
	    htmlFor: _react.PropTypes.string
	  };
	  exports.default = FloatingLabel;
	});

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Dividers/Divider'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.Divider);
	    global.TextFieldDivider = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _Divider) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _Divider2 = _interopRequireDefault(_Divider);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TextFieldDivider = function (_PureComponent) {
	    _inherits(TextFieldDivider, _PureComponent);
	
	    function TextFieldDivider() {
	      _classCallCheck(this, TextFieldDivider);
	
	      return _possibleConstructorReturn(this, (TextFieldDivider.__proto__ || Object.getPrototypeOf(TextFieldDivider)).apply(this, arguments));
	    }
	
	    _createClass(TextFieldDivider, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            active = _props.active,
	            error = _props.error,
	            lineDirection = _props.lineDirection,
	            className = _props.className,
	            props = _objectWithoutProperties(_props, ['active', 'error', 'lineDirection', 'className']);
	
	        return _react2.default.createElement(_Divider2.default, _extends({}, props, {
	          className: (0, _classnames2.default)('md-divider--text-field md-divider--expand-from-' + lineDirection, {
	            'md-divider--text-field-expanded': active,
	            'md-divider--text-field-active': !error && active,
	            'md-divider--text-field-error': error
	          }, className)
	        }));
	      }
	    }]);
	
	    return TextFieldDivider;
	  }(_react.PureComponent);
	
	  TextFieldDivider.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    active: _react.PropTypes.bool,
	    error: _react.PropTypes.bool,
	    lineDirection: _react.PropTypes.oneOf(['left', 'center', 'right'])
	  };
	  exports.default = TextFieldDivider;
	});

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(497)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./Message'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.Message);
	    global.TextFieldMessage = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _Message) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _Message2 = _interopRequireDefault(_Message);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TextFieldMessage = function (_PureComponent) {
	    _inherits(TextFieldMessage, _PureComponent);
	
	    function TextFieldMessage(props) {
	      _classCallCheck(this, TextFieldMessage);
	
	      var _this = _possibleConstructorReturn(this, (TextFieldMessage.__proto__ || Object.getPrototypeOf(TextFieldMessage)).call(this, props));
	
	      _this.state = {
	        message: props.error && props.errorText || props.helpText || props.errorText,
	        isMessageVisible: _this._isMessageVisible(props)
	      };
	      return _this;
	    }
	
	    _createClass(TextFieldMessage, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var keys = ['active', 'error', 'helpOnFocus', 'helpText', 'errorText'];
	        if (this._anyChanges(keys, this.props, nextProps)) {
	          this.setState({
	            isMessageVisible: this._isMessageVisible(nextProps),
	            message: nextProps.error && nextProps.errorText || nextProps.helpText || nextProps.errorText
	          });
	        }
	      }
	    }, {
	      key: '_anyChanges',
	      value: function _anyChanges(keys, p1, p2) {
	        var changed = false;
	        keys.some(function (key) {
	          if (p1[key] !== p2[key]) {
	            changed = true;
	          }
	
	          return changed;
	        });
	
	        return changed;
	      }
	    }, {
	      key: '_isMessageVisible',
	      value: function _isMessageVisible(props) {
	        var error = props.error,
	            errorText = props.errorText,
	            helpText = props.helpText,
	            helpOnFocus = props.helpOnFocus,
	            active = props.active;
	
	        return (error && errorText || !!helpText) && (!helpOnFocus || active);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            maxLength = _props.maxLength,
	            error = _props.error,
	            className = _props.className,
	            errorText = _props.errorText,
	            helpText = _props.helpText,
	            currentLength = _props.currentLength,
	            leftIcon = _props.leftIcon,
	            rightIcon = _props.rightIcon,
	            block = _props.block,
	            active = _props.active;
	        var _state = this.state,
	            isMessageVisible = _state.isMessageVisible,
	            message = _state.message;
	
	
	        if (currentLength === 'undefined' || !helpText && !errorText && !maxLength) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('md-text-field-message-container', {
	              'md-text-field-message-container--error': error,
	              'md-text-field-message-container--count-only': !message || !isMessageVisible,
	              'md-text-field-message-container--left-icon-offset': leftIcon,
	              'md-text-field-message-container--right-icon-offset': rightIcon,
	              'md-full-width': !block
	            }, className)
	          },
	          _react2.default.createElement(
	            _Message2.default,
	            { key: 'message', active: isMessageVisible },
	            message
	          ),
	          _react2.default.createElement(
	            _Message2.default,
	            { key: 'counter', className: 'md-text-field-message--counter', active: active },
	            maxLength ? currentLength + ' / ' + maxLength : null
	          )
	        );
	      }
	    }]);
	
	    return TextFieldMessage;
	  }(_react.PureComponent);
	
	  TextFieldMessage.propTypes = {
	    className: _react.PropTypes.string,
	    error: _react.PropTypes.bool,
	    helpText: _react.PropTypes.string,
	    errorText: _react.PropTypes.string,
	    active: _react.PropTypes.bool,
	    helpOnFocus: _react.PropTypes.bool,
	    maxLength: _react.PropTypes.number,
	    currentLength: _react.PropTypes.number,
	    leftIcon: _react.PropTypes.bool,
	    rightIcon: _react.PropTypes.bool,
	    block: _react.PropTypes.bool
	  };
	  exports.default = TextFieldMessage;
	});

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(8), __webpack_require__(40), __webpack_require__(68), __webpack_require__(26), __webpack_require__(501)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/PropTypes/invalidIf'), require('../utils/PropTypes/between'), require('../Papers/Paper'), require('./ToolbarTitle'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.deprecated, global.invalidIf, global.between, global.Paper, global.ToolbarTitle);
	    global.Toolbar = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _deprecated, _invalidIf, _between, _Paper, _ToolbarTitle) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	  var _between2 = _interopRequireDefault(_between);
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  var _ToolbarTitle2 = _interopRequireDefault(_ToolbarTitle);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Toolbar = function (_PureComponent) {
	    _inherits(Toolbar, _PureComponent);
	
	    function Toolbar() {
	      _classCallCheck(this, Toolbar);
	
	      return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
	    }
	
	    _createClass(Toolbar, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            component = _props.component,
	            titleStyle = _props.titleStyle,
	            titleClassName = _props.titleClassName,
	            prominentTitle = _props.prominentTitle,
	            primary = _props.primary,
	            secondary = _props.secondary,
	            themed = _props.themed,
	            singleColor = _props.singleColor,
	            actions = _props.actions,
	            fixed = _props.fixed,
	            actionLeft = _props.actionLeft,
	            actionsRight = _props.actionsRight,
	            children = _props.children,
	            inset = _props.inset,
	            props = _objectWithoutProperties(_props, ['style', 'className', 'component', 'titleStyle', 'titleClassName', 'prominentTitle', 'primary', 'secondary', 'themed', 'singleColor', 'actions', 'fixed', 'actionLeft', 'actionsRight', 'children', 'inset']);
	
	        delete props.nav;
	        delete props.title;
	        delete props.titleMenu;
	        delete props.zDepth;
	        delete props.colored;
	        delete props.prominent;
	
	        // delete deprecated;
	        delete props.containerStyle;
	        delete props.containerClassName;
	        delete props.actionLeft;
	        delete props.actionsRight;
	
	        var _props2 = this.props,
	            colored = _props2.colored,
	            title = _props2.title,
	            titleMenu = _props2.titleMenu,
	            nav = _props2.nav,
	            prominent = _props2.prominent,
	            zDepth = _props2.zDepth;
	
	
	        colored = colored || primary || secondary;
	        prominent = prominent || prominentTitle;
	
	        title = _react2.default.createElement(_ToolbarTitle2.default, {
	          key: 'title',
	          style: titleStyle,
	          className: titleClassName,
	          prominent: prominentTitle,
	          offset: prominentTitle,
	          title: title
	        });
	
	        if (nav || actionLeft) {
	          var navEl = _react.Children.only(nav || actionLeft);
	          nav = (0, _react.cloneElement)(nav, {
	            className: (0, _classnames2.default)('md-btn--toolbar md-toolbar--action-left', navEl.props.className)
	          });
	        }
	
	        var rightActions = void 0;
	        if (actions || actionsRight) {
	          rightActions = _react.Children.map(_react.Children.toArray(actions || actionsRight), function (action) {
	            return (0, _react.cloneElement)(action, {
	              className: (0, _classnames2.default)('md-btn--toolbar', action.props.className)
	            });
	          });
	
	          rightActions = _react2.default.createElement(
	            'div',
	            { key: 'actions', className: 'md-cell--right md-toolbar--action-right' },
	            rightActions
	          );
	        }
	
	        if (titleMenu) {
	          titleMenu = _react.Children.only(titleMenu);
	          titleMenu = (0, _react.cloneElement)(titleMenu, {
	            className: (0, _classnames2.default)('md-title md-title--toolbar md-select-field--toolbar', {
	              'md-title--toolbar-offset': prominentTitle,
	              'md-title--toolbar-prominent': prominentTitle
	            }, titleMenu.props.className),
	            position: titleMenu.props.position || 'tl',
	            toolbar: true
	          });
	        }
	
	        if (typeof zDepth !== 'number') {
	          zDepth = fixed ? 2 : 0;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          _extends({}, props, {
	            component: component,
	            zDepth: zDepth,
	            style: style,
	            className: (0, _classnames2.default)('md-toolbar', {
	              'md-background--primary': colored,
	              'md-toolbar--themed': themed,
	              'md-toolbar--text-white': singleColor && colored,
	              'md-toolbar--discrete': !prominent,
	              'md-toolbar--prominent': prominent,
	              'md-toolbar--fixed': fixed,
	              'md-toolbar--inset': inset
	            }, className)
	          }),
	          nav,
	          title,
	          titleMenu,
	          children,
	          rightActions
	        );
	      }
	    }]);
	
	    return Toolbar;
	  }(_react.PureComponent);
	
	  Toolbar.propTypes = {
	    /**
	     * An optional style to apply to the toolbar.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the toolbar,
	     */
	    className: _react.PropTypes.string,
	
	    /*
	     * An optional style to apply to the `h2` surroudning the `title` prop.
	     */
	    titleStyle: _react.PropTypes.object,
	
	    /*
	     * An optional className to apply to the `h2` surroudning the `title` prop.
	     */
	    titleClassName: _react.PropTypes.string,
	
	    /**
	     * Boolean if the toolbar should more prominent. This will double the height of the toolbar.
	     */
	    prominent: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the toolbar's title should be more prominent. This will move the title to the
	     * second line of the toolbar. This only works when the `prominent` prop is true as well.
	     */
	    prominentTitle: _react.PropTypes.bool,
	
	    /**
	     * The current title of the page to show in the toolbar. It is invalid to specify both a
	     * `title` and a `titleMenu`. Only one should be given.
	     */
	    title: (0, _invalidIf2.default)(_react.PropTypes.node, 'titleMenu'),
	
	    /**
	     * An optional title menu to display instead of the title. This should be a `SelectField` component.
	     * It is cloned with some additional props, so if the `SelectField` is separated into a separate
	     * component, the following props must be passed to get the correct styling: `className`, `block`,
	     * `paddedBlock`, `position`.
	     */
	    titleMenu: _react.PropTypes.element,
	
	    /**
	     * This prop is used for rendering an optional navigation button to the left of the `title`
	     * or the `titleMenu` component. This needs to be an icon `Button` because some additional props
	     * are cloned into it.
	     */
	    nav: _react.PropTypes.element,
	
	    /**
	     * Any additional actions to display to the right of the title. This should be a list or a single
	     * `Button` to display. The buttons get cloned with an additional className for toolbar styling.
	     */
	    actions: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)]),
	
	    /**
	     * Any children to display in the toolbar. This will be displayed between the optional title and
	     * actions.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the toolbar should be fixed to the top of the page. This will add some additional box shadow.
	     */
	    fixed: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the nav, actions, and title should share the same color. For a `colored` or dark `themed`
	     * toolbar, they will all be colored white. For a transparent or light `themed` toolbar, the colors will
	     * be the `rgba(0, 0, 0, .87)`. Setting this to false will only style the title to the specific color
	     * stated above.
	     */
	    singleColor: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the toolbar should be colored based off the current theme. This will either style the background
	     * to be fairly white, or fairly black. You can not specify both `themed` and `colored`.
	     */
	    themed: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the toolbar should be colored with the `$md-primary-color`.
	     */
	    colored: (0, _invalidIf2.default)(_react.PropTypes.bool, 'themed'),
	
	    /**
	     * The component to render the toolbar as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * Boolean if the toolbar is inset in the page. This will just add some margin around
	     * it.
	     */
	    inset: _react.PropTypes.bool,
	
	    /**
	     * An optional zDepth to enforce for the toolbar. This should be a number between 0 and 5.
	     * If this is omitted, the toolbar will gain a zDepth of 2 when `fixed`.
	     */
	    zDepth: (0, _between2.default)(_react.PropTypes.number, 0, 5),
	    containerStyle: (0, _deprecated2.default)(_react.PropTypes.object, 'The `container` no longer exists in the `Toolbar`. Use the `style` prop instead'),
	    containerClassName: (0, _deprecated2.default)(_react.PropTypes.string, 'The `container` no longer exists in the `Toolbar`. Use the `className` prop instead'),
	    primary: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use the `colored` prop instead'),
	    secondary: (0, _deprecated2.default)(_react.PropTypes.bool, 'Toolbars can no longer be themed to the secondary color. Use the `colored` prop instead'),
	    actionLeft: (0, _deprecated2.default)(_react.PropTypes.element, 'Use the `nav` prop instead'),
	    actionsRight: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `menu` prop and/or the `actions` prop instead')
	  };
	  Toolbar.defaultProps = {
	    singleColor: true,
	    component: 'header'
	  };
	  exports.default = Toolbar;
	});

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.media = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  var MOBILE_MIN_WIDTH = exports.MOBILE_MIN_WIDTH = 320;
	  var TABLET_MIN_WIDTH = exports.TABLET_MIN_WIDTH = 768;
	  var DESKTOP_MIN_WIDTH = exports.DESKTOP_MIN_WIDTH = 1025;
	});

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(396), __webpack_require__(398), __webpack_require__(401), __webpack_require__(405), __webpack_require__(195), __webpack_require__(411), __webpack_require__(422), __webpack_require__(426), __webpack_require__(427), __webpack_require__(428), __webpack_require__(432), __webpack_require__(434), __webpack_require__(436), __webpack_require__(127), __webpack_require__(437), __webpack_require__(440), __webpack_require__(442), __webpack_require__(203), __webpack_require__(444), __webpack_require__(207), __webpack_require__(447), __webpack_require__(464), __webpack_require__(467), __webpack_require__(476), __webpack_require__(469), __webpack_require__(486), __webpack_require__(478), __webpack_require__(489), __webpack_require__(211), __webpack_require__(495), __webpack_require__(500), __webpack_require__(502), __webpack_require__(505)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Autocompletes'), require('./Avatars'), require('./BottomNavigations'), require('./Buttons'), require('./Cards'), require('./Chips'), require('./DataTables'), require('./Dialogs'), require('./Dividers'), require('./Drawers'), require('./ExpansionPanels'), require('./FABTransitions'), require('./FileInputs'), require('./FontIcons'), require('./Helpers'), require('./Inks'), require('./Lists'), require('./Media'), require('./Menus'), require('./NavigationDrawers'), require('./Papers'), require('./Pickers'), require('./Progress'), require('./SelectionControls'), require('./SelectFields'), require('./Sliders'), require('./Sidebars'), require('./Snackbars'), require('./Subheaders'), require('./Tabs'), require('./TextFields'), require('./Toolbars'), require('./Tooltips'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Autocompletes, global.Avatars, global.BottomNavigations, global.Buttons, global.Cards, global.Chips, global.DataTables, global.Dialogs, global.Dividers, global.Drawers, global.ExpansionPanels, global.FABTransitions, global.FileInputs, global.FontIcons, global.Helpers, global.Inks, global.Lists, global.Media, global.Menus, global.NavigationDrawers, global.Papers, global.Pickers, global.Progress, global.SelectionControls, global.SelectFields, global.Sliders, global.Sidebars, global.Snackbars, global.Subheaders, global.Tabs, global.TextFields, global.Toolbars, global.Tooltips);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Autocompletes, _Avatars, _BottomNavigations, _Buttons, _Cards, _Chips, _DataTables, _Dialogs, _Dividers, _Drawers, _ExpansionPanels, _FABTransitions, _FileInputs, _FontIcons, _Helpers, _Inks, _Lists, _Media, _Menus, _NavigationDrawers, _Papers, _Pickers, _Progress, _SelectionControls, _SelectFields, _Sliders, _Sidebars, _Snackbars, _Subheaders, _Tabs, _TextFields, _Toolbars, _Tooltips) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.injectTooltip = exports.Toolbar = exports.TextField = exports.TabPanel = exports.MenuTab = exports.Tab = exports.Tabs = exports.TabsContainer = exports.Snackbar = exports.Sidebar = exports.Slider = exports.Subheader = exports.Switch = exports.Radio = exports.RadioGroup = exports.Checkbox = exports.SelectionControlGroup = exports.SelectionControl = exports.SelectField = exports.LinearProgress = exports.CircularProgress = exports.TimePicker = exports.DatePicker = exports.Paper = exports.JumpToContentLink = exports.CloseButton = exports.NavigationDrawer = exports.Menu = exports.MediaOverlay = exports.Media = exports.ListItemControl = exports.ListItem = exports.List = exports.injectInk = exports.Portal = exports.FocusContainer = exports.IconSeparator = exports.Collapse = exports.AccessibleFakeInkedButton = exports.AccessibleFakeButton = exports.FontIcon = exports.FileUpload = exports.FileInput = exports.SpeedDial = exports.ExpansionPanel = exports.ExpansionList = exports.Drawer = exports.Divider = exports.Dialog = exports.SelectFieldColumn = exports.TablePagination = exports.EditDialogColumn = exports.TableCardHeader = exports.TableColumn = exports.TableRow = exports.TableBody = exports.TableHeader = exports.DataTable = exports.Chip = exports.CardActionOverlay = exports.CardText = exports.CardActions = exports.CardMedia = exports.CardTitle = exports.Card = exports.IconButton = exports.FloatingButton = exports.RaisedButton = exports.FlatButton = exports.Button = exports.BottomNavigation = exports.Avatar = exports.Autocomplete = undefined;
	
	  var _Autocompletes2 = _interopRequireDefault(_Autocompletes);
	
	  var _Avatars2 = _interopRequireDefault(_Avatars);
	
	  var _BottomNavigations2 = _interopRequireDefault(_BottomNavigations);
	
	  var _Buttons2 = _interopRequireDefault(_Buttons);
	
	  var _Cards2 = _interopRequireDefault(_Cards);
	
	  var _Chips2 = _interopRequireDefault(_Chips);
	
	  var _DataTables2 = _interopRequireDefault(_DataTables);
	
	  var _Dialogs2 = _interopRequireDefault(_Dialogs);
	
	  var _Dividers2 = _interopRequireDefault(_Dividers);
	
	  var _Drawers2 = _interopRequireDefault(_Drawers);
	
	  var _FileInputs2 = _interopRequireDefault(_FileInputs);
	
	  var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	  var _Inks2 = _interopRequireDefault(_Inks);
	
	  var _Media2 = _interopRequireDefault(_Media);
	
	  var _Menus2 = _interopRequireDefault(_Menus);
	
	  var _NavigationDrawers2 = _interopRequireDefault(_NavigationDrawers);
	
	  var _Papers2 = _interopRequireDefault(_Papers);
	
	  var _SelectFields2 = _interopRequireDefault(_SelectFields);
	
	  var _Sliders2 = _interopRequireDefault(_Sliders);
	
	  var _Sidebars2 = _interopRequireDefault(_Sidebars);
	
	  var _Snackbars2 = _interopRequireDefault(_Snackbars);
	
	  var _Subheaders2 = _interopRequireDefault(_Subheaders);
	
	  var _TextFields2 = _interopRequireDefault(_TextFields);
	
	  var _Toolbars2 = _interopRequireDefault(_Toolbars);
	
	  var _Tooltips2 = _interopRequireDefault(_Tooltips);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.Autocomplete = _Autocompletes2.default;
	  exports.Avatar = _Avatars2.default;
	  exports.BottomNavigation = _BottomNavigations2.default;
	  exports.Button = _Buttons2.default;
	  exports.FlatButton = _Buttons.FlatButton;
	  exports.RaisedButton = _Buttons.RaisedButton;
	  exports.FloatingButton = _Buttons.FloatingButton;
	  exports.IconButton = _Buttons.IconButton;
	  exports.Card = _Cards2.default;
	  exports.CardTitle = _Cards.CardTitle;
	  exports.CardMedia = _Cards.CardMedia;
	  exports.CardActions = _Cards.CardActions;
	  exports.CardText = _Cards.CardText;
	  exports.CardActionOverlay = _Cards.CardActionOverlay;
	  exports.Chip = _Chips2.default;
	  exports.DataTable = _DataTables2.default;
	  exports.TableHeader = _DataTables.TableHeader;
	  exports.TableBody = _DataTables.TableBody;
	  exports.TableRow = _DataTables.TableRow;
	  exports.TableColumn = _DataTables.TableColumn;
	  exports.TableCardHeader = _DataTables.TableCardHeader;
	  exports.EditDialogColumn = _DataTables.EditDialogColumn;
	  exports.TablePagination = _DataTables.TablePagination;
	  exports.SelectFieldColumn = _DataTables.SelectFieldColumn;
	  exports.Dialog = _Dialogs2.default;
	  exports.Divider = _Dividers2.default;
	  exports.Drawer = _Drawers2.default;
	  exports.ExpansionList = _ExpansionPanels.ExpansionList;
	  exports.ExpansionPanel = _ExpansionPanels.ExpansionPanel;
	  exports.SpeedDial = _FABTransitions.SpeedDial;
	  exports.FileInput = _FileInputs2.default;
	  exports.FileUpload = _FileInputs.FileUpload;
	  exports.FontIcon = _FontIcons2.default;
	  exports.AccessibleFakeButton = _Helpers.AccessibleFakeButton;
	  exports.AccessibleFakeInkedButton = _Helpers.AccessibleFakeInkedButton;
	  exports.Collapse = _Helpers.Collapse;
	  exports.IconSeparator = _Helpers.IconSeparator;
	  exports.FocusContainer = _Helpers.FocusContainer;
	  exports.Portal = _Helpers.Portal;
	  exports.injectInk = _Inks2.default;
	  exports.List = _Lists.List;
	  exports.ListItem = _Lists.ListItem;
	  exports.ListItemControl = _Lists.ListItemControl;
	  exports.Media = _Media2.default;
	  exports.MediaOverlay = _Media.MediaOverlay;
	  exports.Menu = _Menus2.default;
	  exports.NavigationDrawer = _NavigationDrawers2.default;
	  exports.CloseButton = _NavigationDrawers.CloseButton;
	  exports.JumpToContentLink = _NavigationDrawers.JumpToContentLink;
	  exports.Paper = _Papers2.default;
	  exports.DatePicker = _Pickers.DatePicker;
	  exports.TimePicker = _Pickers.TimePicker;
	  exports.CircularProgress = _Progress.CircularProgress;
	  exports.LinearProgress = _Progress.LinearProgress;
	  exports.SelectField = _SelectFields2.default;
	  exports.SelectionControl = _SelectionControls.SelectionControl;
	  exports.SelectionControlGroup = _SelectionControls.SelectionControlGroup;
	  exports.Checkbox = _SelectionControls.Checkbox;
	  exports.RadioGroup = _SelectionControls.RadioGroup;
	  exports.Radio = _SelectionControls.Radio;
	  exports.Switch = _SelectionControls.Switch;
	  exports.Subheader = _Subheaders2.default;
	  exports.Slider = _Sliders2.default;
	  exports.Sidebar = _Sidebars2.default;
	  exports.Snackbar = _Snackbars2.default;
	  exports.TabsContainer = _Tabs.TabsContainer;
	  exports.Tabs = _Tabs.Tabs;
	  exports.Tab = _Tabs.Tab;
	  exports.MenuTab = _Tabs.MenuTab;
	  exports.TabPanel = _Tabs.TabPanel;
	  exports.TextField = _TextFields2.default;
	  exports.Toolbar = _Toolbars2.default;
	  exports.injectTooltip = _Tooltips2.default;
	  exports.default = {
	    Autocomplete: _Autocompletes2.default,
	    Avatar: _Avatars2.default,
	    BottomNavigation: _BottomNavigations2.default,
	
	    Button: _Buttons2.default,
	    FlatButton: _Buttons.FlatButton,
	    RaisedButton: _Buttons.RaisedButton,
	    FloatingButton: _Buttons.FloatingButton,
	    IconButton: _Buttons.IconButton,
	
	    Card: _Cards2.default,
	    CardTitle: _Cards.CardTitle,
	    CardMedia: _Cards.CardMedia,
	    CardActions: _Cards.CardActions,
	    CardText: _Cards.CardText,
	    CardActionOverlay: _Cards.CardActionOverlay,
	
	    Chip: _Chips2.default,
	
	    DataTable: _DataTables2.default,
	    TableHeader: _DataTables.TableHeader,
	    TableBody: _DataTables.TableBody,
	    TableRow: _DataTables.TableRow,
	    TableColumn: _DataTables.TableColumn,
	    TableCardHeader: _DataTables.TableCardHeader,
	    EditDialogColumn: _DataTables.EditDialogColumn,
	    TablePagination: _DataTables.TablePagination,
	    SelectFieldColumn: _DataTables.SelectFieldColumn,
	
	    Dialog: _Dialogs2.default,
	    Divider: _Dividers2.default,
	    Drawer: _Drawers2.default,
	
	    ExpansionList: _ExpansionPanels.ExpansionList,
	    ExpansionPanel: _ExpansionPanels.ExpansionPanel,
	
	    SpeedDial: _FABTransitions.SpeedDial,
	
	    FileInput: _FileInputs2.default,
	    FileUpload: _FileInputs.FileUpload,
	
	    FontIcon: _FontIcons2.default,
	    AccessibleFakeButton: _Helpers.AccessibleFakeButton,
	    AccessibleFakeInkedButton: _Helpers.AccessibleFakeInkedButton,
	    Collapse: _Helpers.Collapse,
	    IconSeparator: _Helpers.IconSeparator,
	    FocusContainer: _Helpers.FocusContainer,
	    Portal: _Helpers.Portal,
	
	    injectInk: _Inks2.default,
	
	    List: _Lists.List,
	    ListItem: _Lists.ListItem,
	    ListItemControl: _Lists.ListItemControl,
	
	    Media: _Media2.default,
	    MediaOverlay: _Media.MediaOverlay,
	
	    Menu: _Menus2.default,
	
	    NavigationDrawer: _NavigationDrawers2.default,
	    CloseButton: _NavigationDrawers.CloseButton,
	    JumpToContentLink: _NavigationDrawers.JumpToContentLink,
	
	    Paper: _Papers2.default,
	
	    DatePicker: _Pickers.DatePicker,
	    TimePicker: _Pickers.TimePicker,
	
	    CircularProgress: _Progress.CircularProgress,
	    LinearProgress: _Progress.LinearProgress,
	
	    SelectField: _SelectFields2.default,
	
	    SelectionControl: _SelectionControls.SelectionControl,
	    SelectionControlGroup: _SelectionControls.SelectionControlGroup,
	    Checkbox: _SelectionControls.Checkbox,
	    RadioGroup: _SelectionControls.RadioGroup,
	    Radio: _SelectionControls.Radio,
	    Switch: _SelectionControls.Switch,
	
	    Subheader: _Subheaders2.default,
	
	    Slider: _Sliders2.default,
	    Sidebar: _Sidebars2.default,
	    Snackbar: _Snackbars2.default,
	
	    TabsContainer: _Tabs.TabsContainer,
	    Tabs: _Tabs.Tabs,
	    Tab: _Tabs.Tab,
	    MenuTab: _Tabs.MenuTab,
	    TabPanel: _Tabs.TabPanel,
	
	    TextField: _TextFields2.default,
	    Toolbar: _Toolbars2.default,
	    injectTooltip: _Tooltips2.default
	  };
	});

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.DateTimeFormat = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  var DateTimeFormat = function () {
	    if (typeof Intl !== 'undefined' && typeof Intl.DateTimeFormat !== 'undefined') {
	      return Intl.DateTimeFormat;
	    }
	
	    // Very bad 'mock' of Intl.DateTimeFormat
	    return function () {
	      return (/* locales, formatOptions */{ format: function format(date) {
	            return date.toLocaleString();
	          } }
	      );
	    };
	  }();
	
	  exports.default = DateTimeFormat;
	});

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.formatTime = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = formatTime;
	  /**
	   * Formats a date as a time string using the DateTimeFormat function and locales.
	   *
	   * @param {function} DateTimeFormat the DateTimeFormat function to use.
	   * @param {string|string[]} locales the locales to use.
	   * @param {Date} time the time to format into a string.
	   * @return a string of the formatted time.
	   */
	  function formatTime(DateTimeFormat, locales, time) {
	    return new DateTimeFormat(locales, { hour: 'numeric', minute: '2-digit' }).format(time);
	  }
	});

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.getDayOfWeek = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = getDayOfWeek;
	  /**
	   * Gets a day in the week. 0 = Sunday 6 = Saturday
	   *
	   * @param {date} sourceDate the date to find a relative day of week from
	   * @param {number} dow the day of the week to find
	   * @return a new Date as the given day of week
	   */
	  function getDayOfWeek(sourceDate) {
	    var dow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    var date = new Date(sourceDate);
	    var day = date.getDay();
	
	    var diff = date.getDate() - day + dow;
	    return new Date(date.setDate(diff));
	  }
	});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.stripTime = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = stripTime;
	  /**
	   * Removes all time from a date. Only keeps year, month, and date.
	   * @param {Date} date the date to strip
	   * @return a new Date with the time stripped.
	   */
	  function stripTime(date) {
	    if (!date || !(date instanceof Date)) {
	      return null;
	    }
	
	    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
	  }
	});

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('../../constants/keyCodes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.keyCodes);
	    global.isValidFocusKeypress = mod.exports;
	  }
	})(this, function (exports, _keyCodes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = isValidFocusKeypress;
	
	
	  /**
	   * Checks if a keydown or keyup event's key was the TAB key or any additional valid
	   * keys that were passed in.
	   *
	   * @param {Object} event - The event to check.
	   * @param {Array.<number>=} additionalKeys - An optional array of additional key codes
	   *    that are considered valid for a focus event.
	   */
	  function isValidFocusKeypress(event, additionalKeys) {
	    var key = event.which || event.keyCode;
	    return key === _keyCodes.TAB || additionalKeys && additionalKeys.indexOf(key) !== -1;
	  }
	});

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.isBetween = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = isBetween;
	  /**
	   * Checks if a number is between a min and maximum (inclusive)
	   *
	   * @param {Number} num the number to check
	   * @param {Number} min the minimum
	   * @param {Number} max the maximum
	   * @return {Boolean} true if the number is between the min and max (inclusive)
	   */
	  function isBetween(num, min, max) {
	    return num >= min && num <= max;
	  }
	});

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.oneRequired = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = oneRequired;
	  function oneRequired(validator) {
	    for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      otherPropNames[_key - 1] = arguments[_key];
	    }
	
	    return function validate(props, propName, componentName, location, propFullName) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	      var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	        args[_key2 - 5] = arguments[_key2];
	      }
	
	      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	      if (!err && !allPropNames.filter(function (pn) {
	        return typeof props[pn] !== 'undefined';
	      }).length) {
	        err = new Error('One of the following props are required for the ' + componentNameSafe + ' component. ' + ('`' + allPropNames.join('`, `') + '`.'));
	      }
	
	      return err;
	    };
	  }
	});

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.addSuffix = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = addSuffix;
	  /**
	   * Optionally adds a suffix to a string if it does
	   * not already contain that string.
	   *
	   * @param {String} str - The string to modify
	   * @param {String} suffix - The suffix to add
	   *
	   * @return {String} the string with a suffix
	   */
	  function addSuffix(str, suffix) {
	    if (!str) {
	      return str;
	    }
	
	    return str.indexOf(suffix) === -1 ? str.trim() + " " + suffix : str;
	  }
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.getDisplayName = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = getDisplayName;
	
	  /**
	   * Gets the display name for a composed component.
	   *
	   * @param {function} ComposedComponent - The composed component to use
	   * @return {String} the name of the composed component or 'Component'.
	   */
	  function getDisplayName(ComposedComponent, suffix) {
	    var name = '' + (ComposedComponent.displayName || ComposedComponent.name || 'Component');
	
	    return name.indexOf(suffix) === -1 ? '' + name + suffix : name;
	  }
	});

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(230)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./getPagePosition'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.getPagePosition);
	    global.calcPageOffset = mod.exports;
	  }
	})(this, function (exports, _getPagePosition) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = calcPageOffset;
	
	  var _getPagePosition2 = _interopRequireDefault(_getPagePosition);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  /**
	   * Calculates the page offset of an element. If the element
	   * is false-ish, an empty object will be returned.
	   *
	   * This is really only used for calculating an ink position.
	   *
	   * @param {Node} el - An html node to find a page offset for.
	   * @return {Object} an object with a left and top attribute for the page
	   *    offset.
	   */
	  function calcPageOffset(el) {
	    if (!el) {
	      return { left: null, right: null };
	    }
	
	    var rect = el.getBoundingClientRect();
	    return {
	      left: rect.left + (0, _getPagePosition2.default)('x'),
	      top: rect.top + (0, _getPagePosition2.default)('y')
	    };
	  }
	});

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.getPagePosition = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = getPagePosition;
	  /**
	   * Gets the current page position.
	   *
	   * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY
	   * @param {String} direction - The direction that should be retrieved. This
	   *    should be either 'x' or 'y'.
	   * @return {number} the position of the direction on the page.
	   */
	  function getPagePosition(direction) {
	    var scroll = 'scroll' + (direction === 'x' ? 'Left' : 'Top');
	    if (typeof window.pageXOffset !== 'undefined') {
	      return window['page' + direction.toUpperCase() + 'Offset'];
	    } else if ((document.compatMode || '') === 'CSS1Compat') {
	      return document.documentElement[scroll];
	    } else {
	      return document.body[scroll];
	    }
	  }
	});

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(124), __webpack_require__(210), __webpack_require__(65)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../Dividers/Divider'), require('../Subheaders/Subheader'), require('../Lists/ListItem'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.Divider, global.Subheader, global.ListItem);
	    global.mapToListParts = mod.exports;
	  }
	})(this, function (exports, _react, _Divider, _Subheader, _ListItem) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = mapToListParts;
	
	  var _Divider2 = _interopRequireDefault(_Divider);
	
	  var _Subheader2 = _interopRequireDefault(_Subheader);
	
	  var _ListItem2 = _interopRequireDefault(_ListItem);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function mapToListParts(item, index) {
	    if (typeof item === 'string') {
	      return (0, _react.createElement)(_ListItem2.default, { key: item, primaryText: item });
	    } else if ((0, _react.isValidElement)(item)) {
	      return item;
	    }
	
	    var divider = item.divider,
	        subheader = item.subheader,
	        nestedItems = item.nestedItems,
	        remainingProps = _objectWithoutProperties(item, ['divider', 'subheader', 'nestedItems']);
	
	    var component = void 0;
	    if (divider) {
	      component = _Divider2.default;
	    } else if (subheader) {
	      component = _Subheader2.default;
	    } else {
	      component = _ListItem2.default;
	    }
	
	    var props = Object.assign({}, remainingProps, { key: item.key || index });
	    if (nestedItems) {
	      props.nestedItems = nestedItems.map(mapToListParts);
	    }
	
	    return (0, _react.createElement)(component, props);
	  }
	});

/***/ },
/* 232 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(140);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, _ref2) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact;
	    var route = _ref2.route;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        component = _props.component,
	        render = _props.render,
	        children = _props.children;
	
	
	    (0, _warning2.default)(!(component && render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(component && children), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(render && children), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props2 = this.props,
	        children = _props2.children,
	        component = _props2.component,
	        render = _props2.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
	    _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 235 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//  weak
	
	var RESISTANCE_COEF = exports.RESISTANCE_COEF = 0.6;
	
	// This value is closed to what browsers are using internally to
	// trigger a native scroll.
	var UNCERTAINTY_THRESHOLD = exports.UNCERTAINTY_THRESHOLD = 3; // px

/***/ },
/* 236 */
109,
/* 237 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(27);
	var ReactTransitionChildMapping = __webpack_require__(562);
	
	var propTypesFactory = __webpack_require__(74);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var emptyFunction = __webpack_require__(17);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: PropTypes.any,
	  childFactory: PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(54);
	
	var ReactElement = __webpack_require__(53);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(54);
	
	var ReactCurrentOwner = __webpack_require__(28);
	var REACT_ELEMENT_TYPE = __webpack_require__(237);
	
	var getIteratorFn = __webpack_require__(566);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(236);
	var warning = __webpack_require__(4);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 242 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_Component) {
	  _inherits(About, _Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).apply(this, arguments));
	  }
	
	  _createClass(About, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "md-grid" },
	        _react2.default.createElement(
	          "h2",
	          { className: "md-cell md-cell--12 md-text-container" },
	          "About"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          _react2.default.createElement(
	            "h4",
	            null,
	            " An application that allows user to organize books based on reading activity. There are 3 status or shelves where each book can be placed namely:",
	            _react2.default.createElement(
	              "em",
	              null,
	              "\"Currently Reading\""
	            ),
	            ", ",
	            _react2.default.createElement(
	              "em",
	              null,
	              "\"Want To Read\""
	            ),
	            ",",
	            _react2.default.createElement(
	              "em",
	              null,
	              " \"Read\""
	            ),
	            ". There's also a search capability that dynamically filter books by matching query with status, title or author."
	          ),
	          _react2.default.createElement(
	            "h5",
	            null,
	            " To Use: "
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              " clone this repo"
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              " run \"npm install\" on terminal to install dependencies "
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              " run \"npm start\" "
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h5",
	            null,
	            " Technology: "
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              " :Using create-react-app: ReactJS, React-md, React Router 4 "
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "h5",
	            null,
	            " License / Credits: "
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              " Udacity React Nano Degree "
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              " create-react-app "
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              " react-md-with-router4 example "
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return About;
	}(_react.Component);
	
	exports.default = About;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutabilityHelper = __webpack_require__(163);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _BooksAPI = __webpack_require__(144);
	
	var BooksAPI = _interopRequireWildcard(_BooksAPI);
	
	var _Navigation = __webpack_require__(247);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	__webpack_require__(303);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, App);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      books: [],
	      listTitles: ["MyReads", "MySearch"],
	      shelves: [{ slug: "currentlyReading", title: "Currently Reading" }, { slug: "wantToRead", title: "Want To Read" }, { slug: "read", title: "Read" }]
	    }, _this.fetchBooks = function () {
	      BooksAPI.getAll().then(function (books) {
	        _this.setState({ books: books });
	      });
	    }, _this.checkBookOnList = function (currentSetBooks, modifiedBook) {
	      var currentBooksTitles = [];
	      currentSetBooks.map(function (book) {
	        currentBooksTitles.push(book.id);
	      });
	      var checkBook = currentBooksTitles.includes(modifiedBook.id);
	      return checkBook;
	    }, _this.updateBooks = function (modifiedBook) {
	      var currentSetBooks = _this.state.books;
	      var newSetBooks = void 0;
	
	      if (_this.checkBookOnList(currentSetBooks, modifiedBook)) {
	        alert('This book already exist in your shelf.');
	      } else {
	        newSetBooks = currentSetBooks.push(modifiedBook);
	        _this.setState(function (state) {
	          books: newSetBooks;
	        });
	        alert('Success: Book is now added and can be found at ' + modifiedBook.shelf + ' shelf.');
	        BooksAPI.update(modifiedBook, modifiedBook.shelf);
	      }
	    }, _this.transferShelf = function (book, shelf) {
	      var myBooks = _this.state.books;
	      var modifiedBook = (0, _immutabilityHelper2.default)(book, { shelf: { $set: book.shelf = shelf } });
	      _this.setState(function (state) {
	        books: modifiedBook;
	      });
	      BooksAPI.update(modifiedBook, shelf);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchBooks();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          books = _state.books,
	          shelves = _state.shelves;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Navigation2.default, {
	          books: books,
	          transferShelf: this.transferShelf,
	          updateBooks: this.updateBooks,
	          checkBookOnList: this.checkBookOnList,
	          shelves: shelves })
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMd = __webpack_require__(219);
	
	var _TabsNav = __webpack_require__(250);
	
	var _TabsNav2 = _interopRequireDefault(_TabsNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Listings = function (_Component) {
	  _inherits(Listings, _Component);
	
	  function Listings() {
	    _classCallCheck(this, Listings);
	
	    return _possibleConstructorReturn(this, (Listings.__proto__ || Object.getPrototypeOf(Listings)).apply(this, arguments));
	  }
	
	  _createClass(Listings, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          books = _props.books,
	          transferShelf = _props.transferShelf,
	          shelves = _props.shelves,
	          shelf = _props.shelf;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactMd.TabsContainer,
	          { panelClassName: 'md-grid', colored: true },
	          _react2.default.createElement(
	            _reactMd.Tabs,
	            { tabId: 'TabsNav-tab' },
	            shelves.map(function (shelf) {
	              return _react2.default.createElement(
	                _reactMd.Tab,
	                { label: shelf.title, key: shelf.title },
	                _react2.default.createElement(_TabsNav2.default, {
	                  books: books,
	                  search: false,
	                  shelf: shelf.slug,
	                  transferShelf: transferShelf })
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Listings;
	}(_react.Component);
	
	Listings.propTypes = {
	  books: _propTypes2.default.array.isRequired,
	  transferShelf: _propTypes2.default.func,
	  shelves: _propTypes2.default.array.isRequired,
	  shelf: _propTypes2.default.string
	};
	exports.default = Listings;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(138);
	
	var _FontIcons = __webpack_require__(127);
	
	var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	var _ListItem = __webpack_require__(65);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavLink = function NavLink(_ref) {
	  var label = _ref.label,
	      to = _ref.to,
	      exact = _ref.exact,
	      icon = _ref.icon;
	  return _react2.default.createElement(
	    _reactRouterDom.Route,
	    { path: to, exact: exact },
	    function (_ref2) {
	      var match = _ref2.match;
	
	      var leftIcon = void 0;
	      if (icon) {
	        leftIcon = _react2.default.createElement(
	          _FontIcons2.default,
	          null,
	          icon
	        );
	      }
	
	      return _react2.default.createElement(_ListItem2.default, {
	        component: _reactRouterDom.Link,
	        active: !!match,
	        to: to,
	        primaryText: label,
	        leftIcon: leftIcon
	      });
	    }
	  );
	};
	
	NavLink.propTypes = {
	  label: _react.PropTypes.string.isRequired,
	  to: _react.PropTypes.string,
	  exact: _react.PropTypes.bool,
	  icon: _react.PropTypes.node
	};
	exports.default = NavLink;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(138);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _NavigationDrawers = __webpack_require__(207);
	
	var _NavigationDrawers2 = _interopRequireDefault(_NavigationDrawers);
	
	var _NavLinks = __webpack_require__(246);
	
	var _NavLinks2 = _interopRequireDefault(_NavLinks);
	
	var _Search = __webpack_require__(248);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Listings = __webpack_require__(245);
	
	var _Listings2 = _interopRequireDefault(_Listings);
	
	var _About = __webpack_require__(243);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var navItems = [{
	  exact: true,
	  label: 'Home',
	  to: '/',
	  icon: 'home'
	}, {
	  label: 'Search',
	  to: '/search',
	  icon: 'bookmark'
	}, {
	  label: 'About',
	  to: '/about',
	  icon: 'flight_land'
	}];
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).apply(this, arguments));
	  }
	
	  _createClass(Navigation, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          books = _props.books,
	          shelves = _props.shelves,
	          transferShelf = _props.transferShelf,
	          updateBooks = _props.updateBooks;
	
	      return _react2.default.createElement(_reactRouterDom.Route, {
	        render: function render(_ref) {
	          var location = _ref.location;
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _NavigationDrawers2.default,
	              {
	                drawerTitle: 'Menu',
	                toolbarTitle: 'myEbookz',
	                navItems: navItems.map(function (props) {
	                  return _react2.default.createElement(_NavLinks2.default, Object.assign({}, props, { key: props.to }));
	                }) },
	              _react2.default.createElement(
	                _reactRouterDom.Switch,
	                { key: location.key },
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', location: location,
	                  render: function render() {
	                    return _react2.default.createElement(_Listings2.default, {
	                      books: books,
	                      shelves: shelves,
	                      transferShelf: transferShelf });
	                  } }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/about', location: location, component: _About2.default }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/search', location: location,
	                  render: function render() {
	                    return _react2.default.createElement(_Search2.default, {
	                      books: books,
	                      shelves: shelves,
	                      updateBooks: updateBooks,
	                      transferShelf: transferShelf });
	                  } })
	              )
	            )
	          );
	        } });
	    }
	  }]);
	
	  return Navigation;
	}(_react.Component);
	
	Navigation.propTypes = {
	  books: _propTypes2.default.array.isRequired,
	  shelves: _propTypes2.default.array,
	  transferShelf: _propTypes2.default.func,
	  updateBooks: _propTypes2.default.func
	};
	exports.default = Navigation;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _escapeStringRegexp = __webpack_require__(302);
	
	var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);
	
	var _immutabilityHelper = __webpack_require__(163);
	
	var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);
	
	var _reactMd = __webpack_require__(219);
	
	var _BooksAPI = __webpack_require__(144);
	
	var BooksAPI = _interopRequireWildcard(_BooksAPI);
	
	var _Shelves = __webpack_require__(145);
	
	var _Shelves2 = _interopRequireDefault(_Shelves);
	
	__webpack_require__(305);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Search);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Search.__proto__ || Object.getPrototypeOf(Search)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      query: '',
	      resultBooks: []
	    }, _this.searchBooks = function (query) {
	      _this.updateQuery(query);
	      BooksAPI.search(_this.state.query, 20).then(function (newBooks) {
	        _this.setState({ resultBooks: newBooks });
	        var newResultBooks = _this.state.resultBooks.filter(function (book) {
	          return !_this.props.books.some(function (b) {
	            return b.id === book.id;
	          });
	        });
	        _this.setState({ resultBooks: newResultBooks });
	      });
	    }, _this.updateQuery = function (query) {
	      _this.setState({ query: query.trim() });
	    }, _this.clearQuery = function () {
	      _this.setState({ query: '' });
	    }, _this.clearResultBooks = function () {
	      _this.setState({ resultBooks: [] });
	    }, _this.filterBooks = function (query) {
	      var match = new RegExp((0, _escapeStringRegexp2.default)(query), 'i');
	      var filteredBooks = _this.state.resultBooks.filter(function (book) {
	        return match.test(book.title);
	      });
	      _this.setState({ resultBooks: filteredBooks });
	    }, _this.addBook = function (book, shelf) {
	      var modifiedBook = (0, _immutabilityHelper2.default)(book, { shelf: { $set: book.shelf = shelf } });
	      _this.props.updateBooks(modifiedBook);
	      BooksAPI.update(modifiedBook, shelf);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Search, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          transferShelf = _props.transferShelf,
	          books = _props.books;
	      var _state = this.state,
	          query = _state.query,
	          resultBooks = _state.resultBooks;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'search-books-bar' },
	          _react2.default.createElement(
	            'div',
	            { className: 'search-books-input-wrapper' },
	            _react2.default.createElement('input', { className: 'search-box',
	              type: 'text',
	              placeholder: 'Search by title',
	              value: query,
	              onChange: function onChange(event) {
	                return _this2.searchBooks(event.target.value);
	              } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Shelves2.default, { books: resultBooks,
	            addBook: this.addBook,
	            clearQuery: this.clearQuery,
	            transferShelf: transferShelf })
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	Search.propTypes = {
	  transferShelf: _propTypes2.default.func,
	  updateBooks: _propTypes2.default.func,
	  checkBookOnList: _propTypes2.default.func,
	  books: _propTypes2.default.array
	};
	exports.default = Search;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShelfChanger = function (_Component) {
	  _inherits(ShelfChanger, _Component);
	
	  function ShelfChanger() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ShelfChanger);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShelfChanger.__proto__ || Object.getPrototypeOf(ShelfChanger)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectValue: "none"
	    }, _this.handleChange = function (e) {
	      if (e.target.value) {
	        var selectedOption = e.target.value;
	        _this.props.transferShelf(_this.props.book, selectedOption);
	        _this.setState({ selectValue: selectedOption });
	      } else {
	        _this.props.clearQuery;
	      }
	    }, _this.handleAddBook = function (e) {
	      _this.props.addBook(_this.props.book, _this.state.selectValue);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ShelfChanger, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'select',
	          { value: this.props.shelf, onChange: this.handleChange },
	          _react2.default.createElement(
	            'option',
	            { value: 'none' },
	            'Move to...'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'currentlyReading' },
	            'Currently Reading'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'wantToRead' },
	            'Want to Read'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'read' },
	            'Read'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'none' },
	            'None'
	          )
	        ),
	        this.props.addBook ? _react2.default.createElement(
	          'button',
	          { onClick: this.handleAddBook },
	          'Add'
	        ) : null
	      );
	    }
	  }]);
	
	  return ShelfChanger;
	}(_react.Component);
	
	ShelfChanger.propTypes = {
	  book: _propTypes2.default.object.isRequired,
	  transferShelf: _propTypes2.default.func,
	  addBook: _propTypes2.default.func,
	  clearQuery: _propTypes2.default.func,
	  shelf: _propTypes2.default.string
	};
	exports.default = ShelfChanger;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Shelves = __webpack_require__(145);
	
	var _Shelves2 = _interopRequireDefault(_Shelves);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabsNav = function (_Component) {
	  _inherits(TabsNav, _Component);
	
	  function TabsNav() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TabsNav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabsNav.__proto__ || Object.getPrototypeOf(TabsNav)).call.apply(_ref, [this].concat(args))), _this), _this.sortShelf = function (shelf) {
	      var shelfBooks = void 0;
	      shelfBooks = _this.props.books.filter(function (book) {
	        return book.shelf === shelf;
	      });
	      return shelfBooks;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TabsNav, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          books = _props.books,
	          transferShelf = _props.transferShelf,
	          search = _props.search,
	          shelf = _props.shelf;
	
	
	      var showBooks = void 0;
	      if (search === false) {
	        showBooks = this.sortShelf(shelf);
	      } else {
	        showBooks = books;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Shelves2.default, { books: showBooks,
	          transferShelf: transferShelf })
	      );
	    }
	  }]);
	
	  return TabsNav;
	}(_react.Component);
	
	TabsNav.propTypes = {
	  books: _propTypes2.default.array.isRequired,
	  transferShelf: _propTypes2.default.func,
	  search: _propTypes2.default.bool.isRequired,
	  shelf: _propTypes2.default.string
	};
	exports.default = TabsNav;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(7);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(138);
	
	var _App = __webpack_require__(244);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(304);
	
	var _webfontloader = __webpack_require__(570);
	
	var _webfontloader2 = _interopRequireDefault(_webfontloader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_webfontloader2.default.load({
	  google: {
	    families: ['Roboto:300,400,500,700', 'Material Icons']
	  }
	});
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRouterDom.BrowserRouter,
	  null,
	  _react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(265), __esModule: true };

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(266), __esModule: true };

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(267), __esModule: true };

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(268), __esModule: true };

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(269), __esModule: true };

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(270), __esModule: true };

/***/ },
/* 258 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(253);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(146);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(255);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(252);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(147);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 262 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(147);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(290);
	module.exports = __webpack_require__(24).Object.assign;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(291);
	var $Object = __webpack_require__(24).Object;
	module.exports = function create(P, D){
	  return $Object.create(P, D);
	};

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(292);
	var $Object = __webpack_require__(24).Object;
	module.exports = function defineProperty(it, key, desc){
	  return $Object.defineProperty(it, key, desc);
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(293);
	module.exports = __webpack_require__(24).Object.getPrototypeOf;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(294);
	module.exports = __webpack_require__(24).Object.setPrototypeOf;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(297);
	__webpack_require__(295);
	__webpack_require__(298);
	__webpack_require__(299);
	module.exports = __webpack_require__(24).Symbol;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(296);
	__webpack_require__(300);
	module.exports = __webpack_require__(99).f('iterator');

/***/ },
/* 271 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(35)
	  , toLength  = __webpack_require__(288)
	  , toIndex   = __webpack_require__(287);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(57)
	  , gOPS    = __webpack_require__(91)
	  , pIE     = __webpack_require__(69);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(29).document && document.documentElement;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(148);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(90)
	  , descriptor     = __webpack_require__(70)
	  , setToStringTag = __webpack_require__(92)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(42)(IteratorPrototype, __webpack_require__(43)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 278 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(57)
	  , toIObject = __webpack_require__(35);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(71)('meta')
	  , isObject = __webpack_require__(56)
	  , has      = __webpack_require__(33)
	  , setDesc  = __webpack_require__(34).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(41)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(57)
	  , gOPS     = __webpack_require__(91)
	  , pIE      = __webpack_require__(69)
	  , toObject = __webpack_require__(96)
	  , IObject  = __webpack_require__(152)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(41)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(34)
	  , anObject = __webpack_require__(55)
	  , getKeys  = __webpack_require__(57);
	
	module.exports = __webpack_require__(31) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(35)
	  , gOPN      = __webpack_require__(155).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(32)
	  , core    = __webpack_require__(24)
	  , fails   = __webpack_require__(41);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(56)
	  , anObject = __webpack_require__(55);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(149)(Function.call, __webpack_require__(154).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(95)
	  , defined   = __webpack_require__(86);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(95)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(95)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(272)
	  , step             = __webpack_require__(278)
	  , Iterators        = __webpack_require__(88)
	  , toIObject        = __webpack_require__(35);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(153)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(32);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(281)});

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(90)});

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(32);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(31), 'Object', {defineProperty: __webpack_require__(34).f});

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(96)
	  , $getPrototypeOf = __webpack_require__(156);
	
	__webpack_require__(284)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(32);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(285).set});

/***/ },
/* 295 */
/***/ function(module, exports) {



/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(286)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(153)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(29)
	  , has            = __webpack_require__(33)
	  , DESCRIPTORS    = __webpack_require__(31)
	  , $export        = __webpack_require__(32)
	  , redefine       = __webpack_require__(158)
	  , META           = __webpack_require__(280).KEY
	  , $fails         = __webpack_require__(41)
	  , shared         = __webpack_require__(94)
	  , setToStringTag = __webpack_require__(92)
	  , uid            = __webpack_require__(71)
	  , wks            = __webpack_require__(43)
	  , wksExt         = __webpack_require__(99)
	  , wksDefine      = __webpack_require__(98)
	  , keyOf          = __webpack_require__(279)
	  , enumKeys       = __webpack_require__(274)
	  , isArray        = __webpack_require__(276)
	  , anObject       = __webpack_require__(55)
	  , toIObject      = __webpack_require__(35)
	  , toPrimitive    = __webpack_require__(97)
	  , createDesc     = __webpack_require__(70)
	  , _create        = __webpack_require__(90)
	  , gOPNExt        = __webpack_require__(283)
	  , $GOPD          = __webpack_require__(154)
	  , $DP            = __webpack_require__(34)
	  , $keys          = __webpack_require__(57)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(155).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(69).f  = $propertyIsEnumerable;
	  __webpack_require__(91).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(89)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(42)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(98)('asyncIterator');

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(98)('observable');

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(289);
	var global        = __webpack_require__(29)
	  , hide          = __webpack_require__(42)
	  , Iterators     = __webpack_require__(88)
	  , TO_STRING_TAG = __webpack_require__(43)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var emptyObject = __webpack_require__(44);
	var _invariant = __webpack_require__(3);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @nosideeffects
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function (Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function (Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function (Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	    },
	    contextTypes: function (Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function (Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function (Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function (Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function () {} };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	         false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	      }
	
	      return;
	    }
	
	    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
	    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);
	
	      var isInherited = name in Constructor;
	      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function (newThis) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	        } else if (!args.length) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedMixin = {
	    componentDidMount: function () {
	      this.__isMounted = true;
	    },
	    componentWillUnmount: function () {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function (newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function () {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function () {};
	  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedMixin);
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 302 */
/***/ function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ },
/* 303 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 304 */
303,
/* 305 */
303,
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(3);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 307 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(307);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(317);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var createArrayFromMixed = __webpack_require__(310);
	var getMarkupWrap = __webpack_require__(312);
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 313 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 314 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(314);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 316 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(316);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 318 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(102);
	
	var _PathUtils = __webpack_require__(58);
	
	var _createTransitionManager = __webpack_require__(103);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    if (basename) path = (0, _PathUtils.stripPrefix)(path, basename);
	
	    return _extends({}, (0, _PathUtils.parsePath)(path), {
	      state: state,
	      key: key
	    });
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(102);
	
	var _PathUtils = __webpack_require__(58);
	
	var _createTransitionManager = __webpack_require__(103);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    if (basename) path = (0, _PathUtils.stripPrefix)(path, basename);
	
	    return (0, _PathUtils.parsePath)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(58);
	
	var _LocationUtils = __webpack_require__(102);
	
	var _createTransitionManager = __webpack_require__(103);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 322 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(324)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 324 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(164);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(164);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(17);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(165);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(17);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	var assign = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(165);
	var checkPropTypes = __webpack_require__(327);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 330 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(10);
	
	var focusNode = __webpack_require__(160);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(60);
	var ExecutionEnvironment = __webpack_require__(15);
	var FallbackCompositionState = __webpack_require__(338);
	var SyntheticCompositionEvent = __webpack_require__(374);
	var SyntheticInputEvent = __webpack_require__(377);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(167);
	var ExecutionEnvironment = __webpack_require__(15);
	var ReactInstrumentation = __webpack_require__(20);
	
	var camelizeStyleName = __webpack_require__(308);
	var dangerousStyleValue = __webpack_require__(383);
	var hyphenateStyleName = __webpack_require__(315);
	var memoizeStringOnly = __webpack_require__(318);
	var warning = __webpack_require__(4);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(59);
	var EventPropagators = __webpack_require__(60);
	var ExecutionEnvironment = __webpack_require__(15);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(21);
	var SyntheticEvent = __webpack_require__(25);
	
	var getEventTarget = __webpack_require__(117);
	var isEventSupported = __webpack_require__(118);
	var isTextInputElement = __webpack_require__(186);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topInput') {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topClick') {
	    return targetInst;
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(46);
	var ExecutionEnvironment = __webpack_require__(15);
	
	var createNodesFromMarkup = __webpack_require__(311);
	var emptyFunction = __webpack_require__(17);
	var invariant = __webpack_require__(3);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 336 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(60);
	var ReactDOMComponentTree = __webpack_require__(10);
	var SyntheticMouseEvent = __webpack_require__(76);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(37);
	
	var getTextContentAccessor = __webpack_require__(183);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(47);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(48);
	
	var instantiateReactComponent = __webpack_require__(185);
	var KeyEscapeUtils = __webpack_require__(109);
	var shouldUpdateReactComponent = __webpack_require__(119);
	var traverseAllChildren = __webpack_require__(188);
	var warning = __webpack_require__(4);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/myreads-react-md"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(142);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(105);
	var ReactDOMIDOperations = __webpack_require__(347);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var React = __webpack_require__(27);
	var ReactComponentEnvironment = __webpack_require__(111);
	var ReactCurrentOwner = __webpack_require__(28);
	var ReactErrorUtils = __webpack_require__(112);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactNodeTypes = __webpack_require__(178);
	var ReactReconciler = __webpack_require__(48);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(44);
	var invariant = __webpack_require__(3);
	var shallowEqual = __webpack_require__(101);
	var shouldUpdateReactComponent = __webpack_require__(119);
	var warning = __webpack_require__(4);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var AutoFocusUtils = __webpack_require__(331);
	var CSSPropertyOperations = __webpack_require__(333);
	var DOMLazyTree = __webpack_require__(46);
	var DOMNamespaces = __webpack_require__(106);
	var DOMProperty = __webpack_require__(47);
	var DOMPropertyOperations = __webpack_require__(169);
	var EventPluginHub = __webpack_require__(59);
	var EventPluginRegistry = __webpack_require__(107);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactDOMComponentFlags = __webpack_require__(171);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMInput = __webpack_require__(348);
	var ReactDOMOption = __webpack_require__(349);
	var ReactDOMSelect = __webpack_require__(172);
	var ReactDOMTextarea = __webpack_require__(352);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactMultiChild = __webpack_require__(361);
	var ReactServerRenderingTransaction = __webpack_require__(366);
	
	var emptyFunction = __webpack_require__(17);
	var escapeTextContentForBrowser = __webpack_require__(78);
	var invariant = __webpack_require__(3);
	var isEventSupported = __webpack_require__(118);
	var shallowEqual = __webpack_require__(101);
	var validateDOMNesting = __webpack_require__(120);
	var warning = __webpack_require__(4);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(120);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(10);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 346 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(105);
	var ReactDOMComponentTree = __webpack_require__(10);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var DOMPropertyOperations = __webpack_require__(169);
	var LinkedValueUtils = __webpack_require__(110);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(21);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        // eslint-disable-next-line
	        if (value != valueAsNumber) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	        // eslint-disable-next-line
	      } else if (value != node.value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var React = __webpack_require__(27);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMSelect = __webpack_require__(172);
	
	var warning = __webpack_require__(4);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var getNodeForCharacterOffset = __webpack_require__(388);
	var getTextContentAccessor = __webpack_require__(183);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var DOMChildrenOperations = __webpack_require__(105);
	var DOMLazyTree = __webpack_require__(46);
	var ReactDOMComponentTree = __webpack_require__(10);
	
	var escapeTextContentForBrowser = __webpack_require__(78);
	var invariant = __webpack_require__(3);
	var validateDOMNesting = __webpack_require__(120);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(6);
	
	var LinkedValueUtils = __webpack_require__(110);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(21);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactUpdates = __webpack_require__(21);
	var Transaction = __webpack_require__(77);
	
	var emptyFunction = __webpack_require__(17);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(330);
	var BeforeInputEventPlugin = __webpack_require__(332);
	var ChangeEventPlugin = __webpack_require__(334);
	var DefaultEventPluginOrder = __webpack_require__(336);
	var EnterLeaveEventPlugin = __webpack_require__(337);
	var HTMLDOMPropertyConfig = __webpack_require__(339);
	var ReactComponentBrowserEnvironment = __webpack_require__(341);
	var ReactDOMComponent = __webpack_require__(343);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactDOMEmptyComponent = __webpack_require__(345);
	var ReactDOMTreeTraversal = __webpack_require__(353);
	var ReactDOMTextComponent = __webpack_require__(351);
	var ReactDefaultBatchingStrategy = __webpack_require__(354);
	var ReactEventListener = __webpack_require__(358);
	var ReactInjection = __webpack_require__(359);
	var ReactReconcileTransaction = __webpack_require__(364);
	var SVGDOMPropertyConfig = __webpack_require__(369);
	var SelectEventPlugin = __webpack_require__(370);
	var SimpleEventPlugin = __webpack_require__(371);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 356 */
237,
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(59);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var EventListener = __webpack_require__(159);
	var ExecutionEnvironment = __webpack_require__(15);
	var PooledClass = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactUpdates = __webpack_require__(21);
	
	var getEventTarget = __webpack_require__(117);
	var getUnboundedScrollPosition = __webpack_require__(313);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(47);
	var EventPluginHub = __webpack_require__(59);
	var EventPluginUtils = __webpack_require__(108);
	var ReactComponentEnvironment = __webpack_require__(111);
	var ReactEmptyComponent = __webpack_require__(173);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactHostComponent = __webpack_require__(175);
	var ReactUpdates = __webpack_require__(21);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(382);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactComponentEnvironment = __webpack_require__(111);
	var ReactInstanceMap = __webpack_require__(61);
	var ReactInstrumentation = __webpack_require__(20);
	
	var ReactCurrentOwner = __webpack_require__(28);
	var ReactReconciler = __webpack_require__(48);
	var ReactChildReconciler = __webpack_require__(340);
	
	var emptyFunction = __webpack_require__(17);
	var flattenChildren = __webpack_require__(385);
	var invariant = __webpack_require__(3);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 363 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var CallbackQueue = __webpack_require__(168);
	var PooledClass = __webpack_require__(37);
	var ReactBrowserEventEmitter = __webpack_require__(75);
	var ReactInputSelection = __webpack_require__(176);
	var ReactInstrumentation = __webpack_require__(20);
	var Transaction = __webpack_require__(77);
	var ReactUpdateQueue = __webpack_require__(113);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(362);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var PooledClass = __webpack_require__(37);
	var Transaction = __webpack_require__(77);
	var ReactInstrumentation = __webpack_require__(20);
	var ReactServerUpdateQueue = __webpack_require__(367);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(113);
	
	var warning = __webpack_require__(4);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 368 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.5.4';

/***/ },
/* 369 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(60);
	var ExecutionEnvironment = __webpack_require__(15);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInputSelection = __webpack_require__(176);
	var SyntheticEvent = __webpack_require__(25);
	
	var getActiveElement = __webpack_require__(161);
	var isTextInputElement = __webpack_require__(186);
	var shallowEqual = __webpack_require__(101);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventListener = __webpack_require__(159);
	var EventPropagators = __webpack_require__(60);
	var ReactDOMComponentTree = __webpack_require__(10);
	var SyntheticAnimationEvent = __webpack_require__(372);
	var SyntheticClipboardEvent = __webpack_require__(373);
	var SyntheticEvent = __webpack_require__(25);
	var SyntheticFocusEvent = __webpack_require__(376);
	var SyntheticKeyboardEvent = __webpack_require__(378);
	var SyntheticMouseEvent = __webpack_require__(76);
	var SyntheticDragEvent = __webpack_require__(375);
	var SyntheticTouchEvent = __webpack_require__(379);
	var SyntheticTransitionEvent = __webpack_require__(380);
	var SyntheticUIEvent = __webpack_require__(62);
	var SyntheticWheelEvent = __webpack_require__(381);
	
	var emptyFunction = __webpack_require__(17);
	var getEventCharCode = __webpack_require__(115);
	var invariant = __webpack_require__(3);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(76);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	
	var getEventCharCode = __webpack_require__(115);
	var getEventKey = __webpack_require__(386);
	var getEventModifierState = __webpack_require__(116);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(62);
	
	var getEventModifierState = __webpack_require__(116);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(76);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 382 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(167);
	var warning = __webpack_require__(4);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(28);
	var ReactDOMComponentTree = __webpack_require__(10);
	var ReactInstanceMap = __webpack_require__(61);
	
	var getHostComponentFromComposite = __webpack_require__(182);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(109);
	var traverseAllChildren = __webpack_require__(188);
	var warning = __webpack_require__(4);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/myreads-react-md"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(142);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(115);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 387 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 388 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(78);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(177);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(393);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(17);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var ReactPropTypesSecret = __webpack_require__(394);
	var checkPropTypes = __webpack_require__(391);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 394 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(36), __webpack_require__(2), __webpack_require__(14), __webpack_require__(12), __webpack_require__(11), __webpack_require__(65), __webpack_require__(66), __webpack_require__(52)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('react-addons-css-transition-group'), require('classnames'), require('../utils/PropTypes/controlled'), require('../utils/getField'), require('../constants/keyCodes'), require('../Lists/ListItem'), require('../Menus/Menu'), require('../TextFields/TextField'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.reactAddonsCssTransitionGroup, global.classnames, global.controlled, global.getField, global.keyCodes, global.ListItem, global.Menu, global.TextField);
	    global.Autocomplete = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _reactAddonsCssTransitionGroup, _classnames, _controlled, _getField, _keyCodes, _ListItem, _Menu, _TextField) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _ListItem2 = _interopRequireDefault(_ListItem);
	
	  var _Menu2 = _interopRequireDefault(_Menu);
	
	  var _TextField2 = _interopRequireDefault(_TextField);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Autocomplete = function (_PureComponent) {
	    _inherits(Autocomplete, _PureComponent);
	
	    _createClass(Autocomplete, null, [{
	      key: 'caseInsensitiveFilter',
	      value: function caseInsensitiveFilter(haystack, filterText, dataLabel) {
	        var needle = filterText.toLowerCase();
	
	        return haystack.filter(function (hay) {
	          if (hay === null || typeof hay === 'undefined') {
	            return false;
	          } else if (_react2.default.isValidElement(hay)) {
	            return true;
	          }
	
	          var value = void 0;
	          switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
	            case 'string':
	            case 'number':
	              value = hay.toString();
	              break;
	            default:
	              value = hay[dataLabel];
	          }
	
	          return value && value.toLowerCase().indexOf(needle) !== -1;
	        });
	      }
	    }, {
	      key: 'fuzzyFilter',
	      value: function fuzzyFilter(haystack, needle, dataLabel) {
	        // Create an amazing regex that matches the letters in order
	        // and escapes any strings that could be part of a regex.
	        var reg = new RegExp(('' + needle).split('').join('\\w*').replace(/(\(|\||\)|\\(?!w\*)|\[|\|-|\.|\^|\+|\$|\?|^(?!w)\*)/g, '\\$1')
	        // Couldn't get the matching of two '*' working, so replace them here..
	        .replace(/\*\*/g, '*\\*'), 'i');
	
	        return haystack.filter(function (hay) {
	          if (hay === null || typeof hay === 'undefined') {
	            return false;
	          } else if (_react2.default.isValidElement(hay)) {
	            return true;
	          }
	
	          var value = void 0;
	          switch (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) {
	            case 'string':
	            case 'number':
	              value = hay.toString();
	              break;
	            default:
	              value = hay[dataLabel];
	          }
	
	          return value && value.match(reg);
	        });
	      }
	    }, {
	      key: 'findIgnoreCase',
	      value: function findIgnoreCase(haystack, value, dataLabel) {
	        var needle = value ? value.toLowerCase() : '';
	
	        if (!needle) {
	          return needle;
	        }
	
	        var suggestion = '';
	        haystack.some(function (hay) {
	          if (hay === null || typeof hay === 'undefined' || _react2.default.isValidElement(hay)) {
	            return false;
	          }
	
	          var hayStr = (typeof hay === 'undefined' ? 'undefined' : _typeof(hay)) === 'object' ? hay[dataLabel] : hay.toString();
	
	          if (hayStr.toLowerCase().indexOf(needle) === 0) {
	            suggestion = hayStr;
	          }
	
	          return suggestion;
	        });
	
	        return suggestion;
	      }
	    }]);
	
	    function Autocomplete(props) {
	      _classCallCheck(this, Autocomplete);
	
	      var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));
	
	      var defaultValue = props.defaultValue,
	          data = props.data,
	          dataLabel = props.dataLabel,
	          filter = props.filter;
	
	
	      _this.state = {
	        value: defaultValue,
	        matches: defaultValue && filter ? filter(data, defaultValue, dataLabel) : [],
	        isOpen: false,
	        matchIndex: -1,
	        manualFocus: false,
	        suggestionIndex: -1
	      };
	
	      _this._setField = _this._setField.bind(_this);
	      _this._setMenu = _this._setMenu.bind(_this);
	      _this._setSuggestion = _this._setSuggestion.bind(_this);
	      _this._close = _this._close.bind(_this);
	      _this._updateFont = _this._updateFont.bind(_this);
	      _this._handleBlur = _this._handleBlur.bind(_this);
	      _this._handleFocus = _this._handleFocus.bind(_this);
	      _this._handleClick = _this._handleClick.bind(_this);
	      _this._handleChange = _this._handleChange.bind(_this);
	      _this._handleItemClick = _this._handleItemClick.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      _this._handleMenuKeyDown = _this._handleMenuKeyDown.bind(_this);
	      _this._handleTextFieldKeyDown = _this._handleTextFieldKeyDown.bind(_this);
	      _this._focusSuggestion = _this._focusSuggestion.bind(_this);
	      _this._findInlineSuggestions = _this._findInlineSuggestions.bind(_this);
	      _this._mapToListItem = _this._mapToListItem.bind(_this);
	      _this._toggleMenu = _this._toggleMenu.bind(_this);
	      _this._updateSuggestionStyle = _this._updateSuggestionStyle.bind(_this);
	      return _this;
	    }
	
	    _createClass(Autocomplete, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.inline) {
	          window.addEventListener('resize', this._updateFont);
	        }
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        if (this.state.isOpen !== nextState.isOpen) {
	          var menuFn = nextProps['onMenu' + (nextState.isOpen ? 'Open' : 'Close')];
	          if (menuFn) {
	            menuFn();
	          }
	        }
	
	        if (this.props.inline !== nextProps.inline) {
	          if (nextProps.inline) {
	            this._updateFont();
	            window.addEventListener('resize', this._updateFont);
	          } else {
	            window.removeEventListener('resize', this._updateFont);
	          }
	        }
	
	        if (nextProps.data !== this.props.data || nextProps.value !== this.props.value) {
	          var data = nextProps.data,
	              filter = nextProps.filter,
	              dataLabel = nextProps.dataLabel;
	
	          var value = (0, _getField2.default)(nextProps, nextState, 'value');
	
	          var matches = filter ? filter(data, value, dataLabel) : data;
	          var next = { matches: matches };
	          if (value && nextState.focus && matches.length) {
	            next.isOpen = true;
	          }
	
	          this.setState(next);
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var suggestion = this.state.suggestion;
	
	        this._updateSuggestionStyle(suggestion && !prevState.suggestion, !suggestion && prevState.suggestion);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.props.inline) {
	          window.removeEventListener('resize', this._updateFont);
	        }
	      }
	    }, {
	      key: '_updateSuggestionStyle',
	      value: function _updateSuggestionStyle(isNew, isDeleted) {
	        if (isNew) {
	          var msg = (0, _reactDom.findDOMNode)(this).querySelector('.md-text-field-message');
	
	          if (msg) {
	            var cs = window.getComputedStyle(this._suggestion);
	            var bottom = parseInt(cs.getPropertyValue('bottom'), 10) + msg.offsetHeight;
	
	            this.setState({
	              suggestionStyle: Object.assign({}, this.state.suggestionStyle, { bottom: bottom })
	            });
	          }
	        } else if (isDeleted) {
	          var suggestionStyle = Object.assign({}, this.state.suggestionStyle);
	          delete suggestionStyle.bottom;
	
	          this.setState({ suggestionStyle: suggestionStyle });
	        }
	      }
	    }, {
	      key: '_updateFont',
	      value: function _updateFont() {
	        if (this._field) {
	          var cs = window.getComputedStyle(this._field);
	          this.setState({
	            fontSize: parseInt(cs.getPropertyValue('font-size'), 10),
	            font: cs.getPropertyValue('font')
	          });
	        }
	      }
	    }, {
	      key: '_close',
	      value: function _close() {
	        if (this.props.onBlur) {
	          this.props.onBlur();
	        }
	
	        this.setState({ focus: false, isOpen: false });
	      }
	    }, {
	      key: '_handleChange',
	      value: function _handleChange(value, event) {
	        var _props = this.props,
	            onChange = _props.onChange,
	            filter = _props.filter,
	            findInlineSuggestion = _props.findInlineSuggestion,
	            data = _props.data,
	            dataLabel = _props.dataLabel,
	            inline = _props.inline;
	
	
	        if (onChange) {
	          onChange(value, event);
	        }
	
	        if (inline) {
	          // If findInlineSuggestion does not exist, assume that `onChange` will handle it.
	          return findInlineSuggestion ? this._findInlineSuggestions(value) : null;
	        }
	
	        var matches = value ? this.state.matches : [];
	        if (value && filter) {
	          matches = filter(data, value, dataLabel);
	        }
	
	        return this.setState({ matches: matches, isOpen: !!matches.length, value: value });
	      }
	    }, {
	      key: '_handleFocus',
	      value: function _handleFocus(e) {
	        if (this.props.onFocus) {
	          this.props.onFocus(e);
	        }
	
	        this.setState({
	          matchIndex: -1,
	          isOpen: !this.state.manualFocus && !!(0, _getField2.default)(this.props, this.state, 'value') && !!this.state.matches.length,
	          manualFocus: false,
	          focus: true
	        });
	      }
	    }, {
	      key: '_handleBlur',
	      value: function _handleBlur(e) {
	        if (this.props.inline) {
	          if (this.props.onBlur) {
	            this.props.onBlur(e);
	          }
	
	          this.setState({ focus: false });
	        }
	      }
	    }, {
	      key: '_handleTextFieldKeyDown',
	      value: function _handleTextFieldKeyDown(e) {
	        var _props2 = this.props,
	            inline = _props2.inline,
	            data = _props2.data,
	            dataLabel = _props2.dataLabel,
	            onKeyDown = _props2.onKeyDown,
	            onAutocomplete = _props2.onAutocomplete;
	        var suggestionIndex = this.state.suggestionIndex;
	
	
	        var key = e.which || e.keyCode;
	        if (onKeyDown) {
	          onKeyDown(e);
	        }
	
	        if (inline && key === _keyCodes.TAB && suggestionIndex !== -1) {
	          // Autocomplete the text field
	          e.preventDefault();
	
	          var value = data[suggestionIndex];
	          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	            value = value[dataLabel];
	          }
	
	          if (onAutocomplete) {
	            onAutocomplete(value, suggestionIndex, this.state.matches);
	          }
	
	          this.setState({
	            value: value,
	            suggestion: '',
	            suggestionIndex: -1,
	            tabbed: true
	          });
	        }
	      }
	    }, {
	      key: '_handleMenuKeyDown',
	      value: function _handleMenuKeyDown(e) {
	        var key = e.which || e.keyCode;
	        if (key === _keyCodes.TAB) {
	          if (this.props.onBlur) {
	            this.props.onBlur();
	          }
	
	          this.setState({ isOpen: false });
	        } else if (key === _keyCodes.UP || key === _keyCodes.DOWN) {
	          this._focusSuggestion(key === _keyCodes.UP, e);
	        } else if ((key === _keyCodes.ENTER || key === _keyCodes.SPACE) && e.target.classList.contains('md-list-tile')) {
	          // Prevent any form submissions
	          e.preventDefault();
	
	          // Need to emulate the click event since the default enter/space don't work for some reason
	          e.target.click();
	          this._handleItemClick(this.state.matchIndex);
	        }
	      }
	    }, {
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        var target = e.target;
	        while (target && target.parentNode) {
	          if (target.classList.contains('md-list-item')) {
	            var items = target.parentNode.querySelectorAll('.md-list-item');
	            items = Array.prototype.slice.call(items);
	
	            return this._handleItemClick(items.indexOf(target));
	          }
	
	          target = target.parentNode;
	        }
	
	        return null;
	      }
	    }, {
	      key: '_handleItemClick',
	      value: function _handleItemClick(index) {
	        var _this2 = this;
	
	        if (index === -1) {
	          return;
	        }
	
	        var matches = this.state.matches;
	        var _props3 = this.props,
	            data = _props3.data,
	            dataLabel = _props3.dataLabel,
	            filter = _props3.filter,
	            onAutocomplete = _props3.onAutocomplete,
	            clearOnAutocomplete = _props3.clearOnAutocomplete;
	
	        var value = matches.filter(function (m) {
	          return !_react2.default.isValidElement(m);
	        })[index];
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	          value = value[dataLabel];
	        }
	
	        if (onAutocomplete) {
	          onAutocomplete(value, index, matches);
	        }
	
	        value = clearOnAutocomplete ? '' : value;
	        this.setState({
	          isOpen: false,
	          manualFocus: true,
	          matches: filter ? filter(data, value, dataLabel) : matches,
	          value: value
	        }, function () {
	          _this2._field.focus();
	        });
	      }
	    }, {
	      key: '_focusSuggestion',
	      value: function _focusSuggestion(negative, e) {
	        e.preventDefault();
	        var _state = this.state,
	            matchIndex = _state.matchIndex,
	            matches = _state.matches;
	
	        var l = matches.length;
	
	        var index = void 0;
	        if (negative && matchIndex === -1 || !negative && matchIndex >= l) {
	          return;
	        } else if (negative) {
	          index = matchIndex - 1;
	          if (index === -1) {
	            this._field.focus();
	          }
	        } else {
	          index = Math.min(l, matchIndex + 1);
	        }
	
	        if (index !== -1 && index !== matchIndex) {
	          var item = this._menu.querySelectorAll('.md-list-tile')[index];
	          if (item) {
	            item.focus();
	          }
	        }
	
	        this.setState({ matchIndex: index });
	      }
	    }, {
	      key: '_findInlineSuggestions',
	      value: function _findInlineSuggestions(value) {
	        var _props4 = this.props,
	            data = _props4.data,
	            dataLabel = _props4.dataLabel,
	            findInlineSuggestion = _props4.findInlineSuggestion;
	        var _state2 = this.state,
	            font = _state2.font,
	            fontSize = _state2.fontSize;
	        var suggestionStyle = this.state.suggestionStyle;
	
	
	        var suggestion = findInlineSuggestion(data, value, dataLabel);
	        if ((typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
	          throw new Error('`findInlineSuggestion` should return a string or a number, but got an object.', suggestion);
	        }
	
	        var suggestionIndex = -1;
	
	        if (suggestion) {
	          // Find index of suggestion
	          data.some(function (datum, i) {
	            var d = (typeof dataum === 'undefined' ? 'undefined' : _typeof(dataum)) === 'object' ? datum[dataLabel] : datum;
	            if (d === suggestion) {
	              suggestionIndex = i;
	            }
	
	            return suggestionIndex !== -1;
	          });
	
	          // Strip already used letters
	          suggestion = suggestion.toString().substring(value.length, suggestion.length);
	
	          // Calculate distance to move the suggestion to already existing text
	          var canvas = document.createElement('canvas');
	          var context = canvas.getContext('2d');
	
	          if (context) {
	            // context doesn't exist in jsdom with jest
	            context.font = font;
	            var padding = this.props.block ? fontSize * 1.5 : 8;
	
	            // Update suggestion style to be offset and not expand past text field
	            var left = context.measureText(value).width + padding;
	            suggestionStyle = Object.assign({}, suggestionStyle, { left: left });
	          }
	        }
	
	        this.setState({ value: value, suggestion: suggestion, suggestionIndex: suggestionIndex, suggestionStyle: suggestionStyle, tabbed: false });
	      }
	    }, {
	      key: '_mapToListItem',
	      value: function _mapToListItem(match) {
	        if (_react2.default.isValidElement(match)) {
	          return match;
	        }
	
	        var _props5 = this.props,
	            dataLabel = _props5.dataLabel,
	            dataValue = _props5.dataValue,
	            deleteKeys = _props5.deleteKeys;
	
	        var props = void 0;
	        switch (typeof match === 'undefined' ? 'undefined' : _typeof(match)) {
	          case 'string':
	          case 'number':
	            props = {
	              key: match,
	              primaryText: match
	            };
	            break;
	          default:
	            props = _extends({}, match, {
	              key: match.key || dataValue && match[dataValue] || match[dataLabel],
	              primaryText: match[dataLabel]
	            });
	
	            if (typeof deleteKeys === 'string') {
	              delete props[deleteKeys];
	            } else if (Array.isArray(deleteKeys)) {
	              deleteKeys.forEach(function (key) {
	                delete props[key];
	              });
	            }
	
	        }
	
	        // Allows focus, but does not let tab focus. This is so up and down keys work.
	        return _react2.default.createElement(_ListItem2.default, _extends({ tabIndex: -1 }, props));
	      }
	    }, {
	      key: '_toggleMenu',
	      value: function _toggleMenu(e) {
	        if (this.props.onMouseDown) {
	          this.props.onMouseDown(e);
	        }
	
	        if (!this.props.inline && this.state.matches.length && (0, _getField2.default)(this.props, this.state, 'value')) {
	          this.setState({ isOpen: !this.state.isOpen });
	        }
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        var target = e.target;
	        var _props6 = this.props,
	            data = _props6.data,
	            dataLabel = _props6.dataLabel,
	            onAutocomplete = _props6.onAutocomplete;
	        var _state3 = this.state,
	            suggestionIndex = _state3.suggestionIndex,
	            suggestion = _state3.suggestion;
	
	        if (target.classList.contains('md-autocomplete-suggestion') && suggestion) {
	          var value = data[suggestionIndex];
	          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	            value = value[dataLabel];
	          }
	
	          if (onAutocomplete) {
	            onAutocomplete(value, suggestionIndex, data);
	          }
	
	          this.setState({
	            value: value,
	            suggestion: '',
	            suggestionIndex: -1,
	            tabbed: true
	          });
	        }
	      }
	    }, {
	      key: '_setField',
	      value: function _setField(field) {
	        if (field) {
	          this._field = field.getField();
	
	          if (this.props.inline) {
	            this._updateFont();
	          }
	        }
	      }
	    }, {
	      key: '_setMenu',
	      value: function _setMenu(menu) {
	        this._menu = (0, _reactDom.findDOMNode)(menu);
	      }
	    }, {
	      key: '_setSuggestion',
	      value: function _setSuggestion(suggestion) {
	        this._suggestion = suggestion;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state4 = this.state,
	            isOpen = _state4.isOpen,
	            matches = _state4.matches,
	            tabbed = _state4.tabbed,
	            focus = _state4.focus,
	            suggestionStyle = _state4.suggestionStyle;
	
	        var _props7 = this.props,
	            fullWidth = _props7.fullWidth,
	            block = _props7.block,
	            style = _props7.style,
	            className = _props7.className,
	            listStyle = _props7.listStyle,
	            listClassName = _props7.listClassName,
	            textFieldStyle = _props7.textFieldStyle,
	            textFieldClassName = _props7.textFieldClassName,
	            inline = _props7.inline,
	            props = _objectWithoutProperties(_props7, ['fullWidth', 'block', 'style', 'className', 'listStyle', 'listClassName', 'textFieldStyle', 'textFieldClassName', 'inline']);
	
	        delete props.value;
	        delete props.defaultValue;
	        delete props.dataLabel;
	        delete props.dataValue;
	        delete props.filter;
	        delete props.data;
	        delete props.onAutocomplete;
	        delete props.onMenuOpen;
	        delete props.onMenuClose;
	        delete props.onBlur;
	        delete props.onFocus;
	        delete props.onKeyDown;
	        delete props.onMouseDown;
	        delete props.onChange;
	        delete props.findInlineSuggestion;
	        delete props.clearOnAutocomplete;
	        delete props.deleteKeys;
	
	        var value = (0, _getField2.default)(this.props, this.state, 'value');
	
	        var autocomplete = _react2.default.createElement(_TextField2.default, _extends({}, props, {
	          style: textFieldStyle,
	          className: (0, _classnames2.default)('md-autocomplete', textFieldClassName),
	          key: 'autocomplete',
	          ref: this._setField,
	          value: value,
	          onKeyDown: this._handleTextFieldKeyDown,
	          onMouseDown: this._toggleMenu,
	          onChange: this._handleChange,
	          onFocus: this._handleFocus,
	          onBlur: this._handleBlur,
	          fullWidth: fullWidth,
	          block: block
	        }));
	
	        if (inline) {
	          var suggestion = void 0;
	          if (focus && this.state.suggestion) {
	            suggestion = _react2.default.createElement(
	              'span',
	              {
	                ref: this._setSuggestion,
	                key: 'suggestion',
	                style: suggestionStyle,
	                className: (0, _classnames2.default)('md-autocomplete-suggestion', {
	                  'md-autocomplete-suggestion--floating': props.label,
	                  'md-autocomplete-suggestion--block': block
	                })
	              },
	              this.state.suggestion
	            );
	          }
	
	          return _react2.default.createElement(
	            _reactAddonsCssTransitionGroup2.default,
	            {
	              component: 'div',
	              style: style,
	              className: (0, _classnames2.default)('md-menu-container md-autocomplete-container', className, {
	                'md-full-width': fullWidth || block
	              }),
	              transitionName: 'opacity',
	              transitionEnterTimeout: 150,
	              transitionLeave: !tabbed,
	              transitionLeaveTimeout: 150,
	              onTouchStart: this._handleTouchStart
	            },
	            autocomplete,
	            suggestion
	          );
	        }
	
	        return _react2.default.createElement(
	          _Menu2.default,
	          {
	            ref: this._setMenu,
	            toggle: autocomplete,
	            isOpen: isOpen,
	            onClick: this._handleClick,
	            onClose: this._close,
	            onKeyDown: this._handleMenuKeyDown,
	            position: _Menu2.default.Positions.BELOW,
	            fullWidth: fullWidth || block,
	            style: style,
	            className: (0, _classnames2.default)('md-autocomplete-container', className),
	            listStyle: listStyle,
	            listClassName: (0, _classnames2.default)('md-autocomplete-list', listClassName)
	          },
	          matches.map(this._mapToListItem)
	        );
	      }
	    }]);
	
	    return Autocomplete;
	  }(_react.PureComponent);
	
	  Autocomplete.propTypes = {
	    /**
	     * An optional style to apply to the menu that contains the autocomplete.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the menu that contains the autocomplete.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the autocomplete's text field.
	     */
	    textFieldStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the autocomplete's text field.
	     */
	    textFieldClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the autocomplete's text field input itself.
	     */
	    inputStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the autocomplete's input field iteself.
	     */
	    inputClassName: _react.PropTypes.string,
	
	    /**
	     * The optional style to apply to the opened menu List if the
	     * `Autocomplete` is not using `inline` suggestions.
	     */
	    listStyle: _react.PropTypes.object,
	
	    /**
	     * The optional className to apply to the opened menu List if the
	     * `Autocomplete` is not using `inline` suggestions.
	     */
	    listClassName: _react.PropTypes.string,
	
	    /**
	     * Boolean if the autocomplete is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * A label to display with the autocomplete.
	     */
	    label: _react.PropTypes.string,
	
	    /**
	     * An optional value to use for the text field. This will force this component
	     * to be controlled and require the `onChange` function.
	     */
	    value: (0, _controlled2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]), 'onChange'),
	
	    /**
	     * The default value for the autocomplete's text field.
	     */
	    defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	    /**
	     * An object key to use to extract the text to be compared for filtering.
	     * This will only be applied if the the given `data` prop is an array of objects.
	     */
	    dataLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * An optional object key to use to extract the `value` of the given `data` prop.
	     * This is really only used with generating a unique react key. The unique react
	     * key with either be:
	     * - the datum if it is a string or number
	     * - the `key` attribute of the datum object
	     * - the `datum[dataValue]`
	     * - or the `datum[dataLabel]`
	     */
	    dataValue: _react.PropTypes.string,
	
	    /**
	     * A single key or an array of keys to delete from your data object before passing
	     * to the `ListItem` component.
	     */
	    deleteKeys: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]),
	
	    /**
	     * The data that will be used for autocomplete suggestions. This can either be
	     * an array of string, number, or object. If it is an array of objects, the key
	     * `dataLabel` is required.
	     *
	     * ```docgen
	     * PropTypes.arrayOf(PropTypes.oneOfType([
	     *   PropTypes.element,
	     *   PropTypes.string,
	     *   PropTypes.number,
	     *   PropTypes.shape({
	     *     [dataLabel]: PropTypes.oneOfType([
	     *       PropTypes.string,
	     *       PropTypes.number,
	     *     ]).isRequired,
	     *   }),
	     * ])).isRequired
	     * ```
	     */
	    data: function data(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      var _PropTypes$arrayOf;
	
	      var dataLabel = props.dataLabel;
	
	      return (_PropTypes$arrayOf = _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.shape(_defineProperty({}, dataLabel, _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]).isRequired))]))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(others));
	    },
	
	    /**
	     * An optional function to use to filter the `data`. If you have a sexy backend
	     * using solr or some other seach/indexer, it is recommended to set this prop to
	     * `null` or `false`-ish.
	     */
	    filter: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `Autocomplete`'s text field has a `keydown` event.
	     */
	    onKeyDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `Autocomplete`'s text field has a `mousedown` event.
	     */
	    onMouseDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `Autocomplete`'s text field value changes.
	     * The callback will be given the new value and the change event.
	     *
	     * `onChange(textFeldValue, event)`
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `Autocomplete`'s text field is focused.
	     */
	    onFocus: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the entire `Autocomplete` component is blurred.
	     * This will be triggered when the window is clicked or when a user tabs away from
	     * the autocomplete.
	     */
	    onBlur: _react.PropTypes.func,
	
	    /**
	     * Boolean if this text field should be styled as a full width text field.
	     * Floating labels and the text field indicator will be removed automatically.
	     */
	    block: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the autocomplete should span the entire width.
	     */
	    fullWidth: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `Autocomplete` should display suggestions inline instead
	     * of in a `Menu`.
	     */
	    inline: _react.PropTypes.bool,
	
	    /**
	     * The function to call to find a suggestion for an inline autocomplete. This function
	     * expects to return a single result of a number or a string.
	     *
	     * ```js
	     * @param {Array<Object|String|Number>} data - The data prop to search.
	     * @param {String} value - The current value to use for searching.
	     * @param {String} dataLabel - The `dataLabel` prop to use if a datum is an object.
	     * @return {String|Number} the found suggestion or false-ish
	     * ```
	     */
	    findInlineSuggestion: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when an autocomplete suggestion is clicked either
	     * by using the mouse, the enter/space key, or touch. The match index and current
	     * `dataLabel` will be given back.
	     *
	     * `onAutocomplete(suggestion[dataLabel] || suggestion, suggestionIndex, matches);`
	     */
	    onAutocomplete: _react.PropTypes.func,
	
	    /**
	     * A boolean if the text field's value should be reset to the empty string when
	     * an item is auto-completed. This is usefull if you do not want a fully controlled
	     * component and the values are stored outside of the `TextField`. (like `Chips`).
	     */
	    clearOnAutocomplete: _react.PropTypes.bool,
	
	    /**
	     * An optional function to call when the `Autocomplete` suggestion menu opens.
	     */
	    onMenuOpen: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `Autocomplete` suggestion menu closes.
	     */
	    onMenuClose: _react.PropTypes.func,
	
	    /**
	     * This prop is used for disabling the browser's default autocomplete suggestions
	     * of previously typed values in the text field. By default, this is disabled.
	     */
	    autoComplete: _react.PropTypes.oneOf(['on', 'off'])
	  };
	  Autocomplete.defaultProps = {
	    fullWidth: true,
	    defaultValue: '',
	    dataLabel: 'primaryText',
	    filter: Autocomplete.fuzzyFilter,
	    findInlineSuggestion: Autocomplete.findIgnoreCase,
	    autoComplete: 'off'
	  };
	  exports.default = Autocomplete;
	});

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(395)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Autocomplete'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Autocomplete);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Autocomplete) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Autocomplete2.default;
	});

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(518)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../utils/PropTypes/oneRequiredForA11yIf'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.oneRequiredForA11yIf);
	    global.Avatar = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _oneRequiredForA11yIf) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _oneRequiredForA11yIf2 = _interopRequireDefault(_oneRequiredForA11yIf);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Avatar = function (_PureComponent) {
	    _inherits(Avatar, _PureComponent);
	
	    function Avatar(props) {
	      _classCallCheck(this, Avatar);
	
	      var _this = _possibleConstructorReturn(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call(this, props));
	
	      _this.state = { color: null };
	
	      _this._setRandomColor = _this._setRandomColor.bind(_this);
	      return _this;
	    }
	
	    _createClass(Avatar, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        if (this.props.random) {
	          this._setRandomColor();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (nextProps.random && (this.props.src !== nextProps.src || this.props.icon !== nextProps.icon)) {
	          this._setRandomColor();
	        } else if (this.props.random && !nextProps.random) {
	          this.setState({ color: null });
	        }
	      }
	    }, {
	      key: '_setRandomColor',
	      value: function _setRandomColor() {
	        var suffixes = this.props.suffixes;
	
	
	        var i = Math.floor(Math.random() * (suffixes.length - 1)) + 1;
	        this.setState({ color: suffixes[i] });
	      }
	    }, {
	      key: '_getColor',
	      value: function _getColor(suffix, suffixes, color) {
	        if (suffix) {
	          return 'md-avatar--' + suffix;
	        } else if (!!suffixes && !color) {
	          return 'md-avatar--default';
	        }
	
	        return 'md-avatar--' + color;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            src = _props.src,
	            alt = _props.alt,
	            icon = _props.icon,
	            children = _props.children,
	            suffix = _props.suffix,
	            suffixes = _props.suffixes,
	            iconSized = _props.iconSized,
	            role = _props.role,
	            props = _objectWithoutProperties(_props, ['className', 'src', 'alt', 'icon', 'children', 'suffix', 'suffixes', 'iconSized', 'role']);
	
	        delete props.random;
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-inline-block md-avatar', this._getColor(suffix, suffixes, this.state.color), {
	              'md-avatar--icon-sized': iconSized
	            }, className)
	          }),
	          src && _react2.default.createElement('img', { src: src, alt: alt, role: role, className: 'md-avatar-img' }),
	          !src && _react2.default.createElement(
	            'div',
	            { className: 'md-avatar-content' },
	            icon || children
	          )
	        );
	      }
	    }]);
	
	    return Avatar;
	  }(_react.PureComponent);
	
	  Avatar.propTypes = {
	    /**
	     * An optional className to apply to the avatar.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional image source to use for the avatar.
	     */
	    src: _react.PropTypes.string,
	
	    /**
	     * An optional image alt to use for the avatar if it is
	     * an image.
	     */
	    alt: _react.PropTypes.string,
	
	    /**
	     * An optional `FontIcon` to convert into an avatar.
	     */
	    icon: _react.PropTypes.node,
	
	    /**
	     * An optional letter to display in the avatar.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * A boolean if a random color should be applied to the avatar.
	     * This will be one of the `suffixes`.
	     */
	    random: _react.PropTypes.bool,
	
	    /**
	     * A list of available suffixes to use when generating a random
	     * color for the avatar.
	     */
	    suffixes: _react.PropTypes.arrayOf(_react.PropTypes.string),
	
	    /**
	     * The suffix to use for a color. This can be any value but
	     * *should* be one of the available `suffixes`.
	     */
	    suffix: _react.PropTypes.string,
	
	    /**
	     * Boolean if the `Avatar` should be sized to a `FontIcon` size. This
	     * will just set the width and height to the `$md-font-icon-size`.
	     */
	    iconSized: _react.PropTypes.bool,
	
	    /**
	     * A role for the avatar's image. When the `src` prop is set, either a `role` of `presentation`
	     * or the `alt` prop must be defined for a11y.
	     */
	    role: (0, _oneRequiredForA11yIf2.default)(_react.PropTypes.oneOf(['presentation']), 'src', 'alt')
	  };
	  Avatar.defaultProps = {
	    suffixes: ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'yellow', 'amber', 'orange', 'deep-orange', 'brown', 'grey', 'blue-grey']
	  };
	  exports.default = Avatar;
	});

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(397)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Avatar'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Avatar);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Avatar) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Avatar2 = _interopRequireDefault(_Avatar);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Avatar2.default;
	});

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(22), __webpack_require__(38), __webpack_require__(127)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Helpers/AccessibleFakeInkedButton'), require('../Helpers/Collapse'), require('../FontIcons'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.AccessibleFakeInkedButton, global.Collapse, global.FontIcons);
	    global.BottomNav = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _AccessibleFakeInkedButton, _Collapse, _FontIcons) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	  var _Collapse2 = _interopRequireDefault(_Collapse);
	
	  var _FontIcons2 = _interopRequireDefault(_FontIcons);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var BottomNav = function (_PureComponent) {
	    _inherits(BottomNav, _PureComponent);
	
	    function BottomNav(props) {
	      _classCallCheck(this, BottomNav);
	
	      var _this = _possibleConstructorReturn(this, (BottomNav.__proto__ || Object.getPrototypeOf(BottomNav)).call(this, props));
	
	      _this.state = {};
	      _this._handleClick = _this._handleClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(BottomNav, [{
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        var _props = this.props,
	            onClick = _props.onClick,
	            onNavChange = _props.onNavChange,
	            index = _props.index;
	
	        if (onClick) {
	          onClick(index, e);
	        }
	
	        if (onNavChange) {
	          onNavChange(index, e);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            active = _props2.active,
	            fixed = _props2.fixed,
	            className = _props2.className,
	            iconClassName = _props2.iconClassName,
	            iconChildren = _props2.iconChildren,
	            colored = _props2.colored,
	            props = _objectWithoutProperties(_props2, ['active', 'fixed', 'className', 'iconClassName', 'iconChildren', 'colored']);
	
	        delete props.index;
	        delete props.label;
	        delete props.onClick;
	        delete props.onNavChange;
	
	        var label = this.props.label;
	
	        var labelClassName = (0, _classnames2.default)('md-bottom-nav-label', { 'md-bottom-nav-label--shifting-inactive': !active && !fixed });
	        if (_react.Children.count(label) === 1 && (0, _react.isValidElement)(label)) {
	          var labelEl = _react.Children.only(label);
	          label = (0, _react.cloneElement)(label, {
	            className: (0, _classnames2.default)(labelClassName, labelEl.props.className)
	          });
	        } else {
	          label = _react2.default.createElement(
	            'div',
	            { className: labelClassName },
	            label
	          );
	        }
	
	        return _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          _extends({}, props, {
	            onClick: this._handleClick,
	            className: (0, _classnames2.default)('md-bottom-nav', {
	              'md-bottom-nav--active': active,
	              'md-bottom-nav--fixed': fixed,
	              'md-bottom-nav--shifting': !fixed,
	              'md-bottom-nav--shifting-active': !fixed && active,
	              'md-bottom-nav--shifting-inactive': !fixed && !active,
	              'md-text': !active && !colored,
	              'md-text--theme-primary': active && !colored
	            }, className)
	          }),
	          _react2.default.createElement(
	            _FontIcons2.default,
	            { iconClassName: iconClassName, className: 'md-icon--inherit' },
	            iconChildren
	          ),
	          _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: !fixed && !active },
	            label
	          )
	        );
	      }
	    }]);
	
	    return BottomNav;
	  }(_react.PureComponent);
	
	  BottomNav.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
	    active: _react.PropTypes.bool,
	    fixed: _react.PropTypes.bool,
	    children: _react.PropTypes.node,
	    index: _react.PropTypes.number.isRequired,
	    label: _react.PropTypes.node.isRequired,
	    colored: _react.PropTypes.bool,
	    iconChildren: _react.PropTypes.node,
	    iconClassName: _react.PropTypes.string,
	    onClick: _react.PropTypes.func,
	    onNavChange: _react.PropTypes.func,
	    role: _react.PropTypes.string
	  };
	  BottomNav.defaultProps = {
	    component: 'a',
	    role: null
	  };
	  exports.default = BottomNav;
	});

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(8), __webpack_require__(12), __webpack_require__(14), __webpack_require__(64), __webpack_require__(26), __webpack_require__(399)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../Helpers/Portal'), require('../Papers/Paper'), require('./BottomNav'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.deprecated, global.getField, global.controlled, global.Portal, global.Paper, global.BottomNav);
	    global.BottomNavigation = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _deprecated, _getField, _controlled, _Portal, _Paper, _BottomNav) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _Portal2 = _interopRequireDefault(_Portal);
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  var _BottomNav2 = _interopRequireDefault(_BottomNav);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var BottomNavigation = function (_PureComponent) {
	    _inherits(BottomNavigation, _PureComponent);
	
	    function BottomNavigation(props) {
	      _classCallCheck(this, BottomNavigation);
	
	      var _this = _possibleConstructorReturn(this, (BottomNavigation.__proto__ || Object.getPrototypeOf(BottomNavigation)).call(this, props));
	
	      var visible = typeof props.initiallyVisible === 'boolean' ? props.initiallyVisible : props.defaultVisible;
	      _this.state = {
	        visible: visible,
	        portalVisible: visible
	      };
	      if (typeof props.activeIndex === 'undefined') {
	        _this.state.activeIndex = props.defaultActiveIndex;
	      }
	
	      _this._handleNavChange = _this._handleNavChange.bind(_this);
	      _this._addTouchEvents = _this._addTouchEvents.bind(_this);
	      _this._removeTouchEvents = _this._removeTouchEvents.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      _this._handleTouchMove = _this._handleTouchMove.bind(_this);
	      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
	      return _this;
	    }
	
	    _createClass(BottomNavigation, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.dynamic) {
	          this._addTouchEvents();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var dynamic = nextProps.dynamic;
	
	        if (this.props.dynamic === dynamic) {
	          return;
	        }
	
	        if (dynamic) {
	          this._addTouchEvents();
	        } else {
	          this._removeTouchEvents();
	        }
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        if (this.state.visible !== nextState.visible && nextProps.onVisibilityChange) {
	          nextProps.onVisibilityChange(nextState.visible);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.props.dynamic) {
	          this._removeTouchEvents();
	        }
	
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	      }
	    }, {
	      key: '_addTouchEvents',
	      value: function _addTouchEvents() {
	        window.addEventListener('touchstart', this._handleTouchStart);
	        window.addEventListener('touchmove', this._handleTouchMove);
	        window.addEventListener('touchend', this._handleTouchEnd);
	      }
	    }, {
	      key: '_removeTouchEvents',
	      value: function _removeTouchEvents() {
	        window.removeEventListener('touchstart', this._handleTouchStart);
	        window.removeEventListener('touchmove', this._handleTouchMove);
	        window.removeEventListener('touchend', this._handleTouchEnd);
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        var pageY = e.changedTouches[0].pageY;
	
	
	        this._pageY = pageY;
	        this._scrolling = true;
	      }
	    }, {
	      key: '_handleTouchMove',
	      value: function _handleTouchMove(e) {
	        var _this2 = this;
	
	        var visible = this.state.visible;
	
	        if (!this._scrolling) {
	          return;
	        }
	
	        var touchY = e.changedTouches[0].pageY;
	        var _props = this.props,
	            transitionDuration = _props.transitionDuration,
	            dynamicThreshold = _props.dynamicThreshold;
	
	        var passedThreshold = Math.abs(this._pageY - touchY) >= dynamicThreshold;
	        if (this._pageY > touchY && visible && passedThreshold) {
	          if (this._timeout) {
	            clearTimeout(this._timeout);
	          }
	
	          this._timeout = setTimeout(function () {
	            _this2._timeout = null;
	            _this2.setState({ portalVisible: false });
	          }, transitionDuration);
	
	          this._pageY = touchY;
	          this.setState({ visible: false });
	        } else if (this._pageY < touchY && !visible && passedThreshold) {
	          if (this._timeout) {
	            clearTimeout(this._timeout);
	          }
	
	          this._timeout = setTimeout(function () {
	            _this2._timeout = null;
	            _this2.setState({ visible: true });
	          }, 17);
	
	          this._pageY = touchY;
	          this.setState({ portalVisible: true });
	        }
	      }
	    }, {
	      key: '_handleTouchEnd',
	      value: function _handleTouchEnd() {
	        this._scrolling = false;
	      }
	    }, {
	      key: '_handleNavChange',
	      value: function _handleNavChange(index, e) {
	        if (this.props.onNavChange || this.props.onChange) {
	          (this.props.onNavChange || this.props.onChange)(index, e);
	        }
	
	        if (typeof this.props.activeIndex === 'undefined') {
	          this.setState({ activeIndex: index });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _state = this.state,
	            visible = _state.visible,
	            portalVisible = _state.portalVisible;
	
	        var _props2 = this.props,
	            className = _props2.className,
	            actions = _props2.actions,
	            colored = _props2.colored,
	            dynamic = _props2.dynamic,
	            lastChild = _props2.lastChild,
	            props = _objectWithoutProperties(_props2, ['className', 'actions', 'colored', 'dynamic', 'lastChild']);
	
	        delete props.links;
	        delete props.activeIndex;
	        delete props.onNavChange;
	        delete props.onVisibilityChange;
	        delete props.defaultVisible;
	        delete props.defaultActiveIndex;
	        delete props.dynamicThreshold;
	        delete props.transitionDuration;
	        delete props.renderNode;
	
	        // Delete deprecated
	        delete props.onChange;
	        delete props.initiallyVisible;
	        delete props.containerStyle;
	        delete props.containerClassName;
	        delete props.transitionName;
	        delete props.transitionEnterTimeout;
	        delete props.transitionLeaveTimeout;
	
	        var links = this.props.links;
	
	        if (actions) {
	          links = actions;
	        }
	
	        var fixed = links.length === 3;
	        var activeIndex = (0, _getField2.default)(this.props, this.state, 'activeIndex');
	        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	
	        return _react2.default.createElement(
	          _Portal2.default,
	          { renderNode: renderNode, visible: portalVisible, lastChild: lastChild },
	          _react2.default.createElement(
	            _Paper2.default,
	            _extends({}, props, {
	              className: (0, _classnames2.default)('md-bottom-navigation', {
	                'md-background--card': !colored,
	                'md-background--primary': colored,
	                'md-bottom-navigation--dynamic': dynamic,
	                'md-bottom-navigation--dynamic-inactive': dynamic && !visible
	              }, className),
	              role: 'navigation'
	            }),
	            links.map(function (action, index) {
	              return _react2.default.createElement(_BottomNav2.default, _extends({}, action, {
	                key: action.key || index,
	                index: index,
	                onNavChange: _this3._handleNavChange,
	                active: activeIndex === index,
	                colored: colored,
	                fixed: fixed
	              }));
	            })
	          )
	        );
	      }
	    }]);
	
	    return BottomNavigation;
	  }(_react.PureComponent);
	
	  BottomNavigation.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * A list of objects to generate a bottom navigation link. There must be at least 3 and no more
	     * than 5 links. A link gets rendered as the `AccessibleFakeButton` component, so any additional
	     * props in the link's shape will be passed along.
	     *
	     * ```docgen
	     * PropTypes.arrayOf(PropTypes.shape({
	     *   label: PropTypes.node.isRequired,
	     *   iconChildren: PropTypes.node,
	     *   iconClassName: PropTypes.string,
	     *   component: PropTypes.oneOfType([
	     *      PropTypes.func,
	     *      PropTypes.string,
	     *   ]),
	     * }).isRequired
	     * ```
	     */
	    links: function links(props, propName, component) {
	      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        args[_key - 3] = arguments[_key];
	      }
	
	      var _PropTypes$arrayOf;
	
	      var links = props[propName] || props.actions;
	      var len = links.length;
	
	      if (len < 3) {
	        return new Error('Only ' + len + ' `' + propName + '` were given to the ' + component + '. At least 3 are required.');
	      } else if (len > 5) {
	        return new Error(len + ' `' + propName + '` were given to the ' + component + '. No more than 5 may be given.');
	      }
	
	      return (_PropTypes$arrayOf = _react.PropTypes.arrayOf(_react.PropTypes.shape({
	        label: _react.PropTypes.node.isRequired,
	        iconChildren: _react.PropTypes.node,
	        iconClassName: _react.PropTypes.string,
	        component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string])
	      }))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(args));
	    },
	
	    /**
	     * Boolean if the bottom navigation should be colored with the primary color or whatever color
	     * was a result of the `react-md-theme-bottom-navigations-colored` mixin.
	     */
	    colored: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the bottom navigation should dynamically appear based on scrolling. When the user
	     * scrolls the `dynamicThreshold` amount, this component will either disappear (scrolling down)
	     * or appera (scrolling up).
	     */
	    dynamic: _react.PropTypes.bool,
	
	    /**
	     * The distance a user must scroll before the bottom navigation appears or disappears when it is `dyanamic`.
	     */
	    dynamicThreshold: _react.PropTypes.number.isRequired,
	
	    /**
	     * An optional function to call when a link has been clicked. The callback will
	     * include the new active index and the click event.
	     *
	     * ```js
	     * onNavChange(newActiveIndex, event);
	     * ```
	     */
	    onNavChange: _react.PropTypes.func,
	
	    /**
	     * An optional active index to use. This will make the component controlled and require the
	     * `onNavChange` prop to be defined.
	     */
	    activeIndex: (0, _controlled2.default)(_react.PropTypes.number, 'onNavChange', 'defaultActiveIndex'),
	
	    /**
	     * The index for the link that is active by default.
	     */
	    defaultActiveIndex: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if the bottom navigation is visible by default. This *should* probably always
	     * be true.
	     */
	    defaultVisible: _react.PropTypes.bool.isRequired,
	
	    /**
	     * The component to render the bottom navigation as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * Since the `BottomNavigation` component uses the `Portal` component, you can pass an optional
	     * HTML Node to render in.
	     */
	    renderNode: _react.PropTypes.object,
	
	    /**
	     * Boolean if the bottom navigation should render as the last child in the `renderNode` or `body`
	     * instead of as the first.
	     */
	    lastChild: _react.PropTypes.bool,
	
	    /**
	     * The transition duration for the dynamic bottom navigation to appear or disappear. This should
	     * match the `$md-bottom-navigation-transition-time` variable.
	     */
	    transitionDuration: _react.PropTypes.number.isRequired,
	
	    /**
	     * An optional function to call when the visibility of the bottom navigation changes. The callback
	     * will include the new visibility.
	     *
	     * ```js
	     * onVisibilityChange(!visible);
	     * ```
	     */
	    onVisibilityChange: _react.PropTypes.func,
	
	    onChange: (0, _deprecated2.default)(_react.PropTypes.func, 'Use `onNavChange` instead'),
	    initiallyVisible: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `defaultVisible` instead'),
	    initialActiveIndex: (0, _deprecated2.default)(_react.PropTypes.number, 'Use `defaultActiveIndex` instead'),
	    containerStyle: (0, _deprecated2.default)(_react.PropTypes.object, 'Use `style` instead'),
	    containerClassName: (0, _deprecated2.default)(_react.PropTypes.string, 'Use `className` instead'),
	    transitionName: (0, _deprecated2.default)(_react.PropTypes.string, 'There is no CSSTransitionGroup used anymore'),
	    transitionEnterTimeout: (0, _deprecated2.default)(_react.PropTypes.number, 'Use `transitionDuration` instead'),
	    transitionLeaveTimeout: (0, _deprecated2.default)(_react.PropTypes.number, 'Use `transitionDuration` instead'),
	    actions: (0, _deprecated2.default)(_react.PropTypes.array, 'Use `links` instead')
	  };
	  BottomNavigation.defaultProps = {
	    defaultActiveIndex: 0,
	    component: 'footer',
	    defaultVisible: true,
	    transitionDuration: 300,
	    dynamicThreshold: 20
	  };
	  BottomNavigation.contextTypes = {
	    renderNode: _react.PropTypes.object
	  };
	  exports.default = BottomNavigation;
	});

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(400)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./BottomNavigation'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.BottomNavigation);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _BottomNavigation) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _BottomNavigation2 = _interopRequireDefault(_BottomNavigation);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _BottomNavigation2.default;
	});

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(39), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../utils/PropTypes/componentDeprecated'), require('./Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.componentDeprecated, global.Button);
	    global.FlatButton = mod.exports;
	  }
	})(this, function (exports, _react, _componentDeprecated, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var FlatButton = function (_PureComponent) {
	    _inherits(FlatButton, _PureComponent);
	
	    function FlatButton() {
	      _classCallCheck(this, FlatButton);
	
	      return _possibleConstructorReturn(this, (FlatButton.__proto__ || Object.getPrototypeOf(FlatButton)).apply(this, arguments));
	    }
	
	    _createClass(FlatButton, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(_Button2.default, _extends({}, this.props, { flat: true }));
	      }
	    }]);
	
	    return FlatButton;
	  }(_react.PureComponent);
	
	  FlatButton.propTypes = {
	    /**
	     * The label to display in the button.
	     */
	    label: _react.PropTypes.string.isRequired,
	
	    /**
	     * An optional className to apply to the button.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Boolean if the icon should be displayed before the label.
	     */
	    iconBefore: _react.PropTypes.bool,
	
	    /**
	     * A `FontIcon` to display in the button. It can be placed before
	     * or after the label.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * The button type.
	     */
	    type: _react.PropTypes.string,
	
	    /**
	     * Boolean if the button should be styled with the primary color.
	     */
	    primary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the button should be styled with the secondary color.
	     */
	    secondary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the button is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional href to convert the button into a link button.
	     */
	    href: _react.PropTypes.string,
	
	    /**
	     * An optional function to call when the button is clicked.
	     */
	    onClick: _react.PropTypes.func,
	
	    deprecated: (0, _componentDeprecated2.default)('The behavior of the `FlatButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` compnent and add a ' + 'prop `flat`.')
	  };
	  FlatButton.defaultProps = {
	    type: 'button',
	    iconBefore: true
	  };
	  exports.default = FlatButton;
	});

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(39), __webpack_require__(189)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../utils/PropTypes/componentDeprecated'), require('./IconButton'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.componentDeprecated, global.IconButton);
	    global.FloatingButton = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _componentDeprecated, _IconButton) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	  var _IconButton2 = _interopRequireDefault(_IconButton);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var FloatingButton = function (_PureComponent) {
	    _inherits(FloatingButton, _PureComponent);
	
	    function FloatingButton() {
	      _classCallCheck(this, FloatingButton);
	
	      return _possibleConstructorReturn(this, (FloatingButton.__proto__ || Object.getPrototypeOf(FloatingButton)).apply(this, arguments));
	    }
	
	    _createClass(FloatingButton, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            fixed = _props.fixed,
	            mini = _props.mini,
	            children = _props.children,
	            iconClassName = _props.iconClassName,
	            props = _objectWithoutProperties(_props, ['className', 'fixed', 'mini', 'children', 'iconClassName']);
	
	        return _react2.default.createElement(
	          _IconButton2.default,
	          _extends({}, props, {
	            className: (0, _classnames2.default)({
	              'md-btn--floating-fixed': fixed,
	              'md-btn--floating-mini': mini
	            }, className),
	            iconClassName: iconClassName,
	            floating: true
	          }),
	          children
	        );
	      }
	    }]);
	
	    return FloatingButton;
	  }(_react.PureComponent);
	
	  FloatingButton.propTypes = {
	    /**
	     * The className to use for rendering the `FontIcon`.
	     */
	    iconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children to use to render the `FontIcon`.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * An optional className to apply to the button.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The button type.
	     */
	    type: _react.PropTypes.string,
	
	    /**
	     * Boolean if the button is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional href to convert the button into a link button.
	     */
	    href: _react.PropTypes.string,
	
	    /**
	     * An optional function to call when the button is clicked.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * An optional label to use if you would like a tooltip to display
	     * on hover or touch hold.
	     */
	    tooltipLabel: _react.PropTypes.string,
	
	    /**
	     * The position that the tooltip should be displayed relative to
	     * the button.
	     */
	    tooltipPosition: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * An optional amount of delay before the tooltip appears.
	     */
	    tooltipDelay: _react.PropTypes.number,
	
	    /**
	     * Boolean if the floating button is fixed.
	     */
	    fixed: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the floating button should be displayed as the mini
	     * version.
	     */
	    mini: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the floating button should be styled with the primary color.
	     */
	    primary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the floating button should be styled with the secondary color.
	     */
	    secondary: _react.PropTypes.bool,
	
	    deprecated: (0, _componentDeprecated2.default)('The behavior of the `FloatingButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` compnent and add a ' + 'prop `floating`.')
	  };
	  exports.default = FloatingButton;
	});

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(39), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../utils/PropTypes/componentDeprecated'), require('./Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.componentDeprecated, global.Button);
	    global.RaisedButton = mod.exports;
	  }
	})(this, function (exports, _react, _componentDeprecated, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var RaisedButton = function (_PureComponent) {
	    _inherits(RaisedButton, _PureComponent);
	
	    function RaisedButton() {
	      _classCallCheck(this, RaisedButton);
	
	      return _possibleConstructorReturn(this, (RaisedButton.__proto__ || Object.getPrototypeOf(RaisedButton)).apply(this, arguments));
	    }
	
	    _createClass(RaisedButton, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(_Button2.default, _extends({}, this.props, { raised: true }));
	      }
	    }]);
	
	    return RaisedButton;
	  }(_react.PureComponent);
	
	  RaisedButton.propTypes = {
	    /**
	     * The label to display in the button.
	     */
	    label: _react.PropTypes.string.isRequired,
	
	    /**
	     * An optional className to apply to the button.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Boolean if the icon should be displayed before the label.
	     */
	    iconBefore: _react.PropTypes.bool,
	
	    /**
	     * A `FontIcon` to display in the button. It can be placed before
	     * or after the label.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * The button type.
	     */
	    type: _react.PropTypes.string,
	
	    /**
	     * Boolean if the button should be styled with the primary color.
	     */
	    primary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the button should be styled with the secondary color.
	     */
	    secondary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the button is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional href to convert the button into a link button.
	     */
	    href: _react.PropTypes.string,
	
	    /**
	     * An optional function to call when the button is clicked.
	     */
	    onClick: _react.PropTypes.func,
	
	    deprecated: (0, _componentDeprecated2.default)('The behavior of the `RaisedButton` can be achieved with the `Button` component ' + 'without the additional bundle size. Switch to the `Button` compnent and add a ' + 'prop `raised`.')
	  };
	  RaisedButton.defaultProps = {
	    type: 'button',
	    iconBefore: true
	  };
	  exports.default = RaisedButton;
	});

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(16), __webpack_require__(402), __webpack_require__(404), __webpack_require__(403), __webpack_require__(189)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Button'), require('./FlatButton'), require('./RaisedButton'), require('./FloatingButton'), require('./IconButton'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Button, global.FlatButton, global.RaisedButton, global.FloatingButton, global.IconButton);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Button2, _FlatButton2, _RaisedButton2, _FloatingButton2, _IconButton2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.IconButton = exports.FloatingButton = exports.RaisedButton = exports.FlatButton = exports.Button = undefined;
	
	  var _Button3 = _interopRequireDefault(_Button2);
	
	  var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	  var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	  var _FloatingButton3 = _interopRequireDefault(_FloatingButton2);
	
	  var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Button3.default;
	  exports.Button = _Button3.default;
	  exports.FlatButton = _FlatButton3.default;
	  exports.RaisedButton = _RaisedButton3.default;
	  exports.FloatingButton = _FloatingButton3.default;
	  exports.IconButton = _IconButton3.default;
	});

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(8), __webpack_require__(14), __webpack_require__(12), __webpack_require__(194), __webpack_require__(26), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/PropTypes/controlled'), require('../utils/getField'), require('./contextTypes'), require('../Papers/Paper'), require('../Helpers/Collapse'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.deprecated, global.controlled, global.getField, global.contextTypes, global.Paper, global.Collapse);
	    global.Card = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _deprecated, _controlled, _getField, _contextTypes, _Paper, _Collapse) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  var _Collapse2 = _interopRequireDefault(_Collapse);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Card = function (_PureComponent) {
	    _inherits(Card, _PureComponent);
	
	    function Card(props) {
	      _classCallCheck(this, Card);
	
	      var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));
	
	      _this.state = {
	        zDepth: 1,
	        expanded: typeof props.initiallyExpanded !== 'undefined' ? props.initiallyExpanded : !!props.defaultExpanded
	      };
	      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      _this._handleExpandClick = _this._handleExpandClick.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      return _this;
	    }
	
	    _createClass(Card, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        var _props = this.props,
	            iconClassName = _props.iconClassName,
	            iconChildren = _props.iconChildren,
	            expanderTooltipLabel = _props.expanderTooltipLabel,
	            expanderTooltipDelay = _props.expanderTooltipDelay,
	            expanderTooltipPosition = _props.expanderTooltipPosition,
	            expanderIconClassName = _props.expanderIconClassName,
	            expanderIconChildren = _props.expanderIconChildren;
	
	
	        var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');
	
	        return {
	          expanded: expanded,
	          onExpandClick: this._handleExpandClick,
	          iconClassName: typeof iconClassName !== 'undefined' ? iconClassName : expanderIconClassName,
	          iconChildren: typeof iconChildren !== 'undefined' ? iconChildren : expanderIconChildren,
	          tooltipLabel: expanderTooltipLabel,
	          tooltipDelay: expanderTooltipDelay,
	          tooltipPosition: expanderTooltipPosition
	        };
	      }
	    }, {
	      key: '_handleMouseOver',
	      value: function _handleMouseOver(e) {
	        if (this.props.onMouseOver) {
	          this.props.onMouseOver(e);
	        }
	
	        if (this.props.raise && !this._touched) {
	          this.setState({ zDepth: 4 });
	        }
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave(e) {
	        if (this.props.onMouseLeave) {
	          this.props.onMouseLeave(e);
	        }
	
	        this._touched = false;
	        if (this.props.raise && this.state.zDepth !== 1) {
	          this.setState({ zDepth: 1 });
	        }
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        if (this.props.onTouchStart) {
	          this.props.onTouchStart(e);
	        }
	
	        this._touched = true;
	      }
	    }, {
	      key: '_handleExpandClick',
	      value: function _handleExpandClick(e) {
	        var onExpanderClick = this.props.onExpanderClick;
	
	        var expanded = !(0, _getField2.default)(this.props, this.state, 'expanded');
	        if (onExpanderClick) {
	          onExpanderClick(expanded, e);
	        }
	
	        if (typeof this.props.expanded === 'undefined') {
	          this.setState({ expanded: expanded });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var zDepth = this.state.zDepth;
	
	        var _props2 = this.props,
	            className = _props2.className,
	            raise = _props2.raise,
	            tableCard = _props2.tableCard,
	            children = _props2.children,
	            props = _objectWithoutProperties(_props2, ['className', 'raise', 'tableCard', 'children']);
	
	        delete props.expanded;
	        delete props.isExpanded;
	        delete props.onExpanderClick;
	        delete props.initiallyExpanded;
	        delete props.defaultExpanded;
	        delete props.iconChildren;
	        delete props.iconClassName;
	        delete props.expanderIconChildren;
	        delete props.expanderIconClassName;
	        delete props.expanderTooltipLabel;
	        delete props.expanderTooltipDelay;
	        delete props.expanderTooltipPosition;
	
	        var expanded = typeof this.props.isExpanded !== 'undefined' ? this.props.isExpanded : (0, _getField2.default)(this.props, this.state, 'expanded');
	        var expanderIndex = -1;
	        var parts = _react.Children.map(_react.Children.toArray(children), function (child, i) {
	          if (!child || !child.props) {
	            return child;
	          } else if (expanderIndex < 0 && (child.props.isExpander || child.props.expander)) {
	            expanderIndex = i;
	          }
	
	          if (!child.props.expandable) {
	            return child;
	          }
	
	          var collapsed = expanderIndex === -1 || expanderIndex === i || !expanded;
	          return _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: collapsed },
	            child
	          );
	        });
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          _extends({}, props, {
	            zDepth: zDepth,
	            className: (0, _classnames2.default)('md-card', {
	              'md-card--raise': raise,
	              'md-card--table': tableCard
	            }, 'md-background--card', className),
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave,
	            onTouchStart: this._handleTouchStart
	          }),
	          parts
	        );
	      }
	    }]);
	
	    return Card;
	  }(_react.PureComponent);
	
	  Card.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the card.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Any Card parts that should be rendered.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the card is expanded by default when there is an expander
	     * component.
	     */
	    defaultExpanded: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the card should raise on hover when on a desktop display.
	     */
	    raise: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the card is currently expanded. This will require the `onExpanderClick` function
	     * to toggle the state. The card will become controlled if this is not `undefined`.
	     */
	    expanded: (0, _controlled2.default)(_react.PropTypes.bool, 'onExpanderClick', 'defaultExpanded'),
	
	    /**
	     * An optional function to call when the expander is clicked.
	     */
	    onExpanderClick: _react.PropTypes.func,
	
	    /**
	     * The icon className to use for the expander icon.
	     */
	    expanderIconClassName: _react.PropTypes.string,
	
	    /**
	     * Any icon children required for the expander icon.
	     */
	    expanderIconChildren: _react.PropTypes.string,
	
	    /**
	     * The tooltip position for the expander icon.
	     */
	    expanderTooltipPosition: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	
	    /**
	     * The optional tooltip to display for the expander icon.
	     */
	    expanderTooltipLabel: _react.PropTypes.string,
	
	    /**
	     * An optional delay before the tooltip appears for the expander icon on hover.
	     */
	    expanderTooltipDelay: _react.PropTypes.number,
	
	    /**
	     * Boolean if the card contains a table. It will update the styling accordingly.
	     * When using the `DataTable` component, do not wrap it in a `CardText` component.
	     *
	     * ```js
	     * <Card tableCard={true}>
	     *   <CardTitle title="Example />
	     *   <DataTable>
	     *     ...
	     *   </DataTable>
	     * </Card>
	     * ```
	     */
	    tableCard: _react.PropTypes.bool,
	
	    /**
	     * An optional function to call when the mouseover event is triggered.
	     */
	    onMouseOver: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the mouseleave event is triggered.
	     */
	    onMouseLeave: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the touchstart event is triggered.
	     */
	    onTouchStart: _react.PropTypes.func,
	    initiallyExpanded: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `defaultExpanded` instead'),
	    isExpanded: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `expanded` instead'),
	    iconChildren: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `expanderIconChildren` prop instead'),
	    iconClassName: (0, _deprecated2.default)(_react.PropTypes.string, 'Use the `expanderIconClassName` prop instead')
	  };
	  Card.defaultProps = {
	    expanderIconChildren: 'keyboard_arrow_down',
	    expanderIconClassName: 'material-icons',
	    expanderTooltipPosition: 'left'
	  };
	  Card.childContextTypes = _contextTypes2.default;
	  exports.default = Card;
	});

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(192), __webpack_require__(190), __webpack_require__(16), __webpack_require__(39)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('./CardTitle'), require('./CardActions'), require('../Buttons/Button'), require('../utils/PropTypes/componentDeprecated'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.CardTitle, global.CardActions, global.Button, global.componentDeprecated);
	    global.CardActionOverlay = mod.exports;
	  }
	})(this, function (exports, _react, _CardTitle, _CardActions, _Button, _componentDeprecated) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _CardTitle2 = _interopRequireDefault(_CardTitle);
	
	  var _CardActions2 = _interopRequireDefault(_CardActions);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardActionOverlay = function (_PureComponent) {
	    _inherits(CardActionOverlay, _PureComponent);
	
	    function CardActionOverlay() {
	      _classCallCheck(this, CardActionOverlay);
	
	      return _possibleConstructorReturn(this, (CardActionOverlay.__proto__ || Object.getPrototypeOf(CardActionOverlay)).apply(this, arguments));
	    }
	
	    _createClass(CardActionOverlay, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            actions = _props.actions,
	            titleProps = _objectWithoutProperties(_props, ['actions']);
	
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_CardTitle2.default, titleProps),
	          _react2.default.createElement(
	            _CardActions2.default,
	            null,
	            actions.map(function (actionProps, i) {
	              return _react2.default.createElement(_Button2.default, _extends({ flat: true, key: i }, actionProps));
	            })
	          )
	        );
	      }
	    }]);
	
	    return CardActionOverlay;
	  }(_react.PureComponent);
	
	  CardActionOverlay.propTypes = {
	    /**
	     * The title to use.
	     */
	    title: _react.PropTypes.string,
	
	    /**
	     * The optional subtitle to use.
	     */
	    subtitle: _react.PropTypes.string,
	
	    /**
	     * An array of flat button props.
	     */
	    actions: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      label: _react.PropTypes.string.isRequired
	    })),
	
	    /**
	     * Any children to display in the `CardTitle` component.
	     */
	    children: _react.PropTypes.node,
	    deprecated: (0, _componentDeprecated2.default)('It is not a worthwhile component since the same thing can be accomplished with the `MediaOverlay` component.')
	  };
	  exports.default = CardActionOverlay;
	});

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(8), __webpack_require__(39), __webpack_require__(201), __webpack_require__(202)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../utils/PropTypes/componentDeprecated'), require('../Media/Media'), require('../Media/MediaOverlay'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.deprecated, global.componentDeprecated, global.Media, global.MediaOverlay);
	    global.CardMedia = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _deprecated, _componentDeprecated, _Media, _MediaOverlay) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	  var _Media2 = _interopRequireDefault(_Media);
	
	  var _MediaOverlay2 = _interopRequireDefault(_MediaOverlay);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardMedia = function (_PureComponent) {
	    _inherits(CardMedia, _PureComponent);
	
	    function CardMedia() {
	      _classCallCheck(this, CardMedia);
	
	      return _possibleConstructorReturn(this, (CardMedia.__proto__ || Object.getPrototypeOf(CardMedia)).apply(this, arguments));
	    }
	
	    _createClass(CardMedia, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            children = _props.children,
	            props = _objectWithoutProperties(_props, ['className', 'children']);
	
	        delete props.overlay;
	
	        var overlay = this.props.overlay;
	
	        if (overlay) {
	          overlay = _react2.default.createElement(
	            _MediaOverlay2.default,
	            null,
	            overlay
	          );
	        }
	
	        return _react2.default.createElement(
	          _Media2.default,
	          _extends({ className: (0, _classnames2.default)('md-card-media', className) }, props),
	          children,
	          overlay
	        );
	      }
	    }]);
	
	    return CardMedia;
	  }(_react.PureComponent);
	
	  CardMedia.aspect = {
	    equal: '1-1',
	    wide: '16-9'
	  };
	  CardMedia.propTypes = {
	    /**
	     * An optional className to apply to the card media component.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional overlay component to be rendered over the media. This *should*
	     * be A `CardTitle`, `CardActions` or both.
	     */
	    overlay: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `MediaOverlay` component as a child instead'),
	
	    /**
	     * Any media to display.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the aspect ratio should be forced.
	     */
	    forceAspect: _react.PropTypes.bool,
	
	    /**
	     * The aspect ratio to use.
	     */
	    aspectRatio: _react.PropTypes.oneOf([CardMedia.aspect.equal, CardMedia.aspect.wide]).isRequired,
	
	    /**
	     * Boolean if this component should be expandable when there is a `CardExpander`
	     * above it in the `Card`.
	     */
	    expandable: _react.PropTypes.bool,
	
	    /**
	     * The component to render the card media as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    deprecated: (0, _componentDeprecated2.default)('There were no unique styles for media in cards so it is simpler to just use the ' + '`Media` component.')
	  };
	  CardMedia.defaultProps = {
	    forceAspect: true,
	    aspectRatio: CardMedia.aspect.wide,
	    component: 'section'
	  };
	  exports.default = CardMedia;
	});

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.CardText = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CardText = function (_PureComponent) {
	    _inherits(CardText, _PureComponent);
	
	    function CardText() {
	      _classCallCheck(this, CardText);
	
	      return _possibleConstructorReturn(this, (CardText.__proto__ || Object.getPrototypeOf(CardText)).apply(this, arguments));
	    }
	
	    _createClass(CardText, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            Component = _props.component,
	            className = _props.className,
	            props = _objectWithoutProperties(_props, ['component', 'className']);
	
	        delete props.expandable;
	
	        return _react2.default.createElement(Component, _extends({}, props, { className: (0, _classnames2.default)('md-card-text', className) }));
	      }
	    }]);
	
	    return CardText;
	  }(_react.PureComponent);
	
	  CardText.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The children to display.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * The component to render as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired,
	
	    /**
	     * Boolean if this component should be expandable when there is a `CardExpander`
	     * above it in the `Card`.
	     */
	    expandable: _react.PropTypes.bool
	  };
	  CardText.defaultProps = {
	    component: 'section'
	  };
	  exports.default = CardText;
	});

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(8), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/deprecated'), require('../FontIcons/FontIcon'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.deprecated, global.FontIcon);
	    global.Chip = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _deprecated, _FontIcon) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Chip = function (_PureComponent) {
	    _inherits(Chip, _PureComponent);
	
	    function Chip(props) {
	      _classCallCheck(this, Chip);
	
	      var _this = _possibleConstructorReturn(this, (Chip.__proto__ || Object.getPrototypeOf(Chip)).call(this, props));
	
	      _this.state = { hover: false };
	      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      return _this;
	    }
	
	    _createClass(Chip, [{
	      key: '_handleMouseOver',
	      value: function _handleMouseOver(e) {
	        if (this.props.onMouseOver) {
	          this.props.onMouseOver(e);
	        }
	
	        this.setState({ hover: true });
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave(e) {
	        if (this.props.onMouseLeave) {
	          this.props.onMouseLeave(e);
	        }
	
	        this.setState({ hover: false });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var hover = this.state.hover;
	
	        var _props = this.props,
	            label = _props.label,
	            className = _props.className,
	            iconClassName = _props.iconClassName,
	            avatar = _props.avatar,
	            children = _props.children,
	            removable = _props.removable,
	            remove = _props.remove,
	            onClick = _props.onClick,
	            rotateIcon = _props.rotateIcon,
	            props = _objectWithoutProperties(_props, ['label', 'className', 'iconClassName', 'avatar', 'children', 'removable', 'remove', 'onClick', 'rotateIcon']);
	
	        delete props.removeIconChildren;
	        delete props.removeIconClassName;
	
	        var icon = void 0;
	        if (removable || remove) {
	          icon = _react2.default.createElement(
	            _FontIcon2.default,
	            {
	              className: (0, _classnames2.default)('md-chip-icon', {
	                'md-chip-icon--rotate': rotateIcon,
	                'md-chip-text--hover': hover
	              }),
	              iconClassName: iconClassName
	            },
	            children
	          );
	        }
	
	        return _react2.default.createElement(
	          'button',
	          _extends({
	            type: 'button'
	          }, props, {
	            className: (0, _classnames2.default)('md-chip', {
	              'md-chip--avatar': avatar,
	              'md-chip--remove': removable,
	              'md-chip--hover': hover
	            }, className),
	            onClick: remove || onClick,
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave
	          }),
	          avatar,
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)('md-chip-text', {
	                'md-chip-text--hover': hover
	              })
	            },
	            label
	          ),
	          icon
	        );
	      }
	    }]);
	
	    return Chip;
	  }(_react.PureComponent);
	
	  Chip.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional icon className to use for the remove icon when `removable`.
	     */
	    iconClassName: _react.PropTypes.string,
	
	    /**
	     * Boolean if the `.md-chip-icon--rotate` style should be applied to the remove icon.
	     * The `.md-chip-icon--rotate` just rotates the icon 45 degrees.
	     */
	    rotateIcon: _react.PropTypes.bool,
	
	    /**
	     * Any children used to display the remove icon when `removable`.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * The label to display on the chip.
	     */
	    label: _react.PropTypes.string.isRequired,
	
	    /**
	     * Boolean if the chip is removable.
	     */
	    removable: _react.PropTypes.bool,
	
	    /**
	     * An optional avatar to display on the chip.
	     */
	    avatar: _react.PropTypes.element,
	
	    /**
	     * An optional function to call when the `click` event is triggered.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `mouseover` event is triggered.
	     */
	    onMouseOver: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `mouseleave` event is triggered.
	     */
	    onMouseLeave: _react.PropTypes.func,
	    remove: (0, _deprecated2.default)(_react.PropTypes.func, 'Use `removable` and `onClick` instead'),
	    removeIconChildren: (0, _deprecated2.default)(_react.PropTypes.node, 'Use `iconChildren` instead'),
	    removeIconClassName: (0, _deprecated2.default)(_react.PropTypes.string, 'Use `iconClassName` instead')
	  };
	  Chip.defaultProps = {
	    rotateIcon: true,
	    children: 'add_circle'
	  };
	  exports.default = Chip;
	});

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(410)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Chip'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Chip);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Chip) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Chip2 = _interopRequireDefault(_Chip);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Chip2.default;
	});

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(519), __webpack_require__(40), __webpack_require__(80)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../utils/PropTypes/requiredForA11yIfNot'), require('../utils/PropTypes/invalidIf'), require('./contextTypes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.requiredForA11yIfNot, global.invalidIf, global.contextTypes);
	    global.DataTable = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _requiredForA11yIfNot, _invalidIf, _contextTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _requiredForA11yIfNot2 = _interopRequireDefault(_requiredForA11yIfNot);
	
	  var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var DataTable = function (_PureComponent) {
	    _inherits(DataTable, _PureComponent);
	
	    function DataTable(props) {
	      _classCallCheck(this, DataTable);
	
	      var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));
	
	      var rows = props.defaultSelectedRows;
	      _this.state = {
	        allSelected: _this._allSelected(rows),
	        selectedRows: rows
	      };
	
	      _this._removed = 0;
	      _this._initial = true;
	      _this._toggleAllRows = _this._toggleAllRows.bind(_this);
	      _this._toggleSelectedRow = _this._toggleSelectedRow.bind(_this);
	      _this._createCheckbox = _this._createCheckbox.bind(_this);
	      _this._removeCheckbox = _this._removeCheckbox.bind(_this);
	      return _this;
	    }
	
	    _createClass(DataTable, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        var _props = this.props,
	            uncheckedIconChildren = _props.uncheckedIconChildren,
	            uncheckedIconClassName = _props.uncheckedIconClassName,
	            checkedIconChildren = _props.checkedIconChildren,
	            checkedIconClassName = _props.checkedIconClassName,
	            plain = _props.plain,
	            baseId = _props.baseId;
	
	
	        return {
	          uncheckedIconChildren: uncheckedIconChildren,
	          uncheckedIconClassName: uncheckedIconClassName,
	          checkedIconChildren: checkedIconChildren,
	          checkedIconClassName: checkedIconClassName,
	          plain: plain,
	          allSelected: this.state.allSelected,
	          selectedRows: this.state.selectedRows,
	          toggleAllRows: this._toggleAllRows,
	          toggleSelectedRow: this._toggleSelectedRow,
	          createCheckbox: this._createCheckbox,
	          removeCheckbox: this._removeCheckbox,
	          baseId: baseId,
	          baseName: baseId + '-control'
	        };
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        this._removed = 0;
	        this._initial = false;
	      }
	    }, {
	      key: '_allSelected',
	      value: function _allSelected(rows) {
	        var all = rows.length !== 0;
	        rows.some(function (checked) {
	          if (!checked) {
	            all = false;
	          }
	
	          return !all;
	        });
	
	        return all;
	      }
	    }, {
	      key: '_createCheckbox',
	      value: function _createCheckbox(index) {
	        var _this2 = this;
	
	        this.setState(function (state, props) {
	          var selectedRows = state.selectedRows.slice();
	          // Only use the default selected rows prop on first mount. If other changes occur after,
	          // default to false.
	          var selected = _this2._initial && props.defaultSelectedRows[index] || false;
	          selectedRows.splice(index, 0, selected);
	          return { selectedRows: selectedRows, allSelected: _this2._allSelected(selectedRows) };
	        });
	      }
	    }, {
	      key: '_removeCheckbox',
	      value: function _removeCheckbox(index) {
	        var _this3 = this;
	
	        this.setState(function (state) {
	          // When multiple checkboxes are removed in a render cycle, they are removed in list order.
	          // So to keep the index correct while removing, need to keep subract the provided index by
	          // the current number of removed elements. This value gets reset to 0 after a finished cycle.
	          var selectedRows = state.selectedRows.slice();
	          selectedRows.splice(index - _this3._removed, 1);
	          _this3._removed += 1;
	          return { selectedRows: selectedRows, allSelected: _this3._allSelected(selectedRows) };
	        });
	      }
	    }, {
	      key: '_toggleAllRows',
	      value: function _toggleAllRows() {
	        var allSelected = !this.state.allSelected;
	        if (this.props.onRowToggle) {
	          this.props.onRowToggle(-1, allSelected, allSelected ? this.state.selectedRows.length : 0);
	        }
	
	        this.setState({
	          allSelected: allSelected,
	          selectedRows: this.state.selectedRows.map(function () {
	            return allSelected;
	          })
	        });
	      }
	    }, {
	      key: '_toggleSelectedRow',
	      value: function _toggleSelectedRow(row) {
	        var selectedRows = this.state.selectedRows.slice();
	        selectedRows[row] = !selectedRows[row];
	        var selectedCount = selectedRows.filter(function (selected) {
	          return selected;
	        }).length;
	
	        if (this.props.onRowToggle) {
	          this.props.onRowToggle(row, selectedRows[row], selectedCount);
	        }
	
	        this.setState({ selectedRows: selectedRows, allSelected: this._allSelected(selectedRows) });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            className = _props2.className,
	            children = _props2.children,
	            plain = _props2.plain,
	            responsive = _props2.responsive,
	            props = _objectWithoutProperties(_props2, ['className', 'children', 'plain', 'responsive']);
	
	        delete props.checkedIconChildren;
	        delete props.checkedIconClassName;
	        delete props.uncheckedIconChildren;
	        delete props.uncheckedIconClassName;
	        delete props.defaultSelectedRows;
	        delete props.baseId;
	        delete props.onRowToggle;
	
	        var table = _react2.default.createElement(
	          'table',
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-data-table', {
	              'md-data-table--plain': plain
	            }, className)
	          }),
	          children
	        );
	
	        return responsive ? _react2.default.createElement(
	          'div',
	          { className: 'md-data-table--responsive' },
	          table
	        ) : table;
	      }
	    }]);
	
	    return DataTable;
	  }(_react.PureComponent);
	
	  DataTable.propTypes = {
	    /**
	     * A base id to use for every checkbox or `EditDialogColumn` in the data table. This is
	     * required for a11y if the data table is not plain.
	     */
	    baseId: (0, _requiredForA11yIfNot2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]), 'plain'),
	
	    /**
	     * Optional style to apply to the table.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the table.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The table contents to display. This *should* be a list of `TableHeader` and `TableBody`
	     * components.
	     */
	    children: _react.PropTypes.node.isRequired,
	
	    /**
	     * An optional array of booleans denoting if a row is selected.
	     * This is an associative array so the index must match the row
	     * number in the `TableBody` component.
	     */
	    defaultSelectedRows: _react.PropTypes.arrayOf(_react.PropTypes.bool).isRequired,
	
	    /**
	     * Boolean if the table is responsive. This will wrap the table in a container
	     * that allows scrolling to the right if overflow exists.
	     */
	    responsive: _react.PropTypes.bool.isRequired,
	
	    /**
	     * Boolean if this table should not include the checkboxes on each row.
	     * This really means that the entire table is unselectable and you wish
	     * to display as a normal table.
	     */
	    plain: _react.PropTypes.bool,
	
	    /**
	     * The icon className to use for the unchecked row icon. This value
	     * will be passed down as `context`.
	     */
	    uncheckedIconClassName: _react.PropTypes.string.isRequired,
	
	    /**
	     * The icon children to use for the unchecked row icon. This value
	     * will be passed down as `context`.
	     */
	    uncheckedIconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className to use for the checked row icon. This value
	     * will be passed down as `context`.
	     */
	    checkedIconClassName: _react.PropTypes.string.isRequired,
	
	    /**
	     * The icon children to use for the checked row icon. This value
	     * will be passed down as `context`.
	     */
	    checkedIconChildren: _react.PropTypes.node,
	
	    /**
	     * An optional function to call when a non-plain data table has a row toggled.
	     * The callback will include the selected row id, the boolean if it is now selected,
	     * and the count of rows that are selected. If the checkbox in the `TableHeader` was
	     * clicked, the selected row id will be `-1`.
	     *
	     * ```js
	     * onRowToggle(3, true, 8); // 4th row was toggled
	     * onRowToggle(-1, true, 15); // select all checkbox was toggled on.
	     * ```
	     */
	    onRowToggle: (0, _invalidIf2.default)(_react.PropTypes.func, 'plain')
	  };
	  DataTable.defaultProps = {
	    uncheckedIconChildren: 'check_box_outline_blank',
	    uncheckedIconClassName: 'material-icons',
	    checkedIconChildren: 'check_box',
	    checkedIconClassName: 'material-icons',
	    defaultSelectedRows: [],
	    responsive: true
	  };
	  DataTable.childContextTypes = _contextTypes2.default;
	  exports.default = DataTable;
	});

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(11), __webpack_require__(30), __webpack_require__(12), __webpack_require__(40), __webpack_require__(63), __webpack_require__(121), __webpack_require__(52), __webpack_require__(18), __webpack_require__(81)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('../constants/keyCodes'), require('../constants/CSSTransitionGroupTick'), require('../utils/getField'), require('../utils/PropTypes/invalidIf'), require('../Dialogs/DialogFooter'), require('./TableColumn'), require('../TextFields/TextField'), require('../FontIcons/FontIcon'), require('./findTable'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.keyCodes, global.CSSTransitionGroupTick, global.getField, global.invalidIf, global.DialogFooter, global.TableColumn, global.TextField, global.FontIcon, global.findTable);
	    global.EditDialogColumn = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _keyCodes, _CSSTransitionGroupTick, _getField, _invalidIf, _DialogFooter, _TableColumn, _TextField, _FontIcon, _findTable) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	  var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	  var _TextField2 = _interopRequireDefault(_TextField);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  var _findTable2 = _interopRequireDefault(_findTable);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var EditDialogColumn = function (_PureComponent) {
	    _inherits(EditDialogColumn, _PureComponent);
	
	    function EditDialogColumn(props, context) {
	      _classCallCheck(this, EditDialogColumn);
	
	      var _this = _possibleConstructorReturn(this, (EditDialogColumn.__proto__ || Object.getPrototypeOf(EditDialogColumn)).call(this, props, context));
	
	      _this.state = {
	        value: props.defaultValue,
	        active: false,
	        absolute: false,
	        animating: false
	      };
	
	      _this._table = null;
	      _this._column = null;
	      _this._field = null;
	
	      _this._setColumn = _this._setColumn.bind(_this);
	      _this._setDialog = _this._setDialog.bind(_this);
	      _this._setField = _this._setField.bind(_this);
	      _this._setOkButton = _this._setOkButton.bind(_this);
	      _this._save = _this._save.bind(_this);
	      _this._overrideTab = _this._overrideTab.bind(_this);
	      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._handleChange = _this._handleChange.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      _this._handleCancelClick = _this._handleCancelClick.bind(_this);
	      _this._handleClickOutside = _this._handleClickOutside.bind(_this);
	      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      _this._positionCell = _this._positionCell.bind(_this);
	      _this._repositionCell = _this._repositionCell.bind(_this);
	      _this._activateDialog = _this._activateDialog.bind(_this);
	      return _this;
	    }
	
	    _createClass(EditDialogColumn, [{
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var active = this.state.active;
	
	        if (active === prevState.active) {
	          return;
	        } else if (this._table) {
	          this._table[(active ? 'add' : 'remove') + 'EventListener']('scroll', this._repositionCell);
	          this._left = active ? this.state.left : null;
	          this._scrollLeft = active ? this._table.scrollLeft : null;
	        }
	
	        window[(active ? 'add' : 'remove') + 'EventListener']('click', this._handleClickOutside);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('click', this._handleClickOutside);
	
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	      }
	    }, {
	      key: '_getDialogPosition',
	      value: function _getDialogPosition(dialog) {
	        var left = null;
	        var width = null;
	        if (dialog) {
	          left = dialog.getBoundingClientRect().left - 1;
	          width = dialog.offsetWidth;
	        }
	
	        return { width: width, left: left };
	      }
	    }, {
	      key: '_setColumn',
	      value: function _setColumn(column) {
	        this._column = (0, _reactDom.findDOMNode)(column);
	        this._table = (0, _findTable2.default)(this._column);
	      }
	    }, {
	      key: '_setDialog',
	      value: function _setDialog(dialog) {
	        this._dialog = dialog;
	      }
	    }, {
	      key: '_setField',
	      value: function _setField(field) {
	        if (field) {
	          this._field = field.getField();
	        }
	      }
	    }, {
	      key: '_setOkButton',
	      value: function _setOkButton(okButton) {
	        this._okButton = (0, _reactDom.findDOMNode)(okButton);
	      }
	    }, {
	      key: '_positionCell',
	      value: function _positionCell() {
	        if (this.props.inline) {
	          return;
	        }
	
	        var position = void 0;
	        if (!this.state.absolute) {
	          position = this._getDialogPosition(this._dialog, this._table);
	        }
	
	        this.setState(_extends({ absolute: true }, position));
	      }
	    }, {
	      key: '_repositionCell',
	      value: function _repositionCell() {
	        var _this2 = this;
	
	        if (!this._ticking) {
	          requestAnimationFrame(function () {
	            _this2._ticking = false;
	
	            var left = _this2._left;
	            var scrolledOut = false;
	            if (_this2._table) {
	              var _table = _this2._table,
	                  scrollLeft = _table.scrollLeft,
	                  offsetWidth = _table.offsetWidth;
	
	              left -= scrollLeft - _this2._scrollLeft;
	              scrolledOut = left < 16 || offsetWidth - left < _this2.state.width * _this2.props.scrollThreshold;
	            }
	
	            var _state = _this2.state,
	                absolute = _state.absolute,
	                active = _state.active;
	
	            if (!_this2._timeout && scrolledOut) {
	              _this2._timeout = setTimeout(function () {
	                _this2._timeout = null;
	                _this2.setState({ absolute: false, left: null, width: null });
	              }, _this2.props.transitionDuration);
	              active = false;
	              absolute = true;
	            }
	
	            _this2.setState({ left: left, absolute: absolute, active: active });
	          });
	        }
	
	        this._ticking = true;
	      }
	    }, {
	      key: '_activateDialog',
	      value: function _activateDialog(e) {
	        if (e) {
	          var callback = void 0;
	          if (e.type === 'click') {
	            callback = 'onClick';
	          } else if (e.type === 'touchend') {
	            callback = 'onTouchEnd';
	          }
	
	          if (callback && this.props[callback]) {
	            this.props[callback](e);
	          }
	        }
	
	        if (this.props.inline || this.state.active) {
	          return;
	        }
	
	        this.setState({ active: true, cancelValue: (0, _getField2.default)(this.props, this.state, 'value') });
	      }
	    }, {
	      key: '_handleClickOutside',
	      value: function _handleClickOutside(e) {
	        if (this._column && !this._column.contains(e.target)) {
	          if (this.props.onOutsideClick) {
	            this.props.onOutsideClick(e);
	          }
	
	          if (this.props.okOnOutsideClick) {
	            this._save(e);
	          } else {
	            this._handleCancelClick(e);
	          }
	        }
	      }
	    }, {
	      key: '_handleMouseOver',
	      value: function _handleMouseOver(e) {
	        if (this.props.onMouseOver) {
	          this.props.onMouseOver(e);
	        }
	
	        this._positionCell();
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave(e) {
	        if (this.props.onMouseLeave) {
	          this.props.onMouseLeave(e);
	        }
	
	        if (this.props.inline) {
	          return;
	        }
	
	        var position = void 0;
	        if (!this.state.active) {
	          position = { width: null, left: null };
	        }
	
	        this.setState(_extends({ absolute: false }, position));
	      }
	    }, {
	      key: '_handleKeyUp',
	      value: function _handleKeyUp(e) {
	        var _this3 = this;
	
	        if (this.props.onKeyUp) {
	          this.props.onKeyUp(e);
	        }
	
	        // Make sure this is really a _focus_ event from keyboard
	        if ((e.which || e.keyCode) !== _keyCodes.TAB || this.state.active || this.props.inline) {
	          return;
	        }
	
	        // To get a smooth transition with keybaord, need to _emulate_ how the mouse interaction works.
	        // Basically position the edit field absolutely, wait for a re-render, then activate the dialog.
	        this._timeout = setTimeout(function () {
	          _this3._timeout = null;
	          _this3._activateDialog();
	        }, _CSSTransitionGroupTick2.default);
	        this._positionCell();
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        if (this.props.onTouchStart) {
	          this.props.onTouchStart(e);
	        }
	
	        this._positionCell();
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        var onKeyDown = this.props.onKeyDown;
	
	        if (onKeyDown) {
	          onKeyDown(e);
	        }
	
	        var key = e.which || e.keyCode;
	        if (key === _keyCodes.ENTER) {
	          this._save(e);
	        } else if (key === _keyCodes.TAB) {
	          this._overrideTab(e);
	        } else if (key === _keyCodes.ESC) {
	          this._handleCancelClick(e);
	        }
	      }
	    }, {
	      key: '_overrideTab',
	      value: function _overrideTab(e) {
	        var _props = this.props,
	            large = _props.large,
	            inline = _props.inline,
	            okOnOutsideClick = _props.okOnOutsideClick;
	
	        var key = e.which || e.keyCode;
	        if (key !== _keyCodes.TAB) {
	          return;
	        } else if (inline) {
	          this._save(e);
	          return;
	        } else if (!large) {
	          if (okOnOutsideClick) {
	            this._save(e);
	          } else {
	            this._handleCancelClick(e);
	          }
	          return;
	        }
	
	        var shiftKey = e.shiftKey;
	        var classList = e.target.classList;
	
	
	        var nextFocus = void 0;
	        if (classList.contains('md-text-field') && shiftKey) {
	          nextFocus = this._okButton;
	        } else if (classList.contains('md-btn') && !shiftKey) {
	          nextFocus = this._field;
	        }
	
	        if (nextFocus) {
	          e.preventDefault();
	          nextFocus.focus();
	        }
	      }
	    }, {
	      key: '_save',
	      value: function _save(e) {
	        var _this4 = this;
	
	        if (this.props.onOkClick) {
	          this.props.onOkClick((0, _getField2.default)(this.props, this.state, 'value'), e);
	        }
	
	        this._timeout = setTimeout(function () {
	          _this4._timeout = null;
	          _this4.setState({ absolute: false, left: null, width: null });
	        }, this.props.transitionDuration);
	        this.setState({ active: false, absolute: true });
	      }
	    }, {
	      key: '_handleCancelClick',
	      value: function _handleCancelClick(e) {
	        var _this5 = this;
	
	        if (this.props.onCancelClick) {
	          this.props.onCancelClick(this.state.cancelValue, e);
	        }
	
	        var state = { absolute: true, active: false };
	        if (typeof this.props.value === 'undefined') {
	          state.value = this.state.cancelValue;
	        }
	
	        this._timeout = setTimeout(function () {
	          _this5._timeout = null;
	          _this5.setState({ absolute: false, left: null, width: null });
	        }, this.props.transitionDuration);
	
	        this.setState(state);
	      }
	    }, {
	      key: '_handleChange',
	      value: function _handleChange(value, e) {
	        if (this.props.onChange) {
	          this.props.onChange(value, e);
	        }
	
	        if (typeof this.props.value === 'undefined') {
	          this.setState({ value: value });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var rowId = this.context.rowId;
	        var _state2 = this.state,
	            active = _state2.active,
	            absolute = _state2.absolute,
	            animating = _state2.animating,
	            left = _state2.left,
	            width = _state2.width;
	
	        var _props2 = this.props,
	            style = _props2.style,
	            className = _props2.className,
	            dialogStyle = _props2.dialogStyle,
	            dialogClassName = _props2.dialogClassName,
	            textFieldStyle = _props2.textFieldStyle,
	            textFieldClassName = _props2.textFieldClassName,
	            inputStyle = _props2.inputStyle,
	            inputClassName = _props2.inputClassName,
	            maxLength = _props2.maxLength,
	            title = _props2.title,
	            okLabel = _props2.okLabel,
	            cancelLabel = _props2.cancelLabel,
	            large = _props2.large,
	            label = _props2.label,
	            placeholder = _props2.placeholder,
	            inline = _props2.inline,
	            inlineIconChildren = _props2.inlineIconChildren,
	            inlineIconClassName = _props2.inlineIconClassName,
	            noIcon = _props2.noIcon,
	            header = _props2.header,
	            enforceMinWidth = _props2.enforceMinWidth,
	            props = _objectWithoutProperties(_props2, ['style', 'className', 'dialogStyle', 'dialogClassName', 'textFieldStyle', 'textFieldClassName', 'inputStyle', 'inputClassName', 'maxLength', 'title', 'okLabel', 'cancelLabel', 'large', 'label', 'placeholder', 'inline', 'inlineIconChildren', 'inlineIconClassName', 'noIcon', 'header', 'enforceMinWidth']);
	
	        delete props.id;
	        delete props.onMouseOver;
	        delete props.onMouseLeave;
	        delete props.onTouchStart;
	        delete props.onTouchEnd;
	        delete props.value;
	        delete props.defaultValue;
	        delete props.onOkClick;
	        delete props.onCancelClick;
	        delete props.header;
	        delete props.okOnOutsideClick;
	        delete props.transitionDuration;
	        delete props.scrollThreshold;
	
	        var value = (0, _getField2.default)(this.props, this.state, 'value');
	        var id = this.props.id;
	
	        if (!id) {
	          id = rowId + '-edit-dialog';
	        }
	
	        var actions = void 0;
	        var largeTitle = void 0;
	        if (!inline && large && active) {
	          actions = [{
	            label: cancelLabel,
	            onClick: this._handleCancelClick,
	            primary: true
	          }, {
	            label: okLabel,
	            onClick: this._save,
	            primary: true,
	            ref: this._setOkButton,
	            onKeyDown: this._overrideTab
	          }];
	
	          actions = _react2.default.createElement(_DialogFooter2.default, { actions: actions });
	
	          largeTitle = _react2.default.createElement(
	            'h3',
	            { className: 'md-title' },
	            title
	          );
	        }
	
	        var pointer = (0, _classnames2.default)({ 'md-pointer--hover': !active });
	        var inlineEditIcon = void 0;
	        if (inline && !noIcon) {
	          inlineEditIcon = _react2.default.createElement(
	            _FontIcon2.default,
	            { key: 'edit-icon', iconClassName: inlineIconClassName },
	            inlineIconChildren
	          );
	        }
	
	        var ariaProps = {};
	        if (!inline) {
	          ariaProps.id = id + '-container';
	          ariaProps['aria-haspopup'] = true;
	          ariaProps['aria-expanded'] = active;
	          ariaProps['aria-owns'] = id;
	        }
	
	        return _react2.default.createElement(
	          _TableColumn2.default,
	          {
	            style: _extends({ left: left }, style),
	            className: (0, _classnames2.default)('prevent-grow md-edit-dialog-column', {
	              'md-table-column--fixed': !inline && (absolute || active || animating),
	              'md-table-column--fixed-active': active
	            }, className),
	            header: header,
	            ref: this._setColumn,
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave,
	            onClick: this._activateDialog,
	            onTouchStart: this._handleTouchStart,
	            onTouchEnd: this._activateDialog,
	            __fixedColumn: true
	          },
	          _react2.default.createElement(
	            'div',
	            _extends({}, ariaProps, {
	              ref: this._setDialog,
	              style: _extends({ width: width }, dialogStyle),
	              className: (0, _classnames2.default)('md-edit-dialog', {
	                'md-edit-dialog--active': active,
	                'md-edit-dialog--inline': inline,
	                'md-edit-dialog--min-width': typeof enforceMinWidth === 'undefined' ? props.type === 'text' : enforceMinWidth,
	                'md-background': active
	              }, dialogClassName)
	            }),
	            largeTitle,
	            _react2.default.createElement(_TextField2.default, _extends({}, props, {
	              id: id,
	              ref: this._setField,
	              label: active ? label : null,
	              active: active,
	              floating: active,
	              placeholder: active ? placeholder : placeholder || label,
	              block: !active,
	              paddedBlock: false,
	              style: textFieldStyle,
	              className: (0, _classnames2.default)(pointer, textFieldClassName),
	              inputStyle: inputStyle,
	              inputClassName: (0, _classnames2.default)(pointer, {
	                'md-text-right': props.type === 'number'
	              }, inputClassName),
	              onKeyUp: this._handleKeyUp,
	              onKeyDown: this._handleKeyDown,
	              value: value,
	              onChange: this._handleChange,
	              maxLength: active ? maxLength : null,
	              rightIcon: inlineEditIcon
	            })),
	            actions
	          )
	        );
	      }
	    }]);
	
	    return EditDialogColumn;
	  }(_react.PureComponent);
	
	  EditDialogColumn.propTypes = {
	    /**
	     * An optional id to provide to the text field in the column. If this is omitted,
	     * the id will be the current row id and `-edit-dialog`.
	     */
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * The optional style to apply to the edit dialog's column.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * The optional className to apply to the edit dialog's column.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The optional style to apply to the edit dialog.
	     */
	    dialogStyle: _react.PropTypes.object,
	
	    /**
	     * The optional className to apply to the edit dialog.
	     */
	    dialogClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the text field.
	     */
	    textFieldStyle: _react.PropTypes.object,
	
	    /**
	     * An optional class name to apply to the text field.
	     */
	    textFieldClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the text field's input.
	     */
	    inputStyle: _react.PropTypes.object,
	
	    /**
	     * An optional class name to apply to the text field's input.
	     */
	    inputClassName: _react.PropTypes.string,
	
	    /**
	     * The transition duration when the dialog is moving from
	     * active to inactive.
	     */
	    transitionDuration: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if the edit dialog is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * The optional max length for the edit dialog.
	     */
	    maxLength: _react.PropTypes.number,
	
	    /**
	     * A value to use for the edit dialog text field. This
	     * will make the component controlled so you will need
	     * to provide an `onChange` function.
	     */
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional function to call when the text field's value
	     * is changed. It is called with `(newValue, changeEvent)`.
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * The default value for the column.
	     */
	    defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional function to call when the input is clicked.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the keyup event is triggered.
	     */
	    onKeyUp: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the keydown event is triggered.
	     */
	    onKeyDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the mouseover event is triggered.
	     */
	    onMouseOver: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the mouseleave event is triggered.
	     */
	    onMouseLeave: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the touchstart event is triggered.
	     */
	    onTouchStart: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the touchend event is triggered.
	     */
	    onTouchEnd: _react.PropTypes.func,
	
	    /**
	     * Boolean if the edit dialog should be large.
	     */
	    large: _react.PropTypes.bool,
	
	    /**
	     * The title for the large edit dialog. The custom validation changes to required
	     * when the `large` prop is set to true.
	     */
	    title: function title(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      if (props.large) {
	        var _PropTypes$string;
	
	        return (_PropTypes$string = _react.PropTypes.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(others));
	      } else {
	        return _react.PropTypes.string.apply(_react.PropTypes, [props, propName, component].concat(others));
	      }
	    },
	
	    /**
	     * An optional function to call when the OK button is clicked.
	     * It is called with `(textFieldValue, clickEvent)`. This function
	     * will also be called when a user pressed the enter key.
	     */
	    onOkClick: _react.PropTypes.func,
	
	    /**
	     * The label to use for the OK button.
	     */
	    okLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * An optional function to call when the Cancel button is clicked.
	     * It is called with `(textFieldValueBeforeEdit, clickEvent)`. This
	     * function will also be called when the user presses the escape key.
	     */
	    onCancelClick: _react.PropTypes.func,
	
	    /**
	     * The label to use for the Cancel button.
	     */
	    cancelLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * An optional function to call when the edit dialog is open and the user clicks
	     * somewhere else on the page.
	     */
	    onOutsideClick: _react.PropTypes.func,
	
	    /**
	     * A boolean if the action when the edit dialog is open and the user clicks somewhere
	     * else on the page should be to confirm the current changes.
	     *
	     * If this is set to `true`, `onOkClick` will be called. Otherwise `onCancelClick` will
	     * be called.
	     */
	    okOnOutsideClick: _react.PropTypes.bool.isRequired,
	
	    /**
	     * An optional label for the text field.
	     */
	    label: _react.PropTypes.node,
	
	    /**
	     * An optional placeholder for the text field.
	     */
	    placeholder: _react.PropTypes.string,
	
	    /**
	     * Boolean if the text field should not appear in a dialog.
	     */
	    inline: (0, _invalidIf2.default)(_react.PropTypes.bool, 'title', 'large'),
	
	    /**
	     * Any children used to display an inline edit dialog's edit icon.
	     */
	    inlineIconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className used to display the inline edit dialog's edit icon.
	     */
	    inlineIconClassName: _react.PropTypes.string,
	
	    /**
	     * Boolean if an inline edit text field should not include an icon.
	     */
	    noIcon: (0, _invalidIf2.default)(_react.PropTypes.bool, 'title', 'large'),
	
	    /**
	     * This is injected by the `TableRow` component.
	     */
	    header: _react.PropTypes.bool,
	
	    /**
	     * The type for the text field.
	     */
	    type: _TextField2.default.propTypes.type,
	
	    /**
	     * Boolean if the min width of the dialog should be set to the `$md-edit-dialog-column-min-width` variable.
	     * If this is undefined, the min width will be enforced when the `type` prop is `text`.
	     */
	    enforceMinWidth: _react.PropTypes.bool,
	
	    /**
	     * When the dialog is open and a user scrolls the dialog offscreen, this is the amount
	     * of the dialog that should be offscreen before hiding the dialog (inverse). The default
	     * is to have 25% of the dialog offscreen.
	     */
	    scrollThreshold: _react.PropTypes.number.isRequired
	  };
	  EditDialogColumn.contextTypes = {
	    rowId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired
	  };
	  EditDialogColumn.defaultProps = {
	    type: 'text',
	    defaultValue: '',
	    transitionDuration: 300,
	    okOnOutsideClick: true,
	    okLabel: 'Save',
	    cancelLabel: 'Cancel',
	    inlineIconChildren: 'edit',
	    scrollThreshold: 0.75
	  };
	  exports.default = EditDialogColumn;
	});

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(131), __webpack_require__(121), __webpack_require__(81)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../SelectFields/SelectField'), require('./TableColumn'), require('./findTable'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.SelectField, global.TableColumn, global.findTable);
	    global.SelectFieldColumn = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _SelectField, _TableColumn, _findTable) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _SelectField2 = _interopRequireDefault(_SelectField);
	
	  var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	  var _findTable2 = _interopRequireDefault(_findTable);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var SelectFieldColumn = function (_PureComponent) {
	    _inherits(SelectFieldColumn, _PureComponent);
	
	    function SelectFieldColumn(props, context) {
	      _classCallCheck(this, SelectFieldColumn);
	
	      var _this = _possibleConstructorReturn(this, (SelectFieldColumn.__proto__ || Object.getPrototypeOf(SelectFieldColumn)).call(this, props, context));
	
	      _this.state = {
	        active: !!props.defaultOpen,
	        left: null,
	        width: null
	      };
	
	      _this._wrapper = null;
	      _this._table = null;
	      _this._left = null;
	      _this._scrollLeft = null;
	
	      _this._setWrapper = _this._setWrapper.bind(_this);
	      _this._repositionCell = _this._repositionCell.bind(_this);
	      _this._handleMenuToggle = _this._handleMenuToggle.bind(_this);
	      return _this;
	    }
	
	    _createClass(SelectFieldColumn, [{
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var active = this.state.active;
	
	        if (active === prevState.active) {
	          return;
	        } else if (this._table) {
	          this._table[(active ? 'add' : 'remove') + 'EventListener']('scroll', this._repositionCell);
	          this._left = active ? this.state.left : null;
	          this._scrollLeft = active ? this._table.scrollLeft : null;
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.table && this.state.active) {
	          this._table.removeEventListener('scroll', this._repositionCell);
	        }
	      }
	    }, {
	      key: '_setWrapper',
	      value: function _setWrapper(wrapper) {
	        this._wrapper = wrapper;
	        this._table = (0, _findTable2.default)(this._wrapper);
	      }
	    }, {
	      key: '_repositionCell',
	      value: function _repositionCell() {
	        var _this2 = this;
	
	        if (!this._ticking) {
	          requestAnimationFrame(function () {
	            _this2._ticking = false;
	
	            var left = _this2._left;
	            var scrolledOut = false;
	            if (_this2._table) {
	              var _table = _this2._table,
	                  scrollLeft = _table.scrollLeft,
	                  offsetWidth = _table.offsetWidth;
	
	              left -= scrollLeft - _this2._scrollLeft;
	              scrolledOut = left < 16 || offsetWidth - left < _this2.state.width * _this2.props.scrollThreshold;
	            }
	
	            var active = _this2.state.active;
	
	            if (!_this2._timeout && scrolledOut) {
	              active = false;
	            }
	
	            _this2.setState({ left: left, active: active });
	          });
	        }
	
	        this._ticking = true;
	      }
	    }, {
	      key: '_handleMenuToggle',
	      value: function _handleMenuToggle(active, e) {
	        if (this.props.onMenuToggle) {
	          this.props.onMenuToggle(active, e);
	        }
	
	        var width = null;
	        var left = null;
	        if (this._wrapper && active) {
	          left = this._wrapper.getBoundingClientRect().left - 1; // 1px for box shadow
	          width = this._wrapper.offsetWidth;
	        }
	
	        this.setState({ active: active, width: width, left: left });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var rowId = this.context.rowId;
	        var _state = this.state,
	            active = _state.active,
	            width = _state.width,
	            left = _state.left;
	
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            menuStyle = _props.menuStyle,
	            menuClassName = _props.menuClassName,
	            wrapperStyle = _props.wrapperStyle,
	            wrapperClassName = _props.wrapperClassName,
	            header = _props.header,
	            props = _objectWithoutProperties(_props, ['style', 'className', 'menuStyle', 'menuClassName', 'wrapperStyle', 'wrapperClassName', 'header']);
	
	        delete props.id;
	        delete props.scrollThreshold;
	
	        var id = this.props.id;
	
	        if (!id) {
	          id = rowId + '-select';
	        }
	
	        return _react2.default.createElement(
	          _TableColumn2.default,
	          {
	            style: _extends({ left: left }, style),
	            className: (0, _classnames2.default)('md-select-field-column', {
	              'md-table-column--fixed md-table-column--fixed-active': active
	            }, className),
	            header: header,
	            __fixedColumn: true
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              ref: this._setWrapper,
	              style: _extends({}, wrapperStyle, { width: width }),
	              className: wrapperClassName
	            },
	            _react2.default.createElement(_SelectField2.default, _extends({
	              id: id
	            }, props, {
	              style: menuStyle,
	              className: menuClassName,
	              onMenuToggle: this._handleMenuToggle,
	              fullWidth: true
	            }))
	          )
	        );
	      }
	    }]);
	
	    return SelectFieldColumn;
	  }(_react.PureComponent);
	
	  SelectFieldColumn.propTypes = {
	    /**
	     * An optional id to use for the select field in the column. If this is omitted,
	     * the id will be generated from the `baseId` from the `DataTable`.
	     */
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional style to apply to the `TableColumn`.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `TableColumn`.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the select field's wrapper in the column.
	     */
	    wrapperStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the select field's wrapper in the column.
	     */
	    wrapperClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the select field's menu component.
	     */
	    menuStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the select field's menu component.
	     */
	    menuClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the select field's input.
	     */
	    inputStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the select field's input.
	     */
	    inputClassName: _react.PropTypes.string,
	
	    /**
	     * Boolean if the `SelectFieldColumn` is in the `TableHeader` component. This is
	     * injected from the `TableRow` component. Should not be used.
	     */
	    header: _react.PropTypes.bool,
	
	    /**
	     * An optional function to call when the select field's menu is toggled open.
	     * See the select field component for the callback information.
	     */
	    onMenuToggle: _react.PropTypes.func,
	
	    /**
	     * The position of the select field. It is ideal to keep this as the default.
	     */
	    position: _SelectField2.default.propTypes.position,
	
	    /**
	     * Boolean if the select field is open by default.
	     */
	    defaultOpen: _react.PropTypes.bool,
	
	    /**
	     * When the dialog is open and a user scrolls the dialog offscreen, this is the amount
	     * of the dialog that should be offscreen before hiding the dialog (inverse). The default
	     * is to have 25% of the dialog offscreen.
	     */
	    scrollThreshold: _react.PropTypes.number.isRequired
	  };
	  SelectFieldColumn.defaultProps = {
	    position: _SelectField2.default.Positions.BELOW,
	    scrollThreshold: 0.75
	  };
	  SelectFieldColumn.contextTypes = {
	    rowId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
	  };
	  exports.default = SelectFieldColumn;
	});

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(80)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./contextTypes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.contextTypes);
	    global.TableBody = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _contextTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TableBody = function (_Component) {
	    _inherits(TableBody, _Component);
	
	    function TableBody() {
	      _classCallCheck(this, TableBody);
	
	      return _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
	    }
	
	    _createClass(TableBody, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            children = _props.children,
	            className = _props.className,
	            props = _objectWithoutProperties(_props, ['children', 'className']);
	
	        var _context = this.context,
	            selectedRows = _context.selectedRows,
	            toggleSelectedRow = _context.toggleSelectedRow;
	
	
	        var rows = children ? _react.Children.map(_react.Children.toArray(children), function (row, i) {
	          var uncontrolled = typeof row.props.selected === 'undefined';
	
	          // Update the row to inject the selected prop from context if it is uncontrolled.
	          // Also update the onCheckbox click function to additionally toggle the row if uncontrolled.
	          return _react2.default.cloneElement(row, _extends({}, row.props, {
	            index: i,
	            selected: uncontrolled ? selectedRows[i] : row.props.selected,
	            onCheckboxClick: function onCheckboxClick(checked, e) {
	              if (row.props.onCheckboxClick) {
	                row.props.onCheckboxClick(i, checked, e);
	              }
	
	              if (uncontrolled) {
	                toggleSelectedRow(i);
	              }
	            }
	          }));
	        }) : null;
	
	        return _react2.default.createElement(
	          'tbody',
	          _extends({}, props, { className: (0, _classnames2.default)('md-table-body', className) }),
	          rows
	        );
	      }
	    }]);
	
	    return TableBody;
	  }(_react.Component);
	
	  TableBody.propTypes = {
	    /**
	     * An optional style to apply to the tbody.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the tbody.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * A list or a single item of `TableRow` components to render.
	     */
	    children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)])
	  };
	  TableBody.contextTypes = _contextTypes2.default;
	  exports.default = TableBody;
	});

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(36), __webpack_require__(2), __webpack_require__(30), __webpack_require__(226), __webpack_require__(40), __webpack_require__(193)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-addons-css-transition-group'), require('classnames'), require('../constants/CSSTransitionGroupTick'), require('../utils/PropTypes/oneRequired'), require('../utils/PropTypes/invalidIf'), require('../Cards/CardTitleBlock'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactAddonsCssTransitionGroup, global.classnames, global.CSSTransitionGroupTick, global.oneRequired, global.invalidIf, global.CardTitleBlock);
	    global.TableCardHeader = mod.exports;
	  }
	})(this, function (exports, _react, _reactAddonsCssTransitionGroup, _classnames, _CSSTransitionGroupTick, _oneRequired, _invalidIf, _CardTitleBlock) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	  var _oneRequired2 = _interopRequireDefault(_oneRequired);
	
	  var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	  var _CardTitleBlock2 = _interopRequireDefault(_CardTitleBlock);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TableCardHeader = function (_PureComponent) {
	    _inherits(TableCardHeader, _PureComponent);
	
	    function TableCardHeader(props) {
	      _classCallCheck(this, TableCardHeader);
	
	      var _this = _possibleConstructorReturn(this, (TableCardHeader.__proto__ || Object.getPrototypeOf(TableCardHeader)).call(this, props));
	
	      _this.state = { animating: false };
	      return _this;
	    }
	
	    _createClass(TableCardHeader, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var visible = this.props.visible;
	        var nVisible = nextProps.visible,
	            transitionEnterTimeout = nextProps.transitionEnterTimeout,
	            transitionLeaveTimeout = nextProps.transitionLeaveTimeout;
	
	        var timeout = !nVisible ? transitionLeaveTimeout : transitionEnterTimeout;
	        if (visible !== nVisible) {
	          if (this._timeout) {
	            clearTimeout(this._timeout);
	          }
	
	          this._timeout = setTimeout(function () {
	            _this2._timeout = setTimeout(function () {
	              _this2._timeout = null;
	              _this2.setState({ animating: false });
	            }, timeout);
	          }, _CSSTransitionGroupTick2.default);
	
	          if (!this.state.animating) {
	            this.setState({ animating: true });
	          }
	        }
	      }
	    }, {
	      key: '_cloneCellRight',
	      value: function _cloneCellRight(noAdjust, children) {
	        if (noAdjust || !children) {
	          return children;
	        }
	
	        return _react.Children.map(_react.Children.toArray(children), function (child, i) {
	          if (i === 0) {
	            return (0, _react.cloneElement)(child, { className: (0, _classnames2.default)('md-cell--right', child.props.className) });
	          }
	
	          return child;
	        });
	      }
	    }, {
	      key: '_cloneLeftChildren',
	      value: function _cloneLeftChildren(noClone, children) {
	        if (noClone || !children) {
	          return children;
	        }
	
	        return _react.Children.map(_react.Children.toArray(children), function (child) {
	          return (0, _react.cloneElement)(child, {
	            className: (0, _classnames2.default)('md-btn--dialog', child.props.className)
	          });
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var animating = this.state.animating;
	
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            title = _props.title,
	            actions = _props.actions,
	            contextualChildren = _props.contextualChildren,
	            noActionsAdjust = _props.noActionsAdjust,
	            noChildrenAdjust = _props.noChildrenAdjust,
	            noLeftChildrenClone = _props.noLeftChildrenClone,
	            visible = _props.visible,
	            props = _objectWithoutProperties(_props, ['style', 'className', 'title', 'actions', 'contextualChildren', 'noActionsAdjust', 'noChildrenAdjust', 'noLeftChildrenClone', 'visible']);
	
	        delete props.children;
	        delete props.leftChildren;
	        delete props.contextualTitle;
	
	        var _props2 = this.props,
	            children = _props2.children,
	            leftChildren = _props2.leftChildren,
	            contextualTitle = _props2.contextualTitle;
	
	        children = this._cloneCellRight(noChildrenAdjust, children);
	        leftChildren = this._cloneLeftChildren(noLeftChildrenClone, leftChildren);
	
	        if (title) {
	          children = _react2.default.createElement(
	            'div',
	            { className: 'md-card-title', key: 'main-title' },
	            _react2.default.createElement(_CardTitleBlock2.default, { title: title }),
	            children
	          );
	        } else if (leftChildren) {
	          leftChildren = _react.Children.toArray(leftChildren);
	
	          if (children) {
	            children = leftChildren.concat(_react.Children.toArray(children));
	          } else {
	            children = leftChildren;
	          }
	        }
	
	        if (contextualTitle) {
	          contextualTitle = _react2.default.createElement(
	            'h2',
	            { className: 'md-card-title--title md-card-title--title-contextual' },
	            contextualTitle
	          );
	        }
	
	        var contextualHeader = _react2.default.createElement(
	          'div',
	          { key: 'contextual-header', className: 'md-card-title md-card-title--contextual' },
	          contextualTitle,
	          contextualChildren,
	          this._cloneCellRight(noActionsAdjust, actions)
	        );
	
	        var mergedStyles = style;
	        if (animating) {
	          mergedStyles = Object.assign({}, style, { overflow: 'hidden' });
	        }
	
	        return _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          _extends({}, props, {
	            style: mergedStyles,
	            className: (0, _classnames2.default)('md-table-card-header', {
	              'md-table-card-header--no-title': !title
	            }, className)
	          }),
	          children,
	          visible ? contextualHeader : null
	        );
	      }
	    }]);
	
	    return TableCardHeader;
	  }(_react.PureComponent);
	
	  TableCardHeader.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The component to render as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * The transition name to use when the contextual header appears.
	     */
	    transitionName: _react.PropTypes.string.isRequired,
	
	    /**
	     * The transition time to use when the contextual header appears.
	     */
	    transitionEnterTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * The transition time to use when the contextual header disappears.
	     */
	    transitionLeaveTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * An optional title to display. It is invalid to have both `title` and `leftChildren`
	     * defined as only one will be used.
	     */
	    title: (0, _oneRequired2.default)(_react.PropTypes.node, 'leftChildren', 'children'),
	
	    /**
	     * An optional title to display in the contextual header. This will get wrapped in an `h2`
	     * tag and additional styles applied.
	     */
	    contextualTitle: _react.PropTypes.node,
	
	    /**
	     * Any additional children to display in the contextual header. This will be displayed after
	     * the optional `contextualTile` and before the `actions`.
	     */
	    contextualChildren: _react.PropTypes.node,
	
	    /**
	     * An optional button or list of buttons to display instead of a title.
	     */
	    leftChildren: (0, _invalidIf2.default)(_react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)]), 'title'),
	
	    /**
	     * An additional children to display after the `title` or `leftChildren` prop.
	     * This is _normally_ a list of icon button or menu button.
	     */
	    children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)]),
	
	    /**
	     * An optional button/menu button or a list of button/menu button to display in the
	     * contextual header once the user has selected a row or multiple rows.
	     */
	    actions: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)]),
	
	    /**
	     * Boolean if the `actions` prop should not have each element cloned with additional
	     * class names.
	     */
	    noActionsAdjust: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `children` prop should not have each element cloned with additional
	     * class names.
	     */
	    noChildrenAdjust: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `leftChildren` prop should not have each element cloned with additional
	     * class names.
	     */
	    noLeftChildrenClone: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the contextual header is currently visible.
	     */
	    visible: _react.PropTypes.bool.isRequired
	  };
	  TableCardHeader.defaultProps = {
	    component: 'header',
	    transitionName: 'md-drop-down',
	    transitionEnterTimeout: 150,
	    transitionLeaveTimeout: 150
	  };
	  exports.default = TableCardHeader;
	});

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(51), __webpack_require__(421), __webpack_require__(81)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../SelectionControls/SelectionControl'), require('./checkboxContextTypes'), require('./findTable'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.SelectionControl, global.checkboxContextTypes, global.findTable);
	    global.TableCheckbox = mod.exports;
	  }
	})(this, function (exports, _react, _SelectionControl, _checkboxContextTypes, _findTable) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	  var _checkboxContextTypes2 = _interopRequireDefault(_checkboxContextTypes);
	
	  var _findTable2 = _interopRequireDefault(_findTable);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TableCheckbox = function (_Component) {
	    _inherits(TableCheckbox, _Component);
	
	    function TableCheckbox(props, context) {
	      _classCallCheck(this, TableCheckbox);
	
	      var _this = _possibleConstructorReturn(this, (TableCheckbox.__proto__ || Object.getPrototypeOf(TableCheckbox)).call(this, props, context));
	
	      _this._td = null;
	      _this._header = false;
	      _this._handleMount = _this._handleMount.bind(_this);
	      return _this;
	    }
	
	    _createClass(TableCheckbox, [{
	      key: '_handleMount',
	      value: function _handleMount(td) {
	        if (td) {
	          var header = (0, _findTable2.default)(td).querySelector('thead');
	          var index = td.parentNode.rowIndex - (header ? 1 : 0);
	
	          if (td.parentNode.parentNode.tagName === 'TBODY') {
	            this.context.createCheckbox(index);
	          }
	          this._td = td;
	          this._header = header;
	        } else if (this._td) {
	          var _index = this._td.parentNode.rowIndex;
	          this.context.removeCheckbox(_index - (this._header ? 1 : 0));
	          this._td = null;
	          this._header = false;
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            checked = _props.checked,
	            props = _objectWithoutProperties(_props, ['checked']);
	
	        var _context = this.context,
	            uncheckedIconChildren = _context.uncheckedIconChildren,
	            uncheckedIconClassName = _context.uncheckedIconClassName,
	            checkedIconChildren = _context.checkedIconChildren,
	            checkedIconClassName = _context.checkedIconClassName,
	            rowId = _context.rowId,
	            baseName = _context.baseName;
	
	
	        return _react2.default.createElement(
	          'td',
	          { className: 'md-table-checkbox', ref: this._handleMount },
	          _react2.default.createElement(_SelectionControl2.default, _extends({}, props, {
	            id: rowId,
	            name: baseName + '-checkbox',
	            type: 'checkbox',
	            checked: checked,
	            uncheckedCheckboxIconChildren: uncheckedIconChildren,
	            uncheckedCheckboxIconClassName: uncheckedIconClassName,
	            checkedCheckboxIconChildren: checkedIconChildren,
	            checkedCheckboxIconClassName: checkedIconClassName
	          }))
	        );
	      }
	    }]);
	
	    return TableCheckbox;
	  }(_react.Component);
	
	  TableCheckbox.propTypes = {
	    checked: _react.PropTypes.bool
	  };
	  TableCheckbox.contextTypes = _checkboxContextTypes2.default;
	  exports.default = TableCheckbox;
	});

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(80), __webpack_require__(122)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./contextTypes'), require('./headerContextTypes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.contextTypes, global.headerContextTypes);
	    global.TableHeader = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _contextTypes, _headerContextTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _contextTypes2 = _interopRequireDefault(_contextTypes);
	
	  var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TableHeader = function (_Component) {
	    _inherits(TableHeader, _Component);
	
	    function TableHeader() {
	      _classCallCheck(this, TableHeader);
	
	      return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
	    }
	
	    _createClass(TableHeader, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return _extends({}, this.context, {
	          header: true
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            children = _props.children,
	            props = _objectWithoutProperties(_props, ['className', 'children']);
	
	        var _context = this.context,
	            toggleAllRows = _context.toggleAllRows,
	            allSelected = _context.allSelected;
	
	        var header = _react2.default.Children.only(children);
	        var selected = typeof header.props.selected === 'undefined' ? allSelected : header.props.selected;
	
	        var row = _react2.default.cloneElement(header, _extends({}, header.props, {
	          selected: selected,
	          onCheckboxClick: function onCheckboxClick(checked, e) {
	            if (header.props.onCheckboxClick) {
	              header.props.onCheckboxClick(-1, checked, e);
	            }
	
	            if (typeof header.props.selected === 'undefined') {
	              toggleAllRows();
	            }
	          }
	        }));
	
	        return _react2.default.createElement(
	          'thead',
	          _extends({}, props, { className: (0, _classnames2.default)('md-table-header', className) }),
	          row
	        );
	      }
	    }]);
	
	    return TableHeader;
	  }(_react.Component);
	
	  TableHeader.contextTypes = _contextTypes2.default;
	  TableHeader.childContextTypes = _headerContextTypes2.default;
	  TableHeader.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the table header
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * This should be a single `TableRow` component. The `custom` validation will
	     * warn you if there are more than one children given or none at all.
	     */
	    children: function children(props, propName, component) {
	      try {
	        _react2.default.Children.only(props.children);
	        return null;
	      } catch (e) {
	        var amt = props.children ? props.children.length : 0;
	        return new Error('There must only be one child in a \'' + component + '\', but ' + amt + ' were given.');
	      }
	    }
	  };
	  exports.default = TableHeader;
	});

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(12), __webpack_require__(131), __webpack_require__(16), __webpack_require__(81)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('../utils/getField'), require('../SelectFields/SelectField'), require('../Buttons/Button'), require('./findTable'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.getField, global.SelectField, global.Button, global.findTable);
	    global.TablePagination = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _getField, _SelectField, _Button, _findTable) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _SelectField2 = _interopRequireDefault(_SelectField);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  var _findTable2 = _interopRequireDefault(_findTable);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var
	
	  /**
	   * The `TablePagination` component is used to generate the table footer that helps
	   * pagination through a large dataset by limiting the number of rows per page.
	   * The pagination will always be placed persistently at the bottom of the table
	   * so that when a user scrolls to the right, they will always be able to use the
	   * pagination.
	   */
	  TablePagination = function (_PureComponent) {
	    _inherits(TablePagination, _PureComponent);
	
	    function TablePagination(props, context) {
	      _classCallCheck(this, TablePagination);
	
	      var _this = _possibleConstructorReturn(this, (TablePagination.__proto__ || Object.getPrototypeOf(TablePagination)).call(this, props, context));
	
	      var rpp = typeof props.rowsPerPage !== 'undefined' ? props.rowsPerPage : props.defaultRowsPerPage;
	      var p = typeof props.page !== 'undefined' ? props.page : props.defaultPage;
	      _this.state = {
	        page: props.defaultPage,
	        start: (p - 1) * rpp,
	        rowsPerPage: props.defaultRowsPerPage,
	        controlsMarginLeft: 0
	      };
	
	      _this._setControls = _this._setControls.bind(_this);
	      _this._position = _this._position.bind(_this);
	      _this._increment = _this._increment.bind(_this);
	      _this._decrement = _this._decrement.bind(_this);
	      _this._setRowsPerPage = _this._setRowsPerPage.bind(_this);
	      return _this;
	    }
	
	    _createClass(TablePagination, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._position();
	        window.addEventListener('resize', this._position);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var rows = this.props.rows;
	        var _state = this.state,
	            start = _state.start,
	            rowsPerPage = _state.rowsPerPage;
	
	        if (rows !== prevProps.rows || start !== prevState.start || rowsPerPage !== prevState.rowsPerPage) {
	          this._position();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this._position);
	      }
	    }, {
	      key: '_setControls',
	      value: function _setControls(controls) {
	        this._controls = (0, _reactDom.findDOMNode)(controls);
	      }
	    }, {
	      key: '_position',
	      value: function _position() {
	        var table = (0, _findTable2.default)((0, _reactDom.findDOMNode)(this));
	        if (table) {
	          this.setState({
	            controlsMarginLeft: Math.max(0, table.offsetWidth - this._controls.offsetWidth)
	          });
	        }
	      }
	    }, {
	      key: '_increment',
	      value: function _increment() {
	        var _props = this.props,
	            rows = _props.rows,
	            onPagination = _props.onPagination;
	        var start = this.state.start;
	
	        var rowsPerPage = (0, _getField2.default)(this.props, this.state, 'rowsPerPage');
	        var page = (0, _getField2.default)(this.props, this.state, 'page');
	
	        // Only correct multiple of rows per page
	        var max = rows - rows % rowsPerPage;
	
	        var newStart = Math.min(start + rowsPerPage, max);
	        var nextPage = page + 1;
	
	        onPagination(newStart, rowsPerPage, nextPage);
	        this.setState({ start: newStart, page: nextPage });
	      }
	    }, {
	      key: '_decrement',
	      value: function _decrement() {
	        var start = this.state.start;
	
	        var page = (0, _getField2.default)(this.props, this.state, 'page');
	        var rowsPerPage = (0, _getField2.default)(this.props, this.state, 'rowsPerPage');
	        var newStart = Math.max(0, start - rowsPerPage);
	        var nextPage = page - 1;
	
	        this.props.onPagination(newStart, rowsPerPage, nextPage);
	        this.setState({ start: newStart, page: nextPage });
	      }
	    }, {
	      key: '_setRowsPerPage',
	      value: function _setRowsPerPage(rowsPerPage) {
	        var page = (0, _getField2.default)(this.props, this.state, 'page');
	        var newStart = (page - 1) * rowsPerPage;
	        this.props.onPagination(newStart, rowsPerPage, page);
	        this.setState({ start: newStart, rowsPerPage: rowsPerPage });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state2 = this.state,
	            controlsMarginLeft = _state2.controlsMarginLeft,
	            start = _state2.start;
	
	        var _props2 = this.props,
	            className = _props2.className,
	            rows = _props2.rows,
	            rowsPerPageLabel = _props2.rowsPerPageLabel,
	            rowsPerPageItems = _props2.rowsPerPageItems,
	            incrementIconChildren = _props2.incrementIconChildren,
	            incrementIconClassName = _props2.incrementIconClassName,
	            decrementIconChildren = _props2.decrementIconChildren,
	            decrementIconClassName = _props2.decrementIconClassName,
	            props = _objectWithoutProperties(_props2, ['className', 'rows', 'rowsPerPageLabel', 'rowsPerPageItems', 'incrementIconChildren', 'incrementIconClassName', 'decrementIconChildren', 'decrementIconClassName']);
	
	        delete props.onPagination;
	        delete props.rowsPerPage;
	        delete props.defaultPage;
	        delete props.defaultRowsPerPage;
	        delete props.page;
	
	        var rowsPerPage = (0, _getField2.default)(this.props, this.state, 'rowsPerPage');
	
	        var pagination = start + 1 + '-' + Math.min(rows, start + rowsPerPage) + ' of ' + rows;
	        return _react2.default.createElement(
	          'tfoot',
	          _extends({}, props, { className: (0, _classnames2.default)('md-table-footer', className) }),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              { colSpan: '100%' },
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: this._setControls,
	                  className: 'md-table-pagination md-table-pagination--controls md-text',
	                  style: { marginLeft: controlsMarginLeft }
	                },
	                rowsPerPageLabel,
	                _react2.default.createElement(_SelectField2.default, {
	                  id: this.context.baseId + '-pagination',
	                  menuItems: rowsPerPageItems,
	                  position: _SelectField2.default.Positions.BELOW,
	                  inputClassName: 'md-select-field--pagination',
	                  value: rowsPerPage,
	                  onChange: this._setRowsPerPage
	                }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'md-table-pagination--label' },
	                  pagination
	                ),
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    icon: true,
	                    onClick: this._decrement,
	                    disabled: start === 0,
	                    iconClassName: decrementIconClassName
	                  },
	                  decrementIconChildren
	                ),
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    icon: true,
	                    onClick: this._increment,
	                    disabled: start + rowsPerPage >= rows,
	                    iconClassName: incrementIconClassName
	                  },
	                  incrementIconChildren
	                )
	              ),
	              _react2.default.createElement('div', { className: 'md-table-pagination' })
	            )
	          )
	        );
	      }
	    }]);
	
	    return TablePagination;
	  }(_react.PureComponent);
	
	  TablePagination.propTypes = {
	    /**
	     * An optional style to apply to the `tfoot` tag.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `tfoot` tag.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * A function to call when a user clicks the increment or decrement pagination
	     * icon button. This function will be given the new start index and the number
	     * or rows per page as well as the current page.
	     *
	     * ```js
	     * onPagination(newStart, rowsPerPage, currentPage);
	     * ```
	     */
	    onPagination: _react.PropTypes.func.isRequired,
	
	    /**
	     * The current value for the select field holding the number of rows per page.
	     */
	    rowsPerPage: _react.PropTypes.number,
	
	    /**
	     * The current page for the pagination. This will make the comonent controlled, so the only way to get pagination
	     * is making sure you are updating this prop after the `onPagination` callback is called.
	     *
	     * Pages start from 1 instead of 0.
	     */
	    page: _react.PropTypes.number,
	
	    /**
	     * The default page to start from for the pagination. Pages start from 1 instead of 0.
	     */
	    defaultPage: _react.PropTypes.number.isRequired,
	
	    /**
	     * The default number of rows per page to display. This will be the value for the
	     * `SelectField`.
	     */
	    defaultRowsPerPage: _react.PropTypes.number.isRequired,
	
	    /**
	     * The label to use for the rows per page `SelectField`.
	     */
	    rowsPerPageLabel: _react.PropTypes.node.isRequired,
	
	    /**
	     * A list of numbers for the amount of rows per page to display at a time.
	     * This will be rendered into the `SelectField`.
	     */
	    rowsPerPageItems: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired,
	
	    /**
	     * The total number of rows that can be displayed. This is the unfiltered/non-subset
	     * number of rows. This is used to help calculate the increment/decrement values to
	     * display and determine if the user can increment/decrement again.
	     */
	    rows: _react.PropTypes.number.isRequired,
	
	    /**
	     * Any children used to display the increment icon button.
	     */
	    incrementIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className used to display the increment icon button.
	     */
	    incrementIconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children used to display the decrement icon button.
	     */
	    decrementIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className used to display the decrement icon button.
	     */
	    decrementIconClassName: _react.PropTypes.string
	  };
	  TablePagination.contextTypes = {
	    baseId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired
	  };
	  TablePagination.defaultProps = {
	    defaultPage: 1,
	    defaultRowsPerPage: 10,
	    rowsPerPageLabel: 'Rows per page:',
	    rowsPerPageItems: [10, 20, 30, 40, 50, 100],
	    incrementIconChildren: 'keyboard_arrow_right',
	    decrementIconChildren: 'keyboard_arrow_left'
	  };
	  exports.default = TablePagination;
	});

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(12), __webpack_require__(122), __webpack_require__(423), __webpack_require__(417)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../utils/getField'), require('./headerContextTypes'), require('./rowContextTypes'), require('./TableCheckbox'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.getField, global.headerContextTypes, global.rowContextTypes, global.TableCheckbox);
	    global.TableRow = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _getField, _headerContextTypes, _rowContextTypes, _TableCheckbox) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	  var _rowContextTypes2 = _interopRequireDefault(_rowContextTypes);
	
	  var _TableCheckbox2 = _interopRequireDefault(_TableCheckbox);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TableRow = function (_Component) {
	    _inherits(TableRow, _Component);
	
	    function TableRow(props, context) {
	      _classCallCheck(this, TableRow);
	
	      var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props, context));
	
	      _this.state = {
	        biggest: null,
	        hover: false,
	        selects: []
	      };
	
	      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      _this._setLongestColumn = _this._setLongestColumn.bind(_this);
	      return _this;
	    }
	
	    _createClass(TableRow, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        var _context = this.context,
	            baseId = _context.baseId,
	            context = _objectWithoutProperties(_context, ['baseId']);
	
	        return _extends({}, context, {
	          rowId: context.header ? baseId + 'CheckboxToggleAll' : '' + baseId + this.props.index
	        });
	      }
	    }, {
	      key: '_ignoreHoverState',
	      value: function _ignoreHoverState(classList) {
	        return classList.contains('md-list--menu') || ['md-edit-dialog', 'md-edit-dialog--active'].every(function (className) {
	          return classList.contains(className);
	        });
	      }
	    }, {
	      key: '_handleMouseOver',
	      value: function _handleMouseOver(e) {
	        if (this.props.onMouseOver) {
	          this.props.onMouseOver(e);
	        }
	
	        if (this.context.header) {
	          return;
	        }
	
	        var target = e.target;
	        while (target && target.parentNode) {
	          if (target.classList && this._ignoreHoverState(target.classList)) {
	            this.setState({ hover: false });
	            return;
	          }
	
	          target = target.parentNode;
	        }
	
	        this.setState({ hover: true });
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave(e) {
	        if (this.props.onMouseLeave) {
	          this.props.onMouseLeave(e);
	        }
	
	        if (this.context.header) {
	          return;
	        }
	
	        this.setState({ hover: false });
	      }
	    }, {
	      key: '_setLongestColumn',
	      value: function _setLongestColumn(row) {
	        if (!row || !this.props.autoAdjust) {
	          return;
	        }
	
	        var selects = [];
	        var cols = Array.prototype.slice.call(row.querySelectorAll('.md-table-column'));
	        var biggest = cols.reduce(function (prevBiggest, col, i) {
	          selects.push(!!col.className.match(/select-field/));
	          if (col.className.match(/prevent-grow/)) {
	            return prevBiggest;
	          }
	
	          var width = col.offsetWidth;
	          if (prevBiggest.width < width) {
	            return { width: width, index: i };
	          }
	
	          return prevBiggest;
	        }, { width: 0, index: 0 });
	
	        if (this.state.biggest && this.state.biggest.index === biggest.index) {
	          return;
	        }
	
	        this.setState({ biggest: biggest, selects: selects });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var _state = this.state,
	            hover = _state.hover,
	            biggest = _state.biggest,
	            selects = _state.selects;
	
	        var _props = this.props,
	            className = _props.className,
	            children = _props.children,
	            selected = _props.selected,
	            onCheckboxClick = _props.onCheckboxClick,
	            props = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'onCheckboxClick']);
	
	        delete props.index;
	        delete props.autoAdjust;
	
	        var checkbox = void 0;
	        if (!this.context.plain) {
	          checkbox = _react2.default.createElement(_TableCheckbox2.default, { key: 'checkbox', checked: selected, onChange: onCheckboxClick });
	        }
	
	        var length = children.length;
	        var columns = _react.Children.map(_react.Children.toArray(children), function (col, i) {
	          return (0, _react.cloneElement)(col, {
	            header: (0, _getField2.default)(col.props, _this2.context, 'header'),
	            className: (0, _classnames2.default)({
	              'md-table-column--grow': (0, _getField2.default)(col.props, _this2.context, 'header') && biggest && biggest.index === i,
	              'md-table-column--adjusted': selects.length && !selects[i] && biggest && biggest.index !== i && i + 1 < length
	            }, col.props.className)
	          });
	        });
	
	        return _react2.default.createElement(
	          'tr',
	          _extends({}, props, {
	            ref: this._setLongestColumn,
	            className: (0, _classnames2.default)('md-table-row', className, {
	              'md-table-row--hover': hover,
	              'md-table-row--active': !this.context.header && selected
	            }),
	            onMouseOver: this._handleMouseOver,
	            onMouseLeave: this._handleMouseLeave
	          }),
	          checkbox,
	          columns
	        );
	      }
	    }]);
	
	    return TableRow;
	  }(_react.Component);
	
	  TableRow.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the row.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * A single or list of `TableColumn` to display in the table.
	     *
	     * > The specs "require" at least 3 columns for a non-plain data table, but that isn't
	     * strictly enforced here.
	     */
	    children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)]).isRequired,
	
	    /**
	     * An optional onClick function to call when a row is clicked.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * A function to call when the checkbox is clicked. This
	     * function will will be called with `(rowIndex, event)`. The
	     * `TableBody` and `TableHeader` components will automatically
	     * merge in a function to goggle the checkbox.
	     */
	    onCheckboxClick: _react.PropTypes.func,
	
	    /**
	     * A boolean if the row should automatically check all the `TableColumn`s in the row
	     * and add the className `grow` to the one that is the biggest. You can also disable
	     * individual columns by adding the className `.prevent-grow` to them.
	     */
	    autoAdjust: _react.PropTypes.bool.isRequired,
	
	    /**
	     * An optional function to call onMouseOver.
	     */
	    onMouseOver: _react.PropTypes.func,
	
	    /**
	     * An optional function to call onMouseLeave.
	     */
	    onMouseLeave: _react.PropTypes.func,
	
	    /**
	     * Boolean if the row is currently selected. If this value will be
	     * injected by the `TableHeader` or `TableBody` component.
	     */
	    selected: _react.PropTypes.bool,
	
	    /**
	     * The row's index in the table. This is injected via the `TableBody` component.
	     */
	    index: _react.PropTypes.number
	  };
	  TableRow.defaultProps = {
	    autoAdjust: true
	  };
	  TableRow.contextTypes = _headerContextTypes2.default;
	  TableRow.childContextTypes = _rowContextTypes2.default;
	  exports.default = TableRow;
	});

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react);
	    global.checkboxContextTypes = mod.exports;
	  }
	})(this, function (exports, _react) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = {
	    uncheckedIconClassName: _react.PropTypes.string.isRequired,
	    uncheckedIconChildren: _react.PropTypes.node,
	    checkedIconClassName: _react.PropTypes.string.isRequired,
	    checkedIconChildren: _react.PropTypes.node,
	    rowId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
	    baseName: _react.PropTypes.string.isRequired,
	    createCheckbox: _react.PropTypes.func.isRequired,
	    removeCheckbox: _react.PropTypes.func.isRequired
	  };
	});

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(412), __webpack_require__(418), __webpack_require__(415), __webpack_require__(420), __webpack_require__(121), __webpack_require__(413), __webpack_require__(419), __webpack_require__(416), __webpack_require__(414)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./DataTable'), require('./TableHeader'), require('./TableBody'), require('./TableRow'), require('./TableColumn'), require('./EditDialogColumn'), require('./TablePagination'), require('./TableCardHeader'), require('./SelectFieldColumn'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.DataTable, global.TableHeader, global.TableBody, global.TableRow, global.TableColumn, global.EditDialogColumn, global.TablePagination, global.TableCardHeader, global.SelectFieldColumn);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _DataTable2, _TableHeader2, _TableBody2, _TableRow2, _TableColumn2, _EditDialogColumn2, _TablePagination2, _TableCardHeader2, _SelectFieldColumn2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.SelectFieldColumn = exports.TableCardHeader = exports.TablePagination = exports.EditDialogColumn = exports.TableColumn = exports.TableRow = exports.TableBody = exports.TableHeader = exports.DataTable = undefined;
	
	  var _DataTable3 = _interopRequireDefault(_DataTable2);
	
	  var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	  var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	  var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	  var _TableColumn3 = _interopRequireDefault(_TableColumn2);
	
	  var _EditDialogColumn3 = _interopRequireDefault(_EditDialogColumn2);
	
	  var _TablePagination3 = _interopRequireDefault(_TablePagination2);
	
	  var _TableCardHeader3 = _interopRequireDefault(_TableCardHeader2);
	
	  var _SelectFieldColumn3 = _interopRequireDefault(_SelectFieldColumn2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _DataTable3.default;
	  exports.DataTable = _DataTable3.default;
	  exports.TableHeader = _TableHeader3.default;
	  exports.TableBody = _TableBody3.default;
	  exports.TableRow = _TableRow3.default;
	  exports.TableColumn = _TableColumn3.default;
	  exports.EditDialogColumn = _EditDialogColumn3.default;
	  exports.TablePagination = _TablePagination3.default;
	  exports.TableCardHeader = _TableCardHeader3.default;
	  exports.SelectFieldColumn = _SelectFieldColumn3.default;
	});

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(122)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('./headerContextTypes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.headerContextTypes);
	    global.rowContextTypes = mod.exports;
	  }
	})(this, function (exports, _react, _headerContextTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _headerContextTypes2 = _interopRequireDefault(_headerContextTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var rowContextTypes = Object.assign({}, _headerContextTypes2.default, {
	    rowId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
	  });
	
	  delete rowContextTypes.baseId;
	  exports.default = rowContextTypes;
	});

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(224), __webpack_require__(199), __webpack_require__(26), __webpack_require__(425), __webpack_require__(63)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('../utils/EventUtils/isValidFocusKeypress'), require('../Helpers/FocusContainer'), require('../Papers/Paper'), require('./DialogTitle'), require('./DialogFooter'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.isValidFocusKeypress, global.FocusContainer, global.Paper, global.DialogTitle, global.DialogFooter);
	    global.Dialog = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _isValidFocusKeypress, _FocusContainer, _Paper, _DialogTitle, _DialogFooter) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isValidFocusKeypress2 = _interopRequireDefault(_isValidFocusKeypress);
	
	  var _FocusContainer2 = _interopRequireDefault(_FocusContainer);
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _toArray(arr) {
	    return Array.isArray(arr) ? arr : Array.from(arr);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Dialog = function (_PureComponent) {
	    _inherits(Dialog, _PureComponent);
	
	    function Dialog(props) {
	      _classCallCheck(this, Dialog);
	
	      var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));
	
	      _this._setRenderNode = function (dialog) {
	        _this._renderNode = (0, _reactDom.findDOMNode)(dialog);
	      };
	
	      _this.state = { transformOrigin: null };
	      _this._setContent = _this._setContent.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      return _this;
	    }
	
	    _createClass(Dialog, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return { renderNode: this._renderNode };
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _props = this.props,
	            pageX = _props.pageX,
	            containerX = _props.containerX,
	            pageY = _props.pageY,
	            containerY = _props.containerY;
	
	        if (!pageX || !pageY) {
	          return;
	        }
	
	        this.setState({
	          transformOrigin: pageX - containerX + 'px ' + (pageY - containerY) + 'px'
	        });
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.props.onOpen) {
	          this.props.onOpen();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.props.onLeave) {
	          this.props.onLeave();
	        }
	      }
	    }, {
	      key: '_setContent',
	      value: function _setContent(content) {
	        if (content !== null) {
	          this._content = (0, _reactDom.findDOMNode)(content);
	          var contentPadded = this._content.querySelectorAll('.md-list').length === 0;
	
	          this.setState({ contentPadded: contentPadded });
	        }
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        if (!(0, _isValidFocusKeypress2.default)(e)) {
	          return;
	        }
	
	        var target = e.target,
	            shiftKey = e.shiftKey;
	
	        var _innerFocusables = _toArray(this._innerFocusables),
	            first = _innerFocusables[0],
	            focusables = _innerFocusables.slice(1);
	
	        var last = focusables[focusables.length - 1];
	
	        if (shiftKey && target === first) {
	          e.preventDefault();
	          last.focus();
	        } else if (!shiftKey && target === last) {
	          e.preventDefault();
	          first.focus();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            contentPadded = _state.contentPadded,
	            transformOrigin = _state.transformOrigin;
	
	        var _props2 = this.props,
	            id = _props2.id,
	            className = _props2.className,
	            contentStyle = _props2.contentStyle,
	            contentClassName = _props2.contentClassName,
	            title = _props2.title,
	            Content = _props2.contentComponent,
	            actions = _props2.actions,
	            children = _props2.children,
	            fullPage = _props2.fullPage,
	            props = _objectWithoutProperties(_props2, ['id', 'className', 'contentStyle', 'contentClassName', 'title', 'contentComponent', 'actions', 'children', 'fullPage']);
	
	        delete props.pageX;
	        delete props.pageY;
	        delete props.containerX;
	        delete props.containerY;
	        delete props.style;
	        delete props.onOpen;
	        delete props.onLeave;
	
	        var _props3 = this.props,
	            labelledBy = _props3['aria-labelledby'],
	            style = _props3.style;
	
	        var titleId = id + 'Title';
	        if (!labelledBy && title) {
	          labelledBy = titleId;
	        }
	
	        var dialogChildren = fullPage ? children : [_react2.default.createElement(
	          _DialogTitle2.default,
	          { key: 'title', id: titleId },
	          title
	        ), _react2.default.createElement(
	          Content,
	          {
	            ref: this._setContent,
	            key: 'content',
	            style: contentStyle,
	            className: (0, _classnames2.default)('md-dialog-content', {
	              'md-dialog-content--padded': contentPadded
	            }, contentClassName)
	          },
	          children
	        ), _react2.default.createElement(_DialogFooter2.default, { key: 'footer', actions: actions })];
	
	        if (transformOrigin) {
	          style = Object.assign({}, style, { transformOrigin: transformOrigin });
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          _extends({}, props, {
	            id: id,
	            component: _FocusContainer2.default,
	            ref: this._setRenderNode,
	            style: style,
	            className: (0, _classnames2.default)('md-background--card md-dialog', {
	              'md-dialog--full-page': fullPage,
	              'md-dialog--centered': !fullPage
	            }, className),
	            role: 'dialog',
	            'aria-labelledby': labelledBy
	          }),
	          dialogChildren
	        );
	      }
	    }]);
	
	    return Dialog;
	  }(_react.PureComponent);
	
	  Dialog.propTypes = {
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    'aria-labelledby': _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    contentStyle: _react.PropTypes.object,
	    contentClassName: _react.PropTypes.string,
	    title: _react.PropTypes.node,
	    children: _react.PropTypes.node,
	    contentComponent: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired,
	    actions: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.object, _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.object]))]),
	    initialFocus: _react.PropTypes.string,
	    pageX: _react.PropTypes.number,
	    pageY: _react.PropTypes.number,
	    containerX: _react.PropTypes.number,
	    containerY: _react.PropTypes.number,
	    fullPage: _react.PropTypes.bool,
	    onLeave: _react.PropTypes.func,
	    zDepth: _react.PropTypes.number.isRequired,
	    focusOnMount: _react.PropTypes.bool,
	    onOpen: _react.PropTypes.func
	  };
	  Dialog.defaultProps = {
	    contentComponent: 'section',
	    zDepth: 5
	  };
	  Dialog.childContextTypes = {
	    renderNode: _react.PropTypes.object
	  };
	  exports.default = Dialog;
	});

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.DialogTitle = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var DialogTitle = function (_PureComponent) {
	    _inherits(DialogTitle, _PureComponent);
	
	    function DialogTitle() {
	      _classCallCheck(this, DialogTitle);
	
	      return _possibleConstructorReturn(this, (DialogTitle.__proto__ || Object.getPrototypeOf(DialogTitle)).apply(this, arguments));
	    }
	
	    _createClass(DialogTitle, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            children = _props.children,
	            className = _props.className,
	            props = _objectWithoutProperties(_props, ['children', 'className']);
	
	        if (!children) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'h2',
	          _extends({}, props, { className: (0, _classnames2.default)('md-title md-title--dialog', className) }),
	          children
	        );
	      }
	    }]);
	
	    return DialogTitle;
	  }(_react.PureComponent);
	
	  DialogTitle.propTypes = {
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    className: _react.PropTypes.string,
	    children: _react.PropTypes.node
	  };
	  exports.default = DialogTitle;
	});

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(123)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./DialogContainer'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.DialogContainer);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _DialogContainer) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _DialogContainer2 = _interopRequireDefault(_DialogContainer);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _DialogContainer2.default;
	});

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(124)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Divider'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Divider);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Divider) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Divider2 = _interopRequireDefault(_Divider);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Divider2.default;
	});

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(125)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Drawer'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Drawer);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Drawer) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Drawer2 = _interopRequireDefault(_Drawer);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Drawer2.default;
	});

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('../constants/keyCodes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.keyCodes);
	    global.ExpansionList = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _keyCodes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var ExpansionList = function (_PureComponent) {
	    _inherits(ExpansionList, _PureComponent);
	
	    function ExpansionList(props) {
	      _classCallCheck(this, ExpansionList);
	
	      var _this = _possibleConstructorReturn(this, (ExpansionList.__proto__ || Object.getPrototypeOf(ExpansionList)).call(this, props));
	
	      _this.state = { columnWidths: [], focusedIndex: -1 };
	
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._removeFocus = _this._removeFocus.bind(_this);
	      _this._calcColumnWidths = _this._calcColumnWidths.bind(_this);
	      _this._determineTabFocus = _this._determineTabFocus.bind(_this);
	      return _this;
	    }
	
	    _createClass(ExpansionList, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.children !== nextProps.children) {
	          this._calcColumnWidths();
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var focusedIndex = this.state.focusedIndex;
	
	        if (prevState.focusedIndex === focusedIndex || prevState.focusedIndex > -1 && focusedIndex > -1) {
	          return;
	        }
	
	        if (this.state.focusedIndex === -1) {
	          window.removeEventListener('click', this._removeFocus);
	        } else {
	          window.addEventListener('click', this._removeFocus);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('keyup', this._determineTabFocus);
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        if (container !== null) {
	          this._container = (0, _reactDom.findDOMNode)(container);
	          window.addEventListener('keyup', this._determineTabFocus);
	
	          this._calcColumnWidths();
	        }
	      }
	    }, {
	      key: '_determineTabFocus',
	      value: function _determineTabFocus(e) {
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          var panels = Array.prototype.slice.call((0, _reactDom.findDOMNode)(this).querySelectorAll('.md-panel-header'));
	          this.setState({ focusedIndex: panels.indexOf(e.target) });
	        }
	      }
	    }, {
	      key: '_removeFocus',
	      value: function _removeFocus() {
	        this.setState({ focusedIndex: -1 });
	      }
	    }, {
	      key: '_calcColumnWidths',
	      value: function _calcColumnWidths() {
	        if (!this._container) {
	          return;
	        }
	
	        var columnWidths = Array.prototype.slice.call(this._container.querySelectorAll('.md-panel-header')).reduce(function (maxes, row) {
	          var columns = row.querySelectorAll('.md-panel-column');
	          for (var i = 0; i < columns.length; i++) {
	            // Only need to include the offsetWidth of the column because the child will really
	            // determine the width of the column. Since it has already been defined at this point,
	            // no additional work needs to be done.
	            maxes[i] = Math.max(columns[i].offsetWidth, maxes[i] || 0);
	          }
	
	          return maxes;
	        }, [0]);
	
	        this.setState({ columnWidths: columnWidths });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            columnWidths = _state.columnWidths,
	            focusedIndex = _state.focusedIndex;
	
	        var _props = this.props,
	            children = _props.children,
	            className = _props.className,
	            component = _props.component,
	            props = _objectWithoutProperties(_props, ['children', 'className', 'component']);
	
	        return (0, _react.createElement)(component, _extends({}, props, {
	          ref: this._setContainer,
	          className: (0, _classnames2.default)('md-expansion-panel-list', className)
	        }), _react.Children.map(children, function (child, i) {
	          return (0, _react.cloneElement)(child, {
	            key: child.key || i,
	            columnWidths: columnWidths,
	            focused: focusedIndex === i
	          });
	        }));
	      }
	    }]);
	
	    return ExpansionList;
	  }(_react.PureComponent);
	
	  ExpansionList.propTypes = {
	    /**
	     * An optional style object to apply to the list.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the list.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The children should be a list or singular `ExpansionPanel` component
	     * to render with some additional props injected.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * The component to render the list as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired
	  };
	  ExpansionList.defaultProps = {
	    component: 'ul'
	  };
	  exports.default = ExpansionList;
	});

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(14), __webpack_require__(26), __webpack_require__(126), __webpack_require__(82), __webpack_require__(38), __webpack_require__(431)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('../utils/PropTypes/controlled'), require('../Papers/Paper'), require('../FontIcons/Collapser'), require('../Helpers/AccessibleFakeButton'), require('../Helpers/Collapse'), require('./PanelContent'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.controlled, global.Paper, global.Collapser, global.AccessibleFakeButton, global.Collapse, global.PanelContent);
	    global.ExpansionPanel = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _controlled, _Paper, _Collapser, _AccessibleFakeButton, _Collapse, _PanelContent) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  var _Collapser2 = _interopRequireDefault(_Collapser);
	
	  var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	  var _Collapse2 = _interopRequireDefault(_Collapse);
	
	  var _PanelContent2 = _interopRequireDefault(_PanelContent);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var LABEL_FONT_SIZE = 15;
	  var LINE_HEIGHT = 1.42857;
	  var SINGLE_LINE_HEIGHT = LABEL_FONT_SIZE * LINE_HEIGHT;
	
	  /**
	   * The `ExpansionPanel` component needs to be used with the `ExpansionList`
	   * component. The only reason is that the `ExpansionPanel` should really
	   * be rendered as a table, but it was a bit hard to have a single component
	   * dynamically rendering another row when expanded. It couldn't be in the
	   * same row since the expanded content might not have the same columns.
	   */
	
	  var ExpansionPanel = function (_PureComponent) {
	    _inherits(ExpansionPanel, _PureComponent);
	
	    function ExpansionPanel(props) {
	      _classCallCheck(this, ExpansionPanel);
	
	      var _this = _possibleConstructorReturn(this, (ExpansionPanel.__proto__ || Object.getPrototypeOf(ExpansionPanel)).call(this, props));
	
	      _this.state = {
	        received: false,
	        twoLine: false
	      };
	
	      if (typeof props.expanded === 'undefined') {
	        _this.state.expanded = props.defaultExpanded;
	      }
	
	      _this._handleSave = _this._handleSave.bind(_this);
	      _this._handleCancel = _this._handleCancel.bind(_this);
	      _this._handleClick = _this._handleClick.bind(_this);
	      _this._determineIfTwoLine = _this._determineIfTwoLine.bind(_this);
	      return _this;
	    }
	
	    _createClass(ExpansionPanel, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._determineIfTwoLine();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (false) {
	          if (nextProps.columnWidths.length === 0) {
	            // Hopefully a nice warning about fixing the missing props injected from ExpansionList
	            /* eslint-disable no-console */
	            console.error('The `ExpansionPanel` component expects the `columnWidths` prop to be injected from the ' + '`ExpansionList` component. It could be missing because:' + '\n - you have a wrapper component with extra functionality' + '\n - the `ExpansionPanel` is not a direct child of the `ExpansonList` component' + '\n\nYou can fix this by making sure to pass `this.props.focused` and `this.props.columWidths` ' + 'within your wrapper component and making the `ExpansionPanel` a direct child of `ExpansionList`.');
	          }
	
	          this.setState({ received: true });
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        if (this.props.label === prevProps.label && this.props.secondaryLabel === prevProps.secondaryLabel) {
	          return;
	        }
	
	        this._determineIfTwoLine();
	      }
	    }, {
	      key: '_isExpanded',
	      value: function _isExpanded(props, state) {
	        return typeof props.expanded === 'undefined' ? state.expanded : props.expanded;
	      }
	    }, {
	      key: '_determineIfTwoLine',
	      value: function _determineIfTwoLine() {
	        var twoLine = false;
	        Array.prototype.slice.call((0, _reactDom.findDOMNode)(this).querySelectorAll('.md-panel-column')).some(function (el) {
	          return twoLine = el.offsetHeight > SINGLE_LINE_HEIGHT;
	        });
	
	        this.setState({ twoLine: twoLine });
	      }
	    }, {
	      key: '_handleClick',
	      value: function _handleClick() {
	        var expanded = !this._isExpanded(this.props, this.state);
	        if (this.props.onExpandToggle) {
	          this.props.onExpandToggle(expanded);
	        }
	
	        if (typeof this.props.expanded === 'undefined') {
	          this.setState({ expanded: expanded });
	        }
	      }
	    }, {
	      key: '_handleSave',
	      value: function _handleSave(e) {
	        var _props = this.props,
	            onSave = _props.onSave,
	            onExpandToggle = _props.onExpandToggle,
	            closeOnSave = _props.closeOnSave;
	
	        if (onSave) {
	          onSave(e);
	        }
	
	        if (closeOnSave) {
	          if (onExpandToggle) {
	            onExpandToggle(false);
	          }
	
	          if (typeof this.props.expanded === 'undefined') {
	            this.setState({ expanded: false });
	          }
	        }
	      }
	    }, {
	      key: '_handleCancel',
	      value: function _handleCancel(e) {
	        var _props2 = this.props,
	            onCancel = _props2.onCancel,
	            onExpandToggle = _props2.onExpandToggle,
	            closeOnCancel = _props2.closeOnCancel;
	
	        if (onCancel) {
	          onCancel(e);
	        }
	
	        if (closeOnCancel) {
	          if (onExpandToggle) {
	            onExpandToggle(false);
	          }
	
	          if (typeof this.props.expanded === 'undefined') {
	            this.setState({ expanded: false });
	          }
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props3 = this.props,
	            className = _props3.className,
	            label = _props3.label,
	            secondaryLabel = _props3.secondaryLabel,
	            expandedSecondaryLabel = _props3.expandedSecondaryLabel,
	            children = _props3.children,
	            expandIconChildren = _props3.expandIconChildren,
	            expandIconClassName = _props3.expandIconClassName,
	            focused = _props3.focused,
	            columnWidths = _props3.columnWidths,
	            saveType = _props3.saveType,
	            saveLabel = _props3.saveLabel,
	            savePrimary = _props3.savePrimary,
	            saveSecondary = _props3.saveSecondary,
	            cancelType = _props3.cancelType,
	            cancelLabel = _props3.cancelLabel,
	            cancelPrimary = _props3.cancelPrimary,
	            cancelSecondary = _props3.cancelSecondary,
	            headerStyle = _props3.headerStyle,
	            headerClassName = _props3.headerClassName,
	            contentStyle = _props3.contentStyle,
	            contentClassName = _props3.contentClassName,
	            tabIndex = _props3.tabIndex,
	            props = _objectWithoutProperties(_props3, ['className', 'label', 'secondaryLabel', 'expandedSecondaryLabel', 'children', 'expandIconChildren', 'expandIconClassName', 'focused', 'columnWidths', 'saveType', 'saveLabel', 'savePrimary', 'saveSecondary', 'cancelType', 'cancelLabel', 'cancelPrimary', 'cancelSecondary', 'headerStyle', 'headerClassName', 'contentStyle', 'contentClassName', 'tabIndex']);
	
	        delete props.defaultExpanded;
	        delete props.expanded;
	        delete props.onSave;
	        delete props.onCancel;
	        delete props.onExpandToggle;
	        delete props.closeOnSave;
	        delete props.closeOnCancel;
	
	        var twoLine = this.state.twoLine;
	
	        var expanded = this._isExpanded(this.props, this.state);
	
	        var columns = _react.Children.map(expanded && expandedSecondaryLabel || secondaryLabel, function (panelLabel, i) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'md-panel-column md-text', style: { minWidth: columnWidths[i + 1] } },
	            panelLabel
	          );
	        });
	
	        if (!Array.isArray(columns)) {
	          columns = [columns];
	        }
	
	        columns.unshift(_react2.default.createElement(
	          'div',
	          { className: 'md-panel-column md-text', style: { minWidth: columnWidths[0] }, key: 'main-label' },
	          label
	        ));
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-expansion-panel', {
	              'md-expansion-panel--expanded': expanded
	            }, className),
	            'aria-expanded': expanded
	          }),
	          _react2.default.createElement(
	            _AccessibleFakeButton2.default,
	            {
	              onClick: this._handleClick,
	              style: headerStyle,
	              className: (0, _classnames2.default)('md-panel-header', {
	                'md-panel-header--expanded': expanded || twoLine,
	                'md-panel-header--focused': focused
	              }, headerClassName),
	              tabIndex: tabIndex
	            },
	            columns,
	            _react2.default.createElement(
	              _Collapser2.default,
	              { flipped: expanded, iconClassName: expandIconClassName, className: 'md-cell--right' },
	              expandIconChildren
	            )
	          ),
	          _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: !expanded },
	            _react2.default.createElement(
	              _PanelContent2.default,
	              {
	                style: contentStyle,
	                className: contentClassName,
	                onSave: this._handleSave,
	                onCancel: this._handleCancel,
	                saveType: saveType,
	                saveLabel: saveLabel,
	                savePrimary: savePrimary,
	                saveSecondary: saveSecondary,
	                cancelType: cancelType,
	                cancelLabel: cancelLabel,
	                cancelPrimary: cancelPrimary,
	                cancelSecondary: cancelSecondary
	              },
	              children
	            )
	          )
	        );
	      }
	    }]);
	
	    return ExpansionPanel;
	  }(_react.PureComponent);
	
	  ExpansionPanel.propTypes = {
	    /**
	     * An optional style to apply to the panel.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the panel.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An options style to apply to the panel's header content. This is the
	     * section that toggles the children to be visible and label columns.
	     */
	    headerStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the panel's header content. This is the
	     * section that toggles the children to be visible and label columns.
	     */
	    headerClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to applt to the element surrounding the children when expanded.
	     */
	    contentStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to applt to the element surrounding the children when expanded.
	     */
	    contentClassName: _react.PropTypes.string,
	
	    /**
	     * The main label to display in the unexpanded panel.
	     */
	    label: _react.PropTypes.node.isRequired,
	
	    /**
	     * Any additional columns to display after the main label. If this is a `list`
	     * instead of a singular item, they will each be formatted as a column.
	     */
	    secondaryLabel: _react.PropTypes.node,
	
	    /**
	     * Any additional columns to display after the main label when the panel is
	     * expanded. If this is omitted, the default `secondaryLabel` will be displayed
	     * instead.
	     */
	    expandedSecondaryLabel: _react.PropTypes.node,
	
	    /**
	     * The component to render the panel as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired,
	
	    /**
	     * The content to display once the panel is toggled open.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * A boolean if the panel is currently expanded. This will force the component
	     * to be controlled and require's the `onExpandToggle` function to be defined.
	     */
	    expanded: (0, _controlled2.default)(_react.PropTypes.bool, 'onExpandToggle', 'defaultExpanded'),
	
	    /**
	     * Boolean if an uncontrolled panel should be expanded by default.
	     */
	    defaultExpanded: _react.PropTypes.bool.isRequired,
	
	    /**
	     * Any children required to render the expand icon.
	     */
	    expandIconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className to use to render the expand icon.
	     */
	    expandIconClassName: _react.PropTypes.string,
	
	    /**
	     * Boolean if the `ExpansionPanel` is currently tab focused. This is injected
	     * and managed by the `ExpansionList` component. Do not set yourself.
	     */
	    focused: _react.PropTypes.bool.isRequired,
	
	    /**
	     * A list of min-widths to apply to each column in the panel header. This is injected
	     * and managed by the `ExpansionList` component. Do not set yourself.
	     */
	    columnWidths: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired,
	
	    /**
	     * A function to call when the expansion panel's expanded state is toggled.
	     * The callback for this function will include the new expanded state.
	     *
	     * `onExpandToggle(expanded)`
	     */
	    onExpandToggle: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the Save button is clicked on the expanded panel.
	     */
	    onSave: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the Cancel button is clicked on the expanded panel.
	     */
	    onCancel: _react.PropTypes.func,
	
	    /**
	     * Boolean if the panel should close when the Save button is clicked.
	     */
	    closeOnSave: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the panel should close when the Cancel button is clicked.
	     */
	    closeOnCancel: _react.PropTypes.bool,
	
	    /**
	     * An optional button type to apply to the Save button. This will get
	     * passed to the `FlatButton`.
	     */
	    saveType: _react.PropTypes.oneOf(['button', 'submit', 'reset']),
	
	    /**
	     * The label for the Save button.
	     */
	    saveLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * Boolean if the Save button should be styled with the primary color.
	     */
	    savePrimary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the Save button should be styled with the secondary color,
	     */
	    saveSecondary: _react.PropTypes.bool,
	
	    /**
	     * An optional button type to apply to the Cancel button. This will get
	     * passed to the `FlatButton`.
	     */
	    cancelType: _react.PropTypes.oneOf(['button', 'submit', 'reset']),
	
	    /**
	     * The label for the Cancel button.
	     */
	    cancelLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * Boolean if the Cancel button should be styled with the primary color,
	     */
	    cancelPrimary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the Cancel button should be styled with the secondary color,
	     */
	    cancelSecondary: _react.PropTypes.bool,
	
	    /**
	     * The tab index for the panel's header. This allows keyboard navigation.
	     */
	    tabIndex: _react.PropTypes.number.isRequired
	  };
	  ExpansionPanel.defaultProps = {
	    defaultExpanded: false,
	    expandIconChildren: 'keyboard_arrow_down',
	    component: 'li',
	    saveLabel: 'Save',
	    cancelLabel: 'Cancel',
	    savePrimary: true,
	    tabIndex: 0,
	    closeOnSave: true,
	    closeOnCancel: true,
	    focused: false,
	    columnWidths: []
	  };
	  exports.default = ExpansionPanel;
	});

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(63)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Dialogs/DialogFooter'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.DialogFooter);
	    global.PanelContent = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _DialogFooter) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var PanelContent = function (_PureComponent) {
	    _inherits(PanelContent, _PureComponent);
	
	    function PanelContent() {
	      _classCallCheck(this, PanelContent);
	
	      return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
	    }
	
	    _createClass(PanelContent, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            style = _props.style,
	            contentStyle = _props.contentStyle,
	            className = _props.className,
	            children = _props.children,
	            onSave = _props.onSave,
	            onCancel = _props.onCancel,
	            saveType = _props.saveType,
	            saveLabel = _props.saveLabel,
	            savePrimary = _props.savePrimary,
	            saveSecondary = _props.saveSecondary,
	            cancelType = _props.cancelType,
	            cancelLabel = _props.cancelLabel,
	            cancelPrimary = _props.cancelPrimary,
	            cancelSecondary = _props.cancelSecondary;
	
	
	        var actions = [{
	          type: cancelType,
	          label: cancelLabel,
	          onClick: onCancel,
	          primary: cancelPrimary,
	          secondary: cancelSecondary
	        }, {
	          type: saveType,
	          label: saveLabel,
	          onClick: onSave,
	          primary: savePrimary,
	          secondary: saveSecondary
	        }];
	
	        return _react2.default.createElement(
	          'div',
	          { style: style },
	          _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('md-panel-content', className), style: contentStyle },
	            children
	          ),
	          _react2.default.createElement(_DialogFooter2.default, { actions: actions, className: 'md-divider-border md-divider-border--top' })
	        );
	      }
	    }]);
	
	    return PanelContent;
	  }(_react.PureComponent);
	
	  PanelContent.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    contentStyle: _react.PropTypes.object,
	    children: _react.PropTypes.node,
	    onSave: _react.PropTypes.func.isRequired,
	    onCancel: _react.PropTypes.func.isRequired,
	    saveType: _react.PropTypes.string,
	    saveLabel: _react.PropTypes.string.isRequired,
	    savePrimary: _react.PropTypes.bool,
	    saveSecondary: _react.PropTypes.bool,
	    cancelType: _react.PropTypes.string,
	    cancelLabel: _react.PropTypes.string.isRequired,
	    cancelPrimary: _react.PropTypes.bool,
	    cancelSecondary: _react.PropTypes.bool
	  };
	  exports.default = PanelContent;
	});

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(430), __webpack_require__(429)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./ExpansionPanel'), require('./ExpansionList'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.ExpansionPanel, global.ExpansionList);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _ExpansionPanel, _ExpansionList2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.ExpansionList = exports.ExpansionPanel = undefined;
	
	  var _ExpansionPanel2 = _interopRequireDefault(_ExpansionPanel);
	
	  var _ExpansionList3 = _interopRequireDefault(_ExpansionList2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _ExpansionPanel2.default;
	  exports.ExpansionPanel = _ExpansionPanel2.default;
	  exports.ExpansionList = _ExpansionList3.default;
	});

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(36), __webpack_require__(2), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-addons-css-transition-group'), require('classnames'), require('../Buttons/Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactAddonsCssTransitionGroup, global.classnames, global.Button);
	    global.SpeedDial = mod.exports;
	  }
	})(this, function (exports, _react, _reactAddonsCssTransitionGroup, _classnames, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var SpeedDial = function (_PureComponent) {
	    _inherits(SpeedDial, _PureComponent);
	
	    function SpeedDial(props) {
	      _classCallCheck(this, SpeedDial);
	
	      var _this = _possibleConstructorReturn(this, (SpeedDial.__proto__ || Object.getPrototypeOf(SpeedDial)).call(this, props));
	
	      _this.state = { isOpen: props.initiallyOpen };
	      _this._handleClick = _this._handleClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(SpeedDial, [{
	      key: '_isOpen',
	      value: function _isOpen(props, state) {
	        return typeof props.isOpen === 'undefined' ? state.isOpen : props.isOpen;
	      }
	    }, {
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        var _props = this.props,
	            onClick = _props.onClick,
	            onPassiveClick = _props.onPassiveClick,
	            onActiveClick = _props.onActiveClick;
	
	        if (onClick) {
	          onClick(e);
	        }
	
	        var isOpen = this._isOpen(this.props, this.state);
	        if (isOpen && onActiveClick) {
	          onActiveClick(e);
	        } else if (!isOpen && onPassiveClick) {
	          onPassiveClick(e);
	        }
	
	        if (typeof this.props.isOpen === 'undefined') {
	          this.setState({ isOpen: !isOpen });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            fabs = _props2.fabs,
	            passiveIconChildren = _props2.passiveIconChildren,
	            passiveIconClassName = _props2.passiveIconClassName,
	            activeIconChildren = _props2.activeIconChildren,
	            activeIconClassName = _props2.activeIconClassName,
	            transitionName = _props2.transitionName,
	            transitionEnterTimeout = _props2.transitionEnterTimeout,
	            speedDialTransitionName = _props2.speedDialTransitionName,
	            speedDialTransitionEnterTimeout = _props2.speedDialTransitionEnterTimeout,
	            speedDialTransitionLeaveTimeout = _props2.speedDialTransitionLeaveTimeout,
	            containerProps = _props2.containerProps,
	            props = _objectWithoutProperties(_props2, ['fabs', 'passiveIconChildren', 'passiveIconClassName', 'activeIconChildren', 'activeIconClassName', 'transitionName', 'transitionEnterTimeout', 'speedDialTransitionName', 'speedDialTransitionEnterTimeout', 'speedDialTransitionLeaveTimeout', 'containerProps']);
	
	        delete props.isOpen;
	        delete props.initiallyOpen;
	
	        var isOpen = this._isOpen(this.props, this.state);
	
	        var speedDialFabs = void 0;
	        if (isOpen) {
	          speedDialFabs = fabs.map(function (fab, i) {
	            var fn = void 0;
	            var el = void 0;
	            var fabProps = void 0;
	            if (_react2.default.isValidElement(fab)) {
	              el = _react2.default.Children.only(fab);
	              fn = _react2.default.cloneElement;
	              fabProps = fab.props;
	            } else {
	              el = _Button2.default;
	              fn = _react2.default.createElement;
	              fabProps = fab;
	            }
	
	            var created = fn(el, _extends({
	              floating: true,
	              mini: true
	            }, fabProps));
	            return _react2.default.createElement(
	              'div',
	              { key: i, className: 'md-speed-dial-fab' },
	              created
	            );
	          });
	        }
	
	        props.iconClassName = isOpen ? activeIconClassName : passiveIconClassName;
	        props.children = isOpen ? activeIconChildren : passiveIconChildren;
	        return _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          _extends({}, containerProps, {
	            component: 'div',
	            className: (0, _classnames2.default)('md-speed-dial', !!containerProps && containerProps.className),
	            transitionName: transitionName + '-' + (isOpen ? 'right' : 'left'),
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeave: false,
	            ref: 'container'
	          }),
	          _react2.default.createElement(
	            _reactAddonsCssTransitionGroup2.default,
	            {
	              component: 'div',
	              key: 'speed-dial-fabs',
	              transitionName: speedDialTransitionName,
	              transitionEnterTimeout: speedDialTransitionEnterTimeout,
	              transitionLeaveTimeout: speedDialTransitionLeaveTimeout
	            },
	            speedDialFabs
	          ),
	          _react2.default.createElement(_Button2.default, _extends({}, props, {
	            floating: true,
	            key: (isOpen ? 'open' : 'closed') + '-fab',
	            onClick: this._handleClick
	          }))
	        );
	      }
	    }]);
	
	    return SpeedDial;
	  }(_react.PureComponent);
	
	  SpeedDial.propTypes = {
	    /**
	     * A boolean if the speed dial is currently open. This will make
	     * the speed dial into a controlled component.
	     */
	    isOpen: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the uncontrolled speed dial is initially open.
	     */
	    initiallyOpen: _react.PropTypes.bool,
	
	    /**
	     * An optional className to apply to the speed dial.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The speed dial's floating action button transition name when the button's
	     * open state changes. If the button is open, `-right` is appened, otherwise
	     * `-left`.
	     */
	    transitionName: _react.PropTypes.string.isRequired,
	
	    /**
	     * The timeout for the speed dial's floating action button transition.
	     */
	    transitionEnterTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * The name for the flinging animation of the speed dial.
	     */
	    speedDialTransitionName: _react.PropTypes.string.isRequired,
	
	    /**
	     * The timeout for the flinging animation of the speed dial when opening.
	     */
	    speedDialTransitionEnterTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * The timeout for the flinging animation when the speed dial is closing.
	     */
	    speedDialTransitionLeaveTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * The optional children to display for unopened speed dial floating action button.
	     */
	    passiveIconChildren: _react.PropTypes.node,
	
	    /**
	     * The optional icon className to display for unopened speed dial floating action button.
	     */
	    passiveIconClassName: _react.PropTypes.node,
	
	    /**
	     * The optional children to display for opened speed dial floating action button.
	     */
	    activeIconChildren: _react.PropTypes.node,
	
	    /**
	     * The optional icon className to display for opened speed dial floating action button.
	     */
	    activeIconClassName: _react.PropTypes.string,
	
	    /**
	     * A list of `FloatingButton` or props to generate the `FloatinButton` when the
	     * `SpeedDial` is open. The buttons will automatically be converted to the `mini`
	     * version.
	     */
	    fabs: function fabs(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      var size = props.fabs.length;
	      if (size >= 3 && size <= 5) {
	        var _PropTypes$arrayOf;
	
	        return (_PropTypes$arrayOf = _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
	          onClick: _react.PropTypes.func,
	          iconClassName: _react.PropTypes.string,
	          children: _react.PropTypes.node
	        })]))).isRequired.apply(_PropTypes$arrayOf, [props, propName, component].concat(others));
	      }
	
	      var middle = size < 3 ? 'at least 3' : 'no more than 5';
	      return new Error('A speed dial requires ' + middle + ' floating action buttons to fling. ' + ('However, only ' + size + ' were given.'));
	    },
	
	    /**
	     * An optional function to call when the main floating action button is clicked.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the main floating action button is clicked.
	     */
	    onPassiveClick: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the main floating action button is clicked.
	     */
	    onActiveClick: _react.PropTypes.func,
	
	    /**
	     * Any additional props to apply to the speed dial itself.
	     */
	    containerProps: _react.PropTypes.object
	  };
	  SpeedDial.defaultProps = {
	    initiallyOpen: false,
	    transitionName: 'md-fab-rotate',
	    transitionEnterTimeout: 150,
	    speedDialTransitionName: 'md-speed-dial',
	    speedDialTransitionEnterTimeout: 450,
	    speedDialTransitionLeaveTimeout: 150,
	    passiveIconClassName: 'material-icons',
	    activeIconClassName: 'material-icons'
	  };
	  exports.default = SpeedDial;
	});

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(433)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./SpeedDial'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.SpeedDial);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _SpeedDial2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.SpeedDial = undefined;
	
	  var _SpeedDial3 = _interopRequireDefault(_SpeedDial2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.SpeedDial = _SpeedDial3.default;
	});

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(198)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('./FileInput'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.FileInput);
	    global.FileUpload = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _FileInput) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _FileInput2 = _interopRequireDefault(_FileInput);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var FileUpload = function (_PureComponent) {
	    _inherits(FileUpload, _PureComponent);
	
	    function FileUpload(props) {
	      _classCallCheck(this, FileUpload);
	
	      var _this = _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call(this, props));
	
	      _this.state = {};
	      _this.abort = _this.abort.bind(_this);
	      _this._uploadFile = _this._uploadFile.bind(_this);
	      _this._handleUpload = _this._handleUpload.bind(_this);
	      return _this;
	    }
	
	    /**
	     * Attempts to abort the upload of a file. This function takes an optional `file` or `fileName`
	     * as it's parameter. If the parameter is omitted, it attempts to abort the first file that was
	     * added. If the `onAbort` function was given, it will be called as well.
	     *
	     * @param {Object|string=} file - The file or the file name to use to find the
	     *     correct `FileReader`.
	     */
	
	
	    _createClass(FileUpload, [{
	      key: 'abort',
	      value: function abort(file) {
	        var fileName = file;
	        if (!file) {
	          // Attempt to remove first file added...
	          fileName = Object.keys(this.state)[0];
	        } else if (typeof file.name === 'string') {
	          fileName = file.name;
	        }
	
	        var reader = this.state[fileName];
	        if (reader) {
	          reader.abort();
	          var state = this.state;
	          delete state[fileName];
	
	          (0, _reactDom.findDOMNode)(this).querySelector('.md-file-input').value = '';
	
	          this.setState(state);
	        }
	      }
	    }, {
	      key: '_uploadFile',
	      value: function _uploadFile(file) {
	        var _this2 = this;
	
	        var _props = this.props,
	            onAbort = _props.onAbort,
	            onError = _props.onError,
	            onLoad = _props.onLoad,
	            onLoadStart = _props.onLoadStart,
	            onLoadEnd = _props.onLoadEnd,
	            onProgress = _props.onProgress,
	            readAs = _props.readAs;
	        var name = file.name,
	            type = file.type;
	
	
	        var fr = new FileReader();
	        if (onError) {
	          fr.onerror = function (e) {
	            onError(file, e.target.error, e);
	          };
	        }
	
	        if (onAbort) {
	          fr.onabort = function (e) {
	            onAbort(file, e);
	          };
	        }
	
	        if (onLoadStart) {
	          fr.onloadstart = function (e) {
	            onLoadStart(file, e);
	          };
	        }
	
	        if (onLoadEnd) {
	          fr.onloadend = function (e) {
	            onLoadEnd(file, e);
	          };
	        }
	
	        fr.onload = function (e) {
	          if (onLoad) {
	            onLoad(file, e.target.result, e);
	          }
	
	          var state = Object.assign({}, _this2.state);
	          delete state[name];
	          _this2.setState(state);
	        };
	
	        if (onProgress) {
	          fr.onprogress = function (e) {
	            if (e.lengthComputable) {
	              onProgress(file, e.loaded / e.total * 100, e);
	            }
	          };
	        }
	
	        if (readAs) {
	          if (typeof readAs === 'function') {
	            readAs(file.type, file, fr);
	          } else {
	            fr['readAs' + readAs](file);
	          }
	        } else if (type.match(/image|video|audio/)) {
	          fr.readAsDataURL(file);
	        } else if (type.match(/json$/)) {
	          fr.readAsText(file);
	        } else if (type.match(/application|model|multipart/) || name.match(/(w|e)ar$/)) {
	          fr.readAsArrayBuffer(file);
	        } else {
	          fr.readAsText(file);
	        }
	
	        return fr;
	      }
	    }, {
	      key: '_handleUpload',
	      value: function _handleUpload(fileList, e) {
	        var _this3 = this;
	
	        if (this.props.onChange) {
	          this.props.onChange(fileList, e);
	        }
	
	        if (!fileList) {
	          return;
	        }
	        var _props2 = this.props,
	            maxSize = _props2.maxSize,
	            onSizeError = _props2.onSizeError;
	
	        var files = Array.isArray(fileList) ? fileList : [fileList];
	
	        var errorFiles = [];
	        if (maxSize) {
	          errorFiles = files.filter(function (file) {
	            return file.size > maxSize;
	          });
	          files = files.filter(function (file) {
	            return file.size <= maxSize;
	          });
	        }
	
	        if (errorFiles.length) {
	          onSizeError(errorFiles);
	        }
	
	        if (!files.length) {
	          return;
	        }
	
	        var nextState = {};
	        files.forEach(function (file) {
	          var fileReader = _this3._uploadFile(file);
	          nextState[file.name] = fileReader;
	        });
	
	        this.setState(nextState);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var props = _objectWithoutProperties(this.props, []);
	
	        // Remove invalid input props
	        delete props.maxSize;
	        delete props.onLoad;
	        delete props.onLoadStart;
	        delete props.onLoadEnd;
	        delete props.onProgress;
	        delete props.onAbort;
	        delete props.onError;
	        delete props.maxSize;
	        delete props.onSizeError;
	        delete props.readAs;
	
	        return _react2.default.createElement(_FileInput2.default, _extends({}, props, { onChange: this._handleUpload }));
	      }
	    }]);
	
	    return FileUpload;
	  }(_react.PureComponent);
	
	  FileUpload.propTypes = {
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * Boolean if the `FileInput` should be styled with the primary color.
	     */
	    primary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `FileInput` should be styled with the secondary color.
	     */
	    secondary: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `FileInput` should be styled as a flat button instead of a
	     * raised button.
	     */
	    flat: _react.PropTypes.bool,
	
	    /**
	     * This should be a comma separated list of Media Types that the `FileInput` can
	     * accept. If this prop is left blank, any file will be accepted.
	     *
	     * The values can either be:
	     * - A file extension
	     * - audio/*
	     * - video/*
	     * - image/*
	     * - any valid [IANA Media Type](http://www.iana.org/assignments/media-types/media-types.xhtml)
	     */
	    accept: _react.PropTypes.string,
	
	    /**
	     * Boolean if multiple files will be accepted.
	     */
	    multiple: _react.PropTypes.bool,
	
	    /**
	     * A label to display on the `FileInput`.
	     */
	    label: _react.PropTypes.string,
	
	    /**
	     * The icon children to use for the upload icon.
	     */
	    iconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className to use for the upload icon.
	     */
	    iconClassName: _react.PropTypes.string,
	
	    /**
	     * An optional max size for the file. If the file is greater than
	     * this limit, the file will not be uploaded.
	     */
	    maxSize: _react.PropTypes.number,
	
	    /**
	     * A required function to call when the `maxSize` prop is set. It will
	     * be given a list of files that were too big.
	     */
	    onSizeError: function onSizeError(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      if (typeof props.maxSize === 'number') {
	        var _PropTypes$func;
	
	        return (_PropTypes$func = _react.PropTypes.func).isRequired.apply(_PropTypes$func, [props, propName, component].concat(others));
	      }
	
	      return null;
	    },
	
	    /**
	     * You can force the `FileReader` to read the file as a specific type
	     * if you do not trust the *amazing* regex I have for choosing the correct
	     * one.
	     *
	     * ```js
	     * if(type.match(/image|video|audio/)) {
	     *   fr.readAsDataURL(file);
	     * } else if(type.match(/application|model|multipart/)) {
	     *   fr.readAsArrayBuffer(file);
	     * } else {
	     *   fr.readAsText(file);
	     * }
	     * ```
	     *
	     * > `.yml` and `.js` both are considered `application`, so it definitely fails there.
	     *
	     * If this prop is a function, you will be given the file's type, the file object, and
	     * the file reader. You will then need to call `fileReader.readAsYOUR_CORRECT_TYPE(file)`.
	     */
	    readAs: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['DataURL', 'ArrayBuffer', 'Text']), _react.PropTypes.func]),
	
	    /**
	     * An optional function to call when the `FileUpload` aborts. The current
	     * file and the abort event are given. This might not be the most useful
	     * function to use since you will need to manually call abort yourself anyways.
	     */
	    onAbort: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `FileUpload` errors. The current
	     * file, the error, and the error event are given.
	     *
	     * ```js
	     * onError(file, event.target.error, event);
	     * ```
	     */
	    onError: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `FileUpload` loads. The current
	     * file, the load result, and the load event are given.
	     *
	     * ```js
	     * onLoad(file, event.target.result, event);
	     * ```
	     *
	     * The load result will either be:
	     * - a data url
	     * - a plain text string
	     * - an array buffer
	     *
	     * depending on what type the file is.
	     */
	    onLoad: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `FileUpload` starts loading. The current
	     * file and the load start event are given.
	     */
	    onLoadStart: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `FileUpload` finishes loading. The
	     * current file and the load end event are given.
	     */
	    onLoadEnd: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the `FileUpload` progress. The current
	     * file, upload progress, and the progress event are given. The progress
	     * will be a number between 0 and 100 that has not been rounded.
	     *
	     * ```js
	     * onProgress(file, progress, event);
	     * ```
	     */
	    onProgress: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when a file selects or unselects a file.
	     * This will be called before any local uploading occurs.
	     *
	     * ```js
	     * onChange(file(s) || null, event);
	     * ```
	     */
	    onChange: _react.PropTypes.func
	  };
	  exports.default = FileUpload;
	});

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(198), __webpack_require__(435)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./FileInput'), require('./FileUpload'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.FileInput, global.FileUpload);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _FileInput, _FileUpload2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.FileUpload = exports.FileInput = undefined;
	
	  var _FileInput2 = _interopRequireDefault(_FileInput);
	
	  var _FileUpload3 = _interopRequireDefault(_FileUpload2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _FileInput2.default;
	  exports.FileInput = _FileInput2.default;
	  exports.FileUpload = _FileUpload3.default;
	});

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(82), __webpack_require__(22), __webpack_require__(38), __webpack_require__(199), __webpack_require__(49), __webpack_require__(64)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./AccessibleFakeButton'), require('./AccessibleFakeInkedButton'), require('./Collapse'), require('./FocusContainer'), require('./IconSeparator'), require('./Portal'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.AccessibleFakeButton, global.AccessibleFakeInkedButton, global.Collapse, global.FocusContainer, global.IconSeparator, global.Portal);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _AccessibleFakeButton2, _AccessibleFakeInkedButton2, _Collapse2, _FocusContainer2, _IconSeparator2, _Portal2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.Portal = exports.IconSeparator = exports.FocusContainer = exports.Collapse = exports.AccessibleFakeInkedButton = exports.AccessibleFakeButton = undefined;
	
	  var _AccessibleFakeButton3 = _interopRequireDefault(_AccessibleFakeButton2);
	
	  var _AccessibleFakeInkedButton3 = _interopRequireDefault(_AccessibleFakeInkedButton2);
	
	  var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	  var _FocusContainer3 = _interopRequireDefault(_FocusContainer2);
	
	  var _IconSeparator3 = _interopRequireDefault(_IconSeparator2);
	
	  var _Portal3 = _interopRequireDefault(_Portal2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.AccessibleFakeButton = _AccessibleFakeButton3.default;
	  exports.AccessibleFakeInkedButton = _AccessibleFakeInkedButton3.default;
	  exports.Collapse = _Collapse3.default;
	  exports.FocusContainer = _FocusContainer3.default;
	  exports.IconSeparator = _IconSeparator3.default;
	  exports.Portal = _Portal3.default;
	});

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../constants/CSSTransitionGroupTick'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.CSSTransitionGroupTick);
	    global.Ink = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _CSSTransitionGroupTick) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Ink = function (_PureComponent) {
	    _inherits(Ink, _PureComponent);
	
	    function Ink(props) {
	      _classCallCheck(this, Ink);
	
	      var _this = _possibleConstructorReturn(this, (Ink.__proto__ || Object.getPrototypeOf(Ink)).call(this, props));
	
	      _this.state = {
	        active: false,
	        expanded: false,
	        pulsing: false,
	        leaving: false
	      };
	      return _this;
	    }
	
	    _createClass(Ink, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!this.props.aborted && nextProps.aborted) {
	          if (this._timeout) {
	            clearTimeout(this._timeout);
	          }
	
	          if (this._abort) {
	            this._abort();
	          }
	
	          this.setState({ active: false, expanding: false, pulsing: false, leaving: false });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	      }
	    }, {
	      key: 'componentWillEnter',
	      value: function componentWillEnter(cb) {
	        var _this2 = this;
	
	        if (this.props.aborted) {
	          cb();
	          return;
	        }
	
	        var _props = this.props,
	            transitionOverlap = _props.transitionOverlap,
	            transitionEnterTimeout = _props.transitionEnterTimeout;
	
	        this._abort = cb;
	
	        this._timeout = setTimeout(function () {
	          _this2._timeout = setTimeout(function () {
	            _this2._timeout = null;
	            _this2._abort = null;
	
	            cb();
	          }, transitionEnterTimeout - transitionOverlap);
	
	          _this2.setState({ expanded: true });
	        }, _CSSTransitionGroupTick2.default);
	
	        this.setState({ active: true });
	      }
	    }, {
	      key: 'componentDidEnter',
	      value: function componentDidEnter() {
	        var _this3 = this;
	
	        this._timeout = setTimeout(function () {
	          _this3._timeout = null;
	
	          _this3.setState({ pulsing: true });
	        }, this.props.transitionEnterTimeout);
	      }
	    }, {
	      key: 'componentWillLeave',
	      value: function componentWillLeave(cb) {
	        var _this4 = this;
	
	        if (this.props.aborted) {
	          cb();
	          return;
	        }
	
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        this._abort = cb;
	        this._timeout = setTimeout(function () {
	          _this4._timeout = null;
	
	          cb();
	        }, this.props.transitionLeaveTimeout);
	
	        this.setState({ pulsing: false, leaving: true });
	      }
	    }, {
	      key: 'componentDidLeave',
	      value: function componentDidLeave() {
	        if (!this.props.aborted && this.props.onRemove) {
	          this.props.onRemove();
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            style = _props2.style,
	            className = _props2.className,
	            left = _props2.left,
	            top = _props2.top,
	            size = _props2.size;
	        var _state = this.state,
	            active = _state.active,
	            expanded = _state.expanded,
	            pulsing = _state.pulsing,
	            leaving = _state.leaving;
	
	
	        return _react2.default.createElement('span', {
	          style: Object.assign({}, style, {
	            left: left,
	            top: top,
	            height: size,
	            width: size
	          }),
	          className: (0, _classnames2.default)('md-ink', {
	            'md-ink--active': active,
	            'md-ink--expanded': expanded,
	            'md-ink--pulsing': pulsing,
	            'md-ink--leaving': leaving
	          }, className)
	        });
	      }
	    }]);
	
	    return Ink;
	  }(_react.PureComponent);
	
	  Ink.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    aborted: _react.PropTypes.bool,
	    onRemove: _react.PropTypes.func,
	    left: _react.PropTypes.number.isRequired,
	    top: _react.PropTypes.number.isRequired,
	    size: _react.PropTypes.number.isRequired,
	    transitionOverlap: _react.PropTypes.number.isRequired,
	    transitionEnterTimeout: _react.PropTypes.number.isRequired,
	    transitionLeaveTimeout: _react.PropTypes.number.isRequired
	  };
	  exports.default = Ink;
	});

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(166), __webpack_require__(2), __webpack_require__(11), __webpack_require__(133), __webpack_require__(67), __webpack_require__(229), __webpack_require__(512), __webpack_require__(438)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('react-addons-transition-group'), require('classnames'), require('../constants/keyCodes'), require('../utils/EventUtils/isValidClick'), require('../utils/EventUtils/captureNextEvent'), require('../utils/calcPageOffset'), require('../utils/NumberUtils/calculateHypotenuse'), require('./Ink'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.reactAddonsTransitionGroup, global.classnames, global.keyCodes, global.isValidClick, global.captureNextEvent, global.calcPageOffset, global.calculateHypotenuse, global.Ink);
	    global.InkContainer = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _reactAddonsTransitionGroup, _classnames, _keyCodes, _isValidClick, _captureNextEvent, _calcPageOffset, _calculateHypotenuse, _Ink) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	  var _calcPageOffset2 = _interopRequireDefault(_calcPageOffset);
	
	  var _calculateHypotenuse2 = _interopRequireDefault(_calculateHypotenuse);
	
	  var _Ink2 = _interopRequireDefault(_Ink);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var InkContainer = function (_PureComponent) {
	    _inherits(InkContainer, _PureComponent);
	
	    function InkContainer(props) {
	      _classCallCheck(this, InkContainer);
	
	      var _this = _possibleConstructorReturn(this, (InkContainer.__proto__ || Object.getPrototypeOf(InkContainer)).call(this, props));
	
	      _this.state = { inks: [] };
	      _this.createInk = _this.createInk.bind(_this);
	      _this.focus = _this.focus.bind(_this);
	      _this._handleFocus = _this._handleFocus.bind(_this);
	      _this._createInk = _this._createInk.bind(_this);
	      _this._removeInk = _this._removeInk.bind(_this);
	      _this._setContainers = _this._setContainers.bind(_this);
	      _this._maybeDelayClick = _this._maybeDelayClick.bind(_this);
	      _this._handleBlur = _this._handleBlur.bind(_this);
	      _this._handleMouseDown = _this._handleMouseDown.bind(_this);
	      _this._handleMouseUp = _this._handleMouseUp.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      _this._handleTouchMove = _this._handleTouchMove.bind(_this);
	      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
	      _this._handleRemove = _this._handleRemove.bind(_this);
	      _this._handleSubmit = _this._handleSubmit.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._getKeyboardContainer = _this._getKeyboardContainer.bind(_this);
	      _this._stopPropagationToFocus = _this._stopPropagationToFocus.bind(_this);
	      _this._initOrRemoveEvents = _this._initOrRemoveEvents.bind(_this);
	      return _this;
	    }
	
	    _createClass(InkContainer, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var di = this.props.disabledInteractions;
	        var ndi = nextProps.disabledInteractions;
	
	        if (di === ndi || !this._container) {
	          return;
	        }
	
	        var mouseDisabledDiff = this._isListenerDisabledDiff('mouse', di, ndi);
	        var touchDisabledDiff = this._isListenerDisabledDiff('touch', di, ndi);
	        var keyboardDisabledDiff = this._isListenerDisabledDiff('keyboard', di, ndi);
	        this._initOrRemoveEvents(nextProps, keyboardDisabledDiff, mouseDisabledDiff, touchDisabledDiff);
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._removeTimeout) {
	          clearTimeout(this._removeTimeout);
	        }
	
	        if (this._container) {
	          this._initOrRemoveEvents({ disabledInteractions: ['keyboard', 'mouse', 'touch'] });
	          this._getKeyboardContainer().removeEventListener('blur', this._handleBlur);
	        }
	      }
	    }, {
	      key: 'createInk',
	      value: function createInk(pageX, pageY) {
	        var _this2 = this;
	
	        this._createInk(pageX, pageY);
	        this._removeTimeout = setTimeout(function () {
	          _this2._removeTimeout = null;
	          _this2._removeInk();
	        }, this.props.transitionOverlap);
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        this._getKeyboardContainer().focus();
	      }
	    }, {
	      key: '_createInk',
	      value: function _createInk(pageX, pageY) {
	        var _inkContainer = this._inkContainer,
	            offsetWidth = _inkContainer.offsetWidth,
	            offsetHeight = _inkContainer.offsetHeight;
	
	
	        var x = void 0;
	        var y = void 0;
	        if (typeof pageX !== 'undefined' && typeof pageY !== 'undefined') {
	          var pageOffset = (0, _calcPageOffset2.default)(this._inkContainer);
	
	          x = pageX - pageOffset.left;
	          y = pageY - pageOffset.top;
	        } else {
	          x = offsetWidth / 2;
	          y = offsetHeight / 2;
	        }
	
	        var r = Math.max((0, _calculateHypotenuse2.default)(x, y), (0, _calculateHypotenuse2.default)(offsetWidth - x, y), (0, _calculateHypotenuse2.default)(offsetWidth - x, offsetHeight - y), (0, _calculateHypotenuse2.default)(x, offsetHeight - y));
	
	        var ink = {
	          left: x - r,
	          top: y - r,
	          size: r * 2,
	          key: Date.now()
	        };
	
	        var inks = this.state.inks.slice();
	        inks.push(ink);
	        this.setState({ inks: inks });
	      }
	    }, {
	      key: '_removeInk',
	      value: function _removeInk() {
	        var inks = this.state.inks.slice();
	        inks.pop();
	
	        this.setState({ inks: inks });
	      }
	    }, {
	      key: '_getKeyboardContainer',
	      value: function _getKeyboardContainer() {
	        if (this._container.classList.contains('md-text-field-container')) {
	          return this._container.querySelector('.md-text-field');
	        }
	
	        return this._container;
	      }
	    }, {
	      key: '_setContainers',
	      value: function _setContainers(inkContainer) {
	        if (inkContainer !== null) {
	          this._inkContainer = (0, _reactDom.findDOMNode)(inkContainer);
	          this._container = this._inkContainer.parentNode;
	
	          if (this._container) {
	            this._initOrRemoveEvents(this.props);
	          }
	        }
	      }
	    }, {
	      key: '_initOrRemoveEvents',
	      value: function _initOrRemoveEvents(props) {
	        var keyboardDiff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	        var mouseDiff = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	        var touchDiff = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	        var mouseDisabled = this._isListenerDisabled('mouse', props.disabledInteractions);
	        var touchDisabled = this._isListenerDisabled('touch', props.disabledInteractions);
	        var keyboardDisabled = this._isListenerDisabled('keyboard', props.disabledInteractions);
	
	        if (keyboardDiff) {
	          var fn = (keyboardDisabled ? 'remove' : 'add') + 'EventListener';
	          this._getKeyboardContainer()[fn]('focus', this._handleFocus);
	          this._getKeyboardContainer()[fn]('keydown', this._handleKeyDown);
	
	          if (this._container.getAttribute('type') === 'submit') {
	            window[fn]('submit', this._handleSubmit);
	          }
	
	          if (mouseDiff) {
	            this._container[(mouseDisabled ? 'add' : 'remove') + 'EventListener']('mousedown', this._stopPropagationToFocus);
	          }
	
	          if (touchDiff) {
	            this._container[(touchDisabled ? 'add' : 'remove') + 'EventListener']('touchstart', this._stopPropagationToFocus);
	          }
	        }
	
	        if (mouseDiff) {
	          var _fn = (mouseDisabled ? 'remove' : 'add') + 'EventListener';
	          this._container[_fn]('mousedown', this._handleMouseDown);
	          this._container[_fn]('mouseup', this._handleMouseUp);
	        }
	
	        if (touchDiff) {
	          var _fn2 = (touchDisabled ? 'remove' : 'add') + 'EventListener';
	          this._container[_fn2]('touchstart', this._handleTouchStart);
	          this._container[_fn2]('touchend', this._handleTouchEnd);
	        }
	      }
	    }, {
	      key: '_isListenerDisabledDiff',
	      value: function _isListenerDisabledDiff(interaction, disabledInteractions, nextDisabledInteractions) {
	        var i = disabledInteractions.indexOf(interaction);
	        var ni = nextDisabledInteractions.indexOf(interaction);
	
	        return i < 0 && ni >= 0 || i >= 0 && ni < 0;
	      }
	    }, {
	      key: '_isListenerDisabled',
	      value: function _isListenerDisabled(interaction, disabledInteractions) {
	        return disabledInteractions && disabledInteractions.indexOf(interaction) !== -1;
	      }
	    }, {
	      key: '_maybeDelayClick',
	      value: function _maybeDelayClick() {
	        if (!this.props.waitForInkTransition) {
	          return;
	        }
	
	        (0, _captureNextEvent2.default)('click', this._container);
	      }
	    }, {
	      key: '_handleRemove',
	      value: function _handleRemove() {
	        var _this3 = this;
	
	        if (this._clicked && this.props.waitForInkTransition) {
	          // For some reason if the click event will make the ink unmount, it will no longer
	          // have a debug id in the TransitionGroup and it displays a warning. Adding a 1ms timeout
	          // fixes that issue... It only happens on an actual click instead of an enter click.
	          setTimeout(function () {
	            _this3._container.click();
	          }, 1);
	        }
	
	        this._clicked = false;
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        var key = e.which || e.keyCode;
	        if (key === _keyCodes.ENTER || key === _keyCodes.SPACE) {
	          this._clicked = true;
	          this.createInk();
	          this._maybeDelayClick();
	        }
	      }
	    }, {
	      key: '_handleFocus',
	      value: function _handleFocus() {
	        if (this._clicked) {
	          return;
	        }
	
	        this._createInk();
	        this._getKeyboardContainer().addEventListener('blur', this._handleBlur);
	      }
	    }, {
	      key: '_handleBlur',
	      value: function _handleBlur() {
	        this._getKeyboardContainer().removeEventListener('blur', this._handleBlur);
	        this._removeInk();
	      }
	    }, {
	      key: '_handleMouseDown',
	      value: function _handleMouseDown(e) {
	        this._clicked = true;
	        if (!(0, _isValidClick2.default)(e) || this._skipNextMouse) {
	          this._skipNextMouse = false;
	          return;
	        }
	
	        this._mouseLeave = false;
	        this._container.addEventListener('mouseleave', this._handleMouseLeave);
	        this._createInk(e.pageX, e.pageY);
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave() {
	        this._container.removeEventListener('mouseleave', this._handleMouseLeave);
	        this._mouseLeave = true;
	        this._removeInk();
	      }
	    }, {
	      key: '_handleMouseUp',
	      value: function _handleMouseUp() {
	        if (this._mouseLeave) {
	          return;
	        }
	
	        this._maybeDelayClick();
	        this._container.removeEventListener('mouseleave', this._handleMouseLeave);
	        this._removeInk();
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        this._aborted = false;
	        this._clicked = true;
	        this._skipNextMouse = true;
	        window.addEventListener('touchmove', this._handleTouchMove);
	
	        var _e$changedTouches$ = e.changedTouches[0],
	            pageX = _e$changedTouches$.pageX,
	            pageY = _e$changedTouches$.pageY;
	
	        this._createInk(pageX, pageY);
	      }
	    }, {
	      key: '_handleTouchMove',
	      value: function _handleTouchMove() {
	        window.removeEventListener('touchmove', this._handleTouchMove);
	        var lastInk = this.state.inks[this.state.inks.length - 1];
	        if (!lastInk || Date.now() > lastInk.key + 200) {
	          this._aborted = false;
	          return;
	        }
	
	        var inks = this.state.inks.slice();
	        var index = inks.length - 1;
	
	        var abortedInk = Object.assign({}, lastInk, { aborted: true });
	        inks.splice(index, 1, abortedInk);
	
	        this._aborted = true;
	        this.setState({ inks: inks }, this._removeInk);
	      }
	    }, {
	      key: '_handleTouchEnd',
	      value: function _handleTouchEnd() {
	        this._skipNextMouse = true;
	
	        if (this._aborted) {
	          return;
	        } else {
	          window.removeEventListener('touchmove', this._handleTouchMove);
	        }
	
	        this._removeInk();
	      }
	    }, {
	      key: '_handleSubmit',
	      value: function _handleSubmit(e) {
	        if (document.activeElement === this._container || !e.target.contains(this._container)) {
	          return;
	        }
	
	        this._maybeDelayClick();
	        this.createInk();
	      }
	    }, {
	      key: '_stopPropagationToFocus',
	      value: function _stopPropagationToFocus(e) {
	        var type = e.type;
	
	        var mousedown = type === 'mousedown';
	        this._clicked = mousedown || type === 'touchstart';
	
	        if (this._clicked) {
	          window.addEventListener(mousedown ? 'mouseup' : 'touchend', this._stopPropagationToFocus, true);
	        } else {
	          window.removeEventListener(e.type, this._stopPropagationToFocus, true);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            inkStyle = _props.inkStyle,
	            inkClassName = _props.inkClassName,
	            transitionOverlap = _props.transitionOverlap,
	            transitionEnterTimeout = _props.transitionEnterTimeout,
	            transitionLeaveTimeout = _props.transitionLeaveTimeout;
	
	        var inks = this.state.inks.map(function (props) {
	          return _react2.default.createElement(_Ink2.default, _extends({}, props, {
	            style: inkStyle,
	            className: inkClassName,
	            onRemove: _this4._handleRemove,
	            transitionOverlap: transitionOverlap,
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeaveTimeout: transitionLeaveTimeout
	          }));
	        });
	
	        return _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          {
	            ref: this._setContainers,
	            component: 'div',
	            style: style,
	            className: (0, _classnames2.default)('md-ink-container', className)
	          },
	          inks
	        );
	      }
	    }]);
	
	    return InkContainer;
	  }(_react.PureComponent);
	
	  InkContainer.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    inkStyle: _react.PropTypes.object,
	    inkClassName: _react.PropTypes.string,
	    waitForInkTransition: _react.PropTypes.bool,
	    disabledInteractions: _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['keyboard', 'mouse', 'touch'])),
	    transitionOverlap: _react.PropTypes.number.isRequired,
	    transitionEnterTimeout: _react.PropTypes.number.isRequired,
	    transitionLeaveTimeout: _react.PropTypes.number.isRequired
	  };
	  InkContainer.defaultProps = {
	    transitionOverlap: 150,
	    transitionEnterTimeout: 450,
	    transitionLeaveTimeout: 300
	  };
	  exports.default = InkContainer;
	});

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(128)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./injectInk'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.injectInk);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _injectInk) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _injectInk2 = _interopRequireDefault(_injectInk);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _injectInk2.default;
	});

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(200), __webpack_require__(129)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./ListItemText'), require('./TileAddon'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.ListItemText, global.TileAddon);
	    global.ListItemControl = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _ListItemText, _TileAddon) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	  var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var ListItemControl = function (_PureComponent) {
	    _inherits(ListItemControl, _PureComponent);
	
	    function ListItemControl() {
	      _classCallCheck(this, ListItemControl);
	
	      return _possibleConstructorReturn(this, (ListItemControl.__proto__ || Object.getPrototypeOf(ListItemControl)).apply(this, arguments));
	    }
	
	    _createClass(ListItemControl, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            tileStyle = _props.tileStyle,
	            tileClassName = _props.tileClassName,
	            primaryAction = _props.primaryAction,
	            secondaryAction = _props.secondaryAction,
	            primaryText = _props.primaryText,
	            secondaryText = _props.secondaryText,
	            threeLines = _props.threeLines,
	            leftIcon = _props.leftIcon,
	            leftAvatar = _props.leftAvatar,
	            rightIcon = _props.rightIcon,
	            rightAvatar = _props.rightAvatar,
	            props = _objectWithoutProperties(_props, ['className', 'tileStyle', 'tileClassName', 'primaryAction', 'secondaryAction', 'primaryText', 'secondaryText', 'threeLines', 'leftIcon', 'leftAvatar', 'rightIcon', 'rightAvatar']);
	
	        var control = _react.Children.only(primaryAction || secondaryAction);
	        var text = _react2.default.createElement(_ListItemText2.default, {
	          key: 'text',
	          primaryText: control.props.label || primaryText,
	          secondaryText: secondaryText,
	          className: (0, _classnames2.default)({
	            'md-tile-content--left-icon': leftIcon,
	            'md-tile-content--left-avatar': leftAvatar,
	            'md-tile-content--left-button': primaryAction,
	            'md-tile-content--right-padding': primaryAction
	          })
	        });
	        control = (0, _react.cloneElement)(control, {
	          className: (0, _classnames2.default)('md-list-control', {
	            'md-list-control--right': secondaryAction
	          }, control.props.className),
	          label: text
	        });
	
	        var leftNode = _react2.default.createElement(_TileAddon2.default, {
	          key: 'left-addon',
	          icon: leftIcon,
	          avatar: leftAvatar
	        });
	
	        var rightNode = _react2.default.createElement(_TileAddon2.default, {
	          key: 'right-addon',
	          icon: rightIcon,
	          avatar: rightAvatar
	        });
	
	        var icond = !!leftIcon || !!rightIcon;
	        var avatard = !!leftAvatar || !!rightAvatar;
	
	        return _react2.default.createElement(
	          'li',
	          _extends({}, props, { className: (0, _classnames2.default)('md-list-item', className) }),
	          _react2.default.createElement(
	            'div',
	            {
	              style: tileStyle,
	              className: (0, _classnames2.default)('md-list-tile md-text', {
	                'md-list-tile--icon': !secondaryText && icond && !avatard,
	                'md-list-tile--avatar': !secondaryText && avatard,
	                'md-list-tile--two-lines': secondaryText && !threeLines,
	                'md-list-tile--three-lines': secondaryText && threeLines,
	                'md-list-tile--control-left': primaryAction,
	                'md-list-tile--control-right': secondaryAction
	              }, tileClassName)
	            },
	            leftNode,
	            control,
	            rightNode
	          )
	        );
	      }
	    }]);
	
	    return ListItemControl;
	  }(_react.PureComponent);
	
	  ListItemControl.propTypes = {
	    /**
	     * An optional style to apply to the `.md-list-item`.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `.md-list-item`.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the `.md-list-tile`.
	     */
	    tileStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `.md-list-tile`.
	     */
	    tileClassName: _react.PropTypes.string,
	
	    /**
	     * The primary text to display in the `ListItemControl`. The `primaryAction` or
	     * `secondaryAction` will end up getting the `label` prop injected into it with
	     * a combination of the `primaryText` and `secondaryText`. If the `primaryAction`
	     * or `secondaryAction` already have a label prop, the `label` prop will be used
	     * as the `primaryText`.
	     */
	    primaryText: _react.PropTypes.node,
	
	    /**
	     * An optional secondary text that can be displayed in the label of the `primaryAction`
	     * or `secondaryAction`.
	     */
	    secondaryText: _react.PropTypes.node,
	
	    /**
	     * Boolean if the primary and secondary text will span three lines.
	     */
	    threeLines: _react.PropTypes.bool,
	
	    /**
	     * The primary action of the `ListItemControl`. This _should_ normally
	     * be a type of `SelectionControl`
	     */
	    primaryAction: _react.PropTypes.element,
	
	    /**
	     * The secondary action of the `ListItemControl`. This _should_ normally
	     * be a type of `SelectionControl`. If it is a selection control,
	     * make sure to add the `labelBefore` prop to get correct positioning.
	     */
	    secondaryAction: _react.PropTypes.element,
	
	    /**
	     * An optional `FontIcon` to display to the left of the action.
	     */
	    leftIcon: _react.PropTypes.node,
	
	    /**
	     * An optional `Avatar` to display to the left of the action.
	     */
	    leftAvatar: _react.PropTypes.node,
	
	    /**
	     * An optional `FontIcon` to display to the right of the action.
	     */
	    rightIcon: _react.PropTypes.node,
	
	    /**
	     * An optional `FontIcon` to display to the right of the action.
	     */
	    rightAvatar: _react.PropTypes.node
	  };
	  exports.default = ListItemControl;
	});

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(50), __webpack_require__(65), __webpack_require__(441)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./List'), require('./ListItem'), require('./ListItemControl'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.List, global.ListItem, global.ListItemControl);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _List, _ListItem2, _ListItemControl2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.ListItemControl = exports.ListItem = exports.List = undefined;
	
	  var _List2 = _interopRequireDefault(_List);
	
	  var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	  var _ListItemControl3 = _interopRequireDefault(_ListItemControl2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _List2.default;
	  exports.List = _List2.default;
	  exports.ListItem = _ListItem3.default;
	  exports.ListItemControl = _ListItemControl3.default;
	});

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(13), __webpack_require__(66), __webpack_require__(16), __webpack_require__(83)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-prop-types/lib/isRequiredForA11y'), require('./Menu'), require('../Buttons/Button'), require('./Positions'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.isRequiredForA11y, global.Menu, global.Button, global.Positions);
	    global.MenuButton = mod.exports;
	  }
	})(this, function (exports, _react, _isRequiredForA11y, _Menu, _Button, _Positions) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _Menu2 = _interopRequireDefault(_Menu);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  var _Positions2 = _interopRequireDefault(_Positions);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var MenuButton = function (_PureComponent) {
	    _inherits(MenuButton, _PureComponent);
	
	    function MenuButton(props) {
	      _classCallCheck(this, MenuButton);
	
	      var _this = _possibleConstructorReturn(this, (MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call(this, props));
	
	      _this.state = {
	        isOpen: props.defaultOpen || false
	      };
	      _this._toggleMenu = _this._toggleMenu.bind(_this);
	      _this._closeMenu = _this._closeMenu.bind(_this);
	      return _this;
	    }
	
	    _createClass(MenuButton, [{
	      key: '_toggleMenu',
	      value: function _toggleMenu(e) {
	        var isOpen = !this.state.isOpen;
	        if (this.props.onClick) {
	          this.props.onClick(e);
	        }
	
	        if (this.props.onMenuToggle) {
	          this.props.onMenuToggle(isOpen, e);
	        }
	
	        this.setState({ isOpen: isOpen });
	      }
	    }, {
	      key: '_closeMenu',
	      value: function _closeMenu(e) {
	        if (this.props.onMenuToggle) {
	          this.props.onMenuToggle(false, e);
	        }
	
	        this.setState({ isOpen: false });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var isOpen = this.state.isOpen;
	
	        var _props = this.props,
	            id = _props.id,
	            listId = _props.listId,
	            buttonId = _props.buttonId,
	            menuStyle = _props.menuStyle,
	            menuClassName = _props.menuClassName,
	            listStyle = _props.listStyle,
	            listClassName = _props.listClassName,
	            buttonChildren = _props.buttonChildren,
	            children = _props.children,
	            fullWidth = _props.fullWidth,
	            position = _props.position,
	            contained = _props.contained,
	            transitionName = _props.transitionName,
	            transitionEnterTimeout = _props.transitionEnterTimeout,
	            transitionLeaveTimeout = _props.transitionLeaveTimeout,
	            props = _objectWithoutProperties(_props, ['id', 'listId', 'buttonId', 'menuStyle', 'menuClassName', 'listStyle', 'listClassName', 'buttonChildren', 'children', 'fullWidth', 'position', 'contained', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout']);
	
	        delete props.onClick;
	        delete props.onMenuToggle;
	        delete props.defaultOpen;
	
	        var toggle = _react2.default.createElement(
	          _Button2.default,
	          _extends({
	            key: 'menu-button'
	          }, props, {
	            id: buttonId,
	            onClick: this._toggleMenu
	          }),
	          buttonChildren
	        );
	
	        return _react2.default.createElement(
	          _Menu2.default,
	          {
	            id: id,
	            listId: listId,
	            style: menuStyle,
	            className: menuClassName,
	            listStyle: listStyle,
	            listClassName: listClassName,
	            toggle: toggle,
	            isOpen: isOpen,
	            onClose: this._closeMenu,
	            contained: contained,
	            position: position,
	            fullWidth: fullWidth,
	            transitionName: transitionName,
	            transitionEnterTimeout: transitionEnterTimeout,
	            transitionLeaveTimeout: transitionLeaveTimeout
	          },
	          children
	        );
	      }
	    }]);
	
	    return MenuButton;
	  }(_react.PureComponent);
	
	  MenuButton.Positions = _Positions2.default;
	  MenuButton.propTypes = {
	    /**
	     * An id to use for the menu button. This is required for a11y
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * An optional id to give the button instead of the menu.
	     */
	    buttonId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional id to give the list that appears in the menu.
	     */
	    listId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional style to apply to the button.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the button.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the menu.
	     */
	    menuStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the menu.
	     */
	    menuClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the menu's list when it is open.
	     */
	    listStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the menu's list when it is open.
	     */
	    listClassName: _react.PropTypes.string,
	
	    /**
	     * Any children used to render icons or anything else for the button.
	     */
	    buttonChildren: _react.PropTypes.node,
	
	    /**
	     * An optional function to call when the button is clicked.
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the menu's visiblity is toggled. The callback
	     * will include the next `open` state and the click event.
	     */
	    onMenuToggle: _react.PropTypes.func,
	
	    /**
	     * Boolean if the MenuButton is open by default.
	     */
	    defaultOpen: _react.PropTypes.bool,
	
	    /**
	     * The position for the menu.
	     */
	    position: _react.PropTypes.oneOf([_Positions2.default.TOP_LEFT, _Positions2.default.TOP_RIGHT, _Positions2.default.BOTTOM_LEFT, _Positions2.default.BOTTOM_RIGHT, _Positions2.default.BELOW]),
	
	    /**
	     * A list of `ListItem`s to render when the Menu is toggled open.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the `Menu` is displayed as full width.
	     */
	    fullWidth: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the max width of the menu's list should be equal to the `Button`.
	     */
	    contained: _react.PropTypes.bool,
	
	    /**
	     * An optional transition name to use for the menu transitions.
	     */
	    transitionName: _react.PropTypes.string,
	
	    /**
	     * An optional transition leave timeout to use for the menu transitions.
	     */
	    transitionEnterTimeout: _react.PropTypes.number,
	
	    /**
	     * An optional transition leave timeout to use for the menu transitions.
	     */
	    transitionLeaveTimeout: _react.PropTypes.number
	  };
	  exports.default = MenuButton;
	});

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(66), __webpack_require__(443)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Menu'), require('./MenuButton'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Menu, global.MenuButton);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Menu, _MenuButton2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.MenuButton = exports.Menu = undefined;
	
	  var _Menu2 = _interopRequireDefault(_Menu);
	
	  var _MenuButton3 = _interopRequireDefault(_MenuButton2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Menu2.default;
	  exports.Menu = _Menu2.default;
	  exports.MenuButton = _MenuButton3.default;
	});

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(22), __webpack_require__(129)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Helpers/AccessibleFakeInkedButton'), require('../Lists/TileAddon'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.AccessibleFakeInkedButton, global.TileAddon);
	    global.MiniListItem = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _AccessibleFakeInkedButton, _TileAddon) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	  var _TileAddon2 = _interopRequireDefault(_TileAddon);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var MiniListItem = function (_PureComponent) {
	    _inherits(MiniListItem, _PureComponent);
	
	    function MiniListItem(props) {
	      _classCallCheck(this, MiniListItem);
	
	      var _this = _possibleConstructorReturn(this, (MiniListItem.__proto__ || Object.getPrototypeOf(MiniListItem)).call(this, props));
	
	      _this.state = { active: false };
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
	      _this._handleMouseOver = _this._handleMouseOver.bind(_this);
	      _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
	      return _this;
	    }
	
	    _createClass(MiniListItem, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._touchTimeout) {
	          clearTimeout(this._touchTimeout);
	        }
	      }
	    }, {
	      key: '_handleMouseOver',
	      value: function _handleMouseOver(e) {
	        if (this.props.onMouseOver) {
	          this.props.onMouseOver(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ active: true });
	        }
	      }
	    }, {
	      key: '_handleMouseLeave',
	      value: function _handleMouseLeave(e) {
	        if (this.props.onMouseLeave) {
	          this.props.onMouseLeave(e);
	        }
	
	        if (!this.props.disabled) {
	          this.setState({ active: false });
	        }
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart(e) {
	        if (this.props.onTouchStart) {
	          this.props.onTouchStart(e);
	        }
	
	        this._touched = true;
	
	        this.setState({ active: true, touchedAt: Date.now() });
	      }
	    }, {
	      key: '_handleTouchEnd',
	      value: function _handleTouchEnd(e) {
	        var _this2 = this;
	
	        if (this.props.onTouchEnd) {
	          this.props.onTouchEnd(e);
	        }
	
	        var time = Date.now() - this.state.touchedAt;
	        this._touchTimeout = setTimeout(function () {
	          _this2._touchTimeout = null;
	
	          _this2.setState({ active: false });
	        }, time > 450 ? 0 : 450 - time);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            tileStyle = _props.tileStyle,
	            tileClassName = _props.tileClassName,
	            leftIcon = _props.leftIcon,
	            leftAvatar = _props.leftAvatar,
	            active = _props.active,
	            activeClassName = _props.activeClassName,
	            props = _objectWithoutProperties(_props, ['style', 'className', 'tileStyle', 'tileClassName', 'leftIcon', 'leftAvatar', 'active', 'activeClassName']);
	
	        delete props.defaultOpen;
	        return _react2.default.createElement(
	          'li',
	          { style: style, className: className },
	          _react2.default.createElement(
	            _AccessibleFakeInkedButton2.default,
	            _extends({}, props, {
	              style: tileStyle,
	              className: (0, _classnames2.default)('md-list-tile md-list-tile--icon md-list-tile--mini', {
	                'md-list-tile--active': this.state.active && !this._touched
	              }, tileClassName),
	              onMouseOver: this._handleMouseOver,
	              onMouseLeave: this._handleMouseLeave,
	              onTouchStart: this._handleTouchStart,
	              onTouchEnd: this._handleTouchEnd
	            }),
	            _react2.default.createElement(_TileAddon2.default, {
	              active: active,
	              activeClassName: activeClassName,
	              icon: leftIcon,
	              avatar: leftAvatar
	            })
	          )
	        );
	      }
	    }]);
	
	    return MiniListItem;
	  }(_react.PureComponent);
	
	  MiniListItem.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    tileStyle: _react.PropTypes.object,
	    tileClassName: _react.PropTypes.string,
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
	    active: _react.PropTypes.bool,
	    activeClassName: _react.PropTypes.string,
	    leftIcon: _react.PropTypes.node,
	    leftAvatar: _react.PropTypes.node,
	    disabled: _react.PropTypes.bool,
	    onTouchStart: _react.PropTypes.func,
	    onTouchEnd: _react.PropTypes.func,
	    onMouseOver: _react.PropTypes.func,
	    onMouseLeave: _react.PropTypes.func
	  };
	  MiniListItem.defaultProps = {
	    activeClassName: 'md-text--theme-primary',
	    component: 'div'
	  };
	  exports.default = MiniListItem;
	});

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(36), __webpack_require__(8), __webpack_require__(13), __webpack_require__(12), __webpack_require__(14), __webpack_require__(40), __webpack_require__(16), __webpack_require__(125), __webpack_require__(50), __webpack_require__(217), __webpack_require__(197), __webpack_require__(206), __webpack_require__(205), __webpack_require__(445)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-addons-css-transition-group'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../utils/PropTypes/invalidIf'), require('../Buttons/Button'), require('../Drawers/Drawer'), require('../Lists/List'), require('../Toolbars/Toolbar'), require('../Drawers/isType'), require('./JumpToContentLink'), require('./CloseButton'), require('./MiniListItem'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.reactAddonsCssTransitionGroup, global.deprecated, global.isRequiredForA11y, global.getField, global.controlled, global.invalidIf, global.Button, global.Drawer, global.List, global.Toolbar, global.isType, global.JumpToContentLink, global.CloseButton, global.MiniListItem);
	    global.NavigationDrawer = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _reactAddonsCssTransitionGroup, _deprecated, _isRequiredForA11y, _getField, _controlled, _invalidIf, _Button, _Drawer, _List, _Toolbar, _isType, _JumpToContentLink, _CloseButton, _MiniListItem) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _invalidIf2 = _interopRequireDefault(_invalidIf);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  var _Drawer2 = _interopRequireDefault(_Drawer);
	
	  var _List2 = _interopRequireDefault(_List);
	
	  var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	  var _JumpToContentLink2 = _interopRequireDefault(_JumpToContentLink);
	
	  var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	  var _MiniListItem2 = _interopRequireDefault(_MiniListItem);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  var DrawerTypes = _Drawer2.default.DrawerTypes;
	
	
	  function getNonMiniType(type) {
	    var pMini = DrawerTypes.PERSISTENT_MINI,
	        tMini = DrawerTypes.TEMPORARY_MINI;
	
	    if ([pMini, tMini].indexOf(type) === -1) {
	      return type;
	    }
	
	    return pMini === type ? DrawerTypes.PERSISTENT : DrawerTypes.TEMPORARY;
	  }
	
	  function toMiniListItem(item, index) {
	    if ((0, _react.isValidElement)(item)) {
	      return item;
	    }
	
	    var divider = item.divider,
	        subheader = item.subheader,
	        key = item.key,
	        itemProps = _objectWithoutProperties(item, ['divider', 'subheader', 'key']);
	
	    if (divider || subheader) {
	      return null;
	    }
	
	    delete itemProps.primaryText;
	    delete itemProps.secondaryText;
	    delete itemProps.rightIcon;
	    delete itemProps.rightAvatar;
	    delete itemProps.threeLines;
	    delete itemProps.nestedItems;
	    delete itemProps.expanderIconChildren;
	    delete itemProps.expanderIconClassName;
	    delete itemProps.children;
	
	    return _react2.default.createElement(_MiniListItem2.default, _extends({ key: key || index }, itemProps));
	  }
	
	  /**
	   * The `NavigationDrawer` is used when you want a full layout configuration. It is a combination
	   * of the `Toolbar` component and the `Drawer` component.
	   *
	   * The main benfit of using this component is that it will manage adding respective offset
	   * classes automatically for you to the content and the drawer. It will also manage using
	   * a mini drawer type for you.
	   */
	
	  var NavigationDrawer = function (_PureComponent) {
	    _inherits(NavigationDrawer, _PureComponent);
	
	    _createClass(NavigationDrawer, null, [{
	      key: 'getCurrentMedia',
	      value: function getCurrentMedia() {
	        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NavigationDrawer.defaultProps;
	
	        var mobileType = props.mobileDrawerType,
	            tabletType = props.tabletDrawerType,
	            desktopType = props.desktopDrawerType,
	            constantType = props.constantDrawerType,
	            others = _objectWithoutProperties(props, ['mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'constantDrawerType']);
	
	        return _Drawer2.default.getCurrentMedia(_extends({ mobileType: mobileType, tabletType: tabletType, desktopType: desktopType, constantType: constantType }, others));
	      }
	    }]);
	
	    function NavigationDrawer(props) {
	      _classCallCheck(this, NavigationDrawer);
	
	      var _this = _possibleConstructorReturn(this, (NavigationDrawer.__proto__ || Object.getPrototypeOf(NavigationDrawer)).call(this, props));
	
	      var defaultMedia = props.defaultMedia,
	          defaultVisible = props.defaultVisible,
	          initialDrawerType = props.initialDrawerType;
	
	
	      _this.state = {
	        mobile: initialDrawerType || defaultMedia === 'mobile',
	        tablet: initialDrawerType || defaultMedia === 'tablet',
	        desktop: initialDrawerType || defaultMedia === 'desktop'
	      };
	
	      if (typeof props.drawerType === 'undefined') {
	        _this.state.drawerType = props[(initialDrawerType || defaultMedia) + 'DrawerType'];
	      }
	
	      var type = (0, _getField2.default)(props, _this.state, 'drawerType');
	
	      if (typeof props.visible === 'undefined') {
	        _this.state.visible = typeof defaultVisible !== 'undefined' ? defaultVisible : (0, _isType.isPermanent)(type);
	      }
	
	      _this._handleTypeChange = _this._handleTypeChange.bind(_this);
	      _this._handleVisibility = _this._handleVisibility.bind(_this);
	      _this._toggleVisibility = _this._toggleVisibility.bind(_this);
	      return _this;
	    }
	
	    _createClass(NavigationDrawer, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        var _props = this.props,
	            persistentIconChildren = _props.persistentIconChildren,
	            persistentIconClassName = _props.persistentIconClassName,
	            closeIconChildren = _props.closeIconChildren,
	            closeIconClassName = _props.closeIconClassName,
	            id = _props.contentId,
	            label = _props.jumpLabel;
	
	
	        return {
	          id: id,
	          label: label,
	          closeChildren: closeIconChildren || persistentIconChildren,
	          closeIconClassName: closeIconClassName || persistentIconClassName,
	          onCloseClick: this._toggleVisibility,
	          renderNode: this.context.renderNode
	        };
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        var _this2 = this;
	
	        var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	        var nVisible = (0, _getField2.default)(nextProps, nextState, 'visible');
	        var drawerType = (0, _getField2.default)(nextProps, nextState, 'drawerType');
	
	        if (!(0, _isType.isTemporary)(drawerType) && visible !== nVisible) {
	          if (this._timeout) {
	            clearTimeout(this._timeout);
	          }
	
	          this._timeout = setTimeout(function () {
	            _this2.setState({ contentActive: false });
	          }, nextProps.drawerTransitionDuration);
	
	          this.setState({ contentActive: true });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	      }
	    }, {
	      key: '_toggleVisibility',
	      value: function _toggleVisibility(e) {
	        var _props2 = this.props,
	            onVisibilityToggle = _props2.onVisibilityToggle,
	            onDrawerChange = _props2.onDrawerChange;
	
	        var visible = !(0, _getField2.default)(this.props, this.state, 'visible');
	        if (onVisibilityToggle || onDrawerChange) {
	          (onDrawerChange || onVisibilityToggle)(visible, e);
	        }
	
	        if (typeof this.props.visible === 'undefined') {
	          this.setState({ visible: visible });
	        }
	      }
	    }, {
	      key: '_handleVisibility',
	      value: function _handleVisibility(visible) {
	        if (this.props.onVisibilityToggle) {
	          this.props.onVisibilityToggle(visible);
	        }
	
	        if (typeof this.props.visible === 'undefined') {
	          this.setState({ visible: visible });
	        }
	      }
	    }, {
	      key: '_handleTypeChange',
	      value: function _handleTypeChange(drawerType, mediaState) {
	        var onMediaTypeChange = this.props.onMediaTypeChange;
	
	        var state = mediaState;
	        if (onMediaTypeChange) {
	          onMediaTypeChange(drawerType, mediaState);
	        }
	
	        if (typeof this.props.drawerType === 'undefined') {
	          state = _extends({}, mediaState, { drawerType: drawerType });
	        }
	
	        this.setState(state);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props3 = this.props,
	            style = _props3.style,
	            className = _props3.className,
	            toolbarStyle = _props3.toolbarStyle,
	            toolbarClassName = _props3.toolbarClassName,
	            drawerStyle = _props3.drawerStyle,
	            drawerClassName = _props3.drawerClassName,
	            contentStyle = _props3.contentStyle,
	            contentClassName = _props3.contentClassName,
	            Content = _props3.contentComponent,
	            navItems = _props3.navItems,
	            children = _props3.children,
	            drawerTitle = _props3.drawerTitle,
	            drawerChildren = _props3.drawerChildren,
	            drawerHeaderChildren = _props3.drawerHeaderChildren,
	            drawerTransitionDuration = _props3.drawerTransitionDuration,
	            toolbarTitle = _props3.toolbarTitle,
	            toolbarTitleMenu = _props3.toolbarTitleMenu,
	            toolbarTitleStyle = _props3.toolbarTitleStyle,
	            toolbarTitleClassName = _props3.toolbarTitleClassName,
	            toolbarActions = _props3.toolbarActions,
	            toolbarProminent = _props3.toolbarProminent,
	            toolbarProminentTitle = _props3.toolbarProminentTitle,
	            toolbarThemeType = _props3.toolbarThemeType,
	            toolbarSingleColor = _props3.toolbarSingleColor,
	            toolbarChildren = _props3.toolbarChildren,
	            mobileType = _props3.mobileDrawerType,
	            tabletType = _props3.tabletDrawerType,
	            desktopType = _props3.desktopDrawerType,
	            transitionName = _props3.transitionName,
	            transitionEnterTimeout = _props3.transitionEnterTimeout,
	            transitionLeaveTimeout = _props3.transitionLeaveTimeout,
	            extractMini = _props3.extractMini,
	            miniDrawerHeader = _props3.miniDrawerHeader,
	            miniDrawerChildren = _props3.miniDrawerChildren,
	            temporaryIconChildren = _props3.temporaryIconChildren,
	            temporaryIconClassName = _props3.temporaryIconClassName,
	            menuIconChildren = _props3.menuIconChildren,
	            menuIconClassName = _props3.menuIconClassName,
	            footer = _props3.footer,
	            includeDrawerHeader = _props3.includeDrawerHeader,
	            contentId = _props3.contentId,
	            contentProps = _props3.contentProps,
	            constantDrawerType = _props3.constantDrawerType,
	            props = _objectWithoutProperties(_props3, ['style', 'className', 'toolbarStyle', 'toolbarClassName', 'drawerStyle', 'drawerClassName', 'contentStyle', 'contentClassName', 'contentComponent', 'navItems', 'children', 'drawerTitle', 'drawerChildren', 'drawerHeaderChildren', 'drawerTransitionDuration', 'toolbarTitle', 'toolbarTitleMenu', 'toolbarTitleStyle', 'toolbarTitleClassName', 'toolbarActions', 'toolbarProminent', 'toolbarProminentTitle', 'toolbarThemeType', 'toolbarSingleColor', 'toolbarChildren', 'mobileDrawerType', 'tabletDrawerType', 'desktopDrawerType', 'transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'extractMini', 'miniDrawerHeader', 'miniDrawerChildren', 'temporaryIconChildren', 'temporaryIconClassName', 'menuIconChildren', 'menuIconClassName', 'footer', 'includeDrawerHeader', 'contentId', 'contentProps', 'constantDrawerType']);
	
	        delete props.drawerType;
	        delete props.drawerHeader;
	        delete props.persistentIconChildren;
	        delete props.persistentIconClassName;
	        delete props.jumpLabel;
	        delete props.renderNode;
	
	        // Deprecated deletes
	        delete props.onDrawerChange;
	        delete props.closeIconChildren;
	        delete props.closeIconClassName;
	
	        var drawerHeader = this.props.drawerHeader;
	        var _state = this.state,
	            desktop = _state.desktop,
	            tablet = _state.tablet,
	            contentActive = _state.contentActive;
	
	
	        var drawerType = (0, _getField2.default)(this.props, this.state, 'drawerType');
	        var visible = (0, _getField2.default)(this.props, this.state, 'visible');
	        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	        var mini = (0, _isType.isMini)(drawerType);
	        var temporary = (0, _isType.isTemporary)(drawerType);
	        var persistent = (0, _isType.isPersistent)(drawerType);
	        var clipped = drawerType === DrawerTypes.CLIPPED;
	        var floating = drawerType === DrawerTypes.FLOATING;
	
	        var offset = desktop || tablet ? !temporary && visible : visible;
	        var toolbarRelative = (0, _classnames2.default)({
	          'md-toolbar-relative': !toolbarProminent && !toolbarProminentTitle,
	          'md-toolbar-relative--prominent': toolbarProminent || toolbarProminentTitle
	        });
	
	        var nav = void 0;
	        if (temporary || persistent) {
	          nav = _react2.default.createElement(
	            _Button2.default,
	            {
	              key: 'nav',
	              onClick: this._toggleVisibility,
	              disabled: persistent && visible,
	              icon: true,
	              iconClassName: menuIconClassName || temporaryIconClassName
	            },
	            menuIconChildren || temporaryIconChildren
	          );
	        }
	
	        var closeButton = void 0;
	        if (persistent) {
	          closeButton = _react2.default.createElement(_CloseButton2.default, null);
	        }
	
	        if (!drawerHeader && includeDrawerHeader) {
	          drawerHeader = _react2.default.createElement(
	            _Toolbar2.default,
	            {
	              key: 'drawer-header',
	              title: drawerTitle,
	              actions: visible && nav ? closeButton : null,
	              className: (0, _classnames2.default)('md-divider-border md-divider-border--bottom', _defineProperty({}, toolbarRelative, clipped || floating))
	            },
	            drawerHeaderChildren,
	            _react2.default.createElement(_JumpToContentLink2.default, null)
	          );
	        }
	        var miniDrawer = void 0;
	        if (mini) {
	          var miniList = void 0;
	          if (extractMini) {
	            miniList = navItems.map(toMiniListItem);
	            miniList = _react2.default.createElement(
	              _List2.default,
	              { key: 'mini-nav-items', className: toolbarRelative },
	              miniList
	            );
	          }
	
	          miniDrawer = _react2.default.createElement(
	            _Drawer2.default,
	            { key: 'mini-drawer', type: drawerType, renderNode: renderNode, 'aria-hidden': visible },
	            miniDrawerHeader,
	            miniList,
	            miniDrawerChildren
	          );
	        }
	
	        var desktopOffset = !clipped && !floating && offset;
	
	        return _react2.default.createElement(
	          'div',
	          { style: style, className: className },
	          _react2.default.createElement(
	            _Toolbar2.default,
	            {
	              colored: toolbarThemeType === 'colored',
	              themed: toolbarThemeType === 'themed',
	              singleColor: toolbarSingleColor,
	              style: toolbarStyle,
	              className: (0, _classnames2.default)({
	                'md-toolbar--over-drawer': clipped || floating || mini && !visible
	              }, toolbarClassName),
	              title: toolbarTitle,
	              titleMenu: toolbarTitleMenu,
	              prominent: toolbarProminent,
	              prominentTitle: toolbarProminentTitle,
	              titleStyle: toolbarTitleStyle,
	              titleClassName: (0, _classnames2.default)({
	                'md-title--drawer-active': contentActive,
	                'md-transition--decceleration': offset && visible,
	                'md-transition--acceleration': offset && !visible,
	                'md-title--permanent-offset': desktopOffset && (0, _isType.isPermanent)(drawerType),
	                'md-title--persistent-offset': desktopOffset && persistent
	              }, toolbarTitleClassName),
	              nav: nav,
	              actions: toolbarActions,
	              fixed: true
	            },
	            toolbarChildren
	          ),
	          miniDrawer,
	          _react2.default.createElement(
	            _Drawer2.default,
	            _extends({}, props, {
	              constantType: constantDrawerType,
	              transitionDuration: drawerTransitionDuration,
	              header: drawerHeader,
	              style: drawerStyle,
	              className: drawerClassName,
	              navItems: navItems,
	              renderNode: renderNode,
	              mobileType: mobileType,
	              tabletType: tabletType,
	              desktopType: desktopType,
	              type: getNonMiniType(drawerType),
	              visible: visible,
	              onVisibilityToggle: this._handleVisibility,
	              onMediaTypeChange: this._handleTypeChange
	            }),
	            drawerChildren
	          ),
	          _react2.default.createElement(
	            _reactAddonsCssTransitionGroup2.default,
	            _extends({}, contentProps, {
	              id: contentId,
	              component: Content,
	              transitionName: transitionName,
	              transitionEnter: !!transitionEnterTimeout,
	              transitionEnterTimeout: transitionEnterTimeout,
	              transitionLeave: !!transitionLeaveTimeout,
	              transitionLeaveTimeout: transitionLeaveTimeout,
	              tabIndex: -1,
	              style: contentStyle,
	              className: (0, _classnames2.default)('md-navigation-drawer-content', {
	                'md-navigation-drawer-content--active': contentActive,
	                'md-navigation-drawer-content--inactive': !visible,
	                'md-navigation-drawer-content--prominent-offset': toolbarProminent || toolbarProminentTitle,
	                'md-transition--decceleration': visible,
	                'md-transition--acceleration': !visible,
	                'md-drawer-relative': offset,
	                'md-drawer-relative--mini': mini && (!visible || temporary)
	              }, toolbarRelative, contentClassName)
	            }),
	            children
	          ),
	          footer
	        );
	      }
	    }]);
	
	    return NavigationDrawer;
	  }(_react.PureComponent);
	
	  NavigationDrawer.DrawerType = { // deprecated
	    /* eslint-disable no-console */
	    _warned: false,
	    _msg: 'Invalid use of `NavigationDrawer.DrawerType.{{TYPE}}`. The `NavigationDrawer.DrawerType` ' + 'has been deprecated and will be removed in the next release. Please use the ' + '`NavigationDrawer.DrawerTypes.{{TYPE}}` instead.',
	
	    get FULL_HEIGHT() {
	      if (!this._warned) {
	        console.error(this._msg.replace(/{{TYPE}}/g, 'FULL_HEIGHT'));
	      }
	      this._warned = true;
	
	      return DrawerTypes.FULL_HEIGHT;
	    },
	
	    get CLIPPED() {
	      if (!this._warned) {
	        console.error(this._msg.replace(/{{TYPE}}/g, 'CLIPPED'));
	      }
	      this._warned = true;
	
	      return DrawerTypes.CLIPPED;
	    },
	
	    get FLOATING() {
	      if (!this._warned) {
	        console.error(this._msg.replace(/{{TYPE}}/g, 'FLOATING'));
	      }
	      this._warned = true;
	
	      return DrawerTypes.FLOATING;
	    },
	
	    get PERSISTENT() {
	      if (!this._warned) {
	        console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT'));
	      }
	      this._warned = true;
	
	      return DrawerTypes.PERSISTENT;
	    },
	
	    get PERSISTENT_MINI() {
	      if (!this._warned) {
	        console.error(this._msg.replace(/{{TYPE}}/g, 'PERSISTENT_MINI'));
	      }
	      this._warned = true;
	
	      return DrawerTypes.PERSISTENT_MINI;
	    },
	
	    get TEMPORARY() {
	      if (!this._warned) {
	        console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY'));
	      }
	      this._warned = true;
	
	      return DrawerTypes.TEMPORARY;
	    },
	
	    get TEMPORARY_MINI() {
	      if (!this._warned) {
	        console.error(this._msg.replace(/{{TYPE}}/g, 'TEMPORARY_MINI'));
	      }
	      this._warned = true;
	
	      return DrawerTypes.TEMPORARY_MINI;
	    }
	  };
	  NavigationDrawer.DrawerTypes = DrawerTypes;
	  NavigationDrawer.propTypes = {
	    /**
	     * An optional style to apply to the surrounding container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the surrounding container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the main toolbar.
	     */
	    toolbarStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the toolbar.
	     */
	    toolbarClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the main toolbar's title.
	     */
	    toolbarTitleStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the main toolbar's title.
	     */
	    toolbarTitleClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the drawer.
	     */
	    drawerStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the drawer.
	     */
	    drawerClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the content. This is the container surrounding whatever
	     * `children` are passed in.
	     */
	    contentStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the content. This is the container surrounding whatever
	     * `children` are passed in.
	     */
	    contentClassName: _react.PropTypes.string,
	
	    /**
	     * The children to display in the main content.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * Boolean if the `drawerHeader` component should be built if the `drawerHeader` prop is not
	     * passed in.
	     */
	    includeDrawerHeader: _react.PropTypes.bool,
	
	    /**
	     * An optional header to display in the drawer. This will normally be the `Toolbar` component
	     * or any other type of header. You can either use this prop with the `CloseButton` component
	     * when displaying a persistent drawer, or use the `drawerTitle` and `drawerHeaderChildren` prop
	     * to build a toolbar.
	     */
	    drawerHeader: _react.PropTypes.node,
	
	    /**
	     * An optional title to use for the drawer's header toolbar. If the `drawerHeader` prop is defined,
	     * this is invalid.
	     */
	    drawerTitle: (0, _invalidIf2.default)(_react.PropTypes.node, 'drawerHeader'),
	
	    /**
	     * Any additional children to display in the drawer's header `Toolbar`. If the `drawerHeader` prop is defined,
	     * this is invalud.
	     */
	    drawerHeaderChildren: (0, _invalidIf2.default)(_react.PropTypes.node, 'drawerHeader'),
	
	    /**
	     * Any additional children to display after the `drawerHeader` and `navItems` list in the drawer.
	     */
	    drawerChildren: _react.PropTypes.node,
	
	    /**
	     * The position for the drawer to be displayed.
	     */
	    position: _react.PropTypes.oneOf(['left', 'right']).isRequired,
	
	    /**
	     * An optional list of elements or props to use to build a navigational list in the drawer.
	     * When the item is an object of props, it will build a `ListItem` component unless a key of
	     * `divider` or `subheader` is set to true. It will then create the Divider or Subheader component
	     * with any other remaining keys.
	     */
	    navItems: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.shape({
	      divider: _react.PropTypes.bool,
	      subheader: _react.PropTypes.bool,
	      primaryText: _react.PropTypes.string
	    })])),
	
	    /**
	     * The drawer type to use for mobile devices.
	     */
	    mobileDrawerType: _react.PropTypes.oneOf([DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	    /**
	     * The drawer tye to use for tablets.
	     */
	    tabletDrawerType: _react.PropTypes.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	    /**
	     * The drawer type to use for desktop displays.
	     */
	    desktopDrawerType: _react.PropTypes.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]).isRequired,
	
	    /**
	     * An optional drawer type to enforce on all screen sizes. If the drawer type is not
	     * `temporary`, you are required to define the `onMediaTypeChange` prop to handle switching
	     * to temporary when the media matches a mobile device.
	     * ```
	     */
	    drawerType: _react.PropTypes.oneOf([DrawerTypes.FULL_HEIGHT, DrawerTypes.CLIPPED, DrawerTypes.FLOATING, DrawerTypes.PERSISTENT, DrawerTypes.PERSISTENT_MINI, DrawerTypes.TEMPORARY, DrawerTypes.TEMPORARY_MINI]),
	
	    /**
	     * The default media match for the drawer. This will be what is displayed on first render.
	     * The component will adjust itself to the current media after it has mounted, but this
	     * is mostly used for server side rendering.
	     */
	    defaultMedia: _react.PropTypes.oneOf(['mobile', 'tablet', 'desktop']),
	
	    /**
	     * The min width to use for a mobile media query. This prop should match the `md-mobile-min-width`
	     * variable.
	     *
	     * The media query for a mobile device will be:
	     *
	     * ```js
	     * window.matchMedia(
	     *   `screen and (min-width: ${mobileMinWidth}px) and (max-width: ${tabletMinWidth - 1}px`
	     * ).matches;
	     * ```
	     */
	    mobileMinWidth: _react.PropTypes.number.isRequired,
	
	    /**
	     * The min width to use for a tablet media query. This prop should match the `md-tablet-min-width`
	     * variable.
	     *
	     * The media query for a tablet device will be:
	     *
	     * ```js
	     * window.matchMedia(
	     *   `screen and (min-width: ${tabletMinWidth}px) and (max-width: ${desktopWidth - 1}px`
	     * ).matches;
	     * ```
	     */
	    tabletMinWidth: _react.PropTypes.number.isRequired,
	
	    /**
	     * The min width to use for a desktop media query. This prop should match the `md-desktop-min-width`
	     * variable.
	     *
	     * The media query for a tablet device will be:
	     *
	     * ```js
	     * window.matchMedia(`screen and (min-width: ${tabletMinWidth}px)`).matches;
	     * ```
	     */
	    desktopMinWidth: _react.PropTypes.number.isRequired,
	
	    /**
	     * An optional function to call when the type of the drawer changes because of the
	     * new media queries. The callback will include the newly selected drawer type
	     * and an object containing the media matches of `mobile`, `tablet`, and `desktop`.
	     *
	     * ```js
	     * this.props.onMediaTypeChange(NavigationDrawer.DrawerTypes.TEMPORARY, {
	     *   mobile: true,
	     *   tablet: false,
	     *   desktop: false,
	     * });
	     * ```
	     */
	    onMediaTypeChange: _react.PropTypes.func,
	
	    /**
	     * Boolean if the temporary or persistent drawers are visible by default.
	     */
	    defaultVisible: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the temporary or persistent drawers are visible. If this is defined,
	     * it will make the component controlled and require the `onVisibilityToggle` prop
	     * to be defined.
	     */
	    visible: (0, _controlled2.default)(_react.PropTypes.bool, 'onVisibilityToggle', 'defaultVisible'),
	
	    /**
	     * An optional function to call when the visibility of the drawer changes. The callback
	     * will include the new visibility.
	     *
	     * ```js
	     * this.props.onVisibilityToggle(false);
	     * ```
	     */
	    onVisibilityToggle: _react.PropTypes.func,
	
	    /**
	     * A boolean if the mini drawer's list should be generated from the `navItems` prop. When building
	     * the list, it will extract the `leftIcon` or `leftAvatar` from the `navItem` and then create a
	     * mini `ListItem` containing only that icon or image. Any other event listeners will also be applied.
	     *
	     *
	     * @see miniDrawerHeader
	     * @see miniDrawerChildren
	     */
	    extractMini: _react.PropTypes.bool,
	
	    /**
	     * An optional header to display in the mini drawer. This will be displayed above the optional
	     * mini nav list that get generated if the `extractMini` prop is `true` and the `miniDrawerChildren`.
	     *
	     * @see extractMini
	     */
	    miniDrawerHeader: _react.PropTypes.node,
	
	    /**
	     * Any additional children to display in the mini drawer. This will be displayed after the `miniDrawerHeader`
	     * and the optional mini nav list that gets generated if the `extractMini` prop is `true`.
	     *
	     * @see extractMini
	     */
	    miniDrawerChildren: _react.PropTypes.node,
	
	    /**
	     * Boolean if the drawer should automatically close after a nav item has been clicked for `temporary` drawers.
	     */
	    autoclose: _react.PropTypes.bool,
	
	    /**
	     * An optional title to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	     * may be defined, not both.
	     */
	    toolbarTitle: (0, _invalidIf2.default)(_react.PropTypes.node, 'toolbarTitleMenu'),
	
	    /**
	     * An optional select field menu to display in the main toolbar. Either the `toolbarTitle` or the `toolbarTitleMenu`
	     * may be defined, not both.
	     */
	    toolbarTitleMenu: _react.PropTypes.element,
	
	    /**
	     * The theme style for the main toolbar.
	     *
	     * @see [toolbars](/components/toolbars#prop-types-toolbar)
	     */
	    toolbarThemeType: _react.PropTypes.oneOf(['default', 'colored', 'themed']).isRequired,
	
	    /**
	     * Boolean if the toolbar's nav, actions, and title should share the same color.
	     */
	    toolbarSingleColor: _react.PropTypes.bool,
	
	    /**
	     * A boolean if the toolbar should be prominent.
	     */
	    toolbarProminent: _react.PropTypes.bool,
	
	    /**
	     * A boolean if the toolbar's title should be prominent.
	     */
	    toolbarProminentTitle: _react.PropTypes.bool,
	
	    /**
	     * A list of elements or a single element to display to the right of the
	     * toolbar's nav, title, and children.
	     *
	     * @see [toolbars](/components/toolbars#prop-types-toolbar)
	     */
	    toolbarActions: _Toolbar2.default.propTypes.actions,
	
	    /**
	     * Any children to display in the toolbar. This will be displayed between the optional title and
	     * actions.
	     */
	    toolbarChildren: _Toolbar2.default.propTypes.children,
	
	    /**
	     * The component to render the content in.
	     */
	    contentComponent: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * An optional footer display after the main content.
	     */
	    footer: _react.PropTypes.node,
	
	    /**
	     * Any children used to render a button that will toggle the visibility of the
	     * navigation drawer for `temporary` and `persistent` drawers. This is normally a
	     * hamburger menu.
	     */
	    temporaryIconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className used to render a button that will toggle the visibility of the
	     * navigation drawer for `temporary` and `persistent` drawers. This is normally a
	     * hamburger menu.
	     */
	    temporaryIconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children used to render a button that appears on a persistent drawer's open
	     * header. This is used to create the `CloseButton` for drawers. When a persistent
	     * drawer is closed, the `temporaryIconChildren` and `temporaryIconClassName` props
	     * will be used to create a button to open the drawer.
	     *
	     * If the `drawerHeader` prop is defined, you will have to either include the `CloseButton`
	     * in your header manually, or create your own controlled button to close the drawer.
	     */
	    persistentIconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon classNameused to render a button that appears on a persistent drawer's open
	     * header. This is used to create the `CloseButton` for drawers. When a persistent
	     * drawer is closed, the `temporaryIconChildren` and `temporaryIconClassName` props
	     * will be used to create a button to open the drawer.
	     *
	     * If the `drawerHeader` prop is defined, you will have to either include the `CloseButton`
	     * in your header manually, or create your own controlled button to close the drawer.
	     */
	    persistentIconClassName: _react.PropTypes.string,
	
	    /**
	     * The transition name to use when the page's content changes. If you want to disable
	     * transitions, set both the `transitionEnterTimeout` and `transitionLeaveTimeout` props
	     * to a false-ish value. (`null`, `undefined`, or `0`).
	     */
	    transitionName: _react.PropTypes.string.isRequired,
	
	    /**
	     * The transition enter timeout when the page's content changes. If you want to disable
	     * the enter transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	     */
	    transitionEnterTimeout: _react.PropTypes.number,
	
	    /**
	     * The transition leave timeout when the page's content changes. If you want to disable
	     * the leave transition, set this to a false-ish value (`null`, `undefined`, or `0`).
	     */
	    transitionLeaveTimeout: _react.PropTypes.number,
	
	    /**
	     * The transition duration for the drawer when sliding in and out of view.
	     */
	    drawerTransitionDuration: _react.PropTypes.number.isRequired,
	
	    /**
	     * Any additional props to provide to the main content. This will be applied before any of the generated props,
	     * so this should not include `style`, `className`, or `component`.
	     */
	    contentProps: _react.PropTypes.object,
	
	    /**
	     * An id to give the main content. A hidden link is created in the main drawer's header that links to the main
	     * content. This is used for keyboard only users to jump the navigation and jump straight to the content.
	     *
	     * If you provide your own `drawerHeader`, it is suggested to include the link yourself.
	     */
	    contentId: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * The label to use for a keyboard accessibility link that jumps all the navigation and allows a user to focus
	     * the main content. This is created in the drawer's header.
	     */
	    jumpLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * An optional DOM Node to render the drawer into. The default is to render as
	     * the first child in the `body`.
	     *
	     * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	     * since the `Portal` component will not be used.
	     */
	    renderNode: _react.PropTypes.object,
	
	    /**
	     * Boolean if the drawer should be rendered as the last child instead of the first child
	     * in the `renderNode` or `body`.
	     *
	     * > This prop will not be used when the drawer is of the permanent type or `inline` is specified
	     * since the `Portal` component will not be used.
	     */
	    lastChild: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the `drawerType` should remain constant across all media. This is really only valid
	     * if the `drawerType` is one of the temporary types.
	     */
	    constantDrawerType: _react.PropTypes.bool,
	
	    menuIconChildren: (0, _deprecated2.default)(_react.PropTypes.node, 'Use `temporaryIconChildren` instead'),
	    menuIconClassName: (0, _deprecated2.default)(_react.PropTypes.string, 'Use `temporaryIconClassName` instead'),
	    closeIconChildren: (0, _deprecated2.default)(_react.PropTypes.node, 'Use `persistentIconChildren` instead'),
	    closeIconClassName: (0, _deprecated2.default)(_react.PropTypes.string, 'Use `persistentIconClassName` instead'),
	    onDrawerChange: (0, _deprecated2.default)(_react.PropTypes.func, 'Use `onVisibilityToggle` or `onMediaTypeChange` instead'),
	    contentTransitionName: (0, _deprecated2.default)(_react.PropTypes.string, 'Use `transitionName` instead'),
	    contentTransitionEnterTimeout: (0, _deprecated2.default)(_react.PropTypes.number, 'Use `transtionEnterTimeout` instead'),
	    contentTransitionLeaveTimeout: (0, _deprecated2.default)(_react.PropTypes.number, 'Use `transtionLeaveTimeout` instead'),
	    initialDrawerType: (0, _deprecated2.default)(_react.PropTypes.oneOf(['mobile', 'tablet', 'desktop']), 'Use `defaultMedia` instead')
	  };
	  NavigationDrawer.contextTypes = {
	    renderNode: _react.PropTypes.object
	  };
	  NavigationDrawer.childContextTypes = {
	    closeIconClassName: _react.PropTypes.string,
	    closeChildren: _react.PropTypes.node,
	    onCloseClick: _react.PropTypes.func,
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
	    label: _react.PropTypes.string.isRequired,
	    renderNode: _react.PropTypes.object
	  };
	  NavigationDrawer.defaultProps = {
	    autoclose: _Drawer2.default.defaultProps.autoclose,
	    contentId: 'main-content',
	    // Defaults to false since it keeps the state of the drawerType in sync and makes the Drawer
	    // controlled. On initial mount without any defaultMedia updates, it would always be considered
	    // temporary
	    constantDrawerType: false,
	    jumpLabel: 'Jump to content',
	    extractMini: true,
	    position: _Drawer2.default.defaultProps.position,
	    defaultMedia: _Drawer2.default.defaultProps.defaultMedia,
	    mobileDrawerType: _Drawer2.default.defaultProps.mobileType,
	    tabletDrawerType: _Drawer2.default.defaultProps.tabletType,
	    desktopDrawerType: _Drawer2.default.defaultProps.desktopType,
	    mobileMinWidth: _Drawer2.default.defaultProps.mobileMinWidth,
	    tabletMinWidth: _Drawer2.default.defaultProps.tabletMinWidth,
	    desktopMinWidth: _Drawer2.default.defaultProps.desktopMinWidth,
	    includeDrawerHeader: true,
	    contentComponent: 'main',
	    temporaryIconChildren: 'menu',
	    toolbarThemeType: 'colored',
	    persistentIconChildren: 'arrow_back',
	    transitionName: 'md-cross-fade',
	    transitionEnterTimeout: 300,
	    drawerTransitionDuration: _Drawer2.default.defaultProps.transitionDuration
	  };
	  exports.default = NavigationDrawer;
	});

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(26)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Paper'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Paper);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Paper) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Paper2.default;
	});

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.CalendarDate = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CalendarDate = function (_PureComponent) {
	    _inherits(CalendarDate, _PureComponent);
	
	    function CalendarDate(props) {
	      _classCallCheck(this, CalendarDate);
	
	      var _this = _possibleConstructorReturn(this, (CalendarDate.__proto__ || Object.getPrototypeOf(CalendarDate)).call(this, props));
	
	      _this.state = _this._getFormattedDate(props);
	      _this.state.desktopActive = false;
	      _this._handleClick = _this._handleClick.bind(_this);
	      _this._setActive = _this._setActive.bind(_this);
	      _this._setInactive = _this._setInactive.bind(_this);
	      _this._setFocus = _this._setFocus.bind(_this);
	      return _this;
	    }
	
	    _createClass(CalendarDate, [{
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps) {
	        var _props = this.props,
	            DateTimeFormat = _props.DateTimeFormat,
	            locales = _props.locales,
	            date = _props.date;
	
	        if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
	          this.setState(this._getFormattedDate(nextProps));
	        }
	      }
	    }, {
	      key: '_setFocus',
	      value: function _setFocus(btn) {
	        if (btn && this.props.active) {
	          btn.focus();
	        }
	      }
	    }, {
	      key: '_getFormattedDate',
	      value: function _getFormattedDate(_ref) {
	        var DateTimeFormat = _ref.DateTimeFormat,
	            locales = _ref.locales,
	            date = _ref.date;
	
	        return {
	          date: new DateTimeFormat(locales, { day: 'numeric' }).format(date)
	        };
	      }
	    }, {
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        this.props.onClick(new Date(this.props.date), e);
	      }
	    }, {
	      key: '_setActive',
	      value: function _setActive() {
	        if (!this.props.disabled) {
	          this.setState({ desktopActive: true });
	        }
	      }
	    }, {
	      key: '_setInactive',
	      value: function _setInactive() {
	        if (!this.props.disabled) {
	          this.setState({ desktopActive: false });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            date = _state.date,
	            desktopActive = _state.desktopActive;
	        var _props2 = this.props,
	            disabled = _props2.disabled,
	            active = _props2.active,
	            today = _props2.today,
	            className = _props2.className;
	
	
	        var fullyActive = today && !active && !desktopActive;
	        return _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            ref: this._setFocus,
	            onFocus: this._setActive,
	            onBlur: this._setInactive,
	            onMouseOver: this._setActive,
	            onMouseLeave: this._setInactive,
	            className: (0, _classnames2.default)('md-btn md-calendar-date md-calendar-date--btn', {
	              'md-text--disabled': disabled,
	              'md-pointer--hover': !disabled,
	              'md-text--theme-primary': fullyActive,
	              'md-calendar-date--btn-active': active || desktopActive
	            }, className),
	            onClick: this._handleClick,
	            disabled: disabled
	          },
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)('md-calendar-date--date', {
	                'md-picker-text--active': active || desktopActive,
	                'md-font-bold': fullyActive
	              })
	            },
	            date
	          )
	        );
	      }
	    }]);
	
	    return CalendarDate;
	  }(_react.PureComponent);
	
	  CalendarDate.propTypes = {
	    className: _react.PropTypes.string,
	    date: _react.PropTypes.instanceOf(Date).isRequired,
	    DateTimeFormat: _react.PropTypes.func.isRequired,
	    locales: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]).isRequired,
	    disabled: _react.PropTypes.bool,
	    onClick: _react.PropTypes.func.isRequired,
	    active: _react.PropTypes.bool,
	    today: _react.PropTypes.bool
	  };
	  exports.default = CalendarDate;
	});

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(510), __webpack_require__(222), __webpack_require__(132), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../utils/DateUtils/isMonthBefore'), require('../utils/DateUtils/getDayOfWeek'), require('../utils/DateUtils/addDate'), require('../Buttons/Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.isMonthBefore, global.getDayOfWeek, global.addDate, global.Button);
	    global.CalendarHeader = mod.exports;
	  }
	})(this, function (exports, _react, _isMonthBefore, _getDayOfWeek, _addDate, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _isMonthBefore2 = _interopRequireDefault(_isMonthBefore);
	
	  var _getDayOfWeek2 = _interopRequireDefault(_getDayOfWeek);
	
	  var _addDate2 = _interopRequireDefault(_addDate);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CalendarHeader = function (_PureComponent) {
	    _inherits(CalendarHeader, _PureComponent);
	
	    function CalendarHeader(props) {
	      _classCallCheck(this, CalendarHeader);
	
	      var _this = _possibleConstructorReturn(this, (CalendarHeader.__proto__ || Object.getPrototypeOf(CalendarHeader)).call(this, props));
	
	      _this.state = _this._createState(props);
	      return _this;
	    }
	
	    _createClass(CalendarHeader, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            DateTimeFormat = _props.DateTimeFormat,
	            locales = _props.locales,
	            date = _props.date;
	
	        if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || date !== nextProps.date) {
	          this.setState(this._createState(nextProps));
	        }
	      }
	    }, {
	      key: '_createState',
	      value: function _createState() {
	        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props,
	            DateTimeFormat = _ref.DateTimeFormat,
	            locales = _ref.locales,
	            date = _ref.date;
	
	        var sunday = (0, _getDayOfWeek2.default)(date, 0);
	        var formatter = new DateTimeFormat(locales, { weekday: 'narrow' });
	        var dows = [];
	        for (var i = 0; i < 7; i++) {
	          var dow = formatter.format((0, _addDate2.default)(sunday, i, 'D'));
	          dows.push(_react2.default.createElement(
	            'h4',
	            { className: 'md-calendar-date md-text--disabled md-calendar-dow', key: i },
	            dow
	          ));
	        }
	
	        return {
	          dows: dows,
	          title: new DateTimeFormat(locales, { month: 'long', year: 'numeric' }).format(date)
	        };
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            dows = _state.dows,
	            title = _state.title;
	        var _props2 = this.props,
	            date = _props2.date,
	            minDate = _props2.minDate,
	            maxDate = _props2.maxDate,
	            onPreviousClick = _props2.onPreviousClick,
	            previousIconChildren = _props2.previousIconChildren,
	            previousIconClassName = _props2.previousIconClassName,
	            onNextClick = _props2.onNextClick,
	            nextIconChildren = _props2.nextIconChildren,
	            nextIconClassName = _props2.nextIconClassName;
	
	
	        var isPreviousDisabled = (0, _isMonthBefore2.default)(minDate, date);
	        var isNextDisabled = (0, _isMonthBefore2.default)(date, maxDate);
	        return _react2.default.createElement(
	          'header',
	          { className: 'md-calendar-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'md-calendar-controls' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                icon: true,
	                onClick: onPreviousClick,
	                disabled: isPreviousDisabled,
	                className: 'md-calendar-control',
	                iconClassName: previousIconClassName
	              },
	              previousIconChildren
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: 'md-title' },
	              title
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                icon: true,
	                onClick: onNextClick,
	                disabled: isNextDisabled,
	                className: 'md-calendar-control',
	                iconClassName: nextIconClassName
	              },
	              nextIconChildren
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'md-calendar-dows' },
	            dows
	          )
	        );
	      }
	    }]);
	
	    return CalendarHeader;
	  }(_react.PureComponent);
	
	  CalendarHeader.propTypes = {
	    className: _react.PropTypes.string,
	    children: _react.PropTypes.node,
	    date: _react.PropTypes.instanceOf(Date).isRequired,
	    minDate: _react.PropTypes.instanceOf(Date),
	    maxDate: _react.PropTypes.instanceOf(Date),
	    previousIconChildren: _react.PropTypes.node,
	    previousIconClassName: _react.PropTypes.string,
	    onPreviousClick: _react.PropTypes.func.isRequired,
	    nextIconChildren: _react.PropTypes.node,
	    nextIconClassName: _react.PropTypes.string,
	    onNextClick: _react.PropTypes.func.isRequired,
	    DateTimeFormat: _react.PropTypes.func.isRequired,
	    locales: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]).isRequired
	  };
	  exports.default = CalendarHeader;
	});

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(132), __webpack_require__(223), __webpack_require__(508), __webpack_require__(222), __webpack_require__(448)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../utils/DateUtils/addDate'), require('../utils/DateUtils/stripTime'), require('../utils/DateUtils/getLastDay'), require('../utils/DateUtils/getDayOfWeek'), require('./CalendarDate'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.addDate, global.stripTime, global.getLastDay, global.getDayOfWeek, global.CalendarDate);
	    global.CalendarMonth = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _addDate, _stripTime, _getLastDay, _getDayOfWeek, _CalendarDate) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _addDate2 = _interopRequireDefault(_addDate);
	
	  var _stripTime2 = _interopRequireDefault(_stripTime);
	
	  var _getLastDay2 = _interopRequireDefault(_getLastDay);
	
	  var _getDayOfWeek2 = _interopRequireDefault(_getDayOfWeek);
	
	  var _CalendarDate2 = _interopRequireDefault(_CalendarDate);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CalendarMonth = function (_PureComponent) {
	    _inherits(CalendarMonth, _PureComponent);
	
	    function CalendarMonth() {
	      _classCallCheck(this, CalendarMonth);
	
	      return _possibleConstructorReturn(this, (CalendarMonth.__proto__ || Object.getPrototypeOf(CalendarMonth)).apply(this, arguments));
	    }
	
	    _createClass(CalendarMonth, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            calendarDate = _props.calendarDate,
	            calendarTempDate = _props.calendarTempDate,
	            onCalendarDateClick = _props.onCalendarDateClick,
	            minDate = _props.minDate,
	            maxDate = _props.maxDate,
	            DateTimeFormat = _props.DateTimeFormat,
	            locales = _props.locales,
	            className = _props.className,
	            props = _objectWithoutProperties(_props, ['calendarDate', 'calendarTempDate', 'onCalendarDateClick', 'minDate', 'maxDate', 'DateTimeFormat', 'locales', 'className']);
	
	        var days = [];
	        var currentDate = (0, _stripTime2.default)((0, _getDayOfWeek2.default)(new Date(calendarDate).setDate(1), 0));
	        var endDate = (0, _stripTime2.default)((0, _getDayOfWeek2.default)((0, _getLastDay2.default)(calendarDate), 6));
	        var activeDate = (0, _stripTime2.default)(new Date(calendarTempDate));
	        var today = (0, _stripTime2.default)(new Date());
	
	        while (currentDate <= endDate) {
	          var key = currentDate.getMonth() + '-' + currentDate.getDate();
	
	          var date = void 0;
	          if (currentDate.getMonth() === calendarDate.getMonth()) {
	            var time = currentDate.getTime();
	            var isMinDateDisabled = minDate && minDate.getTime() > time;
	            var isMaxDateDisbaled = maxDate && maxDate.getTime() < time;
	            date = _react2.default.createElement(_CalendarDate2.default, {
	              key: key,
	              today: time === today.getTime(),
	              active: time === activeDate.getTime(),
	              disabled: isMinDateDisabled || isMaxDateDisbaled,
	              onClick: onCalendarDateClick,
	              date: currentDate,
	              DateTimeFormat: DateTimeFormat,
	              locales: locales
	            });
	          } else {
	            date = _react2.default.createElement('div', { key: key, className: 'md-calendar-date' });
	          }
	
	          days.push(date);
	          currentDate = (0, _addDate2.default)(currentDate, 1, 'D');
	        }
	
	        return _react2.default.createElement(
	          'div',
	          _extends({ className: (0, _classnames2.default)('md-calendar-month', className) }, props),
	          days
	        );
	      }
	    }]);
	
	    return CalendarMonth;
	  }(_react.PureComponent);
	
	  CalendarMonth.propTypes = {
	    /**
	     * A className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The current selected date of the calendar. This is
	     * the date after hitting the Ok button or `value` || `defaultValue`.
	     */
	    calendarDate: _react.PropTypes.instanceOf(Date).isRequired,
	
	    /**
	     * The current selected date of the calendar before verifying
	     * the new date.
	     */
	    calendarTempDate: _react.PropTypes.instanceOf(Date).isRequired,
	
	    /**
	     * An optional min date for the calendar. This will disable any
	     * dates that come before this date in the month.
	     */
	    minDate: _react.PropTypes.instanceOf(Date),
	
	    /**
	     * An optional max date for the calendar. This will disable any
	     * dates that come after this date in the month.
	     */
	    maxDate: _react.PropTypes.instanceOf(Date),
	
	    /**
	     * A function to call that will select a new date.
	     */
	    onCalendarDateClick: _react.PropTypes.func.isRequired,
	    DateTimeFormat: _react.PropTypes.func.isRequired,
	    locales: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]).isRequired
	  };
	  exports.default = CalendarMonth;
	});

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(133), __webpack_require__(67), __webpack_require__(511), __webpack_require__(229), __webpack_require__(453), __webpack_require__(452)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../utils/EventUtils/isValidClick'), require('../utils/EventUtils/captureNextEvent'), require('../utils/NumberUtils/calcTimeFromPoint'), require('../utils/calcPageOffset'), require('./ClockTime'), require('./ClockHand'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.isValidClick, global.captureNextEvent, global.calcTimeFromPoint, global.calcPageOffset, global.ClockTime, global.ClockHand);
	    global.ClockFace = mod.exports;
	  }
	})(this, function (exports, _react, _isValidClick, _captureNextEvent, _calcTimeFromPoint, _calcPageOffset, _ClockTime, _ClockHand) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	  var _calcTimeFromPoint2 = _interopRequireDefault(_calcTimeFromPoint);
	
	  var _calcPageOffset2 = _interopRequireDefault(_calcPageOffset);
	
	  var _ClockTime2 = _interopRequireDefault(_ClockTime);
	
	  var _ClockHand2 = _interopRequireDefault(_ClockHand);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var ClockFace = function (_PureComponent) {
	    _inherits(ClockFace, _PureComponent);
	
	    function ClockFace(props) {
	      _classCallCheck(this, ClockFace);
	
	      var _this = _possibleConstructorReturn(this, (ClockFace.__proto__ || Object.getPrototypeOf(ClockFace)).call(this, props));
	
	      _this.state = { radius: 136, moving: false };
	      _this._center = {};
	      _this._setFace = _this._setFace.bind(_this);
	      _this._calcNewTime = _this._calcNewTime.bind(_this);
	      _this._handleMouseUp = _this._handleMouseUp.bind(_this);
	      _this._handleMouseDown = _this._handleMouseDown.bind(_this);
	      _this._handleMouseMove = _this._handleMouseMove.bind(_this);
	      _this._handleTouchEnd = _this._handleTouchEnd.bind(_this);
	      _this._handleTouchMove = _this._handleTouchMove.bind(_this);
	      _this._handleTouchStart = _this._handleTouchStart.bind(_this);
	      return _this;
	    }
	
	    _createClass(ClockFace, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('mousemove', this._handleMouseMove);
	        window.removeEventListener('mouseup', this._handleMouseMove);
	        window.removeEventListener('touchmove', this._handleTouchMove);
	        window.removeEventListener('touchend', this._handleTouchEnd);
	      }
	    }, {
	      key: '_setFace',
	      value: function _setFace(face) {
	        this._face = face;
	
	        if (face !== null) {
	          var radius = face.offsetWidth / 2;
	          var offset = (0, _calcPageOffset2.default)(face);
	          this._center = { x: offset.left + radius, y: offset.top + radius };
	          this._left = offset.left;
	          this._top = offset.top;
	          this.setState({ radius: radius });
	        }
	      }
	    }, {
	      key: '_handleMouseDown',
	      value: function _handleMouseDown(e) {
	        if (!(0, _isValidClick2.default)(e)) {
	          return;
	        }
	
	        window.addEventListener('mousemove', this._handleMouseMove);
	        window.addEventListener('mouseup', this._handleMouseUp);
	        this.setState({ moving: true });
	      }
	    }, {
	      key: '_handleMouseMove',
	      value: function _handleMouseMove(e) {
	        if (!this.state.moving) {
	          return;
	        }
	
	        e.preventDefault();
	        this._calcNewTime(e);
	      }
	    }, {
	      key: '_handleMouseUp',
	      value: function _handleMouseUp(e) {
	        if (!(0, _isValidClick2.default)(e)) {
	          return;
	        }
	
	        if (this._face && !this._face.contains(e.target)) {
	          (0, _captureNextEvent2.default)('click');
	        }
	
	        window.removeEventListener('mousemove', this._handleMouseMove);
	        window.removeEventListener('mouseup', this._handleMouseUp);
	
	        this._calcNewTime(e);
	        this.setState({ moving: false });
	      }
	    }, {
	      key: '_handleTouchStart',
	      value: function _handleTouchStart() {
	        (0, _captureNextEvent2.default)('mousedown');
	
	        window.addEventListener('touchmove', this._handleTouchMove);
	        window.addEventListener('touchend', this._handleTouchEnd);
	        this.setState({ moving: true });
	      }
	    }, {
	      key: '_handleTouchMove',
	      value: function _handleTouchMove(e) {
	        if (!this.state.moving) {
	          return;
	        }
	        e.preventDefault();
	
	        this._calcNewTime(e);
	      }
	    }, {
	      key: '_handleTouchEnd',
	      value: function _handleTouchEnd(e) {
	        this._calcNewTime(e);
	        if (this._face && !this._face.contains(e.target)) {
	          (0, _captureNextEvent2.default)('click');
	        }
	
	        window.removeEventListener('touchmove', this._handleTouchMove);
	        window.removeEventListener('touchend', this._handleTouchEnd);
	
	        this.setState({ moving: false });
	      }
	    }, {
	      key: '_calcNewTime',
	      value: function _calcNewTime(e) {
	        var _ref = e.changedTouches ? e.changedTouches[0] : e,
	            x = _ref.pageX,
	            y = _ref.pageY;
	
	        var innerRadius = this.state.radius - 48;
	        var _props = this.props,
	            onChange = _props.onChange,
	            minutes = _props.minutes,
	            timePeriod = _props.timePeriod;
	
	        onChange((0, _calcTimeFromPoint2.default)({ x: x, y: y }, this._center, innerRadius, minutes, timePeriod));
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            time = _props2.time,
	            minutes = _props2.minutes,
	            timePeriod = _props2.timePeriod,
	            onChange = _props2.onChange;
	        var radius = this.state.radius;
	
	        var size = !minutes && !timePeriod ? 24 : 12;
	        var times = Array.apply(null, new Array(size)).map(function (_, i) {
	          var clockTime = i + 1;
	          if (minutes) {
	            clockTime = clockTime * 5 % 60;
	          } else {
	            clockTime %= 24;
	          }
	
	          return _react2.default.createElement(_ClockTime2.default, {
	            key: 'time-' + i,
	            index: i + 1,
	            time: clockTime,
	            active: clockTime === time,
	            radius: radius,
	            onKeyboardFocus: onChange
	          });
	        });
	
	        return _react2.default.createElement(
	          'div',
	          {
	            ref: this._setFace,
	            className: 'md-clock-face md-block-centered md-pointer--hover',
	            onMouseDown: this._handleMouseDown,
	            onTouchStart: this._handleTouchStart
	          },
	          times,
	          _react2.default.createElement(_ClockHand2.default, { time: time, coords: radius, minutes: minutes })
	        );
	      }
	    }]);
	
	    return ClockFace;
	  }(_react.PureComponent);
	
	  ClockFace.propTypes = {
	    /**
	     * The current time for the clock.
	     */
	    time: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if the clock is on the minutes view.
	     */
	    minutes: _react.PropTypes.bool.isRequired,
	
	    /**
	     * A function to call when a new time is selected. It gives the
	     * new time value. If it is 12 o'clock, 0 will be given.
	     */
	    onChange: _react.PropTypes.func.isRequired,
	
	    /**
	     * An optional time period string. This should be either AM or PM
	     * if the locale uses them.
	     */
	    timePeriod: _react.PropTypes.string
	  };
	  exports.default = ClockFace;
	});

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.ClockHand = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var ClockHand = function (_PureComponent) {
	    _inherits(ClockHand, _PureComponent);
	
	    function ClockHand(props) {
	      _classCallCheck(this, ClockHand);
	
	      var _this = _possibleConstructorReturn(this, (ClockHand.__proto__ || Object.getPrototypeOf(ClockHand)).call(this, props));
	
	      _this.state = { active: false };
	      return _this;
	    }
	
	    _createClass(ClockHand, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (this.props.minutes !== nextProps.minutes) {
	          if (this.state.timeout) {
	            clearTimeout(this.state.timeout);
	          }
	
	          this.setState({
	            active: true,
	            timeout: setTimeout(function () {
	              return _this2.setState({ active: false, timeout: null });
	            }, 150)
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.state.timeout) {
	          clearTimeout(this.state.timeout);
	        }
	      }
	    }, {
	      key: '_calcCurrentDegrees',
	      value: function _calcCurrentDegrees(_ref) {
	        var time = _ref.time,
	            minutes = _ref.minutes;
	
	        var timeAt0Deg = minutes ? 15 : 3;
	        var sectors = minutes ? 60 : 12;
	
	        return (time % sectors - timeAt0Deg) * (360 / sectors);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            coords = _props.coords,
	            time = _props.time,
	            minutes = _props.minutes;
	
	
	        var degrees = this._calcCurrentDegrees(this.props);
	        var invisibleMinute = false;
	        if (minutes) {
	          invisibleMinute = degrees % (360 / 12) !== 0;
	        }
	
	        var rotateTransform = 'rotate3d(0, 0, 1, ' + degrees + 'deg)';
	        return _react2.default.createElement('div', {
	          className: (0, _classnames2.default)('md-clock-hand md-background--primary', {
	            'md-clock-hand--active': this.state.active,
	            'md-clock-hand--minute-hover': invisibleMinute,
	            'md-clock-hand--inner': !minutes && (time > 12 || time === 0)
	          }),
	          style: {
	            left: coords,
	            top: coords,
	            WebkitTransform: rotateTransform,
	            MozTransform: rotateTransform,
	            msTransform: rotateTransform,
	            transform: rotateTransform
	          }
	        });
	      }
	    }]);
	
	    return ClockHand;
	  }(_react.PureComponent);
	
	  ClockHand.propTypes = {
	    /**
	     * This is the x and y coordinate to use for the center of the `ClockFace`.
	     * This should really be whatever the radius of the `ClockFace` is.
	     */
	    coords: _react.PropTypes.number,
	
	    /**
	     * The current time of the clock.
	     */
	    time: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if the clock is displaying minutes instead of hours.
	     */
	    minutes: _react.PropTypes.bool.isRequired
	  };
	  exports.default = ClockHand;
	});

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../constants/keyCodes'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.keyCodes);
	    global.ClockTime = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _keyCodes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CLOCK_PADDING = 4;
	
	  /**
	   * The `ClockTime` component is used for positioning hours or minutes
	   * in a clock. The time will be positioned based on it's given index
	   * and the radius of the clock.
	   */
	
	  var ClockTime = function (_PureComponent) {
	    _inherits(ClockTime, _PureComponent);
	
	    function ClockTime(props) {
	      _classCallCheck(this, ClockTime);
	
	      var _this = _possibleConstructorReturn(this, (ClockTime.__proto__ || Object.getPrototypeOf(ClockTime)).call(this, props));
	
	      _this.state = {
	        // default size in scss
	        size: 18
	      };
	
	      _this._setTime = _this._setTime.bind(_this);
	      _this._setPosition = _this._setPosition.bind(_this);
	      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	      return _this;
	    }
	
	    _createClass(ClockTime, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.radius !== nextProps.radius || this.props.index !== nextProps.index) {
	          this._setPosition(nextProps, this._time);
	        }
	      }
	    }, {
	      key: '_handleKeyUp',
	      value: function _handleKeyUp(e) {
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          this.props.onKeyboardFocus(this.props.time);
	        }
	      }
	    }, {
	      key: '_setTime',
	      value: function _setTime(time) {
	        this._time = time;
	        if (time !== null) {
	          this._setPosition(this.props, time);
	
	          if (this.props.active) {
	            time.focus();
	          }
	        }
	      }
	    }, {
	      key: '_setPosition',
	      value: function _setPosition(_ref, time) {
	        var radius = _ref.radius,
	            index = _ref.index;
	
	        // 36 is default size for the time
	        var size = (time.offsetWidth || 36) / 2;
	        var timeRadians = Math.PI / 2 - index * (Math.PI / 6);
	        var innerCircle = index > 12;
	
	        var outerRadius = radius - size;
	        var innerRadius = outerRadius - CLOCK_PADDING - (innerCircle ? size * 2 : 0);
	
	        this.setState({
	          style: {
	            top: outerRadius - innerRadius * Math.sin(timeRadians),
	            left: outerRadius + innerRadius * Math.cos(timeRadians)
	          }
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            time = _props.time,
	            active = _props.active;
	
	        return _react2.default.createElement(
	          'div',
	          {
	            ref: this._setTime,
	            tabIndex: 0,
	            className: (0, _classnames2.default)('md-clock-time md-text-no-select md-pointer--none', {
	              'md-text': !active,
	              'md-picker-text--active': active
	            }),
	            style: this.state.style,
	            onKeyUp: this._handleKeyUp
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'md-clock-time-value' },
	            time
	          )
	        );
	      }
	    }]);
	
	    return ClockTime;
	  }(_react.PureComponent);
	
	  ClockTime.propTypes = {
	    /**
	     * The index of the current time to be displayed. This
	     * should be a number between 1 and 24.
	     */
	    index: _react.PropTypes.number.isRequired,
	
	    /**
	     * The time number to display.
	     */
	    time: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if this time is currently selected.
	     */
	    active: _react.PropTypes.bool.isRequired,
	
	    /**
	     * The radius of the clock.
	     */
	    radius: _react.PropTypes.number.isRequired,
	
	    onKeyboardFocus: _react.PropTypes.func.isRequired
	  };
	  exports.default = ClockTime;
	});

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(63), __webpack_require__(457), __webpack_require__(455), __webpack_require__(463)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Dialogs/DialogFooter'), require('./DatePickerHeader'), require('./DatePickerCalendar'), require('./YearPicker'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.DialogFooter, global.DatePickerHeader, global.DatePickerCalendar, global.YearPicker);
	    global.DatePicker = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _DialogFooter, _DatePickerHeader, _DatePickerCalendar, _YearPicker) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	  var _DatePickerHeader2 = _interopRequireDefault(_DatePickerHeader);
	
	  var _DatePickerCalendar2 = _interopRequireDefault(_DatePickerCalendar);
	
	  var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var DatePicker = function (_PureComponent) {
	    _inherits(DatePicker, _PureComponent);
	
	    function DatePicker() {
	      _classCallCheck(this, DatePicker);
	
	      return _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
	    }
	
	    _createClass(DatePicker, [{
	      key: 'render',
	      value: function render() {
	        var _cn;
	
	        var _props = this.props,
	            okLabel = _props.okLabel,
	            okPrimary = _props.okPrimary,
	            onOkClick = _props.onOkClick,
	            cancelLabel = _props.cancelLabel,
	            cancelPrimary = _props.cancelPrimary,
	            onCancelClick = _props.onCancelClick,
	            DateTimeFormat = _props.DateTimeFormat,
	            locales = _props.locales,
	            calendarTempDate = _props.calendarTempDate,
	            calendarMode = _props.calendarMode,
	            changeCalendarMode = _props.changeCalendarMode,
	            style = _props.style,
	            className = _props.className,
	            inline = _props.inline,
	            icon = _props.icon,
	            displayMode = _props.displayMode,
	            props = _objectWithoutProperties(_props, ['okLabel', 'okPrimary', 'onOkClick', 'cancelLabel', 'cancelPrimary', 'onCancelClick', 'DateTimeFormat', 'locales', 'calendarTempDate', 'calendarMode', 'changeCalendarMode', 'style', 'className', 'inline', 'icon', 'displayMode']);
	
	        var picker = void 0;
	        if (calendarMode === 'calendar') {
	          picker = _react2.default.createElement(_DatePickerCalendar2.default, _extends({}, props, {
	            key: 'calendar',
	            calendarTempDate: calendarTempDate,
	            DateTimeFormat: DateTimeFormat,
	            locales: locales
	          }));
	        } else {
	          picker = _react2.default.createElement(_YearPicker2.default, _extends({}, props, {
	            key: 'year',
	            calendarTempDate: calendarTempDate,
	            DateTimeFormat: DateTimeFormat,
	            locales: locales
	          }));
	        }
	
	        var actions = [{
	          key: cancelLabel,
	          onClick: onCancelClick,
	          primary: cancelPrimary,
	          secondary: !cancelPrimary,
	          label: cancelLabel
	        }, {
	          key: okLabel,
	          onClick: onOkClick,
	          primary: okPrimary,
	          secondary: !okPrimary,
	          label: okLabel
	        }];
	
	        return _react2.default.createElement(
	          'div',
	          {
	            style: style,
	            className: (0, _classnames2.default)('md-picker md-picker--date', (_cn = {}, _defineProperty(_cn, 'md-picker--' + displayMode, displayMode), _defineProperty(_cn, 'md-picker--inline', inline), _defineProperty(_cn, 'md-picker--inline-icon', inline && icon), _cn), className)
	          },
	          _react2.default.createElement(_DatePickerHeader2.default, {
	            DateTimeFormat: DateTimeFormat,
	            locales: locales,
	            calendarTempDate: calendarTempDate,
	            calendarMode: calendarMode,
	            changeCalendarMode: changeCalendarMode
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'md-picker-content-container' },
	            picker,
	            _react2.default.createElement(_DialogFooter2.default, { actions: actions })
	          )
	        );
	      }
	    }]);
	
	    return DatePicker;
	  }(_react.PureComponent);
	
	  DatePicker.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    okLabel: _react.PropTypes.string.isRequired,
	    okPrimary: _react.PropTypes.bool.isRequired,
	    onOkClick: _react.PropTypes.func.isRequired,
	    cancelLabel: _react.PropTypes.string.isRequired,
	    cancelPrimary: _react.PropTypes.bool.isRequired,
	    onCancelClick: _react.PropTypes.func.isRequired,
	    DateTimeFormat: _react.PropTypes.func.isRequired,
	    locales: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]).isRequired,
	    calendarDate: _react.PropTypes.instanceOf(Date).isRequired,
	    calendarTempDate: _react.PropTypes.instanceOf(Date).isRequired,
	    calendarMode: _react.PropTypes.oneOf(['calendar', 'year']).isRequired,
	    changeCalendarMode: _react.PropTypes.func.isRequired,
	    icon: _react.PropTypes.bool,
	    inline: _react.PropTypes.bool,
	    displayMode: _react.PropTypes.oneOf(['landscape', 'portrait'])
	  };
	  exports.default = DatePicker;
	});

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(450), __webpack_require__(449)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('./CalendarMonth'), require('./CalendarHeader'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.CalendarMonth, global.CalendarHeader);
	    global.DatePickerCalendar = mod.exports;
	  }
	})(this, function (exports, _react, _CalendarMonth, _CalendarHeader) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	  var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var DatePickerCalendar = function (_PureComponent) {
	    _inherits(DatePickerCalendar, _PureComponent);
	
	    function DatePickerCalendar() {
	      _classCallCheck(this, DatePickerCalendar);
	
	      return _possibleConstructorReturn(this, (DatePickerCalendar.__proto__ || Object.getPrototypeOf(DatePickerCalendar)).apply(this, arguments));
	    }
	
	    _createClass(DatePickerCalendar, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            previousIconChildren = _props.previousIconChildren,
	            previousIconClassName = _props.previousIconClassName,
	            onPreviousClick = _props.onPreviousClick,
	            nextIconChildren = _props.nextIconChildren,
	            nextIconClassName = _props.nextIconClassName,
	            onNextClick = _props.onNextClick,
	            calendarDate = _props.calendarDate,
	            calendarTempDate = _props.calendarTempDate,
	            onCalendarDateClick = _props.onCalendarDateClick,
	            DateTimeFormat = _props.DateTimeFormat,
	            locales = _props.locales,
	            minDate = _props.minDate,
	            maxDate = _props.maxDate;
	
	
	        return _react2.default.createElement(
	          'section',
	          { className: 'md-picker-content md-picker-content--calendar' },
	          _react2.default.createElement(_CalendarHeader2.default, {
	            date: calendarDate,
	            minDate: minDate,
	            maxDate: maxDate,
	            DateTimeFormat: DateTimeFormat,
	            locales: locales,
	            onPreviousClick: onPreviousClick,
	            previousIconChildren: previousIconChildren,
	            previousIconClassName: previousIconClassName,
	            onNextClick: onNextClick,
	            nextIconChildren: nextIconChildren,
	            nextIconClassName: nextIconClassName
	          }),
	          _react2.default.createElement(_CalendarMonth2.default, {
	            key: new DateTimeFormat(locales).format(calendarDate),
	            calendarDate: calendarDate,
	            calendarTempDate: calendarTempDate,
	            onCalendarDateClick: onCalendarDateClick,
	            minDate: minDate,
	            maxDate: maxDate,
	            DateTimeFormat: DateTimeFormat,
	            locales: locales
	          })
	        );
	      }
	    }]);
	
	    return DatePickerCalendar;
	  }(_react.PureComponent);
	
	  DatePickerCalendar.propTypes = {
	    previousIconChildren: _react.PropTypes.node,
	    previousIconClassName: _react.PropTypes.string,
	    onPreviousClick: _react.PropTypes.func.isRequired,
	    nextIconChildren: _react.PropTypes.node,
	    nextIconClassName: _react.PropTypes.string,
	    onNextClick: _react.PropTypes.func.isRequired,
	    onCalendarDateClick: _react.PropTypes.func.isRequired,
	    calendarDate: _react.PropTypes.instanceOf(Date).isRequired,
	    calendarTempDate: _react.PropTypes.instanceOf(Date).isRequired,
	    DateTimeFormat: _react.PropTypes.func.isRequired,
	    locales: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]).isRequired,
	    minDate: _react.PropTypes.instanceOf(Date),
	    maxDate: _react.PropTypes.instanceOf(Date)
	  };
	  exports.default = DatePickerCalendar;
	});

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(13), __webpack_require__(8), __webpack_require__(11), __webpack_require__(12), __webpack_require__(14), __webpack_require__(509), __webpack_require__(132), __webpack_require__(220), __webpack_require__(38), __webpack_require__(18), __webpack_require__(52), __webpack_require__(123), __webpack_require__(454)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('react-prop-types/lib/deprecated'), require('../constants/keyCodes'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../utils/DateUtils/isDateEqual'), require('../utils/DateUtils/addDate'), require('../utils/DateUtils/DateTimeFormat'), require('../Helpers/Collapse'), require('../FontIcons/FontIcon'), require('../TextFields/TextField'), require('../Dialogs/DialogContainer'), require('./DatePicker'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.isRequiredForA11y, global.deprecated, global.keyCodes, global.getField, global.controlled, global.isDateEqual, global.addDate, global.DateTimeFormat, global.Collapse, global.FontIcon, global.TextField, global.DialogContainer, global.DatePicker);
	    global.DatePickerContainer = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _isRequiredForA11y, _deprecated, _keyCodes, _getField, _controlled, _isDateEqual, _addDate, _DateTimeFormat, _Collapse, _FontIcon, _TextField, _DialogContainer, _DatePicker) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _isDateEqual2 = _interopRequireDefault(_isDateEqual);
	
	  var _addDate2 = _interopRequireDefault(_addDate);
	
	  var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);
	
	  var _Collapse2 = _interopRequireDefault(_Collapse);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  var _TextField2 = _interopRequireDefault(_TextField);
	
	  var _DialogContainer2 = _interopRequireDefault(_DialogContainer);
	
	  var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var DatePickerContainer = function (_PureComponent) {
	    _inherits(DatePickerContainer, _PureComponent);
	
	    function DatePickerContainer(props) {
	      _classCallCheck(this, DatePickerContainer);
	
	      var _this = _possibleConstructorReturn(this, (DatePickerContainer.__proto__ || Object.getPrototypeOf(DatePickerContainer)).call(this, props));
	
	      var date = void 0;
	      var value = void 0;
	      var defaultValue = props.defaultValue,
	          DateTimeFormat = props.DateTimeFormat,
	          locales = props.locales,
	          formatOptions = props.formatOptions,
	          initialCalendarDate = props.initialCalendarDate,
	          minDate = props.minDate,
	          maxDate = props.maxDate;
	
	      if (typeof props.value !== 'undefined' && props.value !== null) {
	        date = typeof props.value === 'string' ? new Date(props.value) : props.value;
	      } else if (defaultValue) {
	        date = typeof defaultValue === 'string' ? new Date(defaultValue) : defaultValue;
	        value = typeof defaultValue === 'string' ? defaultValue : DateTimeFormat(locales, formatOptions).format(defaultValue);
	      } else {
	        date = new Date();
	      }
	
	      date = _this._validateDateRange(date, minDate, maxDate);
	
	      var calendarTempDate = date;
	      if (typeof initialCalendarDate !== 'undefined' && !props.value && !props.defaultValue) {
	        calendarTempDate = typeof initialCalendarDate === 'string' ? new Date(initialCalendarDate) : initialCalendarDate;
	        date = calendarTempDate;
	      } else if (calendarTempDate === null) {
	        calendarTempDate = new Date();
	        date = new Date();
	      }
	
	      var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;
	
	      _this.state = {
	        value: value,
	        visible: visible,
	        calendarDate: date,
	        calendarTempDate: calendarTempDate,
	        calendarMode: props.initialCalendarMode || props.defaultCalendarMode
	      };
	
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._toggleOpen = _this._toggleOpen.bind(_this);
	      _this._closeOnEsc = _this._closeOnEsc.bind(_this);
	      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
	      _this._handleOkClick = _this._handleOkClick.bind(_this);
	      _this._handleCancelClick = _this._handleCancelClick.bind(_this);
	      _this._changeCalendarMode = _this._changeCalendarMode.bind(_this);
	      _this._nextMonth = _this._nextMonth.bind(_this);
	      _this._previousMonth = _this._previousMonth.bind(_this);
	      _this._setCalendarTempDate = _this._setCalendarTempDate.bind(_this);
	      _this._setCalendarTempYear = _this._setCalendarTempYear.bind(_this);
	      _this._validateDateRange = _this._validateDateRange.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      return _this;
	    }
	
	    _createClass(DatePickerContainer, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var value = nextProps.value,
	            minDate = nextProps.minDate,
	            maxDate = nextProps.maxDate;
	
	        var minEqual = (0, _isDateEqual2.default)(this.props.minDate, minDate);
	        var maxEqual = (0, _isDateEqual2.default)(this.props.maxDate, maxDate);
	        if (this.props.value !== value || !minEqual || !maxEqual) {
	          var calendarDate = this.state.calendarDate;
	
	          if (typeof value !== 'undefined') {
	            calendarDate = typeof value === 'string' ? new Date(value) : value;
	          }
	
	          calendarDate = this._validateDateRange(calendarDate, minDate, maxDate);
	
	          if (!(0, _isDateEqual2.default)(this.state.calendarDate, calendarDate)) {
	            this.setState({ calendarDate: calendarDate, calendarTempDate: calendarDate });
	          }
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var _props = this.props,
	            inline = _props.inline,
	            isOpen = _props.isOpen;
	
	        var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	        var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');
	
	        if (visible === pVisible) {
	          return;
	        }
	
	        if (visible) {
	          if (inline) {
	            window.addEventListener('click', this._handleOutsideClick);
	            window.addEventListener('keydown', this._closeOnEsc);
	          }
	        } else if (inline) {
	          window.removeEventListener('click', this._handleOutsideClick);
	          window.removeEventListener('keydown', this._closeOnEsc);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	        if (visible && this.props.inline) {
	          window.removeEventListener('click', this._handleOutsideClick);
	          window.removeEventListener('keydown', this._closeOnEsc);
	        }
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        this._container = container;
	      }
	    }, {
	      key: '_closeOnEsc',
	      value: function _closeOnEsc(e) {
	        if ((e.which || e.keyCode) === _keyCodes.ESC) {
	          this._handleCancelClick(e);
	        }
	      }
	    }, {
	      key: '_handleOutsideClick',
	      value: function _handleOutsideClick(e) {
	        if (this._container && !this._container.contains(e.target)) {
	          this._handleCancelClick(e);
	        }
	      }
	    }, {
	      key: '_toggleOpen',
	      value: function _toggleOpen(e) {
	        if (this.props.disabled) {
	          return;
	        }
	
	        var visible = !(typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible'));
	
	        if (this.props.onVisibilityChange) {
	          this.props.onVisibilityChange(visible, e);
	        }
	
	        if (typeof this.props.isOpen === 'undefined' && typeof this.props.visible === 'undefined') {
	          this.setState({ visible: visible });
	        }
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        if ((e.which || e.keyCode) === _keyCodes.ENTER) {
	          this._toggleOpen(e);
	        }
	      }
	    }, {
	      key: '_handleOkClick',
	      value: function _handleOkClick(e) {
	        var _props2 = this.props,
	            DateTimeFormat = _props2.DateTimeFormat,
	            locales = _props2.locales,
	            onChange = _props2.onChange,
	            formatOptions = _props2.formatOptions,
	            onVisibilityChange = _props2.onVisibilityChange;
	
	        var value = DateTimeFormat(locales, formatOptions).format(this.state.calendarTempDate);
	        if (onChange) {
	          onChange(value, new Date(this.state.calendarTempDate), e);
	        }
	
	        if (onVisibilityChange) {
	          onVisibilityChange(false, e);
	        }
	
	        var state = void 0;
	        if (typeof this.props.value === 'undefined') {
	          state = { value: value };
	        }
	
	        if (typeof this.props.visible === 'undefined' && typeof this.props.isOpen === 'undefined') {
	          state = state || {};
	          state.visible = false;
	        }
	
	        if (state) {
	          this.setState(state);
	        }
	      }
	    }, {
	      key: '_handleCancelClick',
	      value: function _handleCancelClick(e) {
	        var state = { calendarTempDate: this.state.calendarDate };
	        if (typeof this.props.isOpen === 'undefined' && typeof this.props.isOpen === 'undefined') {
	          state.visible = false;
	        }
	
	        if (this.props.onVisibilityChange) {
	          this.props.onVisibilityChange(false, e);
	        }
	
	        this.setState(state);
	      }
	    }, {
	      key: '_changeCalendarMode',
	      value: function _changeCalendarMode(calendarMode) {
	        if (this.state.calendarMode === calendarMode) {
	          return;
	        }
	
	        this.setState({ calendarMode: calendarMode });
	      }
	    }, {
	      key: '_previousMonth',
	      value: function _previousMonth() {
	        var calendarDate = (0, _addDate2.default)(this.state.calendarDate, -1, 'M');
	        this.setState({ calendarDate: calendarDate });
	      }
	    }, {
	      key: '_nextMonth',
	      value: function _nextMonth() {
	        var calendarDate = (0, _addDate2.default)(this.state.calendarDate, 1, 'M');
	        this.setState({ calendarDate: calendarDate });
	      }
	    }, {
	      key: '_setCalendarTempDate',
	      value: function _setCalendarTempDate(calendarTempDate) {
	        var _this2 = this;
	
	        var _props3 = this.props,
	            autoOk = _props3.autoOk,
	            DateTimeFormat = _props3.DateTimeFormat,
	            locales = _props3.locales,
	            onChange = _props3.onChange,
	            formatOptions = _props3.formatOptions;
	
	
	        var state = { calendarTempDate: calendarTempDate };
	        if (autoOk) {
	          var value = DateTimeFormat(locales, formatOptions).format(calendarTempDate);
	          if (onChange) {
	            onChange(value, new Date(calendarTempDate));
	          }
	
	          if (typeof this.props.value === 'undefined') {
	            state.value = value;
	          }
	
	          this._timeout = setTimeout(function () {
	            _this2._timeout = null;
	
	            if (_this2.props.onVisibilityChange) {
	              _this2.props.onVisibilityChange(false);
	            }
	
	            if (typeof _this2.props.visible === 'undefined' && typeof _this2.props.isOpen === 'undefined') {
	              _this2.setState({ visible: false });
	            }
	          });
	        }
	        this.setState(state);
	      }
	    }, {
	      key: '_setCalendarTempYear',
	      value: function _setCalendarTempYear(year) {
	        var _state = this.state,
	            calendarTempDate = _state.calendarTempDate,
	            calendarDate = _state.calendarDate;
	
	        if (calendarTempDate.getFullYear() === year) {
	          return;
	        }
	
	        var _props4 = this.props,
	            minDate = _props4.minDate,
	            maxDate = _props4.maxDate;
	
	        var nextDate = new Date(calendarDate.setFullYear(year));
	        var nextTemp = new Date(calendarTempDate.setFullYear(year));
	
	        if (minDate && nextTemp < minDate) {
	          nextDate = new Date(minDate);
	          nextTemp = new Date(minDate);
	        }
	
	        if (maxDate && nextTemp > maxDate) {
	          nextDate = new Date(maxDate);
	          nextTemp = new Date(maxDate);
	        }
	
	        this.setState({
	          calendarDate: nextDate,
	          calendarTempDate: nextTemp
	        });
	      }
	    }, {
	      key: '_getFormattedValue',
	      value: function _getFormattedValue(props, state) {
	        var DateTimeFormat = props.DateTimeFormat,
	            locales = props.locales,
	            formatOptions = props.formatOptions;
	
	        var value = (0, _getField2.default)(props, state, 'value');
	        if (!value) {
	          return '';
	        } else if (value instanceof Date) {
	          return DateTimeFormat(locales, formatOptions).format(new Date(value));
	        } else {
	          return value;
	        }
	      }
	    }, {
	      key: '_validateDateRange',
	      value: function _validateDateRange(calendarDate, minDate, maxDate) {
	        var date = calendarDate;
	        if (minDate && minDate > calendarDate) {
	          date = new Date(minDate);
	        }
	
	        if (maxDate && maxDate < calendarDate) {
	          date = new Date(maxDate);
	        }
	
	        return date;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props5 = this.props,
	            style = _props5.style,
	            className = _props5.className,
	            pickerStyle = _props5.pickerStyle,
	            pickerClassName = _props5.pickerClassName,
	            inputStyle = _props5.inputStyle,
	            inputClassName = _props5.inputClassName,
	            textFieldStyle = _props5.textFieldStyle,
	            textFieldClassName = _props5.textFieldClassName,
	            label = _props5.label,
	            placeholder = _props5.placeholder,
	            icon = _props5.icon,
	            inline = _props5.inline,
	            displayMode = _props5.displayMode,
	            fullWidth = _props5.fullWidth,
	            lineDirection = _props5.lineDirection,
	            id = _props5.id,
	            disabled = _props5.disabled,
	            closeOnEsc = _props5.closeOnEsc,
	            renderNode = _props5.renderNode,
	            lastChild = _props5.lastChild,
	            block = _props5.block,
	            paddedBlock = _props5.paddedBlock,
	            active = _props5.active,
	            error = _props5.error,
	            floating = _props5.floating,
	            required = _props5.required,
	            leftIconStateful = _props5.leftIconStateful,
	            rightIcon = _props5.rightIcon,
	            rightIconStateful = _props5.rightIconStateful,
	            customSize = _props5.customSize,
	            errorText = _props5.errorText,
	            helpText = _props5.helpText,
	            helpOnFocus = _props5.helpOnFocus,
	            inlineIndicator = _props5.inlineIndicator,
	            ariaLabel = _props5['aria-label'],
	            isOpen = _props5.isOpen,
	            props = _objectWithoutProperties(_props5, ['style', 'className', 'pickerStyle', 'pickerClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'id', 'disabled', 'closeOnEsc', 'renderNode', 'lastChild', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'aria-label', 'isOpen']);
	
	        delete props.value;
	        delete props.onChange;
	        delete props.visible;
	        delete props.onVisibilityToggle;
	        delete props.defaultValue;
	        delete props.defaultVisible;
	
	        // Delete deprecated
	        delete props.initiallyOpen;
	        delete props.adjustMinWidth;
	        delete props.nextIcon;
	        delete props.previousIcon;
	
	        var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	        var picker = _react2.default.createElement(_DatePicker2.default, _extends({}, this.state, props, {
	          icon: !!icon,
	          inline: inline,
	          style: pickerStyle,
	          className: pickerClassName,
	          displayMode: displayMode,
	          onCancelClick: this._handleCancelClick,
	          onOkClick: this._handleOkClick,
	          changeCalendarMode: this._changeCalendarMode,
	          onPreviousClick: this._previousMonth,
	          onNextClick: this._nextMonth,
	          onCalendarDateClick: this._setCalendarTempDate,
	          onCalendarYearClick: this._setCalendarTempYear
	        }));
	
	        var content = void 0;
	        if (inline) {
	          content = _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: !visible },
	            picker
	          );
	        } else {
	          content = _react2.default.createElement(
	            _DialogContainer2.default,
	            {
	              id: id + 'Dialog',
	              visible: visible,
	              onHide: this._handleCancelClick,
	              dialogClassName: 'md-dialog--picker',
	              contentClassName: 'md-dialog-content--picker',
	              'aria-label': ariaLabel,
	              closeOnEsc: closeOnEsc,
	              renderNode: renderNode,
	              lastChild: lastChild,
	              focusOnMount: false
	            },
	            picker
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
	          _react2.default.createElement(_TextField2.default, {
	            id: id,
	            style: textFieldStyle,
	            className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
	            inputStyle: inputStyle,
	            inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
	            active: active || visible,
	            error: error,
	            floating: floating || visible,
	            required: required,
	            disabled: disabled,
	            leftIcon: icon,
	            leftIconStateful: leftIconStateful,
	            rightIcon: rightIcon,
	            rightIconStateful: rightIconStateful,
	            inlineIndicator: inlineIndicator,
	            block: block,
	            paddedBlock: paddedBlock,
	            fullWidth: fullWidth,
	            lineDirection: lineDirection,
	            customSize: customSize,
	            helpText: helpText,
	            helpOnFocus: helpOnFocus,
	            errorText: errorText,
	            label: label,
	            placeholder: placeholder,
	            onClick: this._toggleOpen,
	            onKeyDown: this._handleKeyDown,
	            value: this._getFormattedValue(this.props, this.state),
	            readOnly: true
	          }),
	          content
	        );
	      }
	    }]);
	
	    return DatePickerContainer;
	  }(_react.PureComponent);
	
	  DatePickerContainer.propTypes = {
	    /**
	     * An id for the text field in the date picker. This is require for a11u.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])),
	
	    /**
	     * An aria label for the dialog. This is required for a11y.
	     */
	    'aria-label': (0, _isRequiredForA11y2.default)(_react.PropTypes.string),
	
	    /**
	     * An optional style to apply to the date picker's container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the date picker's container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the date picker.
	     */
	    pickerStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the date picker.
	     */
	    pickerClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the input tag.
	     */
	    inputStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the input tag.
	     */
	    inputClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the text field's container.
	     */
	    textFieldStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the text field's container.
	     */
	    textFieldClassName: _react.PropTypes.string,
	
	    /**
	     * An optional icon to display with the date picker.
	     */
	    icon: _react.PropTypes.node,
	
	    /**
	     * Boolean if the date picker is open by default.
	     */
	    defaultVisible: _react.PropTypes.bool,
	
	    /**
	     * An optional label to be displayed in the date picker's text
	     * field.
	     */
	    label: _react.PropTypes.string,
	
	    /**
	     * An optional placeholder to be displayed in the date picker's text field.
	     */
	    placeholder: _react.PropTypes.string,
	
	    /**
	     * The value of the date picker. This will make the date picker
	     * be a controlled component. This value should either be a
	     * formatted date string or a date object.
	     */
	    value: (0, _controlled2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.instanceOf(Date)]), 'onChange', 'defaultValue'),
	
	    /**
	     * An optional default value to give for the date picker. This should
	     * either be a formatted date string or a date object.
	     */
	    defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.instanceOf(Date)]),
	
	    /**
	     * An optional date to use when the calendar is opened for the first time.
	     * If this is omitted, it will either be the `defaultValue`, `value`, or
	     * today.
	     */
	    initialCalendarDate: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.instanceOf(Date)]),
	
	    /**
	     * An optional function to call when the selected date is changed
	     * by hitting the OK button. The newly formatted date string,
	     * the new Date object, and the change event will be given.
	     *
	     * `onChange(dateString, dateObject, event)`.
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * A function to format the dates since it should be formatted to the user's
	     * locale. This _should_ be the `Intl.DateTimeFormat` function. You
	     * can also create your own if you really wanted. Unadvisable though.
	     *
	     * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
	     */
	    DateTimeFormat: _react.PropTypes.func.isRequired,
	
	    /**
	     * The locales to use for formatting the date. This will default to using
	     * the user's language in the browser or `'en-US'` when server renering.
	     */
	    locales: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]).isRequired,
	
	    /**
	     * The label to use for the ok button on the date picker.
	     */
	    okLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * Boolean if the ok button should be styled with the primary color.
	     */
	    okPrimary: _react.PropTypes.bool,
	
	    /**
	     * The label to use for the cancel button on the date picker.
	     */
	    cancelLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * Boolean if the cancel button should be styled with the primary color.
	     */
	    cancelPrimary: _react.PropTypes.bool,
	
	    /**
	     * The initial mode to open the calendar in.
	     */
	    defaultCalendarMode: _react.PropTypes.oneOf(['calendar', 'year']),
	
	    /**
	     * Any children used to render the previous icon button in the calendar.
	     */
	    previousIconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className to use to render the previous icon button in the calendar.
	     */
	    previousIconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children used to render the next icon button in the calendar.
	     */
	    nextIconChildren: _react.PropTypes.node,
	
	    /**
	     * The icon className to use to render the next icon button in the calendar.
	     */
	    nextIconClassName: _react.PropTypes.string,
	
	    /**
	     * An optional min date to use for the date picker. This will prevent
	     * any dates before this time to be chosen.
	     */
	    minDate: _react.PropTypes.instanceOf(Date),
	
	    /**
	     * An optional max date to use for the date picker. This will prevent
	     * any dates after this time to be chosen.
	     */
	    maxDate: function maxDate(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      var err = _react.PropTypes.instanceOf(Date).apply(undefined, [props, propName, component].concat(others));
	      if (err || !props.minDate || !props[propName]) {
	        return err;
	      }
	
	      var minDate = props.minDate,
	          maxDate = props.maxDate;
	
	      if (minDate > maxDate) {
	        return new Error('The min date: \'' + minDate + '\' is greater than the max date: \'' + maxDate + '\'');
	      }
	
	      return null;
	    },
	
	    /**
	     * Boolean if the date should automatically be selected when a user clicks
	     * on a new date instead of making them hit the ok button.
	     */
	    autoOk: _react.PropTypes.bool,
	
	    /**
	     * The number of years to display.
	     */
	    yearsDisplayed: _react.PropTypes.number,
	
	    /**
	     * Boolean if the date picker should be displayed inline instead of in a
	     * dialog.
	     */
	    inline: _react.PropTypes.bool,
	
	    /**
	     * An optional force of the display mode of the date picker.
	     * This _should_ not really be used since there are media queries
	     * to use the correct mode based on device orientation.
	     */
	    displayMode: _react.PropTypes.oneOf(['landscape', 'portrait']),
	
	    /**
	     * The DateTimeFormat options to apply to format the date.
	     */
	    formatOptions: _react.PropTypes.shape({
	      weekday: _react.PropTypes.oneOf(['narrow', 'short', 'long']),
	      era: _react.PropTypes.oneOf(['narrow', 'short', 'long']),
	      year: _react.PropTypes.oneOf(['numeric', '2-digit']),
	      month: _react.PropTypes.oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	      day: _react.PropTypes.oneOf(['numeric', '2-digit']),
	      hour: _react.PropTypes.oneOf(['numeric', '2-digit']),
	      minute: _react.PropTypes.oneOf(['numeric', '2-digit']),
	      second: _react.PropTypes.oneOf(['numeric', '2-digit']),
	      timeZoneName: _react.PropTypes.oneOf(['short', 'long'])
	    }),
	
	    /**
	     * Boolean if the text field for the Date Picker should be displayed as full width.
	     */
	    fullWidth: _react.PropTypes.bool,
	
	    /**
	     * The direction that the text field divider expands from when the text field
	     * in the date picker gains focus.
	     */
	    lineDirection: _react.PropTypes.oneOf(['left', 'center', 'right']),
	
	    /**
	     * An optional boolean if the time picker is current visible by dialog or inline.
	     * If this is set, the `onOpenToggle` function is required.
	     */
	    visible: (0, _controlled2.default)(_react.PropTypes.bool, 'onVisibilityChange', 'defaultVisible'),
	
	    /**
	     * An optional function to call when the date picker is opened in either a dialog, or
	     * inline. The callback will include the next state.
	     *
	     * ```js
	     * onVisibilityChange(!visible, e);
	     * ```
	     */
	    onVisibilityChange: _react.PropTypes.func,
	
	    /**
	     * Boolean if the time picker is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
	     */
	    closeOnEsc: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the time is required.
	     *
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    required: _react.PropTypes.bool,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    block: _TextField2.default.propTypes.block,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    paddedBlock: _TextField2.default.propTypes.paddedBlock,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    active: _TextField2.default.propTypes.active,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    error: _TextField2.default.propTypes.error,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    floating: _TextField2.default.propTypes.floating,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    leftIconStateful: _TextField2.default.propTypes.leftIconStateful,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    rightIcon: _TextField2.default.propTypes.rightIcon,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    rightIconStateful: _TextField2.default.propTypes.rightIconStateful,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    customSize: _TextField2.default.propTypes.customSize,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    errorText: _TextField2.default.propTypes.errorText,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    helpText: _TextField2.default.propTypes.helpText,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    helpOnFocus: _TextField2.default.propTypes.helpOnFocus,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    inlineIndicator: _TextField2.default.propTypes.helpOnFocus,
	
	    /**
	     * An optional DOM Node to render the dialog into. The default is to render as the first child
	     * in the `body`.
	     */
	    renderNode: _react.PropTypes.object,
	
	    /**
	     * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
	     * of the first.
	     */
	    lastChild: _react.PropTypes.bool,
	    previousIcon: (0, _deprecated2.default)(_react.PropTypes.node, 'Use `previousIconChildren` and `previousIconClassName` instead'),
	    nextIcon: (0, _deprecated2.default)(_react.PropTypes.node, 'Use `nextIconChildren` and `nextIconClassName` instead'),
	    adjustMinWidth: (0, _deprecated2.default)(_react.PropTypes.bool, 'No longer valid for a text field'),
	    initiallyOpen: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `defaultVisible` instead'),
	    isOpen: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `visible` instead'),
	    initialCalendarMode: (0, _deprecated2.default)(_react.PropTypes.oneOf(['calendar', 'year']), 'Use `defaultCalendarMode` instead'),
	    initialYearsDisplayed: (0, _deprecated2.default)(_react.PropTypes.number, 'Use `yearsDisplayed` instead. I have not implemented infinite loading years')
	  };
	  DatePickerContainer.defaultProps = {
	    previousIconChildren: 'chevron_left',
	    nextIconChildren: 'chevron_right',
	    autoOk: false,
	    icon: _react2.default.createElement(
	      _FontIcon2.default,
	      null,
	      'date_range'
	    ),
	    yearsDisplayed: 100,
	    defaultCalendarMode: 'calendar',
	    DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
	    locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
	    okLabel: 'Ok',
	    okPrimary: true,
	    cancelLabel: 'Cancel',
	    cancelPrimary: true,
	    closeOnEsc: true,
	    'aria-label': 'Pick a date'
	  };
	  exports.default = DatePickerContainer;
	});

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(130)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('./PickerControl'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.PickerControl);
	    global.DatePickerHeader = mod.exports;
	  }
	})(this, function (exports, _react, _PickerControl) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var DatePickerHeader = function (_PureComponent) {
	    _inherits(DatePickerHeader, _PureComponent);
	
	    function DatePickerHeader(props) {
	      _classCallCheck(this, DatePickerHeader);
	
	      var _this = _possibleConstructorReturn(this, (DatePickerHeader.__proto__ || Object.getPrototypeOf(DatePickerHeader)).call(this, props));
	
	      _this.state = _this._getFormattedDate(props);
	      _this._selectYear = _this._selectYear.bind(_this);
	      _this._selectCalendar = _this._selectCalendar.bind(_this);
	      return _this;
	    }
	
	    _createClass(DatePickerHeader, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            DateTimeFormat = _props.DateTimeFormat,
	            locales = _props.locales,
	            calendarTempDate = _props.calendarTempDate,
	            changeCalendarMode = _props.changeCalendarMode;
	
	        if (DateTimeFormat !== nextProps.DateTimeFormat || locales !== nextProps.locales || calendarTempDate !== nextProps.calendarTempDate || changeCalendarMode !== nextProps.changeCalendarMode) {
	          this.setState(this._getFormattedDate(nextProps));
	        }
	      }
	    }, {
	      key: '_getFormattedDate',
	      value: function _getFormattedDate(_ref) {
	        var DateTimeFormat = _ref.DateTimeFormat,
	            locales = _ref.locales,
	            calendarTempDate = _ref.calendarTempDate;
	
	        return {
	          year: DateTimeFormat(locales, { year: 'numeric' }).format(calendarTempDate),
	          weekday: DateTimeFormat(locales, { weekday: 'short' }).format(calendarTempDate),
	          date: DateTimeFormat(locales, { month: 'short', day: '2-digit' }).format(calendarTempDate)
	        };
	      }
	    }, {
	      key: '_selectYear',
	      value: function _selectYear(e) {
	        this.props.changeCalendarMode('year', e);
	      }
	    }, {
	      key: '_selectCalendar',
	      value: function _selectCalendar(e) {
	        this.props.changeCalendarMode('calendar', e);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            year = _state.year,
	            weekday = _state.weekday,
	            date = _state.date;
	        var calendarMode = this.props.calendarMode;
	
	        return _react2.default.createElement(
	          'header',
	          { className: 'md-picker-header' },
	          _react2.default.createElement(
	            _PickerControl2.default,
	            { onClick: this._selectYear, active: calendarMode === 'year' },
	            _react2.default.createElement(
	              'h6',
	              { className: 'md-subheading-1' },
	              year
	            )
	          ),
	          _react2.default.createElement(
	            _PickerControl2.default,
	            { onClick: this._selectCalendar, active: calendarMode === 'calendar' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'md-display-1' },
	              weekday + ',',
	              '\xA0'
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: 'md-display-1' },
	              date
	            )
	          )
	        );
	      }
	    }]);
	
	    return DatePickerHeader;
	  }(_react.PureComponent);
	
	  DatePickerHeader.propTypes = {
	    DateTimeFormat: _react.PropTypes.func.isRequired,
	    locales: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]).isRequired,
	    calendarTempDate: _react.PropTypes.instanceOf(Date).isRequired,
	    calendarMode: _react.PropTypes.oneOf(['calendar', 'year']).isRequired,
	    changeCalendarMode: _react.PropTypes.func.isRequired
	  };
	  exports.default = DatePickerHeader;
	});

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(506), __webpack_require__(130)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../utils/DateUtils/addHours'), require('./PickerControl'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.addHours, global.PickerControl);
	    global.TimePeriods = mod.exports;
	  }
	})(this, function (exports, _react, _addHours, _PickerControl) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _addHours2 = _interopRequireDefault(_addHours);
	
	  var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TimePeriods = function (_PureComponent) {
	    _inherits(TimePeriods, _PureComponent);
	
	    function TimePeriods(props) {
	      _classCallCheck(this, TimePeriods);
	
	      var _this = _possibleConstructorReturn(this, (TimePeriods.__proto__ || Object.getPrototypeOf(TimePeriods)).call(this, props));
	
	      _this._setAM = _this._setAM.bind(_this);
	      _this._setPM = _this._setPM.bind(_this);
	      return _this;
	    }
	
	    _createClass(TimePeriods, [{
	      key: '_setAM',
	      value: function _setAM() {
	        if (this.props.timePeriod !== 'AM') {
	          this.props.setTempTime((0, _addHours2.default)(this.props.tempTime, 12));
	        }
	      }
	    }, {
	      key: '_setPM',
	      value: function _setPM() {
	        if (this.props.timePeriod !== 'PM') {
	          this.props.setTempTime((0, _addHours2.default)(this.props.tempTime, -12));
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var timePeriod = this.props.timePeriod;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'md-time-periods' },
	          _react2.default.createElement(
	            _PickerControl2.default,
	            { onClick: this._setAM, active: timePeriod === 'AM' },
	            _react2.default.createElement(
	              'h6',
	              { className: 'md-time-period' },
	              'AM'
	            )
	          ),
	          _react2.default.createElement(
	            _PickerControl2.default,
	            { onClick: this._setPM, active: timePeriod === 'PM' },
	            _react2.default.createElement(
	              'h6',
	              { className: 'md-time-period' },
	              'PM'
	            )
	          )
	        );
	      }
	    }]);
	
	    return TimePeriods;
	  }(_react.PureComponent);
	
	  TimePeriods.propTypes = {
	    /**
	     * The current time for the time picker.
	     */
	    tempTime: _react.PropTypes.instanceOf(Date).isRequired,
	
	    /**
	     * A function to update the time for the time picker.
	     */
	    setTempTime: _react.PropTypes.func.isRequired,
	
	    /**
	     * The current time period.
	     */
	    timePeriod: _react.PropTypes.string.isRequired
	  };
	  exports.default = TimePeriods;
	});

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(451), __webpack_require__(63), __webpack_require__(461)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./ClockFace'), require('../Dialogs/DialogFooter'), require('./TimePickerHeader'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.ClockFace, global.DialogFooter, global.TimePickerHeader);
	    global.TimePicker = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _ClockFace, _DialogFooter, _TimePickerHeader) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _ClockFace2 = _interopRequireDefault(_ClockFace);
	
	  var _DialogFooter2 = _interopRequireDefault(_DialogFooter);
	
	  var _TimePickerHeader2 = _interopRequireDefault(_TimePickerHeader);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TimePicker = function (_PureComponent) {
	    _inherits(TimePicker, _PureComponent);
	
	    function TimePicker(props) {
	      _classCallCheck(this, TimePicker);
	
	      var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));
	
	      _this._updateTime = _this._updateTime.bind(_this);
	      return _this;
	    }
	
	    /**
	     * Takes in the new time (number o'clock or minutes), updates the temp time
	     * with that new time, and then calls the setTempTime prop.
	     */
	
	
	    _createClass(TimePicker, [{
	      key: '_updateTime',
	      value: function _updateTime(newTime) {
	        var timePart = newTime;
	        var _props = this.props,
	            tempTime = _props.tempTime,
	            setTempTime = _props.setTempTime,
	            timeMode = _props.timeMode,
	            timePeriod = _props.timePeriod;
	
	        var time = new Date(tempTime);
	        if (timeMode === 'hour') {
	          var isAM = timePeriod === 'AM';
	          var is12 = timePart === 12;
	          if (timePeriod && isAM && is12) {
	            timePart = 0;
	          } else if (timePeriod && !isAM && !is12) {
	            timePart += 12;
	          }
	
	          time.setHours(timePart);
	        } else {
	          time.setMinutes(timePart);
	        }
	
	        setTempTime(time);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _cn;
	
	        var _props2 = this.props,
	            okLabel = _props2.okLabel,
	            okPrimary = _props2.okPrimary,
	            onOkClick = _props2.onOkClick,
	            cancelLabel = _props2.cancelLabel,
	            cancelPrimary = _props2.cancelPrimary,
	            onCancelClick = _props2.onCancelClick,
	            style = _props2.style,
	            className = _props2.className,
	            setTimeMode = _props2.setTimeMode,
	            setTempTime = _props2.setTempTime,
	            timeMode = _props2.timeMode,
	            tempTime = _props2.tempTime,
	            hours = _props2.hours,
	            minutes = _props2.minutes,
	            timePeriod = _props2.timePeriod,
	            displayMode = _props2.displayMode,
	            inline = _props2.inline,
	            icon = _props2.icon;
	
	
	        var hoursInt = parseInt(hours, 10);
	        var minutesInt = parseInt(minutes.replace(/[^0-9]/g, ''), 10);
	        var actions = [{
	          key: cancelLabel,
	          onClick: onCancelClick,
	          primary: cancelPrimary,
	          secondary: !cancelPrimary,
	          label: cancelLabel
	        }, {
	          key: okLabel,
	          onClick: onOkClick,
	          primary: okPrimary,
	          secondary: !okPrimary,
	          label: okLabel
	        }];
	
	        return _react2.default.createElement(
	          'div',
	          {
	            style: style,
	            className: (0, _classnames2.default)('md-picker md-picker--time', (_cn = {}, _defineProperty(_cn, 'md-picker--' + displayMode, displayMode), _defineProperty(_cn, 'md-picker--inline', inline), _defineProperty(_cn, 'md-picker--inline-icon', inline && icon), _cn), className)
	          },
	          _react2.default.createElement(_TimePickerHeader2.default, {
	            tempTime: tempTime,
	            timeMode: timeMode,
	            setTimeMode: setTimeMode,
	            setTempTime: setTempTime,
	            hours: hours,
	            minutes: minutes,
	            timePeriod: timePeriod
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'md-picker-content-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'md-picker-content md-picker-content--clock' },
	              _react2.default.createElement(_ClockFace2.default, {
	                time: timeMode === 'hour' ? hoursInt : minutesInt,
	                minutes: timeMode === 'minute',
	                onChange: this._updateTime,
	                timePeriod: timePeriod
	              })
	            ),
	            _react2.default.createElement(_DialogFooter2.default, { actions: actions })
	          )
	        );
	      }
	    }]);
	
	    return TimePicker;
	  }(_react.PureComponent);
	
	  TimePicker.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    okLabel: _react.PropTypes.string.isRequired,
	    okPrimary: _react.PropTypes.bool.isRequired,
	    onOkClick: _react.PropTypes.func.isRequired,
	    cancelLabel: _react.PropTypes.string.isRequired,
	    cancelPrimary: _react.PropTypes.bool.isRequired,
	    onCancelClick: _react.PropTypes.func.isRequired,
	    DateTimeFormat: _react.PropTypes.func.isRequired,
	    locales: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]).isRequired,
	    icon: _react.PropTypes.bool,
	    inline: _react.PropTypes.bool,
	    displayMode: _react.PropTypes.oneOf(['landscape', 'portrait']),
	
	    /**
	     * A function that will switch the state from hour to minute.
	     */
	    setTimeMode: _react.PropTypes.func.isRequired,
	
	    /**
	     * A function that will update the time for the TimePicker before
	     * the user selects ok. This function will be given a new Date object
	     * with a modified time.
	     */
	    setTempTime: _react.PropTypes.func.isRequired,
	
	    /**
	     * The current display mode of the time picker.
	     */
	    timeMode: _react.PropTypes.oneOf(['hour', 'minute']).isRequired,
	
	    /**
	     * The current time as a date object that is being displayed in the
	     * time picker.
	     */
	    tempTime: _react.PropTypes.instanceOf(Date).isRequired,
	
	    /**
	     * A string that is a representation of the hours in the user's locale.
	     */
	    hours: _react.PropTypes.string.isRequired,
	
	    /**
	     * A string that is a representation of the minutes in the user's locale.
	     * This will also include any separator the locale uses.
	     *
	     * Example: ':15' in '3:15 PM' for 'en-US'
	     */
	    minutes: _react.PropTypes.string.isRequired,
	
	    /**
	     * An optional time period if a user's locale uses it.
	     */
	    timePeriod: _react.PropTypes.string
	  };
	  exports.default = TimePicker;
	});

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(13), __webpack_require__(8), __webpack_require__(11), __webpack_require__(12), __webpack_require__(14), __webpack_require__(220), __webpack_require__(221), __webpack_require__(507), __webpack_require__(123), __webpack_require__(18), __webpack_require__(52), __webpack_require__(38), __webpack_require__(459)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('react-prop-types/lib/deprecated'), require('../constants/keyCodes'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../utils/DateUtils/DateTimeFormat'), require('../utils/DateUtils/formatTime'), require('../utils/DateUtils/extractTimeParts'), require('../Dialogs/DialogContainer'), require('../FontIcons/FontIcon'), require('../TextFields/TextField'), require('../Helpers/Collapse'), require('./TimePicker'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.isRequiredForA11y, global.deprecated, global.keyCodes, global.getField, global.controlled, global.DateTimeFormat, global.formatTime, global.extractTimeParts, global.DialogContainer, global.FontIcon, global.TextField, global.Collapse, global.TimePicker);
	    global.TimePickerContainer = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _isRequiredForA11y, _deprecated, _keyCodes, _getField, _controlled, _DateTimeFormat, _formatTime, _extractTimeParts, _DialogContainer, _FontIcon, _TextField, _Collapse, _TimePicker) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _DateTimeFormat2 = _interopRequireDefault(_DateTimeFormat);
	
	  var _formatTime2 = _interopRequireDefault(_formatTime);
	
	  var _extractTimeParts2 = _interopRequireDefault(_extractTimeParts);
	
	  var _DialogContainer2 = _interopRequireDefault(_DialogContainer);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  var _TextField2 = _interopRequireDefault(_TextField);
	
	  var _Collapse2 = _interopRequireDefault(_Collapse);
	
	  var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TimePickerContainer = function (_PureComponent) {
	    _inherits(TimePickerContainer, _PureComponent);
	
	    function TimePickerContainer(props) {
	      _classCallCheck(this, TimePickerContainer);
	
	      var _this = _possibleConstructorReturn(this, (TimePickerContainer.__proto__ || Object.getPrototypeOf(TimePickerContainer)).call(this, props));
	
	      var initialDate = void 0;
	      if (props.defaultValue) {
	        initialDate = new Date(props.defaultValue);
	      } else if (props.value) {
	        initialDate = new Date(props.value);
	      } else {
	        initialDate = new Date();
	      }
	
	      var visible = typeof props.initiallyOpen !== 'undefined' ? props.initiallyOpen : !!props.defaultVisible;
	
	      _this.state = _extends({
	        visible: visible
	      }, _this._getTimeParts(initialDate, props), {
	        value: props.defaultValue,
	        time: initialDate,
	        timeMode: props.initialTimeMode || props.defaultTimeMode,
	        tempTime: initialDate
	      });
	
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._toggleOpen = _this._toggleOpen.bind(_this);
	      _this._closeOnEsc = _this._closeOnEsc.bind(_this);
	      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
	      _this._getTextFieldValue = _this._getTextFieldValue.bind(_this);
	      _this._setTimeMode = _this._setTimeMode.bind(_this);
	      _this._setTempTime = _this._setTempTime.bind(_this);
	      _this._handleOkClick = _this._handleOkClick.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._handleCancelClick = _this._handleCancelClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(TimePickerContainer, [{
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate(nextProps, nextState) {
	        if ((0, _getField2.default)(this.props, this.state, 'value') !== (0, _getField2.default)(nextProps, nextState, 'value')) {
	          this.setState(this._getTimeParts((0, _getField2.default)(nextProps, nextState, 'value'), nextProps));
	        } else if (this.state.tempValue !== nextState.tempTime) {
	          this.setState(this._getTimeParts(nextState.tempTime, nextProps));
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var _props = this.props,
	            inline = _props.inline,
	            isOpen = _props.isOpen;
	
	        var visible = typeof isOpen !== 'undefined' ? isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	        var pVisible = typeof prevProps.isOpen !== 'undefined' ? prevProps.isOpen : (0, _getField2.default)(prevProps, prevState, 'visible');
	
	        if (visible === pVisible) {
	          return;
	        }
	
	        if (visible) {
	          if (inline) {
	            window.addEventListener('click', this._handleOutsideClick);
	            window.addEventListener('keydown', this._closeOnEsc);
	          }
	        } else if (inline) {
	          window.removeEventListener('click', this._handleOutsideClick);
	          window.removeEventListener('keydown', this._closeOnEsc);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	        if (visible && this.props.inline) {
	          window.removeEventListener('click', this._handleOutsideClick);
	          window.removeEventListener('keydown', this._closeOnEsc);
	        }
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        this._container = container;
	      }
	    }, {
	      key: '_getTimeParts',
	      value: function _getTimeParts(date, props) {
	        return (0, _extractTimeParts2.default)(props.DateTimeFormat, props.locales, date);
	      }
	    }, {
	      key: '_closeOnEsc',
	      value: function _closeOnEsc(e) {
	        if ((e.which || e.keyCode) === _keyCodes.ESC) {
	          this._handleCancelClick(e);
	        }
	      }
	    }, {
	      key: '_handleOutsideClick',
	      value: function _handleOutsideClick(e) {
	        if (this._container && !this._container.contains(e.target)) {
	          this._handleCancelClick(e);
	        }
	      }
	    }, {
	      key: '_toggleOpen',
	      value: function _toggleOpen(e) {
	        if (this.props.disabled) {
	          return;
	        }
	
	        var visible = !(typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible'));
	
	        if (this.props.onVisibilityChange) {
	          this.props.onVisibilityChange(visible, e);
	        }
	
	        if (typeof this.props.isOpen === 'undefined' && typeof this.props.visible === 'undefined') {
	          this.setState({ visible: visible });
	        }
	      }
	    }, {
	      key: '_setTimeMode',
	      value: function _setTimeMode(timeMode) {
	        if (this.state.timeMode === timeMode) {
	          return;
	        }
	
	        this.setState({ timeMode: timeMode });
	      }
	    }, {
	      key: '_setTempTime',
	      value: function _setTempTime(time) {
	        if (this.state.tempTime === time) {
	          return;
	        }
	
	        this.setState({ tempTime: time });
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        if ((e.which || e.keyCode) === _keyCodes.ENTER) {
	          this._toggleOpen(e);
	        }
	      }
	    }, {
	      key: '_handleOkClick',
	      value: function _handleOkClick(e) {
	        var _props2 = this.props,
	            onVisibilityChange = _props2.onVisibilityChange,
	            onChange = _props2.onChange,
	            DateTimeFormat = _props2.DateTimeFormat,
	            locales = _props2.locales;
	
	        var value = new Date(this.state.tempTime);
	        if (onChange) {
	          onChange((0, _formatTime2.default)(DateTimeFormat, locales, value), value, e);
	        }
	
	        if (onVisibilityChange) {
	          onVisibilityChange(false, e);
	        }
	
	        var state = void 0;
	        if (typeof this.props.value === 'undefined') {
	          state = { value: value };
	        }
	
	        if (typeof this.props.isOpen === 'undefined' && typeof this.props.visible === 'undefined') {
	          state = state || {};
	          state.visible = false;
	        }
	
	        if (state) {
	          this.setState(state);
	        }
	      }
	    }, {
	      key: '_handleCancelClick',
	      value: function _handleCancelClick(e) {
	        if (this.props.onVisibilityChange) {
	          this.props.onVisibilityChange(false, e);
	        }
	
	        var state = { visible: false, tempTime: this.state.time };
	        if (typeof this.props.isOpen !== 'undefined' || typeof this.props.visible !== 'undefined') {
	          delete state.visible;
	        }
	
	        this.setState(state);
	      }
	    }, {
	      key: '_getTextFieldValue',
	      value: function _getTextFieldValue(props, state) {
	        var DateTimeFormat = props.DateTimeFormat,
	            locales = props.locales;
	
	        var value = (0, _getField2.default)(props, state, 'value');
	        if (!value) {
	          return '';
	        } else if (value instanceof Date) {
	          return (0, _formatTime2.default)(DateTimeFormat, locales, value);
	        } else {
	          // currently don't support value of string
	          return value;
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            timeMode = _state.timeMode,
	            tempTime = _state.tempTime,
	            hours = _state.hours,
	            minutes = _state.minutes,
	            timePeriod = _state.timePeriod;
	
	        var _props3 = this.props,
	            style = _props3.style,
	            className = _props3.className,
	            pickerStyle = _props3.pickerStyle,
	            pickerClassName = _props3.pickerClassName,
	            inputStyle = _props3.inputStyle,
	            inputClassName = _props3.inputClassName,
	            textFieldStyle = _props3.textFieldStyle,
	            textFieldClassName = _props3.textFieldClassName,
	            id = _props3.id,
	            disabled = _props3.disabled,
	            label = _props3.label,
	            placeholder = _props3.placeholder,
	            icon = _props3.icon,
	            inline = _props3.inline,
	            displayMode = _props3.displayMode,
	            fullWidth = _props3.fullWidth,
	            lineDirection = _props3.lineDirection,
	            closeOnEsc = _props3.closeOnEsc,
	            renderNode = _props3.renderNode,
	            lastChild = _props3.lastChild,
	            block = _props3.block,
	            paddedBlock = _props3.paddedBlock,
	            active = _props3.active,
	            error = _props3.error,
	            floating = _props3.floating,
	            required = _props3.required,
	            leftIconStateful = _props3.leftIconStateful,
	            rightIcon = _props3.rightIcon,
	            rightIconStateful = _props3.rightIconStateful,
	            customSize = _props3.customSize,
	            errorText = _props3.errorText,
	            helpText = _props3.helpText,
	            helpOnFocus = _props3.helpOnFocus,
	            inlineIndicator = _props3.inlineIndicator,
	            ariaLabel = _props3['aria-label'],
	            props = _objectWithoutProperties(_props3, ['style', 'className', 'pickerStyle', 'pickerClassName', 'inputStyle', 'inputClassName', 'textFieldStyle', 'textFieldClassName', 'id', 'disabled', 'label', 'placeholder', 'icon', 'inline', 'displayMode', 'fullWidth', 'lineDirection', 'closeOnEsc', 'renderNode', 'lastChild', 'block', 'paddedBlock', 'active', 'error', 'floating', 'required', 'leftIconStateful', 'rightIcon', 'rightIconStateful', 'customSize', 'errorText', 'helpText', 'helpOnFocus', 'inlineIndicator', 'aria-label']);
	
	        delete props.value;
	        delete props.onVisibilityChange;
	        delete props.onChange;
	        delete props.defaultValue;
	        delete props.defaultVisible;
	        delete props.defaultTimeMode;
	
	        // Delete deprecated
	        delete props.isOpen;
	        delete props.initialTimeMode;
	        delete props.initiallyOpen;
	
	        var visible = typeof this.props.isOpen !== 'undefined' ? this.props.isOpen : (0, _getField2.default)(this.props, this.state, 'visible');
	
	        var picker = _react2.default.createElement(_TimePicker2.default, _extends({}, props, {
	          inline: inline,
	          icon: !!icon,
	          tempTime: tempTime,
	          timeMode: timeMode,
	          hours: hours,
	          minutes: minutes,
	          timePeriod: timePeriod,
	          style: pickerStyle,
	          className: pickerClassName,
	          displayMode: displayMode,
	          onOkClick: this._handleOkClick,
	          onCancelClick: this._handleCancelClick,
	          setTimeMode: this._setTimeMode,
	          setTempTime: this._setTempTime
	        }));
	
	        var content = void 0;
	        if (inline) {
	          content = _react2.default.createElement(
	            _Collapse2.default,
	            { collapsed: !visible },
	            picker
	          );
	        } else {
	          content = _react2.default.createElement(
	            _DialogContainer2.default,
	            {
	              id: id + 'Dialog',
	              visible: visible,
	              onHide: this._handleCancelClick,
	              dialogClassName: 'md-dialog--picker',
	              contentClassName: 'md-dialog-content--picker',
	              'aria-label': ariaLabel,
	              closeOnEsc: closeOnEsc,
	              lastChild: lastChild,
	              renderNode: renderNode,
	              focusOnMount: false
	            },
	            picker
	          );
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { style: style, className: (0, _classnames2.default)('md-picker-container', className), ref: this._setContainer },
	          _react2.default.createElement(_TextField2.default, {
	            id: id,
	            style: textFieldStyle,
	            className: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, textFieldClassName),
	            inputStyle: inputStyle,
	            inputClassName: (0, _classnames2.default)({ 'md-pointer--hover': !disabled }, inputClassName),
	            active: active || visible,
	            error: error,
	            floating: floating || visible,
	            required: required,
	            disabled: disabled,
	            leftIcon: icon,
	            leftIconStateful: leftIconStateful,
	            rightIcon: rightIcon,
	            rightIconStateful: rightIconStateful,
	            inlineIndicator: inlineIndicator,
	            block: block,
	            paddedBlock: paddedBlock,
	            fullWidth: fullWidth,
	            lineDirection: lineDirection,
	            customSize: customSize,
	            helpText: helpText,
	            helpOnFocus: helpOnFocus,
	            errorText: errorText,
	            label: label,
	            placeholder: placeholder,
	            onClick: this._toggleOpen,
	            onKeyDown: this._handleKeyDown,
	            value: this._getTextFieldValue(this.props, this.state),
	            readOnly: true
	          }),
	          content
	        );
	      }
	    }]);
	
	    return TimePickerContainer;
	  }(_react.PureComponent);
	
	  TimePickerContainer.propTypes = {
	    /**
	     * An id for the text field in the time picker. This is require for a11u.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])),
	
	    /**
	     * An aria-label to apply to the dialog when it has been opened. This is required for
	     * a11y.
	     */
	    'aria-label': (0, _isRequiredForA11y2.default)(_react.PropTypes.string),
	
	    /**
	     * An optional style to apply to the time picker's container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the time picker's container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the time picker.
	     */
	    pickerStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the time picker.
	     */
	    pickerClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the input tag.
	     */
	    inputStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the input tag.
	     */
	    inputClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the text field's container.
	     */
	    textFieldStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the text field's container.
	     */
	    textFieldClassName: _react.PropTypes.string,
	
	    /**
	     * An optional icon to display with the time picker.
	     */
	    icon: _react.PropTypes.node,
	
	    /**
	     * Boolean if the time picker is open by default.
	     */
	    defaultVisible: _react.PropTypes.bool,
	
	    /**
	     * An optional label to be displayed in the time picker's text
	     * field.
	     */
	    label: _react.PropTypes.string,
	
	    /**
	     * An optional placeholder to be displayed in the time picker's text field.
	     */
	    placeholder: _react.PropTypes.string,
	
	    /**
	     * The value of the time picker. This will make the time picker
	     * be a controlled component.
	     */
	    value: (0, _controlled2.default)(_react.PropTypes.instanceOf(Date), 'onChange', 'defaultValue'),
	
	    /**
	     * An optional function to call when the selected date is changed
	     * by hitting the OK button. The newly formatted time string,
	     * the new Date object, and the change event will be given.
	     *
	     * `onChange(timeString, dateObject, event)`.
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * An optional default value to give for the year picker.
	     */
	    defaultValue: _react.PropTypes.instanceOf(Date),
	
	    /**
	     * A function to format the dates since it should be formatted to the user's
	     * locale. This _should_ be the `Intl.DateTimeFormat` function. You
	     * can also create your own if you really wanted. Unadvisable though.
	     *
	     * See [intl-polyfill](https://github.com/andyearnshaw/Intl.js/) for more info.
	     */
	    DateTimeFormat: _react.PropTypes.func.isRequired,
	
	    /**
	     * The locales to use for formatting the date. This will default to using
	     * the user's language in the browser or `'en-US'` when server renering.
	     */
	    locales: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.arrayOf(_react.PropTypes.string)]).isRequired,
	
	    /**
	     * The label to use for the ok button on the year picker.
	     */
	    okLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * Boolean if the ok button should be styled with the primary color.
	     */
	    okPrimary: _react.PropTypes.bool,
	
	    /**
	     * The label to use for the cancel button on the year picker.
	     */
	    cancelLabel: _react.PropTypes.string.isRequired,
	
	    /**
	     * Boolean if the cancel button should be styled with the primary color.
	     */
	    cancelPrimary: _react.PropTypes.bool,
	
	    /**
	     * The default mode to open the time picker in.
	     */
	    defaultTimeMode: _react.PropTypes.oneOf(['hour', 'minute']),
	
	    /**
	     * Boolean if the date should automatically be selected when a user clicks
	     * on a new date instead of making them hit the ok button.
	     */
	    autoOk: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the date picker should be displayed inline instead of in a
	     * dialog.
	     */
	    inline: _react.PropTypes.bool,
	
	    /**
	     * An optional force of the display mode of the date picker.
	     * This _should_ not really be used since there are media queries
	     * to use the correct mode based on device orientation.
	     */
	    displayMode: _react.PropTypes.oneOf(['landscape', 'portrait']),
	
	    /**
	     * Boolean if the text field for the Time Picker should be displayed as full width.
	     */
	    fullWidth: _react.PropTypes.bool,
	
	    /**
	     * The direction that the text field divider expands from when the text field
	     * in the date picker gains focus.
	     */
	    lineDirection: _react.PropTypes.oneOf(['left', 'center', 'right']),
	
	    /**
	     * An optional boolean if the time picker is current visible by dialog or inline.
	     * If this is set, the `onVisibilityChange` function is required.
	     */
	    visible: (0, _controlled2.default)(_react.PropTypes.bool, 'onVisibilityChange', 'defaultVisible'),
	
	    /**
	     * An optional function to call when the date picker is opened in either a dialog, or
	     * inline. The callback will include the next state.
	     *
	     * ```js
	     * onVisibilityChange(!visible, e);
	     * ```
	     */
	    onVisibilityChange: _react.PropTypes.func,
	
	    /**
	     * Boolean if the time picker is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the dialog should be able to close if a keyboard user presses the escape key.
	     */
	    closeOnEsc: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the time is required.
	     *
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    required: _react.PropTypes.bool,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    block: _TextField2.default.propTypes.block,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    paddedBlock: _TextField2.default.propTypes.paddedBlock,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    active: _TextField2.default.propTypes.active,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    error: _TextField2.default.propTypes.error,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    floating: _TextField2.default.propTypes.floating,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    leftIconStateful: _TextField2.default.propTypes.leftIconStateful,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    rightIcon: _TextField2.default.propTypes.rightIcon,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    rightIconStateful: _TextField2.default.propTypes.rightIconStateful,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    customSize: _TextField2.default.propTypes.customSize,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    errorText: _TextField2.default.propTypes.errorText,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    helpText: _TextField2.default.propTypes.helpText,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    helpOnFocus: _TextField2.default.propTypes.helpOnFocus,
	
	    /**
	     * @see [TextField](/components/text-fields?tab=1)
	     */
	    inlineIndicator: _TextField2.default.propTypes.helpOnFocus,
	
	    /**
	     * An optional DOM Node to render the dialog into. The default is to render as the first child
	     * in the `body`.
	     */
	    renderNode: _react.PropTypes.object,
	
	    /**
	     * Boolean if the dialog should be rendered as the last child of the `renderNode` or `body` instead
	     * of the first.
	     */
	    lastChild: _react.PropTypes.bool,
	    isOpen: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `visible` instead'),
	    initiallyOpen: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use `defaultVisible` instead'),
	    initialTimeMode: (0, _deprecated2.default)(_react.PropTypes.oneOf(['hour', 'minute']), 'Use `defaultTimeMode` instead')
	  };
	  TimePickerContainer.defaultProps = {
	    defaultTimeMode: 'hour',
	    icon: _react2.default.createElement(
	      _FontIcon2.default,
	      null,
	      'access_time'
	    ),
	    DateTimeFormat: _DateTimeFormat2.default, // eslint-disable-line object-shorthand
	    locales: typeof window !== 'undefined' ? window.navigator.userLanguage || window.navigator.language : 'en-US',
	    okLabel: 'Ok',
	    okPrimary: true,
	    cancelLabel: 'Cancel',
	    cancelPrimary: true,
	    closeOnEsc: true,
	    'aria-label': 'Select a time'
	  };
	  exports.default = TimePickerContainer;
	});

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(458), __webpack_require__(130)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('./TimePeriods'), require('./PickerControl'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.TimePeriods, global.PickerControl);
	    global.TimePickerHeader = mod.exports;
	  }
	})(this, function (exports, _react, _TimePeriods, _PickerControl) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _TimePeriods2 = _interopRequireDefault(_TimePeriods);
	
	  var _PickerControl2 = _interopRequireDefault(_PickerControl);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TimePickerHeader = function (_PureComponent) {
	    _inherits(TimePickerHeader, _PureComponent);
	
	    function TimePickerHeader(props) {
	      _classCallCheck(this, TimePickerHeader);
	
	      var _this = _possibleConstructorReturn(this, (TimePickerHeader.__proto__ || Object.getPrototypeOf(TimePickerHeader)).call(this, props));
	
	      _this._setHour = _this._setHour.bind(_this);
	      _this._setMinute = _this._setMinute.bind(_this);
	      return _this;
	    }
	
	    _createClass(TimePickerHeader, [{
	      key: '_setHour',
	      value: function _setHour() {
	        this.props.setTimeMode('hour');
	      }
	    }, {
	      key: '_setMinute',
	      value: function _setMinute() {
	        this.props.setTimeMode('minute');
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            timeMode = _props.timeMode,
	            hours = _props.hours,
	            minutes = _props.minutes,
	            timePeriod = _props.timePeriod,
	            setTempTime = _props.setTempTime,
	            tempTime = _props.tempTime;
	
	        var timePeriods = void 0;
	        if (timePeriod) {
	          timePeriods = _react2.default.createElement(_TimePeriods2.default, { tempTime: tempTime, setTempTime: setTempTime, timePeriod: timePeriod });
	        }
	
	        return _react2.default.createElement(
	          'header',
	          { className: 'md-picker-header md-text-right' },
	          _react2.default.createElement(
	            _PickerControl2.default,
	            { onClick: this._setHour, active: timeMode === 'hour' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'md-display-3' },
	              hours
	            )
	          ),
	          _react2.default.createElement(
	            _PickerControl2.default,
	            { onClick: this._setMinute, active: timeMode === 'minute' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'md-display-3' },
	              minutes
	            )
	          ),
	          timePeriods
	        );
	      }
	    }]);
	
	    return TimePickerHeader;
	  }(_react.PureComponent);
	
	  TimePickerHeader.propTypes = {
	    /**
	     * The current time of the time picker.
	     */
	    tempTime: _react.PropTypes.instanceOf(Date).isRequired,
	
	    /**
	     * The current time type that is being changed.
	     */
	    timeMode: _react.PropTypes.oneOf(['hour', 'minute']).isRequired,
	
	    /**
	     * A function to update the time mode.
	     */
	    setTimeMode: _react.PropTypes.func.isRequired,
	
	    /**
	     * A function to update the time for the time picker.
	     */
	    setTempTime: _react.PropTypes.func.isRequired,
	
	    /**
	     * A formatted hours string for the user's locale. This
	     * would be '3' for en-US if the time was '3:15'
	     */
	    hours: _react.PropTypes.string.isRequired,
	
	    /**
	     * A formatted minutes string for the user's locale.
	     * This would be ':15' for en-US if the time was '3:15'.
	     */
	    minutes: _react.PropTypes.string.isRequired,
	
	    /**
	     * An optional time period to use for locales that use
	     * 12 hour clocks and AM/PM.
	     */
	    timePeriod: _react.PropTypes.string
	  };
	  exports.default = TimePickerHeader;
	});

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.Year = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Year = function (_PureComponent) {
	    _inherits(Year, _PureComponent);
	
	    function Year(props) {
	      _classCallCheck(this, Year);
	
	      var _this = _possibleConstructorReturn(this, (Year.__proto__ || Object.getPrototypeOf(Year)).call(this, props));
	
	      _this.state = { desktopActive: false };
	      _this._handleClick = _this._handleClick.bind(_this);
	      _this._setActive = _this._setActive.bind(_this);
	      _this._setInactive = _this._setInactive.bind(_this);
	      _this._setActiveFocus = _this._setActiveFocus.bind(_this);
	      return _this;
	    }
	
	    _createClass(Year, [{
	      key: '_setActiveFocus',
	      value: function _setActiveFocus(btn) {
	        if (btn && this.props.active) {
	          btn.focus();
	        }
	      }
	    }, {
	      key: '_setActive',
	      value: function _setActive() {
	        this.setState({ desktopActive: true });
	      }
	    }, {
	      key: '_setInactive',
	      value: function _setInactive() {
	        this.setState({ desktopActive: false });
	      }
	    }, {
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        this.props.onClick(this.props.year, e);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var desktopActive = this.state.desktopActive;
	        var _props = this.props,
	            active = _props.active,
	            className = _props.className,
	            year = _props.year;
	
	        return _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            ref: this._setActiveFocus,
	            className: (0, _classnames2.default)('md-btn md-pointer--hover md-full-width md-year', {
	              'md-text': !active && !desktopActive,
	              'md-text--theme-primary': active || desktopActive,
	              'md-year--active': active
	            }, className),
	            onClick: this._handleClick
	          },
	          year
	        );
	      }
	    }]);
	
	    return Year;
	  }(_react.PureComponent);
	
	  Year.propTypes = {
	    className: _react.PropTypes.string,
	    active: _react.PropTypes.bool.isRequired,
	    onClick: _react.PropTypes.func.isRequired,
	    year: _react.PropTypes.number.isRequired
	  };
	  exports.default = Year;
	});

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(462)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('./Year'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.Year);
	    global.YearPicker = mod.exports;
	  }
	})(this, function (exports, _react, _Year) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _Year2 = _interopRequireDefault(_Year);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var YearPicker = function (_PureComponent) {
	    _inherits(YearPicker, _PureComponent);
	
	    function YearPicker(props) {
	      _classCallCheck(this, YearPicker);
	
	      var _this = _possibleConstructorReturn(this, (YearPicker.__proto__ || Object.getPrototypeOf(YearPicker)).call(this, props));
	
	      _this.state = _this._getYearRange(props);
	      _this._setContainer = _this._setContainer.bind(_this);
	      return _this;
	    }
	
	    _createClass(YearPicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.yearsDisplayed !== nextProps.yearsDisplayed) {
	          this.setState(this._getFullYear(nextProps));
	        }
	      }
	    }, {
	      key: '_getYearRange',
	      value: function _getYearRange(_ref) {
	        var minDate = _ref.minDate,
	            maxDate = _ref.maxDate,
	            yearsDisplayed = _ref.yearsDisplayed,
	            calendarTempDate = _ref.calendarTempDate;
	
	        var year = calendarTempDate.getFullYear();
	        var range = !minDate && !maxDate ? parseInt(yearsDisplayed / 2, 10) : yearsDisplayed;
	
	        var startYear = void 0;
	        var endYear = void 0;
	        if (minDate && maxDate) {
	          startYear = minDate.getFullYear();
	          endYear = maxDate.getFullYear();
	        } else if (!minDate && !maxDate) {
	          startYear = year - range;
	          endYear = year + range;
	          if (yearsDisplayed % 2 === 0) {
	            endYear -= 1;
	          }
	        } else if (!maxDate) {
	          startYear = minDate.getFullYear();
	          endYear = startYear + yearsDisplayed - 1;
	        } else {
	          endYear = maxDate.getFullYear();
	          startYear = endYear - yearsDisplayed + 1;
	        }
	
	        return { startYear: startYear, endYear: endYear };
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        if (container === null) {
	          return;
	        }
	
	        var offsetHeight = container.offsetHeight,
	            offsetWidth = container.offsetWidth;
	
	        var _container$querySelec = container.querySelector('.md-year--active'),
	            top = _container$querySelec.offsetTop,
	            height = _container$querySelec.offsetHeight;
	
	        // Portrait seems to be 3/4 of the way while landscape is about 1/2
	        if (offsetHeight > offsetWidth) {
	          container.scrollTop = top - offsetHeight * 3 / 4;
	        } else {
	          container.scrollTop = top - offsetHeight / 2 + height / 2;
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            startYear = _state.startYear,
	            endYear = _state.endYear;
	
	
	        var currentYear = this.props.calendarTempDate.getFullYear();
	        var years = [];
	        for (var year = startYear; year <= endYear; year++) {
	          years.push(_react2.default.createElement(_Year2.default, {
	            key: year,
	            year: year,
	            active: year === currentYear,
	            onClick: this.props.onCalendarYearClick
	          }));
	        }
	
	        return _react2.default.createElement(
	          'section',
	          { className: 'md-picker-content md-picker-content--year', ref: this._setContainer },
	          _react2.default.createElement(
	            'ol',
	            { className: 'md-years' },
	            years
	          )
	        );
	      }
	    }]);
	
	    return YearPicker;
	  }(_react.PureComponent);
	
	  YearPicker.propTypes = {
	    calendarTempDate: _react.PropTypes.instanceOf(Date).isRequired,
	    onCalendarYearClick: _react.PropTypes.func.isRequired,
	    yearsDisplayed: _react.PropTypes.number.isRequired,
	    minDate: _react.PropTypes.instanceOf(Date),
	    maxDate: _react.PropTypes.instanceOf(Date)
	  };
	  exports.default = YearPicker;
	});

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(456), __webpack_require__(460)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./DatePickerContainer'), require('./TimePickerContainer'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.DatePickerContainer, global.TimePickerContainer);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _DatePickerContainer, _TimePickerContainer) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.TimePicker = exports.DatePicker = undefined;
	
	  var _DatePickerContainer2 = _interopRequireDefault(_DatePickerContainer);
	
	  var _TimePickerContainer2 = _interopRequireDefault(_TimePickerContainer);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.DatePicker = _DatePickerContainer2.default;
	  exports.TimePicker = _TimePickerContainer2.default;
	});

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(13), __webpack_require__(68)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/PropTypes/between'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.isRequiredForA11y, global.between);
	    global.CircularProgress = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _isRequiredForA11y, _between) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _between2 = _interopRequireDefault(_between);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var ROATE_DISTANCE = 360 * 1.75;
	  var BASE_SIZE = 24; // font-icon font size
	
	  /**
	   * The `CircularProgress` component is used to give visual feedback while your app
	   * is loading.
	   *
	   * There are two different types of circular progress bars: `Determinate` and `Indeterminate`.
	   *
	   * A `Determinate` circular progress bar should be used when you want to keep track of the current
	   * progress. An example would be downloading a file.
	   *
	   * An `Indeterminate` circular progress bar should be used when you can not keep track of the progress
	   * yourself. An example would be waiting for some API call to complete.
	   */
	
	  var CircularProgress = function (_PureComponent) {
	    _inherits(CircularProgress, _PureComponent);
	
	    function CircularProgress() {
	      _classCallCheck(this, CircularProgress);
	
	      return _possibleConstructorReturn(this, (CircularProgress.__proto__ || Object.getPrototypeOf(CircularProgress)).apply(this, arguments));
	    }
	
	    _createClass(CircularProgress, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            scale = _props.scale,
	            style = _props.style,
	            className = _props.className,
	            value = _props.value,
	            determinateDashoffset = _props.determinateDashoffset,
	            centered = _props.centered,
	            props = _objectWithoutProperties(_props, ['scale', 'style', 'className', 'value', 'determinateDashoffset', 'centered']);
	
	        var isDeterminate = typeof value === 'number';
	        var circleStyle = void 0;
	        var svgStyle = style;
	        if (isDeterminate) {
	          var rotate = 'rotate3d(0, 0, 1, ' + ROATE_DISTANCE / 100 * value + 'deg)';
	          circleStyle = {
	            strokeDashoffset: determinateDashoffset - determinateDashoffset / 100 * value
	          };
	
	          svgStyle = Object.assign({}, style, {
	            WebkitTransform: (0, _classnames2.default)(style.WebkitTransform, rotate),
	            MozTransform: (0, _classnames2.default)(style.MozTransform, rotate),
	            transform: (0, _classnames2.default)(style.transform, rotate)
	          });
	        }
	
	        var accessibilityProps = {
	          role: 'progressbar',
	          'aria-valuemin': 0,
	          'aria-valuemax': 100
	        };
	
	        if (isDeterminate) {
	          accessibilityProps['aria-valuenow'] = value;
	        }
	
	        return _react2.default.createElement(
	          'svg',
	          _extends({}, props, accessibilityProps, {
	            style: svgStyle,
	            className: (0, _classnames2.default)('md-progress md-progress--circular', {
	              'md-block-centered': centered,
	              'md-progress--circular-determinate': isDeterminate,
	              'md-progress--circular-indeterminate': !isDeterminate
	            }, className),
	            width: scale * BASE_SIZE,
	            height: scale * BASE_SIZE,
	            viewBox: '0 0 66 66'
	          }),
	          _react2.default.createElement('circle', {
	            className: (0, _classnames2.default)('md-circular-progress-path', {
	              'md-circular-progress-path--animated': !isDeterminate
	            }),
	            strokeWidth: '6',
	            strokeLinecap: 'round',
	            style: circleStyle,
	            cx: '33',
	            cy: '33',
	            r: '30'
	          })
	        );
	      }
	    }]);
	
	    return CircularProgress;
	  }(_react.PureComponent);
	
	  CircularProgress.propTypes = {
	    /**
	     * The `id` prop is required for accessibility concerns.
	     * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
	     *
	     * > If the progressbar is describing the loading progress of a particular region of a page, the author
	     * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
	     * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
	     * because it is always readonly.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /* eslint-enable max-len */
	
	    /**
	     * A style object to apply to the svg. If this is a determinate `CircularProgress`,
	     * the `transform` (and vendor prefixes) styles will be merged with the current
	     * progress rotation.
	     */
	    style: _react.PropTypes.object.isRequired,
	
	    /**
	     * An optional className to apply to the svg.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The current value of the progress. If this value is defined, it will
	     * be converted to a determinate circular progress. The progress will not
	     * advance unless this value changes.
	     *
	     * This value should also be a number between 0 and 100.
	     */
	    value: (0, _between2.default)(_react.PropTypes.number, 0, 100),
	
	    /**
	     * The scale for the circular progress.
	     */
	    scale: _react.PropTypes.number.isRequired,
	
	    /**
	     * You probably don't want to update this. I'm not good at svg. This should
	     * match the scss variable `$md-circular-progress-stroke-dashoffset`.
	     */
	    determinateDashoffset: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if the the progress should be centered in it's container.
	     */
	    centered: _react.PropTypes.bool
	  };
	  CircularProgress.defaultProps = {
	    style: {},
	    scale: 1,
	    determinateDashoffset: 187,
	    centered: true
	  };
	  exports.default = CircularProgress;
	});

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(13), __webpack_require__(68)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/PropTypes/between'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.isRequiredForA11y, global.between);
	    global.LinearProgress = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _isRequiredForA11y, _between) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _between2 = _interopRequireDefault(_between);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var LinearProgress = function (_PureComponent) {
	    _inherits(LinearProgress, _PureComponent);
	
	    function LinearProgress() {
	      _classCallCheck(this, LinearProgress);
	
	      return _possibleConstructorReturn(this, (LinearProgress.__proto__ || Object.getPrototypeOf(LinearProgress)).apply(this, arguments));
	    }
	
	    _createClass(LinearProgress, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            value = _props.value,
	            query = _props.query,
	            centered = _props.centered,
	            props = _objectWithoutProperties(_props, ['className', 'value', 'query', 'centered']);
	
	        var isDeterminate = typeof value === 'number';
	
	        var accessibilityProps = {
	          role: 'progressbar',
	          'aria-valuemin': 0,
	          'aria-valuemax': 100
	        };
	
	        var style = void 0;
	        if (isDeterminate) {
	          style = { width: value + '%' };
	          accessibilityProps['aria-valuenow'] = value;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-progress md-progress--linear', { 'md-block-centered': centered }, className)
	          }),
	          _react2.default.createElement('div', _extends({}, accessibilityProps, {
	            style: style,
	            className: (0, _classnames2.default)('md-progress--linear-active', {
	              'md-progress--linear-query': query,
	              'md-progress--linear-determinate': isDeterminate,
	              'md-progress--linear-indeterminate': !isDeterminate
	            })
	          }))
	        );
	      }
	    }]);
	
	    return LinearProgress;
	  }(_react.PureComponent);
	
	  LinearProgress.propTypes = {
	    /**
	     * The `id` prop is required for accessibility concerns.
	     * [Progress Bar Role](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_progressbar_role)
	     *
	     * > If the progressbar is describing the loading progress of a particular region of a page, the author
	     * __SHOULD__ use aria-describedby to point to the status, and set the aria-busy attribute to true on the
	     * region until it is finished loading. It is not possible for the user to alter the value of a progressbar
	     * because it is always readonly.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /* eslint-enable max-len */
	    /**
	     * An optional className to apply to the linear progress container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The current value of the progress. If this value is defined, it will
	     * be converted to a determinate circular progress. The progress will not
	     * advance unless this value changes.
	     *
	     * This value should also be a number between 0 and 100.
	     */
	    value: (0, _between2.default)(_react.PropTypes.number, 0, 100),
	
	    /**
	     * Boolean if this should be a query indeterminate progress bar.
	     */
	    query: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the Linear Progress should be centered. This
	     * will only work if the `max-width` style is set.
	     */
	    centered: _react.PropTypes.bool
	  };
	  LinearProgress.defaultProps = {
	    query: false
	  };
	  exports.default = LinearProgress;
	});

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(466), __webpack_require__(465)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./LinearProgress'), require('./CircularProgress'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.LinearProgress, global.CircularProgress);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _LinearProgress2, _CircularProgress2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.CircularProgress = exports.LinearProgress = undefined;
	
	  var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	  var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.LinearProgress = _LinearProgress3.default;
	  exports.CircularProgress = _CircularProgress3.default;
	});

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(30), __webpack_require__(18), __webpack_require__(22), __webpack_require__(49), __webpack_require__(26), __webpack_require__(215)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../constants/CSSTransitionGroupTick'), require('../FontIcons/FontIcon'), require('../Helpers/AccessibleFakeInkedButton'), require('../Helpers/IconSeparator'), require('../Papers/Paper'), require('../TextFields/TextFieldDivider'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.CSSTransitionGroupTick, global.FontIcon, global.AccessibleFakeInkedButton, global.IconSeparator, global.Paper, global.TextFieldDivider);
	    global.Field = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _CSSTransitionGroupTick, _FontIcon, _AccessibleFakeInkedButton, _IconSeparator, _Paper, _TextFieldDivider) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  var _TextFieldDivider2 = _interopRequireDefault(_TextFieldDivider);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Field = function (_PureComponent) {
	    _inherits(Field, _PureComponent);
	
	    function Field(props) {
	      _classCallCheck(this, Field);
	
	      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props));
	
	      _this.state = { droppingClassName: null };
	      _this._transitionNewValue = _this._transitionNewValue.bind(_this);
	      return _this;
	    }
	
	    _createClass(Field, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.value !== nextProps.value) {
	          this._transitionNewValue();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	      }
	    }, {
	      key: '_transitionNewValue',
	      value: function _transitionNewValue() {
	        var _this2 = this;
	
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        this._timeout = setTimeout(function () {
	          _this2._timeout = setTimeout(function () {
	            _this2._timeout = null;
	
	            _this2.setState({ droppingClassName: null });
	          }, 300);
	
	          _this2.setState({ droppingClassName: _this2.state.droppingClassName + ' md-drop-enter-active ' });
	        }, _CSSTransitionGroupTick2.default);
	
	        this.setState({ droppingClassName: 'md-drop-enter' });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var droppingClassName = this.state.droppingClassName;
	
	        var _props = this.props,
	            id = _props.id,
	            name = _props.name,
	            value = _props.value,
	            active = _props.active,
	            below = _props.below,
	            style = _props.style,
	            className = _props.className,
	            label = _props.label,
	            disabled = _props.disabled,
	            placeholder = _props.placeholder,
	            activeLabel = _props.activeLabel,
	            iconChildren = _props.iconChildren,
	            iconClassName = _props.iconClassName,
	            lineDirection = _props.lineDirection,
	            required = _props.required,
	            error = _props.error,
	            toolbar = _props.toolbar,
	            props = _objectWithoutProperties(_props, ['id', 'name', 'value', 'active', 'below', 'style', 'className', 'label', 'disabled', 'placeholder', 'activeLabel', 'iconChildren', 'iconClassName', 'lineDirection', 'required', 'error', 'toolbar']);
	
	        var divider = void 0;
	        if (!below && !toolbar) {
	          divider = _react2.default.createElement(_TextFieldDivider2.default, {
	            key: 'text-divider',
	            active: active,
	            error: error,
	            lineDirection: lineDirection,
	            className: 'md-divider--select-field'
	          });
	        }
	
	        return _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          _extends({}, props, {
	            disabled: disabled,
	            component: _Paper2.default,
	            zDepth: below && active ? 1 : 0,
	            inkDisabled: !below,
	            style: style,
	            className: (0, _classnames2.default)('md-select-field', {
	              'md-text': activeLabel,
	              'md-text--secondary': !activeLabel && placeholder,
	              'md-text--disabled': disabled
	            }, className)
	          }),
	          _react2.default.createElement(
	            _IconSeparator2.default,
	            {
	              label: activeLabel || (label && active || !label) && placeholder || '',
	              labelClassName: droppingClassName,
	              className: (0, _classnames2.default)('md-text-field', {
	                'md-select-field--text-field': !below,
	                'md-select-field--btn': below,
	                'md-text-field--margin': !below && !label,
	                'md-text-field--floating-margin': label,
	                'md-text-field--toolbar': toolbar && !below
	              })
	            },
	            _react2.default.createElement(
	              _FontIcon2.default,
	              { iconClassName: iconClassName },
	              iconChildren
	            )
	          ),
	          divider,
	          _react2.default.createElement('input', {
	            key: 'value',
	            type: 'hidden',
	            id: id,
	            name: name,
	            value: value,
	            required: required
	          })
	        );
	      }
	    }]);
	
	    return Field;
	  }(_react.PureComponent);
	
	  Field.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    active: _react.PropTypes.bool,
	    below: _react.PropTypes.bool,
	    label: _react.PropTypes.node,
	    placeholder: _react.PropTypes.string,
	    iconChildren: _react.PropTypes.node,
	    iconClassName: _react.PropTypes.string,
	    activeLabel: _react.PropTypes.node,
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    name: _react.PropTypes.string,
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    lineDirection: _TextFieldDivider2.default.propTypes.lineDirection,
	    disabled: _react.PropTypes.bool,
	    required: _react.PropTypes.bool,
	    error: _react.PropTypes.bool,
	    toolbar: _react.PropTypes.bool
	  };
	  exports.default = Field;
	});

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(131)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./SelectField'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.SelectField);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _SelectField) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _SelectField2 = _interopRequireDefault(_SelectField);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _SelectField2.default;
	});

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(8), __webpack_require__(13), __webpack_require__(14), __webpack_require__(51)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/PropTypes/controlled'), require('./SelectionControl'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.deprecated, global.isRequiredForA11y, global.controlled, global.SelectionControl);
	    global.Checkbox = mod.exports;
	  }
	})(this, function (exports, _react, _deprecated, _isRequiredForA11y, _controlled, _SelectionControl) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Checkbox = function (_PureComponent) {
	    _inherits(Checkbox, _PureComponent);
	
	    function Checkbox() {
	      _classCallCheck(this, Checkbox);
	
	      return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	    }
	
	    _createClass(Checkbox, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            checkedIconChildren = _props.checkedIconChildren,
	            checkedIconClassName = _props.checkedIconClassName,
	            uncheckedIconChildren = _props.uncheckedIconChildren,
	            uncheckedIconClassName = _props.uncheckedIconClassName,
	            props = _objectWithoutProperties(_props, ['checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
	
	        return _react2.default.createElement(_SelectionControl2.default, _extends({
	          type: 'checkbox',
	          checkedCheckboxIconChildren: checkedIconChildren,
	          checkedCheckboxIconClassName: checkedIconClassName,
	          uncheckedCheckboxIconChildren: uncheckedIconChildren,
	          uncheckedCheckboxIconClassName: uncheckedIconClassName,
	          __superSecreteProp: true
	        }, props));
	      }
	    }]);
	
	    return Checkbox;
	  }(_react.PureComponent);
	
	  Checkbox.propTypes = {
	    /**
	     * An id to use with the checkbox. This is used for accessibility and so that the label
	     * triggers the checkbox toggle.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])),
	
	    /**
	     * An optional style to apply to the checkbox's container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the checkbox's container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * A label to display with the checkbox. This is required for accessibility and triggering
	     * the toggle.
	     */
	    label: _react.PropTypes.node,
	
	    /**
	     * Boolean if the label should appear before the checkbox icon.
	     */
	    labelBefore: _react.PropTypes.bool,
	
	    /**
	     * A name to use for the `Checkbox`. This is required for accessibility. If the checkbox is
	     * part of a group, it is recommended to make this a string ending in `[]` so that the
	     * value can be found from `document.querySelector('input[name="someName[]"]').value`.
	     */
	    name: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * Boolean if the `Checkbox` is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional function to call when the `checked` state of the `Checkbox` changes.
	     * The callback will incude the new checked state and the changeEvent.
	     *
	     * ```js
	     * onChange(changeEvent.target.checked, changeEvent);
	     * ```
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * An optional value for the `Checkbox`. It is recommended to use a value though.
	     */
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * Boolean if the `Checkbox` is checked by default.
	     */
	    defaultChecked: _react.PropTypes.bool,
	
	    /**
	     * A boolean if the `Checkbox` is currently checked. This will required the `onChange` prop
	     * to be defined.
	     */
	    checked: (0, _controlled2.default)(_react.PropTypes.bool, 'onChange', 'defaultChecked'),
	
	    /**
	     * Boolean if the `Checkbox` should be displayed inline.
	     */
	    inline: _react.PropTypes.bool,
	
	    /**
	     * Any children to use for the checked `FontIcon` of the `Checkbox`.
	     */
	    checkedIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className to use for the checked `FontIcon` of the `Checkbox`.
	     */
	    checkedIconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children to use for the unchecked `FontIcon` of the `Checkbox`.
	     */
	    uncheckedIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className to use for the unchecked `FontIcon` of the `Checkbox`.
	     */
	    uncheckedIconClassName: _react.PropTypes.string,
	
	    checkedIcon: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `checkedIconChildren` and `checkedIconClassName` props instead'),
	    uncheckedIcon: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `uncheckedIconChildren` and `uncheckedIconClassName` props instead')
	  };
	  Checkbox.defaultProps = {
	    checkedIconChildren: 'check_box',
	    uncheckedIconChildren: 'check_box_outline_blank'
	  };
	  exports.default = Checkbox;
	});

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(8), __webpack_require__(13), __webpack_require__(51)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('./SelectionControl'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.deprecated, global.isRequiredForA11y, global.SelectionControl);
	    global.Radio = mod.exports;
	  }
	})(this, function (exports, _react, _deprecated, _isRequiredForA11y, _SelectionControl) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Radio = function (_PureComponent) {
	    _inherits(Radio, _PureComponent);
	
	    function Radio() {
	      _classCallCheck(this, Radio);
	
	      return _possibleConstructorReturn(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	    }
	
	    _createClass(Radio, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            checkedIconChildren = _props.checkedIconChildren,
	            checkedIconClassName = _props.checkedIconClassName,
	            uncheckedIconChildren = _props.uncheckedIconChildren,
	            uncheckedIconClassName = _props.uncheckedIconClassName,
	            props = _objectWithoutProperties(_props, ['checkedIconChildren', 'checkedIconClassName', 'uncheckedIconChildren', 'uncheckedIconClassName']);
	
	        return _react2.default.createElement(_SelectionControl2.default, _extends({
	          type: 'radio',
	          checkedRadioIconChildren: checkedIconChildren,
	          checkedRadioIconClassName: checkedIconClassName,
	          uncheckedRadioIconChildren: uncheckedIconChildren,
	          uncheckedRadioIconClassName: uncheckedIconClassName,
	          __superSecreteProp: true
	        }, props));
	      }
	    }]);
	
	    return Radio;
	  }(_react.PureComponent);
	
	  Radio.propTypes = {
	    /**
	     * An id to use with the radio. This is used for accessibility and so that the label
	     * triggers the radio toggle.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])),
	
	    /**
	     * An optional style to apply to the radio's container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the radio's container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * A label to display with the radio. This is required for accessibility and triggering
	     * the toggle.
	     */
	    label: _react.PropTypes.string.isRequired,
	
	    /**
	     * Boolean if the label should appear before the radio icon.
	     */
	    labelBefore: _react.PropTypes.bool,
	
	    /**
	     * A name to use for the `Radio`. This is required for accessibility.
	     */
	    name: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * Boolean if the `Radio` is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * A function to call when the `Radio` triggers the `change` event. The `onChange` callback
	     * will include the current value of the checked `radio` and the change event.
	     *
	     * ```js
	     * onChange(changeEvent.target.value, changeEvent);
	     * ```
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * The value for the `Radio` component.
	     */
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
	
	    /**
	     * A boolean if the `Radio` is currently checked.
	     */
	    checked: _react.PropTypes.bool.isRequired,
	
	    /**
	     * Boolean if the `Radio` should be displayed inline.
	     */
	    inline: _react.PropTypes.bool,
	
	    /**
	     * Any children to use for the checked `FontIcon` of the `Radio`.
	     */
	    checkedIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className to use for the checked `FontIcon` of the `Radio`.
	     */
	    checkedIconClassName: _react.PropTypes.string,
	
	    /**
	     * Any children to use for the unchecked `FontIcon` of the `Radio`.
	     */
	    uncheckedIconChildren: _react.PropTypes.node,
	
	    /**
	     * An icon className to use for the unchecked `FontIcon` of the `Radio`.
	     */
	    uncheckedIconClassName: _react.PropTypes.string,
	
	    checkedIcon: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `checkedIconChildren` and `checkedIconClassName` props instead.'),
	    uncheckedIcon: (0, _deprecated2.default)(_react.PropTypes.node, 'Use the `uncheckedIconChildren` and `uncheckedIconClassName` props instead.')
	  };
	  Radio.defaultProps = {
	    checkedIconChildren: 'radio_button_checked',
	    uncheckedIconChildren: 'radio_button_unchecked'
	  };
	  exports.default = Radio;
	});

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(8), __webpack_require__(208)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-prop-types/lib/deprecated'), require('./SelectionControlGroup'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.deprecated, global.SelectionControlGroup);
	    global.RadioGroup = mod.exports;
	  }
	})(this, function (exports, _react, _deprecated, _SelectionControlGroup) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _SelectionControlGroup2 = _interopRequireDefault(_SelectionControlGroup);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var RadioGroup = function (_PureComponent) {
	    _inherits(RadioGroup, _PureComponent);
	
	    function RadioGroup() {
	      _classCallCheck(this, RadioGroup);
	
	      return _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).apply(this, arguments));
	    }
	
	    _createClass(RadioGroup, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            children = _props.children,
	            props = _objectWithoutProperties(_props, ['children']);
	
	        delete props.id;
	        delete props.defaultValue;
	
	        var _props2 = this.props,
	            id = _props2.id,
	            defaultValue = _props2.defaultValue;
	
	        if (!id) {
	          id = props.name + 'RadiosUniquePlease';
	        }
	
	        if (typeof props.value === 'undefined') {
	          if (typeof defaultValue === 'undefined') {
	            defaultValue = _react.Children.map(children, function (_ref) {
	              var value = _ref.props.value;
	              return value;
	            })[0];
	          }
	        }
	
	        var controls = _react.Children.map(children, function (radio) {
	          var props = Object.assign({}, radio.props);
	          delete props.checkedIcon;
	          delete props.uncheckedIcon;
	          delete props.checkedIconChildren;
	          delete props.checkedIconClassName;
	          delete props.uncheckedIconChildren;
	          delete props.uncheckedIconClassName;
	          return _extends({}, props);
	        });
	        return _react2.default.createElement(_SelectionControlGroup2.default, _extends({}, props, { id: id, defaultValue: defaultValue, type: 'radio', controls: controls }));
	      }
	    }]);
	
	    return RadioGroup;
	  }(_react.PureComponent);
	
	  RadioGroup.propTypes = {
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    defaultValue: _react.PropTypes.string,
	    className: _react.PropTypes.string,
	    children: _react.PropTypes.arrayOf(_react.PropTypes.node).isRequired,
	    inline: _react.PropTypes.bool,
	    onChange: _react.PropTypes.func,
	    name: _react.PropTypes.string,
	    value: _react.PropTypes.string,
	
	    _deprecated: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use the `SelectionControlGroup` component instead')
	  };
	  exports.default = RadioGroup;
	});

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(8), __webpack_require__(13), __webpack_require__(14), __webpack_require__(51)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../utils/PropTypes/controlled'), require('./SelectionControl'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.deprecated, global.isRequiredForA11y, global.controlled, global.SelectionControl);
	    global.Switch = mod.exports;
	  }
	})(this, function (exports, _react, _deprecated, _isRequiredForA11y, _controlled, _SelectionControl) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Switch = function (_PureComponent) {
	    _inherits(Switch, _PureComponent);
	
	    function Switch() {
	      _classCallCheck(this, Switch);
	
	      return _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
	    }
	
	    _createClass(Switch, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            toggled = _props.toggled,
	            defaultToggled = _props.defaultToggled,
	            props = _objectWithoutProperties(_props, ['toggled', 'defaultToggled']);
	
	        if (typeof toggled !== 'undefined' && typeof props.checked === 'undefined') {
	          props.checked = toggled;
	        }
	
	        if (typeof defaultToggled !== 'undefined' && typeof props.defaultChecked === 'undefined') {
	          props.defaultChecked = defaultToggled;
	        }
	
	        return _react2.default.createElement(_SelectionControl2.default, _extends({ type: 'switch' }, props, { __superSecreteProp: true }));
	      }
	    }]);
	
	    return Switch;
	  }(_react.PureComponent);
	
	  Switch.propTypes = {
	    /**
	     * An id to use with the switch. This is used for accessibility and so that the label
	     * triggers the switch toggle.
	     */
	    id: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])),
	
	    /**
	     * An optional style to apply to the switch's container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the switch's container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * A label to display with the switch. This is required for accessibility and triggering
	     * the toggle.
	     */
	    label: _react.PropTypes.node,
	
	    /**
	     * Boolean if the label should appear before the switch.
	     */
	    labelBefore: _react.PropTypes.bool,
	
	    /**
	     * A name to use for the `Switch`. This is required for accessibility since behind the scenes
	     * the `Switch` is renders as an `<input type="checkbox" />`.
	     */
	    name: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * Boolean if the `Switch` is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional function to call when the `checked` state of the `Switch` changes.
	     * The callback will incude the new checked state and the changeEvent.
	     *
	     * ```js
	     * onChange(changeEvent.target.checked, changeEvent);
	     * ```
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * An optional value for the `Switch`. It is recommended to use a value though.
	     */
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * Boolean if the `Switch` is checked by default.
	     */
	    defaultChecked: _react.PropTypes.bool,
	
	    /**
	     * A boolean if the `Switch` is currently checked. This will required the `onChange` prop
	     * to be defined.
	     */
	    checked: (0, _controlled2.default)(_react.PropTypes.bool, 'onChange', 'defaultChecked'),
	
	    defaultToggled: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use the `defaultChecked` prop instead'),
	    toggled: (0, _deprecated2.default)(_react.PropTypes.bool, 'Use the `checked` prop instead')
	  };
	  exports.default = Switch;
	});

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(22)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Helpers/AccessibleFakeInkedButton'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.AccessibleFakeInkedButton);
	    global.SwitchThumb = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _AccessibleFakeInkedButton) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var disabledInteractions = ['mouse'];
	
	  /**
	   * This is the `Thumb` for the switch. The `ink` in the Thumb is only active on touch and keyboard
	   * interactions, so the `AccessibleFakeInkButton` does not work for this case.
	   *
	   * This component really just is used for custom inkage.
	   */
	
	  var SwitchThumb = function (_PureComponent) {
	    _inherits(SwitchThumb, _PureComponent);
	
	    function SwitchThumb() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, SwitchThumb);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SwitchThumb.__proto__ || Object.getPrototypeOf(SwitchThumb)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
	        // The switch's thumb needs to have an onClick handler to enable keyboard accessibility, however,
	        // this actually triggers two click events since the slider's track needs to be clickable as well.
	        // Stop propagation to prevent the thumb click AND track propagation click.
	        e.stopPropagation();
	        _this.props.onClick(e);
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(SwitchThumb, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            disabled = _props.disabled,
	            checked = _props.checked,
	            className = _props.className,
	            props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className']);
	
	        return _react2.default.createElement(_AccessibleFakeInkedButton2.default, _extends({}, props, {
	          onClick: this._handleClick,
	          disabled: disabled,
	          disabledInteractions: disabledInteractions,
	          inkContainerClassName: 'md-ink-container--2x',
	          className: (0, _classnames2.default)('md-switch-thumb', {
	            'md-switch-thumb--disabled': disabled,
	            'md-switch-thumb--on': checked,
	            'md-switch-thumb--off': !checked
	          }, className)
	        }));
	      }
	    }]);
	
	    return SwitchThumb;
	  }(_react.PureComponent);
	
	  SwitchThumb.propTypes = {
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    checked: _react.PropTypes.bool,
	    onClick: _react.PropTypes.func.isRequired
	  };
	  exports.default = SwitchThumb;
	});

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(474)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./SwitchThumb'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.SwitchThumb);
	    global.SwitchTrack = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _SwitchThumb) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _SwitchThumb2 = _interopRequireDefault(_SwitchThumb);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var SwitchTrack = function (_PureComponent) {
	    _inherits(SwitchTrack, _PureComponent);
	
	    function SwitchTrack() {
	      _classCallCheck(this, SwitchTrack);
	
	      return _possibleConstructorReturn(this, (SwitchTrack.__proto__ || Object.getPrototypeOf(SwitchTrack)).apply(this, arguments));
	    }
	
	    _createClass(SwitchTrack, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            disabled = _props.disabled,
	            checked = _props.checked,
	            className = _props.className,
	            props = _objectWithoutProperties(_props, ['disabled', 'checked', 'className']);
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, {
	            className: (0, _classnames2.default)('md-switch-track', {
	              'md-pointer--hover': !disabled,
	              'md-switch-track--disabled': disabled,
	              'md-switch-track--on': checked,
	              'md-switch-track--off': !checked
	            }, className)
	          }),
	          _react2.default.createElement(_SwitchThumb2.default, { disabled: disabled, checked: checked, onClick: props.onClick })
	        );
	      }
	    }]);
	
	    return SwitchTrack;
	  }(_react.PureComponent);
	
	  SwitchTrack.propTypes = {
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    checked: _react.PropTypes.bool
	  };
	  exports.default = SwitchTrack;
	});

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(51), __webpack_require__(208), __webpack_require__(470), __webpack_require__(471), __webpack_require__(472), __webpack_require__(473)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./SelectionControl'), require('./SelectionControlGroup'), require('./Checkbox'), require('./Radio'), require('./RadioGroup'), require('./Switch'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.SelectionControl, global.SelectionControlGroup, global.Checkbox, global.Radio, global.RadioGroup, global.Switch);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _SelectionControl, _SelectionControlGroup2, _Checkbox2, _Radio2, _RadioGroup2, _Switch2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.Switch = exports.RadioGroup = exports.Radio = exports.Checkbox = exports.SelectionControlGroup = exports.SelectionControl = undefined;
	
	  var _SelectionControl2 = _interopRequireDefault(_SelectionControl);
	
	  var _SelectionControlGroup3 = _interopRequireDefault(_SelectionControlGroup2);
	
	  var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	  var _Radio3 = _interopRequireDefault(_Radio2);
	
	  var _RadioGroup3 = _interopRequireDefault(_RadioGroup2);
	
	  var _Switch3 = _interopRequireDefault(_Switch2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _SelectionControl2.default;
	  exports.SelectionControl = _SelectionControl2.default;
	  exports.SelectionControlGroup = _SelectionControlGroup3.default;
	  exports.Checkbox = _Checkbox3.default;
	  exports.Radio = _Radio3.default;
	  exports.RadioGroup = _RadioGroup3.default;
	  exports.Switch = _Switch3.default;
	});

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(125), __webpack_require__(39)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('../Drawers/Drawer'), require('../utils/PropTypes/componentDeprecated'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.Drawer, global.componentDeprecated);
	    global.Sidebar = mod.exports;
	  }
	})(this, function (exports, _react, _Drawer, _componentDeprecated) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _Drawer2 = _interopRequireDefault(_Drawer);
	
	  var _componentDeprecated2 = _interopRequireDefault(_componentDeprecated);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Sidebar = function (_PureComponent) {
	    _inherits(Sidebar, _PureComponent);
	
	    function Sidebar() {
	      _classCallCheck(this, Sidebar);
	
	      return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).apply(this, arguments));
	    }
	
	    _createClass(Sidebar, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            isOpen = _props.isOpen,
	            header = _props.header,
	            overlay = _props.overlay,
	            children = _props.children,
	            onOverlayClick = _props.onOverlayClick,
	            align = _props.align,
	            items = _props.items,
	            fixed = _props.fixed,
	            props = _objectWithoutProperties(_props, ['isOpen', 'header', 'overlay', 'children', 'onOverlayClick', 'align', 'items', 'fixed']);
	
	        delete props.responsive;
	
	        return _react2.default.createElement(
	          _Drawer2.default,
	          _extends({}, props, {
	            visible: isOpen,
	            onVisibilityChange: onOverlayClick,
	            navItems: items,
	            position: align,
	            overflay: overlay,
	            header: header,
	            inline: !fixed
	          }),
	          children
	        );
	      }
	    }]);
	
	    return Sidebar;
	  }(_react.PureComponent);
	
	  Sidebar.propTypes = {
	    deprecated: (0, _componentDeprecated2.default)('All the functionality and responsiveness of a `Sidebar` can be handled by the `Drawer` instead.' + ' Switch to the `Drawer` component instead.'),
	
	    /**
	     * Boolean if the overlay should appear when opened.
	     */
	    overlay: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the sidebar is visible and open.
	     */
	    isOpen: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the sidebar is fixed to the side of the page.
	     */
	    fixed: _react.PropTypes.bool,
	
	    /**
	     * Boolean if sidebar should be responsive.
	     */
	    responsive: _react.PropTypes.bool,
	
	    /**
	     * An optional header to display above the children or list items.
	     */
	    header: _react.PropTypes.node,
	
	    /**
	     * Any children to display after the generated list of items.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The transition name to use for the overlay.
	     */
	    transitionName: _react.PropTypes.string,
	
	    /**
	     * The enter timeout for the overlay transition.
	     */
	    transitionEnterTimeout: _react.PropTypes.number,
	
	    /**
	     * The leave timeout for the overlay transition.
	     */
	    transitionLeaveTimeout: _react.PropTypes.number,
	
	    /**
	     * An optional function to call when the overlay is clicked.
	     * This should normally close the sidebar.
	     */
	    onOverlayClick: _react.PropTypes.func,
	
	    /**
	     * The position to align the sidebar of the screen to.
	     */
	    align: _react.PropTypes.oneOf(['left', 'right']),
	
	    /**
	     * A list of item props to convert into `ListItem`, `Divider`, or
	     * `Subheader` components.
	     *
	     * ##### Item Descriptions
	     */
	    items: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      /**
	       * Boolean if this item is a divider.
	       */
	      divider: _react.PropTypes.bool,
	
	      /**
	       * Boolean if this item is a subheader.
	       */
	      subheader: _react.PropTypes.bool,
	
	      /**
	       * The primary text to display in a `ListItem` or a `Subheader`.
	       */
	      primaryText: _react.PropTypes.string
	    }))
	  };
	  Sidebar.defaultProps = {
	    align: 'left'
	  };
	  exports.default = Sidebar;
	});

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(477)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Sidebar'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Sidebar);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Sidebar) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Sidebar2.default;
	});

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.DiscreteValue = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  var _slicedToArray = function () {
	    function sliceIterator(arr, i) {
	      var _arr = [];
	      var _n = true;
	      var _d = false;
	      var _e = undefined;
	
	      try {
	        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	          _arr.push(_s.value);
	
	          if (i && _arr.length === i) break;
	        }
	      } catch (err) {
	        _d = true;
	        _e = err;
	      } finally {
	        try {
	          if (!_n && _i["return"]) _i["return"]();
	        } finally {
	          if (_d) throw _e;
	        }
	      }
	
	      return _arr;
	    }
	
	    return function (arr, i) {
	      if (Array.isArray(arr)) {
	        return arr;
	      } else if (Symbol.iterator in Object(arr)) {
	        return sliceIterator(arr, i);
	      } else {
	        throw new TypeError("Invalid attempt to destructure non-iterable instance");
	      }
	    };
	  }();
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var DiscreteValue = function (_PureComponent) {
	    _inherits(DiscreteValue, _PureComponent);
	
	    function DiscreteValue() {
	      _classCallCheck(this, DiscreteValue);
	
	      return _possibleConstructorReturn(this, (DiscreteValue.__proto__ || Object.getPrototypeOf(DiscreteValue)).apply(this, arguments));
	    }
	
	    _createClass(DiscreteValue, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            discrete = _props.discrete,
	            dragging = _props.dragging,
	            thumbLeft = _props.thumbLeft,
	            active = _props.active,
	            value = _props.value,
	            valuePrecision = _props.valuePrecision,
	            props = _objectWithoutProperties(_props, ['style', 'className', 'discrete', 'dragging', 'thumbLeft', 'active', 'value', 'valuePrecision']);
	
	        if (!discrete || !active) {
	          return null;
	        }
	
	        var valueStr = value.toFixed(valuePrecision);
	        if (valuePrecision > 0) {
	          var _valueStr$split = valueStr.split('.'),
	              _valueStr$split2 = _slicedToArray(_valueStr$split, 2),
	              w = _valueStr$split2[0],
	              d = _valueStr$split2[1];
	
	          if (parseInt(d, 10) === 0) {
	            valueStr = w;
	          }
	        }
	        return _react2.default.createElement(
	          'span',
	          _extends({}, props, {
	            style: Object.assign({}, style, { left: thumbLeft }),
	            className: (0, _classnames2.default)('md-slider-discrete-value', className, {
	              'md-slider-discrete-value--dragging': dragging
	            })
	          }),
	          valueStr
	        );
	      }
	    }]);
	
	    return DiscreteValue;
	  }(_react.PureComponent);
	
	  DiscreteValue.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    discrete: _react.PropTypes.bool,
	    dragging: _react.PropTypes.bool,
	    active: _react.PropTypes.bool,
	    value: _react.PropTypes.number.isRequired,
	    thumbLeft: _react.PropTypes.string.isRequired,
	    valuePrecision: _react.PropTypes.number.isRequired
	  };
	  exports.default = DiscreteValue;
	});

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(8), __webpack_require__(13), __webpack_require__(11), __webpack_require__(12), __webpack_require__(133), __webpack_require__(513), __webpack_require__(514), __webpack_require__(14), __webpack_require__(481), __webpack_require__(484), __webpack_require__(52)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('react-prop-types/lib/deprecated'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/keyCodes'), require('../utils/getField'), require('../utils/EventUtils/isValidClick'), require('../utils/NumberUtils/calculateValueDistance'), require('../utils/NumberUtils/isWithinStep'), require('../utils/PropTypes/controlled'), require('./SliderLabel'), require('./Track'), require('../TextFields/TextField'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.deprecated, global.isRequiredForA11y, global.keyCodes, global.getField, global.isValidClick, global.calculateValueDistance, global.isWithinStep, global.controlled, global.SliderLabel, global.Track, global.TextField);
	    global.Slider = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _deprecated, _isRequiredForA11y, _keyCodes, _getField, _isValidClick, _calculateValueDistance, _isWithinStep, _controlled, _SliderLabel, _Track, _TextField) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _isValidClick2 = _interopRequireDefault(_isValidClick);
	
	  var _calculateValueDistance2 = _interopRequireDefault(_calculateValueDistance);
	
	  var _isWithinStep2 = _interopRequireDefault(_isWithinStep);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _SliderLabel2 = _interopRequireDefault(_SliderLabel);
	
	  var _Track2 = _interopRequireDefault(_Track);
	
	  var _TextField2 = _interopRequireDefault(_TextField);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Slider = function (_PureComponent) {
	    _inherits(Slider, _PureComponent);
	
	    function Slider(props) {
	      _classCallCheck(this, Slider);
	
	      var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
	      var scale = Math.abs(props.max - props.min) / props.step;
	
	      var value = typeof props.value !== 'undefined' ? props.value : props.defaultValue;
	
	      var distance = value;
	      if (distance === props.min) {
	        distance = 0;
	      } else if (distance === props.max) {
	        distance = 100;
	      } else if (props.min > 1 && props.defaultValue !== 0) {
	        distance = Math.max(0, Math.min(100, (props.defaultValue - props.min) / (props.max - props.min) * 100));
	      } else {
	        distance = value / props.max * 100;
	      }
	
	      var thumbLeft = _this._calcLeft(distance);
	      var trackFillWidth = distance + '%';
	
	      if (typeof props.value !== 'undefined') {
	        value = undefined;
	      }
	
	      var trackWidth = void 0;
	      if (props.label && !props.editable && !props.leftIcon && !props.rightIcon) {
	        trackWidth = '100%';
	      }
	
	      _this.state = {
	        value: value,
	        scale: scale,
	        distance: distance,
	        thumbLeft: thumbLeft,
	        trackWidth: trackWidth,
	        trackFillWidth: trackFillWidth,
	        active: false,
	        dragging: false,
	        maskInked: false
	      };
	      _this._dragAdded = false;
	
	      _this._focusThumb = _this._focusThumb.bind(_this);
	      _this._updatePosition = _this._updatePosition.bind(_this);
	      _this._handleDragStart = _this._handleDragStart.bind(_this);
	      _this._handleDragMove = _this._handleDragMove.bind(_this);
	      _this._handleDragEnd = _this._handleDragEnd.bind(_this);
	      _this._handleFocus = _this._handleFocus.bind(_this);
	      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._handleIncrement = _this._handleIncrement.bind(_this);
	      _this._handleTextFieldChange = _this._handleTextFieldChange.bind(_this);
	      _this._blurOnOutsideClick = _this._blurOnOutsideClick.bind(_this);
	      _this._calcTrackWidth = _this._calcTrackWidth.bind(_this);
	      _this._animateDiscreteInk = _this._animateDiscreteInk.bind(_this);
	      _this._setTrack = _this._setTrack.bind(_this);
	      _this._setField = _this._setField.bind(_this);
	      _this._setNode = _this._setNode.bind(_this);
	      return _this;
	    }
	
	    _createClass(Slider, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            leftIcon = _props.leftIcon,
	            rightIcon = _props.rightIcon,
	            label = _props.label,
	            min = _props.min,
	            max = _props.max,
	            step = _props.step;
	
	        if (leftIcon !== nextProps.leftIcon || rightIcon !== nextProps.rightIcon || label !== nextProps.label) {
	          this._calcTrackWidth(nextProps);
	        }
	
	        if (min !== nextProps.min || max !== nextProps.max || step !== nextProps.step) {
	          this.setState({ scale: Math.abs(nextProps.max - nextProps.min) / nextProps.step });
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var _state = this.state,
	            active = _state.active,
	            manualIncrement = _state.manualIncrement;
	
	        var fn = window[(active ? 'add' : 'remove') + 'EventListener'];
	        if (active !== prevState.active) {
	          fn('click', this._blurOnOutsideClick);
	
	          if (active) {
	            this._focusThumb();
	          }
	        }
	
	        var addDrag = active && !manualIncrement;
	        fn = window[(addDrag ? 'add' : 'remove') + 'EventListener'];
	        if (this._dragAdded !== addDrag) {
	          fn('mousemove', this._handleDragMove);
	          fn('mouseup', this._handleDragEnd);
	          fn('touchmove', this._handleDragMove);
	          fn('touchend', this._handleDragEnd);
	
	          this._dragAdded = addDrag;
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._dragAdded) {
	          var rm = window.removeEventListener;
	          rm('mousemove', this._handleMouseMove);
	          rm('mouseup', this._handleMouseUp);
	          rm('touchmove', this._handleDragMove);
	          rm('touchend', this._handleDragEnd);
	          rm('click', this._blurOnOutsideClick);
	        }
	
	        if (this._inkTimeout) {
	          clearTimeout(this._inkTimeout);
	        }
	
	        if (this._focusTimeout) {
	          clearTimeout(this._focusTimeout);
	        }
	      }
	    }, {
	      key: '_calcLeft',
	      value: function _calcLeft(value) {
	        return 'calc(' + value + '% - 6px)';
	      }
	    }, {
	      key: '_isTextField',
	      value: function _isTextField(target) {
	        return this._textField && this._textField.contains(target);
	      }
	    }, {
	      key: '_isValidClassList',
	      value: function _isValidClassList(classList) {
	        var invalid = false;
	        ['md-slider-label', 'md-slider-ind', 'md-icon'].some(function (cl) {
	          invalid = classList.contains(cl);
	          return invalid;
	        });
	
	        return !invalid;
	      }
	    }, {
	      key: '_updatePosition',
	      value: function _updatePosition(e, normalize) {
	        var x = (e.changedTouches ? e.changedTouches[0] : e).clientX;
	        var scale = this.state.scale;
	        var _props2 = this.props,
	            onChange = _props2.onChange,
	            onDragChange = _props2.onDragChange,
	            min = _props2.min,
	            max = _props2.max,
	            step = _props2.step;
	
	        var _calculateValueDistan = (0, _calculateValueDistance2.default)(x, this._track.offsetWidth, this._track.getBoundingClientRect().left, scale, step, min, max, normalize),
	            value = _calculateValueDistan.value,
	            distance = _calculateValueDistan.distance;
	
	        if (onChange) {
	          onChange(value, e);
	        }
	
	        if (!normalize && onDragChange) {
	          onDragChange(distance, value, e);
	        }
	
	        var state = {
	          value: value,
	          active: true,
	          distance: distance,
	          manualIncrement: false,
	          dragging: !normalize,
	          thumbLeft: this._calcLeft(distance),
	          trackFillWidth: distance + '%'
	        };
	
	        if (e.type === 'touchend' || e.type === 'mousedown') {
	          state.maskInked = false;
	        }
	
	        if (typeof this.props.value !== 'undefined') {
	          delete state.value;
	        }
	
	        this.setState(state);
	      }
	    }, {
	      key: '_handleDragStart',
	      value: function _handleDragStart(e) {
	        if (e.type === 'mousedown' && this.props.onMouseDown) {
	          this.props.onMouseDown(e);
	        } else if (e.type === 'touchstart' && this.props.onTouchStart) {
	          this.props.onTouchStart(e);
	        }
	
	        if (this.props.disabled || e.type === 'mousedown' && !(0, _isValidClick2.default)(e, 'mousedown') || e.target.className.match(/text-field/)) {
	          return;
	        }
	
	        var classList = e.target.classList;
	
	        var isDiscreteValue = classList.contains('md-slider-discrete-value');
	        if (classList.contains('md-slider-thumb') || isDiscreteValue) {
	          // Prevents text highlighting while dragging.
	          e.preventDefault();
	          this.setState({ dragging: true, active: true, manualIncrement: false, maskInked: false });
	        } else if (!this._isTextField(e.target) && this._isValidClassList(classList)) {
	          this._updatePosition(e, true);
	        }
	      }
	    }, {
	      key: '_setNode',
	      value: function _setNode(node) {
	        this._node = (0, _reactDom.findDOMNode)(node);
	      }
	    }, {
	      key: '_setTrack',
	      value: function _setTrack(track) {
	        this._track = (0, _reactDom.findDOMNode)(track);
	      }
	    }, {
	      key: '_setField',
	      value: function _setField(field) {
	        this._field = (0, _reactDom.findDOMNode)(field);
	        this._calcTrackWidth(this.props);
	      }
	    }, {
	      key: '_handleDragMove',
	      value: function _handleDragMove(e) {
	        if (this.props.disabled || !this.state.dragging) {
	          return;
	        }
	
	        // Stops the text highlighting while dragging
	        e.preventDefault();
	
	        this._updatePosition(e, false);
	      }
	    }, {
	      key: '_handleDragEnd',
	      value: function _handleDragEnd(e) {
	        if (!this.state.dragging || this.props.disabled || e.type === 'mouseup' && !(0, _isValidClick2.default)(e)) {
	          return;
	        }
	
	        this._updatePosition(e, true);
	      }
	    }, {
	      key: '_blurOnOutsideClick',
	      value: function _blurOnOutsideClick(e) {
	        if (this.state.dragging && !this.state.manualIncrement || this.props.disabled) {
	          return;
	        }
	
	        if (!this._node.contains(e.target)) {
	          this.setState({ active: false, maskInked: false });
	        }
	      }
	    }, {
	      key: '_handleIncrement',
	      value: function _handleIncrement(incrementedValue, e, disableTransition) {
	        var _props3 = this.props,
	            onChange = _props3.onChange,
	            min = _props3.min,
	            max = _props3.max,
	            discrete = _props3.discrete;
	
	
	        var distance = Math.max(0, Math.min(100, (incrementedValue - min) / (max - min) * 100));
	        var value = Math.max(min, Math.min(max, incrementedValue));
	
	        if (onChange) {
	          onChange(value, e);
	        }
	
	        var state = {
	          distance: distance,
	          manualIncrement: true,
	          thumbLeft: this._calcLeft(distance),
	          trackFillWidth: distance + '%',
	          dragging: Math.abs(this.state.distance - distance) < 2 && disableTransition
	        };
	
	        if (typeof this.props.value === 'undefined') {
	          state.value = value;
	        }
	
	        if (e.type === 'keydown' && !discrete) {
	          state.maskInked = true;
	        }
	
	        this.setState(state);
	      }
	    }, {
	      key: '_handleTextFieldChange',
	      value: function _handleTextFieldChange(newValue, e) {
	        this._handleIncrement(newValue, e, false);
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        var key = e.which || e.keyCode;
	        var _props4 = this.props,
	            min = _props4.min,
	            max = _props4.max,
	            step = _props4.step,
	            disabled = _props4.disabled;
	
	        if (disabled) {
	          return;
	        }
	
	        if (key === _keyCodes.TAB) {
	          this.setState({ active: false, maskInked: false });
	          return;
	        } else if (key !== _keyCodes.LEFT && key !== _keyCodes.RIGHT) {
	          return;
	        }
	
	        var nextValue = (0, _getField2.default)(this.props, this.state);
	        nextValue = Math.max(min, Math.min((key === _keyCodes.LEFT ? -step : step) + nextValue, max));
	
	        this._handleIncrement(nextValue, e, true);
	      }
	    }, {
	      key: '_handleKeyUp',
	      value: function _handleKeyUp(e) {
	        if ((e.which || e.keyCode) !== _keyCodes.TAB) {
	          return;
	        }
	
	        if (this.props.discrete) {
	          this._animateDiscreteInk();
	        }
	
	        this.setState({ maskInked: true });
	      }
	    }, {
	      key: '_handleFocus',
	      value: function _handleFocus() {
	        this.setState({ active: true });
	      }
	    }, {
	      key: '_calcTrackWidth',
	      value: function _calcTrackWidth(props) {
	        var editable = props.editable,
	            leftIcon = props.leftIcon,
	            rightIcon = props.rightIcon,
	            inputWidth = props.inputWidth,
	            label = props.label;
	
	
	        if (!label) {
	          this.setState({ trackWidth: null });
	          return;
	        }
	
	        var trackWidth = null;
	        if (!leftIcon && !rightIcon && !editable) {
	          trackWidth = '100%';
	        } else if (editable && !leftIcon) {
	          var cs = window.getComputedStyle(this._textField);
	          var pl = parseInt(cs.getPropertyValue('padding-left'), 10);
	          var ml = parseInt(cs.getPropertyValue('margin-left'), 10);
	
	          trackWidth = pl + ml + inputWidth;
	        }
	
	        if (trackWidth) {
	          this.setState({ trackWidth: trackWidth });
	        }
	      }
	    }, {
	      key: '_animateDiscreteInk',
	      value: function _animateDiscreteInk() {
	        var _this2 = this;
	
	        var wait = this.props.discreteInkTransitionTime;
	        if (this._inkTimeout) {
	          clearTimeout(this._inkTimeout);
	        }
	
	        this._inkTimeout = setTimeout(function () {
	          _this2.setState({ leaving: true, maskInked: false });
	
	          _this2._inkTimeout = setTimeout(function () {
	            _this2._inkTimeout = null;
	            _this2.setState({ leaving: false });
	          }, wait);
	        }, wait);
	      }
	    }, {
	      key: '_focusThumb',
	      value: function _focusThumb() {
	        var _this3 = this;
	
	        if (this._focusTimeout) {
	          clearTimeout(this._focusTimeout);
	        }
	
	        this._focusTimeout = setTimeout(function () {
	          _this3._focusTimeout = null;
	          if (!_this3._thumb) {
	            _this3._thumb = _this3._node.querySelector('.md-slider-thumb');
	          }
	
	          _this3._thumb.focus();
	        }, 100);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state2 = this.state,
	            dragging = _state2.dragging,
	            active = _state2.active,
	            thumbLeft = _state2.thumbLeft,
	            trackFillWidth = _state2.trackFillWidth,
	            maskInked = _state2.maskInked,
	            trackWidth = _state2.trackWidth,
	            scale = _state2.scale,
	            distance = _state2.distance;
	
	        var _props5 = this.props,
	            id = _props5.id,
	            min = _props5.min,
	            max = _props5.max,
	            disabled = _props5.disabled,
	            className = _props5.className,
	            trackStyle = _props5.trackStyle,
	            trackClassName = _props5.trackClassName,
	            thumbStyle = _props5.thumbStyle,
	            thumbClassName = _props5.thumbClassName,
	            discreteValueStyle = _props5.discreteValueStyle,
	            discreteValueClassName = _props5.discreteValueClassName,
	            label = _props5.label,
	            editable = _props5.editable,
	            step = _props5.step,
	            inputWidth = _props5.inputWidth,
	            leftIcon = _props5.leftIcon,
	            rightIcon = _props5.rightIcon,
	            discrete = _props5.discrete,
	            discreteTicks = _props5.discreteTicks,
	            tickWidth = _props5.tickWidth,
	            valuePrecision = _props5.valuePrecision,
	            props = _objectWithoutProperties(_props5, ['id', 'min', 'max', 'disabled', 'className', 'trackStyle', 'trackClassName', 'thumbStyle', 'thumbClassName', 'discreteValueStyle', 'discreteValueClassName', 'label', 'editable', 'step', 'inputWidth', 'leftIcon', 'rightIcon', 'discrete', 'discreteTicks', 'tickWidth', 'valuePrecision']);
	
	        delete props.value;
	        delete props.onChange;
	        delete props.onDragChange;
	        delete props.discreteInkTransitionTime;
	
	        // delete deprecated
	        delete props.stepPrecision;
	
	        var value = (0, _getField2.default)(this.props, this.state);
	        var rightChildren = rightIcon;
	        if (editable) {
	          rightChildren = _react2.default.createElement(_TextField2.default, {
	            id: id + 'Editor',
	            ref: this._setField,
	            type: 'number',
	            value: value,
	            inputClassName: 'md-slider-editor',
	            style: { width: inputWidth },
	            onChange: this._handleTextFieldChange,
	            step: step
	          });
	        }
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, {
	            ref: this._setNode,
	            className: (0, _classnames2.default)('md-slider-container', className, {
	              'md-pointer--hover': !disabled
	            }),
	            onMouseDown: this._handleDragStart,
	            onTouchStart: this._handleDragStart
	          }),
	          _react2.default.createElement(
	            _SliderLabel2.default,
	            { htmlFor: id },
	            label
	          ),
	          _react2.default.createElement('input', {
	            id: id,
	            type: 'range',
	            className: 'md-slider-input',
	            readOnly: true,
	            min: min,
	            max: max,
	            value: value,
	            disabled: disabled
	          }),
	          leftIcon,
	          _react2.default.createElement(_Track2.default, {
	            ref: this._setTrack,
	            style: Object.assign({}, trackStyle, { width: trackWidth }),
	            className: (0, _classnames2.default)(trackClassName, {
	              'md-slider-track--ind-left': leftIcon,
	              'md-slider-track--ind-right': rightIcon
	            }),
	            thumbStyle: thumbStyle,
	            thumbClassName: thumbClassName,
	            discreteValueStyle: discreteValueStyle,
	            discreteValueClassName: discreteValueClassName,
	            active: active,
	            dragging: dragging,
	            disabled: disabled,
	            thumbLeft: thumbLeft,
	            trackFillWidth: trackFillWidth,
	            on: !disabled && distance > min,
	            off: distance === 0,
	            maskInked: maskInked,
	            onThumbKeyUp: this._handleKeyUp,
	            onThumbKeyDown: this._handleKeyDown,
	            onThumbFocus: this._handleFocus,
	            discrete: discrete,
	            tickWidth: tickWidth,
	            discreteTicks: discreteTicks,
	            valuePrecision: valuePrecision,
	            step: step,
	            scale: scale,
	            value: value
	          }),
	          rightChildren
	        );
	      }
	    }]);
	
	    return Slider;
	  }(_react.PureComponent);
	
	  Slider.propTypes = {
	    /**
	     * An id to use for the `Slider`. This is required if the `label` prop
	     * is defined.
	     */
	    id: function id(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      if (typeof props.label === 'undefined') {
	        return _react.PropTypes.string.apply(_react.PropTypes, [props, propName, component].concat(others));
	      }
	
	      return (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])).apply(undefined, [props, propName, component].concat(others));
	    },
	
	    /**
	     * An optional style to apply to the slider's container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the slider's container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the slider's thumb.
	     */
	    thumbStyle: _react.PropTypes.object,
	
	    /**
	     * An optionl className to apply to the slider's thumb.
	     */
	    thumbClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the slider's track.
	     */
	    trackStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the slider's track.
	     */
	    trackClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the slider's track fill.
	     */
	    trackFillStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the slider's track fill.
	     */
	    trackFillClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to a discrete slider's value.
	     */
	    discreteValueStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to a discrete slider's value.
	     */
	    discreteValueClassName: _react.PropTypes.string,
	
	    /**
	     * The default value for the slider.
	     */
	    defaultValue: _react.PropTypes.number.isRequired,
	
	    /**
	     * The min value for the slider. The min and max values must be on the same
	     * side of 0. It is currently invalid to have a range from negative to positive.
	     */
	    min: function min(props, propName, component) {
	      for (var _len2 = arguments.length, others = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	        others[_key2 - 3] = arguments[_key2];
	      }
	
	      var _PropTypes$number;
	
	      var err = (_PropTypes$number = _react.PropTypes.number).isRequired.apply(_PropTypes$number, [props, propName, component].concat(others));
	      if (!err) {
	        var min = props[propName];
	        var name = void 0;
	        if (min > props.value) {
	          name = 'value';
	        } else if (min > props.defaultValue) {
	          name = 'defaultValue';
	        }
	
	        if (name) {
	          err = new Error('The \'' + propName + '\' prop must be less than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'min: ' + min + '\' and \'' + name + ': ' + props[name] + '\''));
	        } else if (min < 0 && props.max > 0) {
	          err = new Error('The \'' + component + '\' is unable to have a range spanning from negative to positive. The range ' + 'must either be all negative or all postive.');
	        }
	      }
	
	      return err;
	    },
	
	    /**
	     * The max value for the slider. The max value must be greater than the min value
	     * and the min and max values must be on the same side of 0. It is currently
	     * invalid to have a range from negative to positive.
	     */
	    max: function max(props, propName, component) {
	      for (var _len3 = arguments.length, others = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	        others[_key3 - 3] = arguments[_key3];
	      }
	
	      var _PropTypes$number2;
	
	      var err = (_PropTypes$number2 = _react.PropTypes.number).isRequired.apply(_PropTypes$number2, [props, propName, component].concat(others));
	      if (!err) {
	        var max = props[propName];
	        var name = void 0;
	        if (max < props.value) {
	          name = 'value';
	        } else if (max < props.defaultValue) {
	          name = 'defaultValue';
	        }
	
	        if (name) {
	          err = new Error('The \'' + propName + '\' prop must be greater than or equal to the \'' + name + '\' prop for the \'' + component + '\' but ' + ('received: \'' + propName + ': ' + max + '\' and \'' + name + ': ' + props[name] + '\''));
	        }
	      }
	
	      return err;
	    },
	
	    /**
	     * Boolean if the slider is disabled.
	     */
	    disabled: _react.PropTypes.bool,
	
	    /**
	     * An optional value for the slider. This will make the component controlled
	     * and require the `onChange` function.
	     */
	    value: (0, _controlled2.default)(_react.PropTypes.number, 'onChange'),
	
	    /**
	     * This is called when the slider's value gets updated. The value can be updated
	     * by one of the following:
	     *
	     * - Clicking a section of the slider
	     * - Dragging the slider with the mouse
	     * - Touching a section of the slider.
	     * - Dragging the slider with touch
	     * - Using the text field to update the value either by typing or incrementing
	     * - Using the left or right arrow keys to increment/decrement the value.
	     *
	     * The callback for this function is as follows:
	     *
	     * ```js
	     * onChange(value, event);
	     * ```
	     *
	     * where the event can either be:
	     * - a touch start event
	     * - a touch move event
	     * - a touch end event
	     * - a mouse down event
	     * - a mouse move event
	     * - a mouse up event
	     * - a key up event
	     * - a key down event
	     */
	    onChange: _react.PropTypes.func,
	
	    /**
	     * This is only called when the user is dragging the slider with either
	     * the mouse or touch. Probably not really usefull. It just includes the
	     * new drag percentage while the `onChange` does not.
	     *
	     * The callback for this function is defined as:
	     *
	     * ```js
	     * onDragChange(dragPercentage, value, (touchMove || mouseMove) event);
	     * ```
	     */
	    onDragChange: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the slider's container has
	     * the mousedown event.
	     */
	    onMouseDown: _react.PropTypes.func,
	
	    /**
	     * An optional function to call when the slider's container has
	     * the touchstart event.
	     */
	    onTouchStart: _react.PropTypes.func,
	
	    /**
	     * An optional icon or letter to place to the left of the slider.
	     * if you want to use a non-font icon or a letter, use the `md-slider-ind`
	     * className on your element.
	     */
	    leftIcon: _react.PropTypes.element,
	
	    /**
	     * An optional icon or letter to place to the right of the slider.
	     * if you want to use a non-font icon or a letter, use the `md-slider-ind`
	     * className on your element.
	     *
	     * > NOTE: This can not be used if the `editable` prop is true.
	     */
	    rightIcon: _react.PropTypes.element,
	
	    /**
	     * An optional label to display above the slider. If this prop
	     * is set, then an `id` must also be given.
	     */
	    label: _react.PropTypes.node,
	
	    /**
	     * The incremental amount when the user hits left or right with the
	     * keyboard arrows, or the user hits the up or down buttons in the
	     * editable number text field. This number must be a number between
	     * 0 and 1 or a whole number above 1.
	     */
	    step: function step(props, propName, component) {
	      for (var _len4 = arguments.length, others = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
	        others[_key4 - 3] = arguments[_key4];
	      }
	
	      var _PropTypes$number3;
	
	      var err = (_PropTypes$number3 = _react.PropTypes.number).isRequired.apply(_PropTypes$number3, [props, propName, component].concat(others));
	      if (!err) {
	        var step = props[propName];
	        if (step <= 0) {
	          err = new Error('The \'' + propName + '\' for the \'' + component + '\' must be a number greater than 0. The ' + ('current value is \'' + step + '\'.'));
	        } else {
	          var valueDefined = typeof props.value !== 'undefined';
	          var name = void 0;
	          if (!(0, _isWithinStep2.default)(valueDefined ? props.value : props.defaultValue, step)) {
	            name = valueDefined ? 'value' : 'defaultValue';
	          }
	
	          if (name) {
	            err = new Error('The \'' + name + '\' prop on \'' + component + '\' should be a number divisible by the ' + ('\'' + propName + '\' prop. The current value is \'' + props[name] + '\' and the \'' + propName + '\' ') + ('is \'' + step + '\'.'));
	          }
	        }
	      }
	
	      return err;
	    },
	
	    /**
	     * Boolean if the Slider should be editable. This will place a number text field
	     * to the right of the slider. If this prop is set to `true`, the `rightIcon`
	     * prop can not be set.
	     */
	    editable: function editable(props, propName, component) {
	      for (var _len5 = arguments.length, others = Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
	        others[_key5 - 3] = arguments[_key5];
	      }
	
	      var _PropTypes$bool;
	
	      if (typeof props[propName] === 'undefined') {
	        return null;
	      }
	
	      var err = (_PropTypes$bool = _react.PropTypes.bool).isRequired.apply(_PropTypes$bool, [props, propName, component].concat(others));
	      if (!err && typeof props.rightIcon !== 'undefined') {
	        err = new Error('The \'' + component + '\' is unable to be \'editable\' and include a \'rightIcon\'.');
	      }
	
	      return err;
	    },
	
	    /**
	     * The width for the number text field when the Slider is editable.
	     */
	    inputWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
	
	    /**
	     * Boolean if the slider should be discrete. This will update the slider to include a
	     * _balloon_ with the current value inside. It will also not allow the `Slider` to be
	     * editable.
	     */
	    discrete: function discrete(props, propName, component) {
	      for (var _len6 = arguments.length, others = Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
	        others[_key6 - 3] = arguments[_key6];
	      }
	
	      if (typeof props[propName] === 'undefined') {
	        return null;
	      }
	
	      var err = _react.PropTypes.bool.apply(_react.PropTypes, [props, propName, component].concat(others));
	      if (!err && typeof props.editable !== 'undefined') {
	        err = new Error('The \'' + component + '\' cannot be \'discrete\' and \'editable\'. Please choose one.');
	      }
	
	      return err;
	    },
	
	    /**
	     * The width of each tick for a discrete slider with ticks. This can either be a number
	     * which gets converted to `px`, or a valid css unit.
	     */
	    tickWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
	
	    /**
	     * This is number divisible by the total number of values included in the Slider. Every
	     * value that is divisible by this number will include a tick mark. It is common recommended
	     * to have this equal to the `step` prop.
	     *
	     * This prop is completely optional.
	     */
	    discreteTicks: function discreteTicks(props, propName, component) {
	      for (var _len7 = arguments.length, others = Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
	        others[_key7 - 3] = arguments[_key7];
	      }
	
	      if (typeof props[propName] === 'undefined') {
	        return null;
	      }
	
	      var err = _react.PropTypes.number.apply(_react.PropTypes, [props, propName, component].concat(others));
	      if (!err) {
	        var min = props.min,
	            max = props.max,
	            step = props.step;
	
	        var range = Math.abs(max - min);
	
	        if (range / props[propName] % 1 !== 0) {
	          err = new Error('The \'' + propName + '\' must be a number divisible by the range set by the \'min\' and ' + ('\'max\' props. The current range is \'' + range + '\' by including the min: \'' + min + '\' and ') + ('max: \'' + max + '\' values. The current value of \'' + propName + '\' is \'' + props[propName] + '\'.'));
	        } else if (props[propName] % step !== 0) {
	          err = new Error('The \'step\' prop must be a number divisible by the \'' + propName + '\'. It is common to have ' + ('them as the same value. The current \'step\' is \'' + step + '\' and the \'' + propName + '\' is \'' + props[propName] + '\'.'));
	        }
	      }
	
	      return err;
	    },
	
	    /**
	     * The transition time for a discrete Slider's keyboard focus ink. This should match the
	     * `md-slider-discrete-ink-transition-time` value in your SCSS. This is used because
	     * the ink is only visible temporarily for a discrete slider when keyboard focusing.
	     */
	    discreteInkTransitionTime: _react.PropTypes.number.isRequired,
	
	    /**
	     * The precision that the value should be rounded to when the Slider is updated. This
	     * needs to be a whole number greater than or equal to 0.
	     */
	    valuePrecision: function valuePrecision(props, propName, component) {
	      for (var _len8 = arguments.length, others = Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
	        others[_key8 - 3] = arguments[_key8];
	      }
	
	      var _PropTypes$number4;
	
	      var err = (_PropTypes$number4 = _react.PropTypes.number).isRequired.apply(_PropTypes$number4, [props, propName, component].concat(others));
	      if (!err) {
	        var precision = props[propName];
	
	        if (precision % 1 !== 0 || precision < 0) {
	          err = new Error('The \'' + propName + '\' must be a positive whole number or 0 on the \'' + component + '\'. ' + ('The current \'' + propName + '\' is \'' + precision + '\''));
	        }
	      }
	
	      return err;
	    },
	
	    stepPrecision: (0, _deprecated2.default)(_react.PropTypes.number, 'Use `step` and `valuePreceision` instead')
	  };
	  Slider.defaultProps = {
	    defaultValue: 0,
	    min: 0,
	    max: 100,
	    step: 1,
	    inputWidth: 40,
	    tickWidth: 6,
	    discreteInkTransitionTime: 300,
	    valuePrecision: 0
	  };
	  exports.default = Slider;
	});

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.SliderLabel = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var SliderLabel = function (_PureComponent) {
	    _inherits(SliderLabel, _PureComponent);
	
	    function SliderLabel() {
	      _classCallCheck(this, SliderLabel);
	
	      return _possibleConstructorReturn(this, (SliderLabel.__proto__ || Object.getPrototypeOf(SliderLabel)).apply(this, arguments));
	    }
	
	    _createClass(SliderLabel, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            children = _props.children,
	            className = _props.className,
	            htmlFor = _props.htmlFor,
	            props = _objectWithoutProperties(_props, ['children', 'className', 'htmlFor']);
	
	        if (!children) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'label',
	          _extends({}, props, {
	            htmlFor: htmlFor,
	            className: (0, _classnames2.default)('md-slider-label md-text', className)
	          }),
	          children
	        );
	      }
	    }]);
	
	    return SliderLabel;
	  }(_react.PureComponent);
	
	  SliderLabel.propTypes = {
	    className: _react.PropTypes.string,
	    children: _react.PropTypes.node,
	    htmlFor: function htmlFor(props, propName, component) {
	      for (var _len = arguments.length, others = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	        others[_key - 3] = arguments[_key];
	      }
	
	      var _PropTypes$string;
	
	      if (typeof props.children === 'undefined') {
	        return null;
	      }
	
	      return (_PropTypes$string = _react.PropTypes.string).isRequired.apply(_PropTypes$string, [props, propName, component].concat(others));
	    }
	  };
	  exports.default = SliderLabel;
	});

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(82)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Helpers/AccessibleFakeButton'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.AccessibleFakeButton);
	    global.Thumb = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _AccessibleFakeButton) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _AccessibleFakeButton2 = _interopRequireDefault(_AccessibleFakeButton);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Thumb = function (_PureComponent) {
	    _inherits(Thumb, _PureComponent);
	
	    function Thumb() {
	      _classCallCheck(this, Thumb);
	
	      return _possibleConstructorReturn(this, (Thumb.__proto__ || Object.getPrototypeOf(Thumb)).apply(this, arguments));
	    }
	
	    _createClass(Thumb, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            on = _props.on,
	            off = _props.off,
	            active = _props.active,
	            disabled = _props.disabled,
	            dragging = _props.dragging,
	            thumbLeft = _props.thumbLeft,
	            discrete = _props.discrete,
	            props = _objectWithoutProperties(_props, ['style', 'className', 'on', 'off', 'active', 'disabled', 'dragging', 'thumbLeft', 'discrete']);
	
	        return _react2.default.createElement(_AccessibleFakeButton2.default, _extends({
	          disabled: disabled
	        }, props, {
	          style: Object.assign({}, style, { left: thumbLeft }),
	          className: (0, _classnames2.default)('md-slider-thumb', className, {
	            'md-slider-thumb--active': active,
	            'md-slider-thumb--dragging': dragging,
	            'md-slider-thumb--disabled': disabled,
	            'md-slider-thumb--on': on,
	            'md-slider-thumb--continuous-off': !discrete && off,
	            'md-slider-thumb--discrete': discrete,
	            'md-slider-thumb--discrete-on': discrete && active && on,
	            'md-slider-thumb--discrete-off': discrete && !disabled && off,
	            'md-slider-thumb--discrete-active': discrete && active,
	            'md-slider-thumb--discrete-active-off': discrete && active && off
	          })
	        }));
	      }
	    }]);
	
	    return Thumb;
	  }(_react.PureComponent);
	
	  Thumb.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    thumbLeft: _react.PropTypes.string.isRequired,
	    on: _react.PropTypes.bool,
	    off: _react.PropTypes.bool,
	    active: _react.PropTypes.bool,
	    disabled: _react.PropTypes.bool,
	    dragging: _react.PropTypes.bool,
	    discrete: _react.PropTypes.bool
	  };
	  exports.default = Thumb;
	});

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.ThumbMask = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var ThumbMask = function (_PureComponent) {
	    _inherits(ThumbMask, _PureComponent);
	
	    function ThumbMask() {
	      _classCallCheck(this, ThumbMask);
	
	      return _possibleConstructorReturn(this, (ThumbMask.__proto__ || Object.getPrototypeOf(ThumbMask)).apply(this, arguments));
	    }
	
	    _createClass(ThumbMask, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            thumbLeft = _props.thumbLeft,
	            disabled = _props.disabled,
	            dragging = _props.dragging,
	            maskInked = _props.maskInked,
	            discrete = _props.discrete,
	            leaving = _props.leaving,
	            props = _objectWithoutProperties(_props, ['style', 'className', 'thumbLeft', 'disabled', 'dragging', 'maskInked', 'discrete', 'leaving']);
	
	        return _react2.default.createElement('span', _extends({}, props, {
	          style: Object.assign({}, style, { left: thumbLeft }),
	          className: (0, _classnames2.default)('md-slider-thumb md-slider-thumb--mask', className, {
	            'md-slider-thumb--dragging': dragging,
	            'md-slider-thumb--mask-inked': maskInked,
	            'md-slider-thumb--mask-disabled': disabled,
	            'md-slider-thumb--discrete-mask-inked': maskInked && discrete,
	            'md-slider-thumb--discrete-mask-leaving': discrete && leaving
	          })
	        }));
	      }
	    }]);
	
	    return ThumbMask;
	  }(_react.PureComponent);
	
	  ThumbMask.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    disabled: _react.PropTypes.bool,
	    thumbLeft: _react.PropTypes.string.isRequired,
	    maskInked: _react.PropTypes.bool,
	    dragging: _react.PropTypes.bool,
	    discrete: _react.PropTypes.bool,
	    leaving: _react.PropTypes.bool
	  };
	  exports.default = ThumbMask;
	});

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(515), __webpack_require__(485), __webpack_require__(482), __webpack_require__(483), __webpack_require__(479)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../utils/NumberUtils/updateUnit'), require('./TrackFill'), require('./Thumb'), require('./ThumbMask'), require('./DiscreteValue'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.updateUnit, global.TrackFill, global.Thumb, global.ThumbMask, global.DiscreteValue);
	    global.Track = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _updateUnit, _TrackFill, _Thumb, _ThumbMask, _DiscreteValue) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _updateUnit2 = _interopRequireDefault(_updateUnit);
	
	  var _TrackFill2 = _interopRequireDefault(_TrackFill);
	
	  var _Thumb2 = _interopRequireDefault(_Thumb);
	
	  var _ThumbMask2 = _interopRequireDefault(_ThumbMask);
	
	  var _DiscreteValue2 = _interopRequireDefault(_DiscreteValue);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var half = function half(w) {
	    return w / 2;
	  };
	
	  /**
	   * The `Track` component is used for showing the current state of the slider.
	   * It will render the `TrackFill`, `Thumb`, and `ThumbMask` components.
	   */
	
	  var Track = function (_PureComponent) {
	    _inherits(Track, _PureComponent);
	
	    function Track() {
	      _classCallCheck(this, Track);
	
	      return _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).apply(this, arguments));
	    }
	
	    _createClass(Track, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            on = _props.on,
	            off = _props.off,
	            active = _props.active,
	            disabled = _props.disabled,
	            dragging = _props.dragging,
	            className = _props.className,
	            thumbLeft = _props.thumbLeft,
	            trackFillWidth = _props.trackFillWidth,
	            trackFillStyle = _props.trackFillStyle,
	            trackFillClassName = _props.trackFillClassName,
	            discreteValueStyle = _props.discreteValueStyle,
	            discreteValueClassName = _props.discreteValueClassName,
	            maskInked = _props.maskInked,
	            maskLeaving = _props.maskLeaving,
	            thumbStyle = _props.thumbStyle,
	            thumbClassName = _props.thumbClassName,
	            discrete = _props.discrete,
	            onThumbFocus = _props.onThumbFocus,
	            onThumbKeyUp = _props.onThumbKeyUp,
	            onThumbKeyDown = _props.onThumbKeyDown,
	            value = _props.value,
	            tickWidth = _props.tickWidth,
	            discreteTicks = _props.discreteTicks,
	            scale = _props.scale,
	            step = _props.step,
	            valuePrecision = _props.valuePrecision,
	            props = _objectWithoutProperties(_props, ['on', 'off', 'active', 'disabled', 'dragging', 'className', 'thumbLeft', 'trackFillWidth', 'trackFillStyle', 'trackFillClassName', 'discreteValueStyle', 'discreteValueClassName', 'maskInked', 'maskLeaving', 'thumbStyle', 'thumbClassName', 'discrete', 'onThumbFocus', 'onThumbKeyUp', 'onThumbKeyDown', 'value', 'tickWidth', 'discreteTicks', 'scale', 'step', 'valuePrecision']);
	
	        var ticks = [];
	        if (typeof discreteTicks !== 'undefined' && !disabled && discrete) {
	          var amt = scale / (discreteTicks / step);
	          var offset = (0, _updateUnit2.default)(tickWidth, half, 'px');
	          var inc = 100 / amt;
	
	          for (var i = 0; i <= amt; i++) {
	            var left = i * inc + '%';
	            var width = tickWidth;
	            if (i === 0 || i === amt) {
	              width = (0, _updateUnit2.default)(tickWidth, half);
	            } else {
	              left = 'calc(' + left + ' - ' + offset + ')';
	            }
	
	            ticks.push(_react2.default.createElement('span', {
	              key: 'tick-' + i,
	              className: 'md-slider-discrete-tick',
	              style: { left: left, width: width }
	            }));
	          }
	        }
	
	        return _react2.default.createElement(
	          'div',
	          _extends({}, props, { className: (0, _classnames2.default)('md-slider-track', className) }),
	          ticks,
	          _react2.default.createElement(_TrackFill2.default, {
	            style: trackFillStyle,
	            className: trackFillClassName,
	            disabled: disabled,
	            dragging: dragging,
	            trackFillWidth: trackFillWidth
	          }),
	          _react2.default.createElement(_Thumb2.default, {
	            style: thumbStyle,
	            className: thumbClassName,
	            on: on,
	            off: off,
	            disabled: disabled,
	            dragging: dragging,
	            active: active,
	            thumbLeft: thumbLeft,
	            onFocus: onThumbFocus,
	            onKeyUp: onThumbKeyUp,
	            onKeyDown: onThumbKeyDown,
	            discrete: discrete
	          }),
	          _react2.default.createElement(_DiscreteValue2.default, {
	            style: discreteValueStyle,
	            className: discreteValueClassName,
	            discrete: discrete,
	            dragging: dragging,
	            active: active,
	            value: value,
	            thumbLeft: thumbLeft,
	            valuePrecision: valuePrecision
	          }),
	          _react2.default.createElement(_ThumbMask2.default, {
	            dragging: dragging,
	            disabled: disabled,
	            thumbLeft: thumbLeft,
	            maskInked: maskInked,
	            discrete: discrete,
	            leaving: maskLeaving
	          })
	        );
	      }
	    }]);
	
	    return Track;
	  }(_react.PureComponent);
	
	  Track.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    thumbStyle: _react.PropTypes.object,
	    thumbClassName: _react.PropTypes.string,
	    trackFillStyle: _react.PropTypes.object,
	    trackFillClassName: _react.PropTypes.string,
	    discreteValueStyle: _react.PropTypes.object,
	    discreteValueClassName: _react.PropTypes.string,
	    on: _react.PropTypes.bool,
	    off: _react.PropTypes.bool,
	    active: _react.PropTypes.bool,
	    dragging: _react.PropTypes.bool,
	    disabled: _react.PropTypes.bool,
	    thumbLeft: _react.PropTypes.string.isRequired,
	    trackFillWidth: _react.PropTypes.string.isRequired,
	    value: _react.PropTypes.number.isRequired,
	    discrete: _react.PropTypes.bool,
	    maskInked: _react.PropTypes.bool,
	    maskLeaving: _react.PropTypes.bool,
	    onThumbKeyUp: _react.PropTypes.func.isRequired,
	    onThumbKeyDown: _react.PropTypes.func.isRequired,
	    onThumbFocus: _react.PropTypes.func.isRequired,
	    scale: _react.PropTypes.number,
	    step: _react.PropTypes.number,
	    discreteTicks: _react.PropTypes.number,
	    tickWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    valuePrecision: _react.PropTypes.number.isRequired
	  };
	  exports.default = Track;
	});

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.TrackFill = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TrackFill = function (_PureComponent) {
	    _inherits(TrackFill, _PureComponent);
	
	    function TrackFill() {
	      _classCallCheck(this, TrackFill);
	
	      return _possibleConstructorReturn(this, (TrackFill.__proto__ || Object.getPrototypeOf(TrackFill)).apply(this, arguments));
	    }
	
	    _createClass(TrackFill, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            trackFillWidth = _props.trackFillWidth,
	            dragging = _props.dragging,
	            disabled = _props.disabled,
	            props = _objectWithoutProperties(_props, ['style', 'className', 'trackFillWidth', 'dragging', 'disabled']);
	
	        if (disabled) {
	          return null;
	        }
	
	        return _react2.default.createElement('hr', _extends({}, props, {
	          style: Object.assign({}, style, { width: trackFillWidth }),
	          className: (0, _classnames2.default)('md-slider-track-fill', className, {
	            'md-slider-track-fill--dragging': dragging
	          })
	        }));
	      }
	    }]);
	
	    return TrackFill;
	  }(_react.PureComponent);
	
	  TrackFill.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    dragging: _react.PropTypes.bool,
	    disabled: _react.PropTypes.bool,
	    trackFillWidth: _react.PropTypes.string.isRequired
	  };
	  exports.default = TrackFill;
	});

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(480)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Slider'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Slider);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Slider) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Slider2 = _interopRequireDefault(_Slider);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Slider2.default;
	});

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(16), __webpack_require__(209)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Buttons/Button'), require('./isInvalidAnimate'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.Button, global.isInvalidAnimate);
	    global.Snackbar = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _Button, _isInvalidAnimate) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Snackbar = function (_PureComponent) {
	    _inherits(Snackbar, _PureComponent);
	
	    function Snackbar(props) {
	      _classCallCheck(this, Snackbar);
	
	      var _this = _possibleConstructorReturn(this, (Snackbar.__proto__ || Object.getPrototypeOf(Snackbar)).call(this, props));
	
	      _this._clearTimeout = _this._clearTimeout.bind(_this);
	      _this._handleClick = _this._handleClick.bind(_this);
	      _this._handleAutohide = _this._handleAutohide.bind(_this);
	      _this._handleWindowBlur = _this._handleWindowBlur.bind(_this);
	      _this._handleWindowFocus = _this._handleWindowFocus.bind(_this);
	      return _this;
	    }
	
	    _createClass(Snackbar, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _props = this.props,
	            fab = _props.fab,
	            multiline = _props.multiline,
	            onAppear = _props.toast.onAppear;
	
	        if (onAppear) {
	          onAppear();
	        }
	
	        if (!fab || (0, _isInvalidAnimate2.default)(fab)) {
	          return;
	        }
	
	        this._fab = fab.getComposedComponent().getComposedComponent();
	        this._fab._animateForSnackbar(multiline);
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._handleAutohide();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._clearTimeout();
	
	        if (this._eventType === 'focus') {
	          window.removeEventListener('focus', this._handleWindowFocus);
	        } else if (this._eventType === 'blur') {
	          window.removeEventListener('blur', this._handleWindowBlur);
	        }
	      }
	    }, {
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        var _props2 = this.props,
	            onDismiss = _props2.onDismiss,
	            action = _props2.toast.action,
	            leaveTimeout = _props2.leaveTimeout,
	            multiline = _props2.multiline;
	
	        if (typeof action.onClick === 'function') {
	          action.onClick(e);
	        }
	
	        if (this._fab) {
	          this._fab._animateForSnackbar(multiline, leaveTimeout);
	        }
	
	        onDismiss();
	      }
	    }, {
	      key: '_clearTimeout',
	      value: function _clearTimeout() {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	          this._timeout = null;
	        }
	      }
	    }, {
	      key: '_handleAutohide',
	      value: function _handleAutohide() {
	        var _this2 = this;
	
	        var _props3 = this.props,
	            autohide = _props3.autohide,
	            autohideTimeout = _props3.autohideTimeout,
	            onDismiss = _props3.onDismiss,
	            multiline = _props3.multiline,
	            leaveTimeout = _props3.leaveTimeout;
	
	        if (!autohide) {
	          return;
	        }
	
	        window.addEventListener('blur', this._handleWindowBlur);
	        this._eventType = 'blur';
	        this._timeout = setTimeout(function () {
	          _this2._timeout = null;
	          _this2._eventType = null;
	
	          window.removeEventListener('blur', _this2._handleWindowBlur);
	
	          if (_this2._fab) {
	            _this2._fab._animateForSnackbar(multiline, leaveTimeout);
	          }
	
	          onDismiss();
	        }, autohideTimeout || this.state.toast);
	      }
	    }, {
	      key: '_handleWindowBlur',
	      value: function _handleWindowBlur() {
	        this._clearTimeout();
	        window.removeEventListener('blur', this._handleWindowBlur);
	        window.addEventListener('focus', this._handleWindowFocus);
	        this._eventType = 'focus';
	      }
	    }, {
	      key: '_handleWindowFocus',
	      value: function _handleWindowFocus() {
	        window.removeEventListener('focus', this._handleWindowFocus);
	        this._eventType = null;
	        this._handleAutohide();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props4 = this.props,
	            className = _props4.className,
	            toast = _props4.toast,
	            multiline = _props4.multiline,
	            props = _objectWithoutProperties(_props4, ['className', 'toast', 'multiline']);
	
	        delete props.id;
	        delete props.fab;
	        delete props.onDismiss;
	        delete props.autohide;
	        delete props.autohideTimeout;
	        delete props.leaveTimeout;
	        var text = toast.text,
	            action = toast.action;
	        var id = this.props.id;
	
	
	        var Component = 'p';
	        if (action) {
	          Component = 'section';
	          text = _react2.default.createElement(
	            'p',
	            { className: 'md-snackbar--toast md-snackbar--action' },
	            text
	          );
	
	          var btnProps = {
	            flat: true,
	            waitForInkTransition: true,
	            onClick: this._handleClick,
	            label: action,
	            secondary: true,
	            className: 'md-btn--snackbar'
	          };
	
	          if (typeof action !== 'string') {
	            btnProps = Object.assign(btnProps, action, {
	              className: (0, _classnames2.default)(btnProps.className, action.className)
	            });
	          }
	
	          action = _react2.default.createElement(_Button2.default, btnProps);
	        }
	
	        if (!id) {
	          id = 'snackbarAlert' + (action ? 'Dialog' : '');
	        }
	
	        var role = 'alert' + (action ? 'dialog' : '');
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            id: id,
	            role: role,
	            className: (0, _classnames2.default)('md-snackbar', {
	              'md-snackbar--multiline': multiline,
	              'md-snackbar--toast': !action
	            }, className)
	          }),
	          text,
	          action
	        );
	      }
	    }]);
	
	    return Snackbar;
	  }(_react.PureComponent);
	
	  Snackbar.propTypes = {
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    children: _react.PropTypes.node,
	    onDismiss: _react.PropTypes.func.isRequired,
	    toast: _react.PropTypes.shape({
	      text: _react.PropTypes.string.isRequired,
	      action: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.shape({
	        label: _react.PropTypes.string.isRequired,
	        onClick: _react.PropTypes.func
	      })]),
	      onAppear: _react.PropTypes.func
	    }).isRequired,
	    multiline: _react.PropTypes.bool,
	    autohide: _react.PropTypes.bool,
	    autohideTimeout: _react.PropTypes.number,
	    fab: _react.PropTypes.object,
	    leaveTimeout: _react.PropTypes.number.isRequired
	  };
	  exports.default = Snackbar;
	});

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(36), __webpack_require__(8), __webpack_require__(12), __webpack_require__(30), __webpack_require__(209), __webpack_require__(64), __webpack_require__(487)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('react-addons-css-transition-group'), require('react-prop-types/lib/deprecated'), require('../utils/getField'), require('../constants/CSSTransitionGroupTick'), require('./isInvalidAnimate'), require('../Helpers/Portal'), require('./Snackbar'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.reactAddonsCssTransitionGroup, global.deprecated, global.getField, global.CSSTransitionGroupTick, global.isInvalidAnimate, global.Portal, global.Snackbar);
	    global.SnackbarContainer = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _reactAddonsCssTransitionGroup, _deprecated, _getField, _CSSTransitionGroupTick, _isInvalidAnimate, _Portal, _Snackbar) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	  var _deprecated2 = _interopRequireDefault(_deprecated);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	  var _isInvalidAnimate2 = _interopRequireDefault(_isInvalidAnimate);
	
	  var _Portal2 = _interopRequireDefault(_Portal);
	
	  var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  };
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  var _slicedToArray = function () {
	    function sliceIterator(arr, i) {
	      var _arr = [];
	      var _n = true;
	      var _d = false;
	      var _e = undefined;
	
	      try {
	        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	          _arr.push(_s.value);
	
	          if (i && _arr.length === i) break;
	        }
	      } catch (err) {
	        _d = true;
	        _e = err;
	      } finally {
	        try {
	          if (!_n && _i["return"]) _i["return"]();
	        } finally {
	          if (_d) throw _e;
	        }
	      }
	
	      return _arr;
	    }
	
	    return function (arr, i) {
	      if (Array.isArray(arr)) {
	        return arr;
	      } else if (Symbol.iterator in Object(arr)) {
	        return sliceIterator(arr, i);
	      } else {
	        throw new TypeError("Invalid attempt to destructure non-iterable instance");
	      }
	    };
	  }();
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var CHAINED_TOAST_DELAY = 50;
	
	  /**
	   * The `Snackbar` component is used for displaying a concise and small message to the user about
	   * an operation performed.
	   *
	   * > The main component for the `Snackbar` is actually named the `SnackbarContainer`, so you need
	   * to make sure the import is `react-md/lib/Snackbars` or `react-md/lib/Snackbars/SnackbarContainer`.
	   * The first import is preferable.
	   */
	
	  var SnackbarContainer = function (_PureComponent) {
	    _inherits(SnackbarContainer, _PureComponent);
	
	    function SnackbarContainer(props) {
	      _classCallCheck(this, SnackbarContainer);
	
	      var _this = _possibleConstructorReturn(this, (SnackbarContainer.__proto__ || Object.getPrototypeOf(SnackbarContainer)).call(this, props));
	
	      var visible = !!props.toasts.length;
	      _this.state = {
	        visible: visible,
	        toast: null
	      };
	
	      _this._isMultiline = _this._isMultiline.bind(_this);
	      _this._initAndToast = _this._initAndToast.bind(_this);
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._createSwapTimer = _this._createSwapTimer.bind(_this);
	      _this._createLeaveTimer = _this._createLeaveTimer.bind(_this);
	      return _this;
	    }
	
	    _createClass(SnackbarContainer, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var toasts = this.props.toasts;
	
	        if (toasts.length) {
	          this._initAndToast(toasts[0]);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _nextProps$toasts = _slicedToArray(nextProps.toasts, 1),
	            toast = _nextProps$toasts[0];
	
	        var _props$toasts = _slicedToArray(this.props.toasts, 1),
	            prevToast = _props$toasts[0];
	
	        if (toast === prevToast || toast === this.state.toast) {
	          return;
	        }
	
	        if (!toast) {
	          this._createLeaveTimer();
	        } else if (!this.state.visible) {
	          this._initAndToast(toast);
	        } else {
	          this._createSwapTimer(toast);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._initTimeout) {
	          clearTimeout(this._initTimeout);
	        }
	
	        if (this._leaveTimeout) {
	          clearTimeout(this._leaveTimeout);
	        }
	
	        if (this._swapTimeout) {
	          clearTimeout(this._swapTimeout);
	        }
	
	        if (this._dismissTimeout) {
	          clearTimeout(this._dismissTimeout);
	        }
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        this._container = (0, _reactDom.findDOMNode)(container);
	      }
	    }, {
	      key: '_isMultiline',
	      value: function _isMultiline(toast) {
	        var container = this._container;
	        if (container === null) {
	          return false;
	        }
	
	        var message = document.createElement('p');
	        message.classList.add('md-snackbar--toast');
	        message.innerHTML = toast.text;
	
	        var snackbar = void 0;
	        if (toast.action) {
	          message.classList.add('md-snackbar--action');
	
	          snackbar = document.createElement('section');
	          snackbar.className = 'md-snackbar';
	          snackbar.appendChild(message);
	
	          var action = document.createElement('button');
	          action.innerHTML = typeof toast.action === 'string' ? toast.action : toast.action.label;
	          action.className = 'md-btn md-btn--flat md-btn--text md-btn--snackbar';
	          snackbar.appendChild(action);
	        } else {
	          snackbar = message;
	        }
	
	        // Only style we really want from the .md-snackbar
	        snackbar.style.maxWidth = '568px';
	
	        container.appendChild(snackbar);
	        var multiline = message.offsetHeight > 20;
	        container.removeChild(snackbar);
	
	        return multiline;
	      }
	    }, {
	      key: '_initAndToast',
	      value: function _initAndToast(toast) {
	        var _this2 = this;
	
	        this._initTimeout = setTimeout(function () {
	          _this2._initTimeout = null;
	
	          _this2.setState({ toast: toast, multiline: _this2._isMultiline(toast) });
	        }, _CSSTransitionGroupTick2.default);
	
	        this.setState({ visible: true });
	      }
	    }, {
	      key: '_createLeaveTimer',
	      value: function _createLeaveTimer() {
	        var _this3 = this;
	
	        var time = this.props.transitionLeaveTimeout;
	
	        this._leaveTimeout = setTimeout(function () {
	          _this3._leaveTimeout = null;
	
	          _this3.setState({ visible: false });
	        }, time + _CSSTransitionGroupTick2.default);
	
	        this.setState({ toast: null });
	      }
	    }, {
	      key: '_createSwapTimer',
	      value: function _createSwapTimer(toast) {
	        var _this4 = this;
	
	        this._swapTimeout = setTimeout(function () {
	          _this4._swapTimeout = null;
	
	          _this4.setState({ toast: toast, multiline: _this4._isMultiline(toast) });
	        }, this.props.transitionLeaveTimeout + CHAINED_TOAST_DELAY);
	
	        this.setState({ toast: null });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            visible = _state.visible,
	            toast = _state.toast,
	            multiline = _state.multiline;
	
	        var _props = this.props,
	            transitionName = _props.transitionName,
	            transitionEnterTimeout = _props.transitionEnterTimeout,
	            transitionLeaveTimeout = _props.transitionLeaveTimeout,
	            dismiss = _props.dismiss,
	            onDismiss = _props.onDismiss,
	            lastChild = _props.lastChild,
	            props = _objectWithoutProperties(_props, ['transitionName', 'transitionEnterTimeout', 'transitionLeaveTimeout', 'dismiss', 'onDismiss', 'lastChild']);
	
	        delete props.toasts;
	        delete props.renderNode;
	        var renderNode = (0, _getField2.default)(this.props, this.context, 'renderNode');
	
	        var snackbar = void 0;
	        if (toast) {
	          snackbar = _react2.default.createElement(_Snackbar2.default, _extends({}, props, {
	            key: 'snackbar',
	            leaveTimeout: transitionLeaveTimeout,
	            toast: toast,
	            multiline: multiline,
	            onDismiss: onDismiss || dismiss
	          }));
	        }
	
	        return _react2.default.createElement(
	          _Portal2.default,
	          { visible: visible, renderNode: renderNode, lastChild: lastChild },
	          _react2.default.createElement(
	            _reactAddonsCssTransitionGroup2.default,
	            {
	              ref: this._setContainer,
	              key: 'container',
	              className: 'md-snackbar-container',
	              transitionName: transitionName,
	              transitionEnterTimeout: transitionEnterTimeout,
	              transitionLeaveTimeout: transitionLeaveTimeout
	            },
	            snackbar
	          )
	        );
	      }
	    }]);
	
	    return SnackbarContainer;
	  }(_react.PureComponent);
	
	  SnackbarContainer.propTypes = {
	    /**
	     * An id for the Snackbar once a toast has been added and is visible. This is a recommended
	     * prop for accessibility concerns. If it is ommitted, the id will become `'snackbarAlert'`
	     * when there is no action on the toast, or `'snackbarAlertDialog'` when there is an action
	     * on the toast.
	     */
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional style to apply to the snackbar once it appears.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the snackbar once it appears.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An immutable controlled queue of toasts that should appear in the snackbar.
	     * The snackbar will always display the first toast in this list. When the user has
	     * either clicked the action of the toast, or the `autohideTimeout` has been reached,
	     * the `onDismiss` function will be called. The `onDismiss` function should remove the
	     * the first toast and return a new list of remaining toasts.
	     *
	     * ```js
	     * let toasts = [];
	     * const onDismiss = () => {
	     *   const [, ...remainingToasts] = toasts;
	     *   toasts = remainingToasts;
	     * };
	     * ```
	     */
	    toasts: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      /**
	       * The text to display in the toast.
	       */
	      text: _react.PropTypes.string.isRequired,
	
	      /**
	       * An optional action to take. If this value is a string, the `label` for the
	       * button will be this value, Otherwise, all the keys in the action object will
	       * be applied to the `Button`.
	       */
	      action: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.shape({
	        onClick: _react.PropTypes.func,
	        label: _react.PropTypes.string.isRequired
	      })])
	    })).isRequired,
	
	    /**
	     * A function to call that will dismiss a toast. This will automatically be bound to
	     * any toast that has an `action` and it will also be called when the `autohideTimeout`
	     * has been reached.
	     */
	    onDismiss: _react.PropTypes.func.isRequired,
	
	    /**
	     * Boolean if the snackbar's toasts should automatically be dismissed after the
	     * `autohideTimeout` has been reached.
	     */
	    autohide: _react.PropTypes.bool,
	
	    /**
	     * The amount of time before the snackbar should be dequeued and the next toast
	     * should be displayed.
	     */
	    autohideTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * The transition name to use for the snackbar appearing and disappearing.
	     */
	    transitionName: _react.PropTypes.string.isRequired,
	
	    /**
	     * The transition time for the snackbar to enter. This should match the `$md-snackbar-transition-time`
	     * sass variable.
	     */
	    transitionEnterTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * The transition time for the snackbar to leave. This should match the `$md-snackbar-transition-time`
	     * sass variable.
	     */
	    transitionLeaveTimeout: _react.PropTypes.number.isRequired,
	
	    /**
	     * When the app contains a floating action button that is fixed to the bottom of the screen,
	     * you should set this to be a ref of the floating action button. When a snackbar appears,
	     * the FAB will be moved to not overlay the snackbar.
	     */
	    fab: function fab(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	      if (!propValue) {
	        return null;
	      }
	
	      if (propType !== 'object' || typeof propValue.render !== 'function' || (0, _isInvalidAnimate2.default)(propValue)) {
	        var componentNameSafe = componentName || '<<anonymous>>';
	        var propFullNameSafe = propFullName || propName;
	        return new Error('Invalid ' + location + ' `' + propFullNameSafe + '` supplied to `' + componentNameSafe + '`, expected a ' + 'ref to a floating `Button` component. This should not be a DOMElement from `findDOMNode` but instead ' + 'the React ref object.');
	      }
	
	      return null;
	    },
	
	    /**
	     * An optional DOM node to render the Snackbar in. If this is omitted, it will render as the first
	     * child in the `body`.
	     */
	    renderNode: _react.PropTypes.object,
	
	    /**
	     * Boolean if the snackbar should render as the last child in the `renderNode` or `body` instead of
	     * as the first.
	     */
	    lastChild: _react.PropTypes.bool,
	    dismiss: (0, _deprecated2.default)(_react.PropTypes.func, 'Use `onDismiss` instead')
	  };
	  SnackbarContainer.defaultProps = {
	    autohide: true,
	    toasts: [],
	    autohideTimeout: 3000,
	    transitionName: 'md-snackbar',
	    transitionEnterTimeout: 300,
	    transitionLeaveTimeout: 300
	  };
	  SnackbarContainer.contextTypes = {
	    renderNode: _react.PropTypes.object
	  };
	  exports.default = SnackbarContainer;
	});

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(488)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./SnackbarContainer'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.SnackbarContainer);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _SnackbarContainer) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _SnackbarContainer2 = _interopRequireDefault(_SnackbarContainer);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _SnackbarContainer2.default;
	});

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(226), __webpack_require__(22)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../utils/PropTypes/oneRequired'), require('../Helpers/AccessibleFakeInkedButton'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.oneRequired, global.AccessibleFakeInkedButton);
	    global.Tab = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _oneRequired, _AccessibleFakeInkedButton) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _oneRequired2 = _interopRequireDefault(_oneRequired);
	
	  var _AccessibleFakeInkedButton2 = _interopRequireDefault(_AccessibleFakeInkedButton);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Tab = function (_PureComponent) {
	    _inherits(Tab, _PureComponent);
	
	    function Tab(props) {
	      _classCallCheck(this, Tab);
	
	      var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this, props));
	
	      _this._handleClick = _this._handleClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(Tab, [{
	      key: '_handleClick',
	      value: function _handleClick(e) {
	        if (this.props.onClick) {
	          this.props.onClick(this.props.index, this.props.id, this.props.controlsId, this.props.children, e);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            id = _props.id,
	            controlsId = _props.controlsId,
	            className = _props.className,
	            active = _props.active,
	            props = _objectWithoutProperties(_props, ['id', 'controlsId', 'className', 'active']);
	
	        delete props.index;
	        delete props.icon;
	        delete props.label;
	
	        var _props2 = this.props,
	            icon = _props2.icon,
	            label = _props2.label;
	
	        if (icon) {
	          var iconEl = _react.Children.only(icon);
	          icon = (0, _react.cloneElement)(icon, {
	            className: (0, _classnames2.default)('md-icon--tab', iconEl.props.className)
	          });
	        }
	
	        if ((0, _react.isValidElement)(label)) {
	          var labelEl = _react.Children.only(label);
	          label = (0, _react.cloneElement)(label, {
	            className: (0, _classnames2.default)('md-tab-label', labelEl.props.className)
	          });
	        } else {
	          label = _react2.default.createElement(
	            'div',
	            { className: 'md-tab-label' },
	            label
	          );
	        }
	        return _react2.default.createElement(
	          _AccessibleFakeInkedButton2.default,
	          _extends({}, props, {
	            id: id,
	            role: 'tab',
	            onClick: this._handleClick,
	            className: (0, _classnames2.default)('md-tab', {
	              'md-tab--active': active,
	              'md-tab--inactive': !active,
	              'md-tab--icon': label && icon
	            }, className),
	            'aria-controls': controlsId,
	            'aria-selected': active
	          }),
	          icon,
	          label
	        );
	      }
	    }]);
	
	    return Tab;
	  }(_react.PureComponent);
	
	  Tab.propTypes = {
	    /**
	     * An id for the tab. This is required for a11y. If you use the `Tabs` component, this
	     * will automatically be generated for you and injected into this component.
	     */
	    id: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An id for a `TabPanel` that holds the children from this tab. This is required for a11y.
	     * If you use the `Tabs` component, this will automatically be generated for you and injected
	     * into this component.
	     */
	    controlsId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The component to render as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * Any children to display once the tab has been selected.
	     */
	    children: _react.PropTypes.node,
	
	    /**
	     * An optional icon to display in the tab. This can either be used alone, or it
	     * will be placed above the `label` if both are given.
	     */
	    icon: _react.PropTypes.element,
	
	    /**
	     * An optional label to display in the tab. This can either be used alone, or it
	     * will be placed below the `icon` if both are given.
	     */
	    label: (0, _oneRequired2.default)(_react.PropTypes.node, 'icon'),
	
	    /**
	     * An optional function to call when the tab is clicked. The callback includes this tab's index,
	     * id, controlsId, children, and finally click event. All the additional parameters are included
	     * if you are not using the `TabsContainer` component. The `id` and `controlsId` are mainly passed
	     * for accessibility.
	     *
	     * ```js
	     * onClick(index, id, controlsId, children, event);
	     * ```
	     */
	    onClick: _react.PropTypes.func,
	
	    /**
	     * Boolean if the tab is currently active. If you use the `Tabs` component, this is automatically
	     * injected.
	     */
	    active: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the tab is currently active. If you use the `Tabs` component, this is automatically
	     * injected.
	     */
	    index: _react.PropTypes.number
	  };
	  Tab.defaultProps = {
	    component: 'li'
	  };
	  exports.default = Tab;
	});

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(135)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-motion'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactMotion);
	    global.TabIndicator = mod.exports;
	  }
	})(this, function (exports, _react, _reactMotion) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TabIndicator = function (_PureComponent) {
	    _inherits(TabIndicator, _PureComponent);
	
	    function TabIndicator() {
	      _classCallCheck(this, TabIndicator);
	
	      return _possibleConstructorReturn(this, (TabIndicator.__proto__ || Object.getPrototypeOf(TabIndicator)).apply(this, arguments));
	    }
	
	    _createClass(TabIndicator, [{
	      key: 'render',
	      value: function render() {
	        var visible = this.props.visible;
	
	        return _react2.default.createElement(
	          _reactMotion.Motion,
	          {
	            style: {
	              x: (0, _reactMotion.spring)(this.props.offset),
	              width: (0, _reactMotion.spring)(this.props.width),
	              height: (0, _reactMotion.spring)(visible ? 2 : 0)
	            }
	          },
	          function (_ref) {
	            var x = _ref.x,
	                height = _ref.height,
	                width = _ref.width;
	
	            var transform = 'translate3d(' + x + 'px, 0, 0)';
	            return _react2.default.createElement('span', {
	              style: {
	                height: height,
	                width: width,
	                WebkitTransform: transform,
	                MozTransform: transform,
	                msTransform: transform,
	                transform: transform
	              },
	              className: 'md-tab-indicator'
	            });
	          }
	        );
	      }
	    }]);
	
	    return TabIndicator;
	  }(_react.PureComponent);
	
	  TabIndicator.propTypes = {
	    offset: _react.PropTypes.number.isRequired,
	    width: _react.PropTypes.number.isRequired,
	    visible: _react.PropTypes.bool
	  };
	  exports.default = TabIndicator;
	});

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../Buttons/Button'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.Button);
	    global.TabOverflowButton = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _Button) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _Button2 = _interopRequireDefault(_Button);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TabOverflowButton = function (_PureComponent) {
	    _inherits(TabOverflowButton, _PureComponent);
	
	    function TabOverflowButton() {
	      _classCallCheck(this, TabOverflowButton);
	
	      return _possibleConstructorReturn(this, (TabOverflowButton.__proto__ || Object.getPrototypeOf(TabOverflowButton)).apply(this, arguments));
	    }
	
	    _createClass(TabOverflowButton, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            left = _props.left,
	            icon = _props.icon,
	            props = _objectWithoutProperties(_props, ['left', 'icon']);
	
	        return _react2.default.createElement(_Button2.default, _extends({}, props, {
	          icon: true,
	          className: (0, _classnames2.default)('md-icon--inherit md-btn--tab-overflow', {
	            'md-btn--tab-overflow-left': left,
	            'md-btn--tab-overflow-right': !left,
	            'md-btn--tab-overflow-icon': icon
	          })
	        }));
	      }
	    }]);
	
	    return TabOverflowButton;
	  }(_react.PureComponent);
	
	  TabOverflowButton.propTypes = {
	    left: _react.PropTypes.bool,
	    icon: _react.PropTypes.bool
	  };
	  exports.default = TabOverflowButton;
	});

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(13), __webpack_require__(218), __webpack_require__(12), __webpack_require__(14), __webpack_require__(491), __webpack_require__(49), __webpack_require__(18), __webpack_require__(212), __webpack_require__(492)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('react-prop-types/lib/isRequiredForA11y'), require('../constants/media'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('./TabIndicator'), require('../Helpers/IconSeparator'), require('../FontIcons/FontIcon'), require('./MenuTab'), require('./TabOverflowButton'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.isRequiredForA11y, global.media, global.getField, global.controlled, global.TabIndicator, global.IconSeparator, global.FontIcon, global.MenuTab, global.TabOverflowButton);
	    global.Tabs = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _isRequiredForA11y, _media, _getField, _controlled, _TabIndicator, _IconSeparator, _FontIcon, _MenuTab, _TabOverflowButton) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _TabIndicator2 = _interopRequireDefault(_TabIndicator);
	
	  var _IconSeparator2 = _interopRequireDefault(_IconSeparator);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  var _MenuTab2 = _interopRequireDefault(_MenuTab);
	
	  var _TabOverflowButton2 = _interopRequireDefault(_TabOverflowButton);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var MOBILE_PADDING = 72;
	  var DESKTOP_PADDING = 80;
	  var MOBILE_TAB_MIN_WIDTH = 72;
	  var DESKTOP_TAB_MIN_WIDTH = 160;
	
	  /**
	   * The `Tabs` component is used to manage the state of which tab is currently active.
	   */
	
	  var Tabs = function (_PureComponent) {
	    _inherits(Tabs, _PureComponent);
	
	    function Tabs(props) {
	      _classCallCheck(this, Tabs);
	
	      var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
	
	      var defaultTabIndex = typeof props.activeTabIndex === 'undefined' ? props.defaultTabIndex : props.activeTabIndex;
	      var mobile = typeof window !== 'undefined' ? _this._isMobile(props) : props.defaultMedia !== 'desktop';
	      var indicatorWidth = mobile ? MOBILE_TAB_MIN_WIDTH : DESKTOP_TAB_MIN_WIDTH;
	      _this.state = {
	        indicatorWidth: indicatorWidth,
	        indicatorOffset: indicatorWidth * defaultTabIndex,
	        indicatorVisible: true,
	        overflowIndex: 0
	      };
	
	      if (typeof props.activeTabIndex === 'undefined') {
	        _this.state.activeTabIndex = defaultTabIndex;
	      }
	
	      _this._setContainer = _this._setContainer.bind(_this);
	      _this._positionElements = _this._positionElements.bind(_this);
	      _this._scrollActiveIntoView = _this._scrollActiveIntoView.bind(_this);
	      _this._handleTabChange = _this._handleTabChange.bind(_this);
	      _this._nextIndexes = _this._nextIndexes.bind(_this);
	      _this._showNextTabs = _this._showNextTabs.bind(_this);
	      _this._showPreviousTabs = _this._showPreviousTabs.bind(_this);
	      _this._mapToOverflowTabProps = _this._mapToOverflowTabProps.bind(_this);
	      return _this;
	    }
	
	    _createClass(Tabs, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        window.addEventListener('resize', this._positionElements);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.activeTabIndex !== nextProps.activeTabIndex) {
	          this.setState(_extends({}, this._calcIndicatorPosition(this._container, 0, nextProps.activeTabIndex, this.state.overflowAtIndex)), this._scrollActiveIntoView);
	        } else if (!this._shouldAlign(nextProps) && this._shouldAlign(this.props)) {
	          this.setState({ paddingLeft: null });
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        var _this2 = this;
	
	        if (this._shouldAlign(this.props) && this.state.overflowAtIndex !== prevState.overflowAtIndex) {
	          var paddingLeft = this._calcPaddingLeft(this._container, this.state.mobile);
	          // Have to wait for the overflow menus to appear, then wop
	          /* eslint-disable react/no-did-update-set-state */
	          this.setState({ paddingLeft: paddingLeft });
	        } else {
	          (function () {
	            var labels = _react.Children.map(_react.Children.toArray(_this2.props.children), function (_ref) {
	              var label = _ref.props.label;
	              return label;
	            });
	            var prevLabels = _react.Children.map(_react.Children.toArray(prevProps.children), function (_ref2) {
	              var label = _ref2.props.label;
	              return label;
	            });
	            if (labels.length !== prevLabels.length || labels.filter(function (_, i) {
	              return labels[i] !== prevLabels[i];
	            }).length) {
	              _this2.setState(_extends({}, _this2._calcIndicatorPosition(_this2._container, 0, _this2.props.activeTabIndex, _this2.state.overflowAtIndex)), _this2._scrollActiveIntoView);
	            }
	          })();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this._positionElements);
	      }
	    }, {
	      key: '_shouldAlign',
	      value: function _shouldAlign(props) {
	        return typeof props.alignToKeyline === 'boolean' ? props.alignToKeyline : _react.Children.toArray(props.children).filter(function (child) {
	          return !!child;
	        }).length > 3;
	      }
	    }, {
	      key: '_isMobile',
	      value: function _isMobile(props) {
	        var min = props.desktopMinWidth;
	
	        return typeof window !== 'undefined' && !window.matchMedia('screen and (min-width: ' + min + 'px)').matches;
	      }
	    }, {
	      key: '_calcPaddingLeft',
	      value: function _calcPaddingLeft(container, mobile) {
	        var mediaPadding = mobile ? MOBILE_PADDING : DESKTOP_PADDING;
	        var tab = container.querySelector('.md-tab');
	
	        var _tab$querySelector = tab.querySelector('.md-tab-label'),
	            labelOffset = _tab$querySelector.offsetLeft;
	
	        return mediaPadding - labelOffset;
	      }
	    }, {
	      key: '_calcOverflowIndex',
	      value: function _calcOverflowIndex(container) {
	        var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var menu = arguments[2];
	
	        var containerWidth = container.offsetWidth;
	        var overflowIndex = 0;
	        if (containerWidth < container.scrollWidth) {
	          (function () {
	            var tabs = Array.prototype.slice.call(container.querySelectorAll('.md-tab'));
	            var totalWidth = 0;
	            tabs.some(function (tab, i) {
	              overflowIndex = i;
	              totalWidth += tab.offsetWidth;
	
	              return totalWidth > containerWidth;
	            });
	          })();
	        }
	
	        return Math.max(0, overflowIndex - (menu ? 1 : 0));
	      }
	    }, {
	      key: '_calcIndicatorPosition',
	      value: function _calcIndicatorPosition(container) {
	        var paddingLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var activeTabIndex = arguments[2];
	        var overflowAtIndex = arguments[3];
	
	        var activeItem = void 0;
	        if (typeof activeTabIndex === 'number') {
	          if (overflowAtIndex > 0 && activeTabIndex >= overflowAtIndex) {
	            activeItem = container.querySelector('.md-menu--tab');
	          } else {
	            activeItem = container.querySelectorAll('.md-tab')[activeTabIndex];
	          }
	        } else {
	          activeItem = container.querySelector('.md-tab--active');
	        }
	
	        if (!activeItem) {
	          return { indicatorVisible: false };
	        }
	
	        var _activeItem = activeItem,
	            indicatorWidth = _activeItem.offsetWidth,
	            indicatorOffset = _activeItem.offsetLeft;
	
	        return {
	          indicatorWidth: indicatorWidth,
	          indicatorOffset: indicatorOffset + paddingLeft,
	          indicatorVisible: !overflowAtIndex || overflowAtIndex > activeTabIndex
	        };
	      }
	    }, {
	      key: '_setContainer',
	      value: function _setContainer(container) {
	        this._container = (0, _reactDom.findDOMNode)(container);
	        this._positionElements(this._container !== null);
	      }
	    }, {
	      key: '_positionElements',
	      value: function _positionElements(initialRender) {
	        initialRender = typeof initialRender === 'boolean' && initialRender;
	        if (!this._container) {
	          return;
	        }
	
	        var _props = this.props,
	            centered = _props.centered,
	            overflowMenu = _props.overflowMenu;
	
	        var mobile = this._isMobile(this.props);
	
	        var paddingLeft = void 0;
	        if (!centered && this._shouldAlign(this.props)) {
	          paddingLeft = this._calcPaddingLeft(this._container, mobile);
	        }
	
	        var overflowAtIndex = void 0;
	        if (!mobile) {
	          overflowAtIndex = this._calcOverflowIndex(this._container, paddingLeft, overflowMenu);
	        }
	
	        var indicatorPosition = this._calcIndicatorPosition(this._container, initialRender ? paddingLeft : 0);
	
	        this.setState(_extends({ mobile: mobile, paddingLeft: paddingLeft, overflowAtIndex: overflowAtIndex }, indicatorPosition), this._scrollActiveIntoView);
	      }
	    }, {
	      key: '_scrollActiveIntoView',
	      value: function _scrollActiveIntoView() {
	        var _this3 = this;
	
	        if (!this._container || !this.state.mobile) {
	          return;
	        }
	
	        var active = this._container.querySelector('.md-tab--active');
	        if (!active) {
	          return;
	        }
	
	        var allTabs = Array.prototype.slice.call(this._container.querySelectorAll('.md-tab'));
	        if (allTabs[0] === active) {
	          this._container.scrollLeft = 0;
	          return;
	        }
	
	        var _container = this._container,
	            containerWidth = _container.offsetWidth,
	            scrollLeft = _container.scrollLeft;
	        var activeWidth = active.offsetWidth,
	            activeOffset = active.offsetLeft;
	
	        var inFullViewLeft = activeOffset - scrollLeft >= 0;
	        var inFullViewRight = activeOffset + activeWidth - (containerWidth + scrollLeft) <= 0;
	        if (inFullViewLeft && inFullViewRight) {
	          return;
	        }
	
	        var offset = 0;
	        allTabs.some(function (tab, i) {
	          if (i < _this3.props.activeTabIndex) {
	            offset += tab.offsetWidth;
	          }
	
	          return i < _this3.state.activeTabIndex;
	        });
	
	        this._container.scrollLeft = offset;
	      }
	    }, {
	      key: '_handleTabChange',
	      value: function _handleTabChange(index, tabId, tabControlsId, tabChildren, event) {
	        if (this.props.onTabChange) {
	          this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
	        }
	
	        if (typeof this.props.activeTabIndex === 'undefined') {
	          this.setState(_extends({
	            activeTabIndex: index
	          }, this._calcIndicatorPosition(this._container, 0, index, this.state.overflowAtIndex)));
	        }
	      }
	    }, {
	      key: '_mapToOverflowTabProps',
	      value: function _mapToOverflowTabProps(tab, i) {
	        var index = i + this.state.overflowAtIndex;
	        var active = (0, _getField2.default)(this.props, this.state, 'activeTabIndex') === index;
	        var tabEl = _react.Children.only(tab);
	        var handleTabChange = this._handleTabChange;
	
	        return {
	          active: active,
	          primaryText: tabEl.props.label,
	          onClick: function handleClick(event) {
	            var _tabEl$props = tabEl.props,
	                onClick = _tabEl$props.onClick,
	                id = _tabEl$props.id,
	                controlsId = _tabEl$props.controlsId,
	                children = _tabEl$props.children;
	
	            if (onClick) {
	              onClick(index, event);
	            }
	
	            handleTabChange(index, id, controlsId, children, event);
	          }
	        };
	      }
	    }, {
	      key: '_nextIndexes',
	      value: function _nextIndexes(increment) {
	        var _state = this.state,
	            overflowIndex = _state.overflowIndex,
	            overflowAtIndex = _state.overflowAtIndex;
	
	        var visibleAmt = (overflowAtIndex - overflowIndex) * (increment ? 1 : -1);
	
	        this.setState({
	          overflowIndex: overflowIndex + visibleAmt,
	          overflowAtIndex: overflowAtIndex + visibleAmt
	        });
	      }
	    }, {
	      key: '_showNextTabs',
	      value: function _showNextTabs() {
	        this._nextIndexes(true);
	      }
	    }, {
	      key: '_showPreviousTabs',
	      value: function _showPreviousTabs() {
	        this._nextIndexes(false);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _state2 = this.state,
	            indicatorOffset = _state2.indicatorOffset,
	            indicatorWidth = _state2.indicatorWidth,
	            indicatorVisible = _state2.indicatorVisible,
	            overflowIndex = _state2.overflowIndex,
	            overflowAtIndex = _state2.overflowAtIndex,
	            paddingLeft = _state2.paddingLeft;
	
	        var _props2 = this.props,
	            Component = _props2.component,
	            style = _props2.style,
	            className = _props2.className,
	            colored = _props2.colored,
	            centered = _props2.centered,
	            tabId = _props2.tabId,
	            overflowMenu = _props2.overflowMenu,
	            overflowMenuLabel = _props2.overflowMenuLabel,
	            overflowMenuIconChildren = _props2.overflowMenuIconChildren,
	            overflowMenuIconClassName = _props2.overflowMenuIconClassName,
	            nextIconChildren = _props2.nextIconChildren,
	            nextIconClassName = _props2.nextIconClassName,
	            previousIconChildren = _props2.previousIconChildren,
	            previousIconClassName = _props2.previousIconClassName,
	            props = _objectWithoutProperties(_props2, ['component', 'style', 'className', 'colored', 'centered', 'tabId', 'overflowMenu', 'overflowMenuLabel', 'overflowMenuIconChildren', 'overflowMenuIconClassName', 'nextIconChildren', 'nextIconClassName', 'previousIconChildren', 'previousIconClassName']);
	
	        delete props.activeTabIndex;
	        delete props.defaultTabIndex;
	        delete props.defaultMedia;
	        delete props.desktopMinWidth;
	        delete props.onTabChange;
	
	        var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	        var icon = false;
	        var children = _react.Children.map(_react.Children.toArray(this.props.children), function (tab, index) {
	          var handleOnClick = function handleOnClick(tabIndex, id, tabControlsId, tabChildren, event) {
	            if (tab.props.onClick) {
	              tab.props.onClick(tabId, id, tabControlsId, tabChildren, event);
	            }
	
	            _this4._handleTabChange(tabIndex, id, tabControlsId, tabChildren, event);
	          };
	
	          if (tab.props.icon) {
	            icon = true;
	          }
	
	          return (0, _react.cloneElement)(tab, {
	            index: index,
	            id: tab.props.id || tabId + '-' + index,
	            controlsId: tab.props.controlsId || tabId + '-panel-' + index,
	            active: index === activeTabIndex,
	            onClick: handleOnClick
	          });
	        });
	
	        var overflow = void 0;
	        var nextControl = void 0;
	        var previousControl = void 0;
	        if (overflowAtIndex) {
	          var length = children.length;
	          if (overflowMenu) {
	            overflow = _react2.default.createElement(_MenuTab2.default, {
	              id: tabId + '-overflow-menu',
	              activeTabIndex: activeTabIndex,
	              overflowAtIndex: overflowAtIndex,
	              label: _react2.default.createElement(
	                _IconSeparator2.default,
	                { label: overflowMenuLabel },
	                _react2.default.createElement(
	                  _FontIcon2.default,
	                  { iconClassName: overflowMenuIconClassName },
	                  overflowMenuIconChildren
	                )
	              ),
	              tabs: children.slice(overflowAtIndex, children.length).map(this._mapToOverflowTabProps)
	            });
	          }
	
	          children = children.slice(overflowIndex, overflowAtIndex);
	
	          if (!overflowMenu && overflowIndex > 0) {
	            previousControl = _react2.default.createElement(
	              _TabOverflowButton2.default,
	              { iconClassName: previousIconClassName, onClick: this._showPreviousTabs, left: true, icon: icon },
	              previousIconChildren
	            );
	          }
	
	          if (!overflowMenu && length > 3 && overflowAtIndex + overflowIndex <= length) {
	            nextControl = _react2.default.createElement(
	              _TabOverflowButton2.default,
	              { iconClassName: nextIconClassName, onClick: this._showNextTabs, icon: icon },
	              nextIconChildren
	            );
	          }
	        }
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, props, {
	            ref: this._setContainer,
	            style: _extends({}, style, { paddingLeft: paddingLeft }),
	            className: (0, _classnames2.default)('md-tabs', {
	              'md-tabs--pagination': overflowAtIndex && !overflowMenu,
	              'md-tabs--centered': centered,
	              'md-background--primary': colored
	            }, className),
	            role: 'tablist'
	          }),
	          previousControl,
	          children,
	          nextControl,
	          overflow,
	          _react2.default.createElement(_TabIndicator2.default, { offset: indicatorOffset, width: indicatorWidth, visible: indicatorVisible })
	        );
	      }
	    }]);
	
	    return Tabs;
	  }(_react.PureComponent);
	
	  Tabs.propTypes = {
	    /**
	     * A base id to use for each `Tab`. When the child tabs are created, they are cloned
	     * with some additional accessibility props. Each tab will get a prop with this and the
	     * current index of the tab.
	     */
	    tabId: (0, _isRequiredForA11y2.default)(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])),
	
	    /**
	     * An optional style to apply.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * The component to render the tabs in.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * This should either be a single `Tab` component or a list of `Tab` components. Unfortunately,
	     * the child *must* be exactly a `Tab` component because this is unable to extract the correct
	     * `label` and `children` from a custom `Tab` component.
	     */
	    children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.arrayOf(_react.PropTypes.element)]).isRequired,
	
	    /**
	     * Boolean if the tabs should be centered instead of aligned to the keyline. The tabs will
	     * only be aligned to the keyline when there are more than 3 tabs and the `alignToKeyline`
	     * prop is `false`.
	     */
	    centered: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the tabs should align to a toolbar's title keyline. If this is undefined,
	     * the tabs will try to align to the keyline when there are more than 3 tabs.
	     */
	    alignToKeyline: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the tabs should be colored with the primary color. If this is false or undefined,
	     * the tabs will be colored for the light or dark theme.
	     */
	    colored: _react.PropTypes.bool,
	
	    /**
	     * A boolean if the overflow tabs on desktop displays should appear in a menu. If this is false,
	     * the additional tabs will be available by using pagination buttons.
	     */
	    overflowMenu: _react.PropTypes.bool,
	
	    /**
	     * An optional function to call when the active tab is changed. The callback will include
	     * the new active tab index and a click event.
	     *
	     * ```js
	     * onTabChange(newTabIndex, event);
	     * ```
	     */
	    onTabChange: _react.PropTypes.func,
	
	    /**
	     * An optional active tab index to use. If this is defined, it will make the component controlled
	     * and require the `onTabChange` prop to be defined.
	     */
	    activeTabIndex: (0, _controlled2.default)(_react.PropTypes.number, 'onTabChange', 'defaultTabIndex'),
	
	    /**
	     * The default tab index to use when the component is uncontrolled.
	     */
	    defaultTabIndex: _react.PropTypes.number.isRequired,
	
	    /**
	     * The default media to render the tabs for. This is really just used for server side rendering.
	     * Once the component has mounted, it will resize automatically.
	     */
	    defaultMedia: _react.PropTypes.oneOf(['mobile', 'tablet', 'desktop']).isRequired,
	
	    /**
	     * The min width to use for rendering the tabs for desktops. mobile and tablet is not used
	     * because they share the same styles.
	     */
	    desktopMinWidth: _react.PropTypes.number.isRequired,
	
	    /**
	     * When the `overflowMenu` prop is false, this will be used to render the "next slice of tabs"
	     * when there are too many tabs to display at once on desktop screens.
	     */
	    nextIconChildren: _react.PropTypes.node,
	
	    /**
	     * When the `overflowMenu` prop is false, this will be used to render the "next slice of tabs"
	     * when there are too many tabs to display at once on desktop screens.
	     */
	    nextIconClassName: _react.PropTypes.string,
	
	    /**
	     * When the `overflowMenu` prop is false, this will be used to render the "previous slice of tabs"
	     * when there are too many tabs to display at once on desktop screens.
	     */
	    previousIconChildren: _react.PropTypes.node,
	
	    /**
	     * When the `overflowMenu` prop is false, this will be used to render the "previous slice of tabs"
	     * when there are too many tabs to display at once on desktop screens.
	     */
	    previousIconClassName: _react.PropTypes.string,
	
	    /**
	     * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
	     * This will be the text that displays as a tab.
	     */
	    overflowMenuLabel: _react.PropTypes.node.isRequired,
	
	    /**
	     * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
	     * This will be to render the icon to the right of the label.
	     */
	    overflowMenuIconChildren: _react.PropTypes.node,
	
	    /**
	     * When the `overflowMenu` prop is true, this will be used to render the `MenuTab` overflow menu.
	     * This will be to render the icon to the right of the label.
	     */
	    overflowMenuIconClassName: _react.PropTypes.string
	  };
	  Tabs.defaultProps = {
	    component: 'ul',
	    defaultTabIndex: 0,
	    defaultMedia: 'mobile',
	    desktopMinWidth: _media.DESKTOP_MIN_WIDTH,
	    nextIconChildren: 'keyboard_arrow_right',
	    previousIconChildren: 'keyboard_arrow_left',
	    overflowMenuLabel: 'More',
	    overflowMenuIconChildren: 'arrow_drop_down'
	  };
	  exports.default = Tabs;
	});

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(2), __webpack_require__(548), __webpack_require__(12), __webpack_require__(14), __webpack_require__(68), __webpack_require__(26), __webpack_require__(213)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('classnames'), require('react-swipeable-views'), require('../utils/getField'), require('../utils/PropTypes/controlled'), require('../utils/PropTypes/between'), require('../Papers/Paper'), require('./TabPanel'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.classnames, global.reactSwipeableViews, global.getField, global.controlled, global.between, global.Paper, global.TabPanel);
	    global.TabsContainer = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _classnames, _reactSwipeableViews, _getField, _controlled, _between, _Paper, _TabPanel) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _reactSwipeableViews2 = _interopRequireDefault(_reactSwipeableViews);
	
	  var _getField2 = _interopRequireDefault(_getField);
	
	  var _controlled2 = _interopRequireDefault(_controlled);
	
	  var _between2 = _interopRequireDefault(_between);
	
	  var _Paper2 = _interopRequireDefault(_Paper);
	
	  var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TabsContainer = function (_PureComponent) {
	    _inherits(TabsContainer, _PureComponent);
	
	    function TabsContainer(props) {
	      _classCallCheck(this, TabsContainer);
	
	      var _this = _possibleConstructorReturn(this, (TabsContainer.__proto__ || Object.getPrototypeOf(TabsContainer)).call(this, props));
	
	      _this.state = {};
	      if (typeof props.activeTabIndex === 'undefined') {
	        _this.state.activeTabIndex = props.defaultTabIndex;
	      }
	
	      _this._handleTabChange = _this._handleTabChange.bind(_this);
	      _this._handleSwipeChange = _this._handleSwipeChange.bind(_this);
	      return _this;
	    }
	
	    _createClass(TabsContainer, [{
	      key: '_handleTabChange',
	      value: function _handleTabChange(index, tabId, tabControlsId, tabChildren, event) {
	        if (this.props.onTabChange) {
	          this.props.onTabChange(index, tabId, tabControlsId, tabChildren, event);
	        }
	
	        if (typeof this.props.activeTabIndex === 'undefined') {
	          this.setState({ activeTabIndex: index });
	        }
	      }
	    }, {
	      key: '_handleSwipeChange',
	      value: function _handleSwipeChange(activeTabIndex) {
	        this._handleTabChange(activeTabIndex);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var panelHeight = this.state.panelHeight;
	
	        var _props = this.props,
	            Component = _props.component,
	            style = _props.style,
	            className = _props.className,
	            panelStyle = _props.panelStyle,
	            panelClassName = _props.panelClassName,
	            panelComponent = _props.panelComponent,
	            headerStyle = _props.headerStyle,
	            headerClassName = _props.headerClassName,
	            slideStyle = _props.slideStyle,
	            swipeableViewsStyle = _props.swipeableViewsStyle,
	            swipeableViewsClassName = _props.swipeableViewsClassName,
	            headerComponent = _props.headerComponent,
	            headerZDepth = _props.headerZDepth,
	            children = _props.children,
	            colored = _props.colored,
	            fixed = _props.fixed,
	            labelAndIcon = _props.labelAndIcon,
	            props = _objectWithoutProperties(_props, ['component', 'style', 'className', 'panelStyle', 'panelClassName', 'panelComponent', 'headerStyle', 'headerClassName', 'slideStyle', 'swipeableViewsStyle', 'swipeableViewsClassName', 'headerComponent', 'headerZDepth', 'children', 'colored', 'fixed', 'labelAndIcon']);
	
	        delete props.toolbar;
	        var toolbar = this.props.toolbar;
	
	
	        var activeTabIndex = (0, _getField2.default)(this.props, this.state, 'activeTabIndex');
	
	        var tabsEl = _react.Children.only(children);
	        var tabId = tabsEl.props.tabId;
	        var content = _react.Children.map(tabsEl.props.children, function (tab, index) {
	          if (!tab) {
	            return tab;
	          }
	
	          return _react2.default.createElement(
	            _TabPanel2.default,
	            {
	              id: tab.props.controlsId || tabId + '-panel-' + index,
	              active: activeTabIndex === index,
	              style: panelStyle,
	              className: panelClassName,
	              component: panelComponent,
	              controlledById: tab.props.id || tabId + '-' + index
	            },
	            tab.props.children
	          );
	        });
	
	        var childrenProps = _react.Children.only(children).props;
	        var tabs = (0, _react.cloneElement)(children, {
	          colored: typeof childrenProps.colored !== 'undefined' ? childrenProps.colored : colored,
	          onTabChange: this._handleTabChange,
	          activeTabIndex: activeTabIndex
	        });
	
	        var prominentToolbar = false;
	        if (toolbar) {
	          var toolbarProps = _react.Children.only(toolbar).props;
	          toolbar = (0, _react.cloneElement)(toolbar, {
	            component: toolbarProps.component || 'div',
	            colored: typeof toolbarProps.colored !== 'undefined' ? childrenProps.colored : colored
	          });
	
	          prominentToolbar = toolbarProps.prominent || toolbarProps.prominentTitle;
	        }
	
	        var header = void 0;
	        if (fixed) {
	          header = _react2.default.createElement(
	            _Paper2.default,
	            {
	              style: headerStyle,
	              className: (0, _classnames2.default)('md-tabs-fixed-container', headerClassName),
	              zDepth: headerZDepth,
	              component: headerComponent
	            },
	            toolbar,
	            tabs
	          );
	        }
	
	        return _react2.default.createElement(
	          Component,
	          {
	            style: style,
	            className: (0, _classnames2.default)('md-tabs-container', className),
	            ref: function ref(container) {
	              if (container) {
	                var activePanel = (0, _reactDom.findDOMNode)(container).querySelector('.md-tab-panel[aria-hidden=false]');
	                if (activePanel && _this2.state.panelHeight !== activePanel.offsetHeight) {
	                  _this2.setState({ panelHeight: activePanel.offsetHeight });
	                }
	              }
	            }
	          },
	          header,
	          header ? null : toolbar,
	          header ? null : tabs,
	          _react2.default.createElement(
	            _reactSwipeableViews2.default,
	            {
	              style: swipeableViewsStyle,
	              className: (0, _classnames2.default)('md-tabs-content', {
	                'md-tabs-content--offset': fixed,
	                'md-tabs-content--offset-icon': fixed && labelAndIcon,
	                'md-tabs-content--offset-toolbar': fixed && toolbar,
	                'md-tabs-content--offset-toolbar-prominent': fixed && toolbar && prominentToolbar,
	                'md-tabs-content--offset-toolbar-icon': fixed && toolbar && labelAndIcon,
	                'md-tabs-content--offset-toolbar-prominent-icon': fixed && toolbar && labelAndIcon && prominentToolbar
	              }, swipeableViewsClassName),
	              slideStyle: _extends({ height: panelHeight }, slideStyle),
	              index: activeTabIndex,
	              onChangeIndex: this._handleSwipeChange
	            },
	            content
	          )
	        );
	      }
	    }]);
	
	    return TabsContainer;
	  }(_react.PureComponent);
	
	  TabsContainer.propTypes = {
	    /**
	     * An optional style to apply to the container.
	     */
	    style: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the container.
	     */
	    className: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to each `TabPanel` that gets generated. Each tab's children
	     * will get wrapped in a `TabPanel` component.
	     */
	    panelStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to each each `TabPanel` that gets generated. Each tab's
	     * children will get wrapped in a `TabPanel` component.
	     */
	    panelClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the header component when the tabs are fixed to the top of the page.
	     * The optional toolbar and tabs get wrapped in a `Paper` component.
	     */
	    headerStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the header component when the tabs are fixed to the top of the page.
	     * The optional toolbar and tabs get wrapped in a `Paper` component.
	     */
	    headerClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to the `SwipeableViews`.
	     *
	     * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
	     */
	    swipeableViewsStyle: _react.PropTypes.object,
	
	    /**
	     * An optional className to apply to the `SwipeableViews` container.
	     */
	    swipeableViewsClassName: _react.PropTypes.string,
	
	    /**
	     * An optional style to apply to each slide component.
	     *
	     * @see https://github.com/oliviertassinari/react-swipeable-views#user-content-swipeableviews-
	     */
	    slideStyle: _react.PropTypes.object,
	
	    /**
	     * This should be a `Tabs` component with children of `Tab`. This is used to figure out which
	     * tab's content is currently visible.
	     */
	    children: _react.PropTypes.element.isRequired,
	
	    /**
	     * The component to render the container as.
	     */
	    component: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]).isRequired,
	
	    /**
	     * The component to render each `TabPanel` as.
	     */
	    panelComponent: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
	
	    /**
	     * An optional toolbar to render above the tabs.
	     */
	    toolbar: _react.PropTypes.element,
	
	    /**
	     * An optional active tab index to use. If this is defined, the component will be controlled
	     * and require the `onTabChange` prop to be defined.
	     */
	    activeTabIndex: (0, _controlled2.default)(_react.PropTypes.number, 'onTabChange', 'defaultTabIndex'),
	
	    /**
	     * An optional function to call when a new tab is seleced by swiping or clicking a tab. When
	     * a new tab has been clicked, the callback will include the active tab index, the tab's `id`,
	     * the tab's `controlsId`, the tab's `children`, and the click event.
	     *
	     * If the tab was changed by swiping, it will only contain the new active tab index.
	     *
	     * ```js
	     * onTabChange(newActiveTabIndex, tabId, tabControlsId, tabChildren, event);
	     * ```
	     */
	    onTabChange: _react.PropTypes.func,
	
	    /**
	     * The default tab index to use when the component is uncontrolled.
	     */
	    defaultTabIndex: _react.PropTypes.number.isRequired,
	
	    /**
	     * Boolean if the `toolbar` and `Tabs` should be cloned with `colored: true`.
	     */
	    colored: _react.PropTypes.bool,
	
	    /**
	     * Boolean if the tabs and the optional toolbar should be fixed to the top of the page.
	     */
	    fixed: _react.PropTypes.bool,
	
	    /**
	     * A boolean if a `fixed` `TabsContainer` has tabs with a label and an icon.
	     */
	    labelAndIcon: _react.PropTypes.bool,
	
	    /**
	     * An optional component to render the fixed tabs header as.
	     */
	    headerComponent: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
	
	    /**
	     * The zDepth for the fixed tabs header.
	     */
	    headerZDepth: (0, _between2.default)(_react.PropTypes.number, 0, 5)
	  };
	  TabsContainer.defaultProps = {
	    component: 'section',
	    defaultTabIndex: 0,
	    headerZDepth: 1
	  };
	  exports.default = TabsContainer;
	});

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(494), __webpack_require__(493), __webpack_require__(490), __webpack_require__(212), __webpack_require__(213)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./TabsContainer'), require('./Tabs'), require('./Tab'), require('./MenuTab'), require('./TabPanel'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.TabsContainer, global.Tabs, global.Tab, global.MenuTab, global.TabPanel);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _TabsContainer, _Tabs2, _Tab2, _MenuTab2, _TabPanel2) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.TabPanel = exports.MenuTab = exports.Tab = exports.Tabs = exports.TabsContainer = undefined;
	
	  var _TabsContainer2 = _interopRequireDefault(_TabsContainer);
	
	  var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	  var _Tab3 = _interopRequireDefault(_Tab2);
	
	  var _MenuTab3 = _interopRequireDefault(_MenuTab2);
	
	  var _TabPanel3 = _interopRequireDefault(_TabPanel2);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _TabsContainer2.default;
	  exports.TabsContainer = _TabsContainer2.default;
	  exports.Tabs = _Tabs3.default;
	  exports.Tab = _Tab3.default;
	  exports.MenuTab = _MenuTab3.default;
	  exports.TabPanel = _TabPanel3.default;
	});

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(499)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('./TextArea'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.TextArea);
	    global.InputField = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _TextArea) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _TextArea2 = _interopRequireDefault(_TextArea);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var InputField = function (_PureComponent) {
	    _inherits(InputField, _PureComponent);
	
	    function InputField(props) {
	      _classCallCheck(this, InputField);
	
	      var _this = _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).call(this, props));
	
	      _this.getValue = _this.getValue.bind(_this);
	      _this.getField = _this.getField.bind(_this);
	      _this.focus = _this.focus.bind(_this);
	      _this._setField = _this._setField.bind(_this);
	      return _this;
	    }
	
	    _createClass(InputField, [{
	      key: 'getField',
	      value: function getField() {
	        return typeof this.props.rows === 'undefined' ? this._field : this._field.getField();
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue() {
	        if (typeof this.props.rows === 'undefined') {
	          return this._field.value;
	        }
	
	        return this._field.getValue();
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        this._field.focus();
	      }
	    }, {
	      key: '_setField',
	      value: function _setField(field) {
	        this._field = field;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            className = _props.className,
	            rows = _props.rows,
	            label = _props.label,
	            customSize = _props.customSize,
	            fullWidth = _props.fullWidth,
	            type = _props.type,
	            passwordVisible = _props.passwordVisible,
	            block = _props.block,
	            inlineIndicator = _props.inlineIndicator,
	            props = _objectWithoutProperties(_props, ['className', 'rows', 'label', 'customSize', 'fullWidth', 'type', 'passwordVisible', 'block', 'inlineIndicator']);
	
	        var multiline = typeof rows !== 'undefined';
	        var Component = multiline ? _TextArea2.default : 'input';
	        if (!multiline) {
	          props.type = passwordVisible ? 'text' : type;
	
	          delete props.maxRows;
	          delete props.onHeightChange;
	        } else {
	          props.label = label;
	          props.block = block;
	        }
	
	        return (0, _react.createElement)(Component, _extends({}, props, {
	          rows: rows,
	          ref: this._setField,
	          className: (0, _classnames2.default)('md-text-field', _defineProperty({
	            'md-text': !props.disabled,
	            'md-text--disabled': props.disabled,
	            'md-text-field--inline-indicator': inlineIndicator || !multiline && type === 'password',
	            'md-text-field--multiline': multiline,
	            'md-full-width': fullWidth,
	            'md-text-field--margin': !block && !multiline && !label,
	            'md-text-field--floating-margin': !block && !multiline && label
	          }, 'md-text-field--' + customSize, customSize), className)
	        }));
	      }
	    }]);
	
	    return InputField;
	  }(_react.PureComponent);
	
	  InputField.propTypes = {
	    id: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    type: _react.PropTypes.string,
	    placeholder: _react.PropTypes.string,
	    block: _react.PropTypes.bool,
	    disabled: _react.PropTypes.bool,
	    rows: _react.PropTypes.number,
	    maxRows: _react.PropTypes.number,
	    label: _react.PropTypes.string,
	    fullWidth: _react.PropTypes.bool,
	    customSize: _react.PropTypes.string,
	    passwordVisible: _react.PropTypes.bool,
	    inlineIndicator: _react.PropTypes.bool
	  };
	  exports.default = InputField;
	});

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.Message = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Message = function (_PureComponent) {
	    _inherits(Message, _PureComponent);
	
	    function Message() {
	      _classCallCheck(this, Message);
	
	      return _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).apply(this, arguments));
	    }
	
	    _createClass(Message, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            active = _props.active,
	            children = _props.children,
	            className = _props.className;
	
	
	        if (!children) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'span',
	          {
	            'aria-hidden': !active,
	            className: (0, _classnames2.default)('md-text-field-message', 'md-text-field-message--' + (active ? '' : 'in') + 'active', className)
	          },
	          children
	        );
	      }
	    }]);
	
	    return Message;
	  }(_react.PureComponent);
	
	  Message.propTypes = {
	    active: _react.PropTypes.bool,
	    className: _react.PropTypes.string,
	    children: _react.PropTypes.node
	  };
	  exports.default = Message;
	});

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(11), __webpack_require__(18)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../constants/keyCodes'), require('../FontIcons/FontIcon'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.keyCodes, global.FontIcon);
	    global.PasswordButton = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _keyCodes, _FontIcon) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var PasswordButton = function (_PureComponent) {
	    _inherits(PasswordButton, _PureComponent);
	
	    function PasswordButton(props) {
	      _classCallCheck(this, PasswordButton);
	
	      var _this = _possibleConstructorReturn(this, (PasswordButton.__proto__ || Object.getPrototypeOf(PasswordButton)).call(this, props));
	
	      _this.state = { keyboardFocus: false };
	
	      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	      _this._handleKeyDown = _this._handleKeyDown.bind(_this);
	      _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
	      return _this;
	    }
	
	    _createClass(PasswordButton, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.state.keyboardFocus) {
	          window.removeEventListener('click', this._handleOutsideClick);
	        }
	      }
	    }, {
	      key: '_handleOutsideClick',
	      value: function _handleOutsideClick(e) {
	        if (this._button && !this._button.contains(e.target)) {
	          window.removeEventListener('click', this._handleOutsideClick);
	          this.setState({ keyboardFocus: false });
	        }
	      }
	    }, {
	      key: '_handleKeyUp',
	      value: function _handleKeyUp(e) {
	        if (this.props.onKeyUp) {
	          this.props.onKeyUp(e);
	        }
	
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          window.addEventListener('click', this._handleOutsideClick);
	          this.setState({ keyboardFocus: true });
	        }
	      }
	    }, {
	      key: '_handleKeyDown',
	      value: function _handleKeyDown(e) {
	        if (this.props.onKeyDown) {
	          this.props.onKeyDown(e);
	        }
	
	        var key = e.which || e.keyCode;
	        if (key === _keyCodes.TAB || key === _keyCodes.ENTER || key === _keyCodes.SPACE) {
	          window.removeEventListener('click', this._handleOutsideClick);
	          this.setState({ keyboardFocus: false });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var keyboardFocus = this.state.keyboardFocus;
	
	        var _props = this.props,
	            active = _props.active,
	            passwordVisible = _props.passwordVisible,
	            iconClassName = _props.iconClassName,
	            iconChildren = _props.iconChildren,
	            block = _props.block,
	            floating = _props.floating,
	            props = _objectWithoutProperties(_props, ['active', 'passwordVisible', 'iconClassName', 'iconChildren', 'block', 'floating']);
	
	        return _react2.default.createElement(
	          'button',
	          _extends({}, props, {
	            onKeyDown: this._handleKeyDown,
	            onKeyUp: this._handleKeyUp,
	            type: 'button',
	            className: (0, _classnames2.default)('md-text-field-inline-indicator md-password-btn md-pointer--hover', {
	              'md-password-btn--focus': keyboardFocus,
	              'md-password-btn--active': active,
	              'md-password-btn--invisible': active && !passwordVisible,
	              'md-text-field-inline-indicator--floating': floating,
	              'md-text-field-inline-indicator--block': block
	            })
	          }),
	          _react2.default.createElement(
	            _FontIcon2.default,
	            { iconClassName: iconClassName },
	            iconChildren
	          )
	        );
	      }
	    }]);
	
	    return PasswordButton;
	  }(_react.PureComponent);
	
	  PasswordButton.propTypes = {
	    active: _react.PropTypes.bool,
	    passwordVisible: _react.PropTypes.bool,
	    iconClassName: _react.PropTypes.string,
	    iconChildren: _react.PropTypes.node,
	    onKeyUp: _react.PropTypes.func,
	    onKeyDown: _react.PropTypes.func,
	    block: _react.PropTypes.bool,
	    floating: _react.PropTypes.bool
	  };
	  exports.default = PasswordButton;
	});

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.TextArea = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TextArea = function (_PureComponent) {
	    _inherits(TextArea, _PureComponent);
	
	    function TextArea(props) {
	      _classCallCheck(this, TextArea);
	
	      var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));
	
	      _this.state = { height: null };
	      _this.focus = _this.focus.bind(_this);
	      _this.getField = _this.getField.bind(_this);
	      _this.getValue = _this.getValue.bind(_this);
	      _this._handleChange = _this._handleChange.bind(_this);
	      _this._handleResize = _this._handleResize.bind(_this);
	      _this._syncHeightWithMask = _this._syncHeightWithMask.bind(_this);
	      return _this;
	    }
	
	    _createClass(TextArea, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._rowHeight = this._calcRowHeight(this._field, this.props);
	        this._syncHeightWithMask();
	        window.addEventListener('resize', this._handleResize);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.rows !== nextProps.rows) {
	          this._rowHeight = this._calcRowHeight(this._field, this.props);
	        }
	
	        if (this.props.value !== nextProps.value || this.props.maxRows !== nextProps.maxRows) {
	          this._syncHeightWithMask(nextProps.value);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this._handleResize);
	      }
	    }, {
	      key: 'getField',
	      value: function getField() {
	        return this._field;
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue() {
	        return this._field.value;
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        this._field.focus();
	      }
	    }, {
	      key: '_setMask',
	      value: function _setMask(mask) {
	        this._mask = mask;
	      }
	    }, {
	      key: '_setField',
	      value: function _setField(field) {
	        this._field = field;
	      }
	    }, {
	      key: '_calcRowHeight',
	      value: function _calcRowHeight(field, props) {
	        return field.offsetHeight / props.rows;
	      }
	    }, {
	      key: '_handleResize',
	      value: function _handleResize() {
	        this._rowHeight = this._calcRowHeight(this._field, this.props);
	        this._syncHeightWithMask();
	      }
	    }, {
	      key: '_syncHeightWithMask',
	      value: function _syncHeightWithMask(value) {
	        if (value !== undefined) {
	          this._mask.value = value;
	        }
	
	        var height = this._mask.scrollHeight;
	        if (height === undefined) {
	          return;
	        }
	
	        var _props = this.props,
	            rows = _props.rows,
	            maxRows = _props.maxRows;
	
	        if (maxRows && maxRows > 0) {
	          height = Math.min(height, this._rowHeight * maxRows);
	        }
	
	        height = Math.max(this._rowHeight * rows, height);
	
	        if (this.props.onHeightChange) {
	          // For some reason the md-text-field-multiline-container is 5px
	          // larger than the textareas.. So just add 5 here and on the inline style
	          this.props.onHeightChange(height + 5);
	        }
	
	        this.setState({ height: height });
	      }
	    }, {
	      key: '_handleChange',
	      value: function _handleChange(e) {
	        this._syncHeightWithMask(e.target.value, e);
	
	        if (this.props.onChange) {
	          this.props.onChange(e);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var height = this.state.height;
	
	        var _props2 = this.props,
	            style = _props2.style,
	            defaultValue = _props2.defaultValue,
	            value = _props2.value,
	            className = _props2.className,
	            label = _props2.label,
	            block = _props2.block,
	            props = _objectWithoutProperties(_props2, ['style', 'defaultValue', 'value', 'className', 'label', 'block']);
	
	        delete props.maxRows;
	        delete props.onChange;
	        delete props.onHeightChange;
	
	        return _react2.default.createElement(
	          'div',
	          {
	            style: { height: height && height + 5 },
	            className: (0, _classnames2.default)('md-text-field-multiline-container', {
	              'md-text-field--margin': !label && !block,
	              'md-text-field--floating-margin': label && !block
	            })
	          },
	          _react2.default.createElement('textarea', {
	            ref: function ref(mask) {
	              _this2._mask = mask;
	            },
	            className: (0, _classnames2.default)(className, 'md-text-field--multiline-mask'),
	            readOnly: true,
	            rows: props.rows,
	            tabIndex: -1,
	            style: style,
	            defaultValue: defaultValue,
	            'aria-hidden': true,
	            value: value
	          }),
	          _react2.default.createElement('textarea', _extends({}, props, {
	            ref: function ref(field) {
	              _this2._field = field;
	            },
	            style: Object.assign({}, style, { height: height }),
	            className: className,
	            defaultValue: defaultValue,
	            value: value,
	            onChange: this._handleChange
	          }))
	        );
	      }
	    }]);
	
	    return TextArea;
	  }(_react.PureComponent);
	
	  TextArea.propTypes = {
	    id: _react.PropTypes.string,
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    rows: _react.PropTypes.number.isRequired,
	    maxRows: _react.PropTypes.number,
	    onChange: _react.PropTypes.func,
	    defaultValue: _react.PropTypes.string,
	    floatingLabel: _react.PropTypes.bool,
	    value: _react.PropTypes.string,
	    onHeightChange: _react.PropTypes.func,
	    block: _react.PropTypes.bool,
	    label: _react.PropTypes.string
	  };
	  exports.default = TextArea;
	});

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(52)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./TextField'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.TextField);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _TextField) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _TextField2 = _interopRequireDefault(_TextField);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _TextField2.default;
	});

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames);
	    global.ToolbarTitle = mod.exports;
	  }
	})(this, function (exports, _react, _classnames) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var ToolbarTitle = function (_PureComponent) {
	    _inherits(ToolbarTitle, _PureComponent);
	
	    function ToolbarTitle(props) {
	      _classCallCheck(this, ToolbarTitle);
	
	      var _this = _possibleConstructorReturn(this, (ToolbarTitle.__proto__ || Object.getPrototypeOf(ToolbarTitle)).call(this, props));
	
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(ToolbarTitle, [{
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            title = _props.title,
	            className = _props.className,
	            prominent = _props.prominent,
	            offset = _props.offset,
	            props = _objectWithoutProperties(_props, ['title', 'className', 'prominent', 'offset']);
	
	        if (!title) {
	          return null;
	        }
	
	        var fullClassName = (0, _classnames2.default)('md-title md-title--toolbar', {
	          'md-title--toolbar-prominent': prominent,
	          'md-title--toolbar-offset': offset
	        }, className);
	
	        if ((0, _react.isValidElement)(title)) {
	          var titleEl = _react.Children.only(title);
	          return (0, _react.cloneElement)(title, {
	            className: (0, _classnames2.default)(fullClassName, titleEl.props.className)
	          });
	        }
	
	        return _react2.default.createElement(
	          'h2',
	          _extends({}, props, {
	            className: fullClassName
	          }),
	          title
	        );
	      }
	    }]);
	
	    return ToolbarTitle;
	  }(_react.PureComponent);
	
	  ToolbarTitle.propTypes = {
	    className: _react.PropTypes.string,
	    prominent: _react.PropTypes.bool,
	    offset: _react.PropTypes.bool,
	    title: _react.PropTypes.node
	  };
	  exports.default = ToolbarTitle;
	});

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(217)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./Toolbar'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.Toolbar);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _Toolbar) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _Toolbar2.default;
	});

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(30)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('classnames'), require('../constants/CSSTransitionGroupTick'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.classnames, global.CSSTransitionGroupTick);
	    global.Tooltip = mod.exports;
	  }
	})(this, function (exports, _react, _classnames, _CSSTransitionGroupTick) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _CSSTransitionGroupTick2 = _interopRequireDefault(_CSSTransitionGroupTick);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var Tooltip = function (_PureComponent) {
	    _inherits(Tooltip, _PureComponent);
	
	    function Tooltip(props) {
	      _classCallCheck(this, Tooltip);
	
	      var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	      _this.state = {
	        entering: false,
	        leaving: false,
	        active: false,
	        visible: false
	      };
	
	      _this._timeout = null;
	      return _this;
	    }
	
	    _createClass(Tooltip, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	      }
	    }, {
	      key: 'componentWillEnter',
	      value: function componentWillEnter(cb) {
	        var _this2 = this;
	
	        this._timeout = setTimeout(function () {
	          _this2._timeout = setTimeout(function () {
	            _this2._timeout = null;
	
	            cb();
	          }, _this2.props.enterTimeout);
	          _this2.setState({ active: true });
	        }, _CSSTransitionGroupTick2.default);
	
	        this.setState({ entering: true });
	      }
	    }, {
	      key: 'componentDidEnter',
	      value: function componentDidEnter() {
	        this.setState({ entering: false, active: false, visible: true });
	      }
	    }, {
	      key: 'componentWillLeave',
	      value: function componentWillLeave(cb) {
	        var _this3 = this;
	
	        if (this._timeout) {
	          clearTimeout(this._timeout);
	        }
	
	        this._timeout = setTimeout(function () {
	          _this3._timeout = setTimeout(function () {
	            _this3._timeout = null;
	
	            cb();
	          }, _this3.props.leaveTimeout);
	
	          _this3.setState({ active: true, visible: false });
	        }, _CSSTransitionGroupTick2.default);
	
	        this.setState({ leaving: true });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            active = _state.active,
	            entering = _state.entering,
	            leaving = _state.leaving,
	            visible = _state.visible;
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            children = _props.children,
	            position = _props.position;
	
	
	        var direction = position === 'top' || position === 'bottom' ? 'horizontal' : 'vertical';
	        return _react2.default.createElement(
	          'span',
	          {
	            style: style,
	            className: (0, _classnames2.default)('md-tooltip md-tooltip--' + position + ' md-tooltip--' + direction, _defineProperty({
	              'md-tooltip--active': active,
	              'md-tooltip--enter': entering,
	              'md-tooltip--enter-active': entering && active,
	              'md-tooltip--leave': leaving,
	              'md-tooltip--leave-active': leaving && active
	            }, 'md-tooltip--' + position + '-active', visible || entering && active), className)
	          },
	          children
	        );
	      }
	    }]);
	
	    return Tooltip;
	  }(_react.PureComponent);
	
	  Tooltip.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    position: _react.PropTypes.oneOf(['top', 'right', 'bottom', 'left']).isRequired,
	    children: _react.PropTypes.node.isRequired,
	    enterTimeout: _react.PropTypes.number.isRequired,
	    leaveTimeout: _react.PropTypes.number.isRequired
	  };
	  exports.default = Tooltip;
	});

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(7), __webpack_require__(166), __webpack_require__(2), __webpack_require__(11), __webpack_require__(67), __webpack_require__(503)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('react-dom'), require('react-addons-transition-group'), require('classnames'), require('../constants/keyCodes'), require('../utils/EventUtils/captureNextEvent'), require('./Tooltip'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.reactDom, global.reactAddonsTransitionGroup, global.classnames, global.keyCodes, global.captureNextEvent, global.Tooltip);
	    global.TooltipContainer = mod.exports;
	  }
	})(this, function (exports, _react, _reactDom, _reactAddonsTransitionGroup, _classnames, _keyCodes, _captureNextEvent, _Tooltip) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	  var _classnames2 = _interopRequireDefault(_classnames);
	
	  var _captureNextEvent2 = _interopRequireDefault(_captureNextEvent);
	
	  var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var TooltipContainer = function (_PureComponent) {
	    _inherits(TooltipContainer, _PureComponent);
	
	    function TooltipContainer(props) {
	      _classCallCheck(this, TooltipContainer);
	
	      var _this = _possibleConstructorReturn(this, (TooltipContainer.__proto__ || Object.getPrototypeOf(TooltipContainer)).call(this, props));
	
	      _this.state = { visible: false };
	      _this._delayedTimeout = null;
	
	      _this._setContainers = _this._setContainers.bind(_this);
	      _this._showTooltip = _this._showTooltip.bind(_this);
	      _this._hideTooltip = _this._hideTooltip.bind(_this);
	      _this._stopContextMenu = _this._stopContextMenu.bind(_this);
	      _this._handleKeyUp = _this._handleKeyUp.bind(_this);
	      return _this;
	    }
	
	    _createClass(TooltipContainer, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this._container) {
	          this._container.removeEventListener('mouseover', this._showTooltip);
	          this._container.removeEventListener('mouseleave', this._hideTooltip);
	          this._container.removeEventListener('touchstart', this._showTooltip);
	          this._container.removeEventListener('touchend', this._hideTooltip);
	          this._container.removeEventListener('keyup', this._handleKeyUp);
	          this._container.removeEventListener('blur', this._hideTooltip);
	        }
	
	        if (this._delayedTimeout) {
	          clearTimeout(this._delayedTimeout);
	        }
	      }
	    }, {
	      key: '_setContainers',
	      value: function _setContainers(container) {
	        if (container) {
	          this._container = (0, _reactDom.findDOMNode)(container).parentNode;
	
	          this._container.addEventListener('mouseover', this._showTooltip);
	          this._container.addEventListener('mouseleave', this._hideTooltip);
	          this._container.addEventListener('touchstart', this._showTooltip);
	          this._container.addEventListener('touchend', this._hideTooltip);
	          this._container.addEventListener('keyup', this._handleKeyUp);
	          this._container.addEventListener('blur', this._hideTooltip);
	        }
	      }
	    }, {
	      key: '_stopContextMenu',
	      value: function _stopContextMenu(e) {
	        e.preventDefault();
	        window.removeEventListener('contextmenu', this._stopContextMenu, true);
	        (0, _captureNextEvent2.default)('click');
	        this.setState({ visible: true });
	      }
	    }, {
	      key: '_showTooltip',
	      value: function _showTooltip(e) {
	        var _this2 = this;
	
	        if (e.type === 'mouseover' && this._touched) {
	          return;
	        }
	
	        if (e.type === 'touchstart') {
	          this._touched = true;
	
	          window.addEventListener('contextmenu', this._stopContextMenu, true);
	          return;
	        }
	
	        var delay = this.props.delay;
	
	        if (this._delayedTimeout) {
	          clearTimeout(this._delayedTimeout);
	        }
	
	        if (delay) {
	          this._delayedTimeout = setTimeout(function () {
	            _this2._delayedTimeout = null;
	
	            _this2.setState({ visible: true });
	          }, delay);
	        } else {
	          this.setState({ visible: true });
	        }
	      }
	    }, {
	      key: '_hideTooltip',
	      value: function _hideTooltip(e) {
	        if (this._delayedTimeout) {
	          clearTimeout(this._delayedTimeout);
	        }
	
	        if (e.type === 'mouseover' && this._touched) {
	          return;
	        }
	
	        this.setState({ visible: false });
	      }
	    }, {
	      key: '_handleKeyUp',
	      value: function _handleKeyUp(e) {
	        if ((e.which || e.keyCode) === _keyCodes.TAB) {
	          this._showTooltip(e);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var visible = this.state.visible;
	        var _props = this.props,
	            style = _props.style,
	            className = _props.className,
	            tooltipStyle = _props.tooltipStyle,
	            tooltipClassName = _props.tooltipClassName,
	            label = _props.label,
	            position = _props.position,
	            enterTimeout = _props.enterTimeout,
	            leaveTimeout = _props.leaveTimeout;
	
	
	        var tooltip = _react2.default.createElement(
	          _Tooltip2.default,
	          {
	            key: 'tooltip',
	            style: tooltipStyle,
	            className: tooltipClassName,
	            position: position,
	            enterTimeout: enterTimeout,
	            leaveTimeout: leaveTimeout
	          },
	          label
	        );
	
	        return _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          {
	            style: style,
	            className: (0, _classnames2.default)('md-tooltip-container', className),
	            ref: this._setContainers,
	            component: 'div'
	          },
	          visible ? tooltip : null
	        );
	      }
	    }]);
	
	    return TooltipContainer;
	  }(_react.PureComponent);
	
	  TooltipContainer.propTypes = {
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    tooltipStyle: _react.PropTypes.object,
	    tooltipClassName: _react.PropTypes.string,
	    label: _react.PropTypes.node.isRequired,
	    position: _Tooltip2.default.propTypes.position,
	    delay: _react.PropTypes.number.isRequired,
	    enterTimeout: _react.PropTypes.number.isRequired,
	    leaveTimeout: _react.PropTypes.number.isRequired
	  };
	  exports.default = TooltipContainer;
	});

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(84)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./injectTooltip'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.injectTooltip);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _injectTooltip) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _injectTooltip2 = _interopRequireDefault(_injectTooltip);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _injectTooltip2.default;
	});

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.addHours = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = addHours;
	  /**
	   * Adds hours to a date.
	   *
	   * @param {Date} time the time to increment
	   * @param {number} hours the number of hours to increment by.
	   * @return a new Date with the new hours set.
	   */
	  function addHours(time, hours) {
	    var t = new Date(time.getTime());
	    t.setHours(t.getHours() + hours);
	    return t;
	  }
	});

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(221)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./formatTime'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.formatTime);
	    global.extractTimeParts = mod.exports;
	  }
	})(this, function (exports, _formatTime) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = extractTimeParts;
	
	  var _formatTime2 = _interopRequireDefault(_formatTime);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _toArray(arr) {
	    return Array.isArray(arr) ? arr : Array.from(arr);
	  }
	
	  var _slicedToArray = function () {
	    function sliceIterator(arr, i) {
	      var _arr = [];
	      var _n = true;
	      var _d = false;
	      var _e = undefined;
	
	      try {
	        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	          _arr.push(_s.value);
	
	          if (i && _arr.length === i) break;
	        }
	      } catch (err) {
	        _d = true;
	        _e = err;
	      } finally {
	        try {
	          if (!_n && _i["return"]) _i["return"]();
	        } finally {
	          if (_d) throw _e;
	        }
	      }
	
	      return _arr;
	    }
	
	    return function (arr, i) {
	      if (Array.isArray(arr)) {
	        return arr;
	      } else if (Symbol.iterator in Object(arr)) {
	        return sliceIterator(arr, i);
	      } else {
	        throw new TypeError("Invalid attempt to destructure non-iterable instance");
	      }
	    };
	  }();
	
	  /**
	   * Extracts the hours, minutes, and optional time period from
	   * a date time.
	   *
	   * @param {function} DateTimeFormat the DateTimeFormat function to use.
	   * @param {string|string[]} locales the locales to use.
	   * @param {Date} time the time to extract from.
	   * @return {Object} an object of { hours, minutes, timePeriod }
	   */
	  function extractTimeParts(DateTimeFormat, locales, time) {
	    var formatted = (0, _formatTime2.default)(DateTimeFormat, locales, time);
	
	    // IE does not like lookaheads or splitting on [^0-9]
	    // it will include the non-printable characters..
	
	    var _formatted$match = formatted.match(/[0-9]+/g),
	        _formatted$match2 = _slicedToArray(_formatted$match, 2),
	        hours = _formatted$match2[0],
	        minutes = _formatted$match2[1];
	
	    var _formatted$match3 = formatted.match(/[ ,.:A-z]+/g),
	        _formatted$match4 = _toArray(_formatted$match3),
	        separator = _formatted$match4[0],
	        remaining = _formatted$match4.slice(1);
	
	    var timePeriod = void 0;
	    if (remaining && remaining.length) {
	      timePeriod = remaining.join('').trim();
	    }
	
	    return {
	      hours: hours,
	      minutes: separator + minutes,
	      timePeriod: timePeriod
	    };
	  }
	});

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.getLastDay = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = getLastDay;
	  /**
	   * Gets the last day in a month
	   *
	   * @param {Date} sourceDate the date to get the last day from.
	   * @return a new Date as the last day of the month.
	   */
	  function getLastDay(sourceDate) {
	    return new Date(sourceDate.getFullYear(), sourceDate.getMonth() + 1, 0);
	  }
	});

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.isDateEqual = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = isDateEqual;
	
	  /**
	   * Checks if two dates are equal by comparing the exact time.
	   * This allows null or undefined.
	   *
	   * @param {Date} d1 - The first date to compare.
	   * @param {Date} d2 - The second date to compare.
	   * @return {bool} - true if the dates are equal.
	   */
	  function isDateEqual(d1, d2) {
	    if (!d1 && !d2) {
	      return true;
	    } else if (!d1 && d2 || d1 && !d2) {
	      return false;
	    }
	
	    return d1.getTime() === d2.getTime();
	  }
	});

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(223)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./stripTime'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.stripTime);
	    global.isMonthBefore = mod.exports;
	  }
	})(this, function (exports, _stripTime) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = isMonthBefore;
	
	  var _stripTime2 = _interopRequireDefault(_stripTime);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  /**
	   * Checks if a date is the month before another date without time
	   *
	   * @param {Date} date the date to check if it is before the other
	   * @param {Date} toCompare the date to compare to
	   * @return true if the date is before the other date's first day of month.
	   */
	  function isMonthBefore(date, toCompare) {
	    if (!date || !toCompare) {
	      return false;
	    }
	
	    var d1 = (0, _stripTime2.default)(new Date(date.getFullYear(), date.getMonth(), 1));
	    var d2 = (0, _stripTime2.default)(new Date(toCompare.getFullYear(), toCompare.getMonth() - 1, 1));
	    return d1 > d2;
	  }
	});

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.calcTimeFromPoint = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = calcTimeFromPoint;
	  function isPointInCircle(cx, cy, r, x, y) {
	    var distance = Math.pow(cx - x, 2) + Math.pow(cy - y, 2);
	    return distance <= Math.pow(r, 2);
	  }
	
	  function toDegrees(radians) {
	    return radians * (180 / Math.PI);
	  }
	
	  /**
	   * Takes a point from a mouse or touch event and a center point of a circle to determine
	   * what the new time should be.
	   *
	   * If the point.y < center.y, the point is in the top half of the circle.
	   * If the point.x < center.x, the point is in the left half of the circle.
	   *
	   * @param {Object} point - The mouse or touch event's point that contains an x and y coordinate.
	   * @param {Object} center - The center point for the circle that contains an x and y coordinate.
	   * @param {Number} innerRadius - An inner radius for clocks that have 24 hour times. This is
	   *    a circle that contains hours 12-23.
	   * @param {Boolean} minutes - Boolena if the current time to be calculated is minutes instead of
	   *    hours.
	   * @param {Boolean} hour12 - Boolean if the clock is a 12 hour clock.
	   * @return {Number} the new time.
	   */
	  function calcTimeFromPoint(point, center, innerRadius, minutes, hour12) {
	    var x = point.x - center.x;
	    var y = point.y - center.y;
	    var degrees = toDegrees(Math.atan2(y, x));
	    var sectors = minutes ? 60 : 12;
	    var sectorSize = 360 / sectors;
	    var time = Math.round(degrees / sectorSize);
	
	    // Since the css transform has 0π at π/2 place, we need to offset the
	    // time to that location.
	    time += minutes ? 15 : 3;
	
	    // If time is still negative, it is in the top half of the circle
	    if (time < 0) {
	      time += sectors;
	    }
	
	    // Finally, if it is a 24 hour clock, need to check if the point is actually
	    // selecting hours 13 - 24 (0).
	    if (!minutes && !hour12) {
	      var isInCircle = isPointInCircle(0, 0, innerRadius, x, y);
	
	      if (time === 0 && !isInCircle || time !== 0 && isInCircle) {
	        time += 12;
	      }
	    }
	
	    return time;
	  }
	});

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.calculateHypotenuse = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = calculateHypotenuse;
	  /**
	   * Calculates the hypotenuse using the x and y coordinates given.
	   *
	   * @param {number} a the x coordinate
	   * @param {number} b the y coordinate
	   * @return {number} the hypotenuse length for the given x and y coordinates.
	   */
	  function calculateHypotenuse(a, b) {
	    return Math.sqrt(a * a + b * b);
	  }
	});

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.calculateValueDistance = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = calculateValueDistance;
	  /**
	   * This calculates the distance from a screen x location to a position in some element
	   * by comparing the width of the element and the element's page position to the screen
	   * x position.
	   *
	   * If the distance is not _normalized_ the distance will be updated to be a percentage
	   * of the element's total width.
	   *
	   * @param {Number} x - the screen x location.
	   * @param {Number} width - the element's width
	   * @param {Number} left - the element's page x position.
	   * @param {Boolean} normalize - boolean if the distance should be a percentage.
	   *
	   * @return {Number} the distance from the element's left position to the page x
	   *    location.
	   */
	  function calculateDistance(x, width, left, normalize) {
	    var distance = Math.min(width, Math.max(0, x - left));
	
	    return normalize ? distance : distance / width * 100;
	  }
	
	  /**
	   * This calculates the new value and distance for a slider. It will compare the page x
	   * location of a touch or mouse event to the slider's track page x position. If the
	   * final value and distance should be _normalized_, they will be updated to be rounded
	   * with the scale and steps in mind.
	   *
	   * The distance will always be contained within a percentage of 0 - 100 while the
	   * value will be contained within the min and max values.
	   *
	   * @param {Number} x - the page x location of the touch or mouse event.
	   * @param {Number} width - the slider's width
	   * @param {Number} left - the slider's left position in the page.
	   * @param {Number} scale - the total number values included in the slider.
	   * @param {Number} step - the amount to increment by.
	   * @param {Number} min - the min value for the slider.
	   * @param {Number} max - the max value for the slider.
	   * @param {Boolean} normalize - boolean if the vaue and distance should be _normalized_.
	   *
	   * @return {Object} an object with the value and distance.
	   */
	  function calculateValueDistance(x, width, left, scale, step, min, max, normalize) {
	    var value = void 0;
	    var distance = calculateDistance(x, width, left, normalize);
	    if (normalize) {
	      value = Math.round(distance / (width / scale));
	      if (step < 1) {
	        var decimals = String(step).split('.')[1];
	        var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;
	
	        var modded = value * corrector % (step * corrector);
	        if (modded !== 0 && modded >= step / 2) {
	          value += step - modded;
	        } else if (modded !== 0) {
	          value -= modded;
	        }
	      }
	
	      distance = value / scale * 100;
	      value += min;
	    } else {
	      value = Math.round(distance / 100 * scale);
	    }
	
	    if (step > 1) {
	      value *= step;
	    } else if (step > 0 && step < 1) {
	      value *= step;
	    }
	
	    return {
	      distance: Math.max(0, Math.min(100, distance)),
	      value: Math.max(min, Math.min(max, value))
	    };
	  }
	});

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.isWithinStep = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = isWithinStep;
	  function isWithinStep(value, step) {
	    var decimals = String(step).split('.')[1];
	    var corrector = typeof decimals !== 'undefined' && decimals.length > 0 ? Math.pow(10, decimals.length) : 1;
	
	    return value * corrector % (step * corrector) === 0;
	  }
	});

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.updateUnit = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = updateUnit;
	  /**
	   * Takes in a css unit (px, rem, em, etc) or a number and applies a function to the
	   * number part of the unit.
	   *
	   * If the unit was a number to start with and a `toUnit` is given, the number will
	   * be given the `toUnit`. Otherwise the number will be returned.
	   *
	   * If the unit was a string, the original units will be applied back to the updated
	   * unit's value.
	   *
	   * @param {number|String} unit - the unit to apply a function to.
	   * @param {function} fn - the function to apply to the number.
	   * @param {String=} toUnit - an optional unit to cast the updated unit to.
	   *
	   * @return {String|number} the updated unit.
	   */
	  function updateUnit(unit, fn, toUnit) {
	    var updated = fn(parseInt(unit, 10));
	
	    if (typeof unit === 'number') {
	      return toUnit ? '' + updated + toUnit : updated;
	    }
	
	    return '' + updated + unit.replace(/[0-9]/g, '');
	  }
	});

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react);
	    global.minNumber = mod.exports;
	  }
	})(this, function (exports, _react) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = minNumber;
	
	
	  /**
	   * Validates the a prop's value is greater than or equal to the minimum value.
	   *
	   * @param {Number} min - the minimum value for the prop.
	   * @param {Boolean} required - Boolean if the prop is required.
	   * @return {Error} an error or null.
	   */
	  function minNumber(min, required) {
	    return function validate(props, propName, componentName, location, propFullName) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	
	      var validator = _react.PropTypes.number;
	      if (required) {
	        validator = validator.isRequired;
	      }
	
	      for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	        args[_key - 5] = arguments[_key];
	      }
	
	      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	      if (!required && !err && props[propName] < min) {
	        err = new Error('The ' + location + ' `' + propFullNameSafe + '` must be greater than or equal to the min value ' + ('`' + min + '` but received `' + props[propName] + '` for the `' + componentNameSafe + '` component.'));
	      }
	
	      return err;
	    };
	  } /** @module PropTypes/minNumber */
	});

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.oneRequiredForA11y = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = oneRequiredForA11y;
	  /**
	   * This validator checks that either the current prop is defined and valid or that one of the
	   * other given prop names are defined. If it fails it returns an error for a11y.
	   *
	   * @param {function} validator - The React PropTypes validator to use for the given prop.
	   * @param {String[]} otherPropNames - Any other prop names to validate against.
	   * @return {Error} an error or null
	   */
	  function oneRequiredForA11y(validator) {
	    for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      otherPropNames[_key - 1] = arguments[_key];
	    }
	
	    return function validate(props, propName, componentName, location, propFullName) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	      var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	        args[_key2 - 5] = arguments[_key2];
	      }
	
	      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	      if (!err && !allPropNames.filter(function (pn) {
	        return typeof props[pn] !== 'undefined';
	      }).length) {
	        err = new Error('One of the following props are required to make ' + componentNameSafe + ' accessible ' + ('for users of assistive technologies such as screen readers. `' + allPropNames.join('`, ') + '`.'));
	      }
	
	      return err;
	    };
	  }
	});

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.oneRequiredForA11yIf = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = oneRequiredForA11yIf;
	  function oneRequiredForA11yIf(validator, requiringProp) {
	    for (var _len = arguments.length, otherPropNames = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      otherPropNames[_key - 2] = arguments[_key];
	    }
	
	    return function validate(props, propName, componentName, location, propFullName) {
	      var filterUndefined = function filterUndefined(pn) {
	        return typeof props[pn] !== 'undefined';
	      };
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	      var requiredDefined = typeof props[requiringProp] !== 'undefined';
	      var allPropNames = [propFullNameSafe].concat(otherPropNames);
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	        args[_key2 - 5] = arguments[_key2];
	      }
	
	      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	      if (!err && requiredDefined && !allPropNames.filter(filterUndefined).length) {
	        err = new Error('One of the following props are required to make `' + componentNameSafe + '` accessible ' + ('for users of assistive technologies such as screen readers when using the `' + requiringProp + '` ') + ('prop. `' + allPropNames.join('`, `') + '`.'));
	      }
	
	      return err;
	    };
	  }
	});

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.requiredForA11yIfNot = mod.exports;
	  }
	})(this, function (exports) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = requiredForA11yIfNot;
	  /**
	   * This validator checkes that the current prop is valid and defined ONLY if
	   * any of the `otherPropNames` are not true or defined.
	   *
	   * @param {function} validator - The React PropTypes validator to use for the given prop.
	   * @param {String[]} otherPropNames - Any other prop names to validate against.
	   * @return {Error} an error or null
	   */
	  function requiredForA11yIfNot(validator) {
	    for (var _len = arguments.length, otherPropNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      otherPropNames[_key - 1] = arguments[_key];
	    }
	
	    return function validate(props, propName, componentName, location, propFullName) {
	      var componentNameSafe = componentName || '<<anonymous>>';
	      var propFullNameSafe = propFullName || propName;
	      var defined = typeof props[propName] !== 'undefined';
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	        args[_key2 - 5] = arguments[_key2];
	      }
	
	      var err = validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	      if (!err && !defined && !otherPropNames.filter(function (pn) {
	        return !!props[pn];
	      }).length) {
	        err = new Error('The `' + propFullNameSafe + '` ' + location + ' is required to make `' + componentNameSafe + '` accessible ' + 'for users of assistive technologies such as screen readers.');
	      }
	
	      return err;
	    };
	  }
	});

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports);
	    global.capitalizeFirst = mod.exports;
	  }
	})(this, function (exports) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = capitalizeFirst;
	  /**
	   * Capitalizes the first letter of a string. If the string is falsish, it will be
	   * returned as is. If the string is only one letter long, it will be capitalized;
	   *
	   * @param {String} str - The string to capitalize.
	   * @return {String} the updated string or false-ish self.
	   */
	  function capitalizeFirst(str) {
	    if (!str) {
	      return str;
	    } else if (str.length === 1) {
	      return str.toUpperCase();
	    }
	
	    return "" + str.charAt(0).toUpperCase() + str.substring(1, str.length);
	  }
	});

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(230)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./getPagePosition'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.getPagePosition);
	    global.toggleScroll = mod.exports;
	  }
	})(this, function (exports, _getPagePosition) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = toggleScroll;
	
	  var _getPagePosition2 = _interopRequireDefault(_getPagePosition);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  /**
	   * A utility function for toggling the overflow visibility on an element. This will either target
	   * the given `selector`, or the `body` tag to set a `className`.
	   *
	   * If the `visible` param is `undefined`, the className will be toggled.
	   * If the `visible` param is `true`, the className will be added.
	   * If the `visible` param is `false`, the className will be removed.
	   *
	   *
	   * > This depends on the `classList` attribute on elements.
	   *
	   * @param {bool=} visible - An optional boolean to determine how the `className` will be applied.
	   * @param {string=} selector - An optional query selector string to use to select an element.
	   * @param {string=} className - The className to apply. Defaults to 'md-overflow-hidden'
	   */
	  function toggleScroll(scrollable, selector) {
	    var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'md-no-scroll';
	
	    var el = selector ? document.querySelector(selector) : document.querySelector('html');
	    if (typeof scrollable === 'undefined') {
	      scrollable = !el.classList.contains(className);
	    }
	
	    if (scrollable) {
	      el.style.top = '-' + (0, _getPagePosition2.default)('y') + 'px';
	      el.classList.add(className);
	    } else {
	      var scrollTop = Math.abs(parseInt(el.style.top, 10));
	      el.classList.remove(className);
	      el.style.top = null;
	
	      if (!selector) {
	        window.scrollTo(0, scrollTop);
	      } else {
	        el.scrollTop = scrollTop;
	      }
	    }
	  }
	});

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(134);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(85);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(137);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(72);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(104);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(136);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(100);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    onRest: _propTypes2['default'].func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(134);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(85);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(137);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(72);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(104);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(136);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(100);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	    styles: _propTypes2['default'].func.isRequired,
	    children: _propTypes2['default'].func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(134);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(85);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(137);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(525);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(72);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(104);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(136);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(100);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _createReactClass2['default']({
	  propTypes: {
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	    })),
	    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	    }))]).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    willEnter: _propTypes2['default'].func,
	    willLeave: _propTypes2['default'].func,
	    didLeave: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  unmounting: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    if (this.unmounting) {
	      return;
	    }
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // https://github.com/chenglou/react-motion/pull/420
	      // > if execution passes the conditional if (this.unmounting), then
	      // executes async defaultRaf and after that component unmounts and after
	      // that the callback of defaultRaf is called, then setState will be called
	      // on unmounted component.
	      if (_this.unmounting) {
	        return;
	      }
	
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ },
/* 525 */
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(232);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(319);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _reactRouter = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(320);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _reactRouter = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(19);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.MemoryRouter;
	  }
	});

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(19);
	
	var _Link = __webpack_require__(233);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);
	
	  return _react2.default.createElement(_reactRouter.Route, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [activeClassName, className].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active'
	};
	
	exports.default = NavLink;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(19);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Prompt;
	  }
	});

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(19);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Redirect;
	  }
	});

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(19);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Route;
	  }
	});

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(19);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Router;
	  }
	});

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(19);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.StaticRouter;
	  }
	});

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(19);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.Switch;
	  }
	});

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(19);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.matchPath;
	  }
	});

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRouter = __webpack_require__(19);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _reactRouter.withRouter;
	  }
	});

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(321);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(139);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(45);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(58);
	
	var _Router = __webpack_require__(139);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _matchPath = __webpack_require__(140);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(322);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(234);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(326).enable();
	  window.Promise = __webpack_require__(325);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(571);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(6);


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(260);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(262);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(146);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(254);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(258);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(259);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(263);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(261);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMotion = __webpack_require__(135);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _constant = __webpack_require__(235);
	
	var _checkIndexBounds = __webpack_require__(549);
	
	var _checkIndexBounds2 = _interopRequireDefault(_checkIndexBounds);
	
	var _computeIndex2 = __webpack_require__(550);
	
	var _computeIndex3 = _interopRequireDefault(_computeIndex2);
	
	var _getDisplaySameSlide = __webpack_require__(551);
	
	var _getDisplaySameSlide2 = _interopRequireDefault(_getDisplaySameSlide);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  container: {
	    display: 'flex',
	    willChange: 'transform'
	  },
	  slide: {
	    width: '100%',
	    flexShrink: 0,
	    overflow: 'auto'
	  }
	}; /* eslint-disable flowtype/require-valid-file-annotation */
	
	var axisProperties = {
	  root: {
	    x: {
	      overflowX: 'hidden'
	    },
	    'x-reverse': {
	      overflowX: 'hidden'
	    },
	    y: {
	      overflowY: 'hidden'
	    },
	    'y-reverse': {
	      overflowY: 'hidden'
	    }
	  },
	  flexDirection: {
	    x: 'row',
	    'x-reverse': 'row-reverse',
	    y: 'column',
	    'y-reverse': 'column-reverse'
	  },
	  transform: {
	    x: function x(translate) {
	      return 'translate(' + -translate + '%, 0)';
	    },
	    'x-reverse': function xReverse(translate) {
	      return 'translate(' + translate + '%, 0)';
	    },
	    y: function y(translate) {
	      return 'translate(0, ' + -translate + '%)';
	    },
	    'y-reverse': function yReverse(translate) {
	      return 'translate(0, ' + translate + '%)';
	    }
	  },
	  length: {
	    x: 'width',
	    'x-reverse': 'width',
	    y: 'height',
	    'y-reverse': 'height'
	  },
	  rotationMatrix: {
	    x: {
	      x: [1, 0],
	      y: [0, 1]
	    },
	    'x-reverse': {
	      x: [-1, 0],
	      y: [0, 1]
	    },
	    y: {
	      x: [0, 1],
	      y: [1, 0]
	    },
	    'y-reverse': {
	      x: [0, -1],
	      y: [1, 0]
	    }
	  }
	};
	
	// We are using a 2x2 rotation matrix.
	function applyRotationMatrix(touch, axis) {
	  var rotationMatrix = axisProperties.rotationMatrix[axis];
	
	  return {
	    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
	    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
	  };
	}
	
	function getDomTreeShapes(element, rootNode) {
	  var domTreeShapes = [];
	
	  while (element && element !== rootNode.firstChild) {
	    // Ignore the nodes that have no width.
	    if (element.clientWidth > 0) {
	      domTreeShapes.push({
	        element: element,
	        scrollWidth: element.scrollWidth,
	        clientWidth: element.clientWidth,
	        scrollLeft: element.scrollLeft
	      });
	    }
	
	    element = element.parentNode;
	  }
	
	  return domTreeShapes.slice(0, -2) // Remove internal elements.
	  .filter(function (shape) {
	    return shape.scrollWidth > shape.clientWidth;
	  }); // Keep elements with a scroll.
	}
	
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	var nodeHowClaimedTheScroll = null;
	
	var SwipeableViews = function (_Component) {
	  (0, _inherits3.default)(SwipeableViews, _Component);
	
	  function SwipeableViews() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SwipeableViews);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwipeableViews.__proto__ || (0, _getPrototypeOf2.default)(SwipeableViews)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.viewLength = 0, _this.startX = 0, _this.lastX = 0, _this.vx = 0, _this.startY = 0, _this.isSwiping = undefined, _this.started = false, _this.handleTouchStart = function (event) {
	      var _this$props = _this.props;
	      var axis = _this$props.axis;
	      var onTouchStart = _this$props.onTouchStart;
	
	
	      if (onTouchStart) {
	        onTouchStart(event);
	      }
	
	      var touch = applyRotationMatrix(event.touches[0], axis);
	
	      _this.viewLength = _this.node.getBoundingClientRect()[axisProperties.length[axis]];
	      _this.startX = touch.pageX;
	      _this.lastX = touch.pageX;
	      _this.vx = 0;
	      _this.startY = touch.pageY;
	      _this.isSwiping = undefined;
	      _this.started = true;
	    }, _this.handleTouchMove = function (event) {
	      if (_this.props.onTouchMove) {
	        _this.props.onTouchMove(event);
	      }
	
	      // The touch start event can be cancel.
	      // Makes sure we set a starting point.
	      if (!_this.started) {
	        _this.handleTouchStart(event);
	        return;
	      }
	
	      // We are not supposed to hanlde this touch move.
	      if (nodeHowClaimedTheScroll !== null && nodeHowClaimedTheScroll !== _this.node) {
	        return;
	      }
	
	      var _this$props2 = _this.props;
	      var axis = _this$props2.axis;
	      var children = _this$props2.children;
	      var onSwitching = _this$props2.onSwitching;
	      var resistance = _this$props2.resistance;
	
	
	      var touch = applyRotationMatrix(event.touches[0], axis);
	
	      // We don't know yet.
	      if (_this.isSwiping === undefined) {
	        var dx = Math.abs(_this.startX - touch.pageX);
	        var dy = Math.abs(_this.startY - touch.pageY);
	
	        var isSwiping = dx > dy && dx > _constant.UNCERTAINTY_THRESHOLD;
	
	        // We are likely to be swiping, let's prevent the scroll event.
	        if (dx > dy) {
	          event.preventDefault();
	        }
	
	        if (isSwiping === true || dy > _constant.UNCERTAINTY_THRESHOLD) {
	          _this.isSwiping = isSwiping;
	          _this.startX = touch.pageX; // Shift the starting point.
	
	          return; // Let's wait the next touch event to move something.
	        }
	      }
	
	      if (_this.isSwiping !== true) {
	        return;
	      }
	
	      // We are swiping, let's prevent the scroll event.
	      event.preventDefault();
	
	      // Low Pass filter.
	      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
	      _this.lastX = touch.pageX;
	
	      var _computeIndex = (0, _computeIndex3.default)({
	        children: children,
	        resistance: resistance,
	        pageX: touch.pageX,
	        indexLatest: _this.state.indexLatest,
	        startX: _this.startX,
	        viewLength: _this.viewLength
	      });
	
	      var index = _computeIndex.index;
	      var startX = _computeIndex.startX;
	
	      // Add support for native scroll elements.
	
	      if (nodeHowClaimedTheScroll === null) {
	        var domTreeShapes = getDomTreeShapes(event.target, _this.node);
	
	        var hasFoundNativeHandler = domTreeShapes.some(function (shape) {
	          if (index >= _this.state.indexCurrent && shape.scrollLeft + shape.clientWidth < shape.scrollWidth || index <= _this.state.indexCurrent && shape.scrollLeft > 0) {
	            nodeHowClaimedTheScroll = shape.element;
	            return true;
	          }
	
	          return false;
	        });
	
	        // We abort the touch move handler.
	        if (hasFoundNativeHandler) {
	          return;
	        }
	      }
	
	      // We are moving toward the edges.
	      if (startX) {
	        _this.startX = startX;
	      } else if (nodeHowClaimedTheScroll === null) {
	        nodeHowClaimedTheScroll = _this.node;
	      }
	
	      _this.setState({
	        isDragging: true,
	        indexCurrent: index
	      }, function () {
	        if (onSwitching) {
	          onSwitching(index, 'move');
	        }
	      });
	    }, _this.handleTouchEnd = function (event) {
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	
	      nodeHowClaimedTheScroll = null;
	
	      // The touch start event can be cancel.
	      // Makes sure that a starting point is set.
	      if (!_this.started) {
	        return;
	      }
	
	      _this.started = false;
	
	      if (_this.isSwiping !== true) {
	        return;
	      }
	
	      var indexLatest = _this.state.indexLatest;
	      var indexCurrent = _this.state.indexCurrent;
	
	      var indexNew = void 0;
	
	      // Quick movement
	      if (Math.abs(_this.vx) > _this.props.threshold) {
	        if (_this.vx > 0) {
	          indexNew = Math.floor(indexCurrent);
	        } else {
	          indexNew = Math.ceil(indexCurrent);
	        }
	      } else if (Math.abs(indexLatest - indexCurrent) > 0.6) {
	        // Some hysteresis with indexLatest
	        indexNew = Math.round(indexCurrent);
	      } else {
	        indexNew = indexLatest;
	      }
	
	      var indexMax = _react.Children.count(_this.props.children) - 1;
	
	      if (indexNew < 0) {
	        indexNew = 0;
	      } else if (indexNew > indexMax) {
	        indexNew = indexMax;
	      }
	
	      _this.setState({
	        indexCurrent: indexNew,
	        indexLatest: indexNew,
	        isDragging: false,
	        displaySameSlide: false
	      }, function () {
	        if (_this.props.onSwitching) {
	          _this.props.onSwitching(indexNew, 'end');
	        }
	
	        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
	          _this.props.onChangeIndex(indexNew, indexLatest);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SwipeableViews, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (false) {
	        (0, _checkIndexBounds2.default)(this.props);
	      }
	
	      this.setState({
	        indexCurrent: this.props.index,
	        indexLatest: this.props.index,
	        isDragging: false,
	        isFirstRender: true,
	        heightLatest: 0
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      /* eslint-disable react/no-did-mount-set-state */
	      this.setState({
	        isFirstRender: false
	      });
	      /* eslint-enable react/no-did-mount-set-state */
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var index = nextProps.index;
	
	
	      if (typeof index === 'number' && index !== this.props.index) {
	        if (false) {
	          (0, _checkIndexBounds2.default)(nextProps);
	        }
	
	        this.setState({
	          indexCurrent: index,
	          indexLatest: index,
	          // If true, we are going to display the same slide. We shoudn't animate it.
	          displaySameSlide: (0, _getDisplaySameSlide2.default)(this.props, nextProps)
	        });
	      }
	    }
	  }, {
	    key: 'updateHeight',
	    value: function updateHeight(node) {
	      if (node !== null) {
	        var child = node.children[0];
	        if (child !== undefined && child.offsetHeight !== undefined && this.state.heightLatest !== child.offsetHeight) {
	          this.setState({
	            heightLatest: child.offsetHeight
	          });
	        }
	      }
	    }
	  }, {
	    key: 'renderContainer',
	    value: function renderContainer(interpolatedStyle, animateHeight, childrenToRender) {
	      var _props = this.props;
	      var axis = _props.axis;
	      var containerStyle = _props.containerStyle;
	
	
	      var transform = axisProperties.transform[axis](interpolatedStyle.translate);
	
	      var styleNew = {
	        WebkitTransform: transform,
	        transform: transform,
	        height: null,
	        flexDirection: axisProperties.flexDirection[axis]
	      };
	
	      if (animateHeight) {
	        styleNew.height = interpolatedStyle.height;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: (0, _assign2.default)({}, styleNew, styles.container, containerStyle) },
	        childrenToRender
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props;
	      var animateHeight = _props2.animateHeight;
	      var animateTransitions = _props2.animateTransitions;
	      var axis = _props2.axis;
	      var children = _props2.children;
	      var containerStyle = _props2.containerStyle;
	      var disabled = _props2.disabled;
	      var index = _props2.index;
	      var onChangeIndex = _props2.onChangeIndex;
	      var onSwitching = _props2.onSwitching;
	      var resistance = _props2.resistance;
	      var slideStyle = _props2.slideStyle;
	      var springConfig = _props2.springConfig;
	      var style = _props2.style;
	      var threshold = _props2.threshold;
	      var other = (0, _objectWithoutProperties3.default)(_props2, ['animateHeight', 'animateTransitions', 'axis', 'children', 'containerStyle', 'disabled', 'index', 'onChangeIndex', 'onSwitching', 'resistance', 'slideStyle', 'springConfig', 'style', 'threshold']);
	      var _state = this.state;
	      var displaySameSlide = _state.displaySameSlide;
	      var heightLatest = _state.heightLatest;
	      var indexCurrent = _state.indexCurrent;
	      var isDragging = _state.isDragging;
	      var isFirstRender = _state.isFirstRender;
	
	
	      var translate = indexCurrent * 100;
	      var height = heightLatest;
	
	      var motionStyle = isDragging || !animateTransitions || displaySameSlide ? {
	        translate: translate,
	        height: height
	      } : {
	        translate: (0, _reactMotion.spring)(translate, springConfig),
	        height: height !== 0 ? (0, _reactMotion.spring)(height, springConfig) : 0
	      };
	
	      var touchEvents = disabled ? {} : {
	        onTouchStart: this.handleTouchStart,
	        onTouchMove: this.handleTouchMove,
	        onTouchEnd: this.handleTouchEnd
	      };
	
	      // There is no point to animate if we are already providing a height.
	       false ? (0, _warning2.default)(!animateHeight || !containerStyle || !containerStyle.height && !containerStyle.maxHeight && !containerStyle.minHeight, 'react-swipeable-view: You are setting animateHeight to true but you are also providing a custom height.\n      The custom height has a higher priority than the animateHeight property.\n      So animateHeight is most likely having no effect at all.') : void 0;
	
	      var slideStyleObj = (0, _assign2.default)({}, styles.slide, slideStyle);
	
	      var childrenToRender = _react.Children.map(children, function (child, indexChild) {
	        if (isFirstRender && indexChild > 0) {
	          return null;
	        }
	
	        var ref = void 0;
	
	        if (animateHeight && indexChild === _this2.state.indexLatest) {
	          ref = function ref(node) {
	            return _this2.updateHeight(node);
	          };
	          slideStyleObj.overflowY = 'hidden';
	        }
	
	        return _react2.default.createElement(
	          'div',
	          { ref: ref, style: slideStyleObj },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          ref: function ref(node) {
	            _this2.node = node;
	          },
	          style: (0, _assign2.default)({}, axisProperties.root[axis], style)
	        }, other, touchEvents),
	        _react2.default.createElement(
	          _reactMotion.Motion,
	          { style: motionStyle, onRest: this.props.onTransitionEnd },
	          function (interpolatedStyle) {
	            return _this2.renderContainer(interpolatedStyle, animateHeight, childrenToRender);
	          }
	        )
	      );
	    }
	  }]);
	  return SwipeableViews;
	}(_react.Component);
	
	SwipeableViews.defaultProps = {
	  animateHeight: false,
	  animateTransitions: true,
	  axis: 'x',
	  index: 0,
	  threshold: 5,
	  resistance: false,
	  disabled: false,
	  springConfig: {
	    stiffness: 300,
	    damping: 30
	  }
	};
	 false ? SwipeableViews.propTypes = {
	  /**
	   * If `true`, the height of the container will be animated to match the current slide height.
	   * Animating another style property has a negative impact regarding performance.
	   */
	  animateHeight: _react.PropTypes.bool,
	  /**
	   * If `false`, changes to the index prop will not cause an animated transition.
	   */
	  animateTransitions: _react.PropTypes.bool,
	  /**
	   * The axis on which the slides will slide.
	   */
	  axis: _react.PropTypes.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * Use this property to provide your slides.
	   */
	  children: _react.PropTypes.node.isRequired,
	  /**
	   * This is the inlined style that will be applied
	   * to each slide container.
	   */
	  containerStyle: _react.PropTypes.object,
	  /**
	   * If `true`, it will disable touch events.
	   * This is useful when you want to prohibit the user from changing slides.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * This is the index of the slide to show.
	   * This is useful when you want to change the default slide shown.
	   * Or when you have tabs linked to each slide.
	   */
	  index: _react.PropTypes.number,
	  /**
	   * This is callback prop. It's call by the
	   * component when the shown slide change after a swipe made by the user.
	   * This is useful when you have tabs linked to each slide.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {integer} indexLatest This is the oldest index of the slide.
	   */
	  onChangeIndex: _react.PropTypes.func,
	  /**
	   * This is callback prop. It's called by the
	   * component when the slide switching.
	   * This is useful when you want to implement something corresponding to the current slide position.
	   *
	   * @param {integer} index This is the current index of the slide.
	   * @param {string} type Can be either `move` or `end`.
	   */
	  onSwitching: _react.PropTypes.func,
	  /**
	   * @ignore
	   */
	  onTouchEnd: _react.PropTypes.func,
	  /**
	   * @ignore
	   */
	  onTouchMove: _react.PropTypes.func,
	  /**
	   * @ignore
	   */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * The callback that fires when the animation comes to a rest.
	   * This is useful to defer CPU intensive task.
	   */
	  onTransitionEnd: _react.PropTypes.func,
	  /**
	   * If `true`, it will add bounds effect on the edges.
	   */
	  resistance: _react.PropTypes.bool,
	  /**
	   * This is the inlined style that will be applied
	   * on the slide component.
	   */
	  slideStyle: _react.PropTypes.object,
	  /**
	   * This is the config given to react-motion for the spring.
	   * This is useful to change the dynamic of the transition.
	   */
	  springConfig: _react.PropTypes.object,
	  /**
	   * This is the inlined style that will be applied
	   * on the root component.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the threshold used for detecting a quick swipe.
	   * If the computed speed is above this value, the index change.
	   */
	  threshold: _react.PropTypes.number
	} : void 0;
	exports.default = SwipeableViews;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SwipeableViews = __webpack_require__(547);
	
	var _SwipeableViews2 = _interopRequireDefault(_SwipeableViews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SwipeableViews2.default; //  weak

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _warning = __webpack_require__(23);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable flowtype/require-valid-file-annotation */
	
	var checkIndexBounds = function checkIndexBounds(props) {
	  var index = props.index;
	  var children = props.children;
	
	
	  var childrenCount = _react.Children.count(children);
	
	   false ? (0, _warning2.default)(index >= 0 && index <= childrenCount, 'react-swipeable-view: the new index: ' + index + ' is out of bounds: [0-' + childrenCount + '].') : void 0;
	};
	
	exports.default = checkIndexBounds;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = computeIndex;
	
	var _react = __webpack_require__(1);
	
	var _constant = __webpack_require__(235);
	
	//  weak
	
	function computeIndex(params) {
	  var children = params.children;
	  var indexLatest = params.indexLatest;
	  var startX = params.startX;
	  var pageX = params.pageX;
	  var viewLength = params.viewLength;
	  var resistance = params.resistance;
	
	
	  var indexMax = _react.Children.count(children) - 1;
	  var index = indexLatest + (startX - pageX) / viewLength;
	  var newStartX = void 0;
	
	  if (!resistance) {
	    // Reset the starting point
	    if (index < 0) {
	      index = 0;
	      newStartX = (index - indexLatest) * viewLength + pageX;
	    } else if (index > indexMax) {
	      index = indexMax;
	      newStartX = (index - indexLatest) * viewLength + pageX;
	    }
	  } else if (index < 0) {
	    index = Math.exp(index * _constant.RESISTANCE_COEF) - 1;
	  } else if (index > indexMax) {
	    index = indexMax + 1 - Math.exp((indexMax - index) * _constant.RESISTANCE_COEF);
	  }
	
	  return {
	    index: index,
	    startX: newStartX
	  };
	}

/***/ },
/* 551 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//  weak
	
	var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
	  var displaySameSlide = false;
	
	  if (props.children.length && nextProps.children.length) {
	    var oldKey = props.children[props.index].key;
	
	    if (oldKey !== null) {
	      var newKey = nextProps.children[nextProps.index].key;
	
	      if (oldKey === newKey) {
	        displaySameSlide = true;
	      }
	    }
	  }
	
	  return displaySameSlide;
	};
	
	exports.default = getDisplaySameSlide;

/***/ },
/* 552 */
[572, 54],
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(170);
	
	exports.getReactDOM = function () {
	  return ReactDOM;
	};
	
	if (false) {
	  var ReactPerf;
	  var ReactTestUtils;
	
	  exports.getReactPerf = function () {
	    if (!ReactPerf) {
	      ReactPerf = require('react-dom/lib/ReactPerf');
	    }
	    return ReactPerf;
	  };
	
	  exports.getReactTestUtils = function () {
	    if (!ReactTestUtils) {
	      ReactTestUtils = require('react-dom/lib/ReactTestUtils');
	    }
	    return ReactTestUtils;
	  };
	}

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(27);
	var propTypesFactory = __webpack_require__(74);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var ReactTransitionGroup = __webpack_require__(238);
	var ReactCSSTransitionGroupChild = __webpack_require__(555);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	
	var ReactCSSTransitionGroup = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroup, _React$Component);
	
	  function ReactCSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      // We need to provide this childFactory so that
	      // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	      // leave while it is leaving.
	      return React.createElement(ReactCSSTransitionGroupChild, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroup.prototype.render = function render() {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return ReactCSSTransitionGroup;
	}(React.Component);
	
	ReactCSSTransitionGroup.displayName = 'ReactCSSTransitionGroup';
	ReactCSSTransitionGroup.propTypes = {
	  transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	  transitionAppear: PropTypes.bool,
	  transitionEnter: PropTypes.bool,
	  transitionLeave: PropTypes.bool,
	  transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	  transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	  transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	};
	ReactCSSTransitionGroup.defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(27);
	var ReactAddonsDOMDependencies = __webpack_require__(553);
	
	var propTypesFactory = __webpack_require__(74);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var CSSCore = __webpack_require__(306);
	var ReactTransitionEvents = __webpack_require__(563);
	
	var onlyChild = __webpack_require__(240);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroupChild, _React$Component);
	
	  function ReactCSSTransitionGroupChild() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._isMounted = false, _this.transition = function (animationType, finishCallback, userSpecifiedDelay) {
	      var node = ReactAddonsDOMDependencies.getReactDOM().findDOMNode(_this);
	
	      if (!node) {
	        if (finishCallback) {
	          finishCallback();
	        }
	        return;
	      }
	
	      var className = _this.props.name[animationType] || _this.props.name + '-' + animationType;
	      var activeClassName = _this.props.name[animationType + 'Active'] || className + '-active';
	      var timeout = null;
	
	      var endListener = function (e) {
	        if (e && e.target !== node) {
	          return;
	        }
	
	        clearTimeout(timeout);
	
	        CSSCore.removeClass(node, className);
	        CSSCore.removeClass(node, activeClassName);
	
	        ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	        // Usually this optional callback is used for informing an owner of
	        // a leave animation and telling it to remove the child.
	        if (finishCallback) {
	          finishCallback();
	        }
	      };
	
	      CSSCore.addClass(node, className);
	
	      // Need to do this to actually trigger a transition.
	      _this.queueClassAndNode(activeClassName, node);
	
	      // If the user specified a timeout delay.
	      if (userSpecifiedDelay) {
	        // Clean-up the animation after the specified delay
	        timeout = setTimeout(endListener, userSpecifiedDelay);
	        _this.transitionTimeouts.push(timeout);
	      } else {
	        // DEPRECATED: this listener will be removed in a future version of react
	        ReactTransitionEvents.addEndEventListener(node, endListener);
	      }
	    }, _this.queueClassAndNode = function (className, node) {
	      _this.classNameAndNodeQueue.push({
	        className: className,
	        node: node
	      });
	
	      if (!_this.timeout) {
	        _this.timeout = setTimeout(_this.flushClassNameAndNodeQueue, TICK);
	      }
	    }, _this.flushClassNameAndNodeQueue = function () {
	      if (_this._isMounted) {
	        _this.classNameAndNodeQueue.forEach(function (obj) {
	          CSSCore.addClass(obj.node, obj.className);
	        });
	      }
	      _this.classNameAndNodeQueue.length = 0;
	      _this.timeout = null;
	    }, _this.componentWillAppear = function (done) {
	      if (_this.props.appear) {
	        _this.transition('appear', done, _this.props.appearTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillEnter = function (done) {
	      if (_this.props.enter) {
	        _this.transition('enter', done, _this.props.enterTimeout);
	      } else {
	        done();
	      }
	    }, _this.componentWillLeave = function (done) {
	      if (_this.props.leave) {
	        _this.transition('leave', done, _this.props.leaveTimeout);
	      } else {
	        done();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  };
	
	  ReactCSSTransitionGroupChild.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	  };
	
	  ReactCSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  };
	
	  ReactCSSTransitionGroupChild.prototype.render = function render() {
	    return onlyChild(this.props.children);
	  };
	
	  return ReactCSSTransitionGroupChild;
	}(React.Component);
	
	ReactCSSTransitionGroupChild.propTypes = {
	  name: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
	    enter: PropTypes.string,
	    leave: PropTypes.string,
	    active: PropTypes.string
	  }), PropTypes.shape({
	    enter: PropTypes.string,
	    enterActive: PropTypes.string,
	    leave: PropTypes.string,
	    leaveActive: PropTypes.string,
	    appear: PropTypes.string,
	    appearActive: PropTypes.string
	  })]).isRequired,
	
	  // Once we require timeouts to be specified, we can remove the
	  // boolean flags (appear etc.) and just accept a number
	  // or a bool for the timeout flags (appearTimeout etc.)
	  appear: PropTypes.bool,
	  enter: PropTypes.bool,
	  leave: PropTypes.bool,
	  appearTimeout: PropTypes.number,
	  enterTimeout: PropTypes.number,
	  leaveTimeout: PropTypes.number
	};
	
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(552);
	var ReactElement = __webpack_require__(53);
	
	var emptyFunction = __webpack_require__(17);
	var traverseAllChildren = __webpack_require__(241);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(54),
	    _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(141);
	var ReactElement = __webpack_require__(53);
	var ReactPropTypeLocationNames = __webpack_require__(559);
	var ReactNoopUpdateQueue = __webpack_require__(143);
	
	var emptyObject = __webpack_require__(44);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: 'DEFINE_MANY',
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: 'DEFINE_MANY',
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: 'DEFINE_MANY',
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: 'DEFINE_MANY',
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: 'DEFINE_MANY_MERGED',
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: 'DEFINE_MANY_MERGED',
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @required
	   */
	  render: 'DEFINE_ONCE',
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: 'DEFINE_MANY',
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: 'DEFINE_MANY',
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: 'DEFINE_ONCE',
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: 'DEFINE_MANY',
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: 'DEFINE_MANY',
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: 'OVERRIDE_BASE'
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, 'childContext');
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, 'context');
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, 'prop');
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === 'DEFINE_MANY_MERGED') {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === 'DEFINE_MANY') {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	var didWarnDeprecated = false;
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(didWarnDeprecated, '%s: React.createClass is deprecated and will be removed in version 16. ' + 'Use plain JavaScript classes instead. If you\'re not yet ready to ' + 'migrate, create-react-class is available on npm as a ' + 'drop-in replacement.', spec && spec.displayName || 'A Component') : void 0;
	      didWarnDeprecated = true;
	    }
	
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(53);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(53),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(74);
	
	module.exports = factory(isValidElement);

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(6);
	
	var ReactComponent = __webpack_require__(141);
	var ReactNoopUpdateQueue = __webpack_require__(143);
	
	var emptyObject = __webpack_require__(44);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(565);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(15);
	
	var getVendorPrefixedEventName = __webpack_require__(184);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 564 */
368,
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(236);
	var traverseAllChildren = __webpack_require__(241);
	var warning = __webpack_require__(4);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"/myreads-react-md"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(142);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ },
/* 566 */
387,
/* 567 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 568 */
/***/ function(module, exports) {

	'use strict';
	
	var isAbsolute = function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	};
	
	// About 1.5x faster than the two-arg version of Array#splice()
	var spliceOne = function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }list.pop();
	};
	
	// This implementation is based heavily on node's url.parse
	var resolvePathname = function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	};
	
	module.exports = resolvePathname;

/***/ },
/* 569 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var valueEqual = function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	    return valueEqual(item, b[index]);
	  });
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	};
	
	exports.default = valueEqual;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.27 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.m=b||a;this.c=this.m.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
	function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
	function z(a){if("string"===typeof a.f)return a.f;var b=a.m.location.protocol;"about:"==b&&(b=a.a.location.protocol);return"https:"==b?"https:":"http:"}function ea(a){return a.m.location.hostname||a.a.location.hostname}
	function A(a,b,c){function d(){k&&e&&f&&(k(g),k=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,k=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
	function B(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function C(){this.a=0;this.c=null}function D(a){a.a++;return function(){a.a--;E(a)}}function F(a,b){a.c=b;E(a)}function E(a){0==a.a&&a.c&&(a.c(),a.c=null)};function G(a){this.a=a||"-"}G.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function H(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return I(a)+" "+(a.f+"00")+" 300px "+J(a.c)}function J(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function K(a){return a.a+a.f}function I(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
	function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.m.document.documentElement;this.h=b;this.a=new G("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);L(a,"loading")}function M(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}L(a,"inactive")}function L(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,K(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function N(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function O(a){u(a.c,"body",a.a)}function P(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+J(a.c)+";"+("font-style:"+I(a)+";font-weight:"+(a.f+"00")+";")};function Q(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}Q.prototype.start=function(){var a=this.c.m.document,b=this,c=q(),d=new Promise(function(d,e){function k(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(k,25)},function(){e()})}k()}),e=new Promise(function(a,d){setTimeout(d,b.f)});Promise.race([e,d]).then(function(){b.g(b.a)},function(){b.j(b.a)})};function R(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.o=this.j=this.h=this.g=null;this.g=new N(this.c,this.s);this.h=new N(this.c,this.s);this.j=new N(this.c,this.s);this.o=new N(this.c,this.s);a=new H(this.a.c+",serif",K(this.a));a=P(a);this.g.a.style.cssText=a;a=new H(this.a.c+",sans-serif",K(this.a));a=P(a);this.h.a.style.cssText=a;a=new H("serif",K(this.a));a=P(a);this.j.a.style.cssText=a;a=new H("sans-serif",K(this.a));a=
	P(a);this.o.a.style.cssText=a;O(this.g);O(this.h);O(this.j);O(this.o)}var S={D:"serif",C:"sans-serif"},T=null;function U(){if(null===T){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);T=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return T}R.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.o.a.offsetWidth;this.A=q();la(this)};
	function ma(a,b,c){for(var d in S)if(S.hasOwnProperty(d)&&b===a.f[S[d]]&&c===a.f[S[d]])return!0;return!1}function la(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=U()&&ma(a,b,c));d?q()-a.A>=a.w?U()&&ma(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):na(a):V(a,a.v)}function na(a){setTimeout(p(function(){la(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.o.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.o=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,K(a).toString(),"active")],[b.a.c("wf",a.c,K(a).toString(),"loading"),b.a.c("wf",a.c,K(a).toString(),"inactive")]);L(b,"fontactive",a);this.o=!0;oa(this)};
	W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,K(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,K(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,K(a).toString(),"inactive"));w(b.f,d,e)}L(b,"fontinactive",a);oa(this)};function oa(a){0==--a.f&&a.j&&(a.o?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),L(a,"active")):M(a.a))};function pa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}pa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;qa(this,new ha(this.c,a),a)};
	function ra(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,k=d||null||{};if(0===c.length&&f)M(b.a);else{b.f+=c.length;f&&(b.j=f);var h,m=[];for(h=0;h<c.length;h++){var l=c[h],n=k[l.c],r=b.a,x=l;r.g&&w(r.f,[r.a.c("wf",x.c,K(x).toString(),"loading")]);L(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),ya=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
	X=x?42<parseInt(x[1],10):ya?!1:!0}else X=!1;X?r=new Q(p(b.g,b),p(b.h,b),b.c,l,b.s,n):r=new R(p(b.g,b),p(b.h,b),b.c,l,b.s,a,n);m.push(r)}for(h=0;h<m.length;h++)m[h].start()}},0)}function qa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){ra(a,f,b,d,c)})};function sa(a,b){this.c=a;this.a=b}function ta(a,b,c){var d=z(a.c);a=(a.a.api||"fast.fonts.net/jsapi").replace(/^.*http(s?):(\/\/)?/,"");return d+"//"+a+"/"+b+".js"+(c?"?v="+c:"")}
	sa.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var m=0;m<c.length;m++){var l=c[m].fontfamily;void 0!=c[m].fontStyle&&void 0!=c[m].fontWeight?(h=c[m].fontStyle+c[m].fontWeight,e.push(new H(l,h))):e.push(new H(l))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.m;B(this.c,ta(c,d,e),function(e){e?a([]):(f["__MonotypeConfiguration__"+d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+
	d}else a([])};function ua(a,b){this.c=a;this.a=b}ua.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new C;b=0;for(c=d.length;b<c;b++)A(this.c,d[b],D(g));var k=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),m=0;m<h.length;m+=1)k.push(new H(d[0],h[m]));else k.push(new H(d[0]));F(g,function(){a(k,f)})};function va(a,b,c){a?this.c=a:this.c=b+wa;this.a=[];this.f=[];this.g=c||""}var wa="//fonts.googleapis.com/css";function xa(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
	function za(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function Aa(a){this.f=a;this.a=[];this.c={}}
	var Ba={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Ca={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Da={i:"i",italic:"i",n:"n",normal:"n"},
	Ea=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
	function Fa(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var k=d[1];g=[];if(k)for(var k=k.split(","),h=k.length,m=0;m<h;m++){var l;l=k[m];if(l.match(/^[\w-]+$/)){var n=Ea.exec(l.toLowerCase());if(null==n)l="";else{l=n[2];l=null==l||""==l?"n":Da[l];n=n[1];if(null==n||""==n)n="4";else var r=Ca[n],n=r?r:isNaN(n)?"4":n.substr(0,1);l=[l,n].join("")}}else l="";l&&g.push(l)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
	g,0<d.length&&(d=Ba[d[0]])&&(a.c[e]=d))}a.c[e]||(d=Ba[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new H(e,f[d]))}};function Ga(a,b){this.c=a;this.a=b}var Ha={Arimo:!0,Cousine:!0,Tinos:!0};Ga.prototype.load=function(a){var b=new C,c=this.c,d=new va(this.a.api,z(c),this.a.text),e=this.a.families;xa(d,e);var f=new Aa(e);Fa(f);A(c,za(d),D(b));F(b,function(){a(f.a,f.c,Ha)})};function Ia(a,b){this.c=a;this.a=b}Ia.prototype.load=function(a){var b=this.a.id,c=this.c.m;b?B(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],k=b[f+1],h=0;h<k.length;h++)e.push(new H(g,k[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(m){}a(e)}},2E3):a([])};function Ja(a,b){this.c=a;this.f=b;this.a=[]}Ja.prototype.load=function(a){var b=this.f.id,c=this.c.m,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,k=c.fonts.length;g<k;++g){var h=c.fonts[g];d.a.push(new H(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},B(this.c,z(this.c)+(this.f.api||"//f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new pa(window);Y.a.c.custom=function(a,b){return new ua(b,a)};Y.a.c.fontdeck=function(a,b){return new Ja(b,a)};Y.a.c.monotype=function(a,b){return new sa(b,a)};Y.a.c.typekit=function(a,b){return new Ia(b,a)};Y.a.c.google=function(a,b){return new Ga(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ },
/* 571 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.a3cc6a3e.js